// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-corporate-multidomain -> case-associates-corprate-corporate-multidomain
// Generated: 2026-11-03T17:44:41.768Z
// Counts: 0 design, 2900 content, 1735 slot group, 5 collection binding, 11 section, 2 style

export const designOverrides = {};

export const contentOverrides = {
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=160/company/5767906449162419/019e50b7-7ca1-73f9-a6e0-e43f0892138f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "aboutfeaturedtext.background_image": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_featured_image"
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We care about the environment and your utility bills, that’s why our apartments feature energy-efficient appliances, helping you save money and reduce your carbon footprint. In addition, we provide exterior storage space for those extra belongings, so you can keep your living areas clutter-free.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/newport-wichita-apts/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Blending comfort with convenience, you’ll find features in your Newport apartment home. Our <a href=\"/apartments/ks/wichita/newport-wichita-apts/floor-plans\"><strong>1 and 2 bedroom</strong></a><strong> </strong>size options include an open environment that allows easy movement through your home and allows you to customize your living space. Take in the morning sun with a cup of coffee on your private balcony, or tuck yourself in your spacious bedroom with an expansive closet to prepare every outfit for the day ahead.</p>\n<p>Take advantage of convenient amenities inside your Newport apartment home, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/portofino/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start each day right by waking up in one of our gorgeous Wichita apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/remington-wichita/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start each day right by waking up in one of our gorgeous Wichita apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/silver-springs-apts/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start each day right by waking up in one of our gorgeous Wichita apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/belton/center-301/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>After a long day, there’s nothing better than coming home to one of Center 301’s idyllic apartment homes and relaxing in solitude or connecting with friends. Plush carpeting squishes under your feet in your living and dining area, complemented by the addition of personalized touches like cushy sofas. Your designer kitchen will help you easily prepare meals, all while featuring stylish touches that enhance your home’s beauty, like custom kitchen cabinetry and marble countertops. Our in-apartment amenities include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/152-northland/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our Kansas City apartment homes all feature a sophisticated atmosphere. Marble kitchen counters, stainless steel appliances, and plush carpeting are just a few of our elegant design choices that blend together to create a cozy living environment.</p>\n<p>We also have modern electronic thermostats and spacious closets, providing ample storage space. Fireplaces are also available as an option for any of our floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/97-north-oak/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Stylish interiors with marbled kitchen counters, plush carpeting, and stainless steel appliances characterize our Kansas City apartment homes. Enjoy cooking homemade meals in our full apartment kitchens, each including a side-by-side refrigerator with an ice maker, dishwasher, stove, garbage disposal, and microwave. With looming nine-foot ceilings, there’s plenty of room to fill your apartment with stylish furniture and personal touches.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/mark-apts/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Whether you live alone, with a partner or roommate, or with your furry friend(s), we want you to enjoy life inside your four walls. When you live at The Mark, you will be treated to a number of in-home amenities designed for your convenience. Along with having an apartment with a fireplace and an apartment with a washer and dryer, here are some of the features you’ll have access to when you live in one of our Ridgeland apartment homes:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/sunchase-ridgeland-apts/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>With a wide range of luxury apartment amenities at Sunchase Ridgeland, every day feels like a vacation. Enjoy your private balcony, or invite friends to chat around your wood-burning fireplace. You can also enjoy a home-cooked meal from your well-equipped kitchen. The possibilities of upscale apartment living are endless with the help of our amenities.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/the-pointe-of-ridgeland/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Point of Ridgeland Apartments, we understand that the heart of any home is the kitchen. Our well-equipped kitchens, complete with dishwashers, make meal prep a breeze. With our large and spacious closets, you’ll have ample space to store your belongings, keeping your apartment tidy and clutter-free.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/trace-apts/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>One of the best things about our Ridgeland apartment community is the several amenities in our apartments and in our community. Searching for apartments with a fitness center or a pet-friendly apartment in Ridgeland? Check and check—you’ll find both at the Trace of Ridgeland.</p>\n<p>Amenities inside our luxury Ridgeland apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The inside of your upscale apartment home and the serene grounds of The Park at Mission Hills carry a luxury and comfortable living theme defining our community. Make every meal something to remember in your fully equipped kitchen, complete with stainless steel appliances and ample storage space. With available options for cozy fireplaces and spacious vaulted ceilings, you can customize your apartment to construct your desired living space.<br/><br/>You’ll find the following amenities in our apartment homes:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/redbud-ranch/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start each day right by waking up in one of our gorgeous Broken Arrow apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We pay attention to every detail in our Broken Arrow apartments. Revel in chic elements such as lofty ceilings, energy-saving stainless steel appliances, and generous closet space. Keyless entry makes it easy to come home and relax at the end of the day, and your private patio or balcony, available in select layouts, offers a perfect spot to unwind and take in the stunning vistas of Broken Arrow, Bixby, and Tulsa. In-home features include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our luxury apartment community in Broken Arrow, OK, offers carefully designed <a href=\"/apartments/ok/broken-arrow/villas-at-aspen-park/floor-plans#/\"><strong>six 1 and 2 bedroom floor plans</strong></a> that fit diverse needs. At the Villas at Aspen Park, we provide upscale features and modern community amenities that enhance your lifestyle and provide an elevated level of comfort. Our apartments and lofts have practical features like spacious closets, designer interiors, and a barstool-ready kitchen peninsula.</p>\n<p>We also offer luxurious apartment community features to cater to your every need. These features include a well-equipped fitness center, an on-site pond perfect for watching sunsets, a resort-style swimming pool for soaking up the sun, and a clubhouse for throwing parties. Everything you need for a relaxing and convenient life is just outside your door.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start each day right by waking up in one of our gorgeous Jenks apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/artisan-crossing-apts/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>From essential amenities to luxurious finishes, each of our apartments was designed with you in mind. Beautiful chef’s kitchens, cozy living and dining areas, and well-designed bathrooms await you in our Norman apartment homes. Invite your friend or partner over for a home-cooked meal from your gorgeous kitchen and chat while hanging out at your kitchen island or have a movie night in your relaxing living area. Amenities in our apartment homes include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>When you come home to Cimarron Trails, your apartment welcomes you and encourages you to relax and destress after long days at work or school. Head out to your private patio or balcony and breathe in the fresh air, or grab a treat from your kitchen, equipped with a spacious pantry for food storage. The in-home amenities in our Norman apartment homes include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start each day right by waking up in one of our gorgeous Oklahoma City apartment homes. Enjoy the plush feeling of carpeting under your feet and sunlight shining through the large windows. Brew yourself a cup of coffee in your full kitchen, equipped with stainless steel appliances, and enjoy sipping it in the fresh air of your private balcony or patio. Other features and amenities in our apartments, lofts, and townhomes include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>As you look around our <a href=\"/apartments/ok/oklahoma-city/cimarron-pointe-apts/floor-plans#/\"><strong>Oklahoma City townhomes and apartments</strong></a>, you’ll find all the essentials you need for day-to-day living, like washer and dryer connections, a fully equipped kitchen with a dishwasher and disposal, and spacious closets. Select apartment homes also include a wood-burning fireplace so you can get cozy on cold winter nights. You’ll find the following amenities in our Oklahoma City apartments and townhomes:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/park-at-tuscany/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start each day right by waking up in one of our gorgeous Oklahoma City apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/persimmon-square-apartments/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start each day right by waking up in one of our gorgeous Oklahoma City apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start each day right by waking up in one of our gorgeous Oklahoma City apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/stonehorse-crossing/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start each day right by waking up in one of our gorgeous Oklahoma City apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summerfield-place-apts/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start each day right by waking up in one of our gorgeous Oklahoma City apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/tammaron-village-apartments/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start each day right by waking up in one of our gorgeous Oklahoma City apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/warrington-apartments/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start each day right by waking up in one of our gorgeous Oklahoma City apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start each day right by waking up in one of our gorgeous Oklahoma City apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start each day right by waking up in one of our gorgeous <span data-type=\"field-token\" data-field=\"property_address_city\"></span> duplex homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/coffee-creek/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start each day right by waking up in one of our gorgeous Owasso apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cypress-crossing/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Step into your new home at Cypress Crossing, where comfort and style are standard features. From high ceilings and plush carpeting to energy-efficient stainless appliances, every functional and aesthetic touch is designed to enhance your living experience. With options for townhomes, lofts, and apartments, plus select homes featuring private patios or balconies, you’ll find the perfect space to call your own.</p>\n<p>Apartment amenities at Cypress Crossing include:<br/></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/pryor/west-530/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Each apartment is fully outfitted with modern, energy-efficient appliances with a stainless steel finish to complement the custom granite countertops. Spacious, custom cabinetry offers ample room for storage, and select apartments with a balcony offer a relaxing space to enjoy a morning coffee.</p>\n<p>Inside, convenience and comfort go hand in hand. Stay cozy year-round with plush carpeting in bedrooms and individually controlled climate settings and ceiling fans to keep your space as you like. Every home also includes an in-apartment washer and dryer to make laundry days a breeze. Other features include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-glade-apts/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Whether you’re relaxing after a long day, hanging out with friends, or getting some work done, your apartment home is equipped with amenities that will make you feel at home. The spacious and well-equipped kitchen simplifies mealtime, and the open-concept living and dining area is ideal for dinner parties or movie nights. In your Cedar Glade apartment, you’ll enjoy the following amenities.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start each day right by waking up in one of our gorgeous Tulsa apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/nickel-creek-apts/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start each day right by waking up in one of our gorgeous Tulsa apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/polo-run-apartments/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start each day right by waking up in one of our gorgeous Tulsa apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start each day right by waking up in one of our gorgeous Tulsa apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start each day right by waking up in one of our gorgeous Tulsa apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The amenities inside our apartment homes in south Tulsa will complement your daily routine well. Start your day by sipping a coffee at the kitchen counter, which can easily accommodate some stylish bar stools. Make yourself a home-cooked breakfast in the fully equipped kitchen before your commute and return home to the comfortable living room, where the plush carpeting cushions your steps. You’ll find the following amenities in our south Tulsa apartments:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start each day right by waking up in one of our gorgeous Tulsa apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/the-ridge-@-66/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start each day right by waking up in one of our gorgeous Yukon apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start each day right by waking up in one of our gorgeous Amarillo apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start each day right by waking up in one of our gorgeous Amarillo apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Colonies at Hillside goes beyond just offering a place to stay. We’re a vibrant community that curates a truly luxurious living experience for all our residents. You’ll have access to an array of exciting and convenient amenities when you call us home.</p>\n<p>You get much more than just standard living space with us, like garages, apartments with lots of natural light, and our pool. We have a 24-hour fitness center, so you can work out whenever it suits your schedule. Find the perfect apartment and enjoy a lifestyle of unparalleled comfort and sophistication in southwest Amarillo.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start each day right by waking up in one of our gorgeous Amarillo apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/acacia-park-apts/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>In addition to our luxury amenities outside your apartment, you can enjoy many amenities inside our West El Paso apartments. Our <a href=\"/apartments/tx/el-paso/acacia-park-apts/floor-plans\"><strong>floor plans for 1, 2, and 3 bedroom apartments</strong></a> feature spacious kitchen, dining, and living spaces, ample closet space, and upgraded fixtures throughout. Spend the mornings with a cup of coffee or evenings with a delicious meal on the private patio or balcony. Other apartment amenities we offer in West El Paso include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/chimneys-apts/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Each spacious and cozy apartment home has a dedicated line of amenities to enhance your comfort. Many of our properties have a private patio or balcony and even wood-burning fireplaces. We strive to provide you with what’s needed to make your apartment feel like home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Whether you’re looking for a home for you and your pet or are moving in with a partner, Double Tree Apartments combines contemporary style with comfort and convenience in our 1 bedroom and 2 bedroom apartments. Each apartment home has luxury amenities, like plush carpeting throughout and air conditioning, to ensure comfortable and peaceful living at Double Tree in West El Paso. Our other premier apartment features include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 1 bedroom and 2 bedroom apartments in El Paso feature several apartment amenities like upgraded kitchens, spacious floor plans, and a private balcony to ensure a comfortable, refined way of living. Each High Ridge home includes an open-concept living and dining space, perfect for entertaining friends. Additional apartment amenities include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/mountain-village-apts/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>A luxurious lifestyle deserves an upscale home to complement it. To make your dream home a reality, Mountain Village offers several in-unit amenities to our tenants and their furry friends so everyone can enjoy an enhanced living experience. You’ll benefit from spacious closets, powerful air conditioning, and more when you stay with us. Other features that we offer include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/patriot-apts/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start each day right by waking up in one of our gorgeous El Paso apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/phoenix-apts/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The convenient amenities in our El Paso apartments are ideal for entertaining friends, spending quality time with loved ones, or unwinding after your evening commute. Feel the plush comfort of the carpeting under your feet and the fresh air from our picturesque windows. Cook a comfort meal in a full apartment kitchen with a stove, refrigerator, refinished countertops, and a dishwasher for convenient cleanup. Amenities in our apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/shadow-ridge-apts/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Renting one of our pet-friendly apartments at Shadow Ridge provides everyone, including your furry friends, the best apartment amenities in El Paso. Enjoy a nice meal with your family or friends in our well-equipped kitchen, or enjoy the scenic views on your patio or balcony. If you want to read by the fireside, look into our apartment homes with a built-in fireplace. Whatever you envision your ideal apartment home, we’ve got you covered.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/hewitt/icon-at-hewitt/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start each day right by waking up in one of our gorgeous Hewitt apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>In each of our <a href=\"/apartments/tx/lubbock/cottages-at-abbey-glen/neighborhood\"><strong>Lubbock apartments</strong></a>, you’ll enjoy plush, wall-to-wall carpeting and ceramic tile. Our spacious closets can fit your entire wardrobe and even a small shoe collection. Plus, our 1 bedroom and 2 bedroom apartments with a bump-out option can give you room to create a reading nook or cozy corner. Our in-apartment amenities include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>In our quest to create a home-like atmosphere, each spacious and inviting apartment home has a remarkable array of amenities. With sleek appliances in your kitchen, premium ceramic tiling, and ample storage space throughout your home, we’re committed to providing everything you need to turn your apartment into a true sanctuary, from private patios and balconies to ceramic tile.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/temple/portico-at-friars-creek-apts/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Every apartment at Portico at Friars Creek has a long line of amenities to elevate your living experience. Whether you need stainless-steel appliances for trying out new recipes or an apartment with a garage, patio, or balcony, maximize your comfort with our apartment amenities in Temple, TX.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>With our upscale apartment kitchens and spacious living/dining areas, you’ll be excited to host in your Waco apartment. You can enjoy luxury living without even leaving your apartment, thanks to our many in-apartment amenities, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/tuscany-ranch-apartments/amenities::amenitieslist.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start each day right by waking up in one of our gorgeous Waco apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/amenities::amenitieslist.apartment_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Duplex Amenities in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>If you’re searching for secure apartments, you’re in the right place. Arbors of Pleasant Valley apartments are secured with limited gate access that helps provide you with peace of mind. Additionally, you’ll enjoy the convenience of having your packages securely received and stored for you, ensuring that you never miss a delivery.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/north-little-rock/lexington-park/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Streamline your daily routine by taking advantage of the many community amenities at Lexington Park Apartments in North Little Rock. Save money on a gym membership and stay active at our full fitness center, open 24 hours and stocked with all the equipment you need for a good workout. Our pet-friendly community also features a large on-site dog park, where your pup can stretch its legs and make some new friends. Community amenities at Lexington Park include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/maize/watercress-apartments/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Watercress Apartments is more than just a living space. It represents a way of life. Uncover the amenities spread across the community, transforming Watercress into a haven reminiscent of an all-inclusive resort.</p>\n<p>Embrace the winter months by hosting friends in our clubhouse with complimentary WiFi, savoring cozy evenings by the firepit on brisk autumn nights, relishing the invigorating spring breeze in our outdoor lounge, or refreshing yourself in the zero-entry pool during the scorching summer days. Additionally, our community offers:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Throughout our apartment community, you'll find amenities designed to suit your needs, allowing you to make the most of every day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/crown-chase-apts/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Crown Chase offers several community amenities to help you relax, recharge, or stay active. Head to our 24-hour fitness center for your daily workout, equipped with free weights, treadmills, and cable machines. When you want to soak up the summer sun, relax in one of our pool loungers or take a dip in our sparkling swimming pool, which also includes a grill for cooking up some brats or burgers.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/huntington-park/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The relaxing Huntington Park apartment community in Wichita includes luxury amenities to help you stay active or kick back and relax. However you want to spend your day, you’ll never run out of things to do at our Wichita apartment community. The sparkling outdoor pool invites you to cool off on hot summer days, relax in the hot tub, or work on your tan in one of the pool loungers. When you need a workout, head to our full fitness center, equipped with weights, cardio equipment, and cable machines. Community amenities at Huntington Park include</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/newport-wichita-apts/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Throughout our apartment community, you'll find amenities designed to suit your needs, allowing you to make the most of every day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/portofino/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><a href=\"/apartments/ks/wichita/portofino/neighborhood\"><strong>Our private community in Wichita</strong></a> offers a resort-style pool behind our limited access gates to cool off as your dogs enjoy a run around our spacious Bark Park. You can bring friends and family over to enjoy a barbecue outside with multiple grills and picnic areas in our well-maintained courtyard, or for more quiet evenings, relax in our firepit lounge under the stars. Portofino stays running day and night at our all-hours fitness center, and you can take your workout outdoors as you explore our community grounds and the other upscale amenities available to you:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/raintree-apartments/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Enjoy our community’s on-site amenities as part of your daily routine. From fishing in the scenic lake just steps from your door to refreshing swims in the pool during the hot summer months, there’s something for everyone. If you need to focus, take advantage of the complimentary coffee in the internet cafe. Our community amenities at Raintree Apartments in Wichita include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/remington-wichita/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Take advantage of the premium amenities throughout our Wichita apartment community at The Remington Apartments. Dive into relaxation at our outdoor swimming pool, or sit poolside on our comfortable lounge chairs to soak up the sun. Stay active at our on-site fitness center, equipped with cardio machines and free weights for your workout needs. Amenities around our Wichita apartment community include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/silver-springs-apts/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Cool off during the scorching summer months in our indoor tropical pool at Silver Springs Apartments in Wichita. When the weather is more moderate, savor an outing with loved ones at our barbecue and picnic area. Our community ensures a lifestyle of comfort and convenience. Explore the outstanding community amenities we offer.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Indulge in a luxurious lifestyle at our apartment community in northeast Wichita, KS. Throw a birthday party with family in the clubhouse, relax by one of the two resort-style pools, spend the afternoon at the on-site playground, or design a website from the comfort of the internet cafe. The opportunities and amenities are endless at the Villas of Waterford! Our additional apartment community amenities include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/independence/the-adirondack/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our vibrant apartment community in Independence offers many amenities, so you’re ready for every occasion. Unwind with a book at our resort-style pool, host a barbecue with loved ones at our Grill and Chill area, or accomplish your fitness goals with a workout in our state-of-the-art fitness center with weights and medicine balls. Whatever your heart desires is within steps of your front door—not to mention the numerous <a href=\"/apartments/mo/independence/the-adirondack/neighborhood\"><strong>dining, shopping, and entertainment options</strong></a> within minutes of our community.</p>\n<p>Enjoy countless other community amenities at The Adirondack Apartments, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/152-northland/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The comforts of 152 Northland extend beyond the walls of your home. Our Northland apartment community is designed to support your lifestyle, as you’ll have the opportunity to break a sweat by hitting our 24/7 fitness center or swimming laps at our resort-style swimming pool.</p>\n<p>If you want to host loved ones for a weekend day during Kansas City’s long summers, we have an outdoor grilling area, perfect for barbecues with friends, and an indoor clubhouse where you can rest in the air conditioning.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/97-north-oak/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Make the most of every day in Kansas City by living in our <a href=\"/apartments/mo/kansas-city/97-north-oak/neighborhood\"><strong>Northland apartment community</strong></a>, featuring resort-style amenities for residents to enjoy. Stay on top of your fitness routine by visiting our 24-hour fitness center, stocked with free weights, cable machines, cardio equipment, and yoga balls. For those hot Kansas City summer days, cool off in our resort-style pool, complete with a tanning ledge. You’ll also find a nearby cabana, an ideal spot for poolside reading.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/mark-apts/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>You deserve to feel comfortable in your home. The Mark Apartments has a number of state-of-the-art community amenities in place for you to explore in order to create an all-around luxurious experience you can enjoy. You won’t have to drive all the way to the gym when you stay at our apartments with a fitness center, as you can utilize our 24-hour fitness center or find some friends to play doubles on our tennis courts. On top of that, you can cool off afterward by taking a dip, as we offer apartments with a swimming pool!</p>\n<p>Other amenities we offer include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/the-pointe-of-ridgeland/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Whether you prefer cardio workouts or weight training, our well-equipped, 24/7 fitness center has everything you need to meet your fitness goals. Bring a friend and test out your racquetball skills at our unique indoor racquetball court! We also have a convenient laundry facility available to all residents, eliminating the need for time-consuming trips to the laundromat.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/trace-apts/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>When you live at Trace of Ridgeland, you’ll find so much to do, you won’t even have to leave the community. Hit a new PR on squats at our full fitness center, cool off during hot Mississippi summers in our sparkling swimming pool, or catch up with friends over coffee at our resident clubhouse. Our Ridgeland apartment community amenities include:.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our community’s premium features extend beyond your front door. Enjoy quality time with friends and family outdoors in two resort-style pools, or come back inside for a relaxing evening by your fully functioning fireplace. You can enjoy all the amenities of a gym in the privacy of your community at our fitness center, and why not top off your workout with a stroll through our on-site dog park with your canine companions?</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/redbud-ranch/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Broken Arrow’s luxury Redbud Ranch apartment community provides resort-style amenities for relaxation and quality time with loved ones. Our on-site fitness center is fully equipped with treadmills, ellipticals, weights, and cable machines, offering the ideal space to exercise and break a sweat. Unwind in our beautiful clubhouse or pool cabana, creating memorable moments with friends and family. Here are the community amenities provided in our apartment home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Outside your apartment in our serene community, you’ll discover everything you need for your daily routine. Cardio equipment and weights are available in our fitness center to help you reach your fitness goals. When the hot summers in Broken Arrow arrive, indulge in a refreshing dip in our resort-style pool or unwind in the cabana with a cool beverage and your favorite magazine. Our community amenities include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>In our tranquil community, everything you need for your daily routine awaits outside your apartment. At Trails at Aspen Creek, you can keep up with your fitness regimen anytime in our 24-hour gym. During hot and humid Broken Arrow summers, take a refreshing swim in our resort-style pool with a sun deck or partake in some friendly competition at our clubhouse, featuring billiards and shuffleboard. Our community amenities offer:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Escape to the luxurious lifestyle you’ve always dreamed of at our sophisticated apartment community in Broken Arrow, OK. We offer an array of community amenities designed to make your life easier. You can achieve your fitness goals with our fitness center’s exercise machines, free weights, and medicine balls. Take a refreshing dip in our sparkling swimming pool on hot summer days, or host unforgettable events with friends in our elegant clubhouse. Gather around the cozy outdoor fireplace to socialize or show off your culinary skills at our state-of-the-art grilling station and picnic tables.</p>\n<p>The Villas at Aspen Park offers an abundance of other amenities to explore, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/fountain-lake/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Thanks to our luxury community amenities, you can choose your own adventure every day at Fountain Lake Apartments in Edmond. Start your day the right way with a workout in our full fitness center or complimentary coffee from our on-site coffee bar. Invite your friends over for lunch at our grilling and picnic area or for a dip in the pool. Community amenities throughout Fountain Lake include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Live the life you’ve always dreamed of at our apartment community in Edmond, OK! Our two fitness centers are fully equipped with a range of exercise machines and free weights, aiding you in achieving your fitness goals. On sizzling summer days, take a dip in or lie beside one of our two sparkling swimming pools or socialize with friends at the Grill and Chill area. With so many amenities at your fingertips, you’ll never want to leave our community!</p>\n<p>At the Villas at Stonebridge, there’s no shortage of exciting amenities to explore, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/moore/mission-point/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>You’ll find every luxury feature you’ll ever need outside your apartment. Our fitness center is always open so early birds and night owls can stay healthy and active. Invite your friends and family for a meal to remember in our outdoor barbecue and cool off under the arcing fountains in our community pool. However you live your life, we’ll be here to make sure you can enjoy your home in comfort. More community amenities include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/artisan-crossing-apts/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>As you depart your Norman apartment, our inviting, luxury community greets you with amenities to help you make the most of every day. Start the day by walking around our lush green courtyards or playing with your dog at the on-site dog park. When you want to spend time with friends, invite them over for lunch at our grilling stations and picnic area. Amenities throughout our Norman apartment community include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Whether you prefer to enjoy a peaceful day on your own or invite your friends over to hang out, Cimarron Trails has all the amenities you need to enjoy your day. Head to our grilling station and picnic area and enjoy a barbecue lunch, or cool off on hot summer days in our swimming pool with an attached sun deck. When it’s time to get your errands done, our laundry facility will make doing your chores more convenient. Community amenities at our Norman apartment community include: </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Throughout our luxury apartment community, you’ll find amenities designed to suit your needs, allowing you to make the most of every day. Keep up with your fitness routine at our full on-site fitness center, get some studying or work done in our business center, or kick back poolside in our cabana. Community amenities at 24Hundred include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our apartment community, located in Oklahoma City, OK, offers a luxurious lifestyle unlike any other. Our residents can access numerous amenities, including a well-appointed clubhouse perfect for hosting family gatherings, practicing your form in the fitness center, or enjoying a relaxing evening by the firepit.</p>\n<p>Whether you’re looking for a quiet retreat outside the bustling downtown or a spot to call home near the big city’s excitement, our Chisholm Pointe community has something for everyone. We offer additional community amenities, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>As you explore the Cimarron Pointe community, you’ll notice the many on-site amenities available, including two pools, two laundry facilities, a cozy resident clubhouse, and a convenient business center. Whether you plan on relaxing all day or getting some work done, our Oklahoma City apartment community has what you need. Our complete list of community amenities includes:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Enhance your daily routine with our community’s on-site amenities. Head to the on-site fitness center, where you’ll find a variety of equipment to accommodate your workout needs. On hot days, seek refuge from the heat in our sparkling on-site pool. Our business center is the place to go if you need to get some work done, with complimentary coffee available for residents. Community amenities at Council Place Apartments in Oklahoma City include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>What makes Cross Timber’s Oklahoma City apartment community unique? Our community offers a long list of amenities that take your weekends to the next level. Go for a dip in our sparkling pool and then dry off while sunbathing in one of our lounge chairs, or grill yourself some lunch at our barbecue area. Our on-site fitness center, equipped with weights, cardio equipment, cable machines, and a smart fitness mirror, invites you to work out your way. Enjoy these included amenities when you live at Cross Timber apartments in OKC:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/park-at-tuscany/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Oklahoma City apartment experience doesn’t end when you step outside your front door. In fact, it’s just getting started with our expansive line of community amenities. Take your furry friend to our on-site dog park or get some physical activity at our fitness center and pool. The opportunities for recreation and comfort are endless with our community amenities at Park at Tuscany.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/persimmon-square-apartments/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Persimmon Square, you can indulge in lavish amenities that elevate your everyday experience. Imagine gliding into a convenient covered parking space, feeling the warm embrace of the sun at the outdoor swimming pool, and mingling with friendly neighbors in the inviting resident lounge. But the luxuries don’t end there. Other community amenities await, ready to enhance every aspect of daily life, such as:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/stonehorse-crossing/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>As cozy as your apartment or townhome, step outside to discover a wealth of community amenities. Take a refreshing dip in our resort-style swimming pool on hot summer days, or soak up the sun on the expansive pool deck. Stay active and maintain your fitness goals in our state-of-the-art 24-hour fitness center, and for those who enjoy outdoor activities, our lushly landscaped grounds offer calming walking trails, perfect for strolls or morning jogs. </p>\n<p>Additionally, our <a href=\"/apartments/ok/oklahoma-city/stonehorse-crossing/pet-policy\"><strong>pet-friendly community</strong></a> features a spacious dog park where your furry friends can run and play to their hearts’ content, along with these other amenities:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summerfield-place-apts/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Embrace each day to the fullest at our <a href=\"/apartments/ok/oklahoma-city/summerfield-place-apts/pet-policy\"><strong>pet-friendly apartment community</strong></a> in Oklahoma City, where you can enjoy a revitalizing swim in the outdoor pool or focus on your studies in the elegant clubhouse. Summerfield Place also offers a well-equipped fitness center featuring cardio machines and free weights to support your fitness goals. Discover the following community amenities at Summerfield Place.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summit-ridge-villas/summit-villas/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our apartment community, located in Oklahoma City, OK, offers a luxurious lifestyle unlike any other. Our residents can access numerous amenities, including a well-appointed clubhouse perfect for hosting family gatherings, practicing your form in the fitness center, or enjoying a relaxing evening by the firepit.</p>\n<p>Whether you’re looking for a quiet retreat outside the bustling downtown or a spot to call home near the big city’s excitement, our Chisholm Pointe community has something for everyone. We offer additional community amenities, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/tammaron-village-apartments/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Make the most of your weekends with the community amenities at Tammaron Village near the Brookhaven West neighborhood. Bask in the sunshine on the sun deck or unwind in the refreshing waters of our two swimming pools during those balmy summer days. Among the amenities offered at our Oklahoma City apartment community are:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/warrington-apartments/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience the upscale amenities that extend throughout our inviting community. From the moment you step outside your apartment, you’ll encounter an environment of comfort and convenience at every turn.</p>\n<p>Utilize our contemporary fitness center, complete with a range of weights and cardio equipment, allowing you to maintain your exercise regimen at your convenience. Unwind in a lounge chair to soak up some vitamin D or enjoy a refreshing dip in the pristine waters of our outdoor swimming pool. The Warrington offers the following community amenities.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Whether you’re living with your furry friend or loved ones or simply want to set up the bachelor pad of your dreams, you can enjoy our community amenities. Our apartment community in Oklahoma City has two pools where you can cool off during the hot summer months. Wear your sports shorts and head to our volleyball or tennis courts for a little competition. And don’t forget our beautiful lakeside gazebo and fishing pond if you’re in the mood for something calmer.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Throughout our luxury duplex community, you'll find amenities designed to suit your needs, allowing you to make the most of every day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our entire community is dedicated to providing you with the resources and luxuries of a premium apartment lifestyle. Glide into our outdoor pool, adorned with a shaded sun deck and cabana with plenty of room to lounge by the water. A barbecue courtyard and grilling area are just a few steps away from our beach-like poolside, presenting an ideal place for get-togethers with family and friends or a peaceful date night under the stars. More community amenities await in our <a href=\"/apartments/ok/owasso/cottages-at-tallgrass-point/pet-policy\"><strong>pet-friendly apartment community</strong></a>, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cypress-crossing/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Life at Cypress Crossing comes with plenty of perks beyond your front door. <strong><a href=\"/apartments/ok/owasso/cypress-crossing/pet-policy\">Our pet-friendly community</a></strong> is built around convenience and leisure for all our residents and guests. Find peace and focus while working remotely in our business center, enjoy some exercise while taking your furry friend to our on-site dog park, or bask in the sunshine by the pool.</p>\n<p>There’s always something to enjoy here! Our community amenities include:<br/><br/></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/pryor/west-530/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Take advantage of the community features at West 530 — designed to make daily life more comfortable, social, and convenient.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/barrington-apartments/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>As you stroll along the walking paths throughout our verdant grounds, you’ll discover the numerous amenities around our Tulsa apartment community. Accomplish your goals at our full fitness center, which is equipped for cardio and strength training workouts. On hot days, head to our pool and crack a good book in one of our lounge chairs or cool off in the bright blue water. When you want to challenge your friends to some friendly competition, invite them to our sand volleyball or basketball courts. Community amenities at Barrington Apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cascata-luxury-apartments/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our luxury Tulsa apartment community features resort-style amenities that invite you to unwind and spend time with the meaningful people in your life. Get a good sweat in our on-site fitness center, which is equipped with treadmills, stationary bikes, ellipticals, weights, and cable machines. When you want to spend time with friends and family, invite them over and kick back in our outdoor lounge or cabana.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Luxury isn’t just a word when you live at Cedar Ridge—it’s a lifestyle. Experience the many amenities located throughout the community, which make Cedar Ridge feel like an all-inclusive resort. Enjoy every season at our Tulsa apartment community. Take refuge from the winter chill and invite friends over for a game of shuffleboard in our game room, cozy up on crisp autumn nights at our outdoor fireplace, breathe in the fresh spring air at our outdoor lounge, and cool off in our refreshing pool on hot summer days. Amenities around our community include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/creekwood-apartments/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>High-quality amenities await you all around our south Tulsa apartment community. Creekwood has a heated indoor pool and an outdoor pool so you can enjoy a swim any time of the year. Next to our indoor pool, a sauna stands ready to steam all your troubles away. When you need a good workout, head to our on-site fitness center, featuring cardio equipment, cable machines, and free weights. Amenities around our Tulsa apartment community include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/nickel-creek-apts/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The luxuries at Nickel Creek continue beyond just your front door. Our community amenities were developed with resident experience in mind for a community you’ll love to call home. Cool off at our pool, host friends at the grill &amp; chill outdoor kitchen, or get your sweat on in the fitness center. No matter how you choose to spend your time, you’re sure to love calling Nickel Creek home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>It is a pleasure to live at Sheridan Pond because we offer a wide range of amenities. You can engage in a game of fetch with your furry friend at our on-site dog park, partake in a friendly match on our basketball or tennis courts, or savor moments with family at the gazebo near our catch-and-release pond.</p>\n<p>Whether you want to connect with neighbors or relax, our cozy clubhouse offers a welcoming space with comfy chairs and sofas. Our community amenities include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our Tulsa apartment community offers many community amenities within its charming property. Embrace a workout regime with our well-equipped fitness center catering to cardio and strength training enthusiasts.</p>\n<p>On hot summer days, unwind in style by either of our two sparkling swimming pools, where you can bask in the sun on a lounge chair while engrossed in a captivating read or take a refreshing dip. For those seeking a more active pastime, engage in friendly matches on our illuminated tennis court. Explore the range of amenities that Sugarberry Apartments have to offer.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>As a resident of Sunchase, a welcoming and serene community, you can have access to a diverse array of amenities. Unwind in our clubhouse or dip in either the outdoor or indoor swimming pool. Our convenient business center, equipped with a computer and printer, is available if you need to complete work or school tasks. The amenities available in our Tulsa apartment community include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The long list of community amenities at The Courtyards will ensure you’re never bored. Spend summer afternoons floating in the sparkling pool, which features a sun deck with lounge chairs for relaxing. Kick-start your morning with a cardio or strength workout at our on-site fitness center, or head to the on-site dog park and spend some quality time playing with your pup. Amenities you can find throughout our apartment community in south Tulsa include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Let The Greens of Bedford’s community amenities help you maximize your weekends. Spend hot summer days lounging on our sun deck or taking a dip in the cool water of our outdoor pool. When you need to stay on top of your fitness routine, our on-site fitness center is there for you through your New Year’s resolution and beyond. Amenities around our Tulsa apartment community include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>In our Tulsa apartment community, we provide amenities designed to enhance your daily experience. Stay active at any time with our 24-hour fitness center with free weights to support your workout regimen. Host delightful gatherings with friends at our grill and chill area, perfect for casual lunches and socializing. Discover Windsail’s array of community amenities, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Outside your apartment, The Park on Westpointe’s community features prepare you for every part of your day. Get a heart-pumping workout in at any hour in our fitness center, or enjoy a stroll through our naturally shaded and well-maintained courtyard. In this communal space, you’ll find our two resort-style private pools, barbecue area, and on-site dog park so every member of your family can enjoy their time at The Park on Westpointe. Community amenities in our Yukon apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/the-ridge-@-66/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start your day with an energizing workout in our state-of-the-art fitness center, or unwind with a refreshing swim in the pool. Bask in the sun on our tanning ledge, or challenge your neighbors to a game of billiards or shuffleboard in the clubhouse. For pet owners, our onsite dog park is the perfect place for your furry friend to play and socialize.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Here at Newport Apartments, we make every effort to ensure our residents can access comfortable multipurpose spaces that reflect their everyday needs. You and your canine companions can stretch your legs and enjoy the outdoors at our community Bark Park. Trees form a natural canopy over our courtyard for relaxing strolls across the community, and when the day is over, enjoy a meal to remember under our gazebo or around our barbecue and picnic area with your closest friends. More community amenities at Newport Apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Whether you prefer lounging by the resort-style swimming pool on hot summer days, enjoying scenic views as you take a leisurely stroll through beautifully landscaped grounds, or grilling for your friends and family at our outdoor grilling areas, the Remington Apartments in Amarillo have it all.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>No matter your living situation, Colonies at Hillside offers comfortable apartment living for everyone. As a resident of our <a href=\"/apartments/tx/amarillo/the-colonies-at-hillside/neighborhood\"><strong>Amarillo apartments</strong></a>, you can access many community amenities conveniently located on-site. We have an on-site exercise facility and workout area accessible 24/7—perfect if you’re looking for apartments with a gym. You can cool off when you are done by taking a dip in our private pool before you explore the multitude of other amenities we offer, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>With many community amenities at Winchester Apartments, boredom is never a problem. Kick off your day with a cardio or strength training session at our 24-hour fitness center, followed by indulging in a leisurely afternoon soaking up the sun on our comfortable lounge chairs or floating in the swimming pool.</p>\n<p>End your day with a delightful gathering with friends as you cook a feast in our designated grilling area. Explore the array of amenities available in our apartment community in Amarillo.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/acacia-park-apts/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Acacia Park Apartments, we provide an array of resort-inspired community amenities to meet your every whim and desire. Spend the morning next to the pool and poolside spa. Enjoy the afternoon with your furry friend at the dog park. Host friends and family for a sunset barbecue and picnic under a lovely pergola. Additional community amenities you’ll find at our Acacia Park luxury apartments in El Paso include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/chimneys-apts/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Whether you’re living with a partner and kids, a furry friend, or simply setting up a base for yourself, you can use our community amenities to maximize your comfort and entertainment. Our El Paso apartment community offers you a wide range of opportunities for recreation and relaxation. From our well-equipped fitness center to a day lounging out by the poolside, all our tenants can enjoy these amenities throughout our apartment community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Double Tree Apartments in West El Paso combines modern luxury with practical features to heighten your lifestyle and satisfy your every whim and desire. Beyond our sparkling outdoor swimming pool and spacious sun deck, we also offer numerous other community amenities for your convenience, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/mountain-village-apts/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Whether you live alone, with a furry companion, or with a roommate, partner, or child, you can find a comfortable apartment at Mountain Village. Our West El Paso apartments have access to many community amenities available on-site. You’re in luck if you’re looking for apartments with a gym or fitness center. We give residents 24/7 access to our exercise equipment and workout area. Your little ones can also burn off some energy in our kids’ recreation area or apartment playground.</p>\n<p>Other amenities we offer include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/patriot-apts/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Here at The Patriot, our residents enjoy amenities that enhance their everyday lives. Invite friends over for a match on our sand volleyball court, enjoy some barbecue with the family at our grilling and picnic area, or play fetch with your furry friend at our on-site dog park. If you want to mingle with your neighbors, we have a cozy resident clubhouse with lounge chairs and a sofa. Our community amenities include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/phoenix-apts/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Around the friendly, peaceful community of The Phoenix, residents have access to a variety of amenities. Relax and enjoy a barbecue with friends at our grilling and picnic area, cool off in our outdoor swimming pool, or relax and enjoy a cup of coffee in our resident clubhouse. If you need to finish some work or a school assignment, take advantage of our business center, which has computers and a printer. Amenities around our El Paso apartment community include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/shadow-ridge-apts/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Your luxury apartment experience doesn’t end when you leave the front door. Shadow Ridge additionally offers a wide range of community amenities for all our residents to use. Take a break with our pool and picnic areas, or work out at our fitness center. Have kids or a pet eager to get outside? Visit our playground or our on-site bark park. Additional amenities include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>You’ll find everything you need for your daily routine just outside your apartment in our peaceful community. At the Crest, a fully equipped fitness center, including cardio equipment and weights, will help you maintain your fitness regimen. When the El Paso heat is in full swing, we invite you to enjoy a refreshing dip in our on-site pool or engage in some friendly competition at our basketball court. Our community amenities include</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/hewitt/icon-at-hewitt/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>If you’re living with a partner and kids, a pet, or on your own, you can reap the benefits of the many community amenities available at the Icon at Hewitt. Whether you choose to work out at our 24-hour fitness center, relax at our private pool, or take your furry friend on a stroll through our on-site dog park, we encourage you to take advantage of the vibrant community right at your doorstep.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Luxury living continues even after you leave your apartment, thanks to our numerous community amenities. We offer upscale Lubbock apartments with a pool, gym, dog park, and so much more. Invite your friends over to our cozy courtyards and outdoor grilling area and enjoy a cookout or picnic. When you need to get out of your apartment, take a load off and relax in our clubhouse. The full list of community amenities you’ll find in our apartment community in Lubbock includes:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Whether living with a partner and kids, a furry friend, or just setting up a comfortable base, our community amenities offer you plenty of entertainment and comfort. We have plenty of recreation and relaxation opportunities in our Lubbock apartment community. With our secure gated community and on-site dog park, all tenants can take advantage of these and the following amenities:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/temple/portico-at-friars-creek-apts/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Luxury living in Temple doesn’t end when you leave out the door. We also have numerous community amenities for all our residents to use. With a fitness center, pool, on-site dog park, and much more, take advantage of the apartment community around you with our many amenities in Temple, TX.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p> If you want a Waco apartment with a pool, Bend at New Road is the perfect place for you. We also offer gated apartments in Waco, so you can enjoy peace of mind knowing our community is secure. You’ll enjoy the many top-of-the-line community amenities in our Waco apartment community, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/tuscany-ranch-apartments/amenities::amenitieslist.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Waco apartment experience doesn’t end when you step outside your front door. In fact, it’s just getting started with our expansive line of community amenities. Take your furry friend to our on-site dog park or get some physical activity at our fitness center and pool. The opportunities for recreation and comfort are endless with our community amenities at Tuscany Ranch.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "awardsintro.image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfd5c-8899-757e-88e0-9f20a3297fdd.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "awardsintro.image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfd5c-9418-77bf-a736-dd32d2fb065f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "basis-tracking-pixel.universal_pixel_id": {
    "overrideType": "VALUE",
    "customValue": "f8b0b9f1582eb809",
    "generatedValue": null,
    "mappedField": null
  },
  "careersemployees.bel_image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfd5c-ae4c-70f7-8548-1a6c06ea4fe8.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "careersemployees.emp_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfd5c-b7cb-742f-b384-0ff18282e675.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "careersemployees.emp_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfd5c-9dca-711a-bd7b-1b3613d84cb2.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "careersemployees.emp_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfd5c-a5ef-728b-bca1-99524da2f0d4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "careersintro.image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfd5c-e1a8-7466-813f-eff3bb0489c9.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "careersintro.image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfd5c-d8ae-7005-bfa7-d48a6c1082d4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "careersintro.image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfd5c-d00c-71e4-82f9-dd064594f5d8.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/north-little-rock::citymarket.seo_body": {
    "overrideType": "VALUE",
    "customValue": "<h2><strong>Apartments in Little Rock, AR</strong></h2><p>Situated along the Arkansas River, Little Rock—Arkansas’s capital and most populous city—has been growing and offers a wide range of cultural attractions and landmarks. Locations such as the Little Rock Central High School National Historical Site and the Arkansas Museum of Fine Arts provide excellent opportunities to explore local history and appreciate stunning art.</p><p>For over two centuries, Little Rock has flourished along the river, delivering an affordable living environment, a vibrant food scene, and numerous outdoor recreational options at places like Audubon Arkansas, Lake Maumelle, and Two Rivers Park. If you’re in search of a pet-friendly apartment in this dynamic city, look to the <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/ar/\"><strong><u>Arkansas apartment communities</u></strong></a> from Case &amp; Associates!</p><p>Our premier apartment communities are conveniently located near popular roads and major highways, making it easy to hop on the highway and take a weekend trip to Memphis, TN, or Dallas, TX, for a weekend trip! These roadways include:</p><ul><li><p>Interstates 30, 40, 440, and 630</p></li><li><p>Routes 10, 100, and 107</p></li><li><p>Highways 70 and 165</p></li></ul><h2><strong>Little Rock, AR, Apartment Homes Near Pinnacle Mountain State Park</strong></h2><p>Whether your goal is to live closer to the Bill and Hillary Clinton National Airport for travel or a bit further south, near Big Rock Mini Golf &amp; Fun Park, Case &amp; Associates proudly has two apartment communities in Little Rock, AR. Our Little Rock apartment communities include the <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/ar/little-rock/arbors-of-pleasant-valley/\"><strong><u>Arbors of Pleasant Valley</u></strong></a> and <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/ar/north-little-rock/lexington-park/\"><strong><u>Lexington Park Apartment Homes</u></strong></a>.</p><p>Situated in the <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/ar/little-rock/arbors-of-pleasant-valley/neighborhoods\"><strong><u>Rainwood Cove neighborhood</u></strong></a>, across from the Pleasant Valley Country Club, the Arbors offers <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/ar/little-rock/arbors-of-pleasant-valley/floor-plans\"><strong><u>1, 2, and 3 bedroom floorplans</u></strong></a> with stylish designs and private patios or balconies. At Lexington Park Apartment Homes, right off Route 100 and near the Richdale Shopping Center, you can enjoy living with <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/ar/north-little-rock/lexington-park/neighborhoods\"><strong><u>designer amenities</u></strong></a>, like granite countertops and crown molding in select apartments!</p><h2><strong>Apartment Community Amenities in Little Rock</strong></h2><p>Apartment living in Little Rock should accentuate and enhance your everyday lifestyle, not hinder it. Case &amp; Associates proudly provides a range of community amenities that provide residents with entertainment and common spaces to socialize with friends and family! After enjoying a picnic at Burns Park or kayaking at Murray Lake, you can return home to take advantage of all these amenities:</p><ul><li><p>Business Center</p></li><li><p>Clubhouse With Games, like Shuffleboard or Billiards</p></li><li><p>Covered Parking and Detached Garages</p></li><li><p>Fitness Center</p></li><li><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://getflex.com/\"><strong><u>flex. Payment Options Available</u></strong></a></p></li><li><p>Grilling Stations and Outdoor Lounge Area</p></li><li><p>Sparkling Swimming Pool With an Expansive Sundeck</p></li><li><p>Tanning Beds</p></li></ul><h2><strong>Little Rock Apartments With Spacious Bedrooms Near Little Rock Zoo</strong></h2><p>Each stylish apartment is stocked with amenities to enhance your living experience and provide you with everything you need! After exploring the Museum of Discovery, the Old State House Museum, and the William J. Clinton Library and Museum, you can return to your personal sanctuary, featuring expansive floorplans, spacious closets, and cozy plush carpeting. Other in-apartment amenities include:</p><ul><li><p>Super-Fast Internet Powered by AT&amp;T</p></li><li><p>Ceiling Fans, in Select Apartments</p></li><li><p>High Ceilings</p></li><li><p>Full-Size Washer and Dryer in Apartment</p></li><li><p>Large Windows With Window Coverings</p></li><li><p>Energy-Efficient Stainless Steel Appliances, in Select Apartments</p></li><li><p>Fully Equipped Kitchen</p></li></ul><h2><strong>Find Your Perfect Apartment in Little Rock, AR, From Case &amp; Associates</strong></h2><p>When you’re searching for a pet-friendly apartment in Little Rock, AR, look to Case &amp; Associates’ options—Lexington Park Apartment Homes and Arbors of Pleasant Valley—to discover your ideal apartment. From The Old Mill to Rock Town Distillery, wherever you enjoy spending time, our apartment homes can complement and enhance your lifestyle in Little Rock. Schedule a tour of the Arbors at Pleasant Valley or Lexington Park Apartment Homes today! You can also <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"tel:9184921983\"><strong><u>call</u></strong></a> or <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/contact-us/\"><strong><u>contact us online</u></strong></a> to get started or learn more about our apartments.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita::citymarket.seo_body": {
    "overrideType": "VALUE",
    "customValue": "<h2><strong>Apartments in Wichita, KS</strong></h2><p>Wichita, often called the Air Capital of the World due to its aviation history dating back to the early 1900s, is a vibrant city in south-central Kansas. As the state’s largest city, it offers a low cost of living, an expanding economy, and several notable landmarks, including The Keeper of the Plains, Great Plains Nature Center, Exploration Park, and Sedgwick County Zoo.</p><p>If you’re searching for your first apartment near Wichita State University or moving closer to downtown Wichita to attend Friends University, Case &amp; Associates is proud to offer 11 apartment communities across Wichita. Our communities feature studio, 1, 2, and 3 bedroom apartments with premium amenities and easy access to major roads, so you can get where you need to go. All our apartment communities are conveniently located near these major roadways:</p><ul><li><p>Interstate 35</p></li><li><p>Interstate 135</p></li><li><p>Interstate 235</p></li><li><p>Route 96</p></li><li><p>Highway 400</p></li></ul><h2><strong>Wichita, KS, Apartment Homes Near the Wichita Art Museum</strong></h2><p>Case &amp; Associates’ apartment communities throughout Wichita offer residents everything they need: pet-friendly apartments with luxurious in-apartment and community amenities to elevate your lifestyle. From Sedgwick County Park and Dwight D. Eisenhower National Airport to Frank Lloyd Wright’s Allen House, we can help you find the perfect apartment community that meets all your needs. Whether you value a private balcony or need an on-site dog park for your pet, we’re sure you’ll discover the ideal living space in Wichita!</p><h2><strong>Apartment Community Amenities in Wichita</strong></h2><p>After stepping through time while exploring some of Wichita’s most remarkable cultural attractions, like the Museum of World Treasures, Mid-America All-Indian Museum, the Kansas African American Museum, and the Kansas Firefighters Museum, you can return to your beautifully designed, fully equipped apartment. Case &amp; Associates’ apartment communities all feature unique amenities that bring the convenience right to your doorstep.</p><p>You can hang out with friends by the pool, head over to the grill and chill area to cook up some delicious dinner foods, and enjoy your meal under the stars. Many of our Wichita apartment communities feature on-site dog parks or access to walking trails, making them ideal for helping your pup burn off energy. Additional community amenities include:</p><ul><li><p>Grill and Chill Area</p></li><li><p>Clubhouse</p></li><li><p>24/7 Emergency Maintenance</p></li><li><p>On-Site Management</p></li><li><p>Swimming Pool and Sun Deck</p></li><li><p>On-Site Dog Park, at Select Communities</p></li><li><p>Business Center or Internet Cafe, at Select Communities</p></li><li><p>Laundry Facilities</p></li><li><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://getflex.com/\"><strong><u>flex. Payment Options Available</u></strong></a> logo</p></li><li><p>Access to Walking Trails at Select Communities</p></li><li><p>Fitness Center</p></li></ul><h2><strong>Wichita Apartments With Spacious Bedrooms Near Central Riverside Park</strong></h2><p>Each individual studio, 1, 2, and 3 bedroom apartment has been thoughtfully designed with convenient features and luxury amenities. From spacious layouts and large windows to fully equipped kitchens, you’ll find everything you need in one of our Wichita apartments. Enjoy coffee on your beautifully <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/blog/how-to-decorate-your-apartment-balcony/\"><strong><u>decorated private balcony</u></strong></a> or watch <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/blog/guide-for-taking-care-of-indoor-plants/\"><strong><u>your indoor plants thrive</u></strong></a> in the abundant natural light!</p><p>Additional features we offer include:</p><ul><li><p>Fireplace, in Select Homes</p></li><li><p>Private Balcony or Patio, in Select Homes</p></li><li><p>Fully Equipped Kitchen</p></li><li><p>Super-Fast Internet Powered by AT&amp;T Fiber</p></li><li><p>Washer and Dryer Connections, in Select Homes</p></li><li><p>Ceiling Fans, in Select Homes</p></li><li><p>Spacious Floor Plans</p></li><li><p>Large Closets</p></li><li><p>Plush Carpeting</p></li><li><p>Oversized Windows</p></li></ul><h2><strong>Find Your Perfect Apartment in Wichita, KS, With Case &amp; Associates</strong></h2><p>Visit one of our Wichita apartment communities near Watson Park or Botanica, the Wichita Gardens, featuring high-end amenities designed to enhance your lifestyle and simplify your life! Check out our <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/blog/\"><strong><u>apartment living blog</u></strong></a> for tips and tricks on <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/blog/tips-for-decorating-your-apartment/\"><strong><u>decorating your new apartment</u></strong></a>.</p><p>Schedule a tour of one of our <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/ks/\"><strong><u>apartment communities in Wichita, KS</u></strong></a>! You can also <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"tel:9184921983\"><strong><u>call our team</u></strong></a> or <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/contact-us/\"><strong><u>contact us online</u></strong></a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city::citymarket.seo_body": {
    "overrideType": "VALUE",
    "customValue": "<h2><strong>Apartments in Kansas City, MO</strong></h2><p>On the western border of Missouri, Kansas City is renowned for its rich jazz heritage, numerous fountains, delicious barbecue, and a history of Negro League Baseball. This dynamic city has been experiencing significant growth, and with many excellent attractions and activity hot spots nearby, such as Arrowhead Stadium, Kauffman Stadium, Loose Park and the University of Missouri-Kansas City, it can be challenging to find the right apartment in a competitive market.</p><p>Case &amp; Associates proudly offers beautiful, reasonably priced apartments, whether you’re looking for a 1 bedroom, 2 bedroom or 3 bedroom home! Plus, our communities are conveniently located near major roadways, including Highway 169, Route 152, and Interstates 29, 435, and 635. With such proximity to popular routes, you’ll be able to hit the road and visit the new exhibit at the National WWI Museum and Memorial or attend class at Metropolitan Community College.</p><h2><strong>Kansas City, MO, Apartment Homes Near The Nelson-Atkins Museum of Art</strong></h2><p>We offer three apartment communities in Kansas City, MO, each featuring modern designs, sleek finishes, and abundant amenities to sweeten your experience. Explore our three KC apartments below and schedule a tour today:</p><ul><li><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/mo/kansas-city/97-north-oak/\"><strong><u>97 @ North Oak Apartments</u></strong></a><strong>. </strong>Located just under 20 minutes north of downtown Kansas City, <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/mo/kansas-city/97-north-oak/neighborhoods\"><strong><u>in North KC</u></strong></a>, 97 @ North Oak is a brand-new construction not far from Zona Rosa, featuring stylish finishes and <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/mo/kansas-city/97-north-oak/amenities/\"><strong><u>modern amenities</u></strong></a>.</p></li><li><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/mo/independence/adirondack/\"><strong><u>The Adirondack Apartments</u></strong></a><strong>. </strong>Under 20 minutes to the east of downtown KC, Adirondack is another brand-new, <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/mo/independence/adirondack/pet-friendly/\"><strong><u>pet-friendly apartment community</u></strong></a>, sitting off Interstate 70, near the Independence Mall.</p></li><li><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/mo/belton/center-301/\"><strong><u>Center 301 Apartments</u></strong></a><strong>. </strong>Around 25 minutes south of downtown KC, Center 301 has <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/mo/belton/center-301/floor-plans/\"><strong><u>1 and 2 bedroom apartments</u></strong></a> and spacious townhomes near Wallace Park.</p></li></ul><h2><strong>Apartment Community Features in Kansas City Near Worlds of Fun</strong></h2><p>When searching for your perfect apartment, you should be able to find everything you’re looking for, right? It’s not always possible to discover an apartment that checks all your boxes—until now. Case &amp; Associates offers amenity after amenity throughout our communities to enhance your apartment living experience! The amenities we provide across our KCMO apartment communities include:</p><ul><li><p>AT&amp;T Internet and WiFi Connections</p></li><li><p>Clubhouse</p></li><li><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://getflex.com/\"><strong><u>flex Payment Options Available</u></strong></a></p></li><li><p>Fully Equipped Fitness Center</p></li><li><p>Grills and Picnic Tables</p></li><li><p>Onsite Dog Park</p></li><li><p>Spacious Layouts</p></li><li><p>Sparkling Swimming Pool</p></li><li><p>Washer and Dryer Connections</p></li></ul><h2><strong>Kansas City Apartments With Spacious Bedrooms Near Arrowhead Stadium</strong></h2><p>After an afternoon of hiking around Blue Springs Lake in the Jackson County Parks + Rec area, you enjoy returning home to a modern, stylish, and luxurious apartment that perfectly suits your needs. Our Kansas City apartment communities feature 1, 2, and 3 bedroom apartments and townhomes, so you can find a cozy spot near local amenities.</p><p>Our apartments feature soaring ceilings, plush carpeting, and large closets. You’ll love the open-concept kitchen, living, and dining rooms, as well as the oversize windows that bring in ample natural light. Select apartments feature a stunning fireplace that will be the centerpiece of your living space, as well as a private balcony or patio. Sip coffee watching the sunrise or unwind by the cozy fire in the evening—the opportunities are endless.</p><h2><strong>Find Your Perfect Apartment in Kansas City, MO, From Case &amp; Associates</strong></h2><p>Kansas City, MO, is a vibrant city filled with endless possibilities, attractions, and excitement. From the Kansas City Zoo &amp; Aquarium and Science City to the National Museum of Toys and Miniatures, you can find the perfect apartment community that meets all your needs, making life in KCMO delightful.</p><p>Explore our <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/mo/\"><strong><u>apartments in the Kansas City area</u></strong></a> online and schedule a tour today! If you have any questions, feel free to <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"tel:9184921983\"><strong><u>call us</u></strong></a> or <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/contact-us/\"><strong><u>contact us online</u></strong></a>. We’re excited to show you around!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland::citymarket.seo_body": {
    "overrideType": "VALUE",
    "customValue": "<h2><strong>Apartments in Ridgeland, MS</strong></h2><p>For just under two centuries, Ridgeland, MS, has been growing, with fine dining, excellent shopping, and vibrant entertainment options. Ridgeland is home to over 25,000 residents with easy access to many landmarks and popular attractions. These include the Mississippi Civil Rights Museum, the Mississippi Museum of Natural Science, and the Ross R. Barnett Reservoir.</p><p>When you’re searching for a luxury apartment near the Madison, MS, area,&nbsp; Case &amp; Associates has you covered! We offer four pet-friendly apartment homes across Ridgeland, ranging from studios to 3 bedroom apartments, all equipped with high-end amenities. Each of our communities is conveniently located near major roads, including Interstate 55, Highway 51, and the Natchez Trace Parkway, providing easy access to areas throughout Ridgeland.</p><h2><strong>Ridgeland, MS, Apartment Homes Near Strawberry Patch Park</strong></h2><p>If you need a new apartment before the upcoming semester at Jackskn State University or one closer to work by Renaissance at Colony Park, it’s easy to find your perfect apartment in Ridgeland, MS, at one of Case &amp; Associates’ apartment communities!</p><h2><strong>Apartment Community Amenities in Ridgeland</strong></h2><p>After an adventure in nature at LeFleur’s Bluff State Park or a class at Holmes Community College, you can return to your apartment community, which offers all the amenities you need to thrive in Ridgeland. Some of our apartment communities feature tennis courts where you can challenge friends to a game, grilling stations for preparing delicious dinners, and fitness centers to help you achieve your goals.</p><p>Take advantage of our other community amenities, such as:</p><ul><li><p>Laundry Facilities</p></li><li><p>24-Hour Maintenance</p></li><li><p>Swimming Pool and Sundeck</p></li><li><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://getflex.com/\"><strong><u>flex. Payment Options Available</u></strong></a></p></li><li><p>Open Parking</p></li><li><p>Spacious Grounds</p></li></ul><h2><strong>Ridgeland Apartments With Spacious Bedrooms Near Old Trace Park</strong></h2><p>Designed for functionality, comfort, and style, our studio, 1, 2, and 3 bedroom apartments offer you everything you need and more! With spacious floor plans and large closets, you’ll have ample room to organize your belongings. The apartments also feature oversized windows that allow for plenty of natural light. Additional top-tier amenities in our Ridgeland apartments include:</p><ul><li><p>Wood-Burning Fireplaces, in Select Apartments</p></li><li><p>Private Porch or Balcony</p></li><li><p>Cable Ready</p></li><li><p>Plush Carpeting</p></li><li><p>Ceiling Fans</p></li></ul><h2><strong>Find Your Perfect Apartment in Ridgeland, MS, With Case &amp; Associates</strong></h2><p>Look to Case &amp; Associates for meticulously designed pet-friendly apartments in Ridgeland, MS. With four apartment communities across the area, we’re confident you will find the perfect apartment in Ridgeland to fit your lifestyle! Schedule a tour today by <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"tel:9184921983\"><strong><u>calling</u></strong></a> or <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/contact-us/\"><strong><u>contacting us online</u></strong></a>. Discover tips and tricks on our <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/blog/\"><strong><u>blog</u></strong></a> to make the most of your space!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city::citymarket.seo_body": {
    "overrideType": "VALUE",
    "customValue": "<h2><strong>Apartments in Oklahoma City, OK</strong></h2><p>Often referred to as the Modern Frontier, Oklahoma City, OK, offers a blend of cowboy heritage, modern amenities, and numerous attractions. Finding the perfect apartment in this lively city can be challenging. However, we have more than 20 pet-friendly apartment communities nearby, whether you want to be close to Reaves Park or Bricktown River Walk Park!</p><p>Our apartment communities are conveniently situated throughout the OKC area, offering quick access to delicious restaurants, shopping centers, and various recreational activities. The National Cowboy &amp; Western Heritage Museum, the Museum of Osteology, and the Oklahoma City National Memorial &amp; Museum provide great opportunities to explore history. Nearby, the riverfront Wheeler Ferris Wheel and Will Rogers Gardens offer fun and relaxation for friends or family.</p><h2><strong>Oklahoma City, OK, Apartment Homes Near Myriad Botanical Garden</strong></h2><p>If you’re looking to move closer to work near Scissortail Park or by Will Rogers International Airport, Case &amp; Associates proudly offers 23 apartment communities throughout the Oklahoma City, OK, area. We offer studio, 1, 2, and 3-bedroom apartment homes equipped with upscale amenities, such as spacious layouts and large closets—perfect for moving in with a roommate, family, or your pet.</p><h2><strong>Apartment Community Amenities in Oklahoma City</strong></h2><p>Your apartment should meet your needs and improve your lifestyle. With apartment communities from Case &amp; Associates, you can rely on us to satisfy all your needs, thanks to our extensive community amenities. Many of our apartment communities include a business center, a clubhouse, and covered parking.</p><p>Spend sizzling summer days by the pool on the spacious sundeck or play with your pup at the onsite dog park. Grill tasty meals at the grilling stations and relax—the opportunities are endless! Explore our individual communities to discover the community amenities.</p><h2><strong>Oklahoma City Apartments With Spacious Bedrooms Near Oklahoma City Zoo</strong></h2><p>Every apartment community in Oklahoma City, OK, has its own unique amenities. After spending a busy day at Hurricane Harbor or enjoying a peaceful afternoon at the lighthouse on Lake Hefner, you can come back to your apartment and take advantage of everything it has to offer.</p><p>Many of our apartments have spacious floor plans, oversized windows, a washer and dryer or connections, additional storage space, and plush carpeting. Some apartments also include a private patio or balcony and a wood-burning fireplace. Explore our apartment community options online and view the galleries to imagine yourself living in one of our communities!</p><h2><strong>Find Your Perfect Apartment in Oklahoma City, OK, With Case &amp; Associates</strong></h2><p>Explore upscale, pet-friendly apartments in Oklahoma City, OK, offered by Case &amp; Associates! If you prefer living near the Oklahoma State Capitol or Chisholm State Park, our apartment homes are designed to sweeten your lifestyle with a wide range of features and amenities throughout OKC. Schedule a tour of one or more of our pet-friendly apartment communities in Oklahoma City! You can also <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"tel:9184921983\"><strong><u>call</u></strong></a> our team or <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/contact-us/\"><strong><u>contact us</u></strong></a> online to get started, or explore our <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/blog/\"><strong><u>blog</u></strong></a> to learn more today.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/stillwater::citymarket.seo_body": {
    "overrideType": "VALUE",
    "customValue": "<h2><strong>Apartments in Stillwater, OK</strong></h2><p>Located in north-central Oklahoma, the college town of Stillwater sits at the intersection of Highway 177 and Route 54 and is home to Oklahoma State University. As Oklahoma’s 10th largest city, Stillwater offers many attractions, amenities, and landmarks, such as the National Wrestling Hall of Fame, the Stillwater Regional Airport, and the Oklahoma State University Museum of Art.</p><p>If you’re searching for a pet-friendly apartment community with excellent amenities, Case &amp; Associates makes it easy to find an apartment that has everything you need. With options for studio, 1, and 2 bedroom homes, you can enjoy all Stillwater has to offer while thriving in your apartment.</p><h2><strong>Stillwater, OK, Apartment Homes Near Oklahoma State University</strong></h2><p>We have one apartment community in Stillwater, OK, called <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/ok/stillwater/apple-creek/\"><strong><u>Apple Creek Apartments</u></strong></a>. This apartment community is between Pioneer Square and Lakeview Pointe, just down the road from AMC Stillwater 10. Apple Creek Apartments isn’t far from Boomer Lake Park, Belk Outlet, and Boone Pickens Stadium. Find your perfect, <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/ok/stillwater/apple-creek/pet-policy\"><strong><u>pet-friendly apartment</u></strong><u> </u><strong><u>at Apple Creek</u></strong></a>, where the <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/ok/stillwater/apple-creek/amenities/\"><strong><u>amenities</u></strong></a> are plentiful, including spacious apartments and numerous community features.</p><h2><strong>Apartment Community Amenities in Stillwater</strong></h2><p>After exploring the Botanic Garden at Oklahoma State University or boating on Whittenberg Lake, you can return to your apartment community feeling fulfilled, knowing you have all the tools you need to thrive! The Apple Creek Apartments community was carefully designed to bring convenience right to you. Some of the amenities at Apple Creek include:</p><ul><li><p>Clubhouse</p></li><li><p>Laundry Facility</p></li><li><p>Onsite Management</p></li><li><p>Open Parking</p></li><li><p>Spacious Grounds</p></li><li><p>Sports Court</p></li><li><p>Two Swimming Pools and Sundeck</p></li></ul><h2><strong>Stillwater Apartments With Spacious Bedrooms Near Teal Ridge Wetlands</strong></h2><p>Life at Case &amp; Associates’ Stillwater, OK, apartment community includes access to amenities in our spacious studio, 1, and 2 bedroom apartments. Come home to relax by the fireplace after classes at Northern Oklahoma College Stillwater. Or unwind on your private patio or porch after working on your swing at Stillwater Country Club. Additional apartment amenities we offer include:</p><ul><li><p>Energy-Efficient Appliances</p></li><li><p>Fireplace, in Select Homes</p></li><li><p>Large Closets</p></li><li><p>Marble Countertops and Custom Cabinets</p></li><li><p>Oversize Windows</p></li><li><p>Private Patio or Balcony</p></li><li><p>Spacious Floor Plans</p></li><li><p>Vaulted Ceilings, in Select Homes</p></li><li><p>Washer and Dryer Connections, in Select Homes</p></li></ul><h2><strong>Find Your Perfect Apartment in Stillwater, OK, With Case &amp; Associates</strong></h2><p>Find your ideal apartment at Apple Creek Apartments in Stillwater, OK! We offer studio, 1 bedroom, and 2 bedroom floor plans equipped with high-end amenities. Whether you’re moving into a studio before starting college or looking for a larger apartment to share with a roommate, you’ll find everything you need within our welcoming apartment community.</p><p>Schedule a tour online to see Apple Creek Apartments for yourself! <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"tel:8667011243\"><strong><u>Call</u></strong></a> or fill out an <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/ok/stillwater/apple-creek/contact-us/\"><strong><u>online contact form</u></strong></a> for any questions you have.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa::citymarket.seo_body": {
    "overrideType": "VALUE",
    "customValue": "<h2><strong>Apartments in Tulsa, OK</strong></h2><p>Oklahoma’s second-largest city, Tulsa, is located on the Arkansas River and is famous for its Art Deco architecture, wide variety of attractions, and recreational activities. The Tulsa Botanic Garden, Gathering Place, and Tulsa Zoo offer great options for outdoor fun, while the University of Tulsa is known for its academic opportunities.</p><p>When you need a beautifully designed apartment in Tulsa, OK, Case &amp; Associates offers a wide variety of apartment communities across Tulsa neighborhoods, including Chimney Hills, Forest Trails and South Tulsa. Our pet-friendly 1, 2, and 3 bedroom apartments and townhomes feature high-end amenities and spacious floor plans, allowing you to choose exactly what you need!</p><h2><strong>Tulsa, OK, Apartment Homes Near Tulsa Premium Outlets</strong></h2><p>If you want to live near Tulsa International Airport or closer to Turkey Mountain, we have 26 apartment communities throughout the Tulsa, OK, area. Our premium apartments and townhomes can suit anyone’s needs, whether you’re living with a pet, sharing an apartment with a roommate, or moving into a larger space with a partner.</p><h2><strong>Apartment Community Amenities in Tulsa</strong></h2><p>After hanging out at LaFortune Park or exploring Woodward Park and Gardens, you can come home to relax by the swimming pool or cook tasty meals at the grill and chill area with friends. Our Case &amp; Associates apartment communities offer many more unique amenities that make your life easier, including:</p><ul><li><p>Fitness Center</p></li><li><p>Clubhouse</p></li><li><p>Business Center</p></li><li><p>Laundry Facilities</p></li><li><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://getflex.com/\"><strong><u>flex. Payment Options Available</u></strong></a></p></li><li><p>Spacious Grounds</p></li><li><p>On-Site Dog Park</p></li></ul><h2><strong>Tulsa Apartments With Spacious Bedrooms Near the Philbrook Museum of Art</strong></h2><p>One thing stays consistent across all Case &amp; Associates apartments—the unique amenities available at every community! Our 1, 2, and 3 bedroom apartments and townhomes feature large closets for all your storage needs, oversized windows to let in natural light, and plush carpeting for a cozy feel. Additional amenities include:</p><ul><li><p>Cable Ready</p></li><li><p>Washer and Dryer Connections</p></li><li><p>Stackable Washer and Dryer, in Select Homes</p></li><li><p>Vaulted Ceilings, in Select Homes</p></li><li><p>Ceiling Fans, in Select Homes</p></li><li><p>Private Patio or Balcony, in Select Homes</p></li><li><p>Fireplace, in Select Homes</p></li></ul><h2><strong>Find Your Perfect Apartment in Tulsa, OK, With Case &amp; Associates</strong></h2><p>Discover your ideal apartment in Tulsa with Case &amp; Associates! We offer a variety of 1, 2, and 3 bedroom apartments and townhomes, all featuring a wide range of amenities. We are confident that you’ll find the perfect space to suit your needs! Check out our <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/blog/\"><strong><u>blog</u></strong></a> for tips on <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/blog/tips-for-decorating-your-apartment/\"><strong><u>decorating your apartment</u></strong></a> and <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/blog/guide-for-taking-care-of-indoor-plants/\"><strong><u>caring for your indoor </u></strong></a><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"http://plants.Call\"><strong><u>plants</u></strong>.<strong><u>Call</u></strong></a><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"tel:9184921983\"><strong><u> our team</u></strong></a> or complete a <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/contact-us/\"><strong><u>contact form</u></strong></a> to learn more about our apartment communities. If you’re interested in options outside of Tulsa, explore our <strong>apartment communities in Oklahoma City</strong> or check out all our <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/ok/\"><strong><u>locations throughout Oklahoma</u></strong></a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo::citymarket.seo_body": {
    "overrideType": "VALUE",
    "customValue": "<p><br></p><h2><strong>Apartments in Amarillo, TX</strong></h2><p>In the Texas Panhandle sits Amarillo, the 16th-most populous city in the state. From the fun tourist attractions like Cadillac Ranch, Slug Bug Ranch, and the Floating Mesa of Amarillo to the historic Amarillo Route 66 sign, the city provides residents with the charm of a small town while offering access to big city amenities.</p><p>When you’re searching for a pet-friendly apartment home in Amarillo, TX, look to the apartment communities from Case &amp; Associates. Our Amarillo, TX, apartments are filled with amenities to enhance your daily life and offer excellent locations throughout the city. This provides quick access to major roads, including Interstate 40, Interstate 27, U.S. Route 66, and Texas Route, making it simple to get on the road and head to class at Amarillo College or take a flight from Rick Husband Amarillo International Airport.</p><p>With Case &amp; Associates, you’ll enjoy a new level of apartment living in Amarillo!</p><h2><strong>Amarillo, TX, Apartment Homes Near Palo Duro Canyon State Park</strong></h2><p>Are you searching for an apartment in Amarillo? Case &amp; Associates features five apartment communities in Amarillo, each offering unique amenities and exceptional community features to enhance the quality of apartment living. Our Amarillo apartments include:</p><ul><li><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/tx/amarillo/colonies-at-hillside/\"><strong><u>Colonies at Hillside</u></strong></a><strong>. </strong>Near Greenways Village in southwest Amarillo, the Colonies at Hillside offers cozy apartment homes in a <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/tx/amarillo/colonies-at-hillside/neighborhood/\"><strong><u>quiet neighborhood</u></strong></a>.</p></li><li><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/tx/amarillo/park-at-coulter/\"><strong><u>Park at Coulter</u></strong></a><strong>. </strong>Just down the road from McDonald Lake, you’ll discover <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/tx/amarillo/park-at-coulter/floor-plans/\"><strong><u>spacious floor plans</u></strong></a> in this southwest Amarillo apartment community.</p></li><li><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/tx/amarillo/newport/\"><strong><u>Newport Apartment Homes</u></strong></a><strong>. </strong>These apartments offer <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/tx/amarillo/newport/floor-plans/\"><strong><u>1 and 2 bedroom</u></strong></a> floorplans featuring modern designs and elegant finishes in southwest Amarillo.</p></li><li><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/tx/amarillo/remington/\"><strong><u>The Remington Apartments</u></strong></a><strong>. </strong>Experience luxury living in Amarillo at the Remington Apartments near Cinergy Amarillo with high-end <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/tx/amarillo/remington/amenities\"><strong><u>amenities</u></strong></a> and sleek designs.</p></li><li><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/tx/amarillo/winchester/\"><strong><u>Winchester Apartments</u></strong></a><strong>. </strong>Located just around the corner from Westgate Mall and the Amarillo VA, we offer comfortable apartments in a <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/tx/amarillo/winchester/neighborhood/\"><strong><u>peaceful setting in west Amarillo</u></strong></a>.</p></li></ul><h2><strong>Apartment Community Features in Amarillo Near Lake Meredith</strong></h2><p>One thing remains consistent across Case’s Amarillo apartment communities—the enhanced level of comfort for our residents. We want residents to have access to everything they need while living with us! If you’re attending Amarillo College or working near the Amarillo Botanical Gardens, you’ll love living at one of our apartment communities that feature one or more of these amenities:</p><ul><li><p>24/7 Emergency Maintenance</p></li><li><p>Barbeque Station and Lounge</p></li><li><p>Beautiful Courtyard and Spacious Grounds</p></li><li><p>Business Center</p></li><li><p>Connections to Super-Fast Internet Powered by AT&amp;T</p></li><li><p>Covered Parking</p></li><li><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://getflex.com/\"><strong><u>flex. Payment Options Available</u></strong></a></p></li><li><p>Onsite Management</p></li><li><p>Sparkling Swimming Pool</p></li></ul><h2><strong>Amarillo Apartments With Spacious Bedrooms Near Wonderland Amusement Park</strong></h2><p>Three of our apartment communities in Amarillo offer 1 and 2 bedroom apartments, while <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/tx/amarillo/remington/floor-plans/\"><strong><u>the Remington</u></strong></a> and the <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/tx/amarillo/winchester/floor-plans/\"><strong><u>Winchester Apartments</u></strong></a> feature 1, 2, and 3 bedroom floor plans. This way, you can find the perfect fit for your needs, whether you’re sharing with a roommate or partner or getting ready to welcome a new family member.</p><p>Our apartments feature plush carpeting, spacious closets, and an open-concept living area that seamlessly blends into the kitchen and dining space. With large windows that let in plenty of natural light, you’ll have the perfect spot for <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/blog/guide-for-taking-care-of-indoor-plants/\"><strong><u>your houseplants to thrive</u></strong></a>. Plus, some floor plans feature private balconies, patios, and in-home fireplaces. So, get creative and <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/blog/how-to-decorate-your-apartment-balcony/\"><strong><u>decorate your balcony</u></strong></a> or <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/blog/tips-for-decorating-your-apartment/\"><strong><u>refresh your apartment’s vibe</u></strong></a> with new decor!</p><h2><strong>Find Your Perfect Apartment in Amarillo, TX, From Case &amp; Associates</strong></h2><p>The search for the perfect apartment ends with Case &amp; Associates! Our modern and stylish pet-friendly apartment communities have plenty of floor plans to choose from and amenities to enhance your apartment’s ambience. Explore our <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/tx/amarillo/\"><strong><u>apartment communities in Amarillo, TX</u></strong></a>, and schedule a tour today. You can also <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"tel:9184921983\"><strong><u>call</u></strong></a> our friendly team or complete an <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/contact-us/\"><strong><u>online contact form</u></strong></a> to learn more <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/about-us/\"><strong><u>about us</u></strong></a> and our communities!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso::citymarket.seo_body": {
    "overrideType": "VALUE",
    "customValue": "<h2><strong>Apartments in El Paso, TX</strong></h2><p>Across the Rio Grande, on the Mexico-U.S. border, El Paso, TX, is a vibrant and arid desert city within the Chihuahuan Desert. The area is renowned for its attractions, including the El Paso Zoo and Botanical Garden, as well as historical sites such as the Magoffin Home State Historic Site and the Chamizal National Memorial.</p><p>Whether preparing for the semester at Southwest University or looking for a new apartment near El Paso International Airport, our communities are conveniently located with easy access to major roadways. From Interstate 10, Patriot Freeway, and CanAm Highway to Liberty Expressway and Cesar E. Chavez Border Highway, your favorite El Paso spots and attractions are always effortlessly reachable when you live in a Case &amp; Associates apartment!</p><h2><strong>El Paso, TX, Apartment Homes Near Casa de Azucar</strong></h2><p>It can be challenging to find a stylish yet reasonably priced apartment in the largest city in West Texas. However, your issue is resolved when you explore our apartment communities throughout El Paso. Our apartment homes seamlessly blend modern fixtures with cozy features. Plus, our communities are pet-friendly and feature numerous onsite dog parks, making them perfect for the whole family—fur babies included!</p><p>You’ll love life in our apartment communities in El Paso, just a hop away from the beautiful San Jacinto Plaza! These communities include:</p><ul><li><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/tx/el-paso/double-tree/\"><strong><u>Double Tree Apartments</u></strong></a></p></li><li><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/tx/el-paso/the-phoenix/\"><strong><u>The Phoenix of El Paso</u></strong></a></p></li><li><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/tx/el-paso/the-chimneys/\"><strong><u>The Chimneys</u></strong></a></p></li><li><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/tx/el-paso/shadow-ridge/\"><strong><u>Shadow Ridge Apartments</u></strong></a></p></li><li><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/tx/el-paso/high-ridge/\"><strong><u>High Ridge Apartments</u></strong></a></p></li><li><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/tx/el-paso/mountain-village/\"><strong><u>Mountain Village</u></strong></a></p></li><li><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/tx/el-paso/the-patriot/\"><strong><u>The Patriot</u></strong></a></p></li><li><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/tx/el-paso/the-crest/\"><strong><u>The Crest Apartments</u></strong></a></p></li><li><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/tx/el-paso/acacia-park/\"><strong><u>Acacia Park Apartment Homes</u></strong></a></p></li></ul><h2><strong>Apartment Community Features in El Paso Near Franklin Mountains State Park</strong></h2><p>Life at one of Case &amp; Associates’ premium apartment communities sure is sweet. We prioritize our residents’ comfort and want to provide a cozy, ambient home when you step in and out of your front door. Our apartment communities offer an expansive range of amenities to enhance daily life, from sparkling pools to convenient business centers. Features include:</p><ul><li><p>Spacious Floorplans</p></li><li><p>Fully Equipped Kitchens</p></li><li><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://getflex.com/\"><strong><u>flex Payment Options Available</u></strong></a></p></li><li><p>Spanish-Speaking Staff</p></li><li><p>Fitness Center With Free Weights</p></li><li><p>Sparkling Swimming Pool</p></li><li><p>Sundeck and Lounge Chairs</p></li><li><p>Business Center</p></li><li><p>24/7 Emergency Maintenance</p></li></ul><h2><strong>El Paso Apartments With Spacious Bedrooms Near McKelligon Canyon</strong></h2><p>From moving into your first studio apartment to sharing a spacious 2 bedroom apartment with a roommate, we offer a wide range of layouts and sizes to meet your specific needs and style. Across our nine pet-friendly apartment communities, we offer studio, 1, 2, and 3 bedroom options.</p><p>Our thoughtfully designed apartments feature large closets, plush carpeting, and large windows, <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/blog/guide-for-taking-care-of-indoor-plants/\"><strong><u>perfect for indoor plants</u></strong></a>! These apartments are also cable and WiFi-ready, and select apartments even feature a private balcony or patio, as well as a gorgeous fireplace. Imagine enjoying the sunset from your balcony or cozying up by the fireplace in the evening—it’s all possible with Case &amp; Associates.</p><h2><strong>Find Your Perfect Apartment in El Paso, TX, From Case &amp; Associates</strong></h2><p>Explore one of our El Paso apartment communities to discover your ideal home near Cielo Vista Mall! Our nine apartment communities throughout the El Paso area are sure to have exactly what you’re looking for, especially when combined with top-tier amenities. Are you ready to get started? Explore our <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/tx/el-paso/\"><strong><u>apartment communities in El Paso</u></strong></a> and schedule a tour today. You can also <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"tel:9184921983\"><strong><u>call</u></strong></a> our friendly team or fill out an <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/contact-us/\"><strong><u>online contact form</u></strong></a> to learn more about the apartment rental process.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock::citymarket.seo_body": {
    "overrideType": "VALUE",
    "customValue": "<h2><strong>Apartments in Lubbock, TX</strong></h2><p>Situated in northwest Texas, Lubbock is recognized as the birthplace of rock ‘n’ roll icon Buddy Holly, with the Buddy Holly Center near the heart of the town. As the 10th largest city in Texas, Lubbock is brimming with history and landmarks. Renowned attractions include the National Ranching Heritage Center, Lubbock Lake National Historic Landmark, and the American Windmill Museum, ideal for those who enjoy exploring the community.</p><p>The search for a new apartment in Lubbock can be challenging given the area’s popularity, but Case &amp; Associates is here to help. We offer three apartment communities with 1 and 2 bedroom apartments featuring high-end amenities. All three of our communities are conveniently located near major roadways, including Interstate 27, Highways 62 and 84, and Route 289, making it easy to access the surrounding region.</p><h2><strong>Lubbock, TX, Apartment Homes Near Lubbock Preston Smith International Airport</strong></h2><p>If you’re looking for a new apartment in Lubbock before the new semester begins at Texas Tech University or closer to your work near Science Spectrum &amp; OMNI Theater, it’s easy to find your ideal home with our apartment communities! We have three premier, pet-friendly apartment communities to meet all your specific needs, whether you’re interested in loft living or want a fireplace in the living room.</p><p>Our available Lubbock, TX, apartment communities include:</p><ul><li><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/tx/lubbock/cottages-at-abbey-glen/\"><strong><u>The Cottages at Abbey Glen</u></strong></a><strong>.</strong> Between the Springfield and Vintage Township <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/tx/lubbock/cottages-at-abbey-glen/neighborhoods\"><strong><u>neighborhoods</u></strong></a>, The Cottages at Abbey Glen Apartments are next to United Supermarkets, The Plaza Restaurant &amp; Bar, and Johnny Fab’s Cadillac Grill.</p></li><li><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/tx/lubbock/icon-at-lubbock/\"><strong><u>The Icon at Lubbock</u></strong></a><strong>. </strong>These apartments come with <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/tx/lubbock/icon-at-lubbock/amenities\"><strong><u>premier amenities</u></strong></a>, including a fully equipped kitchen, flexible spaces to choose from, and select units come with extra storage for larger items, such as recreational gear.</p></li><li><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/tx/lubbock/tuscany-place/\"><strong><u>Tuscany Place Apartment Homes</u></strong></a><strong>. </strong>Within the Bacon Crest <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/tx/lubbock/tuscany-place/neighborhoods\"><strong><u>neighborhood</u></strong></a> and by Teddy Jack’s Hub City Grill, Tuscany Place offers a premier, <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/tx/lubbock/tuscany-place/pet-policy\"><strong><u>pet-friendly apartment community</u></strong></a> in a quiet area.</p></li></ul><h2><strong>Apartment Community Amenities in Lubbock Near Prairie Dog Town</strong></h2><p>From the outdoor recreation at Hodges Park and Mackenzie Main City Park to the sports events and concerts at the United Supermarkets Arena, having access to nearby hot spots is important when settling into an apartment. The Cottages, The Icon, and Tuscany Place are all uniquely their own, but one thing remains the same—the amount of community amenities we offer!</p><p>Spend time by the fireplace or fire pit in the evenings at the outdoor lounge area, or gather with neighbors in the clubhouse for a book club meeting. Whatever you choose to do, Case &amp; Associates’ apartment communities are here to accommodate. Additional features include:</p><ul><li><p>Detached and Attached Garages</p></li><li><p>Grilling Stations With an Outdoor Lounge</p></li><li><p>State-of-the-Art Fitness Center</p></li><li><p>Clubhouse</p></li><li><p>Spacious Grounds</p></li><li><p>Limited Gate Access</p></li><li><p>Dog Park Onsite</p></li><li><p>Business Center With WiFi</p></li><li><p>Sparkling Swimming Pool</p></li></ul><h2><strong>Lubbock Apartments With Large Bedrooms Near The Museum of Texas Tech University</strong></h2><p>Living in one of our apartment communities is enhanced by the fantastic amenities available in our spacious floorplans. Each Case &amp; Associates apartment community offers 1 and 2 bedroom apartments, all featuring fully equipped kitchens, plush carpeting, and convenient ceiling fans.</p><p>Whether you’re studying at the University Medical Center, enjoying leisure time at Hillcrest Golf &amp; Country Club, or reconnecting with nature at the Lubbock Memorial Arboretum, come back to your wonderful apartment in Lubbock, TX, and spend time <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/blog/how-to-decorate-your-apartment-balcony/\"><strong><u>redecorating the balcony</u></strong></a> or watering <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/blog/guide-for-taking-care-of-indoor-plants/\"><strong><u>your houseplants</u></strong></a> in front of the large windows. Some of our amenities include:</p><ul><li><p>24-Hour Emergency Maintenance</p></li><li><p>Extra Storage, in Select Homes</p></li><li><p>Fireplace, in Select Homes</p></li><li><p>Loft Living</p></li><li><p>Private Balcony or Patio, in Select Homes</p></li><li><p>Spacious Closets</p></li><li><p>Super-Fast Internet Powered by AT&amp;T</p></li><li><p>Tall or Vaulted Ceilings, in Select Homes</p></li><li><p>Washer and Drying Connections</p></li></ul><h2><strong>Find Your Perfect Apartment in Lubbock, TX, From Case &amp; Associates</strong></h2><p>When you choose the stylishly designed apartment homes from Case &amp; Associates, you’ll discover the perfect space that meets all your needs and allows you to live leisurely! With spacious 1 and 2 bedroom floorplans available, you can move into your first apartment with ease or share your new home with a partner or roommate if you prefer.</p><p>Discover the apartment of your dreams within our exceptional <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/tx/\"><strong><u>apartment communities in Texas</u></strong></a>. Schedule a tour today to explore the unique features and amenities we offer. Feel free to <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"tel:9184921983\"><strong><u>call us</u></strong></a> or <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/contact-us/\"><strong><u>contact us online</u></strong></a> for more information about our communities and what they have to offer. Learn tips, like <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/blog/tips-for-decorating-your-apartment/\"><strong><u>how to decorate your apartment</u></strong></a>, on our <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/blog/\"><strong><u>blog</u></strong></a>!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco::citymarket.seo_body": {
    "overrideType": "VALUE",
    "customValue": "<h2><strong>Apartments in Waco, TX</strong></h2><p>Situated along the Brazos River in central Texas, Waco is home to renowned Baylor University, the Waco Mammoth National Monument, and the Dr Pepper Museum. In this growing community, finding a beautifully designed, pet-friendly apartment community with all the amenities on your checklist can sometimes be challenging. However, you won’t have to worry—Case &amp; Associates proudly offers three upscale apartment options, whether you want to be closer to Woodway Park or Hewitt Park.</p><p>Case &amp; Associates’ apartment communities are located near the West Waco and Alta Vista neighborhoods in Waco and Hewitt. These apartment communities offer easy access to major roadways, including Interstate 34, Highway 84, and Highway 77. This, in turn, offers convenient access to popular restaurants, shopping centers, and recreational activities. You can head to Cameron Park Zoo, Waco Surf, or Hawaiian Falls Waco for a fun day in the sun and get there quickly from your apartment!</p><h2><strong>Waco, TX, Apartment Homes Near Richland Mall</strong></h2><p>Our apartment homes in Waco, TX, have 1 and 2 bedroom apartments and townhomes to choose from, with select apartments featuring loft-style living near Lake Waco Welands and Buena Vista Park. Each apartment includes luxury amenities, and our communities offer unique features to provide residents with an elevated living experience.</p><h2><strong>Apartment Community Amenities in Waco</strong></h2><p>When searching for an apartment community, it should improve your lifestyle and cater to your every whim and desire. Case &amp; Associates’ apartment communities are thoughtfully designed to offer residents access to a wide range of amenities, including gated security for peace of mind, 24-hour maintenance, and welcoming on-site management.</p><p>Our Waco apartments also feature additional amenities such as:</p><ul><li><p>Dog Park On-Site</p></li><li><p>Swimming Pool With Sun Deck</p></li><li><p>Grill and Chill Area</p></li><li><p>Fitness Center</p></li><li><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://getflex.com/\"><strong><u>flex. Payment Options Available</u></strong></a></p></li><li><p>Internet Cafe</p></li><li><p>Courtyards With Pet Stations</p></li></ul><h2><strong>Waco Apartments With Spacious Bedrooms Near Lake Waco</strong></h2><p>Waking up each morning and falling asleep every night in one of our Waco Case &amp; Associates apartment communities means you get to enjoy some of the best apartment amenities around.</p><p>Our cozy 1 and 2 bedroom apartments and townhomes feature spacious layouts, large closets, and oversized windows that fill the space with plenty of natural light. Each apartment also includes a beautifully designed, fully equipped kitchen, making it perfect for trying out new and delicious recipes. Find more apartment amenities we offer below:</p><ul><li><p>Plush Carpeting</p></li><li><p>Fully Equipped Kitchen</p></li><li><p>Washer and Dryer Connections</p></li><li><p>Cable Ready</p></li><li><p>Private Balcony or Patio, in Select Homes</p></li><li><p>Attached and Detached Garages</p></li></ul><h2><strong>Find Your Perfect Apartment in Waco, TX, With Case &amp; Associates</strong></h2><p>Check out our luxury pet-friendly apartments in Waco, TX, near Baylor University! Experience our top community amenities firsthand and discover your ideal apartment with one of our Case &amp; Associates communities.</p><p>Schedule a tour of one of our Waco apartment communities today! For any questions, <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"tel:9184921983\"><strong><u>call</u></strong></a> our team or <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/contact-us/\"><strong><u>contact us</u></strong></a> online.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city::citymarket.seo_cta_body": {
    "overrideType": "VALUE",
    "customValue": "<p><br></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city::citymarket.seo_cta_text": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/north-little-rock::citymarket.seo_heading": {
    "overrideType": "VALUE",
    "customValue": "<p></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita::citymarket.seo_heading": {
    "overrideType": "VALUE",
    "customValue": "<p></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city::citymarket.seo_heading": {
    "overrideType": "VALUE",
    "customValue": "<p></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland::citymarket.seo_heading": {
    "overrideType": "VALUE",
    "customValue": "<p></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city::citymarket.seo_heading": {
    "overrideType": "VALUE",
    "customValue": "<p></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/stillwater::citymarket.seo_heading": {
    "overrideType": "VALUE",
    "customValue": "<p></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa::citymarket.seo_heading": {
    "overrideType": "VALUE",
    "customValue": "<p></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo::citymarket.seo_heading": {
    "overrideType": "VALUE",
    "customValue": "<p></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso::citymarket.seo_heading": {
    "overrideType": "VALUE",
    "customValue": "<p></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock::citymarket.seo_heading": {
    "overrideType": "VALUE",
    "customValue": "<p></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco::citymarket.seo_heading": {
    "overrideType": "VALUE",
    "customValue": "<p></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:property::contactform.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Contact Us",
    "generatedValue": null,
    "mappedField": null
  },
  "corporatecontactform.vendor_webhook_url": {
    "overrideType": "VALUE",
    "customValue": "https://hooks.zapier.com/hooks/catch/27207920/u7pqbf9/",
    "generatedValue": null,
    "mappedField": null
  },
  "corporatecontactform.webhook_url": {
    "overrideType": "VALUE",
    "customValue": "https://hooks.zapier.com/hooks/catch/27207920/u7p8daa/",
    "generatedValue": null,
    "mappedField": null
  },
  "corporatespecialoffer.enabled": {
    "overrideType": "VALUE",
    "customValue": "false",
    "generatedValue": null,
    "mappedField": null
  },
  "ctabutton.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfd5d-43b4-7198-b8ff-2b6553c99f01.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:property::flex-payment.client_id": {
    "overrideType": "VALUE",
    "customValue": "recOwmE0Dr750mfxC",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.company_logo": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.logo": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_company_logo"
  },
  "apartments/mo/kansas-city/97-north-oak::footer.logo": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_logo"
  },
  "apartments/ok/tulsa/the-greens-of-bedford::footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "ga4-tracking.measurement_id": {
    "overrideType": "VALUE",
    "customValue": "G-53EXBR28B8",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts::google-tag-manager-2.container_id": {
    "overrideType": "VALUE",
    "customValue": "GTM-NDH4RDK",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:property::google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id_2"
  },
  "apartments/ar/north-little-rock/lexington-park::google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id_2"
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen::google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id_2"
  },
  "apartments/tx/lubbock/icon-at-lubbock::google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id_2"
  },
  "apartments/tx/lubbock/tuscany-place::google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id_2"
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts::google-tag-manager.push_vibesite_events_to_datalayer": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "header.company_logo": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/huntington-park::header.company_logo": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166545/019cfb4f-246d-7226-933a-1d35c66e8df0.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/97-@-north-oak::header.company_logo": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb38-cbf6-730b-aee2-3e765f6b8f96.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-glade-apts::header.company_logo": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf69-33d2-7211-8321-2802a70d4b40.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfd5d-9a05-729b-9e8b-90e7e8252f66.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/97-north-oak::hero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb38-8a07-760c-b0cc-9cc8b920577e.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:property::image-tracking-pixel.pixel_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_tracking_pixel_url"
  },
  "apartments/ok::image-tracking-pixel.pixel_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_tracking_pixel_url"
  },
  "apartments/ok/pryor/west-530::image-tracking-pixel.pixel_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_tracking_pixel_url"
  },
  "apartments/ks/maize/watercress-apartments::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ee-7482-7199-8ab5-14be86410fc0.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a18979-736e-73bc-8f17-409ec470a301.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/huntington-park::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166545/019cfb4e-5a84-71f9-92f2-a38788df6dbb.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/portofino::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019db0cb-f5d0-7240-9ed7-1e8345e3efb1.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-36f6-72eb-9b61-10f0f82c0984.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/belton/center-301::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431e-581b-7689-8e86-e6bf176b5454.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/152-northland::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cec-602e-75b0-9af8-0a27d23c63c3.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/mark-apts::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165610/019db140-87fb-76f9-836c-242983bfa074.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-8001-763b-81ef-d0999a282ba7.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/redbud-ranch::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa537-37ac-703b-9885-374739de6be4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-9cfe-75ab-90bc-45346d7d9c6b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a38-5da0-7499-a86a-5a8dd1885376.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4f9-d066-716d-bf43-9dd1ff0c72a5.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c1c-8e01-7331-82ee-de6a5289dbcc.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/artisan-crossing-apts::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-da90-769c-9071-ca14798e2e0b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06275-2234-75eb-a613-3768ae97dd3b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/chisholm-pointe::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d2-71b2-7495-8c9d-2c7bf46d8d4a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a14009-d7d9-775e-95cc-50bbba677a51.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/01a183b2-afca-706a-ace0-f44c5ba72bd4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-92a8-767a-b452-4ecc616f136f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08675-f849-7382-9851-e9ddd729d751.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019db6dd-cb68-751b-bcf0-87a9dd6624fd.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4d-c3e3-77b4-b2f2-755196cddc29.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-e746-76fa-b655-01612f2b5083.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/coffee-creek::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019d9bed-c8ed-77ff-ba5c-25fe004c1db9.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/01a1358e-5031-76ea-8e53-d5fd718d3004.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/pryor/west-530::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03545-c73d-7402-a3cc-d5c15daa4bb5.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/stillwater/apple-creek-stillwater::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165583/019e21bc-8fea-76f8-9571-24428a509f2e.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/barrington-apartments::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f049b-35da-7444-93ce-28d22a3acd46.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-glade-apts::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf69-3c72-77cb-af90-c02742c1d770.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b9-e844-746f-b753-00799f48bbba.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-ea78-73be-b7e1-25421a081928.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019dbae6-0d3b-74ff-aded-826973889e03.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/creekwood-apartments::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1948-80e9-77ee-ab00-bd962430391d.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/nickel-creek-apts::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db130-5ef5-76de-9c37-8c08f5d4cbc5.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/polo-run-apartments::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a2-7c75-7630-aac3-c5a714e73e45.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02003-856a-752e-8c73-c5f1624a85c5.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a015fe-62c1-72dc-98ce-e3fb030fc8e6.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019d4ca0-8f4c-7290-95d8-eb3e1d6cc6d9.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee077-5d87-77a3-9814-b2edf964512a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-2b65-776c-a90b-2b0e5e2570c3.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fed5c-fefb-7166-bb2d-a6177f0f2266.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c1-a872-70a5-bec6-c1741373fd2b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/the-ridge-66::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f1930-361d-716d-aa61-2851c245796b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf7-e27c-77fc-b1f7-55273b163c3a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc3-b883-74eb-aeaf-077f8e634a5e.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df3-aaf6-734a-9cbf-79048456c417.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/01a0e997-0574-762b-81c6-3fb68a6c5253.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/01a117a3-2a3c-767d-93c2-7ebfd59b028e.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/acacia-park-apts::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1762-c14a-71c9-8837-88b29d56e961.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92c-d22b-7051-99a9-b27f56fa5e01.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5a9-dbf8-7738-8bf3-581c2ed8cdcc.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/phoenix-apts::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/01a0a169-dee2-7181-a7ce-90ca259fb261.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd5-3b52-734e-969f-966640cbfc6a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a0e9d7-66b3-73a9-81e5-e0042427e4b8.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda5-e9bc-7669-9320-7a01ce7b4514.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place::pagehero.background_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2a-a4c5-7693-9f28-943e85a33859.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/raintree-apartments::pagehero.title_line1": {
    "overrideType": "VALUE",
    "customValue": "Welcome to Raintree Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills::pagehero.title_line1": {
    "overrideType": "VALUE",
    "customValue": "Welcome to The Park at Mission Hills",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek::pagehero.title_line1": {
    "overrideType": "VALUE",
    "customValue": "Welcome to Trails at Aspen Creek",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts::pagehero.title_line1": {
    "overrideType": "VALUE",
    "customValue": "Welcome to Cimarron Trails Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts::pagehero.title_line1": {
    "overrideType": "VALUE",
    "customValue": "Welcome to Hunter's Ridge Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i::pagehero.title_line1": {
    "overrideType": "VALUE",
    "customValue": "Welcome to Prairie Springs",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/nickel-creek-apts::pagehero.title_line1": {
    "overrideType": "VALUE",
    "customValue": "Welcome to Nickel Creek Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford::pagehero.title_line1": {
    "overrideType": "VALUE",
    "customValue": "Welcome to The Greens Of Bedford",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments::pagehero.title_line1": {
    "overrideType": "VALUE",
    "customValue": "Welcome to Windsail Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe::pagehero.title_line1": {
    "overrideType": "VALUE",
    "customValue": "Welcome to Park at Westpointe",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/acacia-park-apts::pagehero.title_line1": {
    "overrideType": "VALUE",
    "customValue": "Welcome to Acacia Park Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts::pagehero.title_line1": {
    "overrideType": "VALUE",
    "customValue": "Welcome to Double Tree Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts::pagehero.title_line1": {
    "overrideType": "VALUE",
    "customValue": "Welcome to High Ridge Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail::pagehero.title_line2": {
    "overrideType": "VALUE",
    "customValue": "Embrace a Life of Love in Your New Duplex Home",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments/pet-policy::petpolicy.additional_info": {
    "overrideType": "VALUE",
    "customValue": "<p></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:property::petpolicy.breed_note": {
    "overrideType": "VALUE",
    "customValue": "Maximum of 2 pets per unit.",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts/pet-policy::petpolicy.breed_note": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/pet-policy::petpolicy.breed_note": {
    "overrideType": "VALUE",
    "customValue": "Maximum of two pets per unit.",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/huntington-park/pet-policy::petpolicy.breed_note": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pet_restrictions"
  },
  "apartments/mo/independence/the-adirondack/pet-policy::petpolicy.breed_note": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/97-north-oak/pet-policy::petpolicy.breed_note": {
    "overrideType": "VALUE",
    "customValue": "Maximum of two pets per unit. Breed restrictions apply.",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/pet-policy::petpolicy.breed_note": {
    "overrideType": "VALUE",
    "customValue": "Breed restrictions apply.",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/redbud-ranch/pet-policy::petpolicy.breed_note": {
    "overrideType": "VALUE",
    "customValue": "Breed restrictions apply.",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/pet-policy::petpolicy.breed_note": {
    "overrideType": "VALUE",
    "customValue": "Breed restrictions apply.",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/pet-policy::petpolicy.breed_note": {
    "overrideType": "VALUE",
    "customValue": "Breed restrictions apply.",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/pet-policy::petpolicy.breed_note": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/pet-policy::petpolicy.breed_note": {
    "overrideType": "VALUE",
    "customValue": "Breed restrictions apply ",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/pet-policy::petpolicy.breed_note": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/pet-policy::petpolicy.breed_note": {
    "overrideType": "VALUE",
    "customValue": "Maximum of 2 pets",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/coffee-creek/pet-policy::petpolicy.breed_note": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/pet-policy::petpolicy.breed_note": {
    "overrideType": "VALUE",
    "customValue": " Breed restrictions apply.",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cypress-crossing/pet-policy::petpolicy.breed_note": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/barrington-apartments/pet-policy::petpolicy.breed_note": {
    "overrideType": "VALUE",
    "customValue": "Maximum weight: 40 lb each.",
    "generatedValue": null,
    "mappedField": "property_pet_restrictions"
  },
  "apartments/ok/tulsa/cascata-luxury-apartments/pet-policy::petpolicy.breed_note": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-glade-apts/pet-policy::petpolicy.breed_note": {
    "overrideType": "VALUE",
    "customValue": "Contact Leasing Office for details about breed restrictions",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/pet-policy::petpolicy.breed_note": {
    "overrideType": "VALUE",
    "customValue": "Breed restrictions apply.",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/creekwood-apartments/pet-policy::petpolicy.breed_note": {
    "overrideType": "VALUE",
    "customValue": "Pets are subject to management approval. Breed restrictions apply.",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/nickel-creek-apts/pet-policy::petpolicy.breed_note": {
    "overrideType": "VALUE",
    "customValue": "Breed restrictions apply.",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/pet-policy::petpolicy.breed_note": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/mountain-village-apts/pet-policy::petpolicy.breed_note": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/shadow-ridge-apts/pet-policy::petpolicy.breed_note": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/pet-policy::petpolicy.breed_note": {
    "overrideType": "VALUE",
    "customValue": "Breed restrictions apply.",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/hewitt/icon-at-hewitt/pet-policy::petpolicy.breed_note": {
    "overrideType": "VALUE",
    "customValue": "Breed restrictions apply",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/ar/little-rock/arbors-of-pleasant-valley-apts/contact-us\"><strong>Contact us today</strong></a> for any other questions regarding our pet policy.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/north-little-rock/lexington-park/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/ar/north-little-rock/lexington-park/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/maize/watercress-apartments/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><strong><a href=\"tel:8556431621\">Contact us</a></strong> for any other questions regarding our pet policy.<br/><br/><a href=\"https://watercressmaize.petscreening.com/\" target=\"_blank\"><strong><span style=\"text-decoration: underline;\">Begin your PetScreening Here!</span></strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>We welcome cats and dogs. Breed restrictions apply. Contact office for additional details. </p><p>Pet fee: half of one month’s rent per pet. Monthly pet rent: $30. Maximum 2 pets per unit.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/>Fill out <a href=\"/apartments/ks/wichita/cottages-at-crestview/contact-us\"><strong>a contact form</strong></a> or <a href=\"tel:3165006151\"><strong>give us a call</strong></a> for any other questions regarding our pet policy.<br/><br/><a href=\"https://cottagesatcrestview.petscreening.com/\" target=\"_blank\"><strong><span style=\"text-decoration: underline;\">Begin your PetScreening Here!</span></strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/crown-chase-apts/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/ks/wichita/crown-chase-apts/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><a href=\"https://crownchase.petscreening.com/\" target=\"_blank\"><strong><span style=\"text-decoration: underline;\">Begin your PetScreening Here!</span></strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/huntington-park/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/ks/wichita/huntington-park/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><a href=\"https://huntingtonparkwichita.petscreening.com/\" target=\"_blank\"><strong><span style=\"text-decoration: underline;\">Begin your PetScreening Here!</span></strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/newport-wichita-apts/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/ks/wichita/newport-wichita-apts/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><a href=\"https://newportwichita.petscreening.com/\" target=\"_blank\"><strong><span style=\"text-decoration: underline;\">Begin your PetScreening Here!</span></strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/portofino/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals. <br/><a href=\"/apartments/ks/wichita/portofino/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><a href=\"https://portofinowichita.petscreening.com/\" target=\"_blank\"><strong><span style=\"text-decoration: underline;\">Begin your PetScreening Here!</span></strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/raintree-apartments/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/ks/wichita/raintree-apartments/contact-us\"><strong>Use our contact form</strong></a> or <a href=\"tel:3164443679\"><strong>call us</strong></a> for any other questions regarding our pet policy.<br/><br/><a href=\"https://raintree.petscreening.com/\" target=\"_blank\"><strong><span style=\"text-decoration: underline;\">Begin your PetScreening Here!</span></strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/remington-wichita/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/>For any other questions regarding our pet policy, <a href=\"/apartments/ks/wichita/remington-wichita/contact-us\"><strong>complete a contact form</strong></a> or <a href=\"tel:3168476022\"><strong>give us a call</strong></a>.<br/><br/><a href=\"https://remingtonwichita.petscreening.com/\" target=\"_blank\"><strong><span style=\"text-decoration: underline;\">Begin your PetScreening Here!</span></strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/silver-springs-apts/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>Dogs and cats are welcome. Maximum of two pets per unit. No weight limit. Monthly pet rent is $30 per pet. One-time non-refundable fee: $500 per pet.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/ks/wichita/villas-of-waterford/contact-us\"><strong>Contact us</strong></a> online or <a href=\"tel:3162478569\"><strong>call us</strong></a> for any other questions regarding our pet policy.<br/><br/><a href=\"https://villasofwaterford.petscreening.com\" target=\"_blank\"><strong><span style=\"text-decoration: underline;\">Begin your PetScreening Here!</span></strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/belton/center-301/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/mo/belton/center-301/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><a href=\"https://center301.petscreening.com/\" target=\"_blank\"><strong><span style=\"text-decoration: underline;\">Begin your PetScreening Here!</span></strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/independence/the-adirondack/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"tel:816-744-4931\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><strong><a href=\"https://adirondack.petscreening.com/\" target=\"_blank\">Begin your PetScreening Here!</a></strong></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/152-northland/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"pt-40 text-center mt-40\">*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/mo/kansas-city/152-northland/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/97-north-oak/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/mo/kansas-city/97-north-oak/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><a href=\"https://97atnorthoak.petscreening.com/\" target=\"_blank\"><strong><span style=\"text-decoration: underline;\">Begin your PetScreening Here!</span></strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/mark-apts/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals. <a href=\"/apartments/ms/ridgeland/mark-apts/contact-us\"><strong>Give us a call</strong></a> or <a href=\"/apartments/ms/ridgeland/mark-apts/contact-us\"><strong>contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><a href=\"https://mark.petscreening.com/\" rel=\"noreferrer noopener\" target=\"_blank\">Begin your PetScreening Here!</a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/sunchase-ridgeland-apts/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>Our staff at Sunchase Ridgeland doesn’t consider service animals as pets. Therefore, pet fees and pet rent are not applied. However, additional documentation must be presented if requested. To speak with one of our friendly staff members about our pet policy, <strong><a href=\"/apartments/ms/ridgeland/sunchase-ridgeland-apts/contact-us\">contact us</a></strong> online.<br/><br/><a href=\"https://sunchaseridgeland.petscreening.com/\" rel=\"noreferrer noopener\" target=\"_blank\">Begin your PetScreening Here!</a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/the-pointe-of-ridgeland/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/ms/ridgeland/the-pointe-of-ridgeland/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><a href=\"https://pointe.petscreening.com/\" rel=\"noreferrer noopener\" target=\"_blank\">Begin your PetScreening Here!</a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/trace-apts/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/ms/ridgeland/trace-apts/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><a href=\"https://trace.petscreening.com/\" rel=\"noreferrer noopener\" target=\"_blank\">Begin your PetScreening Here!</a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><a href=\"https://iconatbrokenarrow.petscreening.com/\" target=\"_blank\"><strong>Begin your PetScreening Here!</strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br>For any other questions regarding our pet policy, fill out our <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/apartments/ok/broken-arrow/park-at-mission-hills/contact-us\"><strong>contact form</strong></a> or <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"tel:918-518-0156\"><strong>give us a call</strong></a>.<br><br><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://parkatmissionhills.petscreening.com/\"><strong>Begin your PetScreening Here!</strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/redbud-ranch/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/>For any other questions regarding our pet policy, <a href=\"tel:5392504097\"><strong>call our leasing team</strong></a> or complete a <strong><a href=\"/apartments/ok/broken-arrow/redbud-ranch/contact-us\">contact form</a></strong>.<br/><br/><a href=\"https://redbudranch.petscreening.com/\" target=\"_blank\"><strong><span style=\"text-decoration: underline;\">Begin your PetScreening Here!</span></strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/apartments/ok/broken-arrow/scissortail-crossing/contact-us\"><strong>Contact us </strong></a>for any other questions regarding our pet policy.<br><br><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://scissortailcrossing.petscreening.com/\"><span><strong><u>Begin your PetScreening Here!</u></strong></span></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Please note: Service animals are not classified as pets. Pet fees and pet rent do not apply to these animals, though we may require additional documentation. If you need further details about our pet policy, feel free to reach out via our <strong>contact form</strong> or <strong><a href=\"tel:5392504411\">give us a call</a></strong>. We’re here to assist you!<br/><br/><a href=\"https://trailsatapsencreek.petscreening.com/\" target=\"_blank\"><strong>Begin your PetScreening Here!</strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/>For any other questions regarding our pet policy, <a href=\"/apartments/ok/broken-arrow/villas-at-aspen-park/contact-us\"><strong>fill out a contact form online</strong></a> or <a href=\"tel:4058969771\"><strong>call us</strong></a>.<br/><br/><a href=\"https://villasataspenpark.petscreening.com/\" target=\"_blank\"><strong><span style=\"text-decoration: underline;\">Begin your PetScreening Here!</span></strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/fountain-lake/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://fountainlakex.petscreening.com/\"><strong><u>Begin your PetScreening Here!</u></strong></a><br><br>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p><a href=\"https://villasatstonebridge.petscreening.com/\" target=\"_blank\">https://villasatstonebridge.petscreening.com/</a>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/>For any other questions regarding our pet policy, <a href=\"/apartments/ok/edmond/villas-at-stonebridge/contact-us\"><strong>contact us online</strong></a> or <a href=\"/apartments/ok/edmond/villas-at-stonebridge/contact-us\"><strong>call us</strong></a>.<br/><br/><strong><a href=\"https://villasatstonebridge.petscreening.com/\" target=\"_blank\">Begin your PetScreening Here!</a></strong><br/></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><strong><a href=\"tel:8444930509\">Contact us</a></strong> for any other questions regarding our pet policy.<br/><br/><strong><a href=\"https://reserveatelm.petscreening.com/\" target=\"_blank\">Begin your PetScreening Here!</a></strong></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/moore/mission-point/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://missionpoint.petscreening.com/\"><strong><u>Begin your PetScreening Here!</u></strong></a><br><br>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/artisan-crossing-apts/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://artisancrossing.petscreening.com\"><strong><u>Begin your PetScreening Here!</u></strong></a></p><p><br>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://cimarrontrails.petscreening.com/\"><strong><u>Begin your PetScreening Here!</u></strong></a><br><br>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br><br><a class=\"richtext-link\" href=\"/apartments/ok/norman/cimarron-trails-apts/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/apartments/ok/oklahoma-city/24hundred-apartments/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br><br><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://24hundred.petscreening.com/\"><strong>Begin your PetScreening Here!</strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://chisholmpointe.petscreening.com/\"><strong><u>Begin your PetScreening Here!</u></strong></a><br><br>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/ok/stillwater/apple-creek-stillwater/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://coiuncilplace.petscreening.com/\"><strong><u>Begin your PetScreening Here!</u></strong></a><br><br>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br><br></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/ok/oklahoma-city/cross-timber/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><strong><a href=\"https://crosstimber.petscreening.com/\" target=\"_blank\">Begin your PetScreening Here!</a></strong></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/ok/oklahoma-city/crown-pointe-apartments/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://huntersridgeoklahomacity.petscreening.com/\"><strong><u>Begin your PetScreening Here!</u></strong></a><br><br>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter's-ridge-apts/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/ok/oklahoma-city/hunter-s-ridge-apts/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/park-at-tuscany/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>e animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/ok/oklahoma-city/park-at-tuscany/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/persimmon-square-apartments/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://persimmonsquare.petscreening.com/\"><strong><u>Begin your PetScreening Here!</u></strong></a><br><br>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://prairiespringsx.petscreening.com/\"><strong><u>Begin your PetScreening Here!</u></strong></a><br><br><br>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br><br></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/stonehorse-crossing/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/apartments/ok/oklahoma-city/stonehorse-crossing/contact-us\"><strong>Contact us</strong></a><strong> </strong>for any other questions regarding our pet policy.<br><br><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://stonehorsecrossing.petscreening.com/\" target=\"_blank\"><strong>Begin your PetScreening Here!</strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summerfield-place-apts/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://summerfieldoklahomacity.petscreening.com/\"><strong><u>Begin your PetScreening Here!</u></strong></a><br><br>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br><br></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summit-ridge-villas/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://summitridgeoklahomacity.petscreening.com/\"><strong><u>Begin your PetScreening Here!</u></strong></a><br><br>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br><br></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summit-ridge-villas/summit-villas/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/>For any other questions regarding our pet policy, fill out a <a href=\"/apartments/ok/oklahoma-city/chisholm-pointe/contact-us\"><strong>contact form</strong></a> online or <a href=\"/apartments/ok/oklahoma-city/chisholm-pointe/contact-us\"><strong>schedule a tour</strong></a> today.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/tammaron-village-apartments/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/ok/oklahoma-city/tammaron-village-apartments/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><strong><a href=\"https://tammaronvillage.petscreening.com/\" target=\"_blank\">Begin your PetScreening Here!</a></strong></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/warrington-apartments/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://warrington.petscreening.com/\"><strong><u>Begin your PetScreening Here!</u></strong></a><br><br>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br><br></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/ok/oklahoma-city/waters-edge-apartments/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>Pets are welcome in all our luxury duplex homes. No weight limit. Maximum of two pets allowed. Breed restrictions apply. Pets subject to management approval. Pet rent: $30 per pet per month. $500 one-time fee per pet (non‑refundable).</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/coffee-creek/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/ok/owasso/coffee-creek/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><a href=\"https://coffeecreekapartments.petscreening.com/\" target=\"_blank\"><strong><span style=\"text-decoration: underline;\">Begin your PetScreening Here!</span></strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/apartments/ok/owasso/cottages-at-tallgrass-point/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br><br><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://cottagesattallgrasspoint.petscreening.com/\" target=\"_blank\"><span><strong><u>Begin your PetScreening Here!</u></strong></span></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cypress-crossing/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/ok/owasso/cypress-crossing/contact-us\">Contact us</a> for any other questions regarding our pet policy.<br/><br/><a href=\"https://cypresscrossing.petscreening.com/\" target=\"_blank\"><strong>Begin your PetScreening Here!</strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/pryor/west-530/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"pt-40 text-center mt-40\">*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/ok/pryor/west-530/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/stillwater/apple-creek-stillwater/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/ok/stillwater/apple-creek-stillwater/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/barrington-apartments/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/>For any other questions regarding our pet policy, <a href=\"tel:5392504084\"><strong>give us a call</strong></a> or fill out our <a href=\"/apartments/ok/tulsa/barrington-apartments/contact-us\"><strong>online contact form</strong></a>.<br/><br/><strong><a href=\"https://barrington.petscreening.com/\" target=\"_blank\">Begin your PetScreening Here!</a></strong></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cascata-luxury-apartments/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-glade-apts/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/>For any other questions regarding our pet policy, fill out <a href=\"/apartments/ok/tulsa/cedar-glade-apts/contact-us\"><strong>a contact form</strong></a> or <a href=\"tel:4055863848\"><strong>give us a call</strong></a>.<br/><br/><a href=\"https://cedarglade.petscreening.com/\" target=\"_blank\"><strong><span style=\"text-decoration: underline;\">Begin your PetScreening Here!</span></strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/>For any other questions regarding our pet policy, <a href=\"tel:9189940008\"><strong>call us</strong></a> or fill out <a href=\"/apartments/ok/tulsa/cedar-ridge-apartments/contact-us\"><strong>a contact form</strong></a>.<br/><br/><a href=\"https://cedarridgetulsa.petscreening.com/\" target=\"_blank\"><strong><span style=\"text-decoration: underline;\">Begin your PetScreening Here!</span></strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/ok/tulsa/chardonnay/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><strong><a href=\"https://chardonnay.petscreening.com/\" target=\"_blank\">Begin your PetScreening Here!</a></strong></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/apartments/ok/tulsa/country-hollow-apartments/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br><br><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://countryhollow.petscreening.com/\"><strong>Begin your PetScreening Here!</strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/creekwood-apartments/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/>Fill out <a href=\"/apartments/ok/tulsa/creekwood-apartments/contact-us\"><strong>a contact form</strong></a> or <a href=\"tel:9185057825\"><strong>give us a call</strong></a> for any other questions regarding our pet policy.v</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/nickel-creek-apts/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/ok/tulsa/nickel-creek-apts/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><strong><a href=\"https://nickelcreek.petscreening.com/\" target=\"_blank\">Begin your PetScreening Here!</a></strong></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/polo-run-apartments/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/ok/tulsa/polo-run-apartments/floor-plans\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><a href=\"https://polorun.petscreening.com/\" rel=\"noreferrer noopener\" target=\"_blank\">Begin your PetScreening Here!</a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/ok/tulsa/sheridan-pond/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><strong><a href=\"https://sheridanpond.petscreening.com/\" target=\"_blank\">Begin your PetScreening Here!</a></strong></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/>For any other questions regarding our pet policy, <a href=\"tel:9185051393\"><strong>contact us by phone</strong></a> or <a href=\"/apartments/ok/tulsa/sugarberry-apartments/contact-us\"><strong>online</strong></a>.<br/><br/><strong><a href=\"https://sugarberry.petscreening.com/\" target=\"_blank\">Begin your PetScreening Here!</a></strong></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/ok/tulsa/sunchase-apartments/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/ok/tulsa/the-courtyards/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><strong><a href=\"https://courtyards.petscreening.com/\" target=\"_blank\">Begin your PetScreening Here!</a></strong></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/ok/tulsa/the-greens-of-bedford/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><strong><a href=\"https://greensofbedford.petscreening.com/\" target=\"_blank\">Begin your PetScreening Here!</a></strong></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are exempt from pet fees and pet rent. Further documentation may be necessary.<br/>If you have any inquiries regarding our pet policy, feel free to <a href=\"/apartments/ok/tulsa/windsail-apartments/contact-us\"><strong>contact us</strong></a>. <a href=\"/apartments/ok/tulsa/windsail-apartments/contact-us\"><strong>Schedule a tour</strong></a> of Windsail to determine if our Tulsa apartments align with your needs and those of your pet.<br/><br/><strong><a href=\"https://windsail.petscreening.com/\" target=\"_blank\">Begin your PetScreening Here!</a></strong></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://parkatwestpointe.petscreening.com/\"><strong><u>Begin your PetScreening Here!</u></strong></a><br><br>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/the-ridge-@-66/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/ok/yukon/the-ridge-66/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/the-ridge-66/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://ridgeat66.petscreening.com/\"><strong><u>Begin your PetScreening Here!</u></strong></a><br><br>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/tx/amarillo/newport-amarillo-apts/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><a href=\"https://newportamarillo.petscreening.com/\" target=\"_blank\">Begin your PetScreening Here!</a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals. <strong><a href=\"tel:8444311044\">Contact us</a></strong> for any other questions regarding our pet policy.<br/><br/><a href=\"https://parkatcoulter.petscreening.com/\" target=\"_blank\">Begin your PetScreening Here!</a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/tx/amarillo/remington-amarillo-apts/contact-us\"><strong>Contact us today</strong></a> for any other questions regarding our pet policy.<br/><br/><a href=\"https://remingtonamarillo.petscreening.com/\" target=\"_blank\">Begin your PetScreening Here!</a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/tx/amarillo/the-colonies-at-hillside/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><a href=\"https://coloniesathillside.petscreening.com/\" target=\"_blank\">Being your PetScreening Here!</a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/tx/amarillo/winchester-apartments/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><a href=\"https://winchester.petscreening.com/\" target=\"_blank\">Begin your PetScreening Here!</a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/acacia-park-apts/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/apartments/tx/el-paso/acacia-park-apts/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br><br><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://acaciaparkelpaso.petscreening.com/\"><span><strong><u>Begin your PetScreening Here!</u></strong></span></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/chimneys-apts/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>Pet rent are not applicable for service animals.<br/><a href=\"/apartments/tx/el-paso/chimneys-apts/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><a href=\"https://chimneys.petscreening.com/\" target=\"_blank\"><strong><span style=\"text-decoration: underline;\">Begin your PetScreening Here!</span></strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/tx/el-paso/double-tree-apts/contact-us\"><strong>Contact form</strong></a> for any other questions regarding our pet policy.<br/><br/><a href=\"https://elpasodoubletree.petscreening.com/\" target=\"_blank\"><strong><span style=\"text-decoration: underline;\">Begin your PetScreening Here!</span></strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/tx/el-paso/high-ridge-apts/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><a href=\"https://highridge.petscreening.com/\" target=\"_blank\"><span style=\"text-decoration: underline;\">Begin your PetScreening Here!</span></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/mountain-village-apts/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/>For any other questions regarding our pet policy, <a href=\"tel:9157013244\"><strong>call </strong></a>or <a href=\"/apartments/tx/el-paso/mountain-village-apts/contact-us\"><strong>contact us</strong></a> online.<br/><br/><a href=\"https://mountainvillageelpaso.petscreening.com/\" target=\"_blank\"><strong><span style=\"text-decoration: underline;\">Begin your PetScreening Here!</span></strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/patriot-apts/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/tx/el-paso/patriot-apts/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><strong><span style=\"text-decoration: underline;\"><a href=\"https://patriot.petscreening.com/\" target=\"_blank\">Begin your PetScreening Here!</a></span></strong></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/phoenix-apts/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><strong><a href=\"/apartments/tx/el-paso/phoenix-apts/contact-us\">Contact us</a></strong> for any other questions regarding our pet policy.<br/><br/><a href=\"https://phoenixelpaso.petscreening.com/\" target=\"_blank\"><strong><span style=\"text-decoration: underline;\">Begin your PetScreening Here!</span></strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/shadow-ridge-apts/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/tx/el-paso/shadow-ridge-apts/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><a href=\"https://shadowridgeelpaso.petscreening.com/\" target=\"_blank\"><strong><span style=\"text-decoration: underline;\">Begin your PetScreening Here!</span></strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/tx/el-paso/the-crest/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><a href=\"https://crestelpaso.petscreening.com/\" target=\"_blank\"><strong><span style=\"text-decoration: underline;\">Begin your PetScreening Here!</span></strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/hewitt/icon-at-hewitt/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/tx/hewitt/icon-at-hewitt/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><a href=\"https://iconhewitt.petscreening.com/\" target=\"_blank\"><strong><span style=\"text-decoration: underline;\">Begin your PetScreening Here!</span></strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/tx/lubbock/cottages-at-abbey-glen/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><a href=\"https://cottagesatabbeyglen.petscreening.com/\" target=\"_blank\"><strong><span style=\"text-decoration: underline;\">Begin your PetScreening Here!</span></strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/tx/lubbock/icon-at-lubbock/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><a href=\"https://iconatlubbock.petscreening.com/\" target=\"_blank\"><strong><span style=\"text-decoration: underline;\">Begin your PetScreening Here!</span></strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/tx/lubbock/tuscany-place/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><a href=\"https://tuscanyplacetx.petscreening.com/\" target=\"_blank\"><strong><span style=\"text-decoration: underline;\">Begin your PetScreening Here!</span></strong></a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/temple/portico-at-friars-creek-apts/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/tx/temple/portico-at-friars-creek-apts/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><strong><a href=\"https://porticoatfriarscreek.petscreening.com/\" target=\"_blank\">Begin your PetScreening Here!</a></strong></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/>For any other questions regarding our pet policy, fill out <a href=\"/apartments/tx/waco/bend-at-new-road/contact-us\"><strong>a contact form</strong></a> or <a href=\"tel:2542623277\"><strong>call</strong></a> us.<br/><br/><strong><a href=\"https://thebendatnewroad.petscreening.com/\" target=\"_blank\">Begin your PetScreening Here!</a></strong></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/tuscany-ranch-apartments/pet-policy::petpolicy.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p>*Service animals are not considered pets. Pet fees and pet rent are not applicable for service animals.<br/><a href=\"/apartments/tx/waco/tuscany-ranch-apartments/contact-us\"><strong>Contact us</strong></a> for any other questions regarding our pet policy.<br/><br/><strong><a href=\"https://tuscanyranch.petscreening.com/\" target=\"_blank\">Begin your PetScreening Here!</a></strong></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/huntington-park/pet-policy::petpolicy.max_pets": {
    "overrideType": "VALUE",
    "customValue": "Maximum of 2 pets per unit.",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/97-north-oak/pet-policy::petpolicy.max_pets": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/fountain-lake/pet-policy::petpolicy.max_pets": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/pet-policy::petpolicy.max_pets": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pet_restrictions"
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/pet-policy::petpolicy.max_pets": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/pet-policy::petpolicy.max_pets": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/coffee-creek/pet-policy::petpolicy.max_pets": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/barrington-apartments/pet-policy::petpolicy.max_pets": {
    "overrideType": "VALUE",
    "customValue": "Maximum of 2 pets per unit.",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-glade-apts/pet-policy::petpolicy.max_pets": {
    "overrideType": "VALUE",
    "customValue": "Maximum of 2 pets allowed",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/pet-policy::petpolicy.max_pets": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/patriot-apts/pet-policy::petpolicy.max_pets": {
    "overrideType": "VALUE",
    "customValue": "2",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/hewitt/icon-at-hewitt/pet-policy::petpolicy.max_pets": {
    "overrideType": "VALUE",
    "customValue": "Maximum of 2 pets allowed",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/pet-policy::petpolicy.pet_rent": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_monthly_pet_rent"
  },
  "apartments/ok/tulsa/barrington-apartments/pet-policy::petpolicy.pet_rent": {
    "overrideType": "VALUE",
    "customValue": "30",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-glade-apts/pet-policy::petpolicy.pet_rent": {
    "overrideType": "VALUE",
    "customValue": "30",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/97-north-oak/pet-policy::petpolicy.weight_limit": {
    "overrideType": "VALUE",
    "customValue": "No weight limit",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/fountain-lake/pet-policy::petpolicy.weight_limit": {
    "overrideType": "VALUE",
    "customValue": "No weight limit",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/pet-policy::petpolicy.weight_limit": {
    "overrideType": "VALUE",
    "customValue": "No weight limit",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/pet-policy::petpolicy.weight_limit": {
    "overrideType": "VALUE",
    "customValue": "No weight limit",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/barrington-apartments/pet-policy::petpolicy.weight_limit": {
    "overrideType": "VALUE",
    "customValue": "No weight limit",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-glade-apts/pet-policy::petpolicy.weight_limit": {
    "overrideType": "VALUE",
    "customValue": "No weight limit",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/pet-policy::petpolicy.weight_limit": {
    "overrideType": "VALUE",
    "customValue": "No weight limit",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/pet-policy::petpolicy.weight_limit": {
    "overrideType": "VALUE",
    "customValue": "No weight limit",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/pet-policy::petpolicy.weight_limit": {
    "overrideType": "VALUE",
    "customValue": "No weight limit",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/acacia-park-apts/pet-policy::petpolicy.weight_limit": {
    "overrideType": "VALUE",
    "customValue": "No weight limit",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts/pet-policy::petpolicy.weight_limit": {
    "overrideType": "VALUE",
    "customValue": "No weight limit",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/mountain-village-apts/pet-policy::petpolicy.weight_limit": {
    "overrideType": "VALUE",
    "customValue": "No weight limit",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/patriot-apts/pet-policy::petpolicy.weight_limit": {
    "overrideType": "VALUE",
    "customValue": "No weight limit",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/shadow-ridge-apts/pet-policy::petpolicy.weight_limit": {
    "overrideType": "VALUE",
    "customValue": "No weight limit",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/hewitt/icon-at-hewitt/pet-policy::petpolicy.weight_limit": {
    "overrideType": "VALUE",
    "customValue": "No weight limit",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Elevate your living experience in Little Rock, AR. Located in the heart of Little Rock, AR, Arbors of Pleasant Valley offers a unique blend of convenience and luxury, providing residents with a superb living experience. At Arbors of Pleasant Valley Apartments, we’re dedicated to ensuring that every aspect of your life here is enjoyable and fulfilling. Our community is not just a place to live; it’s a place to thrive.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/north-little-rock/lexington-park::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Lexington Park, where reasonably priced 1, 2, and 3 bedroom apartments in North Little Rock await you. Our North Little Rock apartments are thoughtfully designed with amenities that make your life easier, such as an in-home washer and dryer, spacious closets, and a fully equipped kitchen. Around our <a href=\"/apartments/ar/north-little-rock/lexington-park/pet-policy\"><strong>pet-friendly</strong></a> community, additional amenities enable you to make the most of your day, including an outdoor pool and sundeck, and tanning salon.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/maize/watercress-apartments::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Watercress! Discover our Maize apartments, which offer a seamless fusion of luxury and comfort. Unwind in a 1 or 2 bedroom apartment, indulge in our community amenities, and embrace serenity. Select from six distinctive floor plans, and settle into your exquisitely designed apartment with the choice of lofty ceilings and chic details, such as a painted accent wall and a contemporary LED fireplace. Make yourself at home in style!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Aspen Park, your premier apartment community in Wichita, KS, offering a perfect blend of comfort, convenience, and style. Choose from a variety of thoughtfully designed floor plans, including cozy studios, spacious one bedrooms, and two-bedroom apartments, perfectly tailored to fit your lifestyle. At Aspen Park, we prioritize your well-being with an array of outstanding amenities. Enjoy sunny days by our inviting pool, stay active in our fitness center, or unwind in our beautifully landscaped courtyard. For your convenience, we provide laundry facilities, an on-site maintenance team, and a property manager readily available to address your needs. Our business center is equipped for your professional requirements, while our clubhouse serves as a perfect gathering spot for friends and neighbors. Experience outdoor leisure with our tennis court, sundeck, and picnic area complete with grills—ideal for hosting summer barbecues with family and friends. Each apartment features modern conveniences such as central heat and air conditioning, high-speed internet access, and spacious walk-in closets, ensuring your new home is both comfortable and functional. Enjoy additional perks like a cozy fireplace, private balcony or patio, and efficient kitchen with a dishwasher for effortless clean-up. Relish in the positive vibes of community living at Aspen Park. Don’t miss the opportunity to elevate your lifestyle in Wichita; find your new home today—browse our availability or schedule a tour to visit our vibrant community!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Cottages at Crestview, where you’ll find comfortable Wichita apartments with upscale amenities in a serene, gated community. With 12 unique 1, 2, and 3 bedroom apartment floor plans available, finding the ideal fit for your needs is simple. You’ll find our apartment community in east Wichita just minutes away from dining, shopping, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/crown-chase-apts::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover a new home in Crown Chase Apartments in west Wichita, where you’ll find comfortable 1 and 2 bedroom apartments. Our charming, <a href=\"/apartments/ks/wichita/crown-chase-apts/pet-policy\"><strong>pet-friendly</strong></a> community features several amenities to enhance your day, like an on-site swimming pool and 24-hour fitness center. Around the northwest Wichita neighborhood, delicious cuisine, fun attractions, and a wide variety of shops await you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/huntington-park::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to the Huntington Park apartment community in Wichita, where you’ll find elegant and comfortable 1 and 2 bedroom apartments. Our Wichita apartment community is near the New Market Square shopping mall and several neighborhood parks, attractions, and highly-rated schools. Our <a href=\"/apartments/ks/wichita/huntington-park/pet-policy\"><strong>pet-friendly apartments</strong></a> in Wichita, featuring a sizable on-site dog park, are the ideal places for pet owners to live.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/newport-wichita-apts::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Find quiet comfort in northwest Wichita at Newport Apartments. Our ideal location leaves the entire city at your doorstep while your home remains comfortably tucked away just west of I-235. Our apartment homes in Wichita go beyond the basics to offer amenities that combine function with a modern yet cozy aesthetic. With a fully equipped kitchen, substantial space for storage, and the option for your own patio and wood-burning fireplace, we give you everything you need to turn your apartment into a home. <a href=\"/apartments/ks/wichita/newport-wichita-apts/contact-us\"><strong>Schedule a tour</strong></a> today to get started!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/portofino::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Comfortable living in east Wichita is easy to come by when you live in an apartment at Portofino. Our <a href=\"/apartments/ks/wichita/portofino/pet-policy\"><strong>pet-friendly</strong></a> community near I-35 and the Beech Factory Airport keeps you close to all the culinary, cultural, and commercial action in town while your home remains tucked away in our quiet corner of Wichita.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/raintree-apartments::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Raintree Apartments, situated near Orchard Park in West Wichita, offers a range of comfortable and <a href=\"/apartments/ks/wichita/raintree-apartments/pet-policy\"><strong>pet-friendly</strong></a> living spaces, including studios, 1 bedrooms, and 2 bedrooms.</p>\n<p>Each apartment features a fully equipped kitchen, ample closet space, inviting living and dining areas, and essential amenities. Conveniently located within walking distance of restaurants, shops, attractions, and schools, Raintree Apartments provides a well-connected and desirable living experience.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/remington-wichita::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience a wealth of amenities with our 1 and 2 bedroom apartments at The Remington Apartments in northeast Wichita, KS, near Greenwich Place.<br/>Every apartment features essential perks such as full-sized washer and dryer connections, a refrigerator and freezer with an ice maker, a cozy patio or balcony, and large walk-in closets. Our pet-friendly community offers a range of amenities, including an outdoor pool and a fitness center, ensuring a comfortable and convenient living experience. <a href=\"/apartments/ks/wichita/remington-wichita/contact-us\"><strong>Schedule a tour</strong></a> to get started today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/remington-wichita-apts::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Remington Wichita, your ideal apartment community in the heart of Wichita, KS. Offering spacious one and two-bedroom floor plans, our homes are designed with your comfort and lifestyle in mind. Each apartment features essentials such as fully equipped kitchens, large closets, ceiling fans for that extra touch of home. Select units come with a wood-burning fireplace as well. Embrace the perfect blend of relaxation and convenience with our exceptional amenities. Enjoy summer days lounging by our outdoor swimming pool or hosting a fun BBQ in our picnic area. For those balancing work and play, our business center and 24-hour fitness center ensure you can stay productive and healthy without leaving home. Plus, our pet-friendly community means your furry friends will love our Bark Park! Experience peace of mind with our 24-hour emergency maintenance and hassle-free features like online rental payments and flexible payment options. Located conveniently near K-96 and I-35, you’ll have easy access to the best that Wichita has to offer. Our professional management team is dedicated to providing you with outstanding service in your new home. Whether you’re looking to entertain guests on your private patio or balcony or need the convenience of laundry facilities and package receiving, Remington Wichita has it all. Plus, stay connected with super-fast internet powered by AT&amp;T, making remote work or streaming your favorite shows a breeze. Find your new home today—browse our availability or schedule a tour to visit our remarkable community! Discover the vibrant lifestyle waiting for you at Remington Wichita!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/silver-springs-apts::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover a cozy and pet-friendly living experience at Silver Springs Apartments near Crown Chase and Westlink in west Wichita. Our studio, 1, and 2 bedroom apartment homes offer a range of amenities, including fully equipped kitchens, spacious closets, and inviting living and dining areas. With plenty of nearby dining, shopping, entertainment, and school options, your ideal lifestyle awaits just around the corner. <a href=\"/apartments/ks/wichita/silver-springs-apts/contact-us\"><strong>Schedule a tour</strong></a> today to get started!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Uncover the epitome of luxury living at Villas of Waterford Apartments in Wichita, KS. Our modern apartment homes offer a sleek design with premium amenities to elevate your lifestyle. Our community in northeast Wichita, near Bel Aire, offers unbeatable comfort and convenience. <br/>Numerous shops, restaurants, and attractions are just a stone’s throw away along KS-96 and East 29th Street North. With our upscale features and lively atmosphere, Villas of Waterford is the ultimate choice for luxury living in Wichita.<strong> </strong><a href=\"https://villasofwaterfordapartmentswichita.securecafe.com/onlineleasing/villas-of-waterford-i-ii/register.aspx\" target=\"_blank\"><strong>Secure your dream apartment</strong></a> today and become a part of our vibrant community!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/missouri/kansas-city/97--north-oak::propertyabout.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_short_description"
  },
  "apartments/mo/belton/center-301::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Tucked away in the peaceful suburb of Belton, Center 301 offers luxury apartments, lofts, and townhomes near Kansas City. Artfully crafted, stylish, modern apartment homes and a resort-style community combine to create the perfect backdrop for your lifestyle. Center 301 is ideally located in the growing community of Belton, just a quick commute away from the bright lights of downtown KC via Highway 71. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/independence/the-adirondack::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover a life of luxury at The Adirondack Apartments in Independence, MO. Our brand-new 1 and 2 bedroom apartments and townhomes are equipped with upscale apartment amenities. From a resort-style swimming pool with tanning ledges to stylish custom cabinetry and stainless steel appliances, you’ll have everything you need to relax, entertain guests, and live the life you want. <a href=\"#schedule-a-tour\"><strong>Schedule a tour</strong></a> today to find your dream home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/152-northland::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover what it means to love where you live by making 152 Northland Apartments your next home. Our community features beautiful apartments in Kansas City, MO, located in the heart of the Northland area.</p>\n<p>We have floor plans in various layouts that all feature high-quality amenities. Step out your front door and you’ll be surrounded by modern amenities like a resort-style swimming pool, an on-site fitness center, and easy access to everything KC has to offer.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/97-north-oak::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Here at 97 @ North Oak, you’ll find stylish and comfortable Kansas City apartment homes in the Northland, near shopping, dining, and everything else you need in your daily life. Our floor plans are thoughtfully designed, featuring open-concept layouts that seamlessly flow between the kitchen, living, and dining areas. As you step outside your Kansas City apartment, you’ll be greeted by resort-style amenities encouraging peaceful relaxation, from our swimming pool and sun deck to our 24-hour fitness center.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/mark-apts::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Sitting in the northern suburbs of Mississippi’s capital, The Mark Apartments is a quiet and cozy community of apartment homes in southeast Ridgeland, MS. We’re located right by the Northpark Shopping Mall and near major roads like I-55, I-220, and the Natchez Trace Parkway, which makes us an ideal place to live for those who commute into Jackson or elsewhere. With amenities like an outdoor pool, fitness center, and 24-hour emergency maintenance, you’ll have no trouble feeling at home when you live in one of our reasonably priced Ridgeland apartments for rent.<br/><a href=\"/apartments/ms/ridgeland/mark-apts/contact-us\"><strong>Contact The Mark Apartments</strong></a> today to learn more!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/sunchase-ridgeland-apts::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Sunchase Ridgeland Apartments offers luxury apartments right in the heart of Ridgeland. With upscale apartments available to rent with amenities included, there’s no need to overthink where to go for apartments in Ridgeland, MS. </p>\n<p>With proximity to major roads and highways, including Old Canton Road and I-55, you’re only a short drive away from the many attractions and destinations of Ridgeland. Whether you’re coming from shopping at Northpark Mall or The Renaissance at Colony Park or taking your kids to Sky Zone Trampoline Park, you can always come home to one of our upscale apartment homes. <a href=\"/apartments/ms/ridgeland/sunchase-ridgeland-apts/contact-us\"><strong>Contact us</strong></a> today for a tour. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/the-pointe-of-ridgeland::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>See yourself at The Pointe, where modern comfort meets Southern charm. Nestled in East Ridgeland, MS, our apartment complex offers an inviting haven for those seeking quality living, a serene community, and an exceptional selection of amenities. Choose between our 1, 2, and 3 bedroom floor plans, take advantage of our beautiful apartment features, and indulge in our natural and relaxing atmosphere, when you choose The Pointe of Ridgeland as your new home. Contact us today for a tour!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/trace-apts::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>While Ridgeland may be known as a suburb of Jackson, it sparkles in its own right, thanks to its rapid growth, variety of attractions, and gorgeous natural areas. There is plenty to do in Ridgeland, from boating in the Ross R. Barnett Reservoir to shopping at Renaissance Mall.</p>\n<p>When you live at The Trace of Ridgeland luxury apartments, you’ll be able to enjoy everything the city has to offer. Our Ridgeland apartment community offers top-notch amenities and spacious floor plans, perfect for single residents, couples, and small families. You’ll find our Ridgeland apartments near the Wildwood North neighborhood, about one mile southwest of Friendship Park. Commuters will love our apartments near Jackson,  located about 15-20 minutes from the city.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Icon at Broken Arrow, home to comfortable, 1 and 2 bedroom luxury apartments near Tulsa. Each of our Broken Arrow apartment homes includes amenities that ensure comfort and convenience and design elements that create the perfect canvas for your style. Icon at Broken Arrow is situated southeast of Tulsa in the desirable suburb of Broken Arrow, near highly rated schools, dining options, and shops. <a href=\"https://iconatbrokenarrowapartments.securecafe.com/onlineleasing/icon-at-broken-arrow-apartments/register.aspx\" target=\"_blank\"><strong>Apply today</strong></a> to get started!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover high-end living at The Park at Mission Hills, a vibrant community surrounded by the lush woods and rolling plains that give Broken Arrow its characteristic charm. Our <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/apartments/ok/broken-arrow/park-at-mission-hills/floor-plans\"><strong>1 and 2 bedroom apartments</strong></a> for rent in Broken Arrow, OK, are situated adjacent to the Broken Arrow Expressway, putting the entire greater Tulsa area within reach as soon as you step outside your door.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/redbud-ranch::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the epitome of luxurious living at Redbud Ranch Apartments in North Broken Arrow near New Tulsa. Our apartments boast elegant finishes and indispensable amenities, providing a tranquil retreat for everyday life. Every corner offers resort-style facilities, from a refreshing courtyard pool to a well-equipped fitness center. Whether you seek relaxation or rejuvenation, Redbud Ranch has everything you need. <a href=\"https://redbudranchapartmentsba.securecafe.com/onlineleasing/redbud-ranch/register.aspx\" target=\"_blank\"><strong>Apply today</strong></a><strong> </strong>to get started!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>At Scissortail Crossing Apartments in north Broken Arrow, we provide the ideal setting to relax after a day at work or school and spend quality time with your loved ones. Our meticulously designed luxury apartment floor plans offer a nurturing environment for your lifestyle near Fairway Crossing. Enjoy top-notch amenities such as a state-of-the-art fitness studio and a resort-style pool just steps from your apartment, enhancing your living experience. <a href=\"https://scissortailcrossingapartmentsbrokenarrow.securecafe.com/onlineleasing/scissortail-crossing/register.aspx\" target=\"_blank\"><strong>Apply to your dream home</strong></a> today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience the pinnacle of luxury living at the brand-new Trails of Aspen Creek in Broken Arrow, OK. Our thoughtfully designed, pet-friendly floor plans are perfect for young students moving into their first apartment, families looking to expand their space with the arrival of a new family member, and everyone in between! Enjoy luxurious in-home and communal amenities for an upscale and stylish daily living experience at our luxury, pet-friendly apartments in Broken Arrow, OK.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience luxury living at the Villas at Aspen Park, located in Broken Arrow, OK. Our apartments and lofts with attached garages offer an abundance of modern amenities and features designed to enhance your daily life, like an attached garage and a fireplace.<br/>Strategically located near OK-51 in Broken Arrow, our community provides easy access to a surplus of shops, restaurants, and local attractions along West Kenosha Street and South 145th East Avenue. Embrace our apartment community today and indulge in the exciting features and lively atmosphere that make Villas at Aspen Park the ultimate choice for <a href=\"/apartments/ok/broken-arrow/villas-at-aspen-park/amenities\"><strong>luxurious living in Broken Arrow</strong></a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/catoosa/bluffs-at-catoosa::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Settle into everyday ease in Catoosa.</strong> At Bluffs at Catoosa, you can choose from comfortable one, two, and three bedroom <a class=\"richtext-link\" href=\"/apartments/ok/catoosa/bluffs-at-catoosa/floor-plans\">floor plans</a> with practical finishes like a dishwasher, electric range, refrigerator, large closets, ceiling fans, window coverings, and a patio in select homes. Faux wood vinyl flooring and carpeting add a polished, livable feel, while pet-friendly living keeps home flexible.</p><p>Outside your door, the community is built for convenience: cool off at the pool, fit in a workout at the fitness center, use in-unit laundry connections, rentable garages, online payments, flex rent options, and responsive on-site management and maintenance. From Highway 167, you’re close to Route 66 favorites like the Blue Whale of Catoosa, Catoosa Historical Museum, D.W. Correll Museum, Reasor’s, The Lodge Eatery &amp; Pub, and Hard Rock Hotel &amp; Casino Tulsa, with more Tulsa-area destinations within easy reach. Explore the <a class=\"richtext-link\" href=\"/apartments/ok/catoosa/bluffs-at-catoosa/amenities\">amenities</a> or see what’s nearby in the <a class=\"richtext-link\" href=\"/apartments/ok/catoosa/bluffs-at-catoosa/neighborhood\">neighborhood</a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/fountain-lake::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Fountain Lake Apartments in Edmond, OK, where you’ll find spacious apartments outfitted with stylish finishes and luxury amenities. Live life to the fullest in our gated community with relaxing amenities like a resort-style pool and sun deck, full fitness center, and scenic courtyards. Tucked away from Oklahoma City, you’ll find Fountain Lake apartments near desirable neighborhoods like The Oaks and Northwood. Find your dream home by <a href=\"https://fountainlakeapartmentsedmond.securecafe.com/onlineleasing/fountain-lake-i-ii/register.aspx\" target=\"_blank\"><strong>applying today</strong></a>!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover an unparalleled lifestyle at the Villas at Stonebridge in Edmond, OK. Our apartments offer the perfect blend of contemporary amenities and stylish features to enhance your daily life. Situated in south Edmond, near Witcher, our apartment community provides comfort and convenience, with an array of grocery stores, shops, parks, restaurants, and other attractions just moments away along South Boulevard and West 33rd Street. </p>\n<p>Take the first step toward living the live of your dreams. <a href=\"https://villasatstonebridgeapartmentsedmond.securecafe.com/onlineleasing/villas-at-stonebridge-i-ii/register.aspx\" target=\"_blank\"><strong>Join our vibrant community today</strong></a> to experience the exciting features and lively atmosphere that make the Villas at Stonebridge the best choice for luxurious living in Edmond.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>The Reserve at Elm Apartments is your gateway to luxury living in Jenks, Oklahoma, just minutes from Tulsa Hills. It is calmly situated in a vibrant neighborhood surrounded by the natural beauty of public parks and the urban conveniences of shopping, dining, and must-see attractions, all only a short drive from your Jenks apartment home. Discover the ideal blend of comfort, style, and convenience in your upscale home at The Reserve at Elm and <a href=\"https://reserveatelmapartmentstulsa.securecafe.com/onlineleasing/the-reserve-at-elm/register.aspx\" target=\"_blank\"><strong>apply today</strong></a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/moore/mission-point::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Find your new home in an luxury apartment community in Moore, Oklahoma, just minutes away from downtown Oklahoma City. Designed with dedicated care and an eye for detail and comfort, our spacious <a href=\"/apartments/ok/moore/mission-point/floor-plans\"><strong>1 and 2 bedroom</strong></a> apartment homes provide every amenity you’d expect from a premier living community with luxurious touches that create a living environment with unparalleled comfort.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/artisan-crossing-apts::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Make yourself at home at Artisan Crossing, where you’ll find Norman apartments near the University of Oklahoma. We offer a selection of modern apartments, lofts, and townhomes adorned with beautiful features like marble countertops and espresso or dove gray kitchen cabinets. Throughout our Norman apartment community, you’ll enjoy resort-style amenities like our swimming pool with a cabana and our 24-hour full fitness center. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Cimarron Trails, where you’ll find Norman apartments for rent with essential amenities alongside modern touches. Throughout our inviting community, you’ll find upscale amenities that can help you make the most of your free time, like an on-site pool, barbecue and picnic stations, and a resident clubhouse. Just a short 15-minute drive from the University of Oklahoma and several of the area’s employers, Cimarron Trails makes commuting simple.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/24hundred-apartments::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Amid Oklahoma City’s unique blend of Old West history and modern metropolitan landscapes, you’ll find 24Hundred, a premier destination for apartments in OKC, offering luxury and comfort near The Village. Our loft, townhome, and apartment floor plans are thoughtfully designed with comfort and style in mind. Our pet-friendly apartment community also embodies luxury, with amenities like two on-site dog parks, a sparkling pool and cabana, a full fitness center, and a resident clubhouse. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/chisholm-pointe::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Chisholm Pointe offers luxury duplex and quadplex apartment homes in Oklahoma City with fenced yards, and additional amenities, and attached garages on select apartment homes. You’ll find 1, 2, and 3 bedroom layouts in Oklahoma City at Chisholm Pointe, so you can select an apartment home that suits your needs. Our <a href=\"/apartments/ok/oklahoma-city/chisholm-pointe/pet-policy\"><strong>pet-friendly</strong></a> apartments in OKC provide a welcoming environment for you and your pet, with an on-site dog park for playtime.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts::propertyabout.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_short_description"
  },
  "apartments/ok/oklahoma-city/council-place-apartments::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Council Place Apartments, located in northwest Oklahoma City near the Quail Creek neighborhood, where you’ll find comfortable, pet-friendly 1, 2, and 3 bedroom apartment homes. Our apartments have essential amenities, like a well-equipped kitchen, ample closet space, and cozy living and dining areas. Nearby, you’ll enjoy a variety of dining options and shops, as well as attractions, entertainment options, and schools.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Cross Timber Apartments in south Oklahoma City, offering 2 and 3 bedroom luxury apartment homes. Each Oklahoma City apartment is elegantly designed with <a href=\"/apartments/ok/oklahoma-city/cross-timber/amenities\"><strong>stylish features</strong></a> like custom kitchen cabinetry and wood-style flooring. Around our opulent Oklahoma City apartment community, resort-style amenities await, like our saltwater swimming pool, full fitness center, and resident clubhouse.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Crown Pointe Apartments, home to comfortable 1 and 2 bedroom apartments in northwest Oklahoma City. Convenient and luxury amenities await you in our OKC apartment homes and around our gated community. Located near the desirable Bluff Creek neighborhood, everything you need is within reach, from top-rated restaurants to family-friendly attractions. To get started, <a href=\"https://crownpointeapartmentsoklahomacity.securecafe.com/onlineleasing/crown-pointe-apartments-2/register.aspx\" target=\"_blank\"><strong>apply today</strong></a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Hunter’s Ridge, where you’ll find reasonably priced 1 and 2 bedroom apartments in Oklahoma City. Our <a href=\"/apartments/ok/oklahoma-city/hunter-s-ridge-apts/pet-policy\"><strong>pet-friendly</strong></a> apartment community is near the Warr Acres neighborhood, close to several dining, shopping, and entertainment options. The amenities available in our Oklahoma City apartment homes ensure comfort and convenience, and the included features around our community will help you make the most of every day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter's-ridge-apts::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Hunter’s Ridge, where you’ll find reasonably priced 1 and 2 bedroom apartments in Oklahoma City. Our <a href=\"/apartments/ok/oklahoma-city/hunter-s-ridge-apts/pet-policy\"><strong>pet-friendly</strong></a> apartment community is near the Warr Acres neighborhood, close to several dining, shopping, and entertainment options. The amenities available in our Oklahoma City apartment homes ensure comfort and convenience, and the included features around our community will help you make the most of every day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/park-at-tuscany::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Create the home you want to live in with our <a href=\"/apartments/ok/oklahoma-city/park-at-tuscany/floor-plans\"><strong>Oklahoma City apartments</strong></a>. We offer a selection of modern and stylish apartments built with your comfort and active living in mind. A community that is ideal for those 55+, but we welcome residents of all ages who enjoy a calm, engaging atmosphere. Enjoy a cup of coffee as you are greeted each morning by warm rays of sunshine in your spacious living room, and come back home to your wood-burning fireplace for a stress-free end to your day in an environment designed around your active lifestyle. However you live, we give you the amenities, options, and space to make your apartment a home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/persimmon-square-apartments::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Persimmon Square is a premier, <a href=\"/apartments/ok/oklahoma-city/persimmon-square-apartments/pet-policy\"><strong>pet-friendly</strong></a> apartment community in Oklahoma City, conveniently located near Quail Springs Mall. Our community offers inviting features and luxurious amenities, ensuring a comfortable and enjoyable apartment living experience. With thoughtfully designed floor plans and a wide range of amenities, Persimmon Square makes it easy for you to embrace the comforts of home and make the most of your day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Prairie Springs is where luxury meets comfort in northwest Oklahoma City. Our vibrant community is surrounded by the neighborhoods of Harvest Hills, Brookhaven West, and Council Heights, offering upscale apartment living tailored to your lifestyle in our comfortable corner of town. Whether you’re seeking a 1, 2, or 3 bedroom apartment, our thoughtfully designed homes provide the ideal balance of modern convenience and classic elegance to reflect the life you want to live at Prairie Springs. <a href=\"https://prairiespringsapartmentsoklahomacity.securecafe.com/onlineleasing/prairie-springs-i-ii/register.aspx\" target=\"_blank\"><strong>Apply today</strong></a> to find your dream home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/stonehorse-crossing::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to your new life in the luxurious, <a href=\"/apartments/ok/oklahoma-city/stonehorse-crossing/pet-policy\"><strong>pet-friendly</strong></a> community of Stonehorse Crossing. Our upscale apartments offer a variety of spacious floor plans, including stylish 1 and 2 bedroom apartments and townhomes. Located just a few blocks from the John Kilpatrick Turnpike in the desirable north OKC near Blue Quail Ridge neighborhood, every convenience you could ever need is right around the corner or a short drive from your apartment home at Stonehorse Crossing.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summerfield-place-apts::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience each day in picturesque Oklahoma City at our Summerfield Place apartment community near Beacon Hill. Our inviting 1 and 2 bedroom luxury apartments in Oklahoma City near Lake Hefner provide the perfect retreat after a bustling day. Whether you’re a student looking for apartment homes near Oklahoma City University or a resident searching for a new apartment living space, Summerfield Place offers an apartment tailored to your lifestyle. <a href=\"/apartments/ok/oklahoma-city/summerfield-place-apts/contact-us\"><strong>Schedule a tour</strong></a> to find your perfect fit!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summit-ridge-villas/summit-villas::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>The Summit Villas offer luxury 2-bedroom duplexes in Oklahoma City with fenced yards, additional amenities, and attached garages on all units. You’ll find spacious bedroom layouts in Oklahoma City at Summit Villas, so you can select a duplex that suits your needs. We offer a luxurious clubhouse that is shared with our Chisholm Pointe community. Our pet-friendly duplexes in OKC provide a welcoming environment for you and your pet!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/tammaron-village-apartments::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Tammaron Village Apartments, situated in Northwest Oklahoma City, near Bethany, offers a distinctive living experience that enhances your daily life. Our contemporary floor plans and stylish amenities are thoughtfully designed to meet our residents’ every whim and desire. The Warwick Crossing Shopping Center is just moments away from our community, making our apartments ideal for those who desire a dynamic and flexible lifestyle.<br/><a href=\"#schedule-a-tour\"><strong>Schedule a tour today</strong></a> or <a href=\"https://app.tour24now.com/prospect/tour/tammaron-village/register/\" target=\"_blank\"><strong>take a self-guided tour</strong></a> of our property to experience the unique lifestyle that Tammaron Village Apartments offers firsthand. Our <a href=\"/apartments/ok/oklahoma-city/tammaron-village-apartments/photos\"><strong>photo gallery</strong></a> features a 360° virtual tour and provides a sneak peek into our community!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/warrington-apartments::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience the epitome of luxury apartment living in Oklahoma City near serene Lake Hefner at The Warrington Apartments. Our meticulously designed 1 and 2 bedroom upscale apartments offer comfort and style, featuring eight unique floor plans to cater to your preferences. Relax and feel at home in our inviting community, where a refreshing pool and peaceful courtyard beckon you to unwind. To get started today, <a href=\"/apartments/ok/oklahoma-city/warrington-apartments/contact-us\"><strong>schedule a tour</strong></a>!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>At Waters Edge, we believe in offering more than just a place to live. We provide an unparalleled living experience where residents can thrive and create lasting memories. From our spacious and modern apartments to our array of <a href=\"/apartments/ok/oklahoma-city/waters-edge-apartments/amenities\"><strong>amenities</strong></a> designed for relaxation and recreation, we’re dedicated to ensuring that every moment spent here feels like coming home. Discover the perfect blend of comfort, convenience, and community at Waters Edge Apartments. Welcome home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Zeal at Quail, your ideal sanctuary located in the heart of Oklahoma City, OK. Offering expertly designed one and two-bedroom floor plans, our duplex community blends comfort and style with extensive amenities to elevate your living experience. Picture yourself enjoying resort-style living with 24-hour access and an on-site property manager dedicated to ensuring your needs are met. At Zeal at Quail, we prioritize your convenience. Take advantage of our package service, on-site maintenance, and energy-efficient, stainless steel appliances, as well as full-size washer/dryer connections. Our community boasts a gated entrance for added security, complemented by an array of amenities including a refreshing pool, a state-of-the-art clubhouse, and outdoor living areas perfect for relaxation or socializing. Unleash your competitive spirit on our basketball court, challenge friends to a game of cornhole, or practice your putting skills on our well-maintained greens. Families will love the playground, ensuring children have a safe space to play. Enjoy ample opportunities to foster connections in our gathering spaces or take a leisurely stroll through our beautifully landscaped grounds. With features such as wood-style flooring, walk-in closets, and fenced yards, your new duplex at Zeal at Quail is not just a place to live; it's a lifestyle. Ready to find your new home? Browse our availability or schedule a tour today to experience all that Zeal at Quail has to offer!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/coffee-creek::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Coffee Creek Apartments welcomes you to make Owasso your home in one of our inviting, <a href=\"/apartments/ok/owasso/coffee-creek/pet-policy\"><strong>pet-friendly</strong></a> 1 or 2 bedroom apartments. Our thoughtfully designed apartment homes provide a perfect blend of relaxing comfort and stylish functionality, ensuring a warm and welcoming atmosphere for our residents. In every apartment at Coffee Creek, you’ll find washer and dryer connections and energy-efficient appliances that help make your upscale apartment home comfortable and functional, all complemented by our luxurious accents that make Coffee Creek a step above the rest.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Cottages at Tallgrass Point is where luxurious living meets creature comforts. Our suburban apartment community presents a wealth of upscale accommodations and features that allow you to make yourself at home. Coupled with our strategic location, which gives you easy access to the greater Tulsa area, Cottages at Tallgrass Point offers a balance of convenience and accessibility in our tranquil, <a href=\"/apartments/ok/owasso/cottages-at-tallgrass-point/pet-policy\"><strong>pet-friendly</strong></a> community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cypress-crossing::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Your new home in Owasso, OK, awaits with luxury, comfort, and convenience at Cypress Crossing. Positioned right off Highway 169 in the heart of north Owasso, our newly built apartment community offers you thoughtfully designed living spaces and luxurious amenities that elevate your lifestyle to a new standard of comfort. Find a cozy 1 bedroom apartment, a comfortable 2 bedroom home, a spacious 3 bedroom home, or the unique charm of a townhome or loft at Cypress Crossing.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/pryor/west-530::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Find your new home in Pryor at West 530 luxury apartments. Our upscale apartment homes near Lake Hudson are tucked away in a quiet corner of town with a relaxing swimming pool, easy access to the highway, and plenty of shops and restaurants nearby to discover and explore.</p>\n<p>West 530 is also just minutes from <a class=\"\" href=\"https://maip.com/\" target=\"_blank\">MidAmerica</a><a href=\"https://maip.com/\" rel=\"noreferrer noopener\" target=\"_blank\"> </a><a class=\"\" href=\"https://maip.com/\" target=\"_blank\">Industrial Park</a>, one of the region’s largest employment centers—offering exceptional convenience for professionals working in the area.</p>\n<p>Each apartment home has gorgeous, newly built interiors and modern amenities to elevate your lifestyle. Live luxuriously in your new 1 or 2 bedroom apartment in Pryor at West 530.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/stillwater/apple-creek-stillwater::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Make the most of every day in scenic Stillwater at our Apple Creek apartment community. Our cozy studio, 1 bedroom, and 2 bedroom apartments in Stillwater invite you to relax and recharge after your busy day. Apple Creek has an apartment to complement your lifestyle, whether you’re a student looking for apartments near Oklahoma State University or a longtime Stillwater resident browsing for a new apartment home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/barrington-apartments::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Barrington Apartments is your ideal choice for luxury apartments and townhomes in south Tulsa, Oklahoma. Living here gives you plenty of options for fun – whether that’s a night on the town or meeting neighbors at our lively basketball and sand volleyball courts. The <a href=\"/apartments/ok/tulsa/barrington-apartments/amenities\">outdoor swimming pool </a>is the perfect spot on a hot day, and your in-home whirlpool tub is the perfect way to unwind after a long day. Our amazing management team helps maintain our beautiful community to make each day more enjoyable.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cascata-luxury-apartments::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Elevate your lifestyle in one of the opulent apartment homes in Tulsa at Cascata Apartments. Each of our Tulsa apartments features stylish finishes and essential amenities, ensuring a comfortable oasis to come home to daily. As you step out of your apartment, resort-style amenities wait around every corner. Find your bliss in a lounge chair next to one of our two pools, or get your heart pumping in our full fitness center. It’s all included here at Cascata.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-glade-apts::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>You’re finally home here at Cedar Glade Apartments in South Tulsa, Oklahoma. We are&nbsp;<a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/apartments/ok/tulsa/cedar-glade-apts/neighborhood\">ideally located</a>&nbsp;near Woodland Hills, making your commute to local businesses and attractions quick and easy. Cedar Glade Apartments offers one, two, and three bedroom apartments for rent, making it easy to find your fit. Students love how close we are to Union Public Schools and Tulsa Community College, while professionals appreciate the short commute to Hillcrest Hospital South, St. Francis Hospital South and Tulsa International Airport. Additionally, Cedar Glade Apartments is close to several highly rated restaurants, including Texas Roadhouse and Bricktown Brewery, which are always fun for a night out. There is always fun to be had here at Cedar Glade Apartments.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Cedar Ridge, where you’ll find Tulsa apartments with the perfect blend of comfortable features and luxury amenities. Find your bliss while relaxing in one of our 1, 2, or 3 bedroom apartments or exploring our community’s amenities. Select any of our nine unique floor plans and make yourself at home in your beautifully crafted apartment home, featuring lofty nine-foot ceilings and stylish accents like marble kitchen countertops and stainless steel appliances.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Find your home here at Chardonnay, where you’ll find comfortable apartment homes in the quiet south Tulsa area. Our Tulsa apartment homes offer essential, everyday amenities paired with attractive features and finishes. When you’re looking for something to do, we invite you to spend your day at our on-site pool or sip on a complimentary cup of joe at our coffee bar. We offer affordable <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/apartments/ok/tulsa/chardonnay/floor-plans#/\"><strong>1 and 2 bedroom apartments</strong></a> to suit your needs.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>As you search for your next home in Tulsa, give yourself the resources and flexibility to create the right environment for your unique lifestyle. Country Hollow’s apartments in Tulsa are built to offer a blend of coziness and convenience, a theme that can be seen in your home and throughout our community accommodations. Make your home in an apartment designed to suit your needs with comfort by <a href=\"https://countryhollowapartmentstulsa.securecafe.com/onlineleasing/country-hollow-apartments/register.aspx\" target=\"_blank\"><strong>exploring the opportunities</strong></a> at Country Hollow.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/creekwood-apartments::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Creekwood Apartments in south Tulsa, offering inviting 1 and 2 bedroom apartments with a long list of included amenities. All our Tulsa apartment homes include an in-home washer and dryer, spacious closets, and a well-equipped kitchen. Our pet-friendly apartment community has several amenities that help residents make the most of every day, such as an indoor heated pool and spa.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/nickel-creek-apts::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>We welcome you to come make your new home in an apartment at Nickel Creek. Located in south Tulsa, you’re never far from the excitement of the city. When you live at Nickel Creek you’re surrounded by a variety of restaurants, shops, and entertainment. Whether you head out for a night on the town or order takeout for an evening in, you’ll love calling our neighborhood home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/polo-run-apartments::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Polo Run Apartments in Tulsa offers comfortable 1 and 2 bedroom living spaces designed to provide a peaceful retreat after a bustling day. Whether you’re a student seeking accommodation near Oral Roberts University or a long-term resident searching for a new apartment near Richmond Hills and Southridge Estate, Polo Run presents an array of options to suit your lifestyle. <a href=\"https://polorunapartmentstulsa.securecafe.com/onlineleasing/polo-run-apartments/register.aspx\" target=\"_blank\"><strong>Apply today</strong></a> to get started.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the ideal fusion of convenience, welcoming features, and upscale amenities at Sheridan Pond—our esteemed luxury apartments for rent in Tulsa, OK. Our meticulously crafted <a href=\"/apartments/ok/tulsa/sheridan-pond/floor-plans\"><strong>floor plans</strong></a> offer home comforts, while our amenities empower you to make the most of your experience in the renowned “world’s largest small town.”</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience the opportunity to craft your sanctuary within our Tulsa apartments, which showcase chic features and top-notch amenities. Situated in the coveted location of south Tulsa near Southbrook, Sugarberry offers convenience at your doorstep, with a range of essentials nearby, including grocery stores and cozy coffee shops as we're just minutes from Highway 169 and the Creek Turnpike. Embrace a vibrant community brimming with enticing amenities designed to elevate your daily living experience to its utmost potential. <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/apartments/ok/tulsa/sugarberry-apartments/contact-us\"><strong>Schedule a tour</strong></a> today to get started!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>In the heart of south Tulsa and near Cedar Ridge Park, Sunchase Apartments provides cozy and welcoming living spaces enhanced by fantastic community features. Our luxury apartments offer a diverse selection of floor plans, from studios to 2 bedroom homes, and cater to your unique lifestyle needs. Conveniently situated near major highways, restaurants, schools, and attractions, our reasonably priced Tulsa apartments ensure easy access to all conveniences and amenities. <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/apartments/ok/tulsa/sunchase-apartments/contact-us\"><strong>Schedule a tour</strong></a> to get started today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to The Courtyards of Tulsa, where you’ll find luxury 1 and 2 bedroom apartments in south Tulsa. Our apartment homes are outfitted with essential amenities like an in-home washer and dryer and luxurious touches like wood-burning fireplaces, which are available in select apartment homes. Resort-style amenities throughout our apartment community in south Tulsa invite our residents to relax and connect with their friends, family, and loved ones.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Make yourself at home at The Greens of Bedford’s Tulsa apartment homes and community. Here, you’ll find reasonably priced apartments in Tulsa with everything you need to live a comfortable life, from an in-home washer and dryer to recently updated kitchens. The Greens of Bedford Apartments are located in south Tulsa, near the Southbrook and Southern Plaza neighborhoods. <a href=\"https://greensofbedfordapartmentstulsa.securecafe.com/onlineleasing/the-greens-of-bedford/register.aspx\" target=\"_blank\"><strong>Apply today</strong></a> to find your dream home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover cozy 1 and 2 bedroom apartment residences at Windsail Apartments in the southern region of Tulsa. Our community provides a range of amenities to elevate your daily living experience, including a refreshing outdoor pool and a convenient 24-hour fitness center. In this thriving area of south Tulsa, indulge in delectable dining options, exciting attractions, and diverse shopping opportunities. <a href=\"/apartments/ok/tulsa/windsail-apartments/contact-us\"><strong>Schedule a tour</strong></a> today to get started!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>When you live in an apartment home from The Park on Westpointe, you can keep the key to a comfortable life in Yukon, OK, in your pocket. Our apartments redefine luxury, offering a sophisticated blend of modern design, premium amenities, and a vibrant community atmosphere. From the thoughtfully designed interiors to a meticulously curated courtyard, The Park on Westpointe is where the allure of upscale living is brought to life in Yukon, OK. <a href=\"https://parkatwestpointeapartmentsyukon.securecafe.com/onlineleasing/park-at-westpointe-i/register.aspx\" target=\"_blank\"><strong>Start your application</strong></a> for your dream home today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/the-ridge-@-66::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Those looking to live in luxury can find a new home in a luxury apartment from Ridge at 66 in Yukon, OK. Our luxury apartments on the northwestern edge of Lake Overholser sits in a calm upscale neighborhood near Lakeview Estates, just a short drive away from Oklahoma City. With a range of nearby shops and attractions as well as easy access to the John Kilpatrick Turnpike, our apartments offer a balance of convenience and opulence to all of our residents.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Modern designs and elegant finishes are the first things you’ll notice when you enter a <a href=\"/apartments/tx/amarillo/newport-amarillo-apts/floor-plans\"><strong>1 or 2 bedroom apartment home</strong></a> at Newport Apartments. Each of our apartments for rent comes equipped with a full kitchen and a spacious interior that is highly adaptable to how you want to live. You can live comfortably as you relax by the pool or enjoy the view from your private patio. Begin each day your way in a welcoming living community designed for comfort at Newport Apartments.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Find your dream home in a community designed around comfort and upscale living. Every detail of our west Amarillo apartments has been carefully crafted to enhance your living experience, from our private outdoor swimming pool to the full on-site fitness center, which is open 24 hours a day. Our <a href=\"/apartments/tx/amarillo/park-at-coulter/floor-plans\"><strong>1 and 2 bedroom apartments</strong></a> are spacious and adaptable so you can create a living space that exceeds your expectations of what a luxury living community can be.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>When you’re looking for luxury living with a peaceful atmosphere, the Remington Apartments are calling your name. Located in Southwest Amarillo near Sleepy Hollow, our luxury apartment community offers a range of spacious 1, 2, and 3 bedroom apartments designed to meet your every need. Whether you’re looking for shopping, dining, or entertainment options, everything is just a short drive away. With floor plans ranging from 725 to 1,110 sq. ft. you’ll have the space you need for maximum comfort. <a href=\"/apartments/tx/amarillo/remington-amarillo-apts/contact-us\"><strong>Contact Remington Apartments for a tour today</strong></a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Comfortably located in southwest Amarillo near the neighborhood of Greenways, Colonies at Hillside is an idyllic setting for your new apartment home. We’re just a short drive from Interstates 27 and 40, giving you quick and easy access to the heart of town where you can find a vibrant cultural scene and endless attractions to discover. Visit Colonies at Hillside, and explore your future home in Amarillo. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience the Winchester Apartments in Amarillo, TX, where luxurious 1, 2, and 3 bedroom homes await in the heart of west Amarillo. Our upscale residences feature modern conveniences like washer and dryer connections and elegant accents like wood-burning fireplaces in select homes. Located within our vibrant community are resort-style amenities that beckon residents to unwind, socialize, and create lasting memories with family and friends. <a href=\"/apartments/tx/amarillo/winchester-apartments/contact-us\"><strong>Schedule a tour</strong></a> to get started today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/acacia-park-apts::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Located off North Mesa Hills Drive, near I-10, our Acacia Park luxury <a href=\"/apartments/tx/el-paso/acacia-park-apts/floor-plans\">apartments in West El Paso, TX</a>, feature resort-inspired community living and abundant amenities. Enjoy our updated fixtures and spacious closets in our cozy apartment options. With floor plans ranging from 1 bedroom to 3 bedroom apartments, we provide apartments that fit any lifestyle.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/chimneys-apts::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Not far from I-10 in El Paso, TX, The Chimneys Apartments is a homey community eager to invite you in. With an expansive line of amenities, like our fitness center and pool, and our proximity to popular attractions throughout northwest El Paso, there’s no better place to call home than The Chimneys. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Savor the mountainside views and diverse food scene of El Paso or Sun City by living in Double Tree’s luxury apartments in El Paso. Our spacious 1 bedroom or 2 bedroom apartment floor plans cater to diverse lifestyles while offering abundant luxury amenities. With our several premier apartment community amenities, you’ll find everything you need when you call Double Tree Apartments your home. <a href=\"/apartments/tx/el-paso/double-tree-apts/contact-us\"><strong>Schedule a tour</strong></a> of our El Paso apartments and discover how Double Tree provides a new level of refined living near Mesa Hill. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Are you searching for luxury apartments in El Paso? High Ridge Apartments blends modern apartment features and premier community amenities. With 1 bedroom and 2 bedroom <a href=\"/apartments/tx/el-paso/high-ridge-apts/pet-policy\"><strong>pet-friendly apartments</strong></a> in East El Paso, we’ll help you make the most of living in Sun City in a prime location near downtown El Paso, Vista Del Valle Park, and Lone Star Golf Club.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/mountain-village-apts::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Located near I-10, Mountain Village Apartments is the leading choice for those seeking a luxurious living experience in El Paso, TX. With its convenient location near the Coronado Country Club and Franklin Mountains State Park, our upscale apartments offer the perfect setting for an active lifestyle.</p>\n<p>We offer a variety of luxury apartment floor plan options, ranging from 700 to 1,040 sq. ft., with high-end finishes and meticulous attention to detail. Our luxury apartments in El Paso, TX, provide myriad amenities, making our apartment homes an excellent choice for families and furry companions. Discover the peace of Mountain Village Apartment Homes today and make it your new home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/patriot-apts::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>The Patriot, our El Paso apartment community, offers an ideal blend of convenient location, inviting features, and luxurious amenities. Our apartment floor plans are thoughtfully designed to provide you with the comforts of home, and the amenities throughout our El Paso apartment community enable you to make the most out of every day in beautiful Sun City.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/phoenix-apts::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Here at The Phoenix, you’ll find high-quality apartments in El Paso with cozy, inviting features and excellent community amenities. Each floor plan is adaptable to your individual lifestyle, with options ranging from 1 to 3 bedroom apartment homes. Our affordable apartments in El Paso are also ideally located near major highways, restaurants, schools, attractions, and more.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/shadow-ridge-apts::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Settled along I-10 near Fort Bliss and El Paso International Airport, Shadow Ridge Apartments is the ideal place to call home in El Paso, TX. Our upscale apartment homes have several floor plans to choose from, ranging from 460 to 1,100 sq. ft. in size, with an extensive line of amenities attached. Whether you’re looking for a pet-friendly apartment in El Paso or a place to settle a family, welcome yourself home at Shadow Ridge Apartments.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience the comforts of The Crest Apartments in West El Paso, the perfect place to unwind after work or school and connect with the people you love. Each of our El Paso apartment floor plans is designed with care, creating the perfect backdrop for your life. When you leave your apartment, you’ll be greeted with a variety of amenities, like our refreshing pool and complete fitness center.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/hewitt/icon-at-hewitt::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Right in the heart of Hewitt, TX, experience upscale apartment living at Icon at Hewitt. Our luxury 1 and 2 bedroom apartments and townhomes near West Waco offer comfortable and spacious floor plans with an expansive and unique line of amenities included.&nbsp;</p><p>Close to I-35, our apartment community is conveniently located near several business areas across West Waco for easy access to and from work or school. Whether you work in Lorena, Woodway, or Central Hewitt, you can always come to your home at Icon at Hewitt.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>When it comes to places to live, Lubbock truly rocks, and not just because it’s known as the birthplace of Buddy Holly. Lubbock’s unique mix of rich southwestern history and modern metropolitan atmosphere makes it truly one of a kind. With tasty Texas barbecue all over town, several diverse art galleries, and echoes of the cowboys of yesteryear, Lubbock has become a cultural hub in western Texas.</p>\n<p>With an excellent Lubbock apartment, you can explore the city in all its splendor. The Cottages at Abbey Glen community features upscale apartments in Lubbock, just a short drive from everything the city has to offer. If you’re looking for a Lubbock apartment with a pool and several other luxurious amenities, The Cottages at Abbey Glen is the place for you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Located near Loop 289 and Marsha Sharp Freeway in Lubbock, TX, The Icon at Lubbock welcomes you with a warm, inviting community. We have a pool, gym, and a convenient 24-hour fitness center, so you’ll always want to stay. There’s no better place to live than The Icon at Lubbock thanks to its prime location near all the attractions, such as GolfSuites Lubbock, Canyon West Shopping Center, and West End Centre. Find your ideal apartment rental at our Lubbock, TX, luxury apartment community!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Colorful Lubbock, TX, has become the site of much recent growth, and it’s easy to see why. Between the city’s booming public art scene and rich musical history, it’s become a cultural beacon of Texas. From browsing the displays at the Buddy Holly Center to relaxing in the Mackenzie Main City Park, life in Lubbock sure is sweet.</p>\n<p>When you live at Tuscany Place’s luxury apartments in Lubbock, you can enjoy all the comforts of life in this blossoming city. At our Lubbock apartment community, you’ll find upscale, modern apartments and an abundance of community amenities. We’re ideally located in southwest Lubbock—a five-minute drive from South Plains Mall, next to Teddy Jack’s Hub City Grill.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/temple/portico-at-friars-creek-apts::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience luxury living in Temple, TX, and call Portico at Friars Creek your home. When you rent one of our southeast Temple luxury apartments or lofts, you enhance your living with a wide range of upscale apartment amenities at your fingertips. Enjoy our onsite pool, fitness center, and private balconies and patios. </p>\n<p>Situated near U.S. Highway 90, our apartment community is close and accessible to many neighborhoods and business parks, including the Temple Mall and Temple Town Center. Whether you work in the Medical District or are coming back from a day at Temple College or the Temple Railroad &amp; Heritage Museum, your Temple apartment home at Portico at Friars Creek is always just a short drive away. <a href=\"/apartments/tx/temple/portico-at-friars-creek-apts/contact-us\"><strong>Contact Portico at Friars Creek</strong></a> today for a tour of our apartments! </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Looking at apartments for rent in Waco, TX? The Bend at New Road apartment community in Waco offers 1 and 2 bedroom apartments in Alta Vista, complete with high-end amenities. Enjoy our 24-hour fitness center, dog park, and community clubhouse without even leaving the premises. Looking for Waco apartments with a pool? The Bend at New Road has that too!</p>\n<p>You’ll find our luxurious apartment floor plans in Waco near the Alta Vista and University neighborhoods, near Magnolia Market and Cameron Park Zoo. With many Waco luxury apartment options, like loft apartments and townhomes, you’re sure to find a floor plan that works for you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/tuscany-ranch-apartments::propertyabout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Are you looking at apartments for rent in Waco, TX? Look no further than Tuscany Ranch for upscale apartment homes in all of Waco. With comfortable luxury apartments and useful amenities from our fitness center to our pool, you can experience upscale apartment living when you call Tuscany Ranch your home.<br/>Near I-35, our apartment community is close to several shopping centers and neighborhoods in and near Waco. Whether you’re at the Central Texas Marketplace or coming home from the Magnolia Market or Baylor University. You can always come home to our Waco apartments. <a href=\"/apartments/tx/waco/tuscany-ranch-apartments/contact-us\"><strong>Schedule your tour</strong></a> to see our luxury apartments and townhomes for rent today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/north-little-rock/lexington-park::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165609/019fc925-67fe-75d5-8f55-33f08db9017f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-170f-7339-9326-dea7206356eb.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/huntington-park::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166545/01a11c6d-094a-72c8-ad7f-efce3c7f90c5.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/portofino::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019db0cc-0faf-75b6-9696-ae312898285a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5ce-e28d-775e-9845-4540e569a9d4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/belton/center-301::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019d593f-4c25-77ef-840a-dfe10f6701a5.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/independence/the-adirondack::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da5-991b-744a-9f3d-4caacec6ab44.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/152-northland::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cec-f49d-77cc-8dab-6e70f38327c0.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/97-north-oak::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-7c46-7605-bcbf-7b0e30457c7b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db68f-d214-739f-b19c-7edb015cd973.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4c-43dd-735f-b3bd-3105a1f07ea2.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4f9-7d8e-716b-92fe-fc7fc50bf0cd.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c14-2f67-73bb-be3b-f36c5a996b17.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-dd83-710a-b8df-3ca4bfec8cb1.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/artisan-crossing-apts::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/01a062bd-8d67-70ec-b9fe-c1e2b11a41ac.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/24hundred-apartments::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db713-45c0-718a-ac8a-b12d1d11d6b5.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/chisholm-pointe::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d1-a077-774f-ac4e-86b4a41be8ef.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/019ffa83-ac53-764e-909b-36450a64dc9e.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-ab51-7244-b835-b4a32a69b27e.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08676-01f5-771b-814f-f56658686bb6.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/01a08181-d26b-712c-a947-b8b951f224e4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d5-a894-74d9-8995-c42ee1d2f578.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4b-2981-737d-b79d-7f7499a58eec.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e1096-1d0c-731c-a21c-ad9a5ca05814.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/coffee-creek::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019d9bed-c763-73ef-b5a1-0a14c1aed7f6.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa491-a22a-740e-896a-189189fdd474.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cypress-crossing::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019cfb40-c4bb-77f9-a347-a03e2ecf0632.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/pryor/west-530::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03546-375f-70f2-9be7-d003fa451933.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/barrington-apartments::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f049e-561c-776a-a1f2-e68d53982840.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cascata-luxury-apartments::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019f610b-4bba-758c-a73a-0cfe0c007aff.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-glade-apts::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf6a-a368-75f9-9e5d-5843d3153217.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b9-c39c-7679-9769-3498457ae2b1.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-e23a-73b2-8e6d-02aaa0c08cdf.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019dbae7-a85a-726d-8434-146db619cf1a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/creekwood-apartments::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1940-cda7-76ca-a70c-89ecf5f3837a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/nickel-creek-apts::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db131-62a0-7473-86dc-ac59efc93a2a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/polo-run-apartments::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a2-4528-76ca-b54b-549069569986.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02003-7f3e-70a8-9b1f-4b21eeb96d08.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a015fe-9219-749d-91db-6c1809869836.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa1f-793a-739e-91aa-bb1475c5ba38.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee077-5d5f-722c-a8ed-b55dc2a9b135.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019cfb4c-f236-716c-8109-0f10144b962a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c1-5695-72a3-98d0-15061242585d.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/the-ridge-66::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192d-0aee-7421-936f-2cd749dbebb8.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf7-80b1-7544-8ccd-e6d22bc004d8.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc5-b5a2-71b0-bcac-706e6b495bcc.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df4-f21a-72ab-b312-455ed594bdbc.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/01a0e998-b27a-74be-83e9-62e27893495a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019f0071-3c1d-75bf-b4be-03394ec82f6b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/acacia-park-apts::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019cfb37-7f5c-77f6-b430-dda343a16ef3.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/chimneys-apts::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611c-2e66-76a3-99b4-ce0bc95e9ce4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92e-09fd-742d-9b9d-b4bcb22fa026.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/01a0a196-25af-7531-9626-e34f21a31222.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/shadow-ridge-apts::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d20af-a4c5-71b8-8285-ef0031cde3e8.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd3-bac6-73ec-b921-cfa7544932a4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a0e9d6-fbd6-73ba-8c6f-b62e36c95b28.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda3-387c-77a9-a678-811b08e8a086.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2a-3f8b-75de-8bb5-31c2c2201d25.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road::propertyabout.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd83-8f11-754b-958c-0c4e0e9b1cad.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments::propertyabout.luxury_suffix": {
    "overrideType": "VALUE",
    "customValue": "Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/newport-wichita-apts::propertyabout.luxury_suffix": {
    "overrideType": "VALUE",
    "customValue": "Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/raintree-apartments::propertyabout.luxury_suffix": {
    "overrideType": "VALUE",
    "customValue": "Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/remington-wichita-apts::propertyabout.luxury_suffix": {
    "overrideType": "VALUE",
    "customValue": "Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments::propertyabout.luxury_suffix": {
    "overrideType": "VALUE",
    "customValue": "Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail::propertyabout.luxury_suffix": {
    "overrideType": "VALUE",
    "customValue": "Luxury Duplexes",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/raintree-apartments::propertyabout.property_name": {
    "overrideType": "VALUE",
    "customValue": "Raintree",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills::propertyabout.property_name": {
    "overrideType": "VALUE",
    "customValue": "The Park at Mission Hills",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts::propertyabout.property_name": {
    "overrideType": "VALUE",
    "customValue": "Cimarron Trails Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts::propertyabout.property_name": {
    "overrideType": "VALUE",
    "customValue": "Hunter's Ridge Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments::propertyabout.property_name": {
    "overrideType": "VALUE",
    "customValue": "Windsail Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail::propertyamenities.apartment_title": {
    "overrideType": "VALUE",
    "customValue": "Duplex Amenities",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Enjoy a life of leisure and relaxation with our community <a href=\"/apartments/ar/little-rock/arbors-of-pleasant-valley-apts/amenities\"><strong>amenities</strong></a>. Take a dip in our shared outdoor pool on hot summer days, or host a barbecue gathering with friends at our grilling area. Stay active and healthy with our state-of-the-art fitness center, where you can work out on your own terms. We believe that true comfort begins with convenience. That’s why our apartments come with a washer and dryer, so you can say goodbye to tedious trips to the laundromat.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/north-little-rock/lexington-park::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Our apartments in North Little Rock come equipped with all of the <a href=\"/apartments/ar/north-little-rock/lexington-park/amenities\"><strong>essential features and amenities</strong></a> you need in your day-to-day life, plus luxurious finishes that exude style. All of our apartment homes come with a washer and dryer to make laundry day easy, as well as a bright sunroom that can be a dining area, reading nook, or pet area. Stylish extras are also available in many apartment homes, such as nine-foot ceilings, granite countertops, and stainless steel appliances.<br/><br/>All around our North Little Rock apartment community, included amenities await you. Keep up with your fitness routine at our 24-hour fitness center, with weights, cardio equipment, and benches to accommodate any workout. When the Arkansas summer hits, cool off in our outdoor pool or lounge on our sundeck. Thanks to our on-site tanning salon, you can also work on your tan any time of the year.<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/maize/watercress-apartments::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Experience elevated living at our upscale apartments for rent in Maize, KS, where many <a href=\"/apartments/ks/maize/watercress-apartments/amenities\"><strong>amenities</strong></a> await you. Our apartment kitchens boast modern appliances and sleek white custom cabinetry for a stylish touch. Choose from a selection of apartment homes with dining areas or office nooks for added versatility.<br/><br/>Beyond your apartment, our luxurious community beckons. Discover a state-of-the-art fitness center, a zero-entry pool with relaxing outdoor cabanas, and a firepit and lounge area for sunny days. Embrace our canine cove and bark park for quality time with your furry friends. When you choose Watercress, you can welcome a lifestyle of comfort and convenience!<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Aspen Park in Wichita, KS, where modern living meets comfort. Choose from thoughtfully designed studios to spacious two-bedroom apartments. Embrace outdoor relaxation on our sun-soaked patio or grill in the picturesque picnic area.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Our cottage-style apartment homes feature an ideal blend of comfort and luxury, outfitted with <a href=\"/apartments/ks/wichita/cottages-at-crestview/amenities\"><strong>convenient amenities and elegant touches</strong></a>. Gourmet kitchens await your next mealtime, equipped with essential appliances: a dishwasher, stove, microwave, and side-by-side refrigerator, and elevated finishes, like custom kitchen cabinetry and tile backsplash. Several apartment homes feature an optional LED fireplace, offering that cozy feeling without the hassle of cleanup. <br/><br/>All around the Cottages at Crestview apartment community, luxury amenities encourage you to enjoy your day your way. Hit a sunrise (or midnight) workout at our on-site fitness center, which is open 24 hours a day and fully stocked with free weights, cable machines, benches, and cardio equipment. Cool off on hot summer days at our on-site pool, or stay warm and cozy with complimentary coffee or tea from our internet cafe and event kitchen space.<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/crown-chase-apts::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Make yourself comfortable in one of Crown Chase’s apartment homes, equipped with <a href=\"/apartments/ks/wichita/crown-chase-apts/amenities\"><strong>amenities</strong></a> that complement your daily routine. An expansive kitchen with all the essential appliances makes preparing meals a breeze, while the private balcony or patio adds a touch of stylish luxury to your apartment home. <br/><br/>The Crown Chase community features amenities around every corner, allowing you to enjoy your day your way. Lush, landscaped paths guide you through our serene community while our sparkling outdoor pool beckons you to cool off on hot summer days. You’ll also find an on-site dog park with beautiful waterside views.<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/huntington-park::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Our Wichita apartment homes include a blend of <a href=\"/apartments/ks/wichita/huntington-park/amenities\"><strong>essential amenities and stylish, luxurious elements</strong></a>. The spacious kitchen features a complete package of energy-efficient appliances, including a dishwasher and garbage disposal. A private patio or balcony can be found in our apartment homes, giving you a personal oasis for getting some fresh air or curating a little garden.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/newport-wichita-apts::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Living at Newport Apartments gives you the flexibility to create the home you want to live in. Prepare meals in your generously sized kitchen and enjoy the scenic view of our charming community through your living room windows. The <a href=\"/apartments/ks/wichita/newport-wichita-apts/amenities\"><strong>amenities</strong></a><strong> </strong>in our Wichita apartment homes put comfort first, from its open-concept design to the subtle touches like our plush carpets and ambient lighting to bring a natural yet upscale feel to your living environment.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/portofino::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Our <a href=\"/apartments/ks/wichita/portofino/amenities\"><strong>luxury apartment homes</strong></a> feature chef-inspired kitchens with sleek stainless steel appliances and designer cabinetry. Relax and unwind in our resort-style swimming pool, or catch up with friends in our cozy outdoor retreat with a fire pit and barbecue lounge. No matter your schedule, you can stay active and healthy in our state-of-the-art fitness center, equipped with cardio machines, free weights, and yoga space, while your furry friends play in the on-site Bark Park in our pet-friendly community.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/raintree-apartments::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience modern living at Raintree Apartments in Wichita, where the ideal blend of tranquillity and recreation awaits. Our community sits alongside a picturesque lake, offering stunning views and impressive <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/apartments/ks/wichita/raintree-apartments/amenities\"><strong>amenities</strong></a>, including a sparkling swimming pool.<br><br>You can enjoy the pool’s refreshing waters conveniently within your home environment. With the serene backdrop of the lake and the convenience of on-site leisure facilities, Raintree Apartments presents an idyllic setting for those seeking a balanced lifestyle in Wichita.<br></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/remington-wichita::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Discover the convenience of our Wichita apartments, complete with upscale <a href=\"/apartments/ks/wichita/remington-wichita/amenities\"><strong>amenities</strong></a> for effortless daily living. Each apartment at The Remington complex features full-sized washer and dryer connections and a well-equipped kitchen with a stove, dishwasher, and microwave.<br/><br/>With various floor plans, our complex offers additional comforts like ceiling fans, extra storage, and even a cozy wood-burning fireplace in select homes. Whether you want to take a refreshing swim in the outdoor pool or work out in our on-site fitness center, you can live a life of choice and comfort at The Remington Apartments.<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/silver-springs-apts::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Experience the enhanced daily living offered by Silver Springs Apartments in Wichita, KS. Our west Wichita apartments provide features and <a href=\"/apartments/ks/wichita/silver-springs-apts/amenities\"><strong>amenities</strong></a> that seamlessly blend into your everyday life. Step out onto your private patio or balcony for fresh air. In the summer, unwind by dipping in the indoor swimming pool or relaxing on our inviting sun deck.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            The Villas of Waterford is Wichita’s leading <a href=\"/apartments/ks/wichita/villas-of-waterford/pet-policy\"><strong>pet-friendly</strong></a> apartment community for those who want the best. Our luxurious apartments offer more than fundamental amenities like washer and dryer connections. With gourmet kitchens, large closets, and plush carpeting, our apartment homes are like a warm embrace after a long day.<br/><br/>We take pride in our <a href=\"/apartments/ks/wichita/villas-of-waterford/amenities\"><strong>premium amenities</strong></a> that cater to your every whim and desire. Whether you want to unwind by one of our two outdoor swimming pools, host a party in our resident clubhouse, or stay fit with our well-equipped, on-site fitness center, we have you covered. The Villas of Waterford is where luxury living meets exceptional convenience. Experience the Villas of Waterford and elevate your lifestyle to new heights.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/belton/center-301::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Our 1 and 2 bedroom apartments, lofts, and townhomes are adorned with stylish touches like unique bathroom tile flooring, marble countertops, and stainless steel appliances. Alongside our opulent features, you’ll find <a href=\"/apartments/mo/belton/center-301/amenities\"><strong>essential amenities</strong></a> to simplify your daily life, like washer and dryer connections, a dishwasher, and spacious closets.<br/><br/>Upon exiting your apartment home, you’ll discover an impressive array of upscale amenities. The saltwater pool beckons you to relax and cool off during the hot Missouri summers, the fully stocked fitness center awaits your next workout, and the secure gated entrance grants you peace of mind. <br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/independence/the-adirondack::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Life is made simple at our luxury apartments in Independence, MO. Our community and in-home <a href=\"/apartments/mo/independence/the-adirondack/amenities\"><strong>luxury apartment amenities</strong></a> create an environment that allows you to easily unwind, accomplish your goals, and spend time with loved ones. Let your pup burn some energy at our on-site dog park, fit in a workout at our fitness center, or make memories with your family and friends at our Grill and Chill areas. At The Adirondack Apartments, we provide everything you need to feel at home and thrive!<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/152-northland::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                             <br/>Everything you need to live your best life can be found at 152 Northland. Our luxury apartments for rent in Kansas City, MO, feature top-tier amenities and finishes conveniently located within easy reach. Along with modern thermostats and appliances, enjoy custom cabinetry, marble countertops, and spacious closets, among other features in select homes.<br/><br/>Beyond the walls of your home, the comforts continue. Our residents have the opportunity to stay active in our 24/7 fitness center, swim laps, or relax in our resort-style pool and cabana. If you work from home or want a quiet spot to get work done, our business center is the perfect place to go. And when the week ends and you want to entertain friends or a significant other, our clubhouse and outdoor grill area offer you space to host a great night.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/97-north-oak::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Relax, connect with loved ones, and catch up with friends at our luxury apartment community, featuring posh <a href=\"/apartments/mo/kansas-city/97-north-oak/amenities\">amenities</a> in each apartment and throughout our inviting community. Our Kansas City luxury apartments feature gorgeous chef’s kitchens adorned with white tile backsplash and dove gray or espresso cabinets. <br/><br/>As you step out of your apartment, our amenities beckon you to seize the day. Cool off on hot summer days at our resort-style pool and cabana, or grab a complimentary coffee and get some work done at our business center. When the weather gets chilly, warm up by our outdoor fireplace or stay indoors and play a game of shuffleboard in our resident clubhouse.<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/mark-apts::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Convenience and comfort are at the forefront when you live at <a href=\"/apartments/ms/ridgeland/mark-apts/amenities\"><strong>The Mark Apartments</strong></a>. We strive to create a community that is more than just a place to stay but a place where you feel at home at every turn. You’ll be able to take advantage of the many amenities we have to offer, along with simple conveniences like having an apartment with a patio and living at apartments with parking amply available. You’ll also enjoy peace of mind knowing we have a 24/7 on-call maintenance staff ready to help at any time.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/sunchase-ridgeland-apts::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            With several apartment and community <a href=\"/apartments/ms/ridgeland/sunchase-ridgeland-apts/amenities\"><strong>amenities</strong></a> included, you’ll unlock luxury apartment living when you rent with us at Sunchase Ridgeland. With a fitness center, an indoor swimming pool, and a private balcony, you’ll get what you need and more to make your upscale apartment home feel special and comfortable.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/the-pointe-of-ridgeland::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            On those warm Mississippi days, take a dip in our refreshing swimming pool to beat the heat. It’s the perfect place to cool off and catch some rays while you enjoy the company of friends and neighbors. Our residents also enjoy staying active at <a href=\"/apartments/ms/ridgeland/the-pointe-of-ridgeland/amenities\"><strong>our o</strong></a><a href=\"/apartments/ms/ridgeland/the-pointe-of-ridgeland/amenities\"><strong>n</strong></a><a href=\"/apartments/ms/ridgeland/the-pointe-of-ridgeland/amenities\"><strong>-site fitness center</strong></a>. Other community amenities our residents love include our 3-acre pond and walking trails that provide tranquility and relaxation.<br/><br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/trace-apts::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Looking for Ridgeland apartments with a pool? We’ve got you covered. Beyond our sparkling outdoor pool, you’ll enjoy several additional community amenities, including a full fitness center, 24-hour maintenance, and a lux resident clubhouse.<br/><br/>The amenities don’t stop when you enter your apartment, where you’ll enjoy a private balcony or patio, spacious closets, and a well-equipped kitchen. Select apartments even include a wood-burning fireplace, perfect for cozying up to with a warm beverage during the winter. Check out our <a href=\"/apartments/ms/ridgeland/trace-apts/amenities\"><strong>list of amenities</strong></a> to see everything included in our Ridgeland apartments.<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Find your bliss in one of our luxury apartments in Broken Arrow, outfitted with <a href=\"/apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/amenities\"><strong>essential amenities</strong></a> and designed with elegant finishes. The full chef’s kitchen includes all the appliances you need for meal preparation, gorgeous quartz countertops, wood-style flooring, and designer kitchen cabinetry. Select apartment homes also feature extras, like a fireplace and a private patio or balcony.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Luxurious touches and care in design can be found in every aspect of your new home in Broken Arrow. Greet each morning with ample rays of sunshine on your private patio before you take the short stroll down to the fitness center for a heart-pumping workout. When the day is done, relax in front of your fireplace as the sun sets in front of you. <br/><br/>You’ll hardly need to leave our secure gated community to enjoy the comforts of a personal garage, two resort-style pools, a relaxing pond, and the many other <a href=\"/apartments/ok/broken-arrow/park-at-mission-hills/amenities\"><strong>amenities</strong></a> and subtle touches indoors and outdoors that offer a higher standard of living to all our residents.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/redbud-ranch::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Personalize your apartment with your furnishings amid the lavish <a href=\"/apartments/ok/broken-arrow/redbud-ranch/amenities\"><strong>amenities</strong></a>, including inviting warm tones, spacious and bright living areas, and contemporary kitchens with stainless steel appliances. Select floor plans offer cozy nooks, ideal for reading or dining, and attached garages for convenience during your daily commute.<br/><br/>Embrace the weekend by exploring our vibrant community, starting with a morning workout at the fitness center. You can share precious moments with a four-legged friend at our on-site dog park, where you can watch them frolic. Later, unwind with a revitalizing swim in the pool or indulge in a relaxing read at the cabana.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Discover warm and inviting upscale apartments in Broken Arrow, OK, that cater to diverse lifestyles. In addition to private patios and balconies in select apartment homes offering stunning views of New Tulsa, you can have a cozy fireplace to keep you comfortable on chilly days.<br/><br/>Beyond the cozy living spaces near Hillside Drive, our community boasts exceptional <a href=\"/apartments/ok/broken-arrow/scissortail-crossing/amenities\"><strong>amenities</strong></a>, including a resort-style pool, resident clubhouse, and 24-hour fitness center, fostering an active and enjoyable lifestyle for you and your loved ones.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Each of our luxury apartment homes at Trails at Aspen Creek in Broken Arrow is brand-new with practical elements like washer and dryer connections, energy-efficient appliances, and central air conditioning and heating. Experience the convenience and effectiveness of smart apartment living through our partnership with Cox for top-notch smart home automation. With cutting-edge technology from Ambient, you can effortlessly control locks, temperature, and more directly from your Ambient Home app. Enjoy the benefits of a Smart Door Lock for seamless home access management and notifications, as well as a Smart Thermostat to customize your preferred temperature and enhance energy efficiency whether you’re at home or away.<br/><br/>Our luxury amenities don’t end when you leave your apartment! Trails at Aspen Creek offers an array of upscale community features to enjoy with family, friends, and neighbors on your time. Enjoy sunny mornings with your pup at our on-site dog park, afternoons grilling and chilling, and evenings breaking a sweat in the fitness center. The opportunities are endless at Trails at Aspen Creek in Broken Arrow, OK!                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Prepare yourself for an exceptional lifestyle at the Villas at Aspen Park! Our apartments embody refinement and sophistication, featuring <a href=\"/apartments/ok/broken-arrow/villas-at-aspen-park/amenities\"><strong>premium amenities</strong></a> that cater to your every whim and desire. Immerse yourself in the lap of luxury with our designer paint, ceramic tiling, and energy-efficient appliances that will make your life easier and more convenient.<br/><br/>Our apartment community offers many breathtaking features, including a sparkling swimming pool, a cutting-edge grilling area, and a state-of-the-art fitness center. The Villas at Aspen Park in Broken Arrow harmonize comfort and accessibility, allowing you to make the most of your time. If you’re a discerning individual looking for the ultimate living experience, look no further than the Villas at Aspen Park.<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/catoosa/bluffs-at-catoosa::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Everyday ease, close to home.</strong> Break a sweat in the fitness center, cool off at the pool, or take a fresh-air pause in the courtyard. Bluffs at Catoosa also keeps the practical side simple with in-unit laundry connections, rentable garages, online payments, and on-site management and maintenance—plus apartment features like dishwashers, large closets, ceiling fans, and select patios.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/fountain-lake::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            The <a href=\"/apartments/ok/edmond/fountain-lake/amenities\"><strong>upscale amenities</strong></a> inside each of our Edmond Apartment homes bring convenience and style to your living space. A contemporary chef’s kitchen, complete with all the appliances you need, will help you prepare meals with ease. Ceramic tile, plush carpeting, and other elegant finishes serve as an ideal canvas for your style. Several of our apartment homes also offer convenient personal garages for rent, helping you streamline your morning routine.<br/><br/>Luxury living doesn’t stop when you step outside your apartment. The resort-style amenities around Fountain Lake await you, helping you stay active or relax and recharge. Lush, green courtyards and well-manicured paths connect our amenities and serve as an ideal spot for walking your dog. Spend summer days at our relaxing pool with a sun deck and loungers for working on your tan.<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Our luxurious apartment community at the Villas at Stonebridge offers more than valuable amenities like washer and dryer connections. Our apartments feature fully equipped kitchens, spacious closets, and sleek elements throughout the design, making them the perfect place to call home.<br/><br/>In addition, our apartment community boasts a range of luxury amenities designed to enhance your lifestyle. You can relax in one of our two outdoor swimming pools during summer, socialize with friends and family in the Grill and Chill area, or easily maintain your fitness goals in one of our two on-site fitness centers. With all these <a href=\"/apartments/ok/edmond/villas-at-stonebridge/amenities\"><strong>luxurious amenities</strong></a> at your fingertips, the Villas at Stonebridge is the perfect place to live your best life in Edmond, OK.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            When you live at The Reserve at Elm, not only will you get top-of-the-line apartment features, but you will also have access to outstanding community amenities.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/moore/mission-point::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Comfort and style combine to create the unique blend of <a href=\"/apartments/ok/moore/mission-point/amenities\"><strong>features and amenities</strong></a> available at Mission Point Apartments. Take a swim in our large private pool on hot summer days, or come indoors to relax in our serene clubhouse with a cup of coffee or hot cocoa in the winter. Our welcoming environment allows you to exercise comfortably, so start your day with a heart-pumping workout in our on-site fitness center or enjoy some quality time outdoors in our vibrant courtyard with your whole family, pets included.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/artisan-crossing-apts::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Our apartments in Norman feature a blend of <a href=\"/apartments/ok/norman/artisan-crossing-apts/amenities\"><strong>comfortable amenities and luxurious features</strong></a> to effortlessly fit into your daily routine. Feel the plush, wall-to-wall carpeting under your feet and warm up by your LED fireplace, available in select apartment homes. Spend the weekend in our inviting community, breaking a sweat at our on-site fitness center or enjoying some coffee while you study in our internet cafe.<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            The inviting features and <a href=\"/apartments/ok/norman/cimarron-trails-apts/amenities\"><strong>amenities throughout our apartments for rent in Norman, OK</strong></a>, complement your daily routine just right. Our kitchens include a dishwasher and in-sink disposal to simplify meal preparation and cleanup. The wide windows and private balcony or patio door let in lots of refreshing natural light, illuminating your personal decor and furniture. <br/><br/>Lush green courtyards span our Norman apartment community grounds, connecting the amenities that help our residents relax. The cool sparkling water and relaxing sun loungers beckon you to our sun deck and swimming pool, inviting you to let your worries fade away. When you need a pick-me-up, stop by our resident clubhouse and grab a cup from our coffee bar.<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/24hundred-apartments::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Our Oklahoma City apartment complexes feature high ceilings, plush carpeting, and stainless steel appliances, making it easy to enjoy upscale apartment living with a variety of amenities. The classic designs in our lofts, townhomes, and apartments provide residents with the perfect opportunity to create the apartment home of their dreams. When you feel like mingling with neighbors or spending time with loved ones, we invite you to indulge in our luxury apartment community’s <a href=\"/apartments/ok/oklahoma-city/24hundred-apartments/amenities\"><strong>amenities</strong></a>. Bask in the sunshine at our opulent pool’s tanning deck or enjoy quality time with friends at our resident clubhouse, complete with a pool table.<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/chisholm-pointe::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Each of our Oklahoma City apartment homes is designed with comfort in mind, featuring all the <a href=\"/apartments/ok/oklahoma-city/chisholm-pointe/amenities\"><strong>amenities</strong></a> you need for your daily routine. The stylish kitchen’s quartz countertops, modern stainless steel appliances, and included dishwasher make mealtimes a breeze. The fenced-in yard is perfect for hosting friends and family, playing with pets, or relaxing on your own.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Inside our thoughtfully designed Oklahoma City apartments, all the <a href=\"/apartments/ok/oklahoma-city/cimarron-pointe-apts/amenities\"><strong>essential amenities</strong></a> await, along with some luxurious touches. Cook up a hearty meal in your fully equipped kitchen and enjoy it in the open-concept dining area. Cleanup is made easy with a dishwasher and in-sink disposal. When you need fresh air, grab a beverage and your favorite book and head to your private patio or balcony.<br/><br/>Around the Cimarron Pointe community, on-site amenities encourage residents to make the most of their day. When summer temperatures peak, cool off in one of our two on-site pools. Lush green courtyards and an on-site dog park also await, where you can enjoy some quality time outdoors. <br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Council Place’s Oklahoma City apartments feature <a href=\"/apartments/ok/oklahoma-city/council-place-apartments/amenities\"><strong>amenities</strong></a> to enrich day-to-day life. An in-home washer and dryer are available in every apartment home, making laundry days more convenient. When you need some fresh air, take advantage of the private balcony or patio in your apartment home.<br/><br/>Throughout our apartment community in Oklahoma City, you’ll find features and amenities that complement your daily routine. Start your day with a workout in our on-site fitness center with weights and cardio equipment. When summer peaks, head to our on-site pool to cool off or work on your tan in one of our pool loungers.<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Our 2 and 3 bedroom apartments in Oklahoma City boast an impressive list of <a href=\"/apartments/ok/oklahoma-city/cross-timber/amenities\"><strong>amenities and features</strong></a> that will make you feel right at home. The beautiful modern kitchen is fully equipped with the essentials and adorned with stylish touches like expansive countertops, custom kitchen cabinetry, and all black appliances. Our apartment bedrooms feature bright and airy windows and expansive closets. <br/><br/>Throughout our Oklahoma City apartment complex, you’ll find amenities to help you make the most of each day. Relax and refresh in our sparkling saltwater swimming pool, or hit a workout in the full fitness center with free weights, exercise machines, and more. When you want to relax or mingle with neighbors, head to our resident clubhouse with comfortable seating and a modern LED fireplace.<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Let the <a href=\"/apartments/ok/oklahoma-city/crown-pointe-apartments/amenities\"><strong>amenities and luxurious touches</strong></a> in each of our Oklahoma City apartments make you feel right at home. The fully equipped kitchen includes all the appliances you need to cook up a delicious meal, while its wood-style flooring gives the space a touch of style. Each apartment home has a private patio or balcony where you can breathe in the fresh air and relax while enjoying your favorite beverage.<br/><br/>Beyond our apartment homes, Crown Pointe boasts an impressive list of community amenities that will help you make the most of every day. A sparkling outdoor pool will help you cool off on hot days while the fitness center, open 24 hours a day, makes it easy to stick to your workout routine.<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            The many <a href=\"/apartments/ok/oklahoma-city/hunter-s-ridge-apts/amenities\"><strong>amenities included in our Oklahoma City apartments</strong></a> will make you feel right at home. A spacious kitchen includes all the essential appliances you need to try out a new recipe or prepare a quick meal. Many of our apartment homes also include a private patio, balcony, or sunroom where you can enjoy plenty of natural light while sipping a refreshing beverage or cracking open a good book.<br/><br/>Convenient amenities don’t end when you step out your front door. They continue into our Oklahoma City apartment community. Invite friends and loved ones over to enjoy a dip in the pool on summer days or relax and recharge in the resident lounge. Our resort-style pool also includes a hot tub to soak your troubles away.<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter's-ridge-apts::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            The many <a href=\"/apartments/ok/oklahoma-city/hunter-s-ridge-apts/amenities\"><strong>amenities included in our Oklahoma City apartments</strong></a> will make you feel right at home. A spacious kitchen includes all the essential appliances you need to try out a new recipe or prepare a quick meal. Many of our apartment homes also include a private patio, balcony, or sunroom where you can enjoy plenty of natural light while sipping a refreshing beverage or cracking open a good book.<br/><br/>Convenient amenities don’t end when you step out your front door. They continue into our Oklahoma City apartment community. Invite friends and loved ones over to enjoy a dip in the pool on summer days or relax and recharge in the resident lounge. Our resort-style pool also includes a hot tub to soak your troubles away.<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/park-at-tuscany::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Make yourself at home as you enjoy the crackling warmth of your wood-burning fireplace or the cool summer breeze as you relax on your personal patio or balcony. Outside, you’ll find <a href=\"/apartments/ok/oklahoma-city/park-at-tuscany/amenities\"><strong>community features</strong></a> that cater to all activity levels, bringing friends and family together for relaxation and entertainment. Whether you’re taking a peaceful stroll along our tree-shaded walking paths or staying active in our fitness facility, designed for all levels, you’ll find plenty of options. You can enjoy a dip in our private pool to cool off under the sun or have a cookout in our barbecue and grilling areas, all tastefully shaded by our pavilions and the natural tree canopy.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/persimmon-square-apartments::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Persimmon Square Apartments is a picturesque north Oklahoma City community boasting a stunning courtyard and vibrant green surroundings. Our Oklahoma City apartments for rent feature expansive closets, abundant natural light, and large, fully equipped kitchens, ideal for culinary exploration. Among our <a href=\"/apartments/ok/oklahoma-city/persimmon-square-apartments/amenities\"><strong>amenities</strong></a>, the dishwasher and garbage disposal stand out, simplifying cleaning tasks and allowing you to allocate more time to your preferred activities.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            We strive to provide our residents with an exceptional living experience, which starts by offering <a href=\"/apartments/ok/oklahoma-city/prairie-springs-i/amenities\"><strong>premium amenities</strong></a> that set our community apart from the rest.<br/><br/>Outside your apartment, dive into relaxation at our sparkling resort-style swimming pool, or break a sweat in our 24-hour community fitness center to stay in shape on your schedule. Taking a step back inside, your luxury apartment offers a living space with ample storage space, plush carpeting, and large closets ready to house your entire wardrobe. With gated access, washer and dryer connections, and garage parking available, Prairie Springs sets a standard for upscale living in Oklahoma City.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/stonehorse-crossing::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            The finest <a href=\"/apartments/ok/oklahoma-city/stonehorse-crossing/amenities\"><strong>amenities</strong></a> and accommodations at Stonehorse Crossing Apartments enhance your living experience and allow you to embrace a comfortable and luxurious lifestyle to the fullest. Our apartment homes are crafted with premium features including custom cabinetry, vaulted ceilings, private balconies, and modern appliances that blend functionality with a sleek aesthetic. <br/><br/>Your home at Stonehorse Crossing extends beyond your apartment with community features that are sure to impress. An expansive dog park, game room, clubhouse, and multiple lounges give you the space to relax and enjoy your experience across our entire property.<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summerfield-place-apts::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Discover <a href=\"/apartments/ok/oklahoma-city/summerfield-place-apts/amenities\"><strong>chic features and practical amenities</strong></a> in each of our upscale Oklahoma City apartments for rent designed to create a sense of home near Camelot Estates. Select layouts come with a private balcony or patio, perfect to unwind on after along day. Indulge in our luxurious apartment kitchens equipped with energy-efficient appliances and wood style floors.<br/><br/>Our community amenities are perfect for socializing with loved ones or savoring moments of solitude. Whether you seek a refreshing dip in our serene pool or a moment of relaxation in our elegant clubhouse, Summerfield Place presents a full array of options for your enjoyment.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summit-ridge-villas/summit-villas::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Each of our Oklahoma City duplexes is designed with comfort in mind, featuring all the <a href=\"/apartments/ok/oklahoma-city/chisholm-pointe/amenities\"><strong>amenities</strong></a> you need for your daily routine. The stylish kitchen’s quartz countertops, modern stainless steel appliances, and included dishwasher make mealtimes a breeze. The fenced-in yard is perfect for hosting friends and family, playing with pets, or relaxing on your own.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/tammaron-village-apartments::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Tammaron Village Apartments is the ultimate choice for pet owners seeking a luxurious, pet-friendly apartment community in Oklahoma City. Our apartments are meticulously designed to offer the perfect blend of comfort and luxury. You’ll feel right at home with spacious kitchens, large pantries, plush carpeting, and ample closets.<br/><br/>Our community boasts <a href=\"/apartments/ok/oklahoma-city/tammaron-village-apartments/amenities\"><strong>premium amenities</strong></a> that meet your every need, including two outdoor swimming pools, two spacious laundry facilities, and an on-site dog park where your furry friend can play and socialize. Our upscale clubhouse is perfect for entertaining friends and family—you can even host parties and events here. Tammaron Village is where luxury living meets exceptional convenience, and we’re confident you’ll love it here.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/warrington-apartments::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Elevate your living space with upscale apartment <a href=\"/apartments/ok/oklahoma-city/warrington-apartments/amenities\"><strong>amenities</strong></a> like modern wooden cabinetry, plush carpeting, and a private balcony or patio that radiates style.<br/><br/>Enjoy the convenience of spacious closets and included washers and dryers, which streamline your daily routine. Take a refreshing dip in our sparkling pool or engage in a workout session at our state-of-the-art fitness center, which provides opportunities to unwind and stay active outside your apartment.<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Living in an apartment with a pool in Oklahoma City provides an easy way to cool off in the summer heat. Waters Edge apartments come equipped with two pools ready for you to enjoy. Our <a href=\"/apartments/ok/oklahoma-city/waters-edge-apartments/amenities\"><strong>apartment amenities</strong></a> also include community amenities such as a lakeside jogging trail, 24-hour fitness center, and a community grilling area.<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/coffee-creek::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Our thoughtfully designed residences boast premium <a href=\"/apartments/ok/owasso/coffee-creek/amenities\"><strong>amenities and features</strong></a> that make you feel instantly at home. The beautiful modern kitchens are fully equipped with essentials and adorned with stylish touches, including expansive countertops, custom cabinetry, and stainless steel appliances that maintain each home’s sleek and modern aesthetic. Outside, you’ll find our resort-style swimming pool surrounded by our well-maintained courtyard, where your friends, family, and pets can find a relaxing space to lounge comfortably.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            At Cottages at Tallgrass Point, we redefine modern living with a host of <a href=\"/apartments/ok/owasso/cottages-at-tallgrass-point/amenities\"><strong>amenities</strong></a> and comforts designed to elevate your lifestyle. Our Owasso apartments boast stylish features like designer paint colors and wood-grain ceramic tile, creating an inviting and contemporary atmosphere. Enjoy the convenience of air conditioning and ceiling fans for your comfort even on the hottest days. The fully outfitted gourmet kitchen with modern stainless steel appliances and ample cabinet space will prepare you to tackle any size meal.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cypress-crossing::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            At Cypress Crossing Apartments, convenience meets luxury with our impressive selection of <strong><a href=\"/apartments/ok/owasso/cypress-crossing/amenities\">community and in-home amenities</a></strong>. In your apartment and throughout our community, you’ll find stylish flourishes that make every day lavish. Work from home in style at our business center, enjoy quality time with your furry friend at the on-site dog park, or huddle up by your in-home fireplace with the whole family. <br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/pryor/west-530::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                             <br/>Step into your modern apartment and<strong> enjoy features like our ceramic tile floors and showers</strong>, in-apartment washers and dryers, stainless steel appliances, and stylish finishes such as granite countertops and custom cabinetry to elevate your living space.<br/> <br/>Beyond your front door, you can enjoy our beautifully maintained grounds, ample parking, and a nearby fishing pond and trail, all in a peaceful setting just minutes from downtown Pryor.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/stillwater/apple-creek-stillwater::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            In each of our Stillwater apartments, you’ll find<a href=\"/apartments/ok/stillwater/apple-creek-stillwater/amenities\"><strong> stylish features and convenient amenities</strong></a> that will make you feel right at home. Soak up the sun on your private balcony or patio, which is included in all our apartment layouts. Our opulent apartment kitchens are outfitted with granite countertops, custom cabinetry, and hardwood flooring.<br/><br/>For weekend breaks from work or studying, our community’s amenities are ideal for enjoying a day by yourself or visiting with friends and loved ones. Cool off on hot summer days in one of our two swimming pools, engage in some friendly competition at our sports court, or get cozy with a book in the cushy chairs of our resident clubhouse. Possibilities surround you at Apple Creek.<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/barrington-apartments::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            When you live at Barrington Apartments, not only will you get top-of-the-line apartment features, but you will also have access to outstanding community amenities.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cascata-luxury-apartments::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Luxury <a href=\"/apartments/ok/tulsa/cascata-luxury-apartments/amenities\"><strong>amenities</strong></a>, like designer accent walls, lush carpeting and tile flooring, and modern kitchens with stainless steel appliances, give you a stylish apartment canvas for your own furnishings. Select floor plans include a nook, ideal for a reading corner or dining alcove. Select 1 and 2 bedroom apartments include an attached garage for a speedier commute. <br/><br/>Fill your weekend with plans to explore our Tulsa apartment community. Get your morning workout at our full fitness center, which is open 24 hours for sunrise training or late-night cardio. Get some fresh air by swimming in our resort-style pool or relaxing with a good book in our cabana. Spend some quality time with your pup at our on-site dog park, where you can sit back and watch your furry friend run and play.<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-glade-apts::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Upscale <a href=\"/apartments/ok/tulsa/cedar-glade-apts/amenities\"><strong>amenities</strong></a> like a private patio or balcony, wood-style flooring, and modern cabinetry exude style, while convenient features like extra storage and washer and dryer connections simplify your daily routine. When you want to get out of your apartment, we invite you to swim in one of our sparkling pools or enjoy a complimentary cup of joe at our community coffee bar.<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Make yourself at home in one of our upscale apartments in Tulsa, outfitted with several <a href=\"/apartments/ok/tulsa/cedar-ridge-apartments/amenities\"><strong>amenities</strong></a> to elevate your living space. The fully equipped kitchen features stainless steel appliances, wood-style flooring, and a gorgeous white tile backsplash. Select apartment homes feature an LED fireplace, enhancing the cozy feeling of the space. With the intimate, open layout, you can chat with guests while you whip up a home-cooked meal or drinks.<br/><br/>You can explore our luxurious community the moment you step out your front door. Work out at our 24-hour fitness center, cool off on summer days at our swimming pool with an attached sun deck, or head to our grilling and picnic area to cook a delicious lunch. Dog owners will delight in the on-site dog park within our community, great for spending quality time with pups.<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            In our Tulsa apartment homes, you’ll find all the necessary<strong> </strong><a href=\"/apartments/ok/tulsa/chardonnay/amenities\"><strong>amenities</strong></a> to live comfortably and then some. The in-unit washer and dryer make laundry days much quicker, while the updated appliances and included dishwasher streamline meal preparation. Beyond the necessities, stylish touches elevate your space, like vaulted ceilings, a wood-burning fireplace, and a private balcony or patio.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Each apartment home stands out with a fully equipped kitchen and large bedroom closets. Step outside to enjoy our Tulsa apartments’ full range of <a href=\"/apartments/ok/tulsa/country-hollow-apartments/amenities\"><strong>amenities</strong></a>, including a pool, resident lounge, and outdoor grilling areas. Go for a stroll down our shaded walking path as you explore our community, or kick back and relax in our traditionally styled lobby with a complimentary coffee bar. With an emphasis on value and versatility, Country Hollow gives you the features you need to thrive in your new home.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/creekwood-apartments::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Find an ideal background for your daily life in one of our south Tulsa apartment homes. Every of our apartments includes <a href=\"/apartments/ok/tulsa/creekwood-apartments/amenities\"><strong>essential amenities</strong></a>, such as in-home laundry and a kitchen with a dishwasher, in-sink disposal, stove, microwave, and refrigerator. Many floor plans include extra luxuries to elevate your space, like built-in bookshelves, vaulted ceilings, and a private patio or balcony.<br/><br/>Every day, choose your own adventure when you live at Creekwood Apartments. When you want to relax, head to our heated indoor pool, sparkling outdoor pool, or sauna, or kick back next to the fireplace in our resident clubhouse. If you’d rather stay active, head to our 24-hour fitness center and work out or stroll our lush courtyards.<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/nickel-creek-apts::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Choose from a variety of apartment homes with <a href=\"/apartments/ok/tulsa/nickel-creek-apts/amenities\"><strong>premium amenities</strong></a> at Nickel Creek including 1 bedroom apartments and 2 bedroom apartments with optional fireplaces, bumpouts, and attached garages. You’ll love living in luxury with spacious closets, fully-equipped kitchens, plush carpets, move-in ready WiFi setup, and more. No matter how you choose to spend your life, Nickel Creek will equip you with the tools to make your home truly yours.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/polo-run-apartments::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/apartments/ok/tulsa/polo-run-apartments/amenities\"><strong>stylish features and convenient amenities</strong></a> throughout our Tulsa apartment homes, designed to make you feel at home. Embrace the comfort of a private balcony or patio in all our apartment layouts. All kitchens showcase sleek countertops, custom cabinetry, and hardwood floors.<br><br>You can unwind and use our community amenities alone or with loved ones any time you want. At Polo Run near Minshall Park, you can beat the summer heat in our refreshing swimming pool, work out in our state-of-the-art fitness center, or relax with a book in our resident clubhouse.<br></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Each of our Tulsa apartment floor plans at Sheridan Pond near River Oaks features expansive closets, abundant natural light streaming through large windows, and generously spaced kitchens designed for culinary exploration. Our on-site fitness center and outdoor pool provide a change of scenery when desired. Among our diverse premium <a href=\"/apartments/ok/tulsa/sheridan-pond/amenities\"><strong>amenities</strong></a>, our on-site dog park offers a convenient space for quality time with your furry companion right in the neighborhood.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Beyond the practical washer and dryer connections, Sugarberry’s Tulsa apartment residences showcase upgraded kitchens, cozy fireplaces, and elegant designer lighting. You can also relish in a range of luxurious community <a href=\"/apartments/ok/tulsa/sugarberry-apartments/amenities\"><strong>amenities</strong></a>, including cooling off in one of our two outdoor swimming pools during summer or exercising in our on-site fitness center, which is within steps of your home.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            All the <a href=\"/apartments/ok/tulsa/sunchase-apartments/amenities\"><strong>amenities</strong></a> required for your daily activities await you inside your south Tulsa apartment. In our upscale apartments, you’ll find well-appointed kitchens with dishwashers, refrigerators, and other essentials. Within our community, you can enjoy a refreshing swim in the outdoor pool, relax in the inviting clubhouse, or exercise in the 24-hour fitness center.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Our 1 and 2 bedroom apartment homes feature an impressive list of <a href=\"/apartments/ok/tulsa/the-courtyards/amenities\"><strong>amenities</strong></a> that will make you feel right at home. The fully equipped kitchen includes all the appliances you need for meal preparation, and the expansive closets and extra storage throughout our apartments ensure that all your belongings have their own place. Luxurious extras are also available in select apartment homes, like wood-burning fireplaces, vaulted ceilings, and private balconies or patios. <br/><br/>Beyond our apartment homes, luxury living continues as you explore our community. You’ll be greeted by amenities like the sparkling outdoor pool and sun deck, 24-hour fitness center, and beautiful event kitchen with complimentary coffee.<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our Tulsa apartment homes come equipped with all the essential <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/apartments/ok/tulsa/the-greens-of-bedford/amenities\"><strong>amenities</strong></a> you’ll need daily. A washer and dryer are standard across all our floor plans, making laundry day quicker and easier. All the essential amenities in your kitchen are there to help you cook delicious home-cooked meals. In the living and dining area, a large bay window lets in refreshing natural light.&nbsp;<br><br>Around our apartment community in Tulsa, you’ll find amenities that will complement your daily routine, including a fitness center, an on-site dog park, and a sparkling outdoor pool. When you feel like mingling with your neighbors or inviting over friends, head to our cozy clubhouse and kick back on the couch or chat over coffee from the event kitchen.<br></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Windsail’s apartment residences feature <a href=\"/apartments/ok/tulsa/windsail-apartments/amenities\"><strong>amenities</strong></a> designed to enhance your daily routine. Our apartments include a full kitchen, which simplifies meal preparation, and a patio or balcony, adding a touch of sophistication to your living space.<br/><br/>With a wealth of amenities throughout Windsail, you have numerous options to fill your day. Enjoy a refreshing dip in the swimming pool during warm summer days, or ensure your furry companion stays joyful and active at the community dog park.<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            In each of our west Oklahoma City apartments at The Park on Westpointe, you’ll discover a blend of stylish features and practical <a href=\"/apartments/ok/yukon/park-at-westpointe/amenities\"><strong>amenities</strong></a><strong> </strong>that seamlessly blend a modern style with highly functional living spaces. Enjoy the serenity of your private balcony or patio, available in our 1 and 2 bedroom apartments, offering an ideal spot to soak in the sun or sip your morning brew. Outside, you can cool off in our community pool or have a cookout with friends and family in our barbecue and picnic areas, along with many other community features that elevate your living experience.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/the-ridge-@-66::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            From our 24-hour fitness center to our resort-style swimming pool, <a href=\"/apartments/ok/yukon/the-ridge-66/amenities\"><strong>every feature</strong></a> is designed to elevate your everyday living experience within our apartments near Oklahoma City, OK. Enjoy the convenience of our on-site dog park for your furry friends and take advantage of our resident clubhouse and poolside cabanas for social gatherings and events at our luxury apartments.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/the-ridge-66::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            From our 24-hour fitness center to our resort-style swimming pool, <a href=\"/apartments/ok/yukon/the-ridge-66/amenities\"><strong>every feature</strong></a> is designed to elevate your everyday living experience within our apartments near Oklahoma City, OK. Enjoy the convenience of our on-site dog park for your furry friends and take advantage of our resident clubhouse and poolside cabanas for social gatherings and events at our luxury apartments.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Our Amarillo, TX, apartments for rent feature relaxed and stylish living spaces fully outfitted with <a href=\"/apartments/tx/amarillo/newport-amarillo-apts/amenities\"><strong>everything you want in your next home</strong></a>. Each apartment rental is washer and dryer ready with easily accessible connections, plush carpeting, and options for a personal patio or balcony. Select apartments also include ample built-in shelving, and an in-home fireplace. Outside the apartments for rent, you’ll find our outdoor courtyard with shaded grilling and dining spaces, a private community swimming pool, and our ever-popular Bark Park so everyone, pets included, can enjoy their new home at Newport Apartments.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            You’ll find everything you need to live a comfortable life in your Park at Coulter apartment home with premium <a href=\"/apartments/tx/amarillo/park-at-coulter/amenities\"><strong>amenities and features</strong></a> across our entire floor plan lineup. Your gourmet kitchen comes complete with stainless steel appliances, copious storage space, and a barstool-ready countertop to create a versatile cooking and entertainment space. Couple these features with plush carpeting, vaulted ceilings, and outdoor amenities that cater to you and your pets, and you will quickly discover why Park at Coulter is among Amarillo’s favorite places to settle.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            At Remington Apartments, we believe in providing our residents with <a href=\"/apartments/tx/amarillo/remington-amarillo-apts/amenities\"><strong>the best amenities</strong></a> possible. Enjoy a fully equipped kitchen for all your culinary adventures. Stay connected with high-speed internet provided by AT&amp;T. And with ample storage space and cable-ready units, we’ve thought of everything to make your life easier.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            You can live in luxury and convenience in southwest Amarillo with 1 and 2 bedroom apartments at the Colonies at Hillside. Start your day at Colonies at Hillside by swimming in our resort-inspired pool and beating the summer heat. <br/>Browse our luxury <a href=\"/apartments/tx/amarillo/the-colonies-at-hillside/amenities\"><strong>apartment amenities</strong></a>, including our 24-hour fitness center, picnic and barbecue areas, and garages. Take advantage of this by <a href=\"/apartments/tx/amarillo/the-colonies-at-hillside/contact-us\"><strong>scheduling a tour</strong></a> at Colonies at Hillside today. Our apartments are also pet-friendly for those with furry friends, allowing everyone in your family to enjoy their Colonies at Hillside apartment home.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Discover a range of upscale <a href=\"/apartments/tx/amarillo/winchester-apartments/amenities\"><strong>amenities</strong></a> within our 1, 2, and 3 bedroom apartment homes designed to give you a sense of belonging. Embrace the fully equipped kitchen with all the necessary appliances for seamless meal preparation. Additionally, enjoy ample storage space, including spacious closets that cater to your organizational needs.<br/><br/>Select apartments showcase luxury elements like wood-burning fireplaces, vaulted ceilings, hardwood floors, and ceiling fans. Discover our community’s amenities, including a swimming pool, 24-hour fitness center, and grilling areas.<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/acacia-park-apts::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            When you choose to live at Acacia Park, you’ll gain access to an impressive list of <a href=\"/apartments/tx/el-paso/acacia-park-apts/amenities\"><strong>luxury amenities</strong></a>. Break a sweat at our on-site fitness center, dip in the pool, or take your family to the community playground—it’s all here at Acacia Park Apartments. At our West El Paso apartment community, you’ll also find an on-site dog park, community basketball court, barbeque area, and much more.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/chimneys-apts::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            When searching for an apartment to rent in El Paso, it’s essential to consider the <a href=\"/apartments/tx/el-paso/chimneys-apts/amenities\"><strong>amenities</strong></a> you need before moving in. At The Chimneys Apartments, we have an extensive line of community and residential amenities for our tenants to use. From our fitness center and pool to carpeting and air conditioning, live life with maximum comfort by utilizing our amenities at our apartment community in northwest El Paso.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Living at Double Tree is like staying at a resort, with a sparkling swimming pool and professional landscaping. We have ample <a href=\"/apartments/tx/el-paso/double-tree-apts/amenities\"><strong>amenities</strong></a> to benefit everyone, from our outdoor pool and spacious sun deck to our shaded barbecue and picnic area. You can also visit the on-site business center when you need to work from home or answer emails while out of the office. <br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Our upscale apartments in El Paso have several <a href=\"/apartments/tx/el-paso/high-ridge-apts/amenities\"><strong>apartment and community amenities</strong></a> to ensure an excellent experience for all our tenants. Spend your days breaking a sweat at our apartment’s full fitness center with free weights and fitness machines, or lounge by our beautiful outdoor pool and spa. It’s all included here at High Ridge Apartments, where our luxury amenities meet your every need.<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/mountain-village-apts::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Living at Mountain Village means living in a <a href=\"/apartments/tx/el-paso/mountain-village-apts/amenities\"><strong>luxurious and comfortable community</strong></a> with several amenities and benefits. Are you looking to cool off from the hot Texas sun? Take a dip in one of our two swimming pools. You can also take your furry friends to our dog park and self-service pet station or squeeze in a quick workout at our 24-hour fitness center. The possibilities are endless!<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/patriot-apts::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            In every one of our El Paso apartment floor plans, you’ll enjoy spacious closets, natural light from the big windows, and a full kitchen, perfect for trying new recipes. For those times when you need to get out of the apartment, enjoy a workout in our 24-hour fitness center or a swim in our lap-sized pool. If you’re a dog owner, you’ll love the convenience of our on-site dog park, where you can play with your pup without leaving the neighborhood—just one of our many <a href=\"/apartments/tx/el-paso/patriot-apts/amenities\"><strong>amenities</strong></a>.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/phoenix-apts::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            In our comfortable El Paso apartments, you’ll find all the <a href=\"/apartments/tx/el-paso/phoenix-apts/amenities\"><strong>amenities</strong></a> you’ll need as you go about your daily routine. Inside our apartment homes, you’ll find full kitchens outfitted with a dishwasher, stove, resurfaced countertops, and more. Around our secure, gated community, you can enjoy blissful dips in the pool, unwinding in our resident clubhouse, or a good workout in our cardio fitness center. <br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/shadow-ridge-apts::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            At Shadow Ridge, take advantage of our expansive line of upscale <a href=\"/apartments/tx/el-paso/shadow-ridge-apts/amenities\"><strong>apartment amenities</strong></a> across our community. Whether you spend your day by our poolside or take your kids to the playground, we’ll help satisfy your recreational and personal apartment living needs. In addition to fun for the family, our pet-friendly apartment homes have amenities for the comfort of your furry friend, such as an on-site bark park. <br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Our El Paso apartments offer warmth and comfort around every corner and can suit a wide variety of lifestyles. Our private patios and balconies invite you to enjoy watching the sun rise and set over the majestic Franklin Mountain, while wood-burning fireplaces beckon you to cozy up with a mug of hot cocoa whenever the weather turns chilly.<br/><br/>Beyond our cozy apartment homes, you’ll enjoy excellent <a href=\"/apartments/tx/el-paso/the-crest/amenities\"><strong>amenities</strong></a> throughout our welcoming El Paso apartment community. Relish your time with family and friends splashing around in our sparkling pool or shooting hoops at our community basketball court. Plus, our on-site fitness center makes exercising and staying active a breeze. <br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/hewitt/icon-at-hewitt::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            At Icon at Hewitt, we offer a vast array of community and residential <a href=\"/apartments/tx/hewitt/icon-at-hewitt/amenities\"><strong>amenities</strong></a> for your convenience and recreation. Our luxurious amenities are second to none, from our fitness center, resort-style pool, and dog park to a night on your private patio or balcony.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Each of our Lubbock apartments is outfitted with <a href=\"/apartments/tx/lubbock/cottages-at-abbey-glen/amenities\"><strong>modern and cozy features</strong></a>, like plush carpeting, ceramic tile, and designer colors. Alongside our luxury apartments, you’ll find a wide range of community amenities, including a pool, grilling area, on-site dog park, and more. We also offer apartments with a garage for maximum privacy.<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Remember to prioritize your desired <a href=\"/apartments/tx/lubbock/icon-at-lubbock/amenities\"><strong>amenities</strong></a> when looking for apartment rentals in southwest Lubbock. The Icon at Lubbock has many community and residential amenities tailored to our tenants’ needs. We have everything you need at our southwest Lubbock, TX, luxury apartments, including a swimming pool, 24-hour fitness center, garages, and an on-site dog park. Find the right pet-friendly apartment in Lubbock, TX, that fits your budget at The Icon at Lubbock.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Our Lubbock apartment homes offer resort-style living, complete with <a href=\"/apartments/tx/lubbock/tuscany-place/amenities\"><strong>numerous amenities</strong></a>. In our 1 and 2 bedroom apartments in Lubbock, you’ll find full kitchens with stainless steel appliances and central air and heating for comfortable living year-round. We also offer wheelchair-accessible apartment homes. <br/><br/>At our Tuscany Place upscale Lubbock apartments, we offer many amenities to residents. Fitness enthusiasts especially love our 24-hour access gym, featuring treadmills, free weights, and cable machines. When summer temperatures skyrocket, you’ll find many of our residents cooling off in our outdoor swimming pool or working on their tan on our sun deck. <br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/temple/portico-at-friars-creek-apts::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Our apartment <a href=\"/apartments/tx/temple/portico-at-friars-creek-apts/amenities\"><strong>amenities</strong></a> include more than just a well-equipped apartment home in Temple, TX. The Portico at Friars Creek community features a wide range of residential and community amenities, so you can take advantage of the vibrant area around you. Whether it’s a day relaxing by our pool or a workout at our fitness center, you can reap the benefits of our many amenities when you rent an apartment with us. If you are looking for pet-friendly apartments in Temple, TX, you’ve come to the right place!<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            When you live at the Bend at New Road, luxury is more than just a word, it’s a way of life. You’ll love our <a href=\"/apartments/tx/waco/bend-at-new-road/amenities\"><strong>amenities</strong></a> in your apartment and in our community. In our Waco, TX, townhomes and luxury apartments, you’ll find nine-foot ceilings, oversized closets, and central heat and air conditioning.<br/><br/>Enjoy living in our Waco luxury apartments with a fitness center, resort-style pool, and so much more. If you are looking for pet-friendly apartments in Waco, TX, you have come to the right place. The community amenities you’ll enjoy at our apartments in south Waco also include an on-site dog park, an internet cafe with complimentary coffee and tea, and much more.<br/> </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/tuscany-ranch-apartments::propertyamenities.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"mb-20 text-sm-center\">\n                            Why settle for less when our upscale apartments in Waco, TX, offer the high-end <a href=\"/apartments/tx/waco/tuscany-ranch-apartments/amenities\"><strong>amenities</strong></a> in town? Our pet-friendly apartments in Waco, TX, come with an array of amenities such as stainless-steel appliances, washer and dryer connections, and spacious closets, our quality features better enhance your living experience in our upscale and pet-friendly apartments in south Waco.                        </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/maize/watercress-apartments::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Watercress Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Aspen Park Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at the Cottages at Crestview",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/crown-chase-apts::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Crown Chase",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/huntington-park::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Huntington Park",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/newport-wichita-apts::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Newport Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/portofino::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Portofino Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/raintree-apartments::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Raintree Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/remington-wichita::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living in The Remington Apartment Homes",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/silver-springs-apts::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living in Silver Springs",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living in Villas of Waterford Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/independence/the-adirondack::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Adirondack Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/97-north-oak::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at 97 @ North Oak",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/trace-apts::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at The Trace of Ridgeland",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Trails at Aspen Creek in Broken Arrow, OK",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/fountain-lake::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Fountain Lake",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Villas at Stonebridge",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/moore/mission-point::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Mission Point",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/artisan-crossing-apts::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Artisan Crossing",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Cimarron Trails",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/24hundred-apartments::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at 24Hundred in Oklahoma City, OK",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/chisholm-pointe::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Chisholm Pointe",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Cimarron Pointe",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Council Place",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Cross Timber",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Crown Pointe",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter's-ridge-apts::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Hunter’s Ridge",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/park-at-tuscany::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Park at Tuscany",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/persimmon-square-apartments::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Persimmon Square",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Prairie Springs",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/stonehorse-crossing::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Stonehorse Crossing",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summerfield-place-apts::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Summerfield Place",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/tammaron-village-apartments::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Tammaron Village",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/warrington-apartments::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at the Warrington Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Waters Edge Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/coffee-creek::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living in Coffee Creek Luxury Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at The Cottages at Tallgrass Point",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/barrington-apartments::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently asked questions about apartment living at Barrington Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cascata-luxury-apartments::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently asked questions about apartment living at Cascata Luxury Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-glade-apts::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently asked questions about apartment living at Cedar Glade Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living in Cedar Ridge Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living in Chardonnay Apartment Homes",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living in Country Hollow Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at The Park at Westpointe",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/the-ridge-@-66::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at The Ridge @ 66",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/hewitt/icon-at-hewitt::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at The Icon at Hewitt",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Icon at Lubbock in Lubbock, TX",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/temple/portico-at-friars-creek-apts::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Portico at Friars Creek in Temple, TX",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Bend at New Road",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/tuscany-ranch-apartments::propertyfaq.dropdown_heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Tuscany Ranch in Waco, TX",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Arbors of Pleasant Valley, we understand that one size doesn’t fit all. That’s why we offer a variety of 1, 2, and 3 bedroom apartment homes to suit your individual needs. Our spacious and well-designed floor plans are ideal for singles, couples, families, and anyone in between. With high ceilings and a private patio, you’ll find your apartment radiates an open and airy atmosphere, making you feel right at home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/north-little-rock/lexington-park::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>No matter which of our <a href=\"/apartments/ar/north-little-rock/lexington-park/floor-plans\"><strong>six unique floor plans</strong></a> you select, each of our 1, 2, and 3 bedroom apartment homes offers tons of space to live comfortably. Our smallest apartment home still provides a whopping 810 sq. ft. of space, while our largest 3 bedroom apartment boasts 1,280 sq. ft. of room. Each of our North Little Rock apartments features an open-concept living area that connects to a charming dining nook, an ideal layout for hosting family dinners or get-togethers.</p>\n<p>Ready to take the first step toward a relaxing life at Lexington Park? <a href=\"/apartments/ar/north-little-rock/lexington-park/contact-us\"><strong>Schedule a tour</strong></a> of our apartment homes in North Little Rock and experience the serene beauty of Lexington Park firsthand. Our friendly leasing staff will be delighted to show you around our community, but if you’d prefer to tour independently, we also offer <strong><a href=\"https://app.tour24now.com/prospect/tour/lexington-park/register/\" target=\"_blank\">self-guided tours</a></strong>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/maize/watercress-apartments::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover our expansive, thoughtfully planned apartments with seamless open-concept designs within our community. Select a <a href=\"/apartments/ks/maize/watercress/floor-plans\"><strong>floor plan</strong></a> that aligns with your unique lifestyle. Enhance your living experience with attached garages for added convenience. Specific layouts boast versatile spaces adjacent to the living area, ideal for creating a cozy reading nook, dining space, or even a stylish wet bar.</p>\n<p><a href=\"/apartments/ks/maize/watercress/contact-us\"><strong>Schedule a tour</strong></a>, and our attentive team will guide you through our Maize apartment community and present our distinctive floor plans. You can also opt for a <a href=\"/apartments/ks/maize/watercress/self-guided-tour\"><strong>self-guided tour</strong></a> to explore at your own pace. Delight in the dynamic lifestyle at Watercress Apartments, featuring contemporary features and convenient amenities.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Whether you’re searching for a versatile studio apartment in Wichita or something a bit more spacious, one of our <a href=\"/apartments/ks/wichita/aspen-park-apartments/floor-plans\"><strong>five distinct floor plans</strong></a> will surely work for you. Each of our floor plans is thoughtfully designed to provide comfort and convenience. Many of our layouts feature an open-concept dining space, kitchen, and living area, giving you more space for furniture and decor. </p>\n<p>Experience the comfort and luxury of Aspen Park firsthand by <strong><span style=\"text-decoration: underline;\"><a href=\"#schedule-a-tour\">scheduling a tour</a></span></strong> of our apartments in Wichita. One of our friendly residential staff members will guide you through our community, answering any questions you may have. Would you prefer to explore our apartments at your own pace? You can schedule a <strong><span style=\"text-decoration: underline;\"><a href=\"https://app.tour24now.com/prospect/tour/aspen-park/register/\" target=\"_blank\">self-guided tour</a></span></strong> of our Wichita apartments!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Each of our spacious <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/apartments/ks/wichita/cottages-at-crestview/floor-plans#/\"><strong>apartment floor plans</strong></a> was designed with care and attention to detail, ensuring comfortable living for a variety of lifestyles. We offer apartments and lofts in Wichita so you can select which suits your needs. Among our floor plans, you’ll also find bumpout options that feature an included nook off the living room to accommodate a dining room table and chairs or a reading corner.</p><p>We encourage you to schedule a tour of our apartments in Wichita to see if Cottages at Crestview is a good fit for you. One of our leasing professionals will be delighted to show you around our community. However, if you’d prefer to explore our Wichita apartments at your own pace, we also offer a <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/apartments/ks/wichita/cottages-at-crestview/self-guided-tour\"><strong>self-guided tour option</strong></a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/crown-chase-apts::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our thoughtfully designed <a href=\"/apartments/ks/wichita/crown-chase-apts/floor-plans\"><strong>1 and 2 bedroom apartment floor plans</strong></a> ensure harmonious living, with an open-concept living and dining area that flows into your full kitchen. Several of our floor plans feature a water view from your private balcony or patio, allowing you to take in the lush surroundings and relax. We also offer apartments with a fireplace, ideal for cozying up on chilly days.</p>\n<p>We invite you to <a href=\"/apartments/ks/wichita/crown-chase-apts/contact-us\"><strong>schedule a tour</strong></a> of Crown Chase Apartments in Wichita and let our friendly leasing staff show you around. If you’d prefer to explore Crown Chase on your own, you can <a href=\"/apartments/ks/wichita/crown-chase-apts/contact-us\"><strong>schedule a self-guided tour instead</strong></a>. We look forward to welcoming you home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/huntington-park::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Creating your own paradise is easy with our selection of <a href=\"/apartments/ks/wichita/huntington-park/floor-plans\"><strong>1 and 2 bedroom apartments</strong></a> at Huntington Park. Our thoughtfully designed apartment homes offer 640 to 990 sq. ft. of space and feature a private balcony or patio for relaxing with loved ones in the evening or watching the sunrise in the morning.</p>\n<p>Ready to get a firsthand look at Huntington Park Apartments in Wichita? <a href=\"#schedule-a-tour\"><strong>Schedule a tour of our Wichita apartment community</strong></a>, and our leasing staff will be delighted to show you around. If you’d rather explore Huntington Park on your own, we also offer <strong><a href=\"https://app.tour24now.com/prospect/tour/huntington-park/register/\" target=\"_blank\">a self-guided tour option</a></strong> for your convenience. We look forward to showing you everything Huntington Park has to offer.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/newport-wichita-apts::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Shape your space to reflect your lifestyle in one of our <a href=\"/apartments/ks/wichita/newport-wichita-apts/floor-plans\"><strong>1 and 2 bedroom apartments</strong></a>, ranging from 730 sq. ft. to 1,040 feet, with the options for a patio, vaulted ceiling, and a working fireplace. Our floor plans are designed with openness in mind to give you ample room to work, relax, and thrive in your apartment.</p>\n<p>Visit Newport Apartments to get a firsthand view of everything our welcoming community offers. Our friendly and knowledgeable staff members will show you each detail of the outside and indoors we offer, so please reach out to <a href=\"/apartments/ks/wichita/newport-wichita-apts/contact-us\"><strong>schedule a tour</strong></a>. If you’d prefer to explore independently,<strong><a href=\"https://app.tour24now.com/prospect/tour/newport-wichita/register/\" target=\"_blank\"> self-guided tours</a></strong> are welcome and easy to schedule. When you are ready to make your new home in Newport Apartments, all you have to do is complete our <a href=\"https://newportapartmentswichita.securecafe.com/onlineleasing/newport-wichita-apts/register.aspx\" target=\"_blank\"><strong>online rental application</strong></a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/portofino::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from a variety of spacious floor plans at Portofino Apartments. Our thoughtfully designed <a href=\"/apartments/ks/wichita/portofino/floor-plans\"><strong>1 and 2 bedroom layouts</strong></a><strong> </strong>offer plenty of room to live and entertain, with features like oversized closets, private balconies or patios, and in-unit washer and dryer connections. Whether you’re looking for a cozy 1 bedroom retreat or a spacious 2 bedroom haven, you’ll find the ideal space to call home at Portofino.</p>\n<p><a href=\"/apartments/ks/wichita/portofino/contact-us\"><strong>Schedule a personal tour</strong></a> of our upscale apartment community today. Our friendly and knowledgeable staff will be delighted to show you around, answer any questions, and help you envision your future home in Wichita. Whether you’re interested in exploring our stunning apartment interiors, experiencing our resort-style amenities, or simply soaking in the tranquil atmosphere of our community, you will find them all in your Portofino apartment home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/raintree-apartments::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Raintree offers a diverse selection of apartment homes tailored to your lifestyle, with sizes ranging from 500 sq. ft. to over 900 sq. ft. Our apartment <a href=\"/apartments/ks/wichita/raintree-apartments/floor-plans\"><strong>floor plans</strong></a> feature spacious living and dining areas, perfect for indulging in binge-worthy TV shows or hosting enjoyable movie nights with friends. The open layout creates an ideal setting for entertaining, as the kitchen and dining areas harmoniously meld together, facilitating seamless dinner parties and gatherings.</p>\n<p>Experience life at Raintree Apartments by <a href=\"/apartments/ks/wichita/raintree-apartments/contact-us\"><strong>scheduling a tour</strong></a> with our welcoming leasing team. Alternatively, you can opt for a <strong><a href=\"https://app.tour24now.com/prospect/tour/raintree/register/\" target=\"_blank\">self-guided tour</a></strong> to explore our west Wichita apartment community at your own pace. Once you’re ready to make Raintree your home, complete the online <a href=\"https://raintreeapartmentswichita.securecafe.com/onlineleasing/raintree-apts/register.aspx\" target=\"_blank\"><strong>rental application</strong></a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/remington-wichita::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our diverse selection of thoughtfully crafted <a href=\"/apartments/ks/wichita/remington-wichita/floor-plans\"><strong>1 and 2 bedroom apartment layouts</strong></a> tailored to enhance your lifestyle. Many of our residences feature private balconies or patios, ideal for showcasing plants or crafting a cozy reading spot. Embrace the opportunity to curate your tranquil haven within the suburban setting of Wichita, allowing you to unwind and savor life’s simple pleasures.</p>\n<p><a href=\"/apartments/ks/wichita/remington-wichita/contact-us\"><strong>Schedule a tour</strong></a>, and we’ll guide you through our Wichita apartment complex. For those who prefer a <strong><a href=\"https://app.tour24now.com/prospect/tour/the-remington/register/\" target=\"_blank\">self-guided tour</a></strong>, arrange a visit at your convenience. When you’re ready to make The Remington Apartments your new home, submit your <a href=\"https://remingtonapartmentswichita.securecafe.com/onlineleasing/remington-wichita-apts/register.aspx\" target=\"_blank\"><strong>rental application online</strong></a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/silver-springs-apts::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover a range of living options at Silver Springs, featuring studio, 1, and 2 bedroom apartment homes tailored to your lifestyle, offering between 500 and 950 sq. ft. Within each <a href=\"/apartments/ks/wichita/silver-springs-apts/floor-plans\"><strong>floor plan</strong></a>, spacious living and dining areas provide the perfect setting for enjoying your favorite shows or hosting movie nights with friends. The open layout design allows for seamless transitions from the kitchen to the dining area during dinner parties, enhancing the overall social experience.</p>\n<p><a href=\"/apartments/ks/wichita/silver-springs-apts/contact-us\"><strong>Schedule a tour</strong></a> with our welcoming leasing team for a Silver Springs Apartments tour, which will give you a glimpse into the lifestyle here. If you prefer a more independent exploration, feel free to embark on a <a href=\"/apartments/ks/wichita/silver-springs-apts/self-guided-tour\"><strong>self-guided tour</strong></a> of our Wichita apartment community. When you’re ready to make Silver Springs your home, complete and submit your <a href=\"https://silverspringsapartmentswichita.securecafe.com/onlineleasing/silver-springs-apts/register.aspx\" target=\"_blank\"><strong>rental application online</strong></a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our Wichita apartment community is the perfect place for you to call home. With <a href=\"/apartments/ks/wichita/villas-of-waterford/floor-plans\"><strong>four unique floor plans</strong></a>, we have outstanding options for any lifestyle, from our serene 1 bedroom to spacious 2 bedrooms. Our 1 bedroom apartment homes feature open-concept living and dining spaces with a breakfast bar in the kitchen. See why our community is the finest choice for your next home in Wichita.</p>\n<p>Our lavish 2 bedroom apartments at the Villas of Waterford Apartments are thoughtfully designed to provide ample open-concept living space, ideal for relaxing with your furry friend on the sofa or hosting gatherings with family and friends. The two full bathrooms and spacious closets make our 2 bedroom apartment homes perfect for having a roommate or a guest room when family visits.</p>\n<p>Explore our pet-friendly apartment community in Wichita, which offers a lifestyle like no other, with luxury amenities designed to radiate comfort and sophistication. Experience it for yourself. <a href=\"/apartments/ks/wichita/villas-of-waterford/contact-us\"><strong>Schedule a tour</strong></a> today to explore our numerous community amenities. Peruse our <a href=\"/apartments/ks/wichita/villas-of-waterford/photos\"><strong>photo gallery</strong></a> online for a 360° virtual tour to discover the Villas of Waterford and all it offers!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/belton/center-301::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Step inside your new luxury 1 or 2 bedroom apartment, loft or townhome at Center 301 Apartments and bask in the exceptional. Each floor plan is purposefully designed to complement your daily routine. Whether hosting a large dinner party or grabbing a morning snack on the go, your <a href=\"/apartments/mo/belton/center-301/amenities\"><strong>gourmet-style kitchen</strong></a> comes with an energy-efficient appliance package to ensure that no culinary task is too great. And with garages available, you’ll never have to worry about scraping ice off your windshield during chilly Missouri mornings.</p>\n<p>We invite you to <a href=\"#schedule-a-tour\"><strong>schedule a tour</strong></a> and come and experience Center 301 for yourself. A courteous and helpful staff member will guide you through our apartment community, showing you our apartment homes and first-rate amenities. When you’re ready to call Center 301 home, complete a <a href=\"https://center301apartmentsbelton.securecafe.com/onlineleasing/center-301/register.aspx\" target=\"_blank\"><strong>rental application</strong></a> online. We look forward to welcoming you home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/independence/the-adirondack::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At our luxury apartments in Independence, you’ll find brand-new <a href=\"/apartments/mo/independence/the-adirondack/floor-plans\"><strong>1 and 2 bedroom floor plans</strong></a> with all the apartment amenities you could ask for, from washer and dryer connections to the option for an attached or detached garage. Whether you want a cozy space for yourself or a more expansive abode to create the office or creative space you’ve always wanted, we have a unique floor plan for every lifestyle at The Adirondack Apartments.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/152-northland::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We offer nine unique floor plans at 152 Northland with one- and two-story options available so you can choose a home that suits your needs and lifestyle. For those living on their own or with a significant other, our 1 bedroom apartments in Kansas City offer enough space to feel comfortable without breaking the bank. If you have a roommate or want a home office, our 2 bedroom apartments in Kansas City are spacious enough to accommodate any design vision.</p>\n<p>You’ll love coming home each day when you live at 152 Northland. Don’t take our word for it, though—come see it for yourself! Schedule a tour today to explore 152 Northland solo or with our friendly leasing staff, who are excited to show you why we’re so proud of our community and answer any questions.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/97-north-oak::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>With <a href=\"/apartments/mo/kansas-city/97-north-oak/floor-plans#/\"><strong>nine distinctive floor plans</strong></a>, you’ll easily find the right fit for your needs. Perhaps you’d prefer our spacious 1 bedroom, 1 bathroom floor plan, featuring an expansive bedroom, a roomy bathroom with a tub, and a cozy living room area with an optional LED fireplace. Or you may prefer our roomy 2 bedroom loft apartment, boasting huge closets, a private balcony or patio, lots of natural light, and an attached garage.</p>\n<p>Ready to experience our Kansas City apartment community firsthand? Take the next step and <a href=\"#schedule-a-tour\"><strong>schedule a tour with us</strong></a>. Explore 97 @ North Oak with our friendly leasing staff, who will be happy to answer any questions you may have about our Kansas City luxury apartments. <br/>Would you prefer to tour our luxury apartments solo? We also offer a <a href=\"https://app.tour24now.com/prospect/tour/97-north-oak/register/\" target=\"_blank\"><strong>self-guided tour</strong></a> option, allowing you to explore at your own pace.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/mark-apts::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Mark Apartments offers spacious 1 bedroom and 2 bedroom apartments in Ridgeland, MS. We have two <a href=\"/apartments/ms/ridgeland/mark-apts/floor-plans\" rel=\"sponsored nofollow\"><strong>floor plans</strong></a> available to choose from, with our 1 bedroom apartments in Ridgeland measuring at 850 sq. ft. and our 2 bedroom apartment homes coming in at 1,100 sq ft. Both options come with a private balcony or patio space, making them perfect for enjoying quiet winter mornings, warm summer nights, and everything in between.</p>\n<p>Staying at The Mark Apartments opens the door to comfortable and easy living. Located conveniently close to I-55 and I-220 in Ridgeland, one of Jackson’s top suburbs, we’re an inviting community for those from all backgrounds. <a href=\"#schedule-a-tour\"><strong>Schedule your tour</strong></a> online today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/sunchase-ridgeland-apts::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Sunchase Ridgeland Apartments, you’ll discover a wide range of studio, 1 , and 2 bedroom apartments. Ranging from 500 sq. ft. to 925 sq. ft. in size, our comfortable and cozy <a href=\"/apartments/ms/ridgeland/sunchase-ridgeland-apts/floor-plans\"><strong>floor plans</strong></a> offer the perfect space for different needs. With well-equipped kitchens and private balconies, find your perfect Ridgeland apartment here with us. </p>\n<p>We’re ready to welcome you into our luxury apartment community at Sunchase Ridgeland. To begin your Ridgeland apartment experience, give our team a <a href=\"tel:6012929306\"><strong>call</strong></a> or <a href=\"/apartments/ms/ridgeland/sunchase-ridgeland-apts/contact-us\"><strong>schedule your initial tour</strong></a> online today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/the-pointe-of-ridgeland::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><a href=\"/apartments/ms/ridgeland/the-pointe-of-ridgeland/floor-plans\"><strong>Our 1, 2, and 3 bedroom apartment homes</strong></a> are thoughtfully designed to cater to your unique needs. Whether you’re a young professional, a small family, or someone looking for the perfect space to call home, we have the floor plan to suit your lifestyle. Each apartment boasts private outdoor patios or balconies, providing you with a relaxing space to unwind and soak in the beautiful Mississippi scenery.</p>\n<p>Don’t miss the opportunity to experience the comfort, convenience, and charm of The Point of Ridgeland Apartments. <a href=\"/apartments/ms/ridgeland/the-pointe-of-ridgeland/contact-us\"><strong>Schedule your tour now</strong></a>, and take the first step towards making The Point of Ridgeland Apartments your perfect sanctuary. Your dream home is just a tour away!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We offer six distinct <a href=\"/apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/floor-plans\"><strong>1 and 2 bedroom apartment floor plans</strong></a>, offering anywhere from 790 to 1,270 sq. ft. of living space. Each of our layouts is thoughtfully designed with plenty of room for comfortable living. We also offer spacious lofts in Broken Arrow, featuring an attached garage option for optimal convenience.</p>\n<p><a href=\"/apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/contact-us\"><strong>Schedule a tour</strong></a> and experience the luxurious comfort of Icon at Broken Arrow firsthand. Our friendly leasing staff will be delighted to show you around, but we also offer a <strong><a href=\"https://app.tour24now.com/prospect/tour/icon-at-broken-arrow/register/\" target=\"_blank\">self-guided tour</a></strong> if you’d prefer to explore independently. Once you’re ready to call Icon at Broken Arrow home, simply complete an <a href=\"https://iconatbrokenarrowapartments.securecafe.com/onlineleasing/icon-at-broken-arrow-apartments/register.aspx\" target=\"_blank\"><strong>online rental application</strong></a>. We look forward to welcoming you home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Park at Mission Hills gives you the space and flexibility to create the ideal living environment. Our versatile <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/apartments/ok/broken-arrow/park-at-mission-hills/floor-plans\"><strong>open-concept floor plans</strong></a> are designed to allow you to efficiently use all the interior space without sacrificing comfort. With our surprisingly spacious 1 bedroom, 1 bath apartments and our popular 2 bed, 2 bath options, there is a fit for everyone’s lifestyle.</p><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/apartments/ok/broken-arrow/park-at-mission-hills/contact-us\"><strong>Tour The Park at Mission Hills</strong></a> to envision your life in a luxury community. Our neighborly community and staff are eager to help you feel at home and ready to answer all your questions as you explore the property. <a target=\"_blank\" rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://app.tour24now.com/prospect/tour/park-at-mission-hills/register/\"><strong>Self-guided tours</strong> </a>are also available to suit your personal preferences, and of course, we are always happy to <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"tel:918-518-0156\"><strong>take your call</strong></a> to help you learn everything you need to know about living at The Park at Mission Hills.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/redbud-ranch::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience the ideal living space tailored to your needs with our array of 1, 2, and 3 bedroom apartments in North Broken Arrow. Each of our <a href=\"/apartments/ok/broken-arrow/redbud-ranch/floor-plans\"><strong>floor plans</strong></a> offers unmatched comfort and convenience. Select one of our apartments featuring a fireplace, adding extra warmth and comfort, perfect for chilly days. The open-concept kitchen and dining area are ideal for dinner parties or gatherings with friends.</p>\n<p>Discover if Redbud Ranch is a match for you by <a href=\"/apartments/ok/broken-arrow/redbud-ranch/contact-us\"><strong>scheduling</strong></a><strong><a href=\"/apartments/ok/broken-arrow/redbud-ranch/contact-us\"> </a></strong><a href=\"/apartments/ok/broken-arrow/redbud-ranch/contact-us\"><strong>a visit</strong></a> to our North Broken Arrow apartment community. Our amiable staff can accompany you and provide a guided tour of our vibrant community and inviting apartment homes. If you’d instead explore independently, <a href=\"/apartments/ok/broken-arrow/redbud-ranch/self-guided-tour\"><strong>schedule a self-guided tour</strong></a> to leisurely wander through Redbud Ranch at your own pace.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the ideal living space at Scissortail Crossing in north Broken Arrow, with a wide range of <a href=\"/apartments/ok/broken-arrow/scissortail-crossing/floor-plans\"><strong>floor plans</strong></a> available. Whether you opt for a charming 1 or 2 bedroom apartment or loft near Broken Arrow Hillside, each meticulously designed residence blends style, comfort, and functionality to create an ideal backdrop for your lifestyle.</p>\n<p>Discover the ideal apartment at Scissortail Crossing, tailored to suit any lifestyle in a serene Broken Arrow neighborhood. Embrace the tranquil surroundings of your new home and enjoy a stress-free and fulfilling life with access to everything you need.<br/>You can binge-watch your favorite show, host dinner parties, or spend quality time with your family in our community. Ready to experience Scissortail Crossing’s unique charm? <a href=\"/apartments/ok/broken-arrow/scissortail-crossing/contact-us\"><strong>Schedule a tour</strong></a> now to find out if it’s the right fit for you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Whether you plan to move into your first apartment or move in with a roommate, Trails at Aspen Creek has a selection of brand-new, beautiful floor plans to suit everyone’s needs and preferences. Choose from cozy 1 bedroom or spacious 2 bedroom luxury apartments, townhomes, or lofts, all equipped with luxury apartment features and upscale finishes like high ceilings, spacious closets, and custom cabinetry.</p>\n<p>Our 3 bedroom apartment homes are excellent for growing families who need a devoted playroom or residents who work from home and require a dedicated office space. These roomy apartment homes feature oversized windows that bring abundant natural light, fully equipped kitchens with high-end stainless appliances, and modern touches throughout the design.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We are delighted to provide <a href=\"/apartments/ok/broken-arrow/villas-at-aspen-park/floor-plans\"><strong>six exceptional 1 and 2 bedroom floor plans</strong></a> at our luxurious apartment community in Broken Arrow. The Villas at Aspen Park offers 1 bedroom apartments and lofts with spacious, open-concept living, kitchen, and dining areas, ideal for relaxing with your furry friend or hosting a party with friends and family. Opt for an apartment or loft with an extra office or dining nook to enhance the ambiance.</p>\n<p>Our 2 bedroom apartments offer even more space and are ideal for those seeking the perfect home in Broken Arrow. These apartments and lofts provide a generously sized main bedroom with an en-suite, an additional bedroom and bathroom, and generous closet space. The bedroom ceiling fans and air conditioning ensure year-round comfort while you create your own personalized home office, art studio, game room, or guest room.</p>\n<p>The Villas of Aspen Park offers a remarkable living experience with its range of apartments and lofts in Broken Arrow, OK. Our apartment community provides amenities that cater to a lifestyle of exceptional standards.<br/>Arrange a<strong> </strong><a href=\"https://app.tour24now.com/prospect/tour/villas-at-aspen/register/\" target=\"_blank\"><strong>tour of our dynamic apartment community</strong></a> with us, and we will guide you through our stunning facilities. We will answer any questions you may have and provide you with an all-inclusive tour of our luxurious spaces. Alternatively, you can take a <a href=\"#schedule-a-tour\"><strong>self-guided tour</strong> </a>and explore our facilities at your own pace. At the Villas of Aspen Park, we offer everything you need to enjoy a luxurious, comfortable, and fulfilling lifestyle.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/fountain-lake::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore our six unique <a href=\"/apartments/ok/edmond/fountain-lake/floor-plans\"><strong>1 and 2 bedroom Edmond apartment floor plans</strong></a> and find the ideal layout for your lifestyle. We offer apartments ranging from 789 sq. ft. to 1,110 sq. ft., plenty of room to live comfortably. Several apartments feature an attached garage for rent for added convenience and privacy. If you want to add coziness to your apartment home in Edmond, select one of our apartment floor plans with an included fireplace.</p>\n<p>Don’t just take our word for it. Come and experience the elegant comfort of Fountain Lake Apartments for yourself by <a href=\"/apartments/ok/edmond/fountain-lake/contact-us\"><strong>scheduling a tour</strong></a>. Our friendly leasing staff will be delighted to show you around our Edmond apartment community, but if you’d prefer to explore on your own, we also offer a <a href=\"/apartments/ok/edmond/fountain-lake/self-guided-tour\"><strong>self-guided tour option</strong></a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At our beautiful apartment community in Edmond, we’re delighted to offer <a href=\"/apartments/ok/edmond/villas-at-stonebridge/floor-plans\"><strong>eight unique floor plans</strong></a> designed to perfectly complement your lifestyle. Whether you’re looking for a comfy 1 bedroom or an immense 3 bedroom, we have the ideal options for you.</p>\n<p>Our apartments at the Villas at Stonebridge were carefully crafted to be the perfect place to call home. With ample, open-concept living and dining space, you’ll have plenty of room for a peaceful weekend or entertaining family and friends. Our 2 bedroom apartments offer two full bathrooms and generous closet space, making them perfect for visiting family or a roommate.</p>\n<p>If you’re looking for even more space, our 3 bedroom apartments offer the perfect option to end your search. These apartments feature a sizable main bedroom with an en suite and two additional bedrooms, allowing you to create a home office, craft room, or any other space you desire.</p>\n<p>We invite you to experience the ultimate luxury apartment community firsthand at the Villas at Stonebridge. Our dynamic Edmond apartment community offers an unparalleled lifestyle you won’t find anywhere else!</p>\n<p><br/><a href=\"/apartments/ok/edmond/villas-at-stonebridge/contact-us\"><strong>Schedule a tour today</strong></a>, and let our expert staff guide you through our world-class amenities, answer your questions, and showcase everything our community offers. You can also <a href=\"https://app.tour24now.com/prospect/tour/villas-of-waterford/register/\" target=\"_blank\"><strong>take a self-guided tour</strong></a> and explore our stunning spaces at your own pace. See why the Villas at Stonebridge is the perfect residence for you!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The ideal floor plan to suit your lifestyle awaits at The Reserve at Elm. Choose from our spacious <a href=\"/apartments/ok/jenks/the-reserve-at-elm/floor-plans\"><strong>1 and 2 bedroom apartments</strong></a>, each offering a blend of style and functionality across six unique layouts. Choose from a range of options to customize your home with an optional wood-burning fireplace, a private balcony or patio, or an attached garage to the highest level of convenience in your new apartment home.</p>\n<p>Take a virtual tour of Elm Reserve Apartments and preview a life lived in luxury. Imagine relaxing by the pool, staying active in the fitness center, or enjoying the company of friends and neighbors in our inviting community spaces. To see more, browse photos of our beautifully appointed interiors, resort-style amenities, and scenic surroundings in our <a href=\"/apartments/ok/jenks/the-reserve-at-elm/photos\"><strong>online gallery</strong></a>. For a closer look, take a virtual walk-through using our 360-degree digital tours.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/moore/mission-point::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our <a href=\"/apartments/ok/moore/mission-point/neighborhood\"></a><strong><a href=\"/apartments/ok/moore/mission-point/floor-plans\"><strong>1 and 2 bedroom luxury apartments</strong></a></strong> and lofts offer a spacious and stylish retreat for every lifestyle. We offer six distinct layouts ranging in size from 789 to 1,176 sq. ft. to accommodate single renters and small families alike, each with the flexibility of an available attached garage. Each apartment beckons ample sunshine and idyllic views from your pool-facing windows, ideal for starting each morning with positivity and energy.</p>\n<p>Are you eager to move forward? Plan a visit to Mission Point Apartments, where our welcoming leasing team is excited to showcase our complex and various floor plans. If you prefer a more independent exploration of our Moore, Oklahoma luxury apartments, set up a <a href=\"https://app.tour24now.com/prospect/tour/mission-point/register/\" target=\"_blank\"><strong>self-guided</strong> <strong>tour</strong></a> and wander through Mission Point at your leisure.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/artisan-crossing-apts::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Along with our luxury 1 and 2 bedroom apartments in Norman, we also offer loft and townhome <a href=\"/apartments/ok/norman/artisan-crossing-apts/floor-plans\"><strong>floor plans</strong></a> for residents seeking more space and privacy. Our 1 bedroom apartments boast 790 sq. ft. of space with a full kitchen that flows right into the living and dining area for an open, airy feel. In our 2 bedroom townhouses in Norman, you’ll find a downstairs living room, half bathroom, kitchen, and dining area. Upstairs, you’ll enjoy two full bedrooms and bathrooms.</p>\n<p>Ready to see if Artisan Crossing is the right place for you? Schedule a tour and explore our community with the guidance of our friendly residence staff. If you prefer to browse our apartment community solo, arrange one of our <a href=\"https://app.tour24now.com/prospect/tour/artisan-crossing/register/\" target=\"_blank\"><strong>self-guided tours</strong></a>. We look forward to showing you everything our community has to offer! If you have any questions or need assistance, feel free to <a href=\"tel:4059286049\"><strong>call us</strong></a> or fill out <a href=\"/apartments/ok/norman/artisan-crossing-apts/contact-us\"><strong>a contact form</strong></a> and our staff will get back to you soon.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We invite you to browse our <a href=\"/apartments/ok/norman/cimarron-trails-apts/floor-plans\"><strong>Norman, OK, apartments for rent</strong></a> and find the right fit for you. Thoughtfully designed 1, 2, and 3 bedroom apartments for rent and townhomes feature open-concept living and dining areas for a comfortable, intimate feeling. Spacious closets in all our floor plans make storing your wardrobe simple.</p>\n<p>We invite you to <a href=\"/apartments/ok/norman/cimarron-trails-apts/floor-plans\"><strong>schedule a tour</strong></a> to find out if Cimarron Trails Apartments in Norman are right for you. Our friendly staff members are ready to guide you through our welcoming community. However, if you’d prefer to explore our apartments for rent on your own, we also offer a <a href=\"/apartments/ok/norman/cimarron-trails-apts/floor-plans\"><strong>self-guided tour option</strong></a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/24hundred-apartments::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Looking to rent in Oklahoma City? You can relax in style in one of our Oklahoma City carefully curated <strong><a href=\"/apartments/ok/oklahoma-city/24hundred-apartments/floor-plans\">floor plans</a></strong> designed to suit your lifestyle, offering options from compact 1bedroom apartments to spacious townhomes. Our apartments range from 789 sqft to over 1,200 sqft, providing the perfect amount of space for your needs. We offer several bedroom apartments with a fireplace, ideal for cozying up on a chilly winter evening. Whether you’re searching for 1-bedroom apartments or larger floor plans, you’ll find a range of options that fit your lifestyle. We also offer Oklahoma City townhomes and lofts with an attached garage for additional convenience and privacy.</p>\n<p>Ready to find your perfect apartment rental in Oklahoma City, OK? <strong><a href=\"https://app.tour24now.com/prospect/tour/24hundred/register/\" target=\"_blank\">Schedule a tour of our pet-friendly apartments for rent in Oklahoma City today</a></strong> and discover why 24Hundred is the ideal place to call home. You can take a tour with one of our friendly resident staff members or <a href=\"https://app.tour24now.com/prospect/tour/24hundred/register/\" target=\"_blank\"><strong>a self-guided tour</strong></a>. Your new Oklahoma City apartment awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/chisholm-pointe::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our duplex apartments in Oklahoma City offer a range of <a href=\"/apartments/ok/oklahoma-city/chisholm-pointe/neighborhood\"><strong>floor plans</strong></a> that are perfect for single renters, couples, and families. Whether you are looking for a cozy 1 bedroom retreat, a spacious 2 bedroom layout for roommates or visiting guests, or a generous 3 bedroom home for added space and flexibility, we have the perfect rental option for you.</p>\n<p><a href=\"/apartments/ok/oklahoma-city/chisholm-pointe/contact-us\"><strong>Schedule your tour</strong></a> today to see how Chisolm Pointe is the right place for you to call home. Our friendly staff is eager to show you around our property so you can become familiar with everything we offer. <a href=\"/apartments/ok/oklahoma-city/chisholm-pointe/contact-us\"><strong>Contact us</strong></a> for more information, and get ready to make Chisholm Pointe your new home in Oklahoma City.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Browse our <a href=\"/apartments/ok/oklahoma-city/cimarron-pointe-apts/floor-plans\"><strong>floor plans</strong></a> to find an Oklahoma City apartment that suits your lifestyle. We offer five distinct layouts, ranging from 550 to 1200 sq. ft. If you’re looking for an extra touch of coziness, several of our apartment floor plans offer an optional wood-burning fireplace. Every floor plan at Cimarron Pointe Apartments in Oklahoma City features a private balcony or patio, ideal for soaking up rays or enjoying a moment of peaceful reflection. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Council Place, we offer <a href=\"/apartments/ok/oklahoma-city/council-place-apartments/floor-plans\"><strong>1, 2, and 3 bedroom apartment homes</strong></a> to suit your lifestyle, where you’ll enjoy 700 to 1,010 sq. ft of living space. Each of our apartment floor plans includes a large living and dining area where you can binge-watch your favorite TV show or invite friends over for a movie night. The kitchen and dining area seamlessly flow into each other in an open layout, ideal for dinner parties. </p>\n<p>Get a taste of what life is like in Council Place Apartments by <a href=\"#schedule-a-tour\"><strong>scheduling a tour</strong></a> with one of our friendly leasing staff members. When you’re ready to call Council Place home, complete a <a href=\"https://councilplaceapartmentsoklahomacity.securecafe.com/onlineleasing/council-place-apartments/register.aspx\" target=\"_blank\"><strong>rental application</strong></a> online.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Cross Timber offers <a href=\"/apartments/ok/oklahoma-city/cross-timber/floor-plans\"><strong>spacious 2 and 3 bedroom apartment floor plans</strong></a>, each offering 929 sq. ft. or more. Our second-floor apartments are loft-style, featuring an entrance downstairs and living quarters upstairs. With an open-concept layout, your living area flows into the kitchen and a charming dining nook, making your Oklahoma City apartment ideal for hosting friends and family.</p>\n<p>Ready for an in-person look at Cross Timber Apartments in Oklahoma City? We invite you to <a href=\"/apartments/ok/oklahoma-city/cross-timber/contact-us\"><strong>schedule a tour</strong></a>, and one of our friendly leasing staff members will be delighted to show you around. If you’d prefer to explore our Oklahoma City apartment complex on your own, take advantage of our <a href=\"/apartments/ok/oklahoma-city/cross-timber/self-guided-tour\"><strong>self-guided tours</strong></a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Browse our <a href=\"/apartments/ok/oklahoma-city/crown-pointe-apartments/floor-plans\"><strong>Oklahoma City apartment floor plans</strong></a> and find the layout that best suits your lifestyle. We offer spacious 1 and 2 bedroom apartment homes with optional extras like a wood-burning fireplace and vaulted ceilings. The spacious living area flows into your modern kitchen, next to a charming dining nook.</p>\n<p>Once you’re ready to take the next step, <a href=\"/apartments/ok/oklahoma-city/crown-pointe-apartments/contact-us\"><strong>schedule a tour of Crown Pointe Apartments </strong></a>and get an in-person look at our community. On your tour, one of our friendly residence staff members will guide you through our Oklahoma City apartments and answer any questions you may have. If you’d prefer to explore Crown Pointe on your own, you can also <a href=\"/apartments/ok/oklahoma-city/crown-pointe-apartments/self-guided-tour\"><strong>schedule a self-guided tour</strong></a> of our apartments in Oklahoma City.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We offer nine unique <a href=\"/apartments/ok/oklahoma-city/hunter-s-ridge-apts/floor-plans\"><strong>floor plans</strong></a> for our 1 and 2 bedroom apartments in Oklahoma City, ranging from 525 sq. ft to over 1,000 sq. ft. An open-concept living and dining area next to your full kitchen gives your apartment a cozy, intimate feeling. Each of our apartments includes lots of closet space and full kitchens.</p>\n<p>Experience the comfort of Hunter’s Ridge Apartments in Oklahoma City firsthand by <a href=\"/apartments/ok/oklahoma-city/hunter-s-ridge-apts/contact-us\"><strong>scheduling a tour</strong></a>. Our friendly residence staff is excited to show you around our Oklahoma City apartment community. Still, if you’d rather explore on your own, we also offer a <strong><a href=\"https://app.tour24now.com/prospect/tour/hunters-ridge/register/\" target=\"_blank\">self-guided tour option</a></strong>. Come and see everything Hunter’s Ridge has to offer!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter's-ridge-apts::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We offer nine unique <a href=\"/apartments/ok/oklahoma-city/hunter-s-ridge-apts/floor-plans\"><strong>floor plans</strong></a> for our 1 and 2 bedroom apartments in Oklahoma City, ranging from 525 sq. ft to over 1,000 sq. ft. An open-concept living and dining area next to your full kitchen gives your apartment a cozy, intimate feeling. Each of our apartments includes lots of closet space and full kitchens.</p>\n<p>Experience the comfort of Hunter’s Ridge Apartments in Oklahoma City firsthand by <a href=\"/apartments/ok/oklahoma-city/hunter-s-ridge-apts/contact-us\"><strong>scheduling a tour</strong></a>. Our friendly residence staff is excited to show you around our Oklahoma City apartment community. Still, if you’d rather explore on your own, we also offer a <strong><a href=\"https://app.tour24now.com/prospect/tour/hunters-ridge/register/\" target=\"_blank\">self-guided tour option</a></strong>. Come and see everything Hunter’s Ridge has to offer!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/park-at-tuscany::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Park at Tuscany gives you a wide selection of floor plans to make our community the home you’ve dreamed of. Choose between our <a href=\"/apartments/ok/oklahoma-city/park-at-tuscany/floor-plans\"><strong>1 and 2 bedroom apartments</strong></a>, available in six distinct layouts, and customize your living space with an optional fireplace, personal balcony or patio, or even a loft with an attached garage.</p>\n<p>We welcome you to get an in-person look at your future home. Our friendly, knowledgeable staff is ready to guide you through the inviting interiors and the unique charm of our welcoming community. So <a href=\"/apartments/ok/oklahoma-city/park-at-tuscany/contact-us\"><strong>schedule your visit</strong></a> to experience firsthand the features, floor plans, and luxurious flourishes that make The Park at Tuscany Apartments a step above the rest.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/persimmon-square-apartments::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our Oklahoma City apartments boast an array of <a href=\"/apartments/ok/oklahoma-city/persimmon-square-apartments/floor-plans\"><strong>floor plans</strong></a>, ranging from compact 1 bedroom apartment homes to expansive 2 bedroom town houses with lofts. With generously spaced living areas and ample closets, our floor plans cater to every lifestyle. Additionally, we provide apartments equipped with in-home washers and dryer connections for added convenience.</p>\n<p>Discovering the ideal Oklahoma City apartment at Persimmon Square is effortless with our inviting community. Whether cozy movie nights with loved ones in your living room or savoring a cup of coffee in our resident lounge, you’ll feel at home at Persimmon Square. When you’re ready to see our secure and welcoming apartment community, <a href=\"/apartments/ok/oklahoma-city/persimmon-square-apartments/contact-us\"><strong>schedule a tour</strong></a> today.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>You’ll find your ideal living space at Prairie Springs in one of our thoughtfully designed <a href=\"/apartments/ok/oklahoma-city/prairie-springs-i/floor-plans\"><strong>1, 2, and 3 bedroom floor plans</strong></a>. Each apartment features modern finishes, ample storage space, and options for private patios or balconies, providing the ideal backdrop for your relaxed lifestyle. Each bedroom has its private bathroom across each of our floor plans, and with a diverse range of layouts, you can choose a home that is organized with your unique needs in mind.</p>\n<p><a href=\"/apartments/ok/oklahoma-city/prairie-springs-i/contact-us\"><strong>Schedule a personalized tour</strong></a> today and experience firsthand all our community offers. Our friendly and professional staff are here to assist you every step of the way, from helping you choose the ideal floor plan to providing a guided tour of our amenities and grounds. See why Prairie Springs is the premier destination for luxury apartment living in northwest Oklahoma City, and when you are ready, <a href=\"https://prairiespringsapartmentsoklahomacity.securecafe.com/onlineleasing/prairie-springs-i-ii/register.aspx\" target=\"_blank\"><strong>apply online</strong></a> to reserve your home at Prairie Springs.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/stonehorse-crossing::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the perfect <a href=\"/apartments/ok/oklahoma-city/stonehorse-crossing/floor-plans\"><strong>floor plan</strong></a> to suit your lifestyle at Stonehorse Crossing Apartments. Whether you’re seeking a cozy 1 bedroom space for you and <a href=\"/apartments/ok/oklahoma-city/stonehorse-crossing/pet-policy\"><strong>your pets</strong></a> or a 2 bedroom apartment or townhome, our diverse selection of layouts offers something for everyone. Each apartment home is designed with comfort and functionality in mind, featuring open-concept living areas, designer finishes, and ample storage space throughout. Select apartments and townhomes also feature an enclosed garage, perfect for keeping your vehicle secured and ready for your next drive to work or a family road trip.</p>\n<p>Ready to experience luxury living in OKC? <a href=\"/apartments/ok/oklahoma-city/stonehorse-crossing/contact-us\"><strong>Schedule a tour of Stonehorse Crossing</strong></a><strong> </strong>today and let our friendly leasing team show you around our stunning grounds. Explore our multiple size options to get a first-hand view of how every corner of our upscale community promotes comfort and relaxation, and once you’ve found the right ideal fit, <a href=\"https://stonehorsecrossingapartmentsoklahomacity.securecafe.com/onlineleasing/stonehorse-crossing/register.aspx\" target=\"_blank\"><strong>start your online application</strong></a> today to take a step toward your new life at Stonehorse Crossing.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summerfield-place-apts::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The meticulously crafted <a href=\"/apartments/ok/oklahoma-city/summerfield-place-apts/floor-plans\"><strong>floor plans</strong></a> in our northwest Oklahoma City apartment community enable you to maximize every inch. They feature intimate living and dining spaces adjacent to the kitchen. Our 2 bedroom, 2 bathroom apartment layouts present two complete bedrooms and bathrooms divided by a central kitchen and living room, which provides ideal privacy if you’re living with a roommate.</p>\n<p><a href=\"/apartments/ok/oklahoma-city/summerfield-place-apts/contact-us\"><strong>Schedule a tour</strong></a> to determine if Summerfield Place Apartments aligns with your preferences and discover the peaceful ambience firsthand. When you’re ready to make Summerfield Place your home, conveniently <a href=\"https://summerfieldplaceapartmentsoklahomacity.securecafe.com/onlineleasing/summerfield-place-apts/register.aspx\" target=\"_blank\"><strong>complete your application online</strong></a>. Our welcoming team members are available to guide you through our community and address any inquiries you may have.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summit-ridge-villas/summit-villas::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 2-bedroom duplexes are a spacious 933 sq. ft, and offer ample room to move around. These duplexes blend living, dining, and kitchen space perfectly, offering quality space for family parties or holidays. Our duplexes offer practical amenities such as washer and dryer connections, fenced yards, and wood-style flooring, and even come with a garage!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/tammaron-village-apartments::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find your ideal home in our Oklahoma City apartment community at Tammaron Village Apartments. With <a href=\"/apartments/ok/oklahoma-city/tammaron-village-apartments/floor-plans\"><strong>four diverse floor plans</strong></a> to choose from, we offer unique options to suit any lifestyle or preference. From cozy studios to tranquil 1 bedroom designs and spacious 2 bedroom layouts, our apartments are perfect for anyone looking for pet-friendly apartment living. Our 500 sq. ft. studio apartments are ideal for first-time renters or University of Central Oklahoma students.</p>\n<p>Our 1 bedroom apartment homes are the embodiment of comfort and luxury. These open-concept living and dining spaces are designed to provide you with convenience and sophistication. The spacious kitchen features a large pantry, perfect for quick snacks and effortless organization. With a generous size of 650 sq. ft., our 1 bedroom apartment homes are the best choice for your next home in Northwest Oklahoma City.</p>\n<p>At Tammaron Village Apartments, we proudly offer our residents two unique floor plans for our 2 bedroom apartments. These apartments are thoughtfully designed to provide generous open-concept living space and spacious closets, perfect for playing board games with friends or relaxing with your pet. Our 2 bedroom apartments are ideal for anyone looking for a space to share with a roommate, a home office, or an art studio.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/warrington-apartments::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Select from eight unique <a href=\"/apartments/ok/oklahoma-city/warrington-apartments/floor-plans\"><strong>floor plans</strong></a>, each thoughtfully crafted to offer comfortable living and dining space, spacious closets, and a private balcony or patio. This allows you to discover the ideal match for your lifestyle in northwest Oklahoma City near Walnut Creek Estates. Embrace the charm of wood-burning fireplaces and enjoy the convenience of stylish, fully equipped kitchens in every layout, whether you opt for a 1 or 2 bedroom apartment.</p>\n<p>Discover if The Warrington is your perfect fit by <a href=\"/apartments/ok/oklahoma-city/warrington-apartments/contact-us\"><strong>scheduling a tour</strong></a> with our friendly resident team. They will gladly guide you through our apartment homes and inviting community. Feel free to take a <a href=\"/apartments/ok/oklahoma-city/warrington-apartments/self-guided-tour\"><strong>self-guided tour</strong></a> of our luxury apartments in Oklahoma City at your convenience. When you’re prepared to make The Warrington your new home, streamline the process by <a href=\"https://warringtonapartmentsoklahomacity.securecafe.com/onlineleasing/warrington-apartments/register.aspx\" target=\"_blank\"><strong>applying online</strong></a> for one of our Oklahoma City apartments.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Waters Edge, you’ll find cozy <a href=\"/apartments/ok/oklahoma-city/waters-edge-apartments/floor-plans\"><strong>studio, 1, and 2 bedroom apartments</strong></a> in Oklahoma City. Enjoy a patio or balcony in our 1 and 2 bedroom apartments, or cook a delicious meal in your well-equipped kitchen. Whether you’re starting your newlywed life, downsizing in retirement, or anything in between, you can live your life how you want with any of our floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Zeal at Quail in vibrant Oklahoma City, choose from stylish one and two-bedroom duplex floor plans that cater to your lifestyle. Each home offers modern amenities and a welcoming atmosphere. Browse our available options today to find the ideal space that fits your vision of comfort and convenience.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/coffee-creek::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Each of our Owasso <a href=\"/apartments/ok/owasso/coffee-creek/floor-plans\"><strong>1 and 2 bedroom apartment homes</strong></a> offers a luxurious living space that maintains a relaxed environment that excels in its utility. Our spacious kitchens are complemented by a large pantry adorned with elegant, easy-to-maintain ceramic flooring. Abundant sunlight shines through multiple shaded windows to greet you each morning. Coffee Creek allows you to individualize your living environment with options for a balcony, fireplace, and an attached garage.</p>\n<p><a href=\"/apartments/ok/owasso/coffee-creek/contact-us\"><strong>Schedule your personalized tour</strong></a><strong> </strong>of the luxurious Coffee Creek Apartments in Owasso. Our welcoming leasing team is eager to show you the exceptional features of our community. Alternatively, if you desire a more independent exploration, you can <a href=\"/apartments/ok/owasso/coffee-creek/self-guided-tour\"><strong>schedule a self-guided tour</strong></a>. We look forward to seeing you!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our thoughtfully designed<strong> </strong><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/apartments/ok/owasso/cottages-at-tallgrass-point/floor-plans\"><strong>1 and 2 bedroom apartments</strong></a>, each boasting distinctive features that bring character to your living environment. Cozy up next to your wood-burning fireplace, creating a warm and inviting ambience during chilly evenings. Enjoy the fresh air and scenic views from a balcony, or experience the unique charm of loft-style living. With a range of layouts, the right fit for you is easy to find.</p><p><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"#schedule-a-tour\">Schedule a visit today</a> and immerse yourself in the vibrant community and exceptional living spaces that define our Owasso apartments. Our friendly staff is ready to welcome you, answer your questions, and guide you through making Cottages at Tallgrass Point your new home. And when you are ready, <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"\" data-field-href=\"property_apply_now_url\"><strong>apply online</strong></a> to take a step toward your new home in Owasso.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cypress-crossing::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We allow you to pick <strong><a href=\"/apartments/ok/owasso/cypress-crossing/floor-plans\">the space that best matches your way of life</a></strong>. With various options, from 1 bedroom apartments perfect for singles and 2 bedroom apartments for couples to expansive 3 bedroom layouts for families, finding your ideal home has never been simpler. </p>\n<p>Prefer a distinctive living space? Our townhomes and lofts bring you unique layouts perfect for those who crave something different and uniquely personal.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/pryor/west-530::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our<strong> 1 bedroom and 2 bedroom apartment homes</strong> are spacious, comfortable, and designed for flexibility. Each floor plan features modern, elegant finishes and smart layouts that make the most of every square foot. There’s plenty of opportunity to make room for guests or to host dinner parties for friends, families, and neighbors to enjoy.</p>\n<p>Plus, with an onsite dog park, everyone with pets, from individuals to families, can find a comfortable home in our luxury apartment community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/stillwater/apple-creek-stillwater::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our Stillwater apartment community’s thoughtfully designed <a href=\"/apartments/ok/stillwater/apple-creek-stillwater/floor-plans\"><strong>floor plans</strong></a> help you make the most of every square foot, with cozy living and dining areas near the kitchen. Our 2 bedroom, 2 bathroom apartment layouts are ideal for living with a roommate, offering two full bedrooms and bathrooms separated by a kitchen and living room for optimal privacy.</p>\n<p>Come experience the peaceful serenity of Apple Creek firsthand by <a href=\"/apartments/ok/stillwater/apple-creek-stillwater/contact-us\"><strong>scheduling a tour</strong></a> to see if our Stillwater apartments will be a good fit for you. One of our friendly representatives will guide you through our community, ready to answer any questions you may have. Once you’re ready to call Apple Creek home, you can fill out your application via our <a href=\"/apartments/ok/stillwater/apple-creek-stillwater/apply\"><strong>online portal</strong></a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/barrington-apartments::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>With 10 floor plan styles to choose from, it’s no wonder residents love calling Barrington Apartments home. With one, two, and three bedroom floor plans ranging from 600 to 1,360 square feet, we have a floor plan to fit your lifestyle. Reach out to us today to set up a personalized tour.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cascata-luxury-apartments::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find an ideal backdrop for your life at Cascata. We offer six distinctive <a href=\"/apartments/ok/tulsa/cascata-luxury-apartments/floor-plans\"><strong>floor plans</strong></a> for our 1 bedroom and 2 bedroom apartments in Tulsa, including layouts with an included study. If you want to enhance your Tulsa apartment’s coziness, opt for one of our 1 or 2 bedroom apartments with a fireplace, great for getting cozy on cold days. Thanks to the open-concept kitchen and dining room area, hosting dinner parties or get-togethers with friends is a breeze. </p>\n<p>See if Cascata is a good fit for you by <a href=\"#schedule-a-tour\"><strong>scheduling a tour</strong></a> of our Tulsa apartment community. Our friendly residence staff members will guide you through our community and show you around our apartment homes. If you prefer to tour independently, schedule a <strong><a href=\"https://app.tour24now.com/prospect/tour/cascata/register/\" target=\"_blank\">self-guided tour</a></strong> and peruse Cascata at your own pace.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-glade-apts::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Cedar Glade Apartments offers one, two, and three bedroom floor plans. Here you are sure to find the space you need for everything you need. Each floor plan conveniently includes life-enhancing extras such as a fully equipped kitchen and extra storage space.</p>\n<p>Book a tour with our helpful residence staff to see if Cedar Glade is right for you. Let us show you around our apartment homes and inviting community. If you’d prefer to explore our apartments by yourself, feel free to schedule a <a href=\"https://app.tour24now.com/prospect/tour/cedar-glade/register/\" target=\"_blank\"><strong>self-guided tour</strong></a> of Cedar Glade. Once you’re ready, we invite you to <a href=\"https://cedargladeapartmentstulsa.securecafe.com/onlineleasing/cedar-glade-apts/register.aspx\" target=\"_blank\"><strong>apply for our Tulsa apartments online</strong></a>. We look forward to welcoming you home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to your beautiful new Cedar Ridge home where open, airy layouts are a standard along with 9-foot ceilings perfect for entertaining or quiet nights in. The <a href=\"/apartments/ok/tulsa/cedar-ridge-apartments/amenities\">upscale kitchen</a> showcases custom cabinetry, a subway tile backsplash, breakfast bar, and energy-efficient appliances that make cooking and cleanup a breeze. Curl up in front of the LED fireplace in select units with a good book or enjoy some fresh air with a glass of wine on your balcony or patio in select units. Some Cedar Ridge homes even feature attached garages to keep your ride safe and dry and provide extra storage.</p>\n<p>See if our Tulsa apartments are the right fit for you and your family by <a href=\"/apartments/ok/tulsa/cedar-ridge-apartments/contact-us\"><strong>scheduling a tour</strong></a> today. On your tour of Cedar Glade, our friendly staff will guide you through our Tulsa apartment community and show you some of our floor plans. We also offer a <a href=\"/apartments/ok/tulsa/cedar-ridge-apartments/self-guided-tour\"><strong>self-guided tour</strong></a> option if you’d prefer to tour Cedar Glade on your own.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Make yourself at home in one of our 1 bedroom, 1 bathroom Tulsa apartments ranging from 495 to 626 sq. ft. Enjoy 846 sq. ft of spacious comfort in our 2 bedroom, 2 bathroom apartments in Tulsa. The Chardonnay apartments feature an open floor plan design throughout the kitchen and living and dining areas, giving you extra room to decorate. The large kitchens in our Tulsa apartments feature easy-to-clean vinyl flooring, and an attached pantry for food storage.</p><p>Experience the peaceful ambience of Chardonnay and <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"#schedule-a-tour\"><strong>schedule a tour</strong></a> of our Tulsa apartment community. Our friendly residence staff members are eager to show you everything Chardonnay offers. If you’d prefer to explore our Tulsa apartments by yourself, feel free to select a <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://app.tour24now.com/prospect/tour/chardonnay-apartments/register/\" target=\"_blank\"><strong>self-guided tour</strong></a> instead. When you’re ready to call Chardonnay home, simply complete the <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://chardonnayapartmentstulsa.securecafe.com/onlineleasing/chardonnay/register.aspx?nocache=1\" target=\"_blank\"><strong>online rental application</strong></a>.&nbsp;</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our south Tulsa apartment homes are available in three unique floor plans with options for <a href=\"/apartments/ok/tulsa/country-hollow-apartments/floor-plans\"><strong>1 and 2 bedroom apartments</strong></a>. Our reasonably priced studio options are a popular choice for students. Wide shaded windows bring in ambient light that fills your home each morning, and with a private patio or balcony available in select floor plans, a breath of fresh air and scenic views of our well-maintained community are always within reach.</p>\n<p>Explore Country Hollow by <a href=\"/apartments/ok/tulsa/country-hollow-apartments/contact-us\"><strong>scheduling your tour</strong></a> today. Our friendly staff is ready to guide you through every aspect of our community so you will know you’ve found the right fit. <a href=\"/apartments/ok/tulsa/country-hollow-apartments/self-guided-tour\"><strong>Self-guided tours</strong></a><strong> </strong>are also welcome for those who prefer to browse independently. When you are ready to make Country Hollow your home, <a href=\"https://countryhollowapartmentstulsa.securecafe.com/onlineleasing/country-hollow-apartments/register.aspx\" target=\"_blank\"><strong>apply online</strong></a> to become part of our welcoming apartment community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/creekwood-apartments::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We offer a variety of <a href=\"/apartments/ok/tulsa/creekwood-apartments/floor-plans\"><strong>1 and 2 apartment and townhome floor plans</strong></a> with carefully designed layouts that complement your lifestyle. Many of our apartment homes include a sunroom or patio, ideal for curating a reading nook or displaying your house plants. When you want some extra room, consider one of our townhomes, which feature two floors of space.</p>\n<p>Ready to take the next step? <a href=\"#schedule-a-tour\"><strong>Schedule a tour</strong></a>, and our friendly staff will be delighted to show you around our apartment community in Tulsa. If you’d rather explore our community solo, <a href=\"https://app.tour24now.com/prospect/tour/creekwood-apartments/register/\" target=\"_blank\"><strong>schedule a self-guided tour of Creekwood</strong></a>. When you’re ready to call Creekwood home, submit your <a href=\"https://creekwoodapartmentstulsa.securecafe.com/onlineleasing/creekwood-apartments-0/register.aspx\" target=\"_blank\"><strong>rental application</strong></a> online. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/polo-run-apartments::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the thoughtful design of our Tulsa apartment community’s <a href=\"/apartments/ok/tulsa/polo-run-apartments/floor-plans\"><strong>floor plans</strong></a>, allowing you to optimize every square foot. Enjoy cozy living and dining areas adjacent to the kitchen, creating a welcoming space for everyday living. We have multiple 1 bedroom apartment options, ranging from 700 sq. ft. to a large 850 sq. ft. Our 2 bedroom, 2 bathroom apartment layouts offer maximum privacy, with the bedrooms and bathrooms separated by a central kitchen and living room, making them ideal for shared living arrangements.</p>\n<p>To determine if Polo Run is the right fit, <a href=\"/apartments/ok/tulsa/polo-run-apartments/contact-us\"><strong>schedule a tour</strong></a> to experience our luxury apartments in Tulsa personally. During the tour, a welcoming representative will guide you through the community and address any inquiries. When you’re ready to make Polo Run your home, you can conveniently <a href=\"https://polorunapartmentstulsa.securecafe.com/onlineleasing/polo-run-apartments/register.aspx\" target=\"_blank\"><strong>complete an application online</strong></a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our inviting Tulsa apartments offer a range of <a href=\"/apartments/ok/tulsa/sheridan-pond/floor-plans\"><strong>floor plans</strong></a>, from compact 1-bedroom options to generous 3-bedroom layouts. Each apartment features spacious living rooms and ample closet space, offering adaptability to suit your lifestyle. Additionally, stainless steel appliances enhance our apartments’ convenience and modern appeal.</p>\n<p>At Sheridan Pond, we take pride in providing a warm and inviting community where you can discover the ideal Tulsa apartment for your lifestyle.<br/>Whether you enjoy movie nights with friends and loved ones in the comfort of your apartment living room or savor delightful moments over coffee in our clubhouse, our secure and welcoming environment offers a range of appealing experiences. If you want to learn more about our apartment community, we invite you to <a href=\"/apartments/ok/tulsa/sheridan-pond/contact-us\"><strong>schedule a tour</strong></a> today.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the ideal floor plan to complement your lifestyle within our Tulsa apartment community. Select from our four distinct <a href=\"/apartments/ok/tulsa/sugarberry-apartments/floor-plans\"><strong>floor plans</strong></a> and revel in the comfort of your tastefully furnished, fully equipped apartment.</p>\n<p>Our 1 bedroom apartments in Tulsa offer generous living and dining spaces, perfect for cozy movie nights or hosting intimate gatherings with friends. Our 2 bedroom apartments feature a master bedroom and two additional bedrooms, catering to diverse living preferences and needs.</p>\n<p><a href=\"/apartments/ok/tulsa/sugarberry-apartments/contact-us\"><strong>Schedule a tour</strong></a> of Sugarberry and experience firsthand our inviting Tulsa apartments and vibrant community. Our knowledgeable staff will guide you through our amenities and answer any queries you may have. Prefer to explore independently? Secure a <a href=\"#schedule-a-tour\"><strong>self-guided tour</strong></a> and wander through our spaces at your leisure.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discovering the ideal apartment in south Tulsa is effortless, thanks to our diverse <a href=\"/apartments/ok/tulsa/sunchase-apartments/floor-plans\"><strong>floor plans</strong></a>. Our compact studio and 1 bedroom, 1 bathroom apartments, spanning from 500 to 700 sq. ft., offer ample room for customization to suit your preferences. Meanwhile, our 2 bedroom, 2 bathroom apartment homes feature spacious closets, two full bathrooms with bathtubs, and generous living areas, ensuring plenty of space for all residents.</p>\n<p>Discover the ideal setting for your lifestyle in our reasonably priced Tulsa apartment homes, offering a blend of comfort and convenience through various amenities and features. Your next apartment home awaits at Sunchase, where our welcoming staff is ready to assist with any inquiries at your convenience when you <a href=\"/apartments/ok/tulsa/sunchase-apartments/contact-us\"><strong>schedule a tour</strong></a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Courtyards of Tulsa feature well-designed <a href=\"/apartments/ok/tulsa/the-courtyards/floor-plans\"><strong>1 and 2 bedroom apartment floor plans</strong></a> that include all the amenities you need in your daily life. Every single one of our eight apartment layouts features a spacious living and dining area for relaxing and unwinding after a long day or hosting guests. We also offer wood-burning fireplaces in select apartment homes for a classic and cozy touch.</p>\n<p>Want an in-person look at our south Tulsa apartments? <a href=\"/apartments/ok/tulsa/the-courtyards/contact-us\"><strong>Schedule a tour of Courtyards of Tulsa</strong></a> and our friendly staff will be happy to show you around our community. As you visit, feel free to ask any questions you may have about our luxury apartment community. We also offer a <strong><a href=\"https://app.tour24now.com/prospect/tour/the-courtyards/register/\" target=\"_blank\">self-guided tour</a></strong> of our apartments for those who would like to wander at their own pace.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find the ideal <a href=\"/apartments/ok/tulsa/the-greens-of-bedford/floor-plans\"><strong>floor plan</strong></a> for your needs here at Greens of Bedford. We offer 1, 2, and 3 bedroom apartment homes in south Tulsa, offering 700 to 1200 sq. ft. of room to spread out and get comfortable. Each of our apartment homes includes a cozy, open-concept living and dining area with a charming bay window as well as a fully equipped kitchen.</p>\n<p>Ready to take the next step? Schedule a tour of The Greens of Bedford Apartments in Tulsa and let one of our friendly residence staff members show you around our community. We also offer a <strong><a href=\"https://app.tour24now.com/prospect/tour/greens-of-bedford/register/\" target=\"_blank\">self-guided tour option</a></strong> for those who’d prefer to explore our apartments alone. Once you’re ready to call The Greens of Bedford home, complete an <a href=\"https://greensofbedfordapartmentstulsa.securecafe.com/onlineleasing/the-greens-of-bedford/register.aspx\" target=\"_blank\"><strong>online rental application</strong></a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience seamless living in our thoughtfully crafted 1 and 2 bedroom apartment <a href=\"/apartments/ok/tulsa/windsail-apartments/floor-plans\"><strong>floor plans</strong></a>, featuring an interconnected living and dining space adjacent to a well-equipped kitchen. Enjoy the convenience of in-home laundry facilities with our washer and dryer connections in select apartments. Select homes also include fireplaces, ideal for cozying up during cool weather days.</p>\n<p><a href=\"/apartments/ok/tulsa/windsail-apartments/contact-us\"><strong>Schedule a tour</strong></a> of Windsail Apartments in Tulsa, where our welcoming leasing team will guide you through our offerings. Alternatively, opt for a self-guided tour to explore Windsail at your own pace. <a href=\"https://windsailapartmentstulsa.securecafe.com/onlineleasing/windsail-apts/register.aspx\" target=\"_blank\"><strong>Apply today</strong></a> to find your dream home at Windsail Apartments!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Whether you’re seeking a cozy 1 bedroom retreat or a spacious 2 bedroom apartment for family or guests, The Park on Westpointe’s <a href=\"/apartments/ok/yukon/park-at-westpointe/floor-plans\"><strong>six distinct floor plans</strong></a> fit your lifestyle. Our homes are designed thoughtfully and with an open concept that enhances the flexibility of our living spaces. With additional options for an attached loft and garage, balcony, or space-boosting bumpout, you can customize your apartment to create the home of your imagination.</p>\n<p>Take the next step by <a href=\"/apartments/ok/yukon/park-on-westpointe/contact-us\"><strong>scheduling a tour</strong></a> of The Park on Westpointe. Our knowledgeable staff and friendly residents are eager to show you every carefully planned detail that makes our apartment community a welcoming and accommodating environment. From the designer paint colors and plush carpets of our apartments to the idyllic scenery of our courtyard, explore everything that awaits you in your new home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/the-ridge-@-66::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find the perfect space to call home in one of our <a href=\"/apartments/ok/yukon/the-ridge-66/floor-plans\"><strong>thoughtfully designed floor plans</strong></a> at Ridge at 66 near Oklahoma City. Within our apartments, you can choose from spacious one-, two-, and three-bedroom layouts, each featuring modern finishes, ample storage space, and stylish interiors. In addition, select floor plans are available with an optional fireplace, a private balcony or patio, as well as an attached garage, giving you the ability to customize your apartment to best fit your way of life.</p>\n<p>Take the first step toward your new home in Yukon by <a href=\"#schedule-a-tour\"><strong>scheduling a tour today</strong></a>. Each of our apartments is designed with your needs in mind, and our helpful on-site staff is ready to show you every detail. Feel free to <a href=\"/apartments/ok/yukon/the-ridge-66/contact-us\"><strong>contact us</strong></a> for more information, we’re eager to help!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/the-ridge-66::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find the perfect space to call home in one of our <a href=\"/apartments/ok/yukon/the-ridge-66/floor-plans\"><strong>thoughtfully designed floor plans</strong></a> at Ridge at 66 near Oklahoma City. Within our apartments, you can choose from spacious one-, two-, and three-bedroom layouts, each featuring modern finishes, ample storage space, and stylish interiors. In addition, select floor plans are available with an optional fireplace, a private balcony or patio, as well as an attached garage, giving you the ability to customize your apartment to best fit your way of life.</p>\n<p>Take the first step toward your new home in Yukon by <a href=\"#schedule-a-tour\"><strong>scheduling a tour today</strong></a>. Each of our apartments is designed with your needs in mind, and our helpful on-site staff is ready to show you every detail. Feel free to <a href=\"/apartments/ok/yukon/the-ridge-66/contact-us\"><strong>contact us</strong></a> for more information, we’re eager to help!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our versatile <a href=\"/apartments/tx/amarillo/newport-amarillo-apts/floor-plans\"><strong>1 and 2 bedroom</strong></a><strong> </strong>Amarillo apartments for rent are available in seven different layouts to ideally match the dream home you have envisioned. Each of our apartment home layouts is carefully planned with comfort and efficiency in mind so you can enjoy ample living space across all our size options. All of our apartments for rent also have personal balconies, giving you even more freedom to customize your comfort at Newport Apartments. You can also enjoy a wood-burning fireplace in select spaces. Find the best apartments for rent in Amarillo, TX, with Newport Apartments.</p>\n<p>With our cozy environment and premium features, Newport Apartments strikes the ideal balance between comfort and adaptability so you can customize your living space to create your dream home in Amarillo. <a href=\"#schedule-a-tour\"><strong>Schedule your guided tour</strong></a> today for an in-depth look at everything we offer from one of our knowledgeable leasing agents, and please <a href=\"/apartments/tx/amarillo/newport-amarillo-apts/contact-us\"><strong>reach out to us</strong></a> with any questions you may have about our apartments for rent. We are eager to help you find the right apartment home for you!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Each of our Amarillo apartments is built with an open concept that enhances the functionality of your space with luxurious flourishes that give each floor plan a distinct character. Our apartment homes blend a modern, sleek design with a classy feel that elevates your living experience. With <a href=\"/apartments/tx/amarillo/park-at-coulter/floor-plans\"><strong>six distinct floor plans</strong></a><strong> </strong>available with the options for an attached garage, loft, and study, the right fit for you and your family is easy to find.</p>\n<p>Experience the serene environment of our Amarillo apartment homes for yourself by <a href=\"/apartments/tx/amarillo/park-at-coulter/contact-us\"><strong>s</strong></a><strong><a href=\"https://app.tour24now.com/prospect/tour/park-at-coulter/register/\" target=\"_blank\">cheduling your tour</a> </strong>today. Our dedicated management team is our most valuable resource, and we are eager to help you make the dream home you’ve envisioned a reality. Once you are ready to make Park at Coulter your home, complete our <a href=\"https://parkatcoulterapartmentsamarillo.securecafe.com/onlineleasing/park-at-coulter/register.aspx\" target=\"_blank\"><strong>online application</strong></a> to start your journey.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Indulge in the lavishness awaiting you as you step foot into your new abode, where luxury reaches its pinnacle. Picture yourself unwinding on your own private balcony or patio, basking in the serene beauty of the surroundings. Our one-, two-, and three-bedroom apartments boast exceptional <a href=\"/apartments/tx/amarillo/remington-amarillo-apts/floor-plans\"><strong>floor plans</strong></a> that cater to your every need.</p>\n<p>Your next chapter begins at Remington Apartments in Amarillo. From the moment you step into our community, you’ll find comfort, convenience, and the modern flourishes that highlight our upscale standard of living. <a href=\"/apartments/tx/amarillo/remington-amarillo-apts/contact-us\"><strong>Schedule a tour of our community</strong></a> today and explore every corner of your new home in Amarillo.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>You’ll find a delightful selection of 1 and 2 bedroom apartments and loft apartments in southwest Amarillo, TX, at Colonies at Hillside. With ceramic tile flooring in select rooms, and fully equipped kitchens, our luxury apartments offer a perfect combination of functionality and aesthetics. Whether starting your new life, downsizing for retirement, or whatever stage of life you’re in, our 1 and 2 bedroom apartments are ideal. Our <a href=\"/apartments/tx/amarillo/the-colonies-at-hillside/floor-plans\"><strong>floor plans</strong></a> let you live the way you want.</p>\n<p>We offer something for everyone at Colonies at Hillside, a charming community located in southwest Amarillo. We offer a wide range of luxurious living options. Our location near Coulter and Hillside provides easy access to major roads such as I-40 and I-27, making it a hassle-free commute.<br/>You’ll also love the convenience of having a well-stocked grocery store just minutes away with Natural Grocers nearby. <a href=\"/apartments/tx/amarillo/the-colonies-at-hillside/contact-us\"><strong>Schedule a tour</strong></a> online today and begin your journey to a life of comfort and elegance at Colonies at Hillside.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Winchester Apartments of Amarillo features well-designed <a href=\"/apartments/tx/amarillo/winchester-apartments/floor-plans\"><strong>1, 2, and 3 bedroom</strong></a> floor plans with many amenities. Each of our four apartment layouts features a spacious living and dining area for relaxing and unwinding after a long day or hosting guests. We also offer wood-burning fireplaces in select apartment homes for a classic, cozy touch.</p>\n<p>Are you interested in a firsthand view of our Amarillo apartments? <a href=\"/apartments/tx/amarillo/winchester-apartments/contact-us\"><strong>Book a tour</strong></a> of Winchester Apartments in Amarillo, where our welcoming team will guide you through our community. Feel free to inquire about any aspects of our upscale apartment living. If you prefer a <a href=\"/apartments/tx/amarillo/winchester-apartments/self-guided-tour\"><strong>self-guided tour</strong></a>, you’re more than welcome to do so at your leisure.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/acacia-park-apts::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Acacia Park offers four meticulously designed <a href=\"/apartments/tx/el-paso/acacia-park-apts/floor-plans\"><strong>floor plans for 1, 2, and 3 bedroom apartments</strong></a> in West El Paso, TX, to accommodate diverse lifestyles. Our apartments feature open-concept living spaces, spacious closets, a private balcony or patio, and a chef’s kitchen. Even our coziest 1 bedroom apartment features an open-concept kitchen, living, and dining space—perfect for entertaining guests or relaxing with friends and family.</p>\n<p>Your new El Paso apartment home awaits you at Acacia Park Apartments, where you can enjoy all that The Sun City has to offer, from unique restaurants to beautiful parks and hiking trails. If you plan to stay in, you’ll find all the entertainment you need with our resort-inspired community amenities. <strong><a href=\"https://app.tour24now.com/prospect/tour/acacia-park-apartments/register/\" target=\"_blank\">Schedule a tour</a></strong> today, or <a href=\"tel:9184176600\"><strong>call us</strong></a> with any questions you have. If you’re eager to move in, you can <a href=\"https://acaciaparkapartmentselpaso.securecafe.com/onlineleasing/acacia-park-apts/register.aspx\" target=\"_blank\"><strong>apply online</strong></a> today.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/chimneys-apts::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Chimneys Apartments, you’ll find our comfortable and welcoming 1 and 2 bedroom apartments to be the best in West El Paso, TX. Ranging from 480 to 950 sq. ft. in size, our El Paso apartments have patios and balconies and a well-equipped kitchen to boot. Whether you’re starting college, settling down a family, or downsizing in retirement, find the West El Paso apartment home you need among our many <a href=\"/apartments/tx/el-paso/chimneys-apts/floor-plans\"><strong>floor plans</strong></a>.</p>\n<p>For the best apartments to rent in west El Paso, TX, there’s nothing like calling The Chimneys your home. Ready to get started? <a href=\"/apartments/tx/el-paso/chimneys-apts/contact-us\"><strong>Contact our team</strong></a>, give us a <a href=\"tel:9156034061\"><strong>call</strong></a>, or <a href=\"/apartments/tx/el-paso/chimneys-apts/contact-us\"><strong>schedule your tour</strong></a> of our Westside El Paso apartments online today.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Double Tree Apartments in West El Paso, we offer <a href=\"/apartments/tx/el-paso/double-tree-apts/floor-plans\"><strong>1 bedroom and 2 bedroom apartments</strong></a> with a private balcony or patio in four meticulously designed floor plans. Our 1 bedroom apartments have a spacious living and dining area, great for movie nights with friends or pets. For even more space, our 2 bedroom apartment options are perfect for small families or those wanting a guest room or home office. This floor plan provides a spacious living and dining area and an en suite bathroom off the main bedroom.</p>\n<p>Find your perfect El Paso apartment at Double Tree and enjoy peaceful living near gorgeous natural scenery. Whether you spend your free time at Franklin Mountains State Park or practicing your swing at Topgolf, Double Tree Apartments offers luxury living near some of El Paso’s top attractions. <a href=\"/apartments/tx/el-paso/double-tree-apts/contact-us\"><strong>Schedule a tour</strong></a> today, <a href=\"tel:4322230982\"><strong>call us</strong></a>, or complete<strong> </strong>a <a href=\"/apartments/tx/el-paso/double-tree-apts/contact-us\"><strong>contact form</strong></a> to get started. Your new home awaits you!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We have <a href=\"/apartments/tx/el-paso/high-ridge-apts/floor-plans\"><strong>1 bedroom and 2 bedroom apartments</strong></a> in East El Paso with four specific floor plans to suit a variety of lifestyles. Singles and couples can enjoy our 1-bedroom apartment with an upgraded kitchen, washer and dryer connections, and spacious living and dining area. Our 2 bedroom apartments are great for those wanting an office or craft space, couples wanting to spread out, or even small families. These apartments offer spacious closets, a private balcony, and an open floor plan, great for gathering with friends or family.</p>\n<p>Are you ready to check out your new apartment home in El Paso? See our excellent, reasonably-priced apartments with luxury community amenities like a pool, a fitness center, and more. <a href=\"https://app.tour24now.com/prospect/tour/high-ridge/register/\" target=\"_blank\"><strong>Schedule a self-guided tour</strong></a> of our East El Paso apartments today, <a href=\"tel:4322555242\"><strong>call us</strong></a>, or <a href=\"/apartments/tx/el-paso/high-ridge-apts/contact-us\"><strong>fill out a contact form</strong></a>, and get ready to experience a new way of living.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/mountain-village-apts::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Mountain Village, you’ll find cozy and quaint studio apartments, 1 bedroom apartments, and 2 bedroom apartments in West El Paso, TX. These <a href=\"/apartments/tx/el-paso/mountain-village-apts/floor-plans\"><strong>floor plans</strong></a> include a private balcony or patio area—perfect for enjoying your morning coffee or standing outside with a few friends—a well-equipped kitchen, and designer-inspired plush carpeting. Whether you’re looking for your first apartment or downsizing after retirement, you can count on comfortable living with Mountain Village luxury apartments.</p>\n<p>Mountain Village Apartments in West El Paso, TX, is a lovely community with multiple luxurious living options. Located right in the heart of West El Paso, TX, we’re easily accessible from I-10, the CanAm Highway, and many other nearby roads. We’re also near the El Paso International Airport, which is convenient if you travel often. <a href=\"/apartments/tx/el-paso/mountain-village-apts/contact-us\"><strong>Schedule a tour</strong></a> online today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/patriot-apts::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We offer cozy El Paso apartments in a variety of <a href=\"/apartments/tx/el-paso/patriot-apts/floor-plans\"><strong>floor plans</strong></a>, ranging from compact 1 bedroom apartments to spacious 3 bedroom residences. Each of our apartments can be easily adapted to your individual lifestyle, featuring an expansive living room area and lots of closet space. We also offer apartments with an included washer and dryer for your convenience.</p>\n<p>Here at The Patriot, you can easily find an El Paso apartment to suit your needs in our welcoming community. From watching movies with friends and loved ones in your cozy apartment living room to enjoying a cup of coffee in our resident clubhouse, it’s easy to feel at home here.</p>\n<p><br/>Are you interested in taking the next step? <a href=\"/apartments/tx/el-paso/patriot-apts/contact-us\"><strong>Schedule a tour</strong></a> with us and get a firsthand look at our secure, welcoming apartment community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/phoenix-apts::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our wide selection of <a href=\"/apartments/tx/el-paso/phoenix-apts/floor-plans\"><strong>El Paso apartment floor plans</strong></a> makes finding the right apartment for you simple. An open-concept living and dining area is featured in our compact 1 bedroom, 1 bathroom apartment, offering lots of flexibility for you to make the space your own. There’s plenty of space for everyone in our spacious 3 bedroom, 2 bathroom apartment homes, which feature spacious closets and two full bathrooms with bathtubs.</p>\n<p>Our secure, affordable El Paso apartment homes are the perfect backdrop to your lifestyle, with comfortable and convenient amenities and features. <a href=\"/apartments/tx/el-paso/phoenix-apts/contact-us\"><strong>Schedule a tour of The Phoenix</strong></a> and find your next apartment home here in our gated community. Our friendly residence staff is happy to answer potential questions and show you what makes The Phoenix great.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/shadow-ridge-apts::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Browse our spacious and cozy <a href=\"/apartments/tx/el-paso/shadow-ridge-apts/floor-plans\"><strong>floor plans</strong></a> at Shadow Ridge to select your luxury apartment. Studio, 1 bedroom, 2 bedroom, and 3 bedroom apartments are available in East El Paso. Whether you’re enjoying the view from your balcony or patio or making a delicious meal in your well-equipped kitchen, kick back, relax, and make one of our El Paso apartment homes your home.</p>\n<p>Our team at Shadow Ridge Apartments is eager to have you join our El Paso community. Explore Shadow Ridge online or in person, and when you are ready to rent one of the best luxury apartments in El Paso, TX, <a href=\"/apartments/tx/el-paso/shadow-ridge-apts/contact-us\"><strong>fill out our online contact form</strong></a>, give us a <a href=\"tel:209159742090\"><strong>call</strong></a>, or <a href=\"/apartments/tx/el-paso/shadow-ridge-apts/contact-us\"><strong>schedule your tour</strong></a> with us today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Crest, we offer a range of apartment <a href=\"/apartments/tx/el-paso/the-crest/floor-plans\"><strong>floor plans</strong></a> to suit your lifestyle needs. From our cozy yet functional 1 bedroom apartments to our spacious 3 bedroom layouts, you’ll find the perfect space to call home. Starting at 605 sq. ft. in our 1 bedroom layouts, our apartments range in size up to 1036 sq. ft. in our 3 bedroom floor plans, providing plenty of room to live, work, and play.</p>\n<p>Each apartment size offers the option for a private patio, where you can enjoy the beautiful El Paso weather and stunning views of the surrounding landscape. Additionally, select floor plans feature an in-home fireplace, adding warmth and ambiance to your living space during the cooler months. </p>\n<p>Your new El Paso apartment home awaits you at The Crest, where you’ll find comfortable apartments to suit any lifestyle in a tranquil neighborhood. Whether you prefer binge-watching your favorite shows, hosting dinner parties, or spending quality time with family, our community has everything you need for a satisfying and stress-free life. Schedule a tour with us to see if The Crest is the right fit for you, and when you are ready to take the next step, <a href=\"https://crestapartmentselpaso.securecafe.com/onlineleasing/the-crest/register.aspx\" target=\"_blank\"><strong>apply online</strong></a> to reserve  your new home today.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/hewitt/icon-at-hewitt::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Icon at Hewitt offers you and your family the best 1 and 2 bedroom apartment homes and luxury townhome rentals in Hewitt, TX. Our spacious and thorough <a href=\"/apartments/tx/hewitt/icon-at-hewitt/floor-plans\"><strong>floor plans</strong></a> come in a variety of sizes ranging from 789 sq. ft. to 1,267 sq. ft. With our many amenities included, such as a private balcony and patio, our Hewitt apartments are your ideal place to call home.</p>\n<p>Our team at Icon at Hewitt Apartments is ready to welcome you into our exciting community. Give us a <a href=\"tel:2546332916\"><strong>call</strong></a>, <a href=\"/apartments/tx/hewitt/icon-at-hewitt/contact-us\"><strong>contact us</strong></a>, or <a href=\"/apartments/tx/hewitt/icon-at-hewitt/contact-us\"><strong>schedule your tour</strong></a> of our property online at our Hewitt apartment homes today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Settle in with ease when you step inside a spacious floor plan. Each of our homes include a fully equipped gourmet kitchen, <a href=\"/apartments/tx/lubbock/cottages-at-abbey-glen/amenities\"><strong>washer and dryer connections</strong></a>, and large walk-in closets. Some of our homes include a cozy fireplace and a patio or balcony. Utilize the extra “flex space” feature in select floor plans for a dining room, lounge, or office area.</p>\n<p>If you’re ready to explore our apartments, <a href=\"/apartments/tx/lubbock/cottages-at-abbey-glen/contact-us\"><strong>schedule a tour</strong></a> with our resident staff and come see our upscale apartments in Lubbock. Your tour guide will be happy to answer questions about our Lubbock apartment community and show you around. When you’re ready to call the Cottages at Abbey Glen home, <a href=\"https://cottagesatabbeyglenapartmentslubbock.securecafe.com/onlineleasing/cottages-at-abbey-glen/register.aspx\" target=\"_blank\"><strong>apply online</strong></a>. We’re excited to welcome you home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Here at The Icon at Lubbock, you’ll find the best <a href=\"/apartments/tx/lubbock/icon-at-lubbock/floor-plans\"><strong>floor plans</strong></a> for our 1 bedroom apartments in Lubbock, TX, and 2 bedroom apartments in Lubbock, TX. With plenty of closet space, cozy fireplaces, and generous bathrooms, our pet-friendly apartments in Lubbock range from 789 to 1,176 sq. ft. Whether starting a family, attending Texas Tech University, or looking for a peaceful retirement home, you’ll find a perfect luxury apartment home here.</p>\n<p>Get ready to experience the unparalleled joy of apartment living at The Icon at Lubbock, where you’ll find the best luxury apartments for rent in southwest Lubbock, TX. Need more information about our apartment rentals? <a href=\"/apartments/tx/lubbock/icon-at-lubbock/contact-us\"><strong>Get in touch</strong></a> with our dedicated team, <a href=\"tel:8068538789\"><strong>give us a call</strong></a>, or <a href=\"/apartments/tx/lubbock/icon-at-lubbock/contact-us\"><strong>book your tour online</strong></a> to find the right apartment with the right number of bedrooms for you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Tuscany Place offers several 1 and 2 bedroom apartment <a href=\"/apartments/tx/lubbock/tuscany-place/floor-plans\"><strong>floor plans</strong></a> in Lubbock, ranging from 790 sq. ft. to 1,180 sq. ft. We even offer loft apartments in Lubbock for couples, families, or single residents who want the opportunity to spread out. All our apartments feature a cozy dining and living area and large closets so you can live comfortably.</p>\n<p>Want to see our Lubbock apartments for yourself? <a href=\"/apartments/tx/lubbock/tuscany-place/contact-us\"><strong>Schedule a tour</strong></a> today! Our resident staff are ready to lead you on a tour of our community so you can see if we’re the right fit for you and your family. We even offer a <strong><span style=\"text-decoration: underline;\"><a href=\"https://app.tour24now.com/prospect/tour/tuscany-place/register/\" target=\"_blank\">self-guided tour</a></span></strong> option if you’d prefer to peruse at your own pace. When you’re ready to call Tuscany Place home, <a href=\"https://tuscanyplaceapartmentslubbock.securecafe.com/onlineleasing/tuscany-place/register.aspx\" target=\"_blank\"><strong>fill out an application</strong></a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/temple/portico-at-friars-creek-apts::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Whether you’ve recently begun living on your own or are part of a family needing additional space, our apartments and lofts are a high-quality choice in Temple. Our spacious <a href=\"/apartments/tx/temple/portico-at-friars-creek-apts/floor-plans\"><strong>floor plans</strong></a> include 1 bedroom apartments in Temple, TX, at 790 sq. ft. to 2 bedroom apartments in Temple, TX, at 1,270 sq. ft. Choose your perfect apartment home and create a paradise at Portico at Friars Creek in Temple, TX.</p>\n<p>Moving to The Portico at Friars Creek is your key to unlocking luxury apartment living in an inviting and exciting community in Temple, TX. Give our team a <a href=\"tel:2547950179\"><strong>call</strong></a> or <a href=\"/apartments/tx/temple/portico-at-friars-creek-apts/contact-us\"><strong>schedule your tour</strong></a> online to rent your Temple apartment today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>With 1 bedroom apartments, 2 bedroom apartments, and even lofts and townhomes in Waco, TX, you’re sure to find a <a href=\"/apartments/tx/waco/bend-at-new-road/floor-plans\"><strong>floor plan</strong></a> that works for you. For those looking for a more compact space, suitable for one or two residents, consider our 1 bedroom apartments in Waco, TX that offer 1 bathroom at 790 sq. ft. If you need more room for family or simply want lots of space for yourself, check out our 2 bedroom apartments in Waco, TX, complete with an attached garage available.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/tuscany-ranch-apartments::propertyfloorplans.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Here at Tuscany Ranch, you can choose between one of our many 1 and 2 bedroom luxury apartments and townhomes in our Waco apartment community. We offer 1 bedroom apartments in Waco, TX starting at 790 sq. ft., and 2 bedroom apartments in Waco, TX, starting at 1,180 sq. ft. You can enjoy a home-cooked meal with our fully equipped kitchen or take in the views from your private patio or balcony.</p><p>Our welcoming and inviting community at Tuscany Ranch Apartments is ready to welcome you into your new home. Ready to experience luxury living in Waco, TX? <a class=\"richtext-link\" href=\"/apartments/tx/waco/tuscany-ranch-apartments/contact-us\"><strong>Contact us</strong></a> online or give our team a <a class=\"richtext-link\" href=\"tel:2543070929\"><strong>call</strong></a> to start today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments::propertyfloorplans.title": {
    "overrideType": "VALUE",
    "customValue": "Apartment Floor Plans for Rent",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/newport-wichita-apts::propertyfloorplans.title": {
    "overrideType": "VALUE",
    "customValue": "Apartment Floor Plans for Rent",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/raintree-apartments::propertyfloorplans.title": {
    "overrideType": "VALUE",
    "customValue": "Apartment Floor Plans for Rent",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/remington-wichita-apts::propertyfloorplans.title": {
    "overrideType": "VALUE",
    "customValue": "Apartment Floor Plans for Rent",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments::propertyfloorplans.title": {
    "overrideType": "VALUE",
    "customValue": "Apartment Floor Plans for Rent",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail::propertyfloorplans.title": {
    "overrideType": "VALUE",
    "customValue": "Luxury Duplex Floor Plans for Rent",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/maize/watercress-apartments/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Watercress Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Aspen Park Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at the Cottages at Crestview",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/crown-chase-apts/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Crown Chase",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/huntington-park/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Huntington Park",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/newport-wichita-apts/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Newport Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/raintree-apartments/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Raintree Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/remington-wichita/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living in The Remington Apartment Homes",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/silver-springs-apts/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living in Silver Springs",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living in Villas of Waterford Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/independence/the-adirondack/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Adirondack Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/97-north-oak/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at 97 @ North Oak",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/trace-apts/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at The Trace of Ridgeland",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Trails at Aspen Creek in Broken Arrow, OK",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/fountain-lake/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Fountain Lake",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Villas at Stonebridge",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/moore/mission-point/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Mission Point",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/artisan-crossing-apts/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Artisan Crossing",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Cimarron Trails",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at 24Hundred in Oklahoma City, OK",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Chisholm Pointe",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Cimarron Pointe",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Council Place",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Cross Timber",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Crown Pointe",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter's-ridge-apts/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Hunter’s Ridge",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/park-at-tuscany/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Park at Tuscany",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/persimmon-square-apartments/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Persimmon Square",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Prairie Springs",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/stonehorse-crossing/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Stonehorse Crossing",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summerfield-place-apts/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Summerfield Place",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/tammaron-village-apartments/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Tammaron Village",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/warrington-apartments/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at the Warrington Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Waters Edge Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/coffee-creek/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Coffee Creek Luxury Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at The Cottages at Tallgrass Point",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/barrington-apartments/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently asked questions about Barrington Apartments floor plans in Tulsa, OK",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cascata-luxury-apartments/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Are apartments with attached garages available at Cascata Luxury Apartments in Tulsa, OK?",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-glade-apts/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently asked questions about Cedar Glade Apartments floor plans in Tulsa, OK",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living in Cedar Ridge Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living in Chardonnay Apartment Homes",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living in Country Hollow Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at The Park at Westpointe",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/the-ridge-@-66/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at The Ridge @ 66",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/hewitt/icon-at-hewitt/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at The Icon at Hewitt",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Icon at Lubbock in Lubbock, TX",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/temple/portico-at-friars-creek-apts/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Portico at Friars Creek in Temple, TX",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Bend at New Road",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/tuscany-ranch-apartments/floor-plans::propertyfloorplansfaq.heading": {
    "overrideType": "VALUE",
    "customValue": "Frequently Asked Questions About Apartment Living at Tuscany Ranch in Waco, TX",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 1 bedroom apartments are a haven for young professionals and singles seeking a cozy, stylish space to call home. Choose from 636 to 702 square foot floor plans for our 1 bedrooms in Little Rock. Featuring high ceilings, these apartments exude an open and airy feel. Enjoy the convenience of a washer and dryer in your unit, private outdoor patios or balconies for relaxation, and spacious closets for organization.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/north-little-rock/lexington-park/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Lexington Park’s 1 bedroom apartment homes offer plentiful space, with a roomy living area with lots of natural light and nine-foot ceilings, available in select apartment homes. The full kitchen makes meal preparation a breeze while boasting elegant touches, like granite countertops and white kitchen cabinetry.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/maize/watercress-apartments/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience our 1 bedroom apartments, featuring a snug living area complemented by a warm LED fireplace in specific residences, providing a cozy retreat during chilly weather. With our 1 bedroom, 1 bathroom layout with flex space, you can display your plant collection, create a reading corner, or design a serene yoga sanctuary.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our <span data-type=\"field-token\" data-field=\"property_address_city\"></span> 1-bedroom apartments feature ample living room areas with plenty of space for plush couches, coffee tables, and personalized furnishings.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Make yourself at home in one of our 1 bedroom apartments in Wichita, where you’ll enjoy 789 sq. ft. of living space. Consider our 1 bed/1 bath with a bumpout, which features an extra space off the living room to accommodate a dining area, reading nook, or even a craft corner. Large 1 bedroom lofts are also available, featuring 966 sq. ft. of room for living your best life, and with the option for an attached garage, you’ll have all the space you need to live with comfort and convenience.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/crown-chase-apts/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 1 bedroom Wichita apartments include a spacious, open-concept living and dining area next to a large kitchen and a full bathroom and bedroom. The expansive bedroom closet features plenty of room to store your wardrobe, and the many windows throughout our 1 bedroom apartments allow bright natural light to stream in.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/huntington-park/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Each of our Wichita 1 bedroom apartments includes a roomy, open-concept living and dining space near the fully equipped kitchen. Spacious closets make wardrobe storage simple, while the large bedroom features lots of energizing natural light. Select apartment homes feature a cozy fireplace that will help you get cozy on winter nights.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/newport-wichita-apts/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Make maximum use of your space in the open-concept layout of our 1 bedroom apartments in Wichita, KS. Rays of sunshine will greet you as you stroll through the front door into your living room, a versatile living space that can easily accommodate a dining area or office with room to spare. Your full kitchen borders convenient storage closets, including washer and dryer connections, that give you the storage space to keep your essentials organized while your apartment remains open and welcoming.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/portofino/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 1 bedroom apartments provide a luxurious living space that makes no compromises. Balancing style with convenience, your kitchen’s kit of stainless steel appliances is complemented by vast counter space and ceramic tile flooring. The expansive bedrooms can accommodate mattresses of all sizes with room to spare and deep closets that are great for keeping every season’s wardrobe ready all year while still leaving room for storage. When it comes time to decorate, you’ll find the accent walls in our apartments with premium lighting make any artwork stand out, making a statement that echoes your personal style for anyone who walks through the door.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/raintree-apartments/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>If you’re seeking more space than a studio apartment, our chic 1 bedroom apartments provide approximately 750 sq. ft. of living area. The expansive kitchen with an adjoining dining area is ideal for delightful dinner parties and engaging game nights.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/remington-wichita-apts/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our <span data-type=\"field-token\" data-field=\"property_address_city\"></span> 1-bedroom apartments feature ample living room areas with plenty of space for plush couches, coffee tables, and personalized furnishings.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/remington-wichita/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore our two distinct 1 bedroom layouts at The Remington Apartments in Wichita, one of which includes a wood-burning fireplace.</p>\n<p>The full-size washer and dryer connections add practicality to your living space. Additionally, spacious bedroom closets provide ample storage for your wardrobe. Select apartment homes offer additional comforts and conveniences, such as extra storage and ceiling fans, for an enhanced living experience.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/silver-springs-apts/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Silver Springs offers 1 bedroom apartments featuring a 1 bedroom, 1 bathroom layout and the choice of optional washer and dryer connections. Opt for a 1 bedroom apartment equipped with washer and dryer connections to streamline your laundry routine. Our compact but comfortable 1 bedroom floor plan spans 750 sq. ft., presenting a generous living room area complemented by a private balcony or patio.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our luxury 1 bedroom apartment homes at the Villas of Waterford provide the ultimate living experience. They have spacious, open living and dining areas perfect for relaxing with family and entertaining friends. The gourmet kitchen includes a breakfast bar, while the apartment offers functional features like washer and dryer connections, making it convenient to take care of day-to-day chores.</p>\n<p>We have great options if you prefer a loft-style 1 bedroom apartment with an attached garage and vaulted ceilings. With our unbeatable amenities and prime location, Villas of Waterford is the ideal place to call home in northeast Wichita.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/belton/center-301/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The thoughtful designs of our 1 bedroom apartment floor plans are made to suit a variety of lifestyles, with spaces ranging from 789 sq. ft. to 1,125 sq. ft. Our 1 bedroom, 1 bathroom flex space floor plan features an extra alcove off the living room to accommodate a dining area, reading nook, or additional storage. Similarly, our 1 bedroom townhomes in Belton offer ample room to get comfortable and decorate, with an open-concept kitchen, dining area, and living area downstairs and a spacious bedroom, full bathroom, and large closet upstairs. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/independence/the-adirondack/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the comfort and convenience of luxury living at The Adirondack Apartments, where you’ll find a range of cozy 1 bedroom apartments in Independence, MO, equipped with open-concept dining and living areas, spacious closets, washer and dryer connections, and all the amenities you need to live your best life. We have three 1 bedroom floor plans ranging in size from 789 sq. ft. to a generous 1125 sq. ft. with options for a fireplace. </p>\n<p>Imagine cuddling up near the fire with your beloved kitten or pup or cooking a meal for your loved ones in your well-equipped kitchen with stainless steel appliances. Whether you’re seeking independence or sharing with a partner, you’ll find the ideal space to call your own at The Adirondack Apartments.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/97-north-oak/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Make yourself at home in one of our 1 bedroom apartments in Kansas City, MO, with floor plans ranging from 789 sq. ft. to 966 sq. ft. In our 1 bedroom, 1 bathroom bump out layout, you’ll enjoy some extra space, where you may curate a reading nook, yoga corner, or dining area. Find additional space and comfort in our 1 bedroom loft. Pull into your attached garage, where you’ll head upstairs to be greeted by a handy coat closet and a cozy living room.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/mark-apts/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 1-bedroom apartments at Mark Apts. offer a comfortable layout designed for solo residents or couples. Each home includes a full-sized kitchen, generous closet space, and a private patio or balcony — perfect for relaxing after a long day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/sunchase-ridgeland-apts/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 1-bedroom apartments at Sunchase Ridgeland Apts. offer a comfortable layout designed for solo residents or couples. Each home includes a full-sized kitchen, generous closet space, and a private patio or balcony — perfect for relaxing after a long day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/trace-apts/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 1-bedroom apartments at Trace Apts. offer a comfortable layout designed for solo residents or couples. Each home includes a full-sized kitchen, generous closet space, and a private patio or balcony — perfect for relaxing after a long day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We offer 1 bedroom apartments and lofts in three separate layouts, offering 789 to 966 sq. ft. of living space. In our 1 bedroom apartment homes, a spacious living area is the perfect place to relax and recharge after a long day, featuring an open layout that connects to an adorable dining nook. Several of our 1 bedroom apartments also include a private balcony or patio, ideal for enjoying morning coffee or afternoon tea.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Park at Mission Hills 1 bedroom apartments put you at the center of attention with a lavishly proportioned bedroom and a conveniently organized kitchen with ample counter space that is lifted and ready for bar stools. The ambient lighting from multiple wide windows brings a natural calmness to each morning and creates a bright yet focused working environment in your alcove or optional patio.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/redbud-ranch/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Redbud Ranch, our 1 bedroom apartments feature generously sized bedrooms and full bathrooms, complemented by spacious open living and dining areas that create an inviting, relaxing atmosphere.</p>\n<p>If you require additional space for a desk, bookshelf, or plants, our 1 bed/1 bath apartment with a nook might be the ideal fit. For those seeking added privacy and convenience for their morning commute, we offer 1 bedroom town houses or lofts with attached garages.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Scissortail Crossing in Broken Arrow, OK, offers three comfortable 1 bedroom floor plans ranging from 800 to 1,000 sq. ft. For those who work from home, our 1 bedroom apartment with a bumpout provides the ideal solution, allowing you to create a separate office space away from your bedroom’s relaxation. The generous living area in each of our 1 bedroom apartments provides ample room for unwinding after a long day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our cozy 1 bedroom apartments in Broken Arrow, OK are perfect for those looking for additional privacy without sacrificing luxury and comfort. We also offer luxury townhomes, and lofts for more unique living options. Each apartment home has expansive high ceilings to create a spacious and welcoming atmosphere and high-quality stainless steel kitchen appliances, providing our residents with the essential tools to prepare exquisite meals for entertaining guests. You’ll love our apartment homes with private patios or balconies if you’re passionate about plants. They provide the perfect space for cultivating potted plants, herbs, and vegetables.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 1 bedroom apartments at Villas at Aspen Park are stylish and elegant, designed to provide maximum convenience and comfort. Entertain your guests in the spacious open-concept living, dining, and kitchen areas perfect for hosting family dinner parties. The updated kitchen with a peninsula provides ample barstool space, making it a culinary haven for all your cooking needs.</p>\n<p>Enjoy a hassle-free lifestyle with practical features such as washer and dryer connections, a dishwasher, and energy-efficient appliances. We also offer fantastic loft-style 1 bedroom apartments with attached garages for those who prefer to park their vehicle inside. Situated in a prime location in Broken Arrow, our unbeatable amenities and designer features make Villas at Aspen Park the perfect place to call home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/fountain-lake/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Each of our 1 bedroom Edmond apartments features a spacious living area that greets you right as you walk through the door. When you select our 1 bedroom flex space option, you’ll also enjoy an extra nook off the living room, ideal for a dining area or reading corner. The large bathroom features a well-lit vanity for getting ready and washer and dryer connections to make laundry day easier.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At the Villas at Stonebridge, our 1 bedroom apartments blend luxury and practicality. With three distinctive floor plans ranging from 789 sq. ft. to 805 sq. ft., these apartments offer comfortable and stylish living space. Whether you’re looking for a serene retreat for a night in or a cozy area to throw a birthday bash, our 1 bedroom apartments at the Villas at Stonebridge are designed to meet your needs. Experience a charming lifestyle in Edmond without compromising on practicality.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Featuring contemporary design elements and thoughtful layouts, our 1 bedroom apartments are available in three floor plans ranging in size from 789 to 860 sq. ft., adding a level of customizability to your living experience. While the private patio or balcony makes for an excellent setting for your morning coffee, the option for an added bumpout can create the perfect space for an office, reading nook, or just a little more room for your larger furniture.</p>\n<p>Attached garages are also available, giving you a level of convenience that can be difficult to find elsewhere. The kitchens are well appointed with stainless steel appliances and a remarkable amount of room to cook and clean on our custom-made countertops, giving you the tools to entertain on date nights, family gatherings, and every other special occasion in between.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/moore/mission-point/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Step into the open-concept layout of our 1 bedroom apartments, where you’ll find versatile living spaces flooded with natural light. <a href=\"/apartments/ok/moore/mission-point/amenities\"><strong>Modern stainless steel appliances</strong></a> grace the fully equipped kitchens, while the unique floor plans offer an extra dining or office nook, providing flexibility to suit your needs. Select apartments feature fireplaces and private patios or balconies, creating an ideal retreat for relaxation.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/artisan-crossing-apts/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We offer 1 bedroom <a href=\"/apartments/ok/norman/artisan-crossing-apts/neighborhood\"><strong>apartments and lofts in Norman</strong></a> with a cozy optional fireplace in the spacious living area. When you select our 1 bedroom loft option, you’ll also be able to enjoy an attached garage for added privacy and convenience. Each of our 1 bedroom apartments includes a full bathroom with a tub for luxurious bubble baths and expansive closets.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>When it comes to 1 bedroom apartments, we offer two floor plan options ranging between 550 and 660 sq. ft. Each of our 1 bedroom apartments features an entryway living and dining area. Made complete with cozy chairs or couches, the cozy living area features plush carpeting and double doors to the private balcony or patio. In the full bathroom, a tub awaits your next bubble bath.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 1 bedroom apartments are designed to impress in Oklahoma City, seamlessly blending comfort and style. With a generous living space of 683 sq. ft., these apartment homes are stylish and comfortable, perfect for young professionals or couples seeking a spellbinding lifestyle without sacrificing practicality.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Council Place offers two floor plan options for 1 bedroom apartments: a 1 bed/1 bath and a 1 bed/1 bath with a den. Our 1 bedroom apartment floor plan offers 700 sq. ft. which includes a spacious living room area, as well as a private balcony or patio. For extra space, select the 1 bedroom apartment with a den ideal for a home office, a game room, or a study.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our large 1 bedroom apartments in OKC span 800 sq. ft. and feature a roomy living and dining area in addition to a spacious bedroom and bathroom. Thanks to the expansive bedroom closet, storing your wardrobe will be a cinch. Several of our 1 bedroom apartments include a living room fireplace for added coziness.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter's-ridge-apts/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Hunter’s Ridge features six unique 1 bedroom apartment floor plans, ranging in size from 525 to 838 sq. ft. No matter which of our floor plans you choose, each of our OKC 1 bedroom apartments includes a comfortable living and dining area right next to the large kitchen. All our 1 bedroom apartment homes also feature expansive closets with plenty of storage space.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/park-at-tuscany/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 1 bedroom apartments in Oklahoma City are ideal for single renters. Spacious, pet-friendly, and designed with an open concept, these homes are designed with comfort and versatility at their core. Enjoy ample space to maneuver and store in your chef-inspired kitchen with barstool-ready countertops and premium tile for an easy-to-clean luxurious look. Customize your space with the options for a fireplace, a bumpout, or an attached loft with a garage to create a living space personalized for you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/persimmon-square-apartments/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 1 bedroom apartments at Persimmon Square Apartments in Oklahoma City offer the perfect blend of comfort and convenience. With open floor plans and <a href=\"/apartments/ok/oklahoma-city/persimmon-square-apartments/amenities\"><strong>modern amenities</strong></a>, these apartments provide an inviting space to call home. Enjoy ample natural light, well-designed living areas, and the flexibility to create your ideal living environment by having the option to choose between a small, mid-size, or large 1 bed.</p>\n<p>Whether you’re looking for a peaceful retreat or a welcoming space to entertain, our 1 bedroom apartments offer the versatility you desire. The advantages of spacious living with easy access to the vibrant OKC community make Persimmon Square Apartments the ideal choice for your lifestyle.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 1 bedroom homes are available in six highly adaptable layouts to fit the home you’ve imagined. Deep closets come standard across all our size options, along with ceiling fans and shaded windows that allow the perfect amount of ambient light into your home. Select apartments are available with an extended porch, wood-burning fireplace, and</p>\n<p> an additional den that could make the ideal office or entertainment room. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/stonehorse-crossing/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 1 bedroom <a href=\"/apartments/ok/oklahoma-city/stonehorse-crossing/neighborhood\"><strong>apartments in Oklahoma City</strong></a> offer a sizable living space, perfect for single renters. Each layout features an open-concept layout that maximizes space and natural light, creating an inviting atmosphere for everyone who enters. Specific floor plans include a corner bumpout, an ideal area for an office or reading nook, as well as an LED fireplace so you can keep comfortable in the winter months without the hassle of firewood.<br/><br/>Our 1 bedroom townhomes take versatility to the next level with a loft, an expanded closet, and an attached garage. You can also enjoy a larger workspace in the kitchen, an optional balcony, and a gorgeous view of our courtyard when you choose this upscaled option.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summerfield-place-apts/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience unmatched comfort and style in our 1 bedroom apartments at Summerfield Place in Oklahoma City. These apartments boast spacious living rooms and dining areas, perfect for entertainment and relaxation. Indulge in luxury with a bathtub in the bathroom, which is ideal for unwinding with soothing bubble baths.</p>\n<p>Whether you’re an individual or a couple seeking a cozy retreat in the lively city of Oklahoma City, our 1 bedroom apartments provide a harmonious fusion of convenience and elegance. Discover the pinnacle of modern living at Summerfield Place Apartments.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/tammaron-village-apartments/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the ideal residence in Oklahoma City with our expansive 1 bedroom apartments, designed to be your sanctuary. Upon entry, you’ll notice a delightful living space featuring a sizable window, a snug dining area, and a well-equipped kitchen. Retreat to the roomy bedroom with a generous closet to fit all you need.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/warrington-apartments/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Unwind in our expansive 1 bedroom apartments and townhomes in Oklahoma City. Choose from a diverse range of 1 bedroom apartments, including small options, standard layouts, and apartments with a den, which provide extra space for various activities, necessities, and hobbies beyond a typical bedroom.</p>\n<p>Each of our 1 bedroom residences features a comfortable living and dining area near the kitchen, facilitating easy meal prep and entertainment. Moreover, enjoy the added convenience of a washer and dryer, which simplifies keeping your wardrobe fresh and clean.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Whether you’re living with your partner or want more space, step up to a 1 bedroom apartment for additional room and comfort. Our 1 bedroom apartments measure 613 sq. ft. and are equipped with a balcony or patio and an in-home washer and dryer.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our <span data-type=\"field-token\" data-field=\"property_address_city\"></span> 1-bedroom duplexes feature ample living room areas with plenty of space for plush couches, coffee tables, and personalized furnishings.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/coffee-creek/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The first thing you’ll notice as you step into your 1 bedroom apartment is the accent wall with chair rail molding across from the entrance, the perfect place for paintings or hanging decorations to pop with vibrance. The wall-to-wall carpeting is cushioned and comfortable, a feature loved by our residents and their <a href=\"/apartments/ok/owasso/coffee-creek/pet-policy\"><strong>pets</strong></a>, and floor plans are available with the options for a flex space living room extension, a private patio, and an attached garage in select homes for unparalleled convenience.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>One of the standout features of our 1 bedroom apartments is their openness and versatility. The brightly lit living room can accommodate sofas and multiple tables for dining and entertainment with room to spare, and the optional bumpout makes for a perfect nook for reading, studying, or as a corner office. Stepping into the bedroom, you’ll find a spacious living area and a deep closet coupled with easy access to the front door and your private patio, allowing you to relax in your cozy home as soon as you step over the threshold.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cypress-crossing/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>If you’re looking for a cozy and private space, our 1 bedroom apartments are just for you, with the perfect balance of comfort and style. </p>\n<p>Our personal apartments in Owasso offer a comfortable space for singles or couples looking for a low-maintenance home without compromising on quality. With modern kitchens featuring custom cabinetry and large living rooms with ample lighting from multiple expansive windows, you’ll have plenty of space to entertain or live lavishly in your private apartment home.</p>\n<p>For those who want something a little different from their apartment home experience, our townhomes and lofts combine style and functionality in unique layouts only available at Cypress Crossing. Townhomes offer multilevel living with private entrances and spacious floor plans, while our lofts bring a trendy, open-concept design that makes a bold statement. Whether you’re looking for contemporary charm or room to spread out, our living options in Owasso bring something for everyone!<br/></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/pryor/west-530/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our <span data-type=\"field-token\" data-field=\"property_address_city\"></span> 1-bedroom apartments, and townhouses feature ample living room areas with plenty of space for plush couches, coffee tables, and personalized furnishings.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/stillwater/apple-creek-stillwater/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-left\">Start your mornings by sipping coffee or tea on your 1 bedroom apartment’s private balcony or patio, right off your living area. Along with a living area and a small dining nook, you’ll enjoy a cozy bathroom, complete with a tub for bubble baths. Stylish hardwood flooring and a tiled kitchen adds character to your home while the soft carpets in your bedroom will keep you comfortable every time you start your day. We also offer select 1 bedroom apartments with an included washer and dryer for optimal convenience.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/barrington-apartments/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 1 bedroom floor plans offer up to 855 sq. ft. of space, with a spacious closet and private balcony or patio. When you select our large 1 bedroom flat, you’ll enjoy a nook attached to the living room, ideal for a yoga corner, cozy reading area, or extra storage. Our 1 bedroom apartments also include full kitchens with a double sink and lots of counter space, great for adding bar stools.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cascata-luxury-apartments/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Cascata’s 1 bedroom apartment options offer a graciously sized bedroom and full bathroom, along with an expansive open living and dining area that invites you to sit back and relax. You may find that our 1 bedroom, 1 bathroom apartment with a nook is the right fit for you, providing extra space for a desk, bookshelves, or houseplants. If it’s extra privacy you’re looking for, consider our 1 bedroom apartment with an attached garage to streamline your morning commute.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-glade-apts/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 1 bedroom apartments in Tulsa offer abundant space for getting cozy, with a wide-open living and dining area right next to the kitchen for easy meal preparation or hosting guests. In the spacious bedroom, you’ll also enjoy a spacious closet with plenty of room for clothing and shoes. The included washer and dryer connections allow you to simplify your laundry days and use your own appliances.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Come home to one of our 1 bedroom apartments and relax in your own personal oasis. You’ll enter the welcoming, cozy living area, complete with an LED fireplace in select homes for warming up when the weather turns chilly. If you choose our 1 bedroom, 1 bathroom flex space floor plan, you’ll find an extra nook off your living room, great for displaying your plant collection, setting up a reading nook, or creating a yoga corner.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Chardonnay’s 1 bedroom apartments in Tulsa are the ideal backdrop to your daily life, equipped with all the essential features you need and an open-concept layout that maximizes your space. As you enter, you’ll be welcomed by the cozy living and dining areas, with plenty of space for a cozy couch and bistro table. Right next to the spacious, fully equipped kitchen, your in-unit washer and dryer await your next laundry day. Around your apartment, you’ll also find spacious closets for stowing clothing and other items. Schedule a tour or <a href=\"https://viewer.panoskin.com/?tour=5f478c4cd25e9a53a51433fe\" rel=\"noreferrer noopener\" target=\"_blank\"><strong>check out our virtual tour</strong></a> now!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 1-bedroom apartments at Country Hollow Apartments offer a comfortable layout designed for solo residents or couples. Each home includes a full-sized kitchen, generous closet space, and a private patio or balcony — perfect for relaxing after a long day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/creekwood-apartments/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>If you’re searching for a 1 bedroom apartment in Tulsa, we’ve got you covered. Creekwood offers nine unique 1 bedroom layouts, including private patio or sunroom space options. Next to the full kitchen, a laundry nook awaits your next cleaning day, and the spacious closets have plenty of room for your wardrobe. Select apartment homes also include a kitchen island with space for barstools, the ideal spot for a coffee corner or mini bar.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/nickel-creek-apts/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Ranging from 789 sq. ft. to 856 sq. ft., our 1 bedroom apartments are great for those who are living alone, with a partner, or with a furry friend. All our apartment units have large closets, an electronic thermostat, and washer and dryer connections for added convenience. Looking for additional luxury? Select a unit with an optional fireplace, bumpout, or attached garage.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/polo-run-apartments/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Enjoy your morning coffee or tea directly from the comfort of your living area in your 1 bedroom apartment or private balcony or patio. The apartment features a spacious living area, a charming dining nook, and a cozy bathroom complete with a relaxing tub for indulgent bubble baths. Additionally, our 1 bedroom apartments come equipped with convenient washer and dryer connections.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our beautiful 1 bedroom apartments at Sheridan Pond epitomize simple yet stylish living, offering abundant comfort and style for individuals or couples. Each meticulously crafted apartment seamlessly blends functionality and aesthetics to create a welcoming environment. Experience the allure of modern living in our charming 1 bedroom Tulsa apartments at Sheridan Pond, complete with spacious kitchens and cozy living areas.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 1 bedroom apartments at Sugarberry balance functionality and luxury, offering comfort and style with 700 sq. ft. of space. Whether you crave a relaxing retreat or a space to entertain a few guests, our apartment community caters to your every need. Immerse yourself in the charm of south Tulsa living with our exceptional 1 bedroom offerings at Sugarberry Apartments.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience the comfort of a deluxe or standard 1 bedroom apartment boasting 725 sq. ft. of space. Enjoy the luminous and open living room and a generous closet in the bedroom. Your 1 bedroom abode showcases a vibrant living area with a balcony or patio, providing ample room for cozy movie nights and gatherings with your loved ones.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We offer five different 1 bedroom apartment floor plans ranging from 550 sq. ft. to 740 sq. ft. of room. As you enter your cozy 1 bedroom apartment, you’ll immediately feel at home walking into the welcoming living and dining area right next to your fully equipped kitchen. Several of our 1 bedroom apartment homes also include a private balcony or patio where you can relax and enjoy the view of our lush courtyards.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Make yourself at home in one of our large 1 bedroom apartments in Tulsa. As you enter your 1 bedroom apartment home, a charming living room with bay windows greets you, located next to a cozy dining nook and fully equipped kitchen. The roomy bedroom is made complete with a spacious closet.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>In our 1 bedroom Tulsa apartments, you’ll discover a generous open-plan living and dining area adjacent to a spacious kitchen, a full bathroom, and a cozy bedroom.</p>\n<p>Take advantage of the ample closet space provided for your wardrobe needs, and relish the extension of your living area to the outdoors through a balcony or patio, inviting abundant natural light indoors. Elevate your living experience with our 1 bedroom townhomes, equipped with comforting fireplaces for enhanced warmth and ambience.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start each morning on the right side of the bed in a spacious bedroom with a large closet to complement it. Our 1 bedroom apartments maintain a flexible open living area to maximize space and comfort. The kitchen has a wide area that allows you enough room to maneuver. The vast kitchen storage space allows you to prepare any size meal for you, your friends, and your family. Our 1 bedroom apartments range in size from 789 to 856 sq. ft., giving you the space you need for the lifestyle you lead.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/the-ridge-@-66/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Ridge at 66’s 1 bedroom apartments in Yukon, OK are adaptable to any lifestyle. Single renters can enjoy our smaller 1 bedroom apartments with an optional fireplace or an additional flex space for extra room. But the flexibility doesn’t stop there. Our townhomes and lofts start at 960 sq. ft. and come with essential features such as an attached garage for added convenience on select units.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 1-bedroom apartments at Newport Amarillo Apts offer a comfortable layout designed for solo residents or couples. Each home includes a full-sized kitchen, generous closet space, and a private patio or balcony — perfect for relaxing after a long day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 1-bedroom apartments at Park at Coulter offer a comfortable layout designed for solo residents or couples. Each home includes a full-sized kitchen, generous closet space, and a private patio or balcony — perfect for relaxing after a long day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>If you’re searching for a cozy living space in the vibrant city of Amarillo, TX, look no further than our impressive selection of 1 bedroom apartments available. With floor plans ranging from 725 to 805 sq. ft., these apartments offer the perfect blend of comfort and convenience, providing individuals or couples with a spacious and private retreat to call their own.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>If you live alone or with your significant other, our 1 bedroom apartments in Amarillo could be the perfect choice. Each spacious apartment measures 900 sq. ft. and offers a comfortable living space with one bedroom, a bathroom, and an extra-large closet. Select homes also have access to a balcony or patio on your floor so you can relax outside.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience the comfort of our 1 bedroom apartment floor plans, ranging from 725 to 805 sq. ft. Upon entering your inviting 1 bedroom apartment, you’ll immediately feel at home with the spacious living and dining space connected to your well-appointed kitchen. Explore our 1 bedroom apartment homes, some of which offer wheelchair accessibility, a charming wood-burning fireplace, or the convenience of an attached garage.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/acacia-park-apts/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our luxury 1 bedroom apartments offer the perfect amount of space for residents living by themselves or a couple moving in together. The open-concept layout seamlessly connects the living, dining, and kitchen spaces, ideal for entertaining friends. In our 1 bedroom apartments, you’ll enjoy 642 sq. ft. of living space, spacious closets, and convenient extra storage.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/chimneys-apts/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Ranging from 480 to 620 sq. ft. in size, our 1 bedroom apartments in El Paso are an excellent option for those living alone, with a partner, or with a pet or two. Each of our 1 bedroom apartments has a patio or balcony, a large closet, a private bathroom, and a fully equipped kitchen. We also have properties with built-in fireplaces available for rent.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Double Tree, you can choose between three distinct 1 bedroom floor plans ranging from 491 sq. ft. to 656 sq. ft. Our 1 bedroom apartments in El Paso are ideal for single residents who desire more space than a studio apartment or couples looking for a cozier living area. With a fully equipped kitchen, a ceiling fan in the bedroom, and a private patio or balcony, Double Tree Apartments meet diverse needs in West El Paso.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At High Ridge Apartments, we offer 1 bedroom homes ranging from 506 sq. ft. to 646 sq. ft. in El Paso. Our cozy apartments give singles and couples plenty of room to live comfortably, with spacious living and dining rooms and large closets. Our apartments include a private balcony and plush carpeting throughout, plus practical features like washer and dryer connections and garbage disposal.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/mountain-village-apts/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Are you living alone or with your significant other? Our 1 bedroom apartments in West El Paso may be perfect for you. These measure in at 700 sq. ft. and come with one bedroom, bathroom, and an extra-large closet. They also feature a small patio or balcony area depending on which floor you stay on. Your in-home fireplace, available in select apartments, is a great spot to gather with your friends and family, while the ample space in your pantry and kitchen cabinets keeps you well-stocked and ready for any occasion.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/patriot-apts/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 1-bedroom apartments at Patriot Apts. offer a comfortable layout designed for solo residents or couples. Each home includes a full-sized kitchen, generous closet space, and a private patio or balcony — perfect for relaxing after a long day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/phoenix-apts/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Get cozy in one of our 1 bedroom apartments, offering nearly 600 sq. ft. of space, a bright and airy living room, and a roomy bedroom closet. As you enter your 1 bedroom apartment, you’ll be welcomed by a bright living room with a large window and plenty of room for movie nights and get-togethers with the people you love.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/shadow-ridge-apts/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>With a wide range of sizes between 457 and 646 sq. ft., Shadow Ridge is your best choice for a 1 bedroom apartment in El Paso, TX. Ideal for those living with a partner or those seeking additional space in their apartment home, our 1 bedroom apartments come well stocked with many amenities, including a private balcony or patio and a built-in fireplace.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The comfortable 1 bedroom apartments in our El Paso community come in three varieties, offering 605 to 878 sq. ft. Residents who work from home often choose our largest 1 bedroom apartment floor plan, which offers a spare room suitable for an office or den. Each and every one of our 1 bedroom apartments offers a spacious living area, perfect for unwinding after a long day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/hewitt/icon-at-hewitt/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>For those living on their own or with a partner or pet, our 1 bedroom apartment homes in Hewitt, TX, are an ideal place to call home. Ranging from 789 to 879 sq. ft. in size, you can unwind in our luxury apartments either in the comfort of your bedroom or on your private balcony or patio. Start each morning in comfort as you wake up in your well-lit bedroom with shaded windows, pick your outfit from your large personal closet, and take on the day ahead.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 1 bedroom, 1 bathroom apartment option is ideal for single residents, couples, or even single parents. If you want a bit more space but don’t need a 2 bedroom apartment, we recommend our 1 bedroom apartment with a bump-out, which offers an extra 60 sq. ft. of space and is a great area for a pet’s corner or a gaming nook.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 1-bedroom apartments at Icon at Lubbock offer a comfortable layout designed for solo residents or couples. Each home includes a full-sized kitchen, generous closet space, and a private patio or balcony — perfect for relaxing after a long day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The 1 bedroom apartments at Tuscany Place are perfect for single residents, couples, and pet owners. Even our most compact 1 bedroom apartment offers nearly 800 sq. ft. of space and a full gourmet kitchen, complete with a dishwasher, stove, microwave, and ceramic tile floors.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/temple/portico-at-friars-creek-apts/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience the perfect blend of functionality and style in our 1 bedroom apartments at Portico at Friars Creek. Ranging from 789 to 879 sq. ft., these thoughtfully designed residences provide ample space for you to relax and unwind. Whether you’re starting a home business or welcoming a new <a href=\"/apartments/tx/temple/portico-at-friars-creek-apts/pet-policy\"><strong>pet</strong></a> into your life, our apartments offer the flexibility you need. Enjoy the convenience of a fully equipped kitchen and the option for added luxuries like a fireplace, balcony, or patio.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our most compact 1 bedroom apartments offer around 790 sq. ft. of space, including a roomy living and dining area. If you want to stick to a 1 bedroom apartment but need a bit more room, consider our 1 bedroom bumpout or 1 bedroom loft apartment options, which offer 880 sq. ft. and 970 sq. ft., respectively. We even offer a 1 bedroom townhouse option, complete with two floors and a whopping 1,130 sq. ft.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/tuscany-ranch-apartments/floor-plans::propertyfloorplanslist.bed1_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Are you and your partner looking for some additional space? Our 1 bedroom apartments in Waco, TX, are the perfect fit for you. Available in layouts between 790 and 860 sq. ft. in size with our <a href=\"/apartments/tx/waco/tuscany-ranch-apartments/amenities\"><strong>luxury apartment amenities</strong></a>, our spacious and comfortable 1 bedroom apartments bring you the best of luxury apartment living. 1 bedroom apartments from Tuscany Ranch offer a large workspace in the kitchen, a well-lit open living area, and the customizability of either a patio or a bump out for extra room.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:property::propertyfloorplanslist.bed1_title": {
    "overrideType": "VALUE",
    "customValue": "<p>1-Bedroom <span data-type=\"field-token\" data-field=\"property_type\"></span> in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/floor-plans::propertyfloorplanslist.bed1_title": {
    "overrideType": "VALUE",
    "customValue": "<p>1-Bedroom Duplex in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cypress-crossing/floor-plans::propertyfloorplanslist.bed1_title": {
    "overrideType": "VALUE",
    "customValue": "<p>1-Bedroom <span data-type=\"field-token\" data-field=\"property_type\"></span> &amp; Townhomes in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 2 bedroom apartments offer the perfect balance of space and comfort for roommates, small families, or anyone craving a little extra room to spread out. Choose from 812, 846, or 1,002 square foot floor plans, with your choice of one or two bathroom layouts in Little Rock. Each home features high ceilings for an open, airy atmosphere, a full-size washer and dryer in the unit, private patios or balconies perfect for morning coffee, and generous closet space throughout. Whether you need a dedicated home office, a guest room, or simply more room to entertain, our 2 bedroom floor plans are designed to fit the way you live.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/north-little-rock/lexington-park/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>As you come home to your spacious 2 bedroom apartment at Lexington Park, you’ll be welcomed home by an airy living room and sunroom, an ideal spot to set up a reading nook or office area. The two full bathrooms allow for extra privacy and easier morning routines for those living with roommates or hosting guests.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/maize/watercress-apartments/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the versatility of our 2 bedroom apartment homes, striking the perfect balance between spaciousness and coziness. The second bedroom offers the flexibility to serve as an office, study area, or entertainment room, catering to your diverse needs.</p>\n<p>With two full bathrooms included in our 2 bedroom floor plans, accommodating roommates or guests is effortless. Step outside onto the private patio or balcony, which offers a tranquil spot to catch fresh air and indulge in a good book.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Each of our 2-bedroom floor plans offers over 900 sq. ft. of room, a spacious kitchen, and bright, airy rooms with large windows. Your kitchen, living room, and dining room all seamlessly flow into one another, opening up room for furniture and decor.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Ideal for living with roommates or accommodating guests, our 2 bedroom apartments feature two separate full bathrooms. The open-concept living and dining area and kitchen streamline mealtimes and create an ideal space for hosting dinners with friends and family. In our 2 bedroom lofts, you’ll find an attached garage downstairs for a speedier commute.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/crown-chase-apts/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 2 bedroom apartment floor plans offer two full bathrooms, ideal for those living with roommates who want some extra privacy. Several of our 2 bedroom apartments also feature a living room fireplace that will enhance your comfort. The kitchen features plenty of countertop space and connects to the living area, making it ideal for hosting dinner parties or movie nights for friends.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/huntington-park/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Huntington Park’s 2 bedroom apartment homes include two full private bathrooms that make roommate living or hosting guests smoother. Each bedroom connects to a full-size living room area with a charming little dining nook. Washer and dryer connections in select apartment homes can help you simplify your laundry days.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/newport-wichita-apts/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>A 2 bedroom apartment in Wichita, KS at Newport is an ideal living solution for those living with roommates, couples, or those who want extra living space for guests and visiting family. Each bedroom is fully outfitted with a private bathroom, generous closet space, and enough room to fit even the largest mattresses comfortably. Our 2 bedroom apartments are available with an optional fireplace or private patio so you can customize your living space to have a home you love to live in.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/portofino/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The large closets and sizable living areas of our 1 bedroom apartments carry over into our 2 bedroom options, while the common area has been expanded to enhance the comfort of everyone in your home. Each bedroom’s private bathroom and shower has a large mirror and custom countertops. These flexible spaces are ideal for roommates and those looking for an office or an extra bed for family and guests. Our 2 bedroom lofts bring a unique layout to Portofino’s floor plan options. With the benefit of a personal garage, your Portofino apartment will truly be a comfortable living space that excels in versatility.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/raintree-apartments/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Opt for our 2 bedroom apartment floor plans, ideal for sharing with a roommate. These floor plans feature separate bedrooms and bathrooms. The generous-sized living area between each bedroom fosters a serene, relaxed atmosphere. Embrace the winter months by selecting one of our 2 bedroom floor plans featuring a wood-burning fireplace, which creates a snug ambiance for enjoying a hot cup of cocoa. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/remington-wichita-apts/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Each of our 2-bedroom floor plans offers 978 sq. ft. of room, a spacious kitchen, and bright, airy rooms with large windows. Your kitchen, living room, and dining room all seamlessly flow into one another, opening up room for furniture and decor.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/remington-wichita/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover unparalleled comfort and convenience in our beautifully crafted 2 bedroom apartments at The Remington Apartments in Wichita. Each of our 2 bedroom apartments comes with two bathrooms, ensuring comfortable co-living and seamless guest hosting. Delight in the balance of privacy and community within each spacious 2 bedroom apartment near Bel Aire in northeast Wichita.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/silver-springs-apts/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 2 bedroom apartments boast two bathrooms, ensuring guests or roommates can coexist comfortably. The fully equipped kitchen is complete with vinyl flooring for effortless maintenance and seamlessly connects to the living and dining spaces, providing a perfect setting for social gatherings with friends and family. Each bedroom abounds in natural light streaming through the windows, creating a bright and inviting ambience.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience the epitome of luxurious living at the Villas of Waterford. Our apartment community offers 2 bedroom apartments and lofts designed to cater to the unique needs of our residents. Our two distinctive floor plans, which span between 1,050 sq. ft. and 1,110 sq. ft., are ideal for those seeking to live with a roommate or work from home in a dedicated office.</p>\n<p>Both layouts feature two sizable bedrooms with plentiful closet space, two full bathrooms, and an open-concept living and dining area. The additional room can be transformed to suit your individual preferences, be it an art studio or a guest room—the possibilities are endless. Choose from our refined options at the Villas of Waterford to elevate your living experience in northeast Wichita.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/belton/center-301/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Center 301 offers five distinctive 2 bedroom floor plans, including lofts, townhomes, and apartment options. Each 2 bedroom apartment layout features two separate bathrooms with a bathtub, perfect for relaxing bubble baths after a long day. Our 2 bedroom townhomes and lofts are ideal for hosting visiting family and friends, with one bedroom and one bathroom downstairs and the other bedroom and bathroom upstairs. When you select one of our Belton townhomes, you can opt for an attached garage to save time on your morning commute.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/independence/the-adirondack/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 2-bedroom apartments at The Adirondack expand on the comfort of our 1-bedroom layouts with additional living space, a private bathroom for each bedroom, and room ideal for roommates, families, or a dedicated home office.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/97-north-oak/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Each of our 2 bedroom apartments in Kansas City, MO includes two full bathrooms to accommodate guests or roommates. The expansive countertops in our apartments’ kitchens are great for sipping on morning coffee or evening cocktails while perched atop a barstool. When you need to relax after a long day at work or school, take a bubble bath in one of your two bathtubs or head to the living room and curl up on the couch with a good book.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/mark-apts/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 2-bedroom apartments at Mark Apts. expand on the comfort of our 1-bedroom layouts with additional living space, a private bathroom for each bedroom, and room ideal for roommates, families, or a dedicated home office.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/sunchase-ridgeland-apts/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 2-bedroom apartments at Sunchase Ridgeland Apts. expand on the comfort of our 1-bedroom layouts with additional living space, a private bathroom for each bedroom, and room ideal for roommates, families, or a dedicated home office.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/the-pointe-of-ridgeland/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 2-bedroom apartments at The Pointe Of Ridgeland expand on the comfort of our 1-bedroom layouts with additional living space, a private bathroom for each bedroom, and room ideal for roommates, families, or a dedicated home office.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/trace-apts/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 2-bedroom apartments at Trace Apts. expand on the comfort of our 1-bedroom layouts with additional living space, a private bathroom for each bedroom, and room ideal for roommates, families, or a dedicated home office.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our spacious 2 bedroom apartments were designed with your comfort in mind, offering over 1,050 sq. ft. of living space. The 2 bedroom bumpout layout offers an extra alcove off the living room, an excellent spot for a reading nook or lounging area. All three of our 2 bedroom apartment and loft floor plans feature two full bathrooms, ideal for roommate-style living or those hosting visiting family, friends, and loved ones.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find comfort in our spacious 2 bedroom apartment homes. The master bedroom is nearest the entryway with a sizable closet and a spacious customizable interior for your most comfortable furniture.<br/><br/>However, that’s not to say the other bedroom is short on features. Outfitted with another large closet and a full personal bathroom, everyone in your home will thrive in a high-quality living environment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/redbud-ranch/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 2 bedroom apartment layouts are quite spacious, ranging from 1,050 sq. ft. to 1,267 sq. ft., which provides ample room to unwind and make yourself home. Many of our 2 bedroom floor plans feature private balconies or patios, allowing you to step outside and enjoy some fresh air. Additionally, indulge in a tranquil bubble bath in the full-sized tub within your bathroom when you need a little extra pampering.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 2 bedroom apartments and lofts are favorites due to their versatility and optimal size. The second bedroom in our 2 bedroom floor plans offers flexibility, serving as a crafting space, game room, home office, or guest room based on your needs. Embrace the open-concept design of our 2 bedroom apartments, where the kitchen, dining, and living areas seamlessly merge, ideal for fostering cherished moments with family or hosting gatherings with friends.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>If you’re looking to live with a roommate or partner, our Broken Arrow 2 bedroom apartments in Broken Arrow, OK, feature an abundance of space for comfortable, luxurious apartment living. With even more living space and an additional bedroom, the possibilities are endless! </p>\n<p>Our top-of-the-line, pet-friendly apartment community features premium finishes like custom kitchen cabinetry and functional elements like washer and dryer connections to meet everyone’s needs. Whether you’re turning it into a cozy roommate’s pad or a private office, you’re just one step away from experiencing the pinnacle of upscale living at Trails at Aspen Creek.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Villas at Aspen Park offers premium 2 bedroom apartments and lofts tailored to meet the needs of its residents. With three varying floor plans ranging from 1,050 sq. ft. to 1,110 sq. ft., our living spaces are suitable for those searching for a dedicated guest room or office, those who prefer to live with a roommate, or those needing an art studio.</p>\n<p>Each floor plan comprises two spacious bedrooms, generous closet space, two full bathrooms, and an open-concept kitchen, living, and dining area. Choose the layout that boasts elegant vaulted ceilings, an additional dining or office nook, a wood-burning fireplace, and a private balcony or patio. Discover a heightened way of life in Broken Arrow at the Villas at Aspen Park.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/fountain-lake/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 2 bedroom apartments in Edmond boast over 1,000 sq. ft. of living space and two separate bathrooms, ideal for those planning to live with roommates. Each bedroom features a large closet with plenty of room for your wardrobe. Spacious windows in the entryway living room fill the space with natural light, and a private balcony or patio, available in many apartment homes, is the ideal place to relax and enjoy your view of our serene community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>If you’re looking for more room to stretch out, our spacious 2 bedroom apartments are the right fit for you. These apartments range from 1,050 sq. ft. to 1,110 sq. ft. and have practical amenities, such as a fully equipped kitchen and washer and dryer connections. You can even choose an apartment with a cozy fireplace, a private balcony or patio, and vaulted ceilings.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Reserve at Elm’s 2 bedroom offerings present the same customizable options as our 1 bedroom options, with an expanded living area and two private bathrooms for each bedroom. Large kitchens with barstool-ready countertops keep everyone in your home comfortable and well-fed, while your optional fireplace is the perfect spot to stay warm on chilly autumn days.</p>\n<p>Our 2 bedroom lofts bring the added bonus of a personal garage and deep personal closets capable of holding every season’s wardrobe with storage space to spare. Whether you want a place to share with a roommate or some extra space for family and guests, choose the right fit for your way of life from our three distinct 2 bedroom floor plans in Jenks, OK.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/moore/mission-point/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 2 bedroom apartments at Mission Point offer a spacious, accommodating living solution. Each bedroom has generous closet space, providing comfort tailored to your preferences. Accent walls bring a dramatic burst of character to your living space, and you’ll be ready to cook, entertain, or sit down for a snack by our barstool-ready countertops. With the option for garages, our 2 bedroom apartments bring you every luxury to make Mission Point your home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/artisan-crossing-apts/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Between our apartments, townhouses, and lofts, you’ll have five different floor plans to choose from if you need a 2 bedroom floor plan. In our 2 bedroom, 2 bathroom apartment, each full bedroom and bathroom is separated by the full kitchen and comfortable living area, an ideal layout for living with roommates. When you select one of our 2 bedroom townhouses in Norman, you’ll enjoy two floors of space to settle in and relax with your loved ones.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We offer roommate-friendly 2 bedroom apartment floor plans, each offering two full bathrooms for optimal privacy. In addition to our 2 bedroom apartments, we also offer townhome floor plans that boast two stories of living space. </p>\n<p>Envision coming home to your 2 bedroom townhome after a long day at work and relaxing in your living area or heading upstairs to nap in one of your full-sized bedrooms.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>For those who need more space, our 2 bedroom apartments range from 926 sq. ft. to 1,125 sq. ft. and offer ample room to move around. These apartments blend living, dining, and kitchen space perfectly, offering ample space for family parties or holidays. Our apartments offer practical amenities such as washer and dryer connections, fenced yards, and wood-style flooring, and we also offer apartments with 1 or 2 car garages!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 2 bedroom apartments offer two separate bathrooms for accommodating guests or roommates. The fully equipped kitchen features vinyl wood-style flooring for simplified cleanup and connects to the living and dining area, where you can share meals with friends and loved ones. Each bedroom also features a window, letting in natural light.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Here at Cross Timber, we offer 2 bed/1 bath and 2 bed/2 bath apartments in Oklahoma City. As you enter your 2 bedroom apartment, you’ll feel at ease immediately in the cozy living and dining area, a great place to set up comfortable seating and TV. When dinner time rolls around, the fully equipped kitchen includes everything you need to prepare a delicious meal, plus a dishwasher for easy cleanup.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Crown Pointe’s 2 bedroom, 2 bathroom apartment homes are great for living with roommates or residents who desire more space. Those who don’t need two bedrooms can easily transform the spare bedroom into a home office or even a game room. Each bedroom features a spacious closet and a large window.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter's-ridge-apts/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The 2 bedroom apartment homes in our Oklahoma City apartment community all include two full bathrooms, ideal for those living with a roommate or wanting a private guest bathroom. Our 2 bedroom apartments also feature washer and dryer connections and a private balcony or patio for relaxing on pleasant evenings.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/park-at-tuscany/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>All the flexibility and customizable options of our 1 bedroom apartments are present and enhanced in our 2 bedroom floor plans. The living rooms have been expanded in these larger apartments for additional living and entertainment space, and each bedroom is spacious and equipped with a fully outfitted bathroom for added privacy. Couple this with ample closet space, plush carpeting, and bright ambient lighting through your exterior windows, and you’ll find our 2 bedroom apartment homes to be the ideal canvas for your luxurious living space.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/persimmon-square-apartments/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore our 2 bedroom apartments in Oklahoma City, featuring three unique floor plans, including washers and dryer connections in many of these spacious and comfortable homes. Our 2 bedroom, 2 bathroom apartment layouts offer ample closet space, and a generous living area. Experience the comfort and convenience of these well-appointed apartments, providing ample space for modern living in the heart of Oklahoma City.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Continuing our theme of customizability, our 2 bedroom apartments start at a spacious 954 sq. ft., with private bathrooms and large accommodating bedrooms. Ample cabinetry keeps you prepared for quick meals and large gatherings, while our wide, barstool-ready countertops create an ideal space to entertain guests as your friends and family gather in your large living room. The poolside view from your optional balcony is serene and breathes life into your home as you enjoy the fresh air and the many <a href=\"/apartments/ok/oklahoma-city/prairie-springs-i/amenities\"><strong>community amenities</strong></a> that await you just a short distance below.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/stonehorse-crossing/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>2 bedroom apartments at Stonehorse Crossing are a popular choice for both roommates looking for a shared space and solo residents who appreciate the extra room for work, study, or accommodating overnight visits from friends and family. Our well-appointed kitchens come equipped with barstool-ready counters to entertain your guests, as they stay warm by your optional fireplace. Moving into the living areas, both bedrooms come with a full private bathroom, shaded windows, and deep closets that can easily hold a whole year’s worth of outfits and accessories. </p>\n<p>We also offer 2 bedroom townhomes to give you the option for a personal garage attached to your loft. These enhanced 2 bedroom living spaces come with ample cabinet and storage space, a private balcony, and closets so large you could get lost in them.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summerfield-place-apts/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 2 bedroom apartment floor plans feature spacious layouts to provide additional space and flexibility, including a spare bedroom perfect for an at-home office or game room. These 2 bedroom, 2 bathroom apartments are ideal for those seeking privacy and ample room to unwind. Experience the joy of sunny days by relaxing with a loved one or pet on your private patio or balcony available in our 2 bedroom apartments.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/tammaron-village-apartments/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore our 2 bedroom floor plans, boasting approximately 850 sq. ft. of living area. Each floor plan features a spacious closet in every bedroom, a bathroom in between, and a window welcoming natural light in the living area. Our 2 bedroom apartment homes encompass spacious living and dining areas, complemented by the convenience of washers and dryers in select homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/warrington-apartments/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover our 2 bedroom apartment and townhome floor plans featuring over 800 sq. ft. of living space. These designs include two individual bathrooms and bedrooms, making them perfect for living with a roommate or accommodating guests. If you desire a dedicated home office space, our 2 bedroom residences are ideal. Step out for fresh air by accessing your balcony or patio with a snack and your preferred book, creating a relaxing outdoor retreat at home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Living by yourself? Waters Edge offers reasonably priced OKC studio apartments that provide a premium apartment living experience while allowing you to stretch your dollar further. Our studios are 396 sq. ft. with a full kitchen, a bathroom with a shower and tub, and a spacious closet. Take advantage of our luxury community amenities in Oklahoma City when you step outside your cozy abode.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/coffee-creek/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>With all the customizable options of our 1 bedroom floor plans, our 2 bedroom apartments expand your living area into an ideal home for small families, roommates, or those wanting extra space for guests and family. Closet space is abundant within the bedrooms and the common area, allowing you to stay organized around every corner. Both bedrooms have their own private bathrooms for added privacy, and your personal balcony loops around the exterior to offer a full view of our beautiful outdoor courtyard.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our emphasis on luxury and comfort continues through our 2 bedroom apartment options. Thrive in your expanded living room as you entertain guests with your barstool-ready countertops, or simply relax in the quiet comfort of a home with ample breathing room. Your stylish and <a href=\"/apartments/ok/owasso/cottages-at-tallgrass-point/amenities\"><strong>modern appliances</strong></a> give you the tools to conquer every meal in a large kitchen with tiled flooring, a feature that has been thoughtfully added near your front door so your home remains easy to clean while tastefully elegant.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cypress-crossing/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Upgrade to more room with our 2 bedroom apartments—perfect for small families, roommates, or anyone who loves having more space around the home. </p>\n<p>Our 2 bedroom apartments are designed to balance privacy and shared living areas, making it easy to host friends or delight in a quiet evening! Enjoy browsing your wardrobe in your spacious closet before a night out or sipping your favorite brew on your private balcony. You can turn your expanded living area into a craft room, office, guest room, or any other useful space that reflects your goals and needs.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/stillwater/apple-creek-stillwater/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>For extra space and versatility, consider one of our 2 bedroom apartment floor plans, offering a spare bedroom for an at-home office or game room. If you plan on living with a roommate, one of our 2 bedroom, 2 bathroom apartments is a great fit, offering privacy and lots of space for spreading out and living comfortably. Select one of our 2 bedroom apartments with an included fireplace and enjoy getting cozy with your friends, loved ones, or pets on chilly evenings.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/barrington-apartments/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>When you come home to one of our 2 bedroom apartments in Tulsa, we invite you to take a load off and relax in your expansive living area in front of the brick fireplace. Wash away the stress of the day in your roomy bathroom, complete with a luxurious whirlpool tub for bubble baths and a Jack-and-Jill sink for more convenient morning routines. If you’d prefer more space, opt for the 2 bedroom, 2.5 bathroom townhome, offering a downstairs kitchen, living and dining area, half bathroom, and two upstairs bedrooms and bathrooms.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cascata-luxury-apartments/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find your bliss in one of our 2 bedroom apartment layouts, all offering over 1,000 sq. ft., allowing you plenty of space to spread out. Get some fresh air by relaxing on your private balcony or patio, which is included in many of our 2 bedroom floor plans. When you need some extra TLC, indulge in a relaxing bubble bath in your bathroom’s full-sized tub.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-glade-apts/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 2 bedroom apartments deliver the space and flexibility you need, whether you're living with a roommate, starting a family, or simply want an extra room to use as a home office or guest retreat. Choose from 940 or 1,050 square foot floor plans, each featuring two full bathrooms for added privacy and convenience. You'll love the wide-open living and dining area that flows seamlessly into the kitchen, making entertaining and everyday meals a breeze. Both bedrooms offer generous closet space, and washer and dryer connections let you bring your own appliances for easy laundry days at home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 2 bedroom apartment homes are some of our most versatile, not too small or too large. The second bedroom can also be easily transformed into an office, study space, or game room. All our 2 bedroom floor plans include two full bathrooms, ideal for those living with a roommate or wanting a separate guest bathroom for visitors. Many of our 2 bedroom apartments include a private patio or balcony space to enjoy some fresh air and crack into a good book.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 2 bedroom Tulsa apartments are ideal for those living with a roommate or wanting a space to accommodate visiting loved ones, with two separate bathrooms for added privacy. A second bedroom also offers versatility, as you can transform your extra bedroom into an office, game room, reading room, or crafting space. Numerous windows let in natural light, making your space airy and bright. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 2-bedroom apartments at Country Hollow Apartments expand on the comfort of our 1-bedroom layouts with additional living space, a private bathroom for each bedroom, and room ideal for roommates, families, or a dedicated home office.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/creekwood-apartments/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Creekwood Apartments in Tulsa offers 2 bedroom apartments and townhomes, making it simple to find the best layout for you. Several of our 2 bedroom layouts feature a cozy wood-burning fireplace in the living area, so you can relax and enjoy the sound of a crackling fire while you warm up on winter days. Our 2 bedroom townhomes include an extra half bath downstairs, making hosting guests a breeze.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/nickel-creek-apts/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Available up to a roomy 1110 sq. ft., our 2 bedroom apartments allow you to truly spread out and relax. You’ll enjoy two bathrooms in each of these floor plans with the option for a fireplace or loft with attached garage. Select units also feature a patio or balcony so you can enjoy the beauty of outside without ever leaving your home base.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/polo-run-apartments/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Polo Run in Tulsa, you’ll discover 2 bedroom apartments and townhomes, each providing approximately 1,000 sq. ft. of living space for comfortable living. Our 2 bedroom apartment floor plan offers two separate bathrooms and generous living and dining areas ideal for roommates.</p>\n<p>Our Tulsa townhomes span two floors and offer two bedrooms and 2 1/2 bathrooms. The half-bathroom on the lower level provides a convenient option for use as a guest bathroom when entertaining family or friends.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Sheridan Pond in Tulsa, we offer thoughtfully designed 2 bedroom apartments with options including 1 1/2 baths, two full bathrooms, or 2 1/2 bathrooms with two main suites, catering to your specific space requirements.</p>\n<p>These apartments, ranging from approximately 1,000 to 1,300 sq. ft., are ideal if you need extra space. Whether you seek a versatile home office, a guest room, or simply more room to relax, our 2 bedroom apartments provide comfort and style, creating an inviting environment for modern living.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Unwind in the comfort of your 2 bedroom apartment as you cozy by the fireplace in the expansive living area. Indulge in relaxation within the spacious bathroom, complete with a luxurious tub perfect for soothing bubble baths and a convenient sink to streamline your morning routine. Wash away the day’s stress effortlessly in our 2 bedroom, 2 bathroom apartments spanning 1,100 sq. ft.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the allure of our expansive 2 bedroom apartments in Tulsa, harmoniously combining comfort and sophistication. Each apartment spans 900 sq. ft. and presents an enchanting eat-in kitchen, ample closet space, and lavish bathrooms with bathtubs. The added convenience of having the option to add washer and dryer connections enhances your living experience. Immerse yourself in luxury living offered by Sunchase Apartments in south Tulsa.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Featuring two full bedrooms and bathrooms, our 2 bedroom apartment floor plans can easily accommodate roommates, family, or visiting guests. In select 2 bedroom apartment homes, you’ll find a wood-burning fireplace with a mantel for maximum comfort. The thoughtful layout ensures harmonious living, with an open-concept living area that flows into a charming dining nook, all tied together by ample natural light from the living room’s large window.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We offer two 2 bedroom floor plans, offering either 1,000 or 1,100 sq. ft. of living space. The master bedroom features an expansive closet, an ensuite bathroom, and a window that lets in refreshing natural light. Our 2 bedroom apartment homes feature a large living and dining area and a stacked washer and dryer.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Enhance your shared living experience in our 2 bedroom apartment floor plans. With one to two full bathrooms, our 2 bedroom residences are ideal for communal living. The fireplace in the living room adds an extra layer of comfort for you and your roommate when you want a cozy movie night. The kitchen boasts ample countertop space and sits next to the dining area, creating a perfect setting for hosting delightful dinner gatherings.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Park on Westpointe’s 2 bedroom apartments make no compromises in space or comfort. Each bedroom is equipped with a full bathroom, shaded windows, and a preinstalled ceiling fan as a standard. Moving to the kitchen, you’ll enjoy a large sink, premium wooden cabinets, and a side-by-side fridge and freezer—everything you need for a spring morning snack on your patio, a soothing cup of hot cocoa by the fireplace, and every other moment that comes in between.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/the-ridge-@-66/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>With two full bathrooms for each bedroom, our 2 bedroom apartments in Yukon, OK, are an ideal choice for roommates. Enjoy the option of a private balcony or patio, ideal for savoring your morning coffee or soaking in the scenic views of our Yukon community. For those seeking additional versatility, our townhome apartments feature lofts, providing the perfect space for a home office, entertainment area, or guest quarters. Plus, select units come with the added convenience of an attached garage, ensuring easy access to your vehicle and extra storage space.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 2-bedroom apartments at Newport Amarillo Apts expand on the comfort of our 1-bedroom layouts with additional living space, a private bathroom for each bedroom, and room ideal for roommates, families, or a dedicated home office.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 2-bedroom apartments at Park at Coulter expand on the comfort of our 1-bedroom layouts with additional living space, a private bathroom for each bedroom, and room ideal for roommates, families, or a dedicated home office.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>When you need more space for your family, pets, or roommate, you’ll enjoy our selection of 2 bedroom apartments at Remington Apartments. Our floor plans range from 961 to 1,110 sq. ft., allowing you to maximize your space so every corner is utilized to its fullest potential. These 2 bedroom apartments boast an array of amenities including premium appliances, washer and dryer connections, and a private patio or balcony that enhance your daily living experience.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Colonies at Hillside, you’ve got three unique options for our 2 bedroom apartments in Amarillo. Our spacious floor plans offer 1,200 sq. ft. of living space to make you feel at home. Equipped with two bathrooms for comfort and privacy, you can choose between a regular layout or a view of the poolside. We also have select floor plans with attached garages, making parking easy and secure.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 2 bedroom apartment floor plans come with two bedrooms and two bathrooms, making it convenient to host roommates, family members, or visiting guests. Select 2 bedroom apartment homes feature a cozy wood-burning fireplace for ultimate comfort.</p>\n<p>The well-planned layout promotes harmonious living. An open-concept living space seamlessly transitions into a delightful dining area, illuminated by ample natural light streaming in through the large window in the living room.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/acacia-park-apts/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Acacia Park’s 2 bedroom apartments offer a happy medium between our 1 bedroom and 3 bedroom apartment options. With a luxury 2 bedroom floor plan, you can have a roommate in the extra room or use the space as a guest room, an office, or even a creative space or studio. We offer 2 bedroom, 1 bathroom apartments and 2 bedroom, 2 bathroom apartments to suit your needs. Our 2 bedroom, 2 bathroom floor plans provide an en suite off the main bedroom, featuring plush carpeting throughout the apartment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/chimneys-apts/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our spacious 2 bedroom apartments have everything you need for high-quality apartment living in El Paso, TX. With options ranging from 800 to 945 sq. ft. in size, many of our 2 bedroom apartment floor plans come with two bathrooms and extra large patios or balconies. These apartments are ideal for families with a single child or a pair of roommates needing separate rooms.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Double Tree’s 2 bedroom apartments offer a spacious 920 sq. ft. of living space, great for residents living alone who want a spare room, couples, or even smaller families. Our 2 bedroom, 2 bathroom apartments are ideal for hosting guests with open-concept living and dining space, turning your second bedroom into a home office, or living with a roommate.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Check out our spacious 2 bedroom apartments in El Paso for additional space to move around. These 2 bedroom apartments have open-concept living and dining spaces, perfect for hosting a dinner party. The extra bedroom allows the possibility of having a guest room, creating a home office, expanding your family, or living with a roommate. With space ranging from 829 to 941 sq. feet you’ll have plenty of room to stretch.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/mountain-village-apts/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Mountain Village has two options for 2 bedroom apartments in El Paso. Our floor plans are 1,040 sq. ft., with one-story layouts and two-story layouts available. The one-story floor plan offers two full bathrooms, an expanded living room, and options for both a fireplace and balcony. With the two-story floor plan, these spacious options have two bedrooms on the lower level with individual bathrooms and a living room area upstairs with an extra half-bathroom, perfect for guests or family.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/patriot-apts/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 2 bedroom apartments in El Paso come in four floor plan options, with many apartment homes featuring an included washer and dryer. Residents needing extra space typically select our 2 bedroom, 2 bathroom apartment option, boasting 835 sq. ft., spacious closets, and a roomy living area.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/phoenix-apts/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We offer two floor plan options for our 2 bedroom apartments, ranging from 727 to 767 sq. ft., including apartments with washer and dryer hookups. In each of our 2 bedroom apartments, you’ll enjoy multiple spacious closets, a charming eat-in kitchen, and a large bathroom with a combination shower and bathtub.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/shadow-ridge-apts/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 2 bedroom apartments at Shadow Ridge are a prime option for families with children or roommates needing separate rooms. Our 2 bedroom apartments in El Paso offer an expanded balcony or patio that you can access directly from your main bedroom for beautiful morning views. Shadow Ridge’s 2 bedroom apartments range from 850 to 958 sq. ft.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 2 bedroom apartments are among our most popular, thanks to their ideal size and flexibility. The roomy second bedroom in our 2 bedroom floor plans can be used as a crafting space, game room, home office, or guest room. You’ll enjoy an open-concept style in our 2 bedroom apartments, where the kitchen, dining, and living areas flow into one another, great for spending quality time with loved ones or entertaining friends.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/hewitt/icon-at-hewitt/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Between 1,050 and 1,108 sq. ft. in size, our 2 bedroom apartment homes have everything you need for a comfortable apartment living experience in Hewitt, TX. These apartments are ideal for those living with a roommate or families who are getting established in the area. Many of our 2 bedroom apartments also come with a fireplace and an expanded balcony or patio.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>When a 1 bedroom apartment is a bit too cramped for you, we have plenty of 2 bedroom apartments to choose from, offering over 1,000 sq ft. of space. Our 2 bedroom apartments in Lubbock are great for couples and small families. Single residents often rent our 2 bedroom apartments so they can create game rooms, home offices, or cozy guest rooms for family and friends.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 2-bedroom apartments at Icon at Lubbock expand on the comfort of our 1-bedroom layouts with additional living space, a private bathroom for each bedroom, and room ideal for roommates, families, or a dedicated home office.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>If you need a college apartment for you and your roommate, our 2 bedroom apartments near Texas Tech are the perfect option. With over 1,000 sq ft. of living space, there’s plenty of room for hosting study groups, movie nights, and dinner parties. You’ll enjoy two spacious closets with plenty of room for your wardrobe.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/temple/portico-at-friars-creek-apts/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Ranging from 1,050 to 1,267 sq. ft. in size, Portico at Friars Creek has quality 2 bedroom apartments available in Temple, TX. If you’re starting a family or moving in with your best friend, an additional room can be very beneficial for upscale apartment living. Each apartment is equipped with modern amenities, including an extended balcony or patio and the option for a cozy fireplace so you can experience the comfort and convenience of luxury living in Temple, TX.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>If you need a 2 bedroom apartment to accommodate a roommate or family member or you want to create a home office, crafting space, or game room, we’ve got many floor plans to choose from. Ranging from our standard 2 bedroom, 2 bathroom apartment to our large 2 bedroom loft apartment, you’ll enjoy plenty of space to make yourself at home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/tuscany-ranch-apartments/floor-plans::propertyfloorplanslist.bed2_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 2 bedroom apartments in Waco, TX, have everything you need and more for luxury apartment living. Ranging between 1,050 and 1,110 sq. ft. in size, you can enjoy more room for a roommate or a little one. In addition to this, we also have 2 bedroom apartments with an expanded balcony or patio and a fireplace.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:property::propertyfloorplanslist.bed2_title": {
    "overrideType": "VALUE",
    "customValue": "<p>2-Bedroom <span data-type=\"field-token\" data-field=\"property_type\"></span> in <span data-type=\"field-token\" data-field=\"property_address_city\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/huntington-park/floor-plans::propertyfloorplanslist.bed2_title": {
    "overrideType": "VALUE",
    "customValue": "<p>2-Bedroom <span data-type=\"field-token\" data-field=\"property_type\"></span> in <span data-type=\"field-token\" data-field=\"property_address_city\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/floor-plans::propertyfloorplanslist.bed2_title": {
    "overrideType": "VALUE",
    "customValue": "<p>2-Bedroom Duplex in <span data-type=\"field-token\" data-field=\"property_address_city\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cypress-crossing/floor-plans::propertyfloorplanslist.bed2_title": {
    "overrideType": "VALUE",
    "customValue": "<p>2-Bedroom <span data-type=\"field-token\" data-field=\"property_type\"></span>&amp; Townhomes in <span data-type=\"field-token\" data-field=\"property_address_city\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts/floor-plans::propertyfloorplanslist.bed3_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 13px;\">Our 3 bedroom apartments are ideal for growing families or anyone who values ample living space. Choose from 1,058 or 1,240 square foot floor plans, each with two full bathrooms for added convenience during busy mornings in Little Rock. These spacious homes showcase high ceilings that create a bright, welcoming feel, in-unit washer and dryer connections, private outdoor patios or balconies for relaxing evenings, and oversized closets to keep everyone organized. With room for everyone to have their own space, our 3 bedroom layouts deliver the comfort and functionality you need to truly feel at home.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/north-little-rock/lexington-park/floor-plans::propertyfloorplanslist.bed3_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 3 bedroom apartment layouts offer over 1,200 sq. ft. of space, featuring a master bedroom with an en suite bathroom, two additional bedrooms, and a second bathroom. Any of the bedrooms in our 3 bedroom apartments can easily accommodate a home office, playroom, or crafting space. Next to the large gourmet kitchen, a laundry nook with an in-home washer and dryer is ready to make laundry day easier.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview/floor-plans::propertyfloorplanslist.bed3_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 3 bedroom apartment homes offer the most space to suit your needs. Any of the three full-sized bedrooms can easily be transformed into a home office, game room, or crafting space. Giving you a diverse range of layouts to choose from, we also offer 3 bedroom lofts with an attached garage so you can enjoy the maximum amount of useful space in your home. Your 3 bedroom apartment welcomes you home daily, encouraging you to get some fresh air on the private balcony or kick back in the expansive living room space.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/97-north-oak/floor-plans::propertyfloorplanslist.bed3_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Consider one of our large 3 bedroom apartments in Kansas City, MO, for plenty of space to spread out. You’ll enjoy a spacious master bedroom and bathroom and an enormous closet with plenty of space for your wardrobe and shoe collection. Across the apartment, you’ll find two additional bedrooms sharing a full bathroom, great for roommates, children, or for use as an office or study. Attached to your living room is a private balcony or porch, where you can watch the sun rise and set on Kansas City or work on your tan.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/the-pointe-of-ridgeland/floor-plans::propertyfloorplanslist.bed3_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 3-bedroom apartments at The Pointe Of Ridgeland are our most spacious option, offering room for growing families, multiple roommates, or anyone who values extra living and storage space.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/redbud-ranch/floor-plans::propertyfloorplanslist.bed3_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Boasting abundant closet space, a generous master bedroom, and an inviting living and dining area adjacent to the chef’s kitchen, the 3 bedroom apartment at Redbud Ranch stands as our most expansive housing option in Broken Arrow. Thanks to multiple windows, natural light illuminates the spacious living area of our 3 bedroom apartments, offering an ideal setting for arranging comfortable couches and chairs and a TV, perfect for movie nights or game nights.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/floor-plans::propertyfloorplanslist.bed3_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose our spacious 3 bedroom apartments in Broken Arrow, OK, for additional room to spread out and appreciate the luxury amenities of our brand-new community. These residences are perfect for everyone, like those who want a dedicated playroom, partners who work from home and seek separate offices, and roommates looking for more space to call their own.</p>\n<p>Select an apartment home with a fireplace and spend chilly winter nights cozied on the couch with your cat! From getting ready in the private bathroom with high-end finishes each morning to ending your day in your cozy bedroom with oversized windows, enjoy the luxuries of Broken Arrow apartment living at Trails at Aspen Creek.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/floor-plans::propertyfloorplanslist.bed3_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the perfect space for you with our 3 bedroom floor plans. Enjoy an impressive 1,178 sq. ft. of space featuring a spacious main bedroom with an en suite, two additional bedrooms, and plenty of closet space. With our diverse options, you can use the extra bedroom as an art studio, workout area, guest room, home office, or for a roommate. Whatever kind of space you need, we have a retreat that fits your needs and wants.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/floor-plans::propertyfloorplanslist.bed3_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Offering the most space and versatility, our 3 bedroom apartments feature a spacious living area attached to a charming dining nook. The expansive master bedroom connects to an en-suite bathroom with a large countertop sink for getting ready in the morning. Also attached to the master bedroom is the large private balcony or patio, where you can stretch out and enjoy the morning air. The extra bedrooms in our 3 bedroom apartments are also easily transformable into home offices, game rooms, nurseries, or guest rooms.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/floor-plans::propertyfloorplanslist.bed3_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Do you need or want even more space? Our 3 bedroom apartments offer an impressive 1,355 sq. ft. of living space with beautifully designed finishes. These apartments include an immense main bedroom with an en suite, two additional bedrooms, spacious closets, and a double garage. See for yourself and discover your dream home at Chisholm Pointe!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/floor-plans::propertyfloorplanslist.bed3_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The most spacious option at Council Place is our 3 bedroom apartment in Oklahoma City, which offers over 1,000 sq. ft. of living space. Each bedroom features a spacious closet for wardrobe storage and plush carpeting for comfort. Many of our 3 bedroom apartment homes feature a wood-burning fireplace, ideal for warming up on cold winter nights.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/floor-plans::propertyfloorplanslist.bed3_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Spanning over 1,204 sq. ft., our 3 bedroom apartments in Oklahoma City are ideal for living with roommates or those wanting extra room. Any of the three bedrooms included can be adapted to your need for a guest room, game room, craft space, or home library. A large vanity sits opposite a bathroom closet in each of the two full bathrooms, making your morning routine effortless.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/floor-plans::propertyfloorplanslist.bed3_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Three-bedroom apartments from Prairie Springs expand the living space available in our smaller options to accommodate each resident with enough room to relax and enjoy their home. Private balconies or patios are standard in our 3 bedroom apartments along with their picturesque views of our community, while additional options for a direct access garage or an expanded floor plan give you the ability to enjoy a full 1,447 sq. ft. of luxurious comfort in your Prairie Springs apartment home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cypress-crossing/floor-plans::propertyfloorplanslist.bed3_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Families looking for maximum space without sacrificing luxury will feel right at home in our 3 bedroom apartments. With expansive layouts, our largest apartments provide ample room for everyone to have their own space while enjoying comfortable shared living areas. </p>\n<p>Thrive in the expansive living areas of your 3 bedroom apartment with modern appliances, barstool-ready countertops, and plush carpeting. Plus, convenient storage spaces throughout your apartment allow you to enjoy your space with all your friends and family without any clutter.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/barrington-apartments/floor-plans::propertyfloorplanslist.bed3_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find your spacious abode in one of our 3 bedroom duplexes or townhomes, equipped with a large kitchen, two full bathrooms, and lots of closet space. Our 3 bedroom townhomes feature a master bedroom downstairs with two additional bedrooms upstairs. You’ll have ample space to live comfortably with roommates or family, or you can transform a spare bedroom into an office, guest room, game room, art studio, or workout space.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-glade-apts/floor-plans::propertyfloorplanslist.bed3_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 3 bedroom apartments are the perfect fit for growing families or anyone who loves having room to spread out. With 1,250 square feet of thoughtfully designed living space and two full bathrooms, there's plenty of room for everyone to feel right at home. The open living and dining area connects effortlessly to the kitchen, creating a warm, inviting space for family dinners and gatherings with friends. Each bedroom offers a spacious closet with ample storage for clothing and shoes, and convenient washer and dryer connections make laundry day simple and stress-free.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/floor-plans::propertyfloorplanslist.bed3_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The 3 bedroom floor plan is our largest Tulsa apartment option at Cedar Ridge, featuring tons of closet space, a spacious master bedroom, and an intimate living and dining area next to the chef’s kitchen. The large living area is perfect for setting up cozy couches and chairs and a TV for movie nights or game days. Natural light fills our 3 bedroom apartments thanks to multiple windows.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/floor-plans::propertyfloorplanslist.bed3_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our community’s two-story, 3 bedroom apartment homes offer unparalleled comfort and space, featuring an entry-level master suite for added convenience. Measuring about 1,500 sq. ft., our Tulsa 3 bedroom apartment floor plans provide ample living space and comfort. These apartments boast stylish interiors, emphasizing convenience and creating an inviting environment to settle in and enjoy your living experience.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments/floor-plans::propertyfloorplanslist.bed3_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 3 bedroom apartment homes feature a master bedroom and two additional bedrooms nearby. The spare bedroom offers various options, as it can serve as an office, guest room, game room, art studio, workout area, or accommodate roommates or family members based on your needs and preferences.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/floor-plans::propertyfloorplanslist.bed3_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Greens of Bedford’s 3 bedroom apartments feature a spacious master bedroom, two additional bedrooms, and two full bathrooms. Our 3 bedroom apartment homes can easily accommodate roommates living together or those wanting some extra space for a home office, den, or study.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/the-ridge-@-66/floor-plans::propertyfloorplanslist.bed3_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Perfect for families, roommates, or those who simply desire extra space, our 3 bedroom apartments in Yukon, OK, offer versatility and comfort. These apartment homes are designed with an expanded living area, providing ample room for entertaining guests or relaxing with loved ones. Whip up delicious meals in our expansive kitchen, complete with wide countertops offering plenty of room to prepare your favorite dishes. Also available as a 3 bedroom loft or townhome, you can opt for a home with an attached garage, optional fireplace, and balcony, among the many other <a href=\"/apartments/ok/yukon/the-ridge-66/amenities\"><strong>amenities</strong></a> that help us provide a luxury environment for all our residents.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/the-ridge-66/floor-plans::propertyfloorplanslist.bed3_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Perfect for families, roommates, or those who simply desire extra space, our 3 bedroom apartments in Yukon, OK, offer versatility and comfort. These apartment homes are designed with an expanded living area, providing ample room for entertaining guests or relaxing with loved ones. Whip up delicious meals in our expansive kitchen, complete with wide countertops offering plenty of room to prepare your favorite dishes. Also available as a 3 bedroom loft or townhome, you can opt for a home with an attached garage, optional fireplace, and balcony, among the many other <a href=\"/apartments/ok/yukon/the-ridge-66/amenities\"><strong>amenities</strong></a> that help us provide a luxury environment for all our residents.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/floor-plans::propertyfloorplanslist.bed3_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find the 3 bedroom apartment you’ll love to call home at Remington Apartments. Take advantage of perfectly crafted meals made in your fully equipped kitchen, family time activities in your open-concept living, and decide on your next fashion statement in your spacious closet. Our 3 bedroom apartments are offered in 1,098 sq. ft., perfect for families, roommates, or anyone who needs a designated office space!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/floor-plans::propertyfloorplanslist.bed3_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 3 bedroom apartments exceed 1,098 sq. ft., catering perfectly to individuals sharing with roommates or requiring additional space. The trio of bedrooms can be flexibly repurposed as a guest room, game room, crafting area, or cozy library, enhancing the versatility of your living space. Also, each of the two full bathrooms features a spacious vanity, streamlining your morning rituals.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/acacia-park-apts/floor-plans::propertyfloorplanslist.bed3_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 3 bedroom apartment floor plans offer ample space and myriad possibilities. This floor plan is ideal for those wanting more space for guests and entertaining, couples welcoming a new member to the family, or even grandparents looking for a place for their grandchildren to stay. In our 3 bedroom apartments, you’ll enjoy two spacious bathrooms and spacious closets in every room.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/patriot-apts/floor-plans::propertyfloorplanslist.bed3_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 3-bedroom apartments at Patriot Apts. are our most spacious option, offering room for growing families, multiple roommates, or anyone who values extra living and storage space.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/phoenix-apts/floor-plans::propertyfloorplanslist.bed3_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Embrace every square foot of the 959 sq. ft. around our 3 bedroom apartment in El Paso, with enough room for guests, roommates, or a home office, game room, or craft studio. The 3 bedroom, 2 bathroom apartment floor plan option includes an open-concept living and dining area, perfect for having friends over dinner or drinks or bonding with family.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/shadow-ridge-apts/floor-plans::propertyfloorplanslist.bed3_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our 3 bedroom apartments are the ideal option for families with multiple children or larger groups of roommates. With a 3 bedroom apartment in El Paso, you can enjoy the luxuries of two bathrooms, an extra-large balcony or patio, and additional storage space for your belongings.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/floor-plans::propertyfloorplanslist.bed3_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Crest’s largest El Paso apartment floor plan is our 3 bedroom option, offering around 1,100 sq. ft. of space. Residents in our 3 bedroom apartments enjoy two full bathrooms and spacious closets with ample room to spread out. Many of our 3 bedroom layouts include a wood-burning fireplace, great for making homemade s’mores and snuggling up with your pet or loved ones.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:property::propertyfloorplanslist.bed3_title": {
    "overrideType": "VALUE",
    "customValue": "<p>3-Bedroom <span data-type=\"field-token\" data-field=\"property_type\"></span> in <span data-type=\"field-token\" data-field=\"property_address_city\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-d072-74e9-9db4-c14ec88ee51e.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-ff04-73ff-b3a9-ec6e335354fd.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-d072-74e9-9db4-c14ec88ee51e.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-c8e1-732a-930e-e8dae21ca7ab.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db588-fdec-703f-aaa6-0f3cdcd8f56e.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019dac74-b3cf-740a-a0d0-8ec385e4ee7f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-e19c-77f0-be03-a5d1a1ff7401.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a1897b-95f4-74ab-a6d6-62559ed4cb95.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a1897b-95f4-74ab-a6d6-62559ed4cb95.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a1897b-95f4-74ab-a6d6-62559ed4cb95.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a1897b-95f4-74ab-a6d6-62559ed4cb95.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a1897b-95f4-74ab-a6d6-62559ed4cb95.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a1897b-95f4-74ab-a6d6-62559ed4cb95.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a1897b-95f4-74ab-a6d6-62559ed4cb95.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/huntington-park::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166545/019cfb4e-5a84-71f9-92f2-a38788df6dbb.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-7549-7639-a7e8-550fbeb7cc34.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-3501-774f-b574-3a71e866b50b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5d0-d63d-741c-909b-669cbde62650.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5d0-3caf-717e-94f3-198f0f49e587.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/independence/the-adirondack::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019d4880-e432-767f-9ccb-53c2e4b036f7.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/independence/the-adirondack/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da3-df91-75ec-92cb-0b442fa2b332.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/independence/the-adirondack/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da3-df91-75ec-92cb-0b442fa2b332.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/independence/the-adirondack/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da3-e980-750b-af44-a32bb71ddfa4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/independence/the-adirondack/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da3-df91-75ec-92cb-0b442fa2b332.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/independence/the-adirondack/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da3-df91-75ec-92cb-0b442fa2b332.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/independence/the-adirondack/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da3-df91-75ec-92cb-0b442fa2b332.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/97-north-oak::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb38-9d1c-742b-9001-4a3d8180a3fe.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-f29a-73e1-89db-6426a7dac986.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-f29a-73e1-89db-6426a7dac986.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-f29a-73e1-89db-6426a7dac986.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-f29a-73e1-89db-6426a7dac986.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-f29a-73e1-89db-6426a7dac986.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-f29a-73e1-89db-6426a7dac986.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-f29a-73e1-89db-6426a7dac986.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db68f-df86-764c-9f4e-439cdb5a81b3.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db68f-bef7-7708-97f2-33c3717a51e7.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-85db-722e-9622-93237a60dd15.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-85db-722e-9622-93237a60dd15.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-85db-722e-9622-93237a60dd15.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-85db-722e-9622-93237a60dd15.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-85db-722e-9622-93237a60dd15.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-85db-722e-9622-93237a60dd15.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-85db-722e-9622-93237a60dd15.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a36-7d65-753b-9102-dc4a26daa35f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a36-7d65-753b-9102-dc4a26daa35f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a36-7d65-753b-9102-dc4a26daa35f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a36-7d65-753b-9102-dc4a26daa35f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a36-7d65-753b-9102-dc4a26daa35f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a36-7d65-753b-9102-dc4a26daa35f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a36-7d65-753b-9102-dc4a26daa35f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c1c-d571-7304-a507-f70a6309bef3.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c1c-d571-7304-a507-f70a6309bef3.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c1c-d571-7304-a507-f70a6309bef3.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c1c-d571-7304-a507-f70a6309bef3.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c1c-d571-7304-a507-f70a6309bef3.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c1c-d571-7304-a507-f70a6309bef3.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c1c-d571-7304-a507-f70a6309bef3.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-de48-70bd-9abd-35db4eb9930f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019db609-7532-737e-be88-875da0799967.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019db60b-1d41-72df-818a-636a947a2d90.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-b6b2-76fa-8d9d-633dd34c301e.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019db609-dbea-72ae-917c-e9e40492daf2.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019db609-8c3f-770d-ac42-183e77c92566.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019db609-bb3e-7768-b230-dde3f41ab441.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06274-5c68-75e5-8f8e-f3aa0837e26c.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06274-5c68-75e5-8f8e-f3aa0837e26c.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06274-5c68-75e5-8f8e-f3aa0837e26c.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06274-5c68-75e5-8f8e-f3aa0837e26c.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06274-5c68-75e5-8f8e-f3aa0837e26c.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06274-5c68-75e5-8f8e-f3aa0837e26c.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06274-5c68-75e5-8f8e-f3aa0837e26c.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a1400a-01f6-74cc-a4fd-18af2bf5211d.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a1400a-01f6-74cc-a4fd-18af2bf5211d.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a1400a-01f6-74cc-a4fd-18af2bf5211d.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a1400a-01f6-74cc-a4fd-18af2bf5211d.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a1400a-01f6-74cc-a4fd-18af2bf5211d.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a1400a-01f6-74cc-a4fd-18af2bf5211d.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a1400a-01f6-74cc-a4fd-18af2bf5211d.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/019cfb3d-f4ec-703e-8d9f-bae38563ea4f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/019cfb3d-f4ec-703e-8d9f-bae38563ea4f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/019cfb3d-f4ec-703e-8d9f-bae38563ea4f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/019cfb3d-f4ec-703e-8d9f-bae38563ea4f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/019cfb3d-f4ec-703e-8d9f-bae38563ea4f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/019cfb3d-f4ec-703e-8d9f-bae38563ea4f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/01a03ea9-280d-731e-a979-ba5cb1cdcf31.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/01a03ea9-280d-731e-a979-ba5cb1cdcf31.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/01a03ea9-280d-731e-a979-ba5cb1cdcf31.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/01a03ea9-280d-731e-a979-ba5cb1cdcf31.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/01a03ea9-280d-731e-a979-ba5cb1cdcf31.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/01a03ea9-280d-731e-a979-ba5cb1cdcf31.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/01a03ea9-280d-731e-a979-ba5cb1cdcf31.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08675-afae-70eb-be11-cc8ebff32f02.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08675-afae-70eb-be11-cc8ebff32f02.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08675-afae-70eb-be11-cc8ebff32f02.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08675-afae-70eb-be11-cc8ebff32f02.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08675-afae-70eb-be11-cc8ebff32f02.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08675-afae-70eb-be11-cc8ebff32f02.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08675-afae-70eb-be11-cc8ebff32f02.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/01a08181-d26b-712c-a947-b8b951f224e4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/01a08181-d26b-712c-a947-b8b951f224e4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/01a08181-d26b-712c-a947-b8b951f224e4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/01a08181-d26b-712c-a947-b8b951f224e4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/01a08181-d26b-712c-a947-b8b951f224e4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/01a08181-d26b-712c-a947-b8b951f224e4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/01a08181-d26b-712c-a947-b8b951f224e4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d5-a8c8-707d-a6a4-92bbd0814237.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d5-a8c8-707d-a6a4-92bbd0814237.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d5-a8c8-707d-a6a4-92bbd0814237.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d5-a8c8-707d-a6a4-92bbd0814237.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d5-a8c8-707d-a6a4-92bbd0814237.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d5-a8c8-707d-a6a4-92bbd0814237.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d5-a8c8-707d-a6a4-92bbd0814237.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-9347-74bd-8563-a11b433c45b8.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-4eab-7618-b172-5a260f7f0720.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-b3b1-7719-a09a-ca8245241890.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-b97d-754f-9986-9a325a455921.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-dbd1-7598-bb9b-cca5e1ff6d69.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-c449-7406-8317-4f30b04f271a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-9461-71c2-80e1-94f91c2b4d62.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa492-f832-708a-90ce-ad72aff11a2e.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa492-f832-708a-90ce-ad72aff11a2e.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa492-f832-708a-90ce-ad72aff11a2e.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa492-f832-708a-90ce-ad72aff11a2e.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa492-f832-708a-90ce-ad72aff11a2e.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa492-f832-708a-90ce-ad72aff11a2e.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/pryor/west-530::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03546-696b-72cc-94f1-52f896471c51.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/stillwater/apple-creek-stillwater::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165583/019e21bb-8b1e-730d-9339-5157c2299c2d.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/stillwater/apple-creek-stillwater/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165583/019e21bb-8b1e-730d-9339-5157c2299c2d.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/stillwater/apple-creek-stillwater/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165583/019e21bb-8b1e-730d-9339-5157c2299c2d.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/stillwater/apple-creek-stillwater/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165583/019e21bb-8b1e-730d-9339-5157c2299c2d.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/stillwater/apple-creek-stillwater/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165583/019e21bb-8b1e-730d-9339-5157c2299c2d.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/stillwater/apple-creek-stillwater/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165583/019e21bb-8b1e-730d-9339-5157c2299c2d.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/stillwater/apple-creek-stillwater/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165583/019e21bb-8b1e-730d-9339-5157c2299c2d.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-3c9d-76e8-94cb-f77787979815.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7d-28ba-763a-abcb-6c224fbeca00.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-ea78-73be-b7e1-25421a081928.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-120b-7351-a2fd-d476804d8254.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-3961-75e9-a0cb-fdb75f6a2975.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-36d3-7618-8cd3-129f7ce5817c.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7b-e115-769f-9af3-aa3d1f7bc189.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019dbae8-02ae-7772-8c95-43e989b44683.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019dbae7-d435-7518-a0f6-714c9c1a45c3.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019cfb3d-f8ff-7006-8b32-059c051cc4d5.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019dbae7-f27c-771d-bcbd-e2ab8c704046.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019dbae7-a90a-7255-a7ed-48a24ed943e1.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019dbae7-f094-74ec-b90b-30d2ba962cca.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019cfb3d-eb39-7085-8698-89de0ce84283.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/polo-run-apartments::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a4-0a5f-7367-add4-be42627ba17b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/polo-run-apartments/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a4-0a5f-7367-add4-be42627ba17b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/polo-run-apartments/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a4-0a5f-7367-add4-be42627ba17b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/polo-run-apartments/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a4-0a5f-7367-add4-be42627ba17b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/polo-run-apartments/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a4-0a5f-7367-add4-be42627ba17b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/polo-run-apartments/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a4-0a5f-7367-add4-be42627ba17b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/polo-run-apartments/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a4-0a5f-7367-add4-be42627ba17b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-a711-73a1-87a6-ff917d9fb6b4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-a711-73a1-87a6-ff917d9fb6b4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-a711-73a1-87a6-ff917d9fb6b4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-a711-73a1-87a6-ff917d9fb6b4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-a711-73a1-87a6-ff917d9fb6b4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-a711-73a1-87a6-ff917d9fb6b4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-a711-73a1-87a6-ff917d9fb6b4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01601-d1ff-71cc-9da1-7306b0287529.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01600-f860-72d3-8d65-f0fa4be1c3f3.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01601-d1ff-71cc-9da1-7306b0287529.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01601-d1ff-71cc-9da1-7306b0287529.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01601-d1ff-71cc-9da1-7306b0287529.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01601-d1ff-71cc-9da1-7306b0287529.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01601-d1ff-71cc-9da1-7306b0287529.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019fbc0e-1f0f-75a9-85da-725a92f84202.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019fb44b-9d3b-770a-b096-8b05f36df333.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019fb44b-9d3b-770a-b096-8b05f36df333.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019fb44b-9d3b-770a-b096-8b05f36df333.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019fb44b-9d3b-770a-b096-8b05f36df333.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019fb44b-9d3b-770a-b096-8b05f36df333.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019fb44b-9d3b-770a-b096-8b05f36df333.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee070-b1c7-77db-a106-bde4a9760503.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee06e-e315-77a5-abd3-62a159fbb1e6.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee077-5c55-73b0-a8cf-72b3eb8f7a5f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee077-5d5b-727e-9e04-6e444f448b8b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee077-5c55-73b0-a8cf-72b3eb8f7a5f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee070-b1c7-77db-a106-bde4a9760503.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-f318-71e9-b683-5030cc51c615.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-f318-71e9-b683-5030cc51c615.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-f318-71e9-b683-5030cc51c615.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-f318-71e9-b683-5030cc51c615.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-f318-71e9-b683-5030cc51c615.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-f318-71e9-b683-5030cc51c615.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-f318-71e9-b683-5030cc51c615.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-4cdc-773d-87ea-8d12fa547536.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-4cdc-773d-87ea-8d12fa547536.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-4cdc-773d-87ea-8d12fa547536.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-4cdc-773d-87ea-8d12fa547536.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-4cdc-773d-87ea-8d12fa547536.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-4cdc-773d-87ea-8d12fa547536.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-4cdc-773d-87ea-8d12fa547536.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c3-d5c1-739b-8ac3-d535d3b988bf.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c3-d5c1-739b-8ac3-d535d3b988bf.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c3-d5c1-739b-8ac3-d535d3b988bf.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c3-d5c1-739b-8ac3-d535d3b988bf.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c3-d5c1-739b-8ac3-d535d3b988bf.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c3-d5c1-739b-8ac3-d535d3b988bf.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c3-d5c1-739b-8ac3-d535d3b988bf.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf7-a414-74c2-aeb9-9c7cd0866b52.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf7-a414-74c2-aeb9-9c7cd0866b52.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf7-a414-74c2-aeb9-9c7cd0866b52.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf7-a414-74c2-aeb9-9c7cd0866b52.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf7-a414-74c2-aeb9-9c7cd0866b52.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf7-a414-74c2-aeb9-9c7cd0866b52.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf7-a414-74c2-aeb9-9c7cd0866b52.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc6-65b8-7651-ae89-766f43bec5d5.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc6-65b8-7651-ae89-766f43bec5d5.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc6-65b8-7651-ae89-766f43bec5d5.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc6-65b8-7651-ae89-766f43bec5d5.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc6-65b8-7651-ae89-766f43bec5d5.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc6-65b8-7651-ae89-766f43bec5d5.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc6-65b8-7651-ae89-766f43bec5d5.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df3-c418-75a9-b7a3-ef3f22dfd3a1.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df3-c418-75a9-b7a3-ef3f22dfd3a1.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df3-c418-75a9-b7a3-ef3f22dfd3a1.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df3-c418-75a9-b7a3-ef3f22dfd3a1.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df3-c418-75a9-b7a3-ef3f22dfd3a1.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df3-c418-75a9-b7a3-ef3f22dfd3a1.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df3-c418-75a9-b7a3-ef3f22dfd3a1.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/01a117ae-246b-7048-8b91-44d09256d861.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/01a117ae-246b-7048-8b91-44d09256d861.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/01a117ae-246b-7048-8b91-44d09256d861.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/01a117ae-246b-7048-8b91-44d09256d861.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/01a117ae-246b-7048-8b91-44d09256d861.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/01a117ae-246b-7048-8b91-44d09256d861.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/01a117ae-246b-7048-8b91-44d09256d861.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-d133-730d-a410-f2c4a0c211e9.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-d133-730d-a410-f2c4a0c211e9.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-d133-730d-a410-f2c4a0c211e9.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-d133-730d-a410-f2c4a0c211e9.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-d133-730d-a410-f2c4a0c211e9.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-d133-730d-a410-f2c4a0c211e9.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-d133-730d-a410-f2c4a0c211e9.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/01a0a195-fb6c-747d-abcf-14bdf243ffbc.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/01a0a195-fb6c-747d-abcf-14bdf243ffbc.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/01a0a195-fb6c-747d-abcf-14bdf243ffbc.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/01a0a195-fb6c-747d-abcf-14bdf243ffbc.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/01a0a195-fb6c-747d-abcf-14bdf243ffbc.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/01a0a195-fb6c-747d-abcf-14bdf243ffbc.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/01a0a195-fb6c-747d-abcf-14bdf243ffbc.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd5-89cd-740f-a87b-fe171f324b67.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd5-89cd-740f-a87b-fe171f324b67.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd5-89cd-740f-a87b-fe171f324b67.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd5-89cd-740f-a87b-fe171f324b67.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd5-89cd-740f-a87b-fe171f324b67.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd5-89cd-740f-a87b-fe171f324b67.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd5-89cd-740f-a87b-fe171f324b67.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a03a68-0246-700a-8653-2d8fa0e8dead.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a03a68-0246-700a-8653-2d8fa0e8dead.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a03a68-0246-700a-8653-2d8fa0e8dead.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a03a68-0246-700a-8653-2d8fa0e8dead.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a03a68-0246-700a-8653-2d8fa0e8dead.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a03a68-0246-700a-8653-2d8fa0e8dead.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a03a68-0246-700a-8653-2d8fa0e8dead.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda4-5e2d-72f6-9eb2-f4e3c0fe79bc.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda4-5e2d-72f6-9eb2-f4e3c0fe79bc.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda4-5e2d-72f6-9eb2-f4e3c0fe79bc.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda4-5e2d-72f6-9eb2-f4e3c0fe79bc.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda4-5e2d-72f6-9eb2-f4e3c0fe79bc.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda4-5e2d-72f6-9eb2-f4e3c0fe79bc.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda4-5e2d-72f6-9eb2-f4e3c0fe79bc.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2f-024b-757d-b3a3-0112a383b577.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2f-024b-757d-b3a3-0112a383b577.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2f-024b-757d-b3a3-0112a383b577.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2f-024b-757d-b3a3-0112a383b577.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2f-024b-757d-b3a3-0112a383b577.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2f-024b-757d-b3a3-0112a383b577.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2f-024b-757d-b3a3-0112a383b577.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd72-c2d6-7513-aa4b-3e1ac4450079.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road/amenities::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd72-c2d6-7513-aa4b-3e1ac4450079.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road/contact-us::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd72-c2d6-7513-aa4b-3e1ac4450079.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road/floor-plans::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd72-c2d6-7513-aa4b-3e1ac4450079.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road/neighborhood::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd72-c2d6-7513-aa4b-3e1ac4450079.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road/pet-policy::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd72-c2d6-7513-aa4b-3e1ac4450079.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road/photos::propertyfootercta.card_image_0": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd72-c2d6-7513-aa4b-3e1ac4450079.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db58a-169d-740b-8553-3d18b22355ee.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-0870-73f4-b10f-1808cbca0a63.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-4e40-7209-bc15-a7a37d74cfff.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-2a4b-7331-aa9b-f135776152f5.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db588-fde4-736b-aab0-39b1062a882f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db58a-169d-740b-8553-3d18b22355ee.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-a062-77ac-a337-575538051785.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a1897a-fef7-764a-980f-ae0f232a0a48.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a1897a-fef7-764a-980f-ae0f232a0a48.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a1897a-fef7-764a-980f-ae0f232a0a48.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a1897a-fef7-764a-980f-ae0f232a0a48.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a1897a-fef7-764a-980f-ae0f232a0a48.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a1897a-fef7-764a-980f-ae0f232a0a48.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a1897a-fef7-764a-980f-ae0f232a0a48.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/huntington-park::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166545/019cfb4e-5b17-77fb-91ae-6a0be2f681c2.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-3507-75ec-9483-ec0d632f691e.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5ce-b727-77c9-9cb6-e91a19da675d.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-8bd6-72d0-b81a-776743309c92.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-b154-763f-af26-ffc256f2ed88.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/97-north-oak::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-c875-75af-8dc5-1f3d478293b0.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-ee3f-7319-9904-d36058038051.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-ee3f-7319-9904-d36058038051.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-ee3f-7319-9904-d36058038051.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-ee3f-7319-9904-d36058038051.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-ee3f-7319-9904-d36058038051.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-ee3f-7319-9904-d36058038051.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-ee3f-7319-9904-d36058038051.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb52-eeac-7379-bf1e-79e2cc4e2d88.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb52-7054-76eb-826f-d661335ba170.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/redbud-ranch::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa538-5004-7279-b3de-e2f7d319a9ed.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/redbud-ranch/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa538-5004-7279-b3de-e2f7d319a9ed.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/redbud-ranch/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa538-5004-7279-b3de-e2f7d319a9ed.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/redbud-ranch/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa538-5004-7279-b3de-e2f7d319a9ed.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/redbud-ranch/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa538-5004-7279-b3de-e2f7d319a9ed.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/redbud-ranch/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa538-5004-7279-b3de-e2f7d319a9ed.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/redbud-ranch/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa538-5004-7279-b3de-e2f7d319a9ed.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-459e-750b-82c1-b6e69c329acd.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-459e-750b-82c1-b6e69c329acd.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-3ff1-775c-bb66-18b3bd84337b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-459e-750b-82c1-b6e69c329acd.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-459e-750b-82c1-b6e69c329acd.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-3ff1-775c-bb66-18b3bd84337b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-3ff1-775c-bb66-18b3bd84337b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a36-511f-7529-9148-8952d9aa5d3f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a36-511f-7529-9148-8952d9aa5d3f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a36-511f-7529-9148-8952d9aa5d3f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a36-511f-7529-9148-8952d9aa5d3f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a36-511f-7529-9148-8952d9aa5d3f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a36-511f-7529-9148-8952d9aa5d3f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a36-511f-7529-9148-8952d9aa5d3f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-5941-76cb-8b69-8278a31f007f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-5941-76cb-8b69-8278a31f007f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-5941-76cb-8b69-8278a31f007f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-5941-76cb-8b69-8278a31f007f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-5941-76cb-8b69-8278a31f007f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-5941-76cb-8b69-8278a31f007f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-5941-76cb-8b69-8278a31f007f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c1c-c6a5-7246-9f09-5b06d07efc4a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c1c-c6a5-7246-9f09-5b06d07efc4a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c1c-c6a5-7246-9f09-5b06d07efc4a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c1c-c6a5-7246-9f09-5b06d07efc4a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c1c-c6a5-7246-9f09-5b06d07efc4a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c1c-c6a5-7246-9f09-5b06d07efc4a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c1c-c6a5-7246-9f09-5b06d07efc4a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc0a-0472-744a-a957-aae73b98e40f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019db609-4bfe-72ff-8833-54041741b981.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019db60a-de39-749a-abd9-123d10f1e6b3.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-eae1-729a-8c0e-a02dffb17224.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019db608-f939-70d4-af47-1e583ad2c854.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019db609-95c7-70fb-9d17-f88182c6c527.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019db609-6276-72e8-b401-ee8181a8159b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06274-3b47-74f8-9dc7-bf24937d16a2.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06274-3b47-74f8-9dc7-bf24937d16a2.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06274-3b47-74f8-9dc7-bf24937d16a2.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06274-3b47-74f8-9dc7-bf24937d16a2.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06274-3b47-74f8-9dc7-bf24937d16a2.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06274-3b47-74f8-9dc7-bf24937d16a2.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06274-3b47-74f8-9dc7-bf24937d16a2.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a1400a-23a1-70d2-b4b3-edc4629dab52.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a1400a-23a1-70d2-b4b3-edc4629dab52.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a1400a-23a1-70d2-b4b3-edc4629dab52.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a1400a-23a1-70d2-b4b3-edc4629dab52.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a1400a-23a1-70d2-b4b3-edc4629dab52.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a1400a-23a1-70d2-b4b3-edc4629dab52.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a1400a-23a1-70d2-b4b3-edc4629dab52.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/01a183b2-a97c-70f0-8d46-766548789255.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/01a183b2-a97c-70f0-8d46-766548789255.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/01a183b2-a97c-70f0-8d46-766548789255.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/01a183b2-a97c-70f0-8d46-766548789255.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/01a183b2-a97c-70f0-8d46-766548789255.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/01a183b2-a97c-70f0-8d46-766548789255.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-af54-77cf-bb67-b1f2ebbaab1c.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-af54-77cf-bb67-b1f2ebbaab1c.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-af54-77cf-bb67-b1f2ebbaab1c.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-af54-77cf-bb67-b1f2ebbaab1c.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-af54-77cf-bb67-b1f2ebbaab1c.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-af54-77cf-bb67-b1f2ebbaab1c.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-af54-77cf-bb67-b1f2ebbaab1c.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08675-a1f0-70de-b001-bb782fcb052a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08675-a1f0-70de-b001-bb782fcb052a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08675-a1f0-70de-b001-bb782fcb052a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08675-a1f0-70de-b001-bb782fcb052a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08675-a1f0-70de-b001-bb782fcb052a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08675-a1f0-70de-b001-bb782fcb052a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08675-a1f0-70de-b001-bb782fcb052a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/01a08181-f91c-71ac-9192-3b247e6aa753.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/01a08181-f91c-71ac-9192-3b247e6aa753.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/01a08181-f91c-71ac-9192-3b247e6aa753.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/01a08181-f91c-71ac-9192-3b247e6aa753.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/01a08181-f91c-71ac-9192-3b247e6aa753.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/01a08181-f91c-71ac-9192-3b247e6aa753.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/01a08181-f91c-71ac-9192-3b247e6aa753.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d5-c7aa-73ee-bc66-8e9b3a0c5f20.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d5-c7aa-73ee-bc66-8e9b3a0c5f20.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d5-c7aa-73ee-bc66-8e9b3a0c5f20.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d5-c7aa-73ee-bc66-8e9b3a0c5f20.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d5-c7aa-73ee-bc66-8e9b3a0c5f20.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d5-c7aa-73ee-bc66-8e9b3a0c5f20.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d5-c7aa-73ee-bc66-8e9b3a0c5f20.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2302-e97d-743c-9289-d86861cbce6a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2302-aafa-711f-916e-24738de9cf43.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-db87-7174-845a-305160dc3368.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-d50d-73ab-b734-3d56e779c524.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-9461-71c2-80e1-94f91c2b4d62.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-5460-7762-9a9c-7f70a3109704.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa492-eae7-7648-aec9-d18ca616f14a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa492-eae7-7648-aec9-d18ca616f14a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa492-eae7-7648-aec9-d18ca616f14a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa492-eae7-7648-aec9-d18ca616f14a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa492-eae7-7648-aec9-d18ca616f14a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa492-eae7-7648-aec9-d18ca616f14a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/pryor/west-530::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03546-4af6-73ca-8cc8-66ac1385eee2.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-d17d-74e8-baf3-ab02e8b231af.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-eac3-746f-a4cb-51ecb3608e07.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-24da-71cc-a208-5482e036ecad.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7b-e119-73aa-89ad-677005680d7e.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-120b-7351-a2fd-d476804d8254.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-3c9d-76e8-94cb-f77787979815.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7b-ca7c-757e-9302-bb8a11e206f7.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019dbae7-e7a7-775d-a6fe-8346567155f7.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019dbae7-a858-72dc-a432-8eb578844bd2.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019dbae7-f6b7-70cb-a2c5-3ecdb32504cd.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019dbae7-cd77-773c-8e99-56621608073a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d20af-28d8-72ec-ba85-e679bc1e69d3.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019dbae7-fae7-7174-9721-eea915ea9f50.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019dbae7-e7a7-775d-a6fe-8346567155f7.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-8407-75db-af34-0494e665ff38.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-8407-75db-af34-0494e665ff38.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-8407-75db-af34-0494e665ff38.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-8407-75db-af34-0494e665ff38.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-8407-75db-af34-0494e665ff38.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-8407-75db-af34-0494e665ff38.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-8407-75db-af34-0494e665ff38.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019fb44b-9d06-76db-afda-aed3b890a7cf.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019fb44b-9d06-76db-afda-aed3b890a7cf.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019fb44b-9d06-76db-afda-aed3b890a7cf.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019fb44b-9d06-76db-afda-aed3b890a7cf.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019fb44b-9d06-76db-afda-aed3b890a7cf.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019fb44b-9d06-76db-afda-aed3b890a7cf.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019fb44b-9d06-76db-afda-aed3b890a7cf.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee06f-1eaa-720f-8418-69eb5b965069.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee070-b1c7-77db-a106-bde4a9760503.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee077-5d5b-727e-9e04-6e444f448b8b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee077-5d5f-722c-a8ed-b55dc2a9b135.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee076-e6bc-778a-b426-7b999ade8240.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee06f-12fb-76df-9845-d9fea4620cb7.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-dc5b-76b1-9d71-ca13db99faea.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-dc5b-76b1-9d71-ca13db99faea.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-dc5b-76b1-9d71-ca13db99faea.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-dc5b-76b1-9d71-ca13db99faea.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-dc5b-76b1-9d71-ca13db99faea.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-dc5b-76b1-9d71-ca13db99faea.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-dc5b-76b1-9d71-ca13db99faea.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fcea7-2d64-75dc-9c03-23c147dcd5e4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fcea7-2d64-75dc-9c03-23c147dcd5e4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fcea7-2d64-75dc-9c03-23c147dcd5e4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fcea7-2d64-75dc-9c03-23c147dcd5e4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fcea7-2d64-75dc-9c03-23c147dcd5e4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fcea7-2d64-75dc-9c03-23c147dcd5e4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fcea7-2d64-75dc-9c03-23c147dcd5e4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c2-ad4a-7368-b6e5-aa532c34e642.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c2-ad4a-7368-b6e5-aa532c34e642.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c2-ad4a-7368-b6e5-aa532c34e642.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c2-ad4a-7368-b6e5-aa532c34e642.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c2-ad4a-7368-b6e5-aa532c34e642.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c2-ad4a-7368-b6e5-aa532c34e642.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c2-ad4a-7368-b6e5-aa532c34e642.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf7-929d-72f1-afcd-653e96d97831.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf7-929d-72f1-afcd-653e96d97831.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf7-929d-72f1-afcd-653e96d97831.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf7-929d-72f1-afcd-653e96d97831.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf7-929d-72f1-afcd-653e96d97831.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf7-929d-72f1-afcd-653e96d97831.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf7-929d-72f1-afcd-653e96d97831.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc6-50f4-726b-a8fc-79bd00c0bb14.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc6-50f4-726b-a8fc-79bd00c0bb14.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc6-50f4-726b-a8fc-79bd00c0bb14.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc6-50f4-726b-a8fc-79bd00c0bb14.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc6-50f4-726b-a8fc-79bd00c0bb14.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc6-50f4-726b-a8fc-79bd00c0bb14.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc6-50f4-726b-a8fc-79bd00c0bb14.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df3-8ea9-742d-9bf6-9c245d287ef7.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df3-8ea9-742d-9bf6-9c245d287ef7.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df3-8ea9-742d-9bf6-9c245d287ef7.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df3-8ea9-742d-9bf6-9c245d287ef7.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df3-8ea9-742d-9bf6-9c245d287ef7.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df3-8ea9-742d-9bf6-9c245d287ef7.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df3-8ea9-742d-9bf6-9c245d287ef7.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/01a0e998-d1f0-744c-ae02-340323df2019.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/01a0e998-d1f0-744c-ae02-340323df2019.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/01a0e998-d1f0-744c-ae02-340323df2019.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/01a0e998-d1f0-744c-ae02-340323df2019.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/01a0e998-d1f0-744c-ae02-340323df2019.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/01a0e998-d1f0-744c-ae02-340323df2019.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/01a0e998-d1f0-744c-ae02-340323df2019.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/01a117ae-132b-754c-840a-315a1c5f3900.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/01a117ae-132b-754c-840a-315a1c5f3900.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/01a117ae-132b-754c-840a-315a1c5f3900.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/01a117ae-132b-754c-840a-315a1c5f3900.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/01a117ae-132b-754c-840a-315a1c5f3900.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/01a117ae-132b-754c-840a-315a1c5f3900.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/01a117ae-132b-754c-840a-315a1c5f3900.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/01a0a196-2978-771c-9407-0620a64bfe13.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/01a0a196-2978-771c-9407-0620a64bfe13.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/01a0a196-2978-771c-9407-0620a64bfe13.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/01a0a196-2978-771c-9407-0620a64bfe13.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/01a0a196-2978-771c-9407-0620a64bfe13.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/01a0a196-2978-771c-9407-0620a64bfe13.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/01a0a196-2978-771c-9407-0620a64bfe13.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/phoenix-apts::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/01a0a16c-1c5e-7466-8a48-9da6f47afb0c.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/phoenix-apts/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/01a0a16c-1c5e-7466-8a48-9da6f47afb0c.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/phoenix-apts/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/01a0a16c-1c5e-7466-8a48-9da6f47afb0c.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/phoenix-apts/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/01a0a16c-1c5e-7466-8a48-9da6f47afb0c.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/phoenix-apts/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/01a0a16c-1c5e-7466-8a48-9da6f47afb0c.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/phoenix-apts/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/01a0a16c-1c5e-7466-8a48-9da6f47afb0c.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/phoenix-apts/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/01a0a16c-1c5e-7466-8a48-9da6f47afb0c.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd5-7a62-7267-bc1f-c08b986347c0.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd5-7b06-70bf-bdb5-7ac2d352aa77.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd5-7b06-70bf-bdb5-7ac2d352aa77.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd5-7b06-70bf-bdb5-7ac2d352aa77.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd5-7b06-70bf-bdb5-7ac2d352aa77.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd5-7b06-70bf-bdb5-7ac2d352aa77.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd5-7b06-70bf-bdb5-7ac2d352aa77.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a03a62-3e40-7408-9e28-add24eba4236.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a03a62-3e40-7408-9e28-add24eba4236.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a03a62-3e40-7408-9e28-add24eba4236.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a03a62-3e40-7408-9e28-add24eba4236.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a03a62-3e40-7408-9e28-add24eba4236.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a03a62-3e40-7408-9e28-add24eba4236.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a03a62-3e40-7408-9e28-add24eba4236.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda4-321d-727c-967a-c7f12ee7f857.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda4-321d-727c-967a-c7f12ee7f857.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda4-321d-727c-967a-c7f12ee7f857.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda4-321d-727c-967a-c7f12ee7f857.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda4-321d-727c-967a-c7f12ee7f857.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda4-321d-727c-967a-c7f12ee7f857.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda4-321d-727c-967a-c7f12ee7f857.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2f-00d9-712b-9eab-46f146603465.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place/amenities::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2f-00d9-712b-9eab-46f146603465.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place/contact-us::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2f-00d9-712b-9eab-46f146603465.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place/floor-plans::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2f-00d9-712b-9eab-46f146603465.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place/neighborhood::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2f-00d9-712b-9eab-46f146603465.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place/pet-policy::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2f-00d9-712b-9eab-46f146603465.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place/photos::propertyfootercta.card_image_1": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2f-00d9-712b-9eab-46f146603465.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-a1ce-7238-9831-0f0daa960bde.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-ed88-70da-9a60-d42b9ef39e65.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-9e75-7733-bfbd-2c0268c6e968.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019d4894-e75a-71c8-b433-1a97ad4e45a1.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db588-d914-7108-9924-fcd4d269d942.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019dac71-f7db-7682-b397-b7072a877ebc.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-a1cd-713b-8fd4-ff0eeed4d48c.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a1897b-0854-705b-8db9-8c01a7dffc52.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a1897b-0854-705b-8db9-8c01a7dffc52.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a1897b-0854-705b-8db9-8c01a7dffc52.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a1897b-0854-705b-8db9-8c01a7dffc52.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a1897b-0854-705b-8db9-8c01a7dffc52.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a1897b-0854-705b-8db9-8c01a7dffc52.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/huntington-park::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166545/019cfb4e-57bd-73a4-8eb0-4497fe98df5e.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/portofino/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166547/019db0cc-1c98-71be-bdce-4daf0ff33329.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-6d49-7456-856e-749d7b3914f6.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-36f4-73fd-83e8-e6688526e7bb.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166550/019db5cf-c3ca-7151-82dd-45336a6c1bb5.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/97-north-oak::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db72a-a0e4-739f-955e-88a7fc8f02b5.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-d9fb-72a6-8ad2-800c612b5c3a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-d9fb-72a6-8ad2-800c612b5c3a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-d9fb-72a6-8ad2-800c612b5c3a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-d9fb-72a6-8ad2-800c612b5c3a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-d9fb-72a6-8ad2-800c612b5c3a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-d9fb-72a6-8ad2-800c612b5c3a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-d9fb-72a6-8ad2-800c612b5c3a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db68f-bcbe-756a-9c3f-91a1ff70a438.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db68f-ea14-7688-a04a-098696b82e53.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-3ff1-775c-bb66-18b3bd84337b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-459e-750b-82c1-b6e69c329acd.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-3ff1-775c-bb66-18b3bd84337b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-3ff1-775c-bb66-18b3bd84337b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-459e-750b-82c1-b6e69c329acd.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-459e-750b-82c1-b6e69c329acd.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a36-3ba7-7497-ab30-ed3889e21009.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a36-3ba7-7497-ab30-ed3889e21009.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a36-3ba7-7497-ab30-ed3889e21009.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a36-3ba7-7497-ab30-ed3889e21009.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a36-3ba7-7497-ab30-ed3889e21009.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a36-3ba7-7497-ab30-ed3889e21009.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a36-3ba7-7497-ab30-ed3889e21009.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c1c-d8ca-71ac-8ce0-56a620aaaffa.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c1c-d8ca-71ac-8ce0-56a620aaaffa.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c1c-d8ca-71ac-8ce0-56a620aaaffa.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c1c-d8ca-71ac-8ce0-56a620aaaffa.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c1c-d8ca-71ac-8ce0-56a620aaaffa.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c1c-d8ca-71ac-8ce0-56a620aaaffa.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c1c-d8ca-71ac-8ce0-56a620aaaffa.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-955f-72cc-b404-cc4a5c9bd1bc.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019db609-99ed-70eb-bb85-75b500e2353a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019db60a-24d9-72b8-b4cc-8afcb7ad4c86.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019db609-c549-71fc-852b-a41e55a4610c.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-b6b2-76fa-8d9d-633dd34c301e.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019db609-cd88-72cf-9952-be26aa11ccef.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-a70c-77c7-a11b-93f1c74fff39.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06274-51b0-74cc-b66d-1254a299e6c2.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06274-51b0-74cc-b66d-1254a299e6c2.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06274-51b0-74cc-b66d-1254a299e6c2.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06274-51b0-74cc-b66d-1254a299e6c2.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06274-51b0-74cc-b66d-1254a299e6c2.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06274-51b0-74cc-b66d-1254a299e6c2.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06274-51b0-74cc-b66d-1254a299e6c2.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a1400a-0944-76db-879a-06c7561899e4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a1400a-1bc0-7758-91d7-6582abc1ff7b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a1400a-1bc0-7758-91d7-6582abc1ff7b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a1400a-1bc0-7758-91d7-6582abc1ff7b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a1400a-1bc0-7758-91d7-6582abc1ff7b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a1400a-1bc0-7758-91d7-6582abc1ff7b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a1400a-1bc0-7758-91d7-6582abc1ff7b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/019cfb3d-f233-71af-98de-f5beb1a6b20a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/019cfb3d-f233-71af-98de-f5beb1a6b20a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/019cfb3d-f233-71af-98de-f5beb1a6b20a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/019cfb3d-f233-71af-98de-f5beb1a6b20a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/019cfb3d-f233-71af-98de-f5beb1a6b20a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/019cfb3d-f233-71af-98de-f5beb1a6b20a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-af63-74f8-bd16-c1ed82ab6849.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-af63-74f8-bd16-c1ed82ab6849.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-ab51-7244-b835-b4a32a69b27e.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-af63-74f8-bd16-c1ed82ab6849.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-ab51-7244-b835-b4a32a69b27e.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-ab51-7244-b835-b4a32a69b27e.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-ab51-7244-b835-b4a32a69b27e.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08675-9edd-75d8-b51d-4ba07102c273.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08675-9edd-75d8-b51d-4ba07102c273.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08675-9edd-75d8-b51d-4ba07102c273.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08675-9edd-75d8-b51d-4ba07102c273.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08675-9edd-75d8-b51d-4ba07102c273.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08675-9edd-75d8-b51d-4ba07102c273.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08675-9edd-75d8-b51d-4ba07102c273.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-b317-703c-ad01-5e99012cdb17.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/01a08181-ef16-7697-9fe9-0d80b5f25b08.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/01a08181-ef16-7697-9fe9-0d80b5f25b08.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/01a08181-ef16-7697-9fe9-0d80b5f25b08.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/01a08181-ef16-7697-9fe9-0d80b5f25b08.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/01a08181-ef16-7697-9fe9-0d80b5f25b08.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/01a08181-ef16-7697-9fe9-0d80b5f25b08.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d5-a894-74d9-8995-c42ee1d2f578.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d5-a894-74d9-8995-c42ee1d2f578.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d5-a894-74d9-8995-c42ee1d2f578.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d5-a894-74d9-8995-c42ee1d2f578.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d5-a894-74d9-8995-c42ee1d2f578.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d5-a894-74d9-8995-c42ee1d2f578.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d5-a894-74d9-8995-c42ee1d2f578.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-4e3c-7058-a687-c320d5dfca75.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2302-c9f5-7698-95c4-7e0f89e9cc8d.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-95a7-73cf-b14d-01d55429a860.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2302-77c8-73dd-ad0d-ea93dcdcc8e1.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-bda3-77cd-81fb-836decbd25bf.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-4e3c-7058-a687-c320d5dfca75.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-9e37-7599-af6d-798dddf3f299.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa492-f831-7081-879e-62d751ef822f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa492-f831-7081-879e-62d751ef822f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa492-f831-7081-879e-62d751ef822f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa492-f831-7081-879e-62d751ef822f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa492-f831-7081-879e-62d751ef822f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa492-f831-7081-879e-62d751ef822f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/pryor/west-530::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03546-395c-70ec-b37d-8d4656163131.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-0a49-7284-922f-5a6675a87459.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7d-1eb4-7696-94f6-d3365c7654d6.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d4eb5-0842-73a2-ab0c-8215886cd343.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d07db-b63d-76a5-b5a2-4163d5b75fae.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7b-e1c8-71e6-b755-a06798947517.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-3d39-72ae-a1b0-2c21fd175d92.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7b-e119-73aa-89ad-6b3de90cfd63.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019cfb3e-05ee-748c-aa3e-ff90b060af19.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019dbae7-a85a-726d-8434-146db619cf1a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019cfb3d-eb20-73af-a399-269920ba64ac.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019cfb3e-95b0-7632-9b8f-620d5e31cf1c.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019dbae5-942e-70a1-bc15-3d2b32b8e754.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019dbae5-942e-70a1-bc15-3d2b32b8e754.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019dbae7-f27c-771d-bcbd-e2ab8c704046.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-82d6-74ab-bf13-0828a33b4de4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-82d6-74ab-bf13-0828a33b4de4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-82d6-74ab-bf13-0828a33b4de4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-82d6-74ab-bf13-0828a33b4de4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-82d6-74ab-bf13-0828a33b4de4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-82d6-74ab-bf13-0828a33b4de4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-82d6-74ab-bf13-0828a33b4de4.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01601-299e-7541-bc7d-ea7f4ec961e5.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01601-2178-76eb-9389-0d51ed1ee2cb.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01601-2178-76eb-9389-0d51ed1ee2cb.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01601-2178-76eb-9389-0d51ed1ee2cb.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01601-299e-7541-bc7d-ea7f4ec961e5.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01601-2178-76eb-9389-0d51ed1ee2cb.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01601-299e-7541-bc7d-ea7f4ec961e5.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-46ea-724c-bb9d-df4d1a31a37a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-46ea-724c-bb9d-df4d1a31a37a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-46ea-724c-bb9d-df4d1a31a37a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-5530-74df-ad45-968735f78892.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-46ea-724c-bb9d-df4d1a31a37a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-46ea-724c-bb9d-df4d1a31a37a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-46ea-724c-bb9d-df4d1a31a37a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee06b-950c-718e-8958-1f92a1e14355.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee070-c542-72e9-90c9-436b5bd23d5d.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee077-5fa0-714d-98a3-f9300007e03f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee076-e6bc-778a-b426-7b999ade8240.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee077-5fa0-714d-98a3-f9300007e03f.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee06f-2360-75ac-b829-19b5c3fa3e90.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-c3fa-74dc-97f6-edde1ca71adb.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-c3fa-74dc-97f6-edde1ca71adb.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-c3fa-74dc-97f6-edde1ca71adb.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-c3fa-74dc-97f6-edde1ca71adb.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-c3fa-74dc-97f6-edde1ca71adb.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-c3fa-74dc-97f6-edde1ca71adb.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-c3fa-74dc-97f6-edde1ca71adb.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c2-9f6a-769c-8281-e0ce309dcb98.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c2-adca-7329-8918-87c985a73ba5.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c2-9f6a-769c-8281-e0ce309dcb98.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c2-9f6a-769c-8281-e0ce309dcb98.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c2-9f6a-769c-8281-e0ce309dcb98.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c2-9f6a-769c-8281-e0ce309dcb98.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c2-9f6a-769c-8281-e0ce309dcb98.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf7-9ff3-73ae-b7e9-072654cb39be.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf7-9ff3-73ae-b7e9-072654cb39be.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf7-9ff3-73ae-b7e9-072654cb39be.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf5-2bb6-74af-8e9c-0af69c7c7426.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf7-9ff3-73ae-b7e9-072654cb39be.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf7-9ff3-73ae-b7e9-072654cb39be.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf7-9ff3-73ae-b7e9-072654cb39be.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc6-430d-7239-ba68-49f65182f55e.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc6-430d-7239-ba68-49f65182f55e.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc6-430d-7239-ba68-49f65182f55e.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc6-430d-7239-ba68-49f65182f55e.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc6-430d-7239-ba68-49f65182f55e.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc6-430d-7239-ba68-49f65182f55e.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc6-430d-7239-ba68-49f65182f55e.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df4-306e-766d-b4b9-a58da11ebeed.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df4-306e-766d-b4b9-a58da11ebeed.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df4-306e-766d-b4b9-a58da11ebeed.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df4-306e-766d-b4b9-a58da11ebeed.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df4-306e-766d-b4b9-a58da11ebeed.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df4-306e-766d-b4b9-a58da11ebeed.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df4-306e-766d-b4b9-a58da11ebeed.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/01a0e998-bf53-73d9-a8cc-383c92a3622b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/01a0e998-bf53-73d9-a8cc-383c92a3622b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/01a0e998-bf53-73d9-a8cc-383c92a3622b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/01a0e998-bf53-73d9-a8cc-383c92a3622b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/01a0e998-bf53-73d9-a8cc-383c92a3622b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/01a0e998-bf53-73d9-a8cc-383c92a3622b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/01a0e998-bf53-73d9-a8cc-383c92a3622b.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/01a117ae-07ba-73d9-a4da-427f85bd1356.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/01a117ae-07ba-73d9-a4da-427f85bd1356.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/01a117ae-07ba-73d9-a4da-427f85bd1356.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/01a117ae-07ba-73d9-a4da-427f85bd1356.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/01a117ae-07ba-73d9-a4da-427f85bd1356.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/01a117ae-07ba-73d9-a4da-427f85bd1356.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/01a117ae-07ba-73d9-a4da-427f85bd1356.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-c221-753e-90f9-bf6d775b85bc.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-c221-753e-90f9-bf6d775b85bc.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-c221-753e-90f9-bf6d775b85bc.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-c221-753e-90f9-bf6d775b85bc.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-c221-753e-90f9-bf6d775b85bc.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-c221-753e-90f9-bf6d775b85bc.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-c221-753e-90f9-bf6d775b85bc.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/01a0a195-6374-76dc-86f4-0fc35f97f0b1.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb41-056c-7149-b288-b0cc5505f8a0.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/01a0a195-67b0-748d-9027-9723de021dea.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/01a0a195-67b0-748d-9027-9723de021dea.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/01a0a195-67b0-748d-9027-9723de021dea.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019d48de-bd85-7028-b700-3ec0f20ed8f1.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/01a0a195-67b0-748d-9027-9723de021dea.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd5-9265-715d-a616-7cd85341ae17.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd5-9265-715d-a616-7cd85341ae17.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd5-9265-715d-a616-7cd85341ae17.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd5-9265-715d-a616-7cd85341ae17.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd5-9265-715d-a616-7cd85341ae17.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd5-9265-715d-a616-7cd85341ae17.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd5-9265-715d-a616-7cd85341ae17.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a03a62-3d4b-7485-8844-b21974fe31b5.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a03a62-3d4b-7485-8844-b21974fe31b5.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a03a62-3d4b-7485-8844-b21974fe31b5.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a03a62-3d4b-7485-8844-b21974fe31b5.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a03a62-3d4b-7485-8844-b21974fe31b5.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a03a62-3d4b-7485-8844-b21974fe31b5.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a03a62-3d4b-7485-8844-b21974fe31b5.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda4-2f52-7441-8d36-ff6a69bcdc94.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda4-2f52-7441-8d36-ff6a69bcdc94.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda4-2f52-7441-8d36-ff6a69bcdc94.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda4-2f52-7441-8d36-ff6a69bcdc94.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda4-2f52-7441-8d36-ff6a69bcdc94.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda4-2f52-7441-8d36-ff6a69bcdc94.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda4-2f52-7441-8d36-ff6a69bcdc94.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2e-eea2-738e-98cc-f50f5c8123b7.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2e-eea2-738e-98cc-f50f5c8123b7.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2e-eea2-738e-98cc-f50f5c8123b7.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2e-eea2-738e-98cc-f50f5c8123b7.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2e-eea2-738e-98cc-f50f5c8123b7.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2e-eea2-738e-98cc-f50f5c8123b7.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2e-eea2-738e-98cc-f50f5c8123b7.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd71-bc57-709a-971d-4293aa2d02fb.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road/amenities::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd71-bc57-709a-971d-4293aa2d02fb.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road/contact-us::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd71-bc57-709a-971d-4293aa2d02fb.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road/floor-plans::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd71-bc57-709a-971d-4293aa2d02fb.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road/neighborhood::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd71-bc57-709a-971d-4293aa2d02fb.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road/pet-policy::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd71-bc57-709a-971d-4293aa2d02fb.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road/photos::propertyfootercta.card_image_2": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd71-bc57-709a-971d-4293aa2d02fb.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:property::propertyfootercta.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "apartments/ok/tulsa/the-greens-of-bedford::propertyfootercta.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "apartments/ok/oklahoma-city/24hundred-apartments::propertyfootercta.property_name": {
    "overrideType": "VALUE",
    "customValue": "24Hundred Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments::propertyfootercta.property_name": {
    "overrideType": "VALUE",
    "customValue": "Windsail Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>If you’re searching for <a href=\"/apartments/ar/little-rock/arbors-of-pleasant-valley-apts/neighborhood\"><strong>apartments near UAMS Hospital</strong></a>, look no further. The Arbors of Pleasant Valley is conveniently located on Hinson Loop Road just a short drive from I-430. Take a swing and relax at the nearby Pleasant Valley Country Club, take a stroll across the Big Dam Bridge, or treat yourself to a shopping trip at Market Place Shopping Center, all located less than 20 minutes from our apartments!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/north-little-rock/lexington-park::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>You’ll find Lexington Park Apartments in <a href=\"/apartments/ar/north-little-rock/lexington-park/neighborhood\"><strong>northern Little Rock</strong></a>, just 15 minutes from downtown. When you need to get out and enjoy some fresh air, head to Big Dam Bridge, the largest pedestrian and biking bridge in North America, just minutes away. You’ll also enjoy a wide selection of dining, shopping, and entertainment venues near our apartments in North Little Rock.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/maize/watercress-apartments::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Escape the hustle and bustle of downtown Wichita but remain conveniently close to the city’s renowned museums and attractions at Watercress, which is perfectly situated near the Delano Township and the <a href=\"/apartments/ks/maize/watercress/neighborhood\"><strong>Fox Ridge neighborhood</strong></a>. West Wichita is a charming, family-friendly area boasting restaurants, coffee shops, shopping centers, and schools and offering a well-rounded community experience.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our apartments in Wichita are located in the <a href=\"/apartments/ks/wichita/aspen-park-apartments/neighborhood\"><strong>Westlink neighborhood</strong></a>, minutes away from downtown. With the Westlink shopping center right down the street, coffee shops, restaurants, and stores will never be far away when you live in our Wichita apartments. You can find beautiful Swanson Park less than two miles away when you feel like getting outside and being in nature.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our apartment homes are in <a href=\"/apartments/ks/wichita/cottages-at-crestview/neighborhood\"><strong>east Wichita</strong></a>, near Harrison Park and Andover. Major retailers, like Walmart and Costco, and Towne East Square Mall are all within reach for residents of Cottages at Crestview. Additionally, excellent elementary, middle, and high schools surround our apartment community, and WSU is just a 10-minute drive away.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/crown-chase-apts::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Located on the banks of a gorgeous lake, Crown Chase apartments are surrounded by<strong> </strong><a href=\"/apartments/ks/wichita/crown-chase-apts/neighborhood\"><strong>shopping, dining, and entertainment</strong></a>. Less than five minutes from our apartment community, the expansive Sedgwick County Park offers a peaceful nature retreat, and the Sedgwick County Zoo invites you to explore its many educational exhibits.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/huntington-park::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Huntington Park’s 1 and 2 bedroom apartment homes in Wichita are situated near the desirable <a href=\"/apartments/ks/wichita/huntington-park/neighborhood\"><strong>Westlink neighborhood</strong></a> and just a short 15-minute commute from downtown. Expansive Sedgwick County Park is also just minutes away, boasting playgrounds, paved and dirt pathways, pavilions, and fishable lakes and ponds. Dining and shopping options surround Huntington Park alongside highly rated schools.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/newport-wichita-apts::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><a href=\"/apartments/ks/wichita/newport-wichita-apts/neighborhood\"><strong>Newport Apartments</strong></a> is just south of Silver Springs Apartments in a quiet corner west of the city. Find high-quality dining, schools, and shopping centers just a stone’s throw away from your luxury home. With the ideal balance of separation from the bustle of downtown Wichita paired with convenient proximity to the highway, the heart and soul of the city are within reach but never a disruption.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/portofino::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience <a href=\"/apartments/ks/wichita/portofino/neighborhood\"><strong>the best of east Wichita living</strong></a> at Portofino Apartments. Just minutes from Bradley Fair Shopping Center and Wichita State University, our community offers easy access to dining, shopping, and entertainment destinations. Spend the day exploring the Great Plains Nature Center or stroll along the scenic trails at Chisholm Creek Park. With convenient access to major highways, commuting to downtown Wichita or nearby neighborhoods like Andover and Bel Aire is a breeze.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/raintree-apartments::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>When you’re ready to step outside our community, <a href=\"/apartments/ks/wichita/raintree-apartments/neighborhood\"><strong>northwest Wichita</strong></a> invites you to explore its hidden gems and delightful attractions. Amid the array of supermarkets, casual and fine dining options, and everyday conveniences, you’ll discover family-friendly activities at places like the renowned Sedgwick County Zoo, offering an enriching experience for all ages.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/remington-wichita::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Located in the <a href=\"/apartments/ks/wichita/remington-wichita/neighborhood\"><strong>charming northeast area of Wichita</strong></a>, The Remington Apartments is near sought-after, family-oriented communities such as Cottonwood Village, Chisholm Creek, and Willowbend. Relish the beauty of neighborhood parks and explore nearby dining options. </p>\n<p>The Remington Apartments complex is conveniently located just a brief drive from numerous elementary, middle, and high schools, which is ideal for students seeking quality education.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/remington-wichita-apts::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Remington Wichita, your new home offers spacious one and two-bedroom apartments amid vibrant community attractions. Enjoy many surrounding entertainment and outdoor attractions such as The Great Plains Nature Center, Top Golf, or Bowlero Northrock.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/silver-springs-apts::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Located in the serene northwest Wichita area close to the <a href=\"/apartments/ks/wichita/silver-springs-apts/neighborhood\"><strong>Newport neighborhood</strong></a>, Silver Springs Apartments provides a peaceful retreat from the urban rush downtown. Enjoy convenient dining options within a short drive at popular restaurants like Bricktown Brewery or 6S Steakhouse when you prefer to avoid cooking for the day or night. For moments of relaxation, explore the nearby local parks for a tranquil experience.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience the top apartment homes in Wichita at the Villas of Waterford, situated just east of the Cottonwood Village <a href=\"/apartments/ks/wichita/villas-of-waterford/neighborhood\"><strong>neighborhood</strong></a><strong> </strong>and only minutes away from Colonel James Jabara Airport. Our unbeatable location gives you access to everything you need, including various restaurants, shops, attractions, grocery stores, and academic institutions. </p>\n<p>Discover the endless possibilities at Northrock Center, offering an array of retail outlets, entertainment options, and food hot spots located just around the corner from our apartment community. With our prime location in Wichita, you can enjoy unique experiences with friends or family at Bowlero Northrock Bowling Alley, AMC Northrock 14, or All Star Adventures.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/belton/center-301::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Step inside your new luxury one or two bedroom home at Center 301 Apartments and bask in the exceptional. Each floor plan is purposefully designed to complement your daily routine. Whether hosting a large dinner party or grabbing a morning snack on the go, your gourmet-style kitchen comes with an energy-efficient appliance package to ensure that no culinary task is too great. And with garages available, you’ll never have to worry about scraping ice off your windshield during chilly Missouri mornings.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/independence/the-adirondack::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Located near the Whispering Meadows <a href=\"/apartments/mo/independence/the-adirondack/neighborhood\"><strong>neighborhood</strong></a><strong> </strong>and minutes from the Independence Center, which features a plethora of well-known shops and food favorites, our luxury apartments are unparalleled. Our location gives you access to numerous shops, dining, and entertainment options, so you’re never bored and have everything you need at your fingertips.</p>\n<p>Not in the mood to cook? Head over to Los Cabos Mexican Grill and Cantina for some tamales—just two minutes away. Or, if you want to spend a night out on the town, hop on I-70, just six minutes away, for an easy commute to downtown Kansas City. Discover all that Independence has to offer at The Adirondack Apartments.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/152-northland::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our Kansas City luxury apartment community in the Northland is located near the Zona Rosa district, with access to a variety of restaurants, shops, and stores for your daily needs.</p>\n<p>Fill up at QuikTrip down the road on your way to work, or grab some groceries at Hy-Vee or Sprouts by driving a few minutes west. You’ll also be able to grab necessities from CVS or watch the Chiefs game at The Peanut. Nightlife destinations like the Argosy Casino &amp; Hotel and the Power &amp; Light District are within a 20-minute drive.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/97-north-oak::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our Kansas City luxury apartments are ideally located in the <a href=\"/apartments/mo/kansas-city/97-north-oak/neighborhood\"><strong>Northland</strong></a>, surrounded by grocery stores, coffee shops, restaurants, and everything else you’ll need in your day-to-day life. Our luxurious apartments near Gladstone are minutes away from Starbucks, Wendy’s, QuikTrip, and more. The thriving City Market within the River Market neighborhood is just a 15-minute drive away, and the vibrant Power &amp; Light district is less than a 20-minute drive. Enjoy luxury living in Downtown Kansas City at 97 @ North Oak</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/mark-apts::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Staying at The Mark Apartments opens the door to comfortable and easy living. Located conveniently close to I-55 and I-220 in Ridgeland, one of Jackson’s top suburbs, we’re an inviting community for those from all backgrounds. <a href=\"/apartments/ms/ridgeland/mark-apts/contact-us\"><strong>Schedule your tour</strong></a> online today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/sunchase-ridgeland-apts::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>When you step out of your front door, the vibrant apartment living experience in Ridgeland continues. Living at Sunchase Ridgeland Apartments, you’re close to several <a href=\"/apartments/ms/ridgeland/sunchase-ridgeland-apts/neighborhood\"><strong>neighborhoods</strong></a> and communities to explore, such as Madison, Wildwood North, Northpointe, and beyond.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/the-pointe-of-ridgeland::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Pointe of Ridgeland Apartments are <a href=\"/apartments/ms/ridgeland/the-pointe-of-ridgeland/neighborhood\"><strong>situated in a convenient location</strong></a>, so that everything you need is just a quick trip away. Head to the Reservoir Overlook and admire the natural beauty of Ross R. Barnette Reservoir or relax and hit a few balls at The Country Club of Jackson, located just a few miles away from your new home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/trace-apts::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our Ridgeland luxury apartments are ideally located near several dining, entertainment, and shopping opportunities. You’ll find a variety of cuisine nearby, unique shopping, and attractions like Sky Zone and Enter/Locked Escape Rooms. With Primo Cafe and several coffee shops in close proximity, there are plenty of places to meet with friends and family.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Icon at Broken Arrow apartment community is situated in <a href=\"/apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/neighborhood\"><strong>southern Broken Arrow</strong></a>, about 20 minutes from downtown Tulsa. Nearby, everything you need is within reach, from restaurants to shops to attractions. Our proximity to Creek Turnpike makes commuting to work or school a cinch. Highly rated schools nearby ensure a quality education for students of any age.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our apartment homes are nestled alongside Country Lane Estates, just across 177th Avenue from the neighborhood of Morrow Ridge. Enjoy a stroll through Nienhuis Park, a large park up the street with football fields, tennis courts, and an expansive golf course. With excellent dining options, top-rated schools, and family-friendly attractions around every corner, your home at <a href=\"/apartments/ok/broken-arrow/park-at-mission-hills/neighborhood\"><strong>The Park at Mission Hills</strong></a> puts you at the cultural center of Broken Arrow.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/redbud-ranch::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our prime location near the <a href=\"/apartments/ok/broken-arrow/redbud-ranch/neighborhood\"><strong>Broken Arrow High School</strong></a> is close to picturesque parks, delightful dining establishments, and top-notch schools. With an array of attractions and entertainment venues nearby, residents at Redbud Ranch have effortless access to quality time with friends and family. Additionally, Walmart Supercenter and Bass Pro Shops are just a brief drive away, ensuring convenient access to groceries and outdoor gear.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our gated north Broken Arrow apartment community offers more than convenient access to Creek Turnpike and Broken Arrow Expressway. It is near <a href=\"/apartments/ok/broken-arrow/scissortail-crossing/neighborhood\"><strong>downtown Broken Arrow</strong></a> and is close to various businesses and attractions, such as restaurants, parks, coffee shops, and schools.</p>\n<p>Attractions like the Broken Arrow Performing Arts Center and Rose District are nearby, so residents of all ages can enjoy them. Additionally, the Arrow Village Shopping Center and Target are just a short drive away, providing easy access to everything you need for your home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Trails at Aspen Creek is in southern Broken Arrow near many shops, grocery stores, and restaurants, including The Shops at Aspen Creek, Starbucks, and Walmart Supercenter.</p>\n<p>After classes at Tulsa Tech Broken Arrow Campus, hit the links at Indian Springs Country Club, catch a film at Regal Warren Broken Arrow Theatre, or challenge your friends to a game of bowling at Broken Arrow Lanes! Whether your loved ones have practice at Indian Springs Sports Complex or want to explore Ray Harral Nature Park &amp; Center, our apartment community is situated near the action in a cozy and quiet setting.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The apartments at the Villas at Aspen Park are in a prime location near Broken Arrow’s <a href=\"/apartments/ok/broken-arrow/villas-at-aspen-park/neighborhood\"><strong>Rose District neighborhood</strong></a>, near Stone Mill BBQ and Steakhouse. Multiple dining, shopping, and grocery stores are nearby, offering residents numerous options.</p>\n<p>The Mayfair Shopping and Business Center is just a three-minute drive. It is an ideal destination for weekend leisure activities, providing a variety of shops and restaurants as an epicenter of activity. Rockwood West Park, Rhema Park, and Jackson Park are all within ten minutes of our apartment homes, making it an ideal spot for playing with your pup and children.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/fountain-lake::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Enjoy suburban comfort in our gated community in Edmond, OK. Spend peaceful weekends in <a href=\"/apartments/ok/edmond/fountain-lake/neighborhood\"><strong>the neighborhood</strong></a>, exploring the many nearby attractions, shops, and dining spots, or take the short drive into OKC and soak up the excitement of the metro. You’ll find Fountain Lake near the highly rated Edmond School District of Oklahoma, making it easy to find good elementary, middle, and high schools nearby.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Located just north of The Crossing <a href=\"/apartments/ok/edmond/villas-at-stonebridge/neighborhood\"><strong>neighborhood</strong></a><strong> </strong>and minutes from Oklahoma Christian University in Edmond, our apartment homes are unparalleled. With access to a vast assortment of dining options, shops, parks, local interests, grocery stores, and academic institutions, the Villas at Stonebridge has everything you need.</p>\n<p>The Shoppes On Broadway mall is just three minutes away—perfect for weekend leisure activities and offers a hub of activity, retail outlets, and food hot spots. For entertainment with friends or pups, look no further than nearby Bowlero Edmond Bowling Alley, Edmond Dog Park, and Whispering Heights Park for unique experiences within steps of your front door. With this prime location in Edmond, you’ll always have things to do!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><a href=\"/apartments/ok/jenks/the-reserve-at-elm/neighborhood\"><strong>Located near River Spirit Casino Resort</strong></a> and <a href=\"/apartments/ok/jenks/the-reserve-at-elm/neighborhood\"><strong>within the Jenks school distric</strong>t</a>, The Reserve at Elm Apartments always keeps you close to the excitement. Whether you’re looking for world-class gaming, dining, or entertainment, you’ll find it all just moments from your doorstep. Explore the vibrant energy of the riverside district or venture out to nearby attractions like the Oklahoma Aquarium and Turkey Mountain Urban Wilderness Area for outdoor adventures only minutes from home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/moore/mission-point::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Located adjacent to I-35 but with enough distance to preserve your peace and quiet, our luxury living community is a comfortable getaway from the highly active center of Oklahoma City. Our strategic location keeps the city within reach but out of mind as you relax by the fireplace in your apartment home. When you begin exploring, you can find OKC’s artistic and culinary culture a short drive away. Nearby, you can find restaurants like Black Bear Diner, Oliveto Italian Bistro, Hidalgo’s Mexican Restaurant and Cantina, and dozens of other beloved local attractions to explore. <a href=\"/apartments/ok/moore/mission-point/contact-us\"><strong>Contact us</strong></a> to schedule a tour!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/artisan-crossing-apts::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Artisan Crossing is ideally located in <a href=\"/apartments/ok/norman/artisan-crossing-apts/neighborhood\"><strong>northern Norman</strong></a> near I-35, just minutes from downtown Norman and the University of Oklahoma. Nearby shopping, dining, and entertainment options make running errands, spending a night out on the town, and bonding with loved ones a breeze. Enjoy a calming nature walk at the nearby Sutton Wilderness Trail Park or grab a tasty breakfast at Syrup, both just a quick drive away.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find our apartments for rent in <a href=\"/apartments/ok/norman/cimarron-trails-apts/neighborhood\"><strong>northern Norman</strong></a>, off I-35 near Legacy Park and University Town Center shopping center. Grab a delicious meal from one of the many nearby restaurants, or plan a shopping day and visit some of the several clothing outlets and specialty stores near our apartments for rent in Norman. Cimarron Trails Apartments near the University of Oklahoma are within reach of top elementary, middle, and high schools, ensuring an excellent education is always within reach. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/24hundred-apartments::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>24Hundred’s Oklahoma City luxury apartments for rent are located in <a href=\"/apartments/ok/oklahoma-city/24hundred-apartments/neighborhood\"><strong>northern OKC</strong></a> near The Village and Quail Creek neighborhoods. Enjoy comfort food with the family at Black Bear Diner or take in the natural scenery at Bluff Creek Park, just minutes from 24Hundred. Living at 24Hundred places you close to excellent schools, parks, family-friendly attractions, and all that Oklahoma City, OK, has to offer.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/chisholm-pointe::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><a href=\"/apartments/ok/oklahoma-city/chisholm-pointe/neighborhood\"><strong>Our duplex apartments in north OKC</strong></a> sit in the calm neighborhood between Camelot Estates and College Park. With quick access to three major highways including John Kilpatrick Turnpike, Route 77, and Highway 74, the entire town of Edmond is well within your reach. Enjoy practicing your putt at Quail Creek Golf Club, shopping at one of the many nearby groceries and malls, and the peaceful afternoons in your home near Lake Hefner.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Located near the <a href=\"/apartments/ok/oklahoma-city/cimarron-pointe-apts/neighborhood\"><strong>Warr Acres neighborhood</strong></a>, Cimarron Pointe offers a quiet retreat away from the hustle and bustle of downtown Oklahoma City but remains just a 20-minute drive away from the city’s sights and sounds. Nearby, you can enjoy a wide selection of cuisine with restaurants like Cajun Corner, Gyro City Cafe, Raising Cane’s, and so many more. Excellent public and private schools are also just minutes away from Cimarron Pointe, making it simple to find a good fit for students of all ages. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>On the outskirts of OKC near <a href=\"/apartments/ok/oklahoma-city/council-place-apartments/neighborhood\"><strong>Northaven</strong></a>, Council Place Apartments offers a quiet haven away from the hustle and bustle of the city while remaining less than 30 minutes from downtown. When you don’t feel like cooking, grab a meal from one of the many restaurants surrounding our apartment community, like Louie’s Grill and Bar or Tokyo Moon. Visit one of the several nearby parks to relax in the great outdoors.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>South of downtown Oklahoma City, Cross Timber Apartments are located near the desirable <a href=\"/apartments/ok/oklahoma-city/cross-timber/neighborhood\"><strong>Lakeridge View neighborhood</strong></a>. Near our Oklahoma City apartment homes, you’ll be within reach of delicious cuisine, a wide variety of stores, beautiful parks, highly rated schools, nearby employers, and anything else you may need in your day-to-day life.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Northwest of the Oklahoma City metro, Crown Pointe’s gated community offers a quiet retreat from the hustle and bustle of city life, but it remains just a quick drive away from all the excitement. In <a href=\"/apartments/ok/oklahoma-city/crown-pointe-apartments/neighborhood\"><strong>the neighborhood</strong></a>, you’ll find top-notch schools and a variety of dining, shopping, and entertainment options, making weekend planning a cinch.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Hunter’s Ridge Apartments in Oklahoma City are located northwest of downtown, in the peaceful <a href=\"/apartments/ok/oklahoma-city/hunter-s-ridge-apts/neighborhood\"><strong>Council Heights neighborhood</strong></a>. Just a few miles west of our Oklahoma City apartment community, scenic Lake Hefner awaits, offering fishing, water sports, waterside dining, and so much more. When you feel like visiting one of the city’s top attractions, downtown is only 20 minutes away.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter's-ridge-apts::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Hunter’s Ridge Apartments in Oklahoma City are located northwest of downtown, in the peaceful <a href=\"/apartments/ok/oklahoma-city/hunter-s-ridge-apts/neighborhood\"><strong>Council Heights neighborhood</strong></a>. Just a few miles west of our Oklahoma City apartment community, scenic Lake Hefner awaits, offering fishing, water sports, waterside dining, and so much more. When you feel like visiting one of the city’s top attractions, downtown is only 20 minutes away.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/park-at-tuscany::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Park at Tuscany is situated off May Avenue, just north of the John Kilpatrick Turnpike, offering convenient proximity to essential services. Our strategic position in <a href=\"/apartments/ok/oklahoma-city/park-at-tuscany/neighborhood\"><strong>northern Oklahoma City</strong></a> puts us close to healthcare facilities and local services frequently used by active adults. You’ll also find yourself within easy reach of the University of Central Oklahoma and Oklahoma City’s center of commerce at Visionworks Quail Springs Mall, providing streamlined access to everything from clothing and groceries to work and education.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/persimmon-square-apartments::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our upscale apartments in Oklahoma City are convenient to <a href=\"/apartments/ok/oklahoma-city/persimmon-square-apartments/neighborhood\"><strong>the north Oklahoma City neighborhood</strong></a> and near Camelot Bel Aire, Chisholm Creek, and beyond. Near the Persimmon Square apartment community, you can easily access various amenities for your day-to-day needs, including restaurants, grocery stores, coffee shops, and family-friendly attractions.</p>\n<p>The HIVE Sports Complex is 10 minutes from our Oklahoma City apartments, while the Quail Creek Golf &amp; Country Club is less than three miles away. Furthermore, the area boasts many nearby schools, making it an ideal location for families in Western Village-Pied Piper, Meadowcreek, and Quail Creek.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><a href=\"/apartments/ok/oklahoma-city/prairie-springs-i/neighborhood\"><strong>Just a short drive from Lake Hefner</strong></a> and well positioned near a range of local shops and restaurants, Prairie Springs offers the ideal balance of tranquillity and accessibility in your future apartment home. Easy access to Oklahoma State Highway 3 makes commuting to work in the morning straightforward and fast, with Uptown and central Oklahoma City within a nine-mile drive of our community.<br/><br/>Those seeking cultural exploration can marvel at the natural wonders of the nearby Stinchcomb Wildlife Refuge or indulge in a range of shopping and dining options at the nearby Northridge Plaza. With its prime location in northwest Oklahoma City, Prairie Springs puts the best of the city at your doorstep.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/stonehorse-crossing::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><a href=\"/apartments/ok/oklahoma-city/stonehorse-crossing/neighborhood\"><strong>Our position in north OKC</strong></a> keeps you close to the city’s centers of life. Explore nearby attractions like Lake Hefner for outdoor recreation or tee off at Top Golf for a fun-filled day with friends and family. With our proximity to major roadways and thoroughfares including Broadway Extension Highway and I-344, commuting to downtown or neighboring Edmond is a breeze, offering the perfect balance of convenience and tranquility in one of Oklahoma City’s most sought-after neighborhoods.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summerfield-place-apts::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Situated close to the <a href=\"/apartments/ok/oklahoma-city/summerfield-place-apts/neighborhood\"><strong>Val Verde</strong></a> Apartments and The Village neighborhood, the apartment residences at Summerfield Place lie within a mile of SoccerCity in Oklahoma City.</p>\n<p>Whether attending a golf tournament at The Greens Country Club or taking in a breath of nature at Bluff Creek Park, there is constant activity in the vicinity. For a delightful break from kitchen duties, treat yourself to a delicious meal from one of the numerous restaurants near Summerfield Place, such as Hacienda Tacos and Mazzio’s Italian Eatery.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summit-ridge-villas/summit-villas::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Summit Villas is a wonderful community located in Oklahoma City. Our community is conveniently situated near the Broadway Extension, providing easy access to downtown OKC. Not only are we minutes from downtown, but we are also close to OKC hot spots like Chicken n Pickle and Slick’s Brewhouse. Enjoy a nice night out on the town, and come home to a luxurious duplex experience.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/tammaron-village-apartments::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Tammaron Village Apartments offers the finest apartment homes in Oklahoma City. Our apartments, just north of the Northaven <a href=\"/apartments/ok/oklahoma-city/tammaron-village-apartments/neighborhood\"><strong>neighborhood</strong></a> and near Lake Hefner, provide convenient access to all your essential needs, like restaurants, retail shops, entertainment options, grocery stores, and schools.</p>\n<p>As a resident of Tammaron Village in Northwest Oklahoma City, you can indulge in a shopping spree with friends at Silver Springs Pointe and Rockwall Plaza Shopping Center, savor a delicious ice cream cone at Braum’s Ice Cream and Dairy Store, or unwind over a refreshing drink at Babble Coffee and Bubble Tea Bar. Our apartment community offers the perfect blend of comfort, luxury, and style, providing an unmatched living experience.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/warrington-apartments::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Just northwest of Downtown OKC and a mere four-minute drive from SoccerCity of Oklahoma City, near the serene <a href=\"/apartments/ok/oklahoma-city/warrington-apartments/neighborhood\"><strong>Warwick Estates neighborhood</strong></a>, our community is close to everything the city offers. In the vicinity of The Warrington, exceptional academic institutions cater to students of all ages.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Moving to Waters Edge means moving to a <a href=\"/apartments/ok/oklahoma-city/waters-edge-apartments/neighborhood\"><strong>vibrant urban community</strong></a> with food, shops, and entertainment just a few minutes away. Located in Southwest Oklahoma City, we’re just a hop, skip, and a jump away from downtown OKC, Oak Grove, Boecking Acres, and Wheatland. Taking your next vacation? We’re also less than a mile north of Will Rogers World Airport.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/coffee-creek::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Owasso melds the quiet comfort of a suburban community with opportunities and attractions you can only find in a bustling city like Tulsa, just a short drive to the south via Highway 169. Our inviting <a href=\"/apartments/ok/owasso/coffee-creek/neighborhood\"><strong>apartment community near Lake Valley</strong></a><strong> </strong>has easy access to several popular grocers, restaurants, and schools, keeping everything you need to live your life to the fullest in Owasso well within reach.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our <a href=\"/apartments/ok/owasso/cottages-at-tallgrass-point/neighborhood\"><strong>apartment community near Bailey Ranch</strong></a> puts everything you need within easy reach. From top-rated schools and nearby shopping to beautiful parks and thriving community events, Cottages at Tallgrass Point ensures you experience the very best of Owasso. Enjoy the serene beauty of Centennial Park and participate in the vibrancy of community events in downtown Tulsa, giving you the chance to quickly create a sense of belonging and connection with your new home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cypress-crossing::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Cypress Crossing places you close to <strong><a href=\"/apartments/ok/owasso/cypress-crossing/neighborhood\">everything Owasso has to offer</a></strong>. Conveniently accessible via Highway 169, you can enjoy local shopping at Sprouts Farmers Market and Owasso Market Shopping Center, indulge in Owasso’s diverse dining options like Akira Sushi and Bricktown Brewery, and entertain the family at several local attractions like Wheels and Thrills or the Tulsa Zoo.</p>\n<p>You can do all this just minutes from your front door, and with Tulsa just a short drive away, more exciting adventures are always within reach.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/pryor/west-530::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>West 530’s apartments for rent in Pryor are only a few blocks from Highway 69, allowing you to relax at home or take advantage of everything there is to <strong>discover in Pryor</strong> and throughout the Tulsa suburbs. Go on a high-speed boating trip on Lake Hudson or find your new favorite restaurant at one of the many delicious nearby eateries. It’s all easily accessible when you live at West 530.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/stillwater/apple-creek-stillwater::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>You’ll find Apple Creek’s apartment homes just two miles from OSU’s campus in <a href=\"/apartments/ok/stillwater/apple-creek-stillwater/neighborhood\"><strong>northern Stillwater</strong></a>. Don your brightest orange shirt and catch a Cowboys game at Boone Pickens Stadium or immerse yourself in the great outdoors at Boomer Lake Park. There’s always something to do around town. When you need a day off from cooking, enjoy a meal from one of the many restaurants near Apple Creek, such as Davinci’s Italian or Texas Roadhouse.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/barrington-apartments::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>With many sporting events to enjoy nearby and several bustling shopping options in the vicinity – including 71st Street and Woodland Hills Mall – you’ll appreciate our <a href=\"/apartments/ok/tulsa/barrington-apartments/neighborhood\">excellent location</a>. Looking for some nature-based fun? Make your way to LaFortune Park and hit the walking and biking trails.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cascata-luxury-apartments::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our welcoming community is near the peaceful <a href=\"/apartments/ok/tulsa/cascata-luxury-apartments/neighborhood\"><strong>Woodland neighborhood</strong></a>, surrounded by gorgeous parks, diverse eateries, and excellent schools. Connecting with your friends, family, and loved ones is a cinch when you live at Cascata, thanks to the attractions and entertainment options nearby. Grab some doughnuts for the office at Daylight Donuts Farmhouse or meet some friends for breakfast at Le Louvre French Cafe, both just a quick drive away.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-glade-apts::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Cedar Glade apartments are nestled near the peaceful <a href=\"/apartments/ok/tulsa/cedar-glade-apts/neighborhood\"><strong>Hampton South neighborhood</strong></a>, southwest of downtown Tulsa. We’re just minutes from Woodland Hills Mall, where you can explore over 100 dining and shopping options. Thanks to the wide variety of highly ranked schools nearby, residents of Cedar Glade can easily find a great academic institution for students of any age. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Cedar Ridge’s <a href=\"/apartments/ok/tulsa/cedar-ridge-apartments/neighborhood\"><strong>ideal location</strong></a> puts you away from the hustle and bustle of downtown Tulsa but still just a short drive away from the metro when you feel like visiting the city’s renowned museums and attractions. The family-friendly neighborhood is full of restaurants, coffee shops, shopping malls, schools, and everything you need for your daily routine. Our apartment community is less than a mile from verdant, sprawling Jackson Park.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Chardonnay Apartments are tucked away in south Tulsa, near the <a href=\"/apartments/ok/tulsa/chardonnay/neighborhood\"><strong>Burning Tree neighborhood</strong></a>. Less than a mile from our Tulsa apartments, Woodland Hills Malls awaits your next shopping spree, operating over 100 shopping and dining outlets to peruse. Students and families can rest easy knowing that Chardonnay Apartments in Tulsa are surrounded by a variety of excellent elementary, middle, and high schools, as well as community colleges and universities<a href=\"/apartments/ok/tulsa/chardonnay/neighborhood\">.</a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our cozy<strong> </strong><a href=\"/apartments/ok/tulsa/country-hollow-apartments/neighborhood\"><strong>apartment community on the corner of 81st and Yale</strong></a> brings Tulsa’s essentials to your doorstep, with a shopping center and locally loved restaurants only minutes away. Downtown is not far away. Just take Yale Avenue north to the Interstate 44/Highway 44 interchange, and you’ll be at the heart of town in minutes. One distinct advantage of our community’s strategic location is our proximity to Oral Roberts University and Tulsa Community College’s south campus, just a few minutes away on 81st Street.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/creekwood-apartments::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Creekwood Apartments in <a href=\"/apartments/ok/tulsa/creekwood-apartments/neighborhood\"><strong>south Tulsa</strong></a> are surrounded by desirable, family-friendly neighborhoods like Chimney Hills, Shadow Ridge, and Woodland. Near our apartment community, scenic neighborhood parks invite you to slow down and enjoy nature, while local restaurants offer just about any food you crave. Elementary, middle, and high schools are all just a short drive from Creekwood, making us an excellent option for students.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/nickel-creek-apts::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Located just off Highway 75 in south Tulsa, Nickel Creek Apartments are waiting for you to call them home! A short drive from Creek Turnpike, you’ll find us on South Union Avenue and West 78th Street. Our community is located west of the Arkansas River and just south of Turkey Mountain Park, Tulsa ER &amp; Hospital, and Page Belcher Golf Course. Explore <a href=\"/apartments/ok/tulsa/nickel-creek-apts/neighborhood\"><strong>apartments for rent in Tulsa, OK</strong></a> and schedule a tour at Nickel Creek today.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/polo-run-apartments::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Are you looking for things to do around town? Located in <a href=\"/apartments/ok/tulsa/polo-run-apartments/neighborhood\"><strong>south Tulsa</strong></a>, just six miles from Jenks, Polo Run’s upscale apartments offer convenient access to various attractions. Indulge in some retail therapy at Woodland Hills Mall or immerse yourself in the outdoors at the expansive Lafortune Park. After a day of exploration, treat yourself to a delightful dining experience at nearby restaurants, such as Braum’s Ice Cream Shop &amp; Burger Restaurant or McNellie’s South City.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The charming <a href=\"/apartments/ok/tulsa/sheridan-pond/neighborhood\"><strong>Woodland Hills neighborhood</strong></a>, east of Oral Roberts University and southwest of Woodland Hills Mall, is the prime location for our elegant south Tulsa apartments at Sheridan Pond.</p>\n<p>This vibrant area near Minshall Park caters to all your daily needs with its restaurants, grocery stores, coffee shops, and local attractions. With a Starbucks just three miles away, Hunter Park within four minutes, and several nearby schools, our Tulsa apartments offer convenient access to essential amenities and leisure options.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Situated near the <a href=\"/apartments/ok/tulsa/sugarberry-apartments/neighborhood\"><strong>Hampton South neighborhood</strong></a> of south Tulsa, our location offers proximity to various dining spots, retail outlets, parks, local attractions, and educational institutions. For weekend leisure, the Marketplace Shopping Center is merely a seven-minute drive away, providing a hub of activity. Additionally, for entertainment options, you can easily access the nearby Cinemark Tulsa IMAX or Eton Square 6 Cinema for an enjoyable moviegoing experience.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Located near the <a href=\"/apartments/ok/tulsa/sunchase-apartments/neighborhood\"><strong>Chimney Hills neighborhood</strong></a>, our Sunchase apartment community offers easy access to all your essentials, including local grocery stores and top-tier schools. Adjacent to the Hardesty Regional Library, you can conveniently find the next book to add to your to-be-read pile. Situated in south Tulsa, our apartments are strategically placed near Highway 169 and Creek Turnpike, providing quick access to downtown job opportunities for commuters.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Courtyards Tulsa apartments are located in the <a href=\"/apartments/ok/tulsa/the-courtyards/neighborhood\"><strong>Chimney Hills neighborhood</strong></a>, offering a quiet retreat from downtown while still being less than a half-hour drive from the city’s most popular attractions. Near our apartments in south Tulsa, you’ll find several restaurants, shops, attractions, and schools just a quick drive away. Less than a mile west of us stands Hunter Park, a beautiful place to relax and take in the scenery.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>You’ll find The Greens of Bedford apartments in <a href=\"/apartments/ok/tulsa/the-greens-of-bedford/neighborhood\"><strong>south Tulsa</strong></a>, just northwest of Broken Arrow and less than 20 minutes from the metro. Near our Tulsa apartment community you’ll find shopping centers, dining options, local parks, and top-notch attractions the entire family will love. There are also several highly rated elementary, middle, and high schools nearby so you can find a school that fits your needs.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Located near the intersection of East 71st Street and South Mingo Road, close to the <a href=\"/apartments/ok/tulsa/windsail-apartments/neighborhood\"><strong>Southbrook neighborhood</strong></a>, Windsail Apartments offers proximity to a plethora of shopping, dining, and entertainment options. Within a short nine-mile radius, you can discover the scenic hilly forest of Turkey Mountain Urban Wilderness and the tranquil River Parks, providing serene natural getaways.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><a href=\"/apartments/ok/yukon/park-at-westpointe/neighborhood\"><strong>Our welcoming community is situated in Yukon</strong></a>, west of Oklahoma City, just a stone’s throw from the intersection of I-40 and the John Kilpatrick Turnpike. This strategic position allows you to enjoy the comforts of a suburban apartment community while OKC’s centers of commercial activity and entertainment remain well within reach. Enjoy local culinary favorites like the authentic cuisine from Thai Orchid, a calming stroll or picnic in Chisholm Trail Park, and other staples of the Yukon community just minutes from home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/the-ridge-@-66::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><a href=\"/apartments/ok/yukon/the-ridge-66/neighborhood\"><strong>Our apartment community in Yukon’s advantageous position</strong></a> near the highway is complemented by our idyllic surroundings near Lake Overholser, offering scenic views and outdoor recreational opportunities just moments from your doorstep. Perfect for fishing, hiking, or simply taking in the serene surroundings, our apartments provide easy access to the great outdoors for residents to enjoy year-round while keeping you close to fine restaurants, shopping centers, and other essentials.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/the-ridge-66::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><a href=\"/apartments/ok/yukon/the-ridge-66/neighborhood\"><strong>Our apartment community in Yukon’s advantageous position</strong></a> near the highway is complemented by our idyllic surroundings near Lake Overholser, offering scenic views and outdoor recreational opportunities just moments from your doorstep. Perfect for fishing, hiking, or simply taking in the serene surroundings, our apartments provide easy access to the great outdoors for residents to enjoy year-round while keeping you close to fine restaurants, shopping centers, and other essentials.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><a href=\"/apartments/tx/amarillo/newport-amarillo-apts/neighborhood\"><strong>Our apartment community is situated in southwest Amarillo</strong></a> between Interstates 27 and 40 so you can enjoy easy access to the greater Amarillo community while you relax in your suburban apartment home in this peaceful corner of town. You can find the Yellow City Grind coffee shop right outside our community, with Puckett Plaza to the north and the rest of town well within reach. Everything Amarillo has to offer can be found just a step outside your door at our Amarillo apartments for rent.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>While the bustle of central Amarillo has much to offer in fine dining and entertainment, our quiet corner of town provides a calm environment that makes no sacrifices when it comes to convenience and accessibility. Soncy Road and I-27 are only a short drive away, making every attraction Amarillo has to offer within easy reach from your <a href=\"/apartments/tx/amarillo/park-at-coulter/neighborhood\"><strong>Puckett apartment home</strong></a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><a href=\"/apartments/tx/amarillo/remington-amarillo-apts/neighborhood\"><strong>Tucked away in the heart of Amarillo</strong></a>, Remington Apartments allows residents to experience all that this dynamic city has to offer. Located near Soncy Road and I-40 in beautiful Southwest Amarillo, Texas, you’re a short drive away from Sleepy Hollow, Westgate Mall, and Amarillo Independent School District.  From its lively entertainment scene to its diverse culinary delights and breathtaking natural beauty, Amarillo truly has something for everyone.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>When you move to Colonies at Hillside, you’ll live in a prime, <a href=\"/apartments/tx/amarillo/the-colonies-at-hillside/neighborhood\"><strong>central location in southwest Amarillo, TX</strong></a>. Our apartments put you at the epicenter of convenience just moments away from delicious local restaurants like Blue Sky, Rosa’s Café &amp; Tortilla Factory, Jorge’s Mexican Bar &amp; Grill, and incredible entertainment options just minutes from home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Located near Westgate Mall and Amarillo’s medical district, the Winchester Apartments provides a peaceful escape from downtown while still being within five miles of the city’s top attractions.</p>\n<p>A quick drive from our luxury apartments in Amarillo will lead you to various restaurants, shops, schools, and attractions. The Don Harrington Discovery Center lies less than two miles southwest, offering captivating permanent exhibits on the universe and weather for your enjoyment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/acacia-park-apts::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Acacia Park’s convenient location in West El Paso, TX, gives you easy access to several dining and entertainment opportunities in the <a href=\"/apartments/tx/el-paso/acacia-park-apts/neighborhood\"><strong>nearby neighborhoods</strong></a>. Some of the communities near Acacia Park include:</p>\n<p>Numerous restaurants, such as Tacos Don Cuco and Villa Del Mar, are located near our Acacia Park apartments in West El Paso. Practice your swing at TopGolf, just southwest of our apartment community. Nearby school districts include Canutillo Independent School District and El Paso Independent School District.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/chimneys-apts::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Moving into our West El Paso apartments gives you access to a lively and vibrant community with many attractions only a few minutes away. We’re only a short distance from numerous <a href=\"/apartments/tx/el-paso/chimneys-apts/neighborhood\"><strong>neighborhoods</strong></a>, such as Upper Mesa Hills, Crestmont, Thunderbird, Coronado Hills, and beyond. Need to head to the hills to escape everyday life? We’re close to Franklin Mountains State Park. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Double Tree Apartments are conveniently located in Westside El Paso, close to many <a href=\"/apartments/tx/el-paso/double-tree-apts/neighborhood\"><strong>restaurants and local attractions</strong></a>. The nearby Franklin Mountains provide a scenic backdrop and several hiking opportunities just a few miles from our Double Tree apartment community. Catch a movie at the Alamo Drafthouse Cinema Montecillo, walk the riverbanks of the Rio Grande Riverpark Trail System, or take yourself to new heights at iFLY Indoor Skydiving El Paso.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>When you need to leave the apartment, you’ll find plenty to do in the <a href=\"/apartments/tx/el-paso/high-ridge-apts/neighborhood\"><strong>East El Paso neighborhood</strong></a> for all ages. Travelers will love that we’re three miles south of El Paso International Airport. Shoppers can enjoy a variety of shops at the Cielo Vista Mall, just a mile away, or the Fountains at Farah Shopping Mall, two miles away. </p>\n<p>Some other neighborhoods you’ll find nearby include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/mountain-village-apts::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Cradled in the western corner of the Lone Star State, Mountain Village Apartments is a quiet and luxurious community of homes in West El Paso. You’ll find us in the shadows of the Franklin Mountains, just a few turns off of many major nearby roads, including I-10, the CanAm Highway, and the 375 Loop. With reasonably priced El Paso apartments and exciting amenities like a 24-hour fitness center and two outdoor swimming pools, we’re confident you’ll feel at home here. <a href=\"/apartments/tx/el-paso/mountain-village-apts/contact-us\"><strong>Contact Mountain Village</strong></a> today to learn more!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/patriot-apts::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>You’ll find our El Paso apartments near <a href=\"/apartments/tx/el-paso/patriot-apts/neighborhood\"><strong>the Milagro Hills neighborhood</strong></a>, north of Fort Bliss and El Paso International Airport. Near The Patriot apartment community, you can find everything you need for day-to-day life—restaurants, grocery stores, coffee shops, and attractions suitable for all ages. You’ll find a Starbucks less than a mile from our El Paso apartments and an AMC theater just five minutes away. There’s also no shortage of schools near our El Paso apartment community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/phoenix-apts::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Thanks to our ideal location near the <a href=\"/apartments/tx/el-paso/phoenix-apts/neighborhood\"><strong>Cielo Vista neighborhood</strong></a>, you’ll find everything you need near The Phoenix apartment community, from local grocery stores to excellent schools. Plus, traveling is a cinch since we’re just four miles south of El Paso International Airport (ELP). Commuters heading to their jobs downtown will also cherish our proximity to I-10, just minutes away from our El Paso apartments.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/shadow-ridge-apts::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>When you rent one of our luxury apartments near Fort Bliss, you’ll experience the thrills of apartment living and the vibrant life of El Paso. Close to many major roads, including I-10, we make it ideal for you to explore the surrounding areas. <a href=\"/apartments/tx/el-paso/shadow-ridge-apts/neighborhood\"><strong>Neighborhoods</strong></a> such as Cielo Vista, East Ridge, Stonehaven, Valley View Heights, and beyond are all near Shadow Ridge Apartments and are ready to welcome you in.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our El Paso apartment community is conveniently located in the <a href=\"/apartments/tx/el-paso/the-crest/neighborhood\"><strong>Coronado Hills neighborhood</strong></a>, surrounded by restaurants, parks, coffee shops, and schools. Residents of all ages can enjoy nearby attractions, like Western Playland Amusement Park and McKelligon Canyon. Just minutes away, you’ll find several shops along Mesa Street, including Burlington department store, Food King grocery store, and several other options for all of your essentials. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/hewitt/icon-at-hewitt::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>When you move into your new apartment home, you’ll gain easy access to a lively and vibrant <a href=\"/apartments/tx/hewitt/icon-at-hewitt/neighborhood\"><strong>neighborhood</strong></a>. You can eat out at Marco’s Pizza or J-Petal &amp; Poke or visit nearby Baylor University for a game. Down the street from us are Hewitt Park and the Hewitt Public Library. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>When you live in one of our 1 or 2 bedroom <a href=\"/apartments/tx/lubbock/cottages-at-abbey-glen/neighborhood\"><strong>apartments in Lubbock</strong></a>, you’ll gain easy access to a number of Lubbock attractions, eateries, and schools. Those with a sweet tooth will love how close we are to Crumbl Cookies, just around a quarter mile away. Within walking distance, you’ll also find Evie Mae’s BBQ and United Supermarkets. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>With our gated luxury apartments in southwest Lubbock, you can join a vibrant and energetic community with plenty of cool stuff to do around the area. We’re close to many <a href=\"/apartments/tx/lubbock/icon-at-lubbock/neighborhood\"><strong>neighborhoods</strong></a>, like Primrose Pointe, Bacon Crest, Regal Park, Remington Park, Wolfforth, and more. Want to try different wines? You’ll be happy to know that we’re close to The Funky Door Bistro &amp; Wine Room.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our Tuscany Place <a href=\"/apartments/tx/lubbock/tuscany-place/neighborhood\"><strong>apartment community is located in southwest Lubbock,</strong></a> putting residents near several of the area’s top dining spots, shopping centers, attractions, and schools. In fact, Heritage Middle School is less than a half-mile from our Lubbock apartments.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/temple/portico-at-friars-creek-apts::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Conveniently located near major roads and highways, our Temple apartment community is part of a lively <a href=\"/apartments/tx/temple/portico-at-friars-creek-apts/neighborhood\"><strong>neighborhood</strong></a>. You’ll be close to Belton Lake, Stillhouse Hollow Lake, Temple College, and Baylor Scott &amp; White Medical Center. Your Temple apartment is your portal to a new and exciting community for you to explore.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our optimal location in <a href=\"/apartments/tx/waco/bend-at-new-road/neighborhood\"><strong>south Waco</strong></a> gives you access to everything Waco has to offer. We’re also a great option for apartments in Beverly Hills, TX, and Robinson, TX. You’ll find several dining options near our south Waco apartments, from well-loved chains to authentic Mexican restaurants.</p>\n<p>We offer apartments near Baylor University, with floor plans for students wanting to live alone or even with a roommate. You’ll also find many entertainment options and parks nearby, such as Cinemark Waco, Main Event, and Alta Vista Park. Just around four miles from downtown Waco, you’re never far away from the excitement of the city. Rent downtown Waco apartments at Bend at New Road!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/tuscany-ranch-apartments::propertyneighborhood.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Next to Tuscany Ranch is a lively and exciting <a href=\"/apartments/tx/waco/tuscany-ranch-apartments/neighborhood\"><strong>neighborhood</strong></a> filled with fun activities to do. You can find Cinemark Waco and XD and Main Event Waco just down the road from our Waco apartments. You can also explore Baylor University, Cottonwood Creek Golf Course, and Kendrick Park—just a short drive away.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments::propertyneighborhood.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience the Best of <span data-type=\"field-token\" data-field=\"property_address_city\"></span> at Our Cozy Apartment Rentals</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/remington-wichita-apts::propertyneighborhood.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience the Best of <span data-type=\"field-token\" data-field=\"property_address_city\"></span> at Our Conveniently Located Community</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail::propertyneighborhood.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience the Best of <span data-type=\"field-token\" data-field=\"property_address_city\"></span> at Our Upscale Duplex Rentals</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">You’ll never have a dull moment when living at Arbors of Pleasant Valley Apartments in Little Rock! There is so much to see and discover in the neighborhood, with a little something for everyone. Catch the movie you’ve been waiting to see at AMC Chenal 9 or take a walk through Birchwood Park on a sunny day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">You’ll find several things to do near <a href=\"/apartments/ks/wichita/aspen-park-apartments/floor-plans\"><strong>our apartment community</strong></a> when you want to spend a night out with friends or get together with family. Take the short drive into the city and wander the verdant grounds of Botanica and The Wichita Gardens, or learn about Wichita’s history at Old Cowtown Museum. Attractions and other places to visit near our apartment community include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/crown-chase-apts/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Crown Chase apartments are just minutes away from some of Wichita’s best attractions, thanks to our prime location. Spend your day strolling through beautiful neighborhood parks, browsing educational exhibits at one of the many nearby museums, or watching a live performance at a local concert hall or theater. Places to visit near Crown Chase Apartments in Wichita include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/newport-wichita-apts/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Wichita is full of exciting places to visit and activities to enjoy for residents of all ages. You can start by visiting the Wichita Art Museum or catching a live performance at the historic Orpheum Theatre. For outdoor enthusiasts, the expansive Sedgwick County Zoo is only a few blocks up the street, and the Sedgwick County Park offers picturesque trails, recreational spaces, and the ideal place for you and your furry friends to enjoy some time outside our <a href=\"/apartments/ks/wichita/newport-wichita-apts/pet-policy\"><strong>pet-friendly apartments</strong></a>.</p>\n<p class=\"has-text-align-center\">There are many more fascinating places and engaging activities to explore, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/portofino/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">A range of exciting attractions for the whole family await just a short drive away. All Star Adventures, on the other side of the Beech Factory Airport, can be the perfect setting for a wonderful weekend day trip full of rides, slides, go-karts, and mini golf. North of our community, Crestview Country Club presents beautifully landscaped courses so you can practice your drive in a peaceful environment. On rainy days, you can always enjoy a movie in the 1940s-style Regal Warren East theater around the corner. More places to explore are scattered all around Wichita, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\"><br/>For those desiring an exhilarating day or weekend in Wichita, our luxurious apartment homes are near a plethora of local attractions, entertainment options, and activities. Explore Central Riverside Park for a riverside setting and a small zoo, discover new things at the Museum of World Treasures, or visit the unique Steampunk Village for a one-of-a-kind experience. Additional notable attractions near the Villas of Waterford include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/belton/center-301/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Spend your weekends exploring KC or stay here in Belton and discover everything this growing community offers. Take in the natural scenery by visiting Memorial Park or Wallace Park and breathe in the fresh air. Just a half-mile from our Belton apartments, you’ll find Belton Cinema 8, where you can sit back, relax, and catch the latest movie. Other entertainment and attractions near us include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/97-north-oak/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Our ideally located apartments make it easy to explore the Northland neighborhood and beyond, where you’ll find plenty of attractions nearby for residents of all ages. Thrill seekers will love the award-winning Worlds of Fun theme park, just 15 minutes from our Kansas City apartments, and adults and children alike can engage in some friendly competition at T-Shotz, a nearby driving range and restaurant. You’ll find several other attractions surrounding our Kansas City apartments, such as:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/mark-apts/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Looking for fun weekend activities in Ridgeland for yourself, your family, or your friends to try out? You’re in luck! Living at The Mark puts you in proximity to tons of things to do and places to visit. For example, if you’re looking for apartments near the Reservoir, we’re less than a mile away! Here are a few of our top recommendations in the Ridgeland area:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/sunchase-ridgeland-apts/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Maybe you want to explore the town and see what activities and attractions are available in Ridgeland, MS. Thankfully, there are many fun destinations just a short distance from Sunchase Ridgeland Apartments. Take your family to the many parks near the Ross R Barnett Reservoir or see a movie at Malco Renaissance Cinema. The endless possibilities are right around the corner from your Ridgeland apartment!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/the-pointe-of-ridgeland/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">For fun and entertainment near The Pointe in East Ridgeland, check out Enter/Locked Escape Rooms or Sky Zone Trampoline Park. If you’re a nature lover, you can take a stroll through Trustmark Park or take your furry friend on a walk through Friendship Park, all located just a short drive away.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">You may be surprised by the wealth of entertainment that can be found in and around Broken Arrow. Vintage Toy Mall is a short drive to the south in Meadow Heights Shopping Center, with an extensive collection that appeals to the young and young at heart. Take the whole family on a one-of-a-kind visit to the Rocket Fizz candy store, or enjoy an escape from home in Broken Arrow to experience the skyline from the Roof of Sidecar Barley and Wine Bar or the made-in-town brews at the entirely gluten-free NEFF Brewing. Places to visit near The Park at Mission Hills include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Get out and explore the entertainment and recreation options near Scissortail Crossing in Broken Arrow, OK.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Living at Trails at Aspen Creek means you’re never far from the vibrant entertainment that Broken Arrow has to offer. Regal Warren Broken Arrow is a popular spot for catching the latest blockbuster movies in a comfortable, retro-style theater setting. It’s less than a mile away, so treat yourself or take loved ones out for a night at the movies just minutes from home. </p>\n<p class=\"has-text-align-center\">For those who prefer live performances, the Broken Arrow Performing Arts Center hosts a variety of shows, from Broadway-style productions to concerts. If you’re looking for something more interactive, head over to Broken Arrow Lanes for bowling or Broken Arrow Roller Sports for high-speed excitement.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><a href=\"/apartments/ok/broken-arrow/villas-at-aspen-park/amenities\">View All Amenities</a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/fountain-lake/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Spend your weekends enjoying our <a href=\"/apartments/ok/edmond/fountain-lake/amenities\"><strong>community amenities</strong></a> or exploring some of the many things to do near Fountain Lake Apartments. Attractions like neighborhood parks and museums await your visit, so you’ll always have something to do. Make the quick 15-minute drive down Broadway Extension to downtown OKC and visit some of the city’s most famous attractions, or stay nearby and hit up some of the family-friendly spots in Edmond. Places to visit near Fountain Lake include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">If you’re seeking an exciting day in Edmond filled with things to do, you’ll be thrilled to discover numerous attractions, entertainment options, and activities encircling our luxury Edmond apartment homes. You can explore the leafy trees of Margaret Annis Boys Centennial Arboretum or play fetch with your pup at Edmond Dog Park. And that’s just the tip of the iceberg. There are other noteworthy destinations close to the Villas at Stonebridge, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\"><br/>When you don’t feel like trying your luck at the River Spirit Casino Resort, there are plenty of new experiences on both sides of the river. Staying on the western bank, you can take a deep dive into the fascinating world of local and exotic aquatic life at the world-renowned Oklahoma Aquarium or perfect your drive at GolfSuites Tulsa. On the other side of the river, you’ll find a nearly endless supply of attractions to explore, from the natural beauty of LaFortune Park’s walking trails to the iconic landmarks sprinkled across the historic Route 66 in downtown Tulsa, along with these popular attractions:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/artisan-crossing-apts/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">There’s so much to do and see around Norman, you’ll never be bored. Plus, since <a href=\"/apartments/ok/norman/artisan-crossing-apts/floor-plans\"><strong>our apartments</strong></a> are just a 20-minute drive from Oklahoma City, world-class museums and attractions are never far away. Check out the exhibits at the nearby Sam Noble Natural History Museum or catch a performance at the nearby Sooner Theatre. Additional attractions and entertainment near our Norman apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Spend your weekend exploring the many attractions and entertainment options in Norman, or take the short drive into downtown Oklahoma City and explore the city. Gorgeous parks, movie theaters, and other attractions await your visit near our Norman apartment homes. Look for these places to visit near Cimarron Trails:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Looking for things to do in Oklahoma City? Family-friendly attractions surround our apartment community in Oklahoma City, so you’ll never be bored. Fun for all ages can be found at the nearby Blue Zoo Aquarium, featuring interactive exhibits and shows. </p>\n<p>Are you looking for a spot for date night? Head to AMC Quail Springs Mall 24 theater and catch the latest movie, or practice your swing at Top Golf. Attractions and entertainment options nearby include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Spend quality time with friends and loved ones by getting out and enjoying some of the many attractions and entertainment options near Cimarron Pointe Apartments in Oklahoma City. Stay in the neighborhood or venture into downtown OKC. Either way, you’ll find many things to see and do. Some places to visit near our apartment community include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Whether you take the short drive into the city or stay around the Lakeridge Run neighborhood, there’s tons to do near Cross Timber Apartments. You can find fascinating museums, serene parks, local movie theaters, and all sorts of family-friendly within reach of Cross Timber. When you need some fresh air, head to Earlywine Park, featuring walking paths, tennis courts, a golf course, a playground, and picnic tables. Other things to do near our OKC apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/park-at-tuscany/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">From iconic landmarks to cultural hot spots, a wealth of experiences await exploration in Oklahoma City. Dive into a heart-pumping team race at the Oklahoma Regatta Festival, immerse yourself in the heart of local culture at the Paseo Arts Festival, or join hundreds of others in the ever-popular Oklahoma City Memorial Marathon. Find more engaging events and attractions near your Park at Tuscany apartment, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/persimmon-square-apartments/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Discover various exciting activities near our Oklahoma City apartments, perfect for embracing the outdoor experience. Whether it’s the thrill of sailing at Lake Hefner, seeing the array of animals at the Oklahoma City Zoo, or a serene adventure along the wooded trails at Martin Park Nature Center, there’s something for everyone.<br/>Residents of all ages can partake in delightful, family-friendly activities near Persimmon Square. Close to our Oklahoma City apartment community, you’ll find:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Dominating the landscape of northern Oklahoma City, Lake Hefner presents an idyllic setting for outdoor adventure. Numerous parks dot the perimeter of this natural attraction, allowing you to explore a new perspective as you relax in nature, hike through the many available trails, or enjoy a day of sailing in the middle of the city. Continue your exploration of Oklahoma City’s distinct identity as you travel the famed Route 66 and discover the dozens of artifacts and landmarks frozen in this iconic period. From the thriving nightlife downtown to the quiet relaxation of golfing near your home, excitement is not hard to find.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/stonehorse-crossing/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\"><br/>Dive into nature at the Martin Park Nature Center, a beautifully cultivated landscape with hiking trails just south of Gaillardia Golf Club. Lake Hefner, the historic reservoir and popular boating and fishing destination to our south is a great place to unwind, and just a short drive to the north will allow you to drive down the famed Route 66 Tail. From icons that define our town’s culture to exciting activities for the whole family, Oklahoma City has much to offer:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summerfield-place-apts/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Oklahoma City offers an abundance of activities to enjoy. Explore the Metropolitan Public Library, a brief drive from Summerfield Place, or venture to Martin Park Nature Center, situated to the north. For a cinematic experience, head to Cinemark near our Oklahoma City apartments. Additional entertainment choices include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/warrington-apartments/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">When you spend your weekend at our Oklahoma City apartments, make the most of the numerous nearby attractions. Whether you explore downtown’s top museums and tourist spots or opt for a closer-to-home adventure, there’s plenty to discover just minutes away from The Warrington.</p>\n<p class=\"has-text-align-center\">Don’t forget to check out Parkhurst Pumpkin Patch, a beloved autumn destination in Oklahoma City with diverse attractions for all ages. Some of the must-visit locations near our Oklahoma City apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\"><br/>Waters Edge is one of the most conveniently located upscale apartments in Southwest Oklahoma City. Downtown OKC is less than 15 minutes away, so you can watch the Thunder or cool off at Hurricane Harbor. Some of Oklahoma City’s favorite attractions, such as the Oklahoma Sports Hall of Fame and the Museum of Art, are nearby, too.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Excitement awaits right outside your front door. Tee off at the scenic Bailey Ranch Golf Course for a leisurely day on the greens or enjoy the lush expanses of Centennial Park, providing a perfect backdrop for outdoor activities. For families seeking an adventure through nature, the Tulsa Zoo offers a captivating wildlife experience, while history enthusiasts can explore the cultural offerings at the Woody Guthrie Center. Explore Owasso’s and Tulsa’s rich culture and build lifelong memories at these nearby attractions:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cypress-crossing/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Owasso is a hub of excitement for friends and family of all ages, and with Tulsa just a short drive away, there is plenty to do just outside your doorstep. If you’re planning a family outing, a casual date night, or simply seeking some “me” time, visit the Tulsa Air and Space Museum or the zoo at Mohawk Park for an afternoon full of fun. Or, you can take a trip with the whole family to Downtown Tulsa, the BOK Center, or catch a Tulsa Drillers game for a one-of-a-kind adventure everyone is sure to remember. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/stillwater/apple-creek-stillwater/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">While Stillwater may not be a large city, there’s still no shortage of things to do in town. Experience the exciting energy of a Cowboys game at Boone Pickens Stadium, just a short drive away, or head down the street to AMC and catch the next big film. When you want to get out and enjoy nature, we recommend visiting Boomer Lake Park for fishing, boating, hiking, and more. Other entertainment options near our apartments in Stillwater include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-glade-apts/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Fill your weekend with plans to visit several attractions near our Tulsa apartments. Explore Tulsa’s best museums and tourist attractions downtown, or stay close to home and discover some of the many things to do within minutes of Cedar Glade. When autumn comes around, don’t forget to visit Tulsa’s fan-favorite pumpkin patch, Pumpkin Town Farms, which offers a variety of fun activities for visitors of all ages. Places to visit near our Tulsa apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Enjoy each day you spend in Tulsa when you live at Chardonnay. Whether you drive into the city or stay in the neighborhood, there’s always something to do near our apartments in Tulsa. Less than five minutes away, Cinergy Theater awaits you, ready to whisk you away with the newest film. Incredible Pizza Company, less than a mile away, offers games, go-karts, and pizza for a day of family-friendly fun. Other attractions and entertainment near Chardonnay include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Our quiet corner of Tulsa keeps you close to attractions and entertainment destinations that define Tulsa’s culture. Head downtown to catch a concert in the Arts District or visit historic Route 66 landmarks just a few miles north of our community. Nearby, you can enjoy a range of places to explore for any occasion, from quiet walks in Hunter Park to a night of excitement at the River Spirit Casino Resort, along with these other attractions:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/nickel-creek-apts/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Nickel Creek is proud to be a convenient option for<strong> </strong>luxury living in South Tulsa. A short drive from downtown, it’s easy to catch a Tulsa Oilers game or see FC Tulsa in action. If you enjoy a bit of a slower pace, the Tulsa Art District offers attractions, including the Center of the Universe, Theater Tulsa, and the Woody Guthrie Center. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/polo-run-apartments/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">In the vibrant city center, Polo Run Apartments on Joplin Avenue is conveniently situated near an array of enjoyable attractions. A brief drive leads to Meadowbrook Country Club, which provides a serene setting for a round of golf. The captivating exhibits and diverse wildlife at Tulsa Zoo are also easily accessible from Polo Run Apartments.</p>\n<p class=\"has-text-align-center\">Dave &amp; Buster’s offers an exciting array of arcade games for a lively evening out with friends. Furthermore, our Tulsa apartments are near various entertainment options, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>When residing in our Tulsa apartments at Sheridan Pond, the surrounding area offers many attractions to explore and enjoy. You have diverse entertainment and recreation options, from the vibrant downtown Tulsa and the captivating Tulsa Zoo to the inviting Forest Trails Shopping Center.</p>\n<p>Whether seeking family-friendly activities or engaging pursuits for individuals of all ages, the attractions near our apartments ensure something for everyone to experience and appreciate, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Get out and explore the entertainment and recreation options near Sunchase Apartments in Tulsa, OK.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><a href=\"/apartments/ok/tulsa/windsail-apartments/amenities\">View All Amenities</a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Oklahoma City’s distinct character is defined by various attractions that draw the curiosity and wonder of locals and tourists. Discover cultural richness at the Oklahoma City Museum of Art, where captivating exhibitions and artistic masterpieces await at the heart of town. For a night of live entertainment, catch a comedy show at the iconic Bricktown Comedy Club or see one of the many major touring acts that regularly visit OKC at Chesapeake Arena. There is a vast world of entertainment to explore in Oklahoma City near The Park on Westpointe. Other examples to visit include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/the-ridge-@-66/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">From outdoor recreational activities to cultural experiences, there’s no shortage of things to see and do in Yukon. Spend a day exploring the scenic beauty of Lake Overholser, enjoy a round of golf at Surrey Hills Golf Club, or catch a live performance at the historic Dale Robertson Center. For a taste of local history, visit the famed highway that gives our community its name: Route 66. With countless monuments and historical buildings to discover, you’ll be surprised just how much there is to do in Yukon:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">One of the best ways to become part of the Amarillo community is by immersing yourself in the local culture. This starts by exploring the must-see attractions, including the Texas Air and Space Museum and the Stonehenge-like Cadillac Ranch. This local artistic marvel draws visitors from miles around. Keep the adventure going with a day trip down Route 66, or visit scenic vistas at the second-largest canyon in the nation in Palo Duro Canyon State Park. Excitement is just around the corner in Amarillo, so be sure to visit these other well-loved attractions:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Take a trip down the iconic Route 66 and discover the beautiful vistas and classic architecture that has drawn thousands of Americans to Amarillo for decades. Your deep dive into Americana continues at the American Quarter Horse Hall of Fame &amp; Museum and Bill’s Backyard Classics, where you can learn about how Amarillo has had a helping hand in moving this country forward throughout its history. Explore these must-see attractions and many others like it near our apartment community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">It’s not hard to find entertainment near Remington Apartments. Located near Sleepy Hollow, there’s something for everyone in this thriving neighborhood. Take a tour of the exciting Texas Air and Space Museum, see a movie at the Tascosa Drive-in, or visit the Amarillo Zoo, all just a short commute away.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">When you live at Colonies at Hillside, you’ll have access to many activities and attractions. With our prime location in southwest Amarillo, you’ll enjoy convenient access to the vibrant city scene. From the one-of-a-kind modern art on display at Cadillac Ranch to the abundance of entertainment options near Colonies at Hillside, dive into the attractions that give Amarillo its character.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/acacia-park-apts/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">There are so many things to experience and explore in the West El Paso area you’ll never run out of things to do. Hiking enthusiasts will enjoy the proximity to Franklin Mountains State Park and the trailheads offered. Enjoy a day out with the family at the El Paso Zoo or Bob-O’s Family Fun Center. In West El Paso, you’ll find numerous entertainment and attractions near our Acacia Park Apartments, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/chimneys-apts/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Being the most conveniently located apartment community in west El Paso, TX, a vast array of attractions and entertainment options are at your disposal. Just a short drive from downtown El Paso, you can spend the day at one of the many local museums, touring a garden, or taking in the breathtaking views of the nearby mountains. All this awaits you when renting a West El Paso apartment at The Chimneys.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">When you want to explore El Paso, there’s no shortage of options near our Double Tree Apartments. You’ll never be bored living in Westside El Paso, from tourist staples like McKelligon Canyon Amphitheatre to local hidden gems like Bob-O’s Family Fun Center. Additional attractions and entertainment options to visit near Double Tree Apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Get out and explore the entertainment and recreation options near High Ridge Apts. in El Paso, TX.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/mountain-village-apts/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">There’s never a shortage of things to do in El Paso, and when you live at Mountain Village, you’ll have easy access to it all. We’re around 20 minutes from downtown El Paso and not much farther from the Sunland Park and Santa Teresa areas of New Mexico. Catch a show at McKelligon Canyon Amphitheater or spend the afternoon shopping at West Towne Marketplace.</p>\n<p class=\"has-text-align-center\">Some of the attractions near Mountain Village Apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/patriot-apts/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">If you want to get out of your apartment and have a good time, you’ll love the attractions near our El Paso Apartments. You could catch a movie at AMC Theater, go for a hike at Franklin Mountain, or discover a new book at the local branch of the El Paso Public Library. There’s plenty to do for residents of all ages near The Patriot, including family-friendly activities.</p>\n<p class=\"has-text-align-center\">Near our El Paso apartment community, you’ll find many attractions, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/phoenix-apts/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Get out and explore the entertainment and recreation options near Phoenix Apts. in El Paso, TX.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/shadow-ridge-apts/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Our apartments near East Ridge and Cielo Vista are located near several local destinations and attractions and numerous major roads and highways leading toward downtown El Paso. From the various museums, parks, and botanical gardens to visit, we encourage our residents to get out and explore the city, including spots like:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Whether you’re seeking family-friendly activities or a romantic night out, there’s something for everyone nearby. Enjoy adrenaline-pumping fun at Urban Air Trampoline Park or Bob-O’s Family Fun Center, or dive into an adventure through nature at Keystone Heritage Park and the El Paso Desert Botanical Garden. For outdoor enthusiasts, Franklin Mountains State Park offers hiking trails and scenic vistas, while Top Golf provides hours of entertainment for golf enthusiasts and novices alike. More entertainment options near our El Paso apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/hewitt/icon-at-hewitt/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Icon at Hewitt also provides a convenient location for you to explore the Hewitt and West Waco area’s numerous attractions and entertainment options. You can stroll the many local parks, including Hewitt Park and Cameron Park, or attend a sporting event or concert in town. Once your day comes to an end, come back and rest your head in the comfort of your apartment home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Located just minutes from Wolfforth, our well-located apartment community offers ultimate convenience for those seeking adventure and entertainment. Whether looking for a fun-filled evening at a venue downtown, a leisurely Saturday afternoon exploring local wineries, or an enriching cultural experience at a museum, The Icon at Lubbock has it all. Get ready for an exciting day or night right outside your door.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Our vibrant city has much to offer for those looking to dive into Lubbock’s culture and entertainment scene.  One of the must-visit attractions is the Buddy Holly Center, a homage to Lubbock’s most famous native son, showcasing memorabilia, artifacts, and interactive exhibits detailing the life and legacy of the rock ‘n’ roll legend. For those with a penchant for art and history, the Museum of Texas Tech University is a treasure trove of cultural riches, along with these attractions near our community:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/temple/portico-at-friars-creek-apts/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">On top of the shopping and dining in Temple, there are many local attractions and entertainment options for you to explore as well. Just a short drive up Highway 190 separates you from all the events, shows, games, and movies that Temple has to offer. And when all is said and done, come home and take the rest of the night off in your luxury apartment home. Explore these attractions near your Temple apartment home:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Life in south Waco is never boring, thanks to the numerous entertainment options to explore. Catch the latest blockbuster at AMC Galaxy 16, or head over to the Dr. Pepper Museum for a taste of local history. You’ll find many must-visit attractions near our Waco apartment community, such as:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/tuscany-ranch-apartments/neighborhood::propertyneighborhoodmap.entertainment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Whether getting your game on, exploring nature, or learning about the area’s history, Waco has many fun attractions and entertainment options. Enjoy a movie at Cinemark Waco and XD or explore Waco’s most popular attractions, such as the Cameron Park Zoo and the Dr Pepper Museum. After a fun-filled day, return to your apartment home with a smile on your face.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">The Chisholm Pointe duplex and quadplex community is ideal for living if you want easy access to a variety of dining options in Oklahoma City. With numerous eateries nearby, you can easily find a cozy spot for brunch, a local café for a quick bite, a fine dining restaurant for a special occasion, or a family-friendly joint for weekend lunches. Don’t miss out on these exceptional dining options located in the vicinity of Chisholm Pointe:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/north-little-rock/lexington-park/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">When you’re craving a good meal but don’t feel like cooking, visit one of the many restaurants near Lexington Park Apartments in Little Rock. Whether you’re craving a sit-down meal with friends or a quick takeout dinner, you’ll find a dining option for every craving within reach. Sip margaritas with friends at the Casa Mexicana restaurant next door, or chow down on some Creole cuisine from Boudreaux’s Grill &amp; Bar. Restaurants near our apartments in Little Rock include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/maize/watercress-apartments/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Indulge in a culinary adventure at the various restaurants and eateries near Watercress Apartments. A brief drive from our Maize apartments leads you to HomeGrown Wichita at Naftzger Park, where you can savor a sandwich paired with fresh lemonade or unwind with a laid-back dinner at On The Border Mexican Grill &amp; Cantina.</p>\n<p>Explore further dining choices near Watercress Apartments, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">When you don’t feel like cooking, visit one of the many restaurants near our Wichita apartments. You’ll find fast food drive-thrus, cafes, coffee shops, and unique local restaurants near Aspen Park. When you need a sweet treat, stop by Sugar Llamas for delicious mini donuts, and when you’re looking for a quick lunch, stop by Schlotzky’s Deli just down the road. Dining options near our apartments in Wichita include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">From one-of-a-kind local restaurants to national chains, you can find a dining option for whatever you’re craving near Cottages at Crestview. Start your day with a pick-me-up from the local Starbucks coffee or grab breakfast at IHOP. For a unique dining experience, head to the Chicken N Pickle next door, where you can practice your pickleball game and enjoy a hearty meal ideally paired with a signature cocktail. Restaurants and other food spots near our apartments in Wichita include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/crown-chase-apts/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">When you don’t feel like cooking in the fully-equipped kitchen or enjoying the <a href=\"/apartments/ks/wichita/crown-chase-apts/amenities\"><strong>many other amenities</strong></a>, experience Wichita’s culinary highlights and visit one of the many restaurants near Crown Chase Apartments. Casual eateries, sit-down restaurants, and well-loved chains can all be found near our Wichita apartments. Look for the following dining options near Crown Chase:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/huntington-park/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Grab dinner with your friends and loved ones or a quick takeout meal from one of the many restaurants near Huntington Park Apartments in Wichita. There’s a dining option for every craving nearby, from nationwide chains to local spots. Some of the restaurants near our <a href=\"/apartments/ks/wichita/huntington-park/floor-plans#/\"><strong>1- and 2-bedroom Wichita apartments</strong></a> include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/newport-wichita-apts/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">A good meal is easy to find in a strategically located apartment community. Try 6S Steakhouse to the north for a taste of Kansas history in an opulent environment, or if you are looking for something more down to Earth, you can’t get any more local than When Pigs Fly BBQ. Our northwest Wichita apartments are situated near a range of dining options, so whether you are aiming for a fine dining experience or the simple delight of local cuisine, the options are all outside your door.<br/><br/>More dining options near Newport Apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/portofino/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">From cozy cafes to upscale bistros, the culinary scene in our area offers something for every palate. Indulge in mouthwatering dishes crafted locally at Cheddar’s Scratch Kitchen or savor international flavors from YaYa’s Euro Bistro or ABuelo’s Mexican Restaurant. Newport Grill is another locally favored destination for fine dining close to home, offering premium seafood with an aquatic theme. Enjoy these dining options and more at an array of restaurants near your home in Portofino:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/raintree-apartments/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>When you’re not making the most of your fully equipped kitchen, you’ll find an array of enticing dining options just a short drive from Raintree Apartments. Whether you’re craving the convenience of national fast-food chains or a memorable sit-down dining experience, there’s something to please every palate.</p>\n<p>Just around the corner from Raintree Apartments, you can savor the delightful sandwiches at Panera Bread or treat yourself to a selection of espresso favorites of Scooter’s Coffee. Other dining options include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/remington-wichita/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Explore the dining options near our Wichita apartments for a culinary experience outside your kitchen. Whether you crave a cozy sit-down meal or prefer grabbing takeout from a beloved spot, The Remington Apartments in Wichita offers various choices nearby, such as:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/silver-springs-apts/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Indulge in delectable dining experiences at the array of restaurants within our community, perfect for when you prefer to take the day or night off from cooking in your fully equipped kitchen. Whether you crave a sit-down meal or a quick bite, you’ll discover a diverse culinary scene just a brief drive away.</p>\n<p>For mouthwatering homemade pies, venture to Spear’s Restaurant &amp; Pie Shop near Silver Springs Apartments, or savor traditional and innovative Italian fare at Bella Vita Bistro. Explore the following dining venues situated close to our Wichita apartment community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find your next great meal at one of the many restaurants near Villas of Waterford in Wichita, KS.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/belton/center-301/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">When you’re not cooking up meals in your apartment’s gourmet kitchen, you can dine at one of the several diverse restaurants in Belton. Try a traditional Hawaiian plate lunch from the nearby Hawaiian Bros or cheer on the Chiefs with wings and a cold one at the nearby Buffalo Wild Wings. Look for the following dining options near Center 301 Apartments:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/independence/the-adirondack/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Adirondack Apartments in Independence offers an abundance of excellent dining options. From soothing coffee shops to upscale fine dining establishments, there is no shortage of choices for a memorable experience in Independence, MO. The diverse range of options ensures that residents can find the perfect spot for a quick meal between errands or a cozy dinner with family.</p>\n<p>Additional restaurants, fine dining, and coffee shops near the Adirondack include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/152-northland/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Kansas City is full of delicious places to eat, many of which are located close to 152 Northland. Pick up a cup of joe at Dunkin’ or Headrush Roasters on your way into the office, and grab a drink at Sandbox or The BrewTop Pub and Patio with friends once you’re off. If you want a dinner spot to celebrate a birthday party, 54th Street Restaurant &amp; Drafthouse is just a few minutes away.</p>\n<p class=\"has-text-align-center\">Other dining options close to our apartments near Zona Rosa include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/97-north-oak/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Kansas City’s barbecue may be its most well-known cuisine, but there are many more dining options near 97 at North Oak. Grab a caffeinated beverage at the neighboring Starbucks or grab a pizza pie from KC’s own local pizza chain, Pizza Shoppe, for a quick and easy dinner. Dining near our Kansas City apartments includes:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/mark-apts/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">You won’t have to travel far to get a quality bite to eat or your morning coffee when you live at The Mark Apartments. We’re right down the road from many local restaurants, national chains, and a variety of local favorites for you to check out. Some of these include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/sunchase-ridgeland-apts/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>There’s no doubt that Ridgeland, MS, has many different shops and dining options for you to try. In just a short drive from our apartment community, you can spend the day roaming around the corridors of Northpark Mall or stop by one of the town’s famous restaurants. When you’re all shopped out and full of food, you can return to your Ridgeland apartment after a day well spent.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/the-pointe-of-ridgeland/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Shopping and dining are just a short drive away from The Pointe of Ridgeland. Whether you have a taste for tacos at Green Ghost Tacos or want to indulge in retail therapy at Northpark Mall, you’ll find exactly what you’re looking for when you choose The Pointe.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/trace-apts/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Hungry but don’t feel like cooking? That’s no problem when you live in our Ridgeland apartment community. For a taste of local flavor, Primo’s Cafe offers southern classics served with a side of hospitality, making every meal feel like a family gathering. Nearby, you’ll find many local and chain restaurants, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Several nearby restaurants offer any kind of cuisine you could crave, from quick takeout dinners to fine dining. Connect with friends and loved ones over brunch at Apple Barrel Cafe or enjoy dinner on the patio at Habaneros Mexican Grill &amp; Bar. Some of the dining options near our apartments in Broken Arrow include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>A good meal is not hard to find near The Park at Mission Hills. Dine in for a taste of classic Oklahoma cuisine at Charleston’s Restaurant. Keo Broken Arrow is another local favorite, offering a modern yet comfortable atmosphere and a taste of Thai culture at the heart of the Great Plains.<br/><br/>More fine dining options await a short drive away in Tulsa. Experience the delightful Italian atmosphere and delicacies at Ti Amo Ristorante Italiano, or taste Tulsa tradition at the ever-popular Spudder Steakhouse, only a mile apart!</p>\n<p><br/>Additional dining options nearby our apartment community include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/redbud-ranch/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Redbud Ranch offers an array of nearby dining choices, ensuring you can effortlessly indulge your culinary desires, whether for a swift bite or a romantic dinner. Just two miles away, Starbucks is an excellent place for a morning pick-me-up.</p>\n<p>Main Street Tavern provides a selection of classic American fare, late-night pub specialties, live jazz, and happy hour delights, all just about four miles from our North Broken Arrow Apartments. Several eateries, cafes, and culinary destinations are also nearby, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Near our Broken Arrow apartments for rent, a diverse range of dining experiences awaits, from well-known chains to unique local eateries. Whether you’re in the mood for flavorful wings at Buffalo Wild Wings or tantalizing Thai cuisine at Amazing Thai Cuisine Broken Arrow, there are many dining choices beyond our apartment community, each offering distinct culinary delights. Here are some other dining options:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Trails at Aspen Creek is surrounded by a wealth of dining options that cater to every palate. For those who appreciate a refined dining experience, Charleston’s Restaurant gives you a taste of classic Oklahoma cuisine in an upscale yet comfortable setting. Another nearby gem is Keo Broken Arrow, where you can indulge in the unique flavors of Thai cuisine presented with a modern twist. The inviting atmosphere and diverse menu make it a perfect spot for casual dining and special occasions any time of the year.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Fine dining experiences are only a short drive away from your home in Villas at Aspen Park. Take a drive down Kenosha St. to explore a number of casual local favorites including All About Cha – Broken Arrow and visit the beloved Bison Steakhouse to the south for a premium meal in a beautiful atmosphere. A short trip into Tulsa offers a near-endless selection of eateries to explore, from Polo Grill to Bull In The Alley, and these other nearby options:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/fountain-lake/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">When you need a good meal but don’t feel like cooking, head to one of the several dining establishments near our Edmond apartments. From local favorites to date night spots to familiar fast food chains, there’s a restaurant for every craving near Fountain Lake Apartments in Edmond. Look for the following dining options near Fountain Lake:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find your next great meal at one of the many restaurants near Villas at Stonebridge in Edmond, OK.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Lovers of exquisite cuisine will appreciate their home’s convenient position near some of Jenks and Tulsa’s finest establishments. Explore the elegant setting and stunning offerings from the upmarket Ruth’s Chris Steak House just across the river, or for an elevated dining experience closer to home, Waterfront Grill Tulsa’s classic American entrees are sure to satisfy any appetite. A wide selection of refined dining and comfort foods is available near your home, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/moore/mission-point/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">When you are craving a quick bite to eat or an intimate dining experience, a wide selection of options for any type of meal can be found right outside your door. Hidalgo’s Mexican Restaurant and Cantina is a local favorite with beautiful scenery and a delectable menu that can be found just on the other side of the highway, or give Genghis Grill a try for a unique build-it-yourself style of stir fry just miniature of the street. More dining options near Mission Point include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/artisan-crossing-apts/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Mouthwatering cuisine awaits you all around our apartments in Norman. Whether you’re looking for a lunch spot or a bar for meeting with friends, you’ll find a restaurant for every craving near our Norman apartment community. Grab a burger, catch a sports game at The Garage Burgers &amp; Brews, or grab dinner at the fan-favorite Tarahumara’s Mexican Cafe. Restaurants near Artisan Crossing include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">From trendy brunch spots to favorite local restaurants, there are dining options for any occasion and palette near our Norman apartment community. Start your day off with a sweet treat and espresso from la Madeleine, then chat with friends over a dinnertime cocktail at Redrock Canyon Grill. Look for these restaurants and other dining options near Cimarron Trails:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">No matter what you’re craving, you’re sure to find it near our apartment community. Near 24Hundred, you’ll find coffee spots, romantic restaurants, brunch haunts, and more. Indulge in a nice cup of joe at Scooter’s Coffee, just down the street from <a href=\"/apartments/ok/oklahoma-city/24hundred-apartments/floor-plans\"><strong>our Oklahoma City apartments</strong></a>, or head to the nearby First Bite Cafe for flavorful brunch fare. Additional dining options near our apartments in Oklahoma City include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">The Chisholm Pointe duplex and quadplex community is ideal for living if you want easy access to a variety of dining options in Oklahoma City. With numerous eateries nearby, you can easily find a cozy spot for brunch, a local café for a quick bite, a fine dining restaurant for a special occasion, or a family-friendly joint for weekend lunches. Don’t miss out on these exceptional dining options located in the vicinity of Chisholm Pointe:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">For days when you’re hungry but just don’t feel like cooking, visit one of the many restaurants near our OKC apartments. Romantic date night spots, popular fast food drive-thrus, and local cafes can all be found near Cimarron Pointe Apartments. Reconnect with friends over chips and salsa at Chelino’s Mexican Restaurant, or head to Gyro City Cafe for a quick lunch. Additional dining options near our apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">When you’re not cooking in your <a href=\"/apartments/ok/oklahoma-city/council-place-apartments/floor-plans\"><strong>fully equipped kitchen</strong></a>, visit one of the restaurants near our community for a delicious meal. From national fast food chains to sit-down restaurants, there’s a dining option for every occasion just a quick drive away. Head to Jimmy’s Egg for delicious breakfast favorites, or grab a burger with friends at S&amp;B’s Burger Joint, both near Council Place Apartments. Additional dining venues near our Oklahoma City apartment community include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Whatever you’re craving, chances are one of the several restaurants near Cross Timber has the cuisine you’re looking for. Enjoy easy access to sit-down restaurants, local eateries, fast-food drive-thrus, cafes, and so much more. Right across the street from Cross Timber, you’ll find a Starbucks Cafe, great for grabbing your caffeine fix before your commute. When you’re looking for a good date night spot, try Spazio Restaurant, just five minutes away from Cross Timber, where you can enjoy Italian favorites in a cozy setting. Other dining options nearby include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Whether you’re craving takeout or a sit-down meal, you’re sure to find what you’re looking for at one of the many restaurants near Crown Pointe. When you need a quick meal, head to the local Hideaway Pizza for a savory pie, and when you need a caffeine boost, a Starbucks is just two minutes away. You’ll find the following dining options near Crown Pointe Apartments in OKC:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter's-ridge-apts/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">When your stomach starts to rumble, head to one of the many dining options near Hunter’s Ridge Apartments. Whether you want a quick takeout meal or a romantic dinner, you’ll find a great option just a short drive away. Some dining options near Hunter’s Ridge Apartments in Oklahoma City include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/park-at-tuscany/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Indulge in the savory offerings of local icons like Mahogany Prime Steakhouse, savor the aromatic brews at charming cafes, and explore a diverse range of culinary delights that await just moments from your doorstep. Some of the tempting dining options adjacent to <a href=\"/apartments/ok/oklahoma-city/park-at-tuscany/floor-plans\"><strong>The Park at Tuscany Apartments</strong></a> include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/persimmon-square-apartments/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Near Persimmon Square, various dining options await, catering to every preference, from quick bites to upscale dining experiences. Our Oklahoma City apartment community boasts proximity to renowned steak establishments like Firebirds Wood Fired Grill and Cattlemen’s Steakhouse, perfect for a delightful evening out. Additionally, just a mile away, Starbucks offers a convenient stop for your favorite caffeine fix. Embrace a diverse culinary landscape, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">OKC’s famed culinary culture is on full display just a few short miles from your home. The Metro Wine Bar &amp; Bistro brings French cuisine into an intimate space for a classy night out in the center of town. For those seeking a more traditional dining experience, Red PrimSteak’s sleek decor and iconic dishes offer an upscale taste of Oklahoma cooking. More premium dining options, as well as classic comfort foods, can be found near your Prairie Springs apartment, such as:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/stonehorse-crossing/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Whether you’re craving Italian, traditional American fare, or something new, you’ll find it all just moments away. Just around the corner on May Avenue you can enjoy a taste of coastal cuisine right here in the center of the Midwest along with Mahogany Prime Steakhouse’s classic Oklahoma surf and turf. More options are available only miniature from home both in northern OKC and downtown, all easy to reach from our well-positioned community, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summerfield-place-apts/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Within proximity to our Oklahoma City apartments are popular local eateries and convenient coffee drive-throughs. In this vibrant city, you can savor a meal at Modern Berry Co. or indulge in a mouthwatering burger from The Garage Burgers &amp; Beer. There are many more to explore, other nearby dining options include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summit-ridge-villas/summit-villas/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">The Chisholm Pointe duplex and quadplex community is ideal for living if you want easy access to a variety of dining options in Oklahoma City. With numerous eateries nearby, you can easily find a cozy spot for brunch, a local café for a quick bite, a fine dining restaurant for a special occasion, or a family-friendly joint for weekend lunches. Don’t miss out on these exceptional dining options located in the vicinity of Chisholm Pointe:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/tammaron-village-apartments/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Explore the array of dining choices near our Oklahoma City apartments. You’re sure to find the perfect spot to satisfy your cravings, whether it’s a speedy takeout meal or a delightful dinner with your loved ones. A quick drive from our apartments will lead you to a variety of dining establishments, ranging from sit-down restaurants and coffee shops to fast-food drive-throughs.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/warrington-apartments/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Warrington Apartments offers convenient access to various dining establishments, ensuring you’re always just a short drive from a delicious meal or quick snack. Indulge in a flavorful steak dinner at Charleston’s or savor some pizza with friends at Revolve Pizza Kitchen.</p>\n<p>For coffee enthusiasts, nearby cafes like Whipped Bakery Cafe, Mentalitea and Coffee, Tawbi Coffee, and Clarity Coffee are perfect for satisfying caffeine cravings. Our reasonably priced apartments in Oklahoma City offer numerous dining options, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Residents of Oklahoma City know the area is a hotbed for some of the best local restaurants in the state. Here at Waters Edge, we have just about everything a few minutes away, including some of the best Mexican food in southwestern Oklahoma City, old-fashioned and delightfully greasy bar food, and favorite chains like Chili’s.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/coffee-creek/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Whether you’re in the mood for a casual dine-in experience, a quick takeout meal, or a delightful gathering with friends and loved ones, Coffee Creek Apartments places you near an array of dining choices in Owasso. Grab your morning coffee across the street at Starbucks with Panera Bread right next door for your lunch. If you are looking for upscale eating options:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Savor the diverse culinary delights near Cottages at Tallgrass. From quick bites to memorable upscale dining experiences, the Owasso and Tulsa communities boast a range of options for every occasion. Indulge in your favorite morning brew at Jordy Jo Coffee Co., relish the comforting flavors at Panera Bread, or for a more refined night out, head south to Fleming’s Prime Steakhouse and Wine bar to enjoy the fine farm-to-table offerings of Juniper’s Restaurant, along with these other dining options near Cottages at Tallgrass Point:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cypress-crossing/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">When you’re not spending <strong><a href=\"/apartments/ok/owasso/cypress-crossing/floor-plans\">relaxing evenings on your private deck</a></strong> or enjoying a family cookout in <strong><a href=\"/apartments/ok/owasso/cypress-crossing/amenities\">our barbecue area</a></strong>, you have plenty of opportunities to explore and fill your days or nights with shopping and dining! Akira Sushi bar, just a short drive down the highway, is locally loved for its powerful flavors on each plate. Also, Bricktown Brewery is just around the corner, giving you the perfect spot to unwind with your partner or enjoy an adult’s night out with your friends. </p>\n<p class=\"has-text-align-center\">Other nearby restaurants include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/pryor/west-530/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Take a break from cooking and treat yourself to one of Pryor’s many restaurants. JL’s Barbeque is a great place to take the family to enjoy a hearty, classic American meal, or for a real treat, head up to Braum’s Ice Cream &amp; Dairy Store for everything from their iconic ice cream cones to flaming hot chicken. There’s plenty nearby to explore, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/stillwater/apple-creek-stillwater/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">From legendary local restaurants to coffee drive-thrus, you’ll find a restaurant for whatever you’re craving near our apartments in Stillwater. Grab some Italian comfort food at Davinci’s Italian for date night or swing by the nearby Chick-fil-A for some study fuel. Other dining options near our Stillwater apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/barrington-apartments/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Craving some takeout or a sit-down meal? Head to one of the many dining establishments near our Tulsa apartment community. From steakhouses to cafes and beyond, there’s a restaurant for any craving near Barrington Apartments. Some of the dining options near our Tulsa apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cascata-luxury-apartments/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Whether you’re looking to grab a quick bite or need a spot for date night, the many dining options near Cascata make it easy to satisfy your cravings. Stop by the local Starbucks, less than a half-mile away, for a caffeine boost before heading to work. Head to Black Bear Diner for excellent brunch and Kirin Asian and Sushi Cuisine for beautifully prepared sushi rolls. Several additional restaurants, coffee shops, and other food spots can be found nearby, such as:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-glade-apts/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">With so many nearby restaurants, Cedar Glade is always a short drive away from a good meal or snack. Grab dinner and a decadent slice of cheesecake at the nearby Cheesecake Factory, or head to Texas Roadhouse for a juicy steak. If you’re a coffee lover, you can get your caffeine fix at one of the several nearby cafes: Starbucks, Rocket Brothers, Ziggi’s, Scooters, and more! Additional dining options near our affordable apartments in Tulsa include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Delicious cuisine awaits you near Cedar Ridge, with restaurants and eateries to satisfy your every craving. Grab a fresh lunch from Cava or enjoy a romantic dinner at Bluestone Steakhouse and Seafood, both a quick drive from our Tulsa apartments. If you need a pick-me-up, grab a fresh cup of joe from Ziggi’s Coffee, just a mile away. Additional dining options near Cedar Ridge include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Are you searching for a good meal? You’re in luck! Our apartments in south Tulsa are situated near a variety of dining options, ranging from casual eateries to sit-down restaurants. Try a slice of The Cheesecake Factory’s signature cheesecake for a sweet treat, or enjoy a classic meal at Black Bear Diner. Additional dining options near Chardonnay Apartments in Tulsa include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Southern Tulsa presents a balanced assortment of high-class dining options and local staples that keep every night out new and exciting. Just a few minutes west of Country Hollow on the riverfront, you can find one of Tulsa’s most desirable upscale restaurants at Ruth’s Chris Steak House, part of the River Spirit Casino Resort. When you are looking for a more casual dining experience, you can always enjoy some Midwestern comfort food at RibCrib BBQ, right next door to our community, along with these other nearby restaurants in Tulsa:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/creekwood-apartments/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">When you’re not preparing meals in your apartment’s fully equipped kitchen, visit one of the several restaurants near our Tulsa apartments. From sit down restaurants to beloved take-out spots, there’s a dining option for any craving within reach. Look for the following food spots near Creekwood apartments in Tulsa:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/nickel-creek-apts/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Whether you’ve lived in Tulsa for decades or are new to the area, it’s easy to see that there is a wide selection of choices for local eateries. Stay close to home with carryout from Hideaway Pizza, head across the river to India Palace, or try new drinks downtown at Cellar Dweller, the options truly are endless.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/polo-run-apartments/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>You’ll discover diverse dining options near our Tulsa apartments, catering to every craving, from renowned local eateries to quick coffee drive-thrus. Close to our Tulsa apartments, you can indulge in delicious burgers at Charleston’s Restaurant or grab some study fuel at Sonic Drive-In. Additionally, other dining options include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Near Sheridan Pond, various dining options cater to different preferences and occasions. Whether you’re craving a quick bite at a fast-food drive-thru or planning a special date night, the area offers a diverse selection of eateries.</p>\n<p>Notable establishments near our Tulsa apartment community include Panera, Chipotle, and Texas Roadhouse, providing convenient dining choices for our residents. Additionally, Starbucks, located just two miles northeast of us, offers a convenient spot for a caffeine fix during daily commutes. Restaurant options near our apartments in Tulsa include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Are you looking to dine out near Sugarberry Apartments in Tulsa? Uncover various restaurants surrounding our Tulsa apartment community, ranging from cozy cafes to elegant steakhouses. South Tulsa boasts numerous dining establishments, ensuring something for everyone, whether you seek a quick meal or a relaxed dinner.</p>\n<p>Explore the vibrant dining landscape around Sugarberry Apartments in south Tulsa to enhance your apartment living experience. Some of the dining venues near Sugarberry Apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">If you don’t feel like cooking up a meal in the comfort of your Tulsa apartment, there are numerous dining options nearby. Indulge in a diverse selection of distinctive local eateries. Lanna Thai Restaurant beckons with its extensive array of Thai delicacies and flavorful curries, while Fish Daddy’s Grill House tantalizes taste buds with its delectable fried fish platters. Sunchase enjoys proximity to the following restaurants and culinary hot spots.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Hungry but don’t feel like cooking? Thankfully, our Tulsa apartments are near several dining options. Sit-down restaurants, takeout, drive-thru spots, coffee shops, and just about anything else you can think of can be found a quick drive away from The Courtyards apartments in Tulsa. Look for these dining options near our apartment community:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Whether you’re craving a quick takeout meal or need a spot to grab dinner with your friends, family, or loved ones, one of the several restaurants near our Tulsa apartments is bound to have what you’re craving. Sit-down restaurants, coffee shops, familiar fast food drive-thrus, and more are just a quick drive away. Look for these dining options near our Tulsa apartments:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">For those days when you crave a break from cooking in your spacious kitchen, venture out to the array of dining options surrounding Windsail Apartments to savor Tulsa’s culinary delights. Our Tulsa residences offer easy access to various restaurants, ranging from cozy cafés to upscale dining establishments and popular chain eateries, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">When you’re craving a break from the kitchen, explore the vibrant dining scene near our <a href=\"/apartments/ok/yukon/park-at-westpointe/floor-plans\"><strong>Oklahoma City apartments</strong></a>. From cozy cafes to artisanal coffee shops, the culinary landscape surrounding The Park on Westpointe offers a delightful array of options to keep each meal fresh and exciting. Stop into Interurban Restaurant for a taste of classic American cuisine, or grab a slice from All American Pizza for a quick locally made bite on your way to work. If you are looking for something sweeter, indulge in delicious mini doughnuts at Sugar Llamas, or grab a homemade Pop Tart from the Okie Dokie Bakery, and be sure to visit these other eateries near The Park on Westpointe.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/the-ridge-@-66/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Start your culinary journey with a diverse selection of dining options near <a href=\"/apartments/ok/yukon/the-ridge-66/floor-plans\"><strong>Ridge at 66</strong></a>. Enjoy classic American dishes at The Lokal Yukon or locally made Italian cuisine at Emma Elle’s Italian Kitchen, just across the street from our apartments. A short drive down Route 66 takes you into the heart of Oklahoma City where more fine and casual places to dine await, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/the-ridge-66/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Start your culinary journey with a diverse selection of dining options near <a href=\"/apartments/ok/yukon/the-ridge-66/floor-plans\"><strong>Ridge at 66</strong></a>. Enjoy classic American dishes at The Lokal Yukon or locally made Italian cuisine at Emma Elle’s Italian Kitchen, just across the street from our apartments. A short drive down Route 66 takes you into the heart of Oklahoma City where more fine and casual places to dine await, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Whether you are looking for the ideal setting for a date night or a place to grab a quick bite to eat on your way to work, Amarillo’s rich culinary community provides plenty of options. Your favorite staples can all be found within a mile of Newport Apartments. If you want something a little more refined, head north to Toscana Italian Steakhouse or try out the extensive wine selection at the Drunken Oyster, a local favorite.<br/><br/>Dining options near Newport Apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Amarillo’s wide selection of restaurants caters to every kind of meal. Our apartment homes are close to some of the community’s most beloved dining establishments, from the beautiful atmosphere of Metropolitan Steak &amp; Seafood to the high-energy experience of Sakura Japanese Steakhouse &amp; Sushi-Oyster Bar and their showmen chefs. Find fine dining options and casual eateries all within a short drive of our Amarillo apartments.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Shopping and dining is always a hassle-free experience when you live at Remington Apartments. Enjoy the convenience of all types of restaurants, bakeries, coffee shops, grocery stores, boutiques, and more when you live in our Southwest Amarillo community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Whether you’re a longtime resident or a newcomer to apartments in southwest Amarillo, you’re in for a treat when dining and shopping in Amarillo. At the Colonies at Hillside, we’re just a short drive from many delectable restaurants and exciting shops. Discover these hidden gems and mouthwatering dishes at the vibrant dining and shopping experiences around the Colonies at Hillside:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Are you craving a delicious meal without the hassle of cooking? Winchester Apartments in Amarillo is close to various dining choices, ranging from cozy sit-down restaurants to convenient takeout and drive-through spots. Explore the array of dining options located near our apartment community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/acacia-park-apts/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find your next great meal at one of the many restaurants near Acacia Park Apts. in El Paso, TX.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/chimneys-apts/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>From residents who have lived in El Paso for decades to those new in town, countless shopping and dining options are available near our westside El Paso apartment community. You can spend the day shopping at one of the many malls and shopping centers across town, and when the time comes for food, you’ll have numerous restaurants to choose from.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find your next great meal at one of the many restaurants near Double Tree Apts. in El Paso, TX.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Living at our High Ridge Apartments near Cielo Vista gives you access to numerous food options, perfect for those nights when you want to cook or don’t have time. For brunch with friends, try The Farm Cart, or for a relaxing evening with family, try Pho Tre Bien. You’ll find several restaurants nearby, such as:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/mountain-village-apts/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Your El Paso apartment home keeps you close to many popular shopping and entertainment destinations while preserving the gorgeous views of our mountainside community. Head down to the Coronado Shopping Center for all your home needs, while West Towne Marketplace to the north is the perfect place to shop for a new outfit, groceries, and much more. Once you’ve found everything you’re looking for, grab a cup of coffee from the nearby Starbucks, a relaxing lunch at Panera Bread, or explore these shopping and dining options near your home:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/patriot-apts/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>From fast food drive-thrus to date night spots, there’s no shortage of dining options near The Patriot. Catch a sports game while enjoying wings at The Shack or start your day with brunch at Grove Brunch Cafe, just two of the many eateries near our El Paso apartment community. You’ll also find a Starbucks coffee shop right down the street, ideal for a caffeine fix during your commute.</p>\n<p>Dining options near our apartments in El Paso include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/phoenix-apts/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">When you’re not enjoying a meal in <a href=\"/apartments/tx/el-paso/phoenix-apts/amenities\"><strong>your cozy El Paso apartment</strong></a>, you’ll find a wide variety of dining options nearby, ranging from fast food favorites to unique local restaurants. Enjoy classic Texas barbecue at Rudy’s, famous for their ribs and brisket, or try one of the unique sushi rolls at Kona Grill. Restaurants and dining establishments near The Phoenix include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/shadow-ridge-apts/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Locals across the area know that the eastside of El Paso is a central hub of shopping and dining destinations. Various shopping centers and malls are scattered throughout the region, including Cielo Vista and East Ridge. After your shopping trip, choose between multiple cuisines and restaurants, like Ruth’s Chris Steak House and The Melting Pot. Once the day is done, return home to your luxury apartment for a good night’s rest.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">You’ll find various restaurants near <a href=\"/apartments/tx/el-paso/the-crest/floor-plans\"><strong>our El Paso apartments</strong></a>, from popular chains to local eateries. Enjoy a signature sushi roll at Koze Teppan Grill, or try classic American dishes with a twist at Thyme Restaurant near our El Paso apartment community. Some other dining options near our El Paso apartment community include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/hewitt/icon-at-hewitt/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">Whether you’re craving a quick bite or a sit-down feast, Hewitt offers a diverse array of culinary delights to tantalize your taste buds. From cozy cafes to bustling bistros, your dining experience here promises to be nothing short of memorable.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">We all have nights when we just don’t want to cook dinner, or we need a quick breakfast on our way to work. When you live at our apartments in southwest Lubbock, you’ll find several dining options nearby, ranging from drive-throughs to sit-down restaurants. Whether you are looking for an elegant date night at Las Brisas Steakhouse or to cater a party with Crumbl Cookies, some nearby dining options include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><br/>Whether you’re a Lubbock resident or new to town, our southwest Lubbock apartment community is surrounded by an abundance of shopping opportunities. From the iconic South Plains Mall to bustling shopping centers like Canyon West, you’ll find everything you need just moments away. Explore a myriad of shops offering fashion, electronics, home goods, and more, ensuring that your shopping needs are always met. So, whether you’re browsing for the latest trends or searching for everyday essentials, the shopping scene near our community has something for everyone.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">You’ll find a wide variety of food options near Tuscany Place Apartments, whether you’re looking for a romantic spot for a date night or a quick drive-through option. Enjoy a night of culinary exploration at Double Nickel Steakhouse or a delicious meal from some of the Lubbock restaurants near our apartment community, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/temple/portico-at-friars-creek-apts/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Luckily for you, Temple, TX, is filled with quality shopping and dining options only a short drive from our community. From the many shopping centers in the area like Temple Mall  to the countless dining options fit for any palette, you can spend all day shopping and eating your way through town before returning to your apartment for a good night’s rest. Visit these shops near your new home:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p class=\"has-text-align-center\">When you don’t feel like cooking, you’ll enjoy a wide selection of Waco eateries, from fast food drive-thrus to upscale restaurants, all just a short drive from our Waco apartments. For a taste of Texas hospitality and mouthwatering steaks, Tejun the Texas Cajun-Robinson beckons with its hearty fare and lively atmosphere. Enjoy a mix of upscale and casual places to dine near your home, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/tuscany-ranch-apartments/neighborhood::propertyneighborhoodmap.food_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>From chains to local establishments, plenty of dining and shopping options are just a short drive from Tuscany Ranch Apartments. Enjoy a prime cut at Saltgrass Steakhouse, or if you are looking for a home-cooked meal, give Magnolia Market a visit for all your grocery needs. With numerous shopping districts and centers across Waco, you’ll never run out of fun and exciting places to stop by during your day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Living at the Arbors of Pleasant Valley not only comes with comfort and luxurious living, but it also comes with convenience and scenic surroundings. In our quiet suburban neighborhood near UAMS Hospital, we’re near all the shopping, dining, and entertainment you desire. Situated on Hinson Road near Pleasant Valley Country Club, we’re also located near plenty of schools and daycares perfect for your little ones.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/north-little-rock/lexington-park/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Lexington Park’s <a href=\"/apartments/ar/north-little-rock/lexington-park/floor-plans\"><strong>1-, 2-, and 3-bedroom apartments</strong></a> are in northern Little Rock, about a 15-minute drive from downtown. Near our Little Rock apartment community, you’ll find everything you’ll need daily, from local restaurants to family-friendly attractions. There are also several highly rated schools in the area so you can find the right fit for any student.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/maize/watercress-apartments/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The <a href=\"/apartments/ks/maize/watercress-apartments/pet-policy\"><strong>pet-friendly</strong></a> Watercress apartment community in Maize, KS, is the perfect blend of urban convenience and suburban charm near Wichita. Situated near various employers and educational institutions, such as the Wichita State University West location, residents and students benefit from an effortless commute.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our Wichita apartments are located on the west side of town, near several restaurants, stores, and schools. The numerous parks nearby, like Sedgwick Park, Swanson Park, and Brown Thrust Park, beckon residents to visit and enjoy the great outdoors. Wichita State University is also nearby, just a quick 15-minute drive from our apartments.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Cottages at Crestview’s <a href=\"/apartments/ks/wichita/cottages-at-crestview/floor-plans#/\"><strong>1-, 2-, and 3-bedroom apartments in eastern Wichita</strong></a> are located near Harrison Park, within reach of several shopping, dining, and entertainment venues. As one of the centers of aviation development, our Wichita apartments keep you close to McConnel Air Force Base, Spirit Aerosystems Holdings, and the Cessna Aircraft headquarters. Private and public elementary, middle, and high schools are just minutes from our Wichita apartments. Cottages at Crestview is an excellent option for those searching for apartments near Wichita State University, just a 10-minute drive away.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/crown-chase-apts/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Crown Chase Apartments are located near the desirable Westlink and Orchard Breeze neighborhoods. Just a short drive from our Wichita apartment community, unique local restaurants, shopping venues, and some of the city’s best attractions await your visit. Crown Chase keeps you close to Wichita’s center of the action with Textron Aviation, the Dwight D. Eisenhower National Airport, and many other major employers easily within reach, and with a variety of private and public schools nearby, it is a breeze to find the right fit for young students or those looking to continue their education.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/huntington-park/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Situated near the Westlink neighborhood, Huntington Park Apartments put you near all of what makes Wichita unique. Dining, shopping, and entertainment options are all just minutes away and highly rated schools for students of all ages, including Wichita State University, can also be found nearby.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/newport-wichita-apts/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find our apartment homes in northwest Wichita near other desirable neighborhoods, including Westlink, Orchard Breeze, and Orchard Park. Our proximity to Central Avenue gives you a distinct advantage through unparalleled access to the heart of Wichita, making fine dining, entertainment, and top-quality schools easily within reach.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/portofino/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><a href=\"/apartments/ks/wichita/portofino/floor-plans\"><strong>The Portofino apartment community</strong></a> is situated on the suburban western edge of Wichita near the intersection of K-96, U.S. Route 400, and Interstate 35. Our ideal location is a massive benefit for commuters and students seeking quick access to the center of town and Wichita State University, giving you multiple highway routes to the greater Wichita area only a few blocks from your door. From here, you can explore all the attractions and offerings our thriving community makes available to you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/raintree-apartments/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Located near the serene Orchard Breeze neighborhood, Raintree apartments in Wichita are convenient for various dining, shopping, and entertainment options. Additionally, several elementary, middle, and high schools are easily accessible, offering a family-friendly appeal. For outdoor recreation, Sedgwick County Park, located just two miles away, provides a delightful setting for enjoying the fresh air with friends and family.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/remington-wichita/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Situated near Bel Aire, The Remington offers <a href=\"/apartments/ks/wichita/remington-wichita/pet-policy\"><strong>pet-friendly</strong></a> apartments that provide a retreat from downtown Wichita while remaining conveniently close by. A quick drive will take you downtown for more urban adventures. For your shopping needs, the Bradley Fair Shopping Center is just a stone’s throw away, and various dining options, such as Wasabi East and Napoli Italian Eatery, are within a short distance, ensuring delicious cuisine is always at your fingertips.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/silver-springs-apts/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Numerous dining, shopping, and entertainment venues are near Silver Springs’s <a href=\"/apartments/ks/wichita/silver-springs-apts/pet-policy\"><strong>pet-friendly</strong></a> apartments in Wichita, KS, by the serene Central Bay neighborhood.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Villas of Waterford Apartments is in a prime location in Wichita, offering outstanding access to KS-96 and less than 10 minutes from Wichita State University. Numerous restaurants, retail shops, and businesses are active in the vibrant neighborhood near Cottonwood Village.<br/>From stocking up on essentials at Costco to shopping with friends at Northrock Center or enjoying a delicious meal with loved ones at Wasabi East, the countless options along North Rock Road and East 29th Street North keep residents entertained. Our<strong> </strong><a href=\"/apartments/ks/wichita/villas-of-waterford/floor-plans\"><strong>luxury 1- and 2-bedroom apartments in Wichita</strong></a> provide convenience and sophistication, catering to your preferences.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/belton/center-301/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Rapidly growing Belton is an ideal place to live with everything you could need to live a happy, fulfilling life—plentiful restaurants, shopping, and highly rated schools. Students and commuters will find a Starbucks and a Dutch Bros mere minutes from our Belton apartments for that early morning boost. Nearby grocery stores like Price Chopper and Hy-Vee make stocking the pantry easy. With Highway 71 nearby, you can reach Kansas City’s hot spots like The Plaza, Crossroads, and River Market in no time. We invite you to <a href=\"/apartments/mo/belton/center-301/contact-us\"><strong>tour Center 301 apartments</strong></a> and experience our ideal location firsthand.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/independence/the-adirondack/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Adirondack Apartments offers an outstanding apartment living experience to those seeking the perfect <a href=\"/apartments/mo/independence/the-adirondack/pet-policy\"><strong>pet-friendly apartment or townhome in Independence</strong></a>. Strategically located in Independence near I-70, our apartments and townhomes provide unparalleled convenience, just a short drive from downtown Kansas City and less than 10 minutes away from Independence Center.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/152-northland/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Whether you’re moving across town or across the country, our Kansas City apartments offer comfortable living within reach of everything you need. This starts with all the shopping stops on your errands list, from Sam’s Club and Sprout’s to Hy-Vee and Price Chopper.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/97-north-oak/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><a href=\"/apartments/mo/kansas-city/97-north-oak/floor-plans\"><strong>Our Kansas City apartments</strong></a> in Northland are centrally located near everything you need, from date night restaurants to peaceful parks. Downtown KC, River Market, Power and Light, and several other must-visit spots are an easy drive away along Highway 169. You can find a variety of shopping options nearby, from grocery stores to clothing outlets.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/mark-apts/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Living at The Mark Apartments puts you right in the middle of all there is to do in Ridgeland area. The surrounding neighborhood is an idyllic balance of a quiet suburban feel with enough hustle and bustle to provide excitement. In addition to several beloved chains and mom-and-pop restaurants, there are several recreational opportunities and events to explore. Beyond that, there are several high-quality schools and places to work nearby. <a href=\"/apartments/ms/ridgeland/mark-apts/contact-us\"><strong>Schedule a tour</strong></a> or take a virtual tour of our Ridgeland apartments on Lake Harbour Drive today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/sunchase-ridgeland-apts/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Situated near major roads and highways, including I-55, Sunchase Ridgeland Apartments is more than what’s on our property. It’s about exploring Ridgeland and the surrounding towns near you. Indulge yourself in the shopping, dining, and entertainment options at your fingertips. From the Renaissance at Colony Park to Holmes Community College, explore Ridgeland today and <a href=\"/apartments/ms/ridgeland/sunchase-ridgeland-apts/contact-us\"><strong>schedule a tour</strong></a> with us online!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/the-pointe-of-ridgeland/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Living at The Pointe of Ridgeland on Rice Road, you’ll enjoy the convenient location close to shops, dining, entertainment, and schools. When you live in an apartment on the reservoir, you can easily take a day trip to Ross Barnett Reservoir and admire nature’s beauty. Looking for a date night spot? Amerigo Italian and Local 463 are the hot spots and favorite restaurants you don’t want to miss out on.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/trace-apts/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our Ridgeland apartment community is just south of the heart of Ridgeland, near I-55 and Highway 51. Nearby, you’ll find many restaurants, stores, parks, and more. Old Trace Park, on the banks of Ross R. Barnett Reservoir, is less than four miles from our apartments in Ridgeland.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The peaceful suburb of Broken Arrow is an excellent place to live, offering suburban conveniences with proximity to all of the excitement of downtown Tulsa. Icon at Broken Arrow is near delicious dining options, convenient shops, fun attractions, and everything else you need in your daily life. When you don’t feel like taking advantage of <a href=\"/apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/amenities\"><strong>our community’s lux amenities</strong></a>, there’s always something to do in the neighborhood.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Broken Arrow, OK, offers a relaxing suburban escape from the bustle of nearby Tulsa. Strategically positioned, <a href=\"/apartments/ok/broken-arrow/park-at-mission-hills/floor-plans#/\"><strong>The Park at Mission Hills</strong></a> can be found next to Country Lane Estates north of Broken Arrow Expressway to give you unparalleled accessibility without the nuisance of road noise. Whenever you are looking for something good to eat, live entertainment, or local businesses to support, the entirety of Broken Arrow is at your doorstep, with downtown Tulsa just up the road.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/redbud-ranch/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our apartments near County Line Rd and Albany St. provide convenient access to Highway 51 and the Creek Turnpike. You can explore various dining options, from well-known fast food chains to distinctive local eateries near our North Broken Arrow apartments. Popular retail destinations such as Target, Sprouts Farmers Market, and Walmart Neighborhood Market are nearby, offering convenience for running errands.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>When you live at Scissortail Crossing Apartments in Broken Arrow, you can enjoy the best of both worlds. You can enjoy the natural beauty of Ray Harral Nature Park and skate near Nienhuis Park Community Center.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Whether you’re commuting for work or heading out for a weekend adventure, our proximity to Creek Turnpike means you can quickly get to where you need to go while still enjoying the tranquility of our quiet corner of town. This strategic location keeps the excitement and opportunities of Broken Arrow, from dining and shopping to entertainment and education, within easy reach of your apartment home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Villas at Aspen Park boasts a prime location just north of Rhema Park, providing easy access to OK-51. This bustling neighborhood, located just to the west of Southbrook, offers a variety of local and chain businesses that provide endless entertainment and engagement opportunities for Broken Arrow residents.<br/>Whether you need groceries from Aldi’s, enjoy shopping with your family at Woodland Hills Mall, or wish to have a delicious meal with friends at 50’s Diner, our <a href=\"/apartments/ok/broken-arrow/villas-at-aspen-park/pet-policy\"><strong>pet-friendly apartments in Broken Arrow</strong></a> offer the perfect combination of convenience and luxury.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/catoosa/bluffs-at-catoosa/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_neighborhood_blurb"
  },
  "apartments/ok/edmond/fountain-lake/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Fountain Lake’s convenient suburban location is the best of both worlds, offering the peace and quiet of nearby neighborhoods while remaining just 15 minutes away from the bright lights of Oklahoma City. A few miles away, Quail Springs Marketplace shopping center offers a wide range of shopping and dining options. In addition to major employers like Frontier City and Paycom just a short drive from your front door, there are also several highly rated elementary, middle, and high schools nearby to suit the needs of any student.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Villas at Stonebridge boasts an unbeatable location just northeast of Oklahoma State University, providing unparalleled access to US-77. This vibrant neighborhood is a bustling hub of activity, offering abundant local and chain businesses.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our relaxed community is situated near the southern edge of the Tulsa Metropolitan Area while keeping you close to the action through premium dining opportunities, commercial hot spots, and must-see attractions only minutes from home. Take the Okmulgee Expressway north for a straight shot to the heart of Tulsa or cross the river to be greeted by the River Spirit Casino Resort, a fine preview of the excitement that awaits in our vibrant community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/moore/mission-point/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Just a short drive south of downtown Oklahoma City, you can find <a href=\"/apartments/ok/moore/mission-point/amenities\"><strong>Mission Point’s luxury apartments</strong></a> near 19th Street and Interstate 35 by looking for our signature masonry and bright red tiled roofs. Our cozy corner of paradise by the highway opens up a world of possibilities in entertainment, shopping, and fine dining. We are surrounded by a range of nearby restaurants and shops, and with all the excitement of greater Oklahoma City easily within reach from your Mission Point apartment home, you can immerse yourself in the city’s culture and quickly become a member of the local community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/artisan-crossing-apts/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>You’ll find our apartments near OU less than five miles from campus and downtown Norman, near several restaurants, stores, and other essentials. Head down the street for El Huevo Mexi-Diner, where you’ll find fresh breakfast options and unique cocktails, or stop by Starbucks for a caffeine boost. You can always find what you need at grocery stores, shopping malls, and local boutiques nearby.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Cimarron Trails is located on the northern side of Norman, surrounded by restaurants, shops, schools, and more. When you need a change of scenery, the exciting and noteworthy attractions in Oklahoma City are just a 30-minute drive away via Interstate 35.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our upscale apartments are ideally located near the Quail Ridge neighborhood, just a quick drive from downtown Oklahoma City. In our peaceful neighborhood, you’ll find culinary delights, unique shops, fun attractions, excellent schools, and lots more. Shopping runs and quality time with friends and loved ones are always within reach at 24Hundred.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Chisholm Pointe is a wonderful <a href=\"/apartments/ok/oklahoma-city/chisholm-pointe/pet-policy\"><strong>pet-friendly community located in Oklahoma City</strong></a>. We offer a variety of duplexes and quadplexes to choose from. Our community is conveniently situated near the Stonegate neighborhood, providing easy access to John Kilpatrick Turnpike and Lake Hefner.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our Oklahoma City apartments and townhomes are northwest of downtown, near desirable suburbs like Warr Acres and Bethany. With unique restaurants and popular chains nearby, finding a good meal near Cimarron Pointe is simple. Retail outlets like Walmart Supercenter and Kohl’s are just minutes away, making errand days a cinch. Several public and private schools are situated within proximity to our Oklahoma City apartments as well, enabling you to find the right fit for students of any age. We invite you to <a href=\"/apartments/ok/oklahoma-city/cimarron-pointe-apts/contact-us\"><strong>schedule a tour</strong></a> and experience our location firsthand. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Located near the peaceful Northaven neighborhood, Council Place Apartments in Oklahoma City is conveniently located near dining, shopping, and entertainment venues. Our town is home to several major employers, including the headquarters for Paycom and INTEGRIS Health’s corporate offices. These are well within reach, with easy access to Northwest Expressway and the John Kilpatrick Turnpike from your apartment home. Also nearby are several elementary, middle, and high schools, and just a few miles away, Bluff Creek Park offers hiking and biking paths and covered pavilions where you can enjoy fresh air.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>You’ll find Cross Timber’s <a href=\"/apartments/ok/oklahoma-city/cross-timber/floor-plans\"><strong>2- and 3-bedroom apartments</strong></a> south of downtown Oklahoma City in the desirable Lakeridge Run neighborhood. We’re a short commute for downtown employees and conveniently located for Will Rogers Airport employees. OKC’s bright lights and premier attractions are well within reach of our ideal location, yet your apartment home serves as a retreat from the hustle and bustle of the metro. When you want to get out of your apartment, dine at one of the nearby restaurants or indulge in a little retail therapy by visiting one of the various nearby retailers.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Near the Warwick Village neighborhood and The Village, Crown Pointe’s <a href=\"/apartments/ok/oklahoma-city/crown-pointe-apartments/floor-plans\"><strong>1- and 2-bedroom apartments</strong></a> are located northwest of downtown OKC. You’ll never be far from a scenic natural retreat just north of Bluff Creek Park and scenic Lake Hefner. There’s also a wide selection of dining and shopping options nearby so you can easily finish your errands.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Hunter’s Ridge Apartments are located northwest of downtown Oklahoma City, just west of scenic Lake Hefner. Numerous dining, shopping, and entertainment venues are available nearby, making it easy to enjoy every day. There are also many highly rated schools near our apartments in Oklahoma City, allowing you to find a good fit for students of any age. See our location firsthand by <strong><a href=\"https://app.tour24now.com/prospect/tour/hunters-ridge/register/\" target=\"_blank\">scheduling a tour of Hunter’s Ridge</a></strong>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter's-ridge-apts/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Hunter’s Ridge Apartments are located northwest of downtown Oklahoma City, just west of scenic Lake Hefner. Numerous dining, shopping, and entertainment venues are available nearby, making it easy to enjoy every day. There are also many highly rated schools near our apartments in Oklahoma City, allowing you to find a good fit for students of any age. See our location firsthand by <strong><a href=\"https://app.tour24now.com/prospect/tour/hunters-ridge/register/\" target=\"_blank\">scheduling a tour of Hunter’s Ridge</a></strong>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/park-at-tuscany/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Just a short drive north of the intersection of John Kilpatrick Turnpike and Lake Hefner Parkway, The Park at Tuscany offers the quiet suburban environment of north Oklahoma City while maintaining unmatched access to the cultural, educational, and commercial centers of activity in this bustling community. Find everything you need, from groceries to golfing at premier OKC destinations like the Gaillardia Golf Club and Quail Springs Mall, both only a few minutes away.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/persimmon-square-apartments/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>In the vibrant Oklahoma City community near Camelot Estates, you’ll discover an array of conveniences just a stone’s throw away, including delightful restaurants and picturesque parks. The Quail Springs Mall, ALDI, and Uptown Grocery Co. are nearby for fantastic shopping options. For outdoor enthusiasts, stroll around Lake Hefner or explore the scenic Duffner Park.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>With a variety of dining, shopping, and entertainment options nearby, Prairie Springs boasts a prime location for those seeking a dynamic lifestyle in OKC. Our ideal position near the Northwest Expressway keeps the greater OKC area within an easy drive from your home, opening up a world of cultural, culinary, and commercial exploration.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/stonehorse-crossing/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Just minutes away from the vibrant heart of Oklahoma City, Stonehorse Crossing gives you a high degree of convenience accessibility with a wealth of entertainment, dining, and shopping options nearby. A vast collection of shopping options await at Quail Springs Mall to the south and an array of local restaurants allow you to enjoy every flavor of Oklahoma City’s famed culinary and cultural scene.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summerfield-place-apts/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience the convenience of Summerfield Place’s <a href=\"/apartments/ok/oklahoma-city/summerfield-place-apts/pet-policy\"><strong>pet-friendly apartments</strong></a>, which are close to Mercy Hospital Oklahoma City and provide easy access to all Oklahoma City offers.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summit-ridge-villas/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Chisholm Pointe is a wonderful <a href=\"/apartments/ok/oklahoma-city/chisholm-pointe/pet-policy\"><strong>pet-friendly community located in Oklahoma City</strong></a>. We offer a variety of duplexes and quadplexes to choose from. Our community is conveniently situated near the Stonegate neighborhood, providing easy access to John Kilpatrick Turnpike and Lake Hefner.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summit-ridge-villas/summit-villas/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Chisholm Pointe is a wonderful <a href=\"/apartments/ok/oklahoma-city/chisholm-pointe/pet-policy\"><strong>pet-friendly community located in Oklahoma City</strong></a>. We offer a variety of duplexes and quadplexes to choose from. Our community is conveniently situated near the Stonegate neighborhood, providing easy access to John Kilpatrick Turnpike and Lake Hefner.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/tammaron-village-apartments/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Conveniently situated in northwest Oklahoma City, Tammaron Village Apartments offers easy access to a variety of dining, shopping, and entertainment venues and top-rated schools and colleges.<br/>Our <a href=\"/apartments/ok/oklahoma-city/tammaron-village-apartments/pet-policy\"><strong>pet-friendly</strong></a> apartments are located near the Beacon Hill neighborhood, providing an ideal location for residents. <a href=\"#schedule-a-tour\"><strong>Schedule a tour</strong></a> today to explore our Oklahoma City apartments for rent near the Wiley Post Airport, just minutes away from Northwest Expressway, ensuring a seamless commute experience.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/warrington-apartments/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore our <a href=\"/apartments/ok/oklahoma-city/warrington-apartments/pet-policy\"><strong>pet-friendly</strong></a> apartments in Oklahoma City, conveniently located near Lake Hefner and Mercy Hospital. Our residences are close to schools, dining establishments, shopping centers, and local attractions, ensuring easy access to everyday necessities via John Kilpatrick Turnpike.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Living at Waters Edge isn’t just about enjoying a comfy apartment with all the <a href=\"/apartments/ok/oklahoma-city/waters-edge-apartments/amenities\"><strong>luxuries of home</strong></a>—it’s about enjoying the bustling urban neighborhood just outside your window. With quick access to I-44, I-40, and Highway 152, Oklahoma City is at your fingertips. Enjoy a handcrafted burrito at Tacoville, take a stroll at nearby Tulsa Park, or hop on the road for a trip to the State Fair Grounds. <a href=\"/apartments/ok/oklahoma-city/waters-edge-apartments/contact-us\"><strong>Schedule a tour</strong></a> at Waters Edge to learn more.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/coffee-creek/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Coffee Creek’s <a href=\"/apartments/ok/owasso/coffee-creek/floor-plans\"><strong>1- and 2-bedroom apartments</strong></a><strong> </strong>offer a lavish residential experience in northern Owasso with all the conveniences of the greater Tulsa area just a short trip from your front door. Our ideal position keeps our community within arm’s reach of Highway 169 but with just enough distance so that road noise is not an issue. Explore the delightful eateries and shops in Owasso, or take a trip down into the city at your convenience to experience the broad range of services and attractions available near your apartment at Coffee Creek.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our <a href=\"/apartments/ok/owasso/cottages-at-tallgrass-point/floor-plans\"><strong>1- and 2-bedroom apartments</strong></a> offer a luxurious residential experience in northern Owasso, with the allure of the greater Tulsa area just a short trip from your doorstep. Explore the local charm of Owasso’s delightful eateries and shops, or venture into the heart of Tulsa to dive into the iconic blend of Midwestern and Southern culture you can only find here in the heart of Oklahoma.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cypress-crossing/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Living comfortably is easy in our apartment community at the center of northern Owasso. We’re conveniently close to Highway 169 but still far enough from the noise of the busy roads, with the heart of Owasso practically a stone’s throw away. Enjoy gourmet dining at top-quality restaurants, entertaining attractions for the whole family across town, and shopping at one of our many local options for groceries, clothing, and all the essentials.<br/></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/pryor/west-530/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Enjoy relaxed, small-town charm with modern conveniences when you live at West 530 Apartments in Pryor, OK. With a cozy home not far from Highway 69, you can live comfortably in a quiet community while staying close to Pryor, Claremore, and the greater Tulsa metropolitan area.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/stillwater/apple-creek-stillwater/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><a href=\"/apartments/ok/stillwater/apple-creek-stillwater/floor-plans\"><strong>Apple Creek’s apartments</strong></a> near OSU let you take advantage of everything Stillwater offers. Our Stillwater apartment community is just a quick drive away from stores, restaurants, attractions, and just about anything else you could need to enjoy each day. From running errands to going out with friends, our apartments’ central location puts everything within reach.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/barrington-apartments/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Just a short drive from downtown, Barrington Apartments are located in south Tulsa near Broken Arrow. Whether you’re running errands, grabbing dinner with friends, or heading to a night out on the town, the neighborhood has everything you need. The next time you’re in the mood for a little retail therapy, take the quick five-minute drive to Woodland Hills Mall, where you’ll find nearly 150 stores. When you’re hungry and don’t want to cook, try one of the several restaurants nearby. <strong><span style=\"text-decoration: underline;\"><a href=\"#schedule-a-tour\">Schedule a tour</a></span></strong> of our apartments in south Tulsa and explore our ideal location.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cascata-luxury-apartments/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>South of downtown Tulsa, you’ll find our <a href=\"/apartments/ok/tulsa/cascata-luxury-apartments/floor-plans\"><strong>1- and 2-bedroom apartments</strong></a> tucked away near the Woodland and South Towne Square neighborhoods. When you’re searching for a good meal, head to one of the many restaurants near our Tulsa apartments, which include everything from familiar fast food chains to unique local favorites. Nearby stores like Target, Sam’s Club, and Best Buy make running errands a cinch.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-glade-apts/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Cedar Glade’s <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/apartments/ok/tulsa/cedar-glade-apts/floor-plans\"><strong>1-, 2- and 3-bedroom apartments</strong></a> are located in south Tulsa, southwest of Woodland Hills Mall and north of Tulsa Community College’s Southeast Campus. Our Tulsa apartments are surrounded by schools, restaurants, shopping, and attractions, making it easy to find what you need nearby. When you’re looking for something to do on a Friday night or weekend, take the quick five-minute drive to Cinemark Tulsa and IMAX and sit back in a reclining lounger while watching the latest film.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Tucked away from the heart of Tulsa, <a href=\"/apartments/ok/tulsa/cedar-ridge-apartments/floor-plans\"><strong>Cedar Ridge</strong></a> offers all the benefits of being close to the metro combined with suburban convenience. Commuters and students alike can benefit from a streamlined commute thanks to our proximity to several employers and schools, like Tulsa Community College-Southeast Campus. When you need new clothes or a gift for a friend, you can find Woodland Hills Mall close at hand, with over 100 stores to peruse.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Look for the Chardonnay Apartments in south Tulsa, near desirable neighborhoods like Burning Tree and South Towne Square. Whenever you crave the exciting atmosphere of Tulsa, downtown is only around 15 minutes away. Restaurants, shopping, and attractions surround our <a href=\"/apartments/ok/tulsa/chardonnay/pet-policy\"><strong>pet-friendly Tulsa apartments</strong></a>, so there’s always something to do nearby. Plus, with top-rated schools just minutes away, students can earn an excellent education.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Located at the intersection of 81st and Yale, our community’s advantageous position presents all the attractions and must-see destinations of greater Tulsa right outside your door. Our proximity to Oral Roberts University and Tulsa Community College makes our community an ideal choice for students looking for a comfortable, reasonably priced community near campus, while our position near Riverside Parkway keeps the commercial heart of town well within reach.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/creekwood-apartments/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Nestled in the peaceful Woodland neighborhood, Creekwood’s<a href=\"/apartments/ok/tulsa/creekwood-apartments/floor-plans\"><strong> 1- and 2-bedroom apartments </strong></a>offer a retreat from downtown Tulsa, yet remain just a quick drive away from the metro. Over 100 stores await you at the nearby Woodland Hills Mall, and delicious cuisine is always within reach at restaurants like Le Louvre French Cafe and Brook South. The several nearby schools ensure that all students can find a great fit.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/nickel-creek-apts/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Nickel Creek we want you to enjoy more than just your apartment unit. Located in south Tulsa, we’re a short drive from plenty of bars, restaurants, and attractions around the city. Have fun with friends at Main Event Tulsa, spend an evening at Tulsa Spotlight Theater, or catch your favorite artist at the BOK Center. No matter how you choose to spend your time, you’ll always have a welcoming space to come home to. Take a <strong><a href=\"https://app.tour24now.com/prospect/tour/nickel-creek/register/\" target=\"_blank\">self-guided tour of Nickel Creek Apartments</a></strong> to learn more about our community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/polo-run-apartments/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Polo Run apartments, you can savor all that Tulsa offers. Our convenient proximity to stores, restaurants, attractions, and essential amenities ensures that everything you need is just a short drive away. The central location of our apartments simplifies errands and social gatherings, offering you easy access to the best of the city.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our vibrant Tulsa community offers a plethora of amenities for daily living. From delightful local dining spots to picturesque parks, residents can easily access everything they need. The Sheridan Pond neighborhood boasts a range of local employers, such as hospitals and universities, along with schools within the Union Public Schools district, providing convenient options for work and education.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Situated a brief drive from downtown and less than 10 minutes from Sem Group Corporation and the NORDAM Group Repair Division, Sugarberry Apartments offers a prime location in south Tulsa near Broken Arrow. This vibrant neighborhood caters to all your needs, whether you’re running errands, dining out with friends, or enjoying a night on the town.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our <a href=\"/apartments/ok/tulsa/sunchase-apartments/pet-policy\"><strong>pet-friendly</strong></a> Sunchase apartments in south Tulsa offer easy access to the city’s vibrant downtown scene with just a short drive. Nearby our Tulsa apartments, you’ll discover various restaurants, schools, shops, parks, and all the essentials for your daily routine. Thanks to our proximity to Highway 169 and Creek Turnpike, commuting to prominent locations like the Sem Group Corporation for work is effortless and efficient.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Courtyards of Tulsa apartment community is located south of the Tulsa metro area, not far from Jenks and Broken Arrow. Located in the desirable Chimney Hills neighborhood, our <a href=\"/apartments/ok/tulsa/the-courtyards/floor-plans\"><strong>1- and 2-bedroom apartments</strong></a> are surrounded by everything you could need: grocery stores, clothing outlets, restaurants, and so much more. Excellent schools for students of all ages can also be found near Courtyards apartments in Tulsa.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Located south of downtown Tulsa, near Broken Arrow, The Greens of Bedford Apartments are just a quick drive away from several dining, shopping, and entertainment options, and highly rated schools and colleges. The Greens of Bedford Apartments are just minutes from Highway 64, making your commute to ONEOK Inc. or one of the many other businesses based downtown a breeze. Experience our ideal location firsthand by <strong><a href=\"https://app.tour24now.com/prospect/tour/greens-of-bedford/register/\" target=\"_blank\">s</a></strong><a href=\"/apartments/ok/tulsa/the-greens-of-bedford/contact-us\"><strong>cheduling a tour of our Tulsa apartments</strong></a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Situated near Hillcrest Hospital and the Woodland Hills and Burning Tree neighborhoods, the <a href=\"/apartments/ok/tulsa/windsail-apartments/pet-policy\"><strong>pet-friendly</strong></a> Windsail Apartments on 71st and Mingo offers proximity to Tulsa’s top attractions, charming local eateries, and convenient shopping destinations. With close access to private and public schools, Windsail simplifies the process of selecting the perfect educational environment for young learners or individuals seeking to advance their studies.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Park on Westpointe sits right at the gate to greater Oklahoma City near I-40. Ideal for residents seeking a quick commute to downtown, our apartments in Yukon are ideally situated and surrounded by quaint local eateries, beautiful parks, and must-see attractions that locals and visitors love.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/the-ridge-@-66/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our calm apartment community on the edge of Lake Overholser presents a relaxed living environment that keeps you close to all of Yukon and greater OKC’s attractions. Located just a stone’s throw away from the intersection of Interstate 344 and the historic Route 66 highway, the accessibility offered by Ridge at 66 is hard to beat.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our apartment community in southwest Amarillo is ideally located. Those looking for a quiet home that is separated from the bustle of the downtown can enjoy a superior home that is only a short drive from highly rated schools, fine and casual dining, and the distinct blend of Texan culture that gives Amarillo its charm.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Few cities epitomize the Texas panhandle quite like Amarillo. Home to one-of-a-kind attractions like The RV Museum and Cadillac Ranch and a top-notch culinary scene, Amarillo presents decades of American culture for you to explore and enjoy when you make your home at Park at Coulter Apartments.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Located near Soncy Road and I-40, the <a href=\"/apartments/tx/amarillo/remington-amarillo-apts/floor-plans\"><strong>Remington Apartments</strong></a> are conveniently situated near plenty of dining, shopping, and entertainment options. When looking for date night spots, couples enjoy Saltgrass Steak House for dinner or brunch at Butterlove Biscuits. Take in the beautiful flowers at Amarillo Botanical Gardens, catch the newest movie at Cinemark, or indulge in a shopping trip at Westgate Mall, all located in close proximity to your new home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>This vibrant neighborhood and the greater Amarillo area is teeming with exhilarating activities, captivating destinations, and opportunities for personal growth. Living in this community unlocks a world of possibilities so you’ll never be bored. The Colonies at Hillside is conveniently located near I-40, I-27, and other major roads, so you can live the life you want. <a href=\"/apartments/tx/amarillo/the-colonies-at-hillside/contact-us\"><strong>Take a tour</strong></a> in person or through a virtual experience, and find your ideal lifestyle!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Winchester apartment community offers a prime location in the vibrant Amarillo neighborhood near Puckett and Olsen. Our <a href=\"/apartments/tx/amarillo/winchester-apartments/pet-policy\"><strong>pet-friendly</strong></a> apartments near Sleepy Hollow provide easy access to essential amenities such as grocery stores, retail shops, and dining options. Additionally, Winchester Apartments in Amarillo is near top-notch schools catering to students of all ages.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/acacia-park-apts/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Acacia Park is ideally located near North Mesa Street and offers apartments in the Upper Mesa Hills neighborhood. The nearby community has something for everyone, from family-friendly fun to swanky bars. Outdoor lovers will enjoy hiking opportunities near our El Paso apartment community, from the Franklin Mountains to Resler Canyon. <a href=\"/apartments/tx/el-paso/acacia-park-apts/contact-us\"><strong>Schedule a tour</strong></a> today to explore our apartment community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/chimneys-apts/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>When you rent an apartment at The Chimneys in West El Paso, you’ll only be a short drive away from the town’s major attractions and events. Whether you go out to Franklin Mountains State Park, get your game on at TopGolf, or visit the Shoppes at Solana or any of El Paso’s shopping districts, you’ll never run out of things to do in town. After all is said and done, you will have a welcoming place to return to at The Chimneys Apartments. <a href=\"/apartments/tx/el-paso/chimneys-apts/contact-us\"><strong>Schedule your tour</strong></a> at our west El Paso apartments today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our Double Tree Apartments near Mesa Hills put you near various attractions, restaurants, and parks. You can hike the Franklin Mountains, catch a movie at Alamo Drafthouse Cinema Montecillo, or glide through the mountains at Wyler Aerial Tramway. Excellent nearby school districts also ensure learning opportunities for those with children or prospective college students.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>There’s no shortage of fun activities, dining, and entertainment options near our <a href=\"/apartments/tx/el-paso/high-ridge-apts/floor-plans\"><strong>East El Paso 1- and 2-bedroom apartments</strong></a>. With our proximity to I-10 and US-78, you’ll find family-friendly entertainment, like El Paso Zoo and Botanical Gardens, and great options for date nights, like The Melting Pot. Living at High Ridge puts you next to it all.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/mountain-village-apts/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Living at Mountain Village Apartments in El Paso opens the door to all the city offers. The neighborhood and greater El Paso area are full of exciting things to do, interesting places to visit, and opportunities to build a better future for yourself and your loved ones. With I-10 just minutes away and other major roads within a short distance, there are no boundaries to the life you can live at Mountain Village. <a href=\"/apartments/tx/el-paso/mountain-village-apts/contact-us\"><strong>Schedule a tour</strong></a> or take a <strong><a href=\"https://app.tour24now.com/prospect/tour/mountain-village/register/\" target=\"_blank\">self-guided tour</a></strong> today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/patriot-apts/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>When you live in our El Paso community, you’ll find everything you need nearby for day-to-day life, from charming local restaurants to gorgeous parks. Our apartments near Fort Bliss are ideal for military service members and their families. Want to spend time in the great outdoors? Head to Franklin Mountain State Park nearby, where you’ll find over 24,000 acres of land ripe with hiking, biking, climbing, and sightseeing opportunities.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/phoenix-apts/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Located in southeast El Paso, the Phoenix apartments are only a short drive from everything downtown offers. Near our El Paso apartments, you will find restaurants, schools, shops, parks, and just about anything else you need in your day-to-day life. Thanks to our proximity to I-10, you’ll enjoy a simple commute to work or school.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/shadow-ridge-apts/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>While a comfortable apartment near Fort Bliss can be a luxury in itself, there’s much more to the area. A plethora of attractions and events are just a short distance away from your east El Paso apartment. With I-10 and Loop 375 nearby, you can easily reach these destinations in just a few minutes. Take a further look into the area by <a href=\"/apartments/tx/el-paso/shadow-ridge-apts/contact-us\"><strong>scheduling your apartment tour</strong></a> at Shadow Ridge today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Sunny El Paso is a city like no other, featuring rich culture and history seamlessly blended with modern touches. Nature lovers adore El Paso’s gorgeous natural scenery and hiking, biking, and camping opportunities. Foodies and culinary enthusiasts delight in El Paso’s unique cuisine, whether enjoying a steak at the nationally recognized Cattleman’s Steakhouse or sipping on a margarita at ELEMI. When you choose The Crest, you’ll be close to the parks, attractions, and shops that bring El Paso to life.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/hewitt/icon-at-hewitt/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Apartment living at Icon at Hewitt doesn’t end once you step off-site. You have easy and reliable access to a bustling and lively community in West Waco and Hewitt, TX. By hopping onto I-35 or the other major roads and highways near our apartment community, you’ll reach a whole world of dining, shopping, and entertainment. <a href=\"/apartments/tx/hewitt/icon-at-hewitt/contact-us\"><strong>Schedule your tour</strong></a> online to learn more about our neighborhood today.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>You’ll find our Lubbock apartment community located in south Lubbock, near Loop 289 and Slide Road. Some neighborhoods near our apartments include Abbey Glen, Lake Ridge, Vintage Township, and The Falls. We’re also near numerous dining and entertainment options and schools. If you’re in need of student housing, keep our apartments near Texas Tech University in mind!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Get to know Lubbock—where there’s much more to explore than just your apartment. You’ll be just a short drive from the town’s unique attractions and events when renting at The Icon at Lubbock near Wolfforth. Shop at West End Center, The Hub, or Canyon West Shopping Center and return home to decorate your living spaces, fill your closet, and make a meal your friends and family are sure to remember.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Tuscany Place’s Lubbock apartment community is located near Lubbock’s best neighborhoods and just a quick drive from the heart of the city. We’re also a great option if you’re looking for an apartment in Wolfforth, which is less than a ten-minute drive from our apartment community. We also offer apartments near Texas Tech, less than 10 miles away.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/temple/portico-at-friars-creek-apts/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>When you’re looking for an apartment to rent in Temple, TX, don’t just look at what’s on the property. Temple is a lively town with a plethora of fun attractions and activities to do. With Portico at Friars Creek right next to several major streets and highways, you have reliable access to the many attractions and landmarks of Temple, TX, such as the Temple Mall, Mary Alice Marshall Performing Arts Center, and Temple College. <br/><a href=\"/apartments/tx/temple/portico-at-friars-creek-apts/contact-us\"><strong>Schedule your tour</strong></a> to further explore the area today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our apartments in Waco are in the perfect location, not far from downtown and near several great neighborhoods. Even if you’re not a resident of Waco, we’re a great option if you’re looking for apartments in Beverly Hills, TX, or Robinson, TX. Our apartments in New Road are situated in south Waco, chock full of dining, entertainment, shopping, and great schools. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/tuscany-ranch-apartments/neighborhood::propertyneighborhoodmap.intro_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Close to I-35, our South Waco apartments are conveniently located for you to explore the neighborhood with no hassle. From the numerous shopping and entertainment options to a meal at one of the many nearby restaurants, you can enjoy apartment living to its fullest even when you’re off the property. <a href=\"/apartments/tx/waco/tuscany-ranch-apartments/contact-us\"><strong>Schedule your tour</strong></a> online to further explore the area today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>When you have school-aged children, it can be hard to find a school near your home that you can rely on. Fortunately, there are plenty of top-rated schools in the Pleasant Valley area for you to choose from that are all just a short drive away from the Arbors of Pleasant Valley Apartments.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/north-little-rock/lexington-park/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Whether you have children or are seeking continued education for yourself, there’s no shortage of schools near our North Little Rock community. Nearby institutions include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/maize/watercress-apartments/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Situated close to schools, the Watercress Apartments offers residents many educational opportunities. These nearby academic institutions, encompassing two-year and four-year colleges, cater to various academic needs.</p>\n<p>Residents benefit from the array of available public and private educational options and choices for higher education. The Maize area fosters a supportive learning environment, ideal for individuals who prioritize academic excellence and value education. These institutions include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>An excellent education is within reach for students of all ages when you live here at Aspen Park. There are numerous schools and educational institutions just a short drive away from our apartments, from elementary schools to college campuses. Some schools you can find near our Wichita apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our apartments near Wichita State University are just a short drive from excellent elementary, middle, and high schools. Whether you’re looking for a private institution or public school, it’s easy to find an excellent fit for students of any age nearby. Schools near our apartment community include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/crown-chase-apts/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>There are many private and public schools near our Wichita apartments, making it easy to find a good fit for any student. Along with elementary, middle, and high schools, you’ll find two- and four-year colleges near Crown Chase apartments. Schools near our Wichita apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/huntington-park/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Near Huntington Park Apartments, you’ll find some of Wichita’s top elementary, middle, and high schools, making it easy for any student to find the right school. You’ll also find a selection of two- and four-year colleges nearby. Wichita schools near Huntington Park Apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/newport-wichita-apts/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Finding the right school for students of all ages is an important decision. Luckily, many schools around Newport Apartments provide quality education for elementary, middle, and high school students, all of which are only a quick drive away. Wichita is home to several centers of higher education in a range of disciplines so every resident has access to top-tier schools, regardless of age. You can find these schools near our apartment community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/portofino/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Choosing the right school for your family is a crucial decision, and residents of Portofino in Wichita have access to a variety of educational options to suit their needs. Whether you’re looking for highly rated public schools, prestigious private academies, or specialized programs, you’ll find them all within reach of our community. You have a wide range of choices, including these notable schools near Portofino:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/raintree-apartments/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The elementary, middle, and high schools near our Wichita apartment community offer diverse educational options to cater to the needs of every student. Additionally, Raintree Apartments is conveniently located near several two-year and four-year colleges, providing further educational opportunities for residents. Near our Wichita apartments, you’ll find the following schools:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/remington-wichita/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Residents can enjoy the convenience of having elementary, middle, and high schools within a short distance of The Remington Apartments, ensuring accessibility to quality education for students of all ages.</p>\n<p>Additionally, proximity to two-year and four-year colleges allows for further education. The abundance of educational resources in northeast Wichita enables residents to fulfill their learning endeavors.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/silver-springs-apts/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Within our Wichita apartment community, you will find a diverse selection of elementary, middle, and high schools catering to students of all ages. Moreover, Silver Springs Apartments are conveniently situated near a range of two-year and four-year colleges, providing educational opportunities for students pursuing higher education. Explore the academic institutions near our apartments in Wichita.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our Wichita apartment community is perfect for students seeking unparalleled educational opportunities. We’re ideally situated within 10 minutes of Wichita State University and 15 minutes from Butler Community College. The Villas of Waterford boasts proximity to a diverse range of public schools, including elementary to high schools and two-year to four-year colleges.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/belton/center-301/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Cedar 301 Apartments in Belton are just a quick drive away from highly rated public and private schools. It’s easy to find the right fit for students of all ages, with elementary, middle, and high schools, as well as two- and four-year colleges nearby:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/independence/the-adirondack/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>If you’re looking for a place that allows you to pursue your academic dreams to the fullest, the Adirondack Apartments is the ideal choice for you. Our apartment and townhome community is conveniently located in Independence near several public and private schools, including elementary, middle, and high schools, two-year colleges, and four-year colleges. Our apartment community’s ideal location provides students of all ages with exceptional educational opportunities.</p>\n<p>Additional schools nearby include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/152-northland/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Northland is one of the best places for families to live in Kansas City’s metropolitan area, and its many great schools are a major reason why. Whether you prefer public school or private institutions, some of the best schools in Kansas City are located near 152 Northland. Schools near our apartment community include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/97-north-oak/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Excellent schools surround our apartments in Kansas City, making it simple to find an ideal learning environment for students of all ages. Whether you prefer a public school or a private institution, you will find a good fit near 97 at North Oak. Kansas City schools near our apartment community include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/mark-apts/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>One of the most important things to consider when deciding where to live is the area’s schools, whether you’re a parent, starting a family, or looking to go back to school yourself. The Mark is very close to some of the top schools in Ridgeland and is an especially popular pick for apartments near Holmes Community College, as we’re about 10 minutes away from campus. Since we’re right off I-55 and I-220, it’ll be an easy drive home when leaving one of these nearby schools, among others:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/sunchase-ridgeland-apts/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>As the school year approaches, you’ll want to ensure your kids attend good schools. When you live at Sunchase Ridgeland Apartments, you can send your child to preschool through college without having to move and leave your Ridgeland apartment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/the-pointe-of-ridgeland/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>If you have school-aged children, you’ll have no problem finding a school for them to attend near The Pointe of Ridgeland in Madison County. From daycares to high schools and community colleges, you’re never too far from a good education!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/trace-apts/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>A quality education near your home is one of the most important factors to consider as you choose where to live. If you’re a parent to a young student or pursuing postsecondary education, you’ll love that our apartments in Ridgeland are near several great schools, such as:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find a great school for a student of any age near Icon at Broken Arrow. Both private and public elementary, middle, and high schools are just minutes away from our apartment community. There are also two- and four-year colleges a short commute away. Schools near Icon at Broken Arrow include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Education is always a top priority for anyone moving to a new community. Fortunately, Broken Arrow is home to various top-quality schools catering to students of all ages and abilities. Find the ideal education match for you or your family at one of these highly rated schools in Broken Arrow and Tulsa, only a short drive away.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/redbud-ranch/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>As a resident of Redbud Ranch, you benefit from convenient access to various educational institutions. Schools, colleges, and universities nearby include North Broken Arrow Public Schools, Rhema Bible Training College, NSU College of Extended Learning, and The University of Tulsa. Redbud Ranch Apartments is close to the following academic institutions:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>With many outstanding schools nearby, Scissortail Crossing is an ideal residence for students across all age groups. Various educational opportunities are near our Broken Arrow apartment community, including early childhood education centers, universities, and community colleges. Among the academic institutions nearby are:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Education is a priority, and Trails at Aspen Creek is situated near some of the best schools in the area. Younger students can attend Arrowhead Elementary School or Indian Springs Elementary School, both known for their strong academic programs and dedicated staff. Centennial Middle School and Oliver Middle School provide a supportive environment for middle schoolers, while high school students benefit from the comprehensive academic offerings and extracurricular activities at Broken Arrow High School and Union High School.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Villas at Aspen Park is an exceptional choice for parents and students of all ages seeking an outstanding educational experience in Broken Arrow. Our apartment and loft community is strategically positioned within  20 minutes of some of the region’s most renowned higher education institutions, including the University of Tulsa, the University of Oklahoma Tulsa, and Oklahoma State University Tulsa. Our location is ideal for accessing varied public and private schools, from elementary schools to four-year colleges.</p>\n<p>Additional schools near our Villas at Aspen Park apartment community are:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/fountain-lake/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Students of all ages will benefit from living near the Edmond School District, one of Oklahoma’s highest-rated school districts. Private and public elementary, middle, and high schools can be found near Fountain Lake Apartments, making it easy to find the right fit for any student. There’s also a selection of two- and four-year colleges within reach. Schools near Fountain Lake Apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Villas at Stonebridge offers unbeatable educational opportunities for students of all ages. Our Edmond apartment community is located within 10 minutes of the prestigious University of Central Oklahoma and five minutes of Oklahoma Christian University. Our community is also conveniently situated close to a selection of public and private schools, ranging from elementary schools to four-year colleges.</p>\n<p>Additional notable schools and colleges located near our Edmond apartment community include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Education is a top priority for many of our residents. <a href=\"/apartments/ok/jenks/the-reserve-at-elm/floor-plans\"><strong>The Reserve at Elm’s apartments</strong></a> are conveniently situated near several highly regarded schools in Jenks and the greater Tulsa area. Families with children will appreciate the proximity to Jenks Middle School and Jenks High School, while students seeking higher education find convenience in the nearby Oral Roberts University. With educational opportunities abound, you can be sure you’ll find the ideal fit at one of these nearby schools:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/moore/mission-point/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Access to quality education is paramount, whether continuing your studies at the University of Oklahoma or looking for a top-tier elementary school for your children. Mission Point’s highly accessible location allows you to choose from a range of highly rated schools in your area to ensure you can find the right academic fit for you and those you care about. Premier schools in Oklahoma City near Mission Point include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/artisan-crossing-apts/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>OU isn’t the only excellent school near Artisan Crossing. There are also several elementary, middle, and high schools just a short distance away. Schools near our apartments in Norman include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Cimarron Trails Apartments in Norman are surrounded by highly rated public and private schools, including elementary, middle, and high schools. We’re also just a short drive away from the University of Oklahoma. Schools near Cimarron Trails include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our apartments are situated near several excellent schools for students of all ages. Nearby public school districts include Edmond and Deer Creek. Furthermore, the area is home to several private schools, offering residents a wide range of choices for learning. Schools near 24Hundred include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Chisholm Pointe, we understand that education is essential, regardless of age. That’s why we strategically located our duplexes and quadplexes in Oklahoma City, providing seamless access to the best schools in the area. Whether you have a child in elementary, middle, or high school or are attending college for the first time, our duplex and quadplex community is the perfect place for you. We have a range of other schools nearby, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Rest assured that students of all ages can receive a quality education at one of the many highly rated schools near Cimarron Pointe Apartments. Private and public elementary, middle, and high schools can all be found a short distance from our apartment community, such as:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>You’ll be sure to find a suitable school for any student at one of the elementary, middle, and high schools near our Oklahoma City apartment community. Council Place Apartments are also close to a variety of two-year and four-year colleges. Schools near our apartments in Oklahoma City include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find the right school for any student near Cross Timber Apartments, located near a broad selection of private and public elementary, middle, and high schools. Our Oklahoma City apartments are less than a five-minute drive from Oklahoma City Community College. Schools near Cross Timber Apartments in OKC include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find a great school for students of all ages near Crown Pointe Apartments. Oklahoma City offers a number of private and public institutions so you can find the right fit. Along with elementary, middle, and high schools, there are several two- and four-year colleges in the area. Schools near our Oklahoma City apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter's-ridge-apts/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Numerous elementary, middle, and high schools are just minutes from Hunter’s Ridge Apartments in Oklahoma City, making it easy to find the right fit for every student. Additionally, a selection of two- and four-year colleges is just a quick commute away from our Oklahoma City apartment homes. Schools near Hunter’s Ridge include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/persimmon-square-apartments/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Private and public schools are conveniently located near our Oklahoma City apartments, catering to students of all ages. These educational institutions offer comprehensive learning opportunities for residents of Oklahoma City apartments. Some of the schools within proximity include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Access to a quality education may be the most important factor to consider as you search for your new home, and Prairie Springs keeps your options open. From top-rated elementary schools to renowned high schools and beyond, the area boasts diverse educational opportunities well within reach, thanks in part to our prime location near the highway. Students of all ages can find top-rated schools just a few minutes away from home, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/stonehorse-crossing/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><a href=\"/apartments/ok/oklahoma-city/stonehorse-crossing/floor-plans\"><strong>Our North OKC apartments</strong></a> are surrounded by top-rated schools that cater to students from elementary through higher education. Whether you’re seeking a nurturing environment for young scholars or pursuing lifelong learning, the schools near Stonehorse Crossing give you the oppositions and opportunities to excel:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summerfield-place-apts/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>You can access numerous outstanding educational institutions near Summerfield Place Apartments in Oklahoma City. From esteemed elementary schools providing foundational education to reputable middle schools guiding students through critical developmental stages and distinguished high schools preparing them for future endeavors, the area offers many academic choices.</p>\n<p>Supporting the growth and success of all residents, our community provides various educational opportunities. In addition to Southern Nazarene University, we are close to top-tier elementary, middle, and high schools, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summit-ridge-villas/summit-villas/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Chisholm Pointe, we understand that education is essential, regardless of age. That’s why we strategically located our duplexes and quadplexes in Oklahoma City, providing seamless access to the best schools in the area. Whether you have a child in elementary, middle, or high school or are attending college for the first time, our duplex and quadplex community is the perfect place for you. We have a range of other schools nearby, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/tammaron-village-apartments/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Near Tammaron Village Apartments, you’ll find a selection of top-rated elementary, middle, and high schools providing various educational options. Explore the nearby schools to find your family’s ideal educational fit within this Oklahoma City apartment community. Schools in the vicinity include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/warrington-apartments/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Just a brief distance from The Warrington Apartments in Oklahoma City lies a selection of excellent elementary, middle, and high schools. Additionally, the vicinity boasts numerous two-year and four-year colleges for individuals looking to advance their education. Whether you prefer public or private institutions, you’ll discover the following various options nearby, ensuring you can find the perfect educational fit for your needs.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Many elementary, middle, and high schools serve Waters Edge Apartments, with a variety of magnet and charter schools that are easily accessible thanks to our proximity to highways and main roads.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/coffee-creek/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We recognize the paramount importance of education for students at every stage of their academic journey, from the early years of kindergarten to higher education pursuits. Our community’s ease of access to the highway and our prime location near Tulsa put your home within reach of some of Oklahoma’s finest schools and colleges, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Perhaps the most crucial factor to consider when searching for a new home is that Owasso and the surrounding Tulsa area are home to a range of top-notch educational institutions. Find acclaimed elementary, middle, and high schools with a history of success so those you care about receive only the best education. Our proximity to Highway 169 and Highway 75 keeps your options open, allowing you to find the best academic fit for you or your family at one of these highly rated schools:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cypress-crossing/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>A quality education for yourself or your loved ones is a top priority when choosing your ideal apartment and townhome community. Thankfully, Owasso is served by a variety of highly rated schools, including multiple elementary, middle, and high schools, all conveniently located just minutes away. With quick access to major roads through Owasso Expressway, getting to school has never been easier.</p>\n<p>Schools near our Owasso apartment community include:<br/></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/pryor/west-530/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Having a home near a quality selection of education options is important, and finding quality schools is easy when you live at West 530. Pryor is served by Pryor Public Schools, with elementary, middle, and high school campuses just a short drive from your apartment.</p>\n<p>For those looking for options in higher education or technical training, Northeast Tech – Pryor Campus and Rogers State University are both within easy reach. Nearby schools include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/stillwater/apple-creek-stillwater/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>OSU isn’t the only top-tier school near our apartment community. You’ll also find excellent elementary schools, middle schools, and high schools near our Stillwater apartment community, such as:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/barrington-apartments/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>You can access an excellent education for students of all ages when you live at Barrington Apartments. You’ll find a variety of public schools and private institutions, including elementary, middle, and high schools, as well as two-year and four-year colleges. Academic institutions near our Tulsa apartment community include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cascata-luxury-apartments/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>An excellent education is within reach when you live at Cascata. Near our Tulsa apartment community, you’ll find a variety of elementary, middle, and high schools, along with community colleges and universities. Academic institutions near Cascata Apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-glade-apts/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Excellent elementary, middle, and high schools are just a short drive from Cedar Glade Apartments in Tulsa. You’ll find private and public institutions nearby, making it simple to find the right fit for you. There are also several two-year and four-year colleges in the area for those seeking to continue their education. Schools near our apartment community include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Living near Cedar Ridge Apartments puts a range of schools and learning institutions within easy reach in Tulsa, OK.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find the ideal school for students of any age near our Tulsa apartments, with public and private schools nearby. Excellent elementary, middle, and high schools are all just a quick drive away from Chardonnay Apartments in Tulsa, as well as a selection of two- and four-year colleges. You’ll find these schools near our Tulsa apartments:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Situated within two miles of <a href=\"/apartments/ok/tulsa/country-hollow-apartments/floor-plans\"><strong>our apartment community</strong></a>, Oral Roberts University provides residents with a wealth of educational and cultural resources right at their fingertips. Whether you’re pursuing higher education, attending events on campus, or simply exploring the university’s beautiful surroundings, Country Hollow keeps you close to this prestigious university as well as these other fine schools in Tulsa for students of all ages:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/creekwood-apartments/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>A quality education is within reach when you live at Creekwood Apartments in Tulsa. Nearby, you’ll find a variety of elementary, middle, and high schools, as well as two-year and four-year colleges. Schools near our Tulsa apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/nickel-creek-apts/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Whether you have young children attending school or you’re a student at Oklahoma State University’s Medical Center, there are plenty of options nearby. Our location in south Tulsa makes Nickel Creek a short drive from multiple elementary, middle, and high schools in the area.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/polo-run-apartments/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Polo Run Apartments offers convenient access to a range of educational institutions in Tulsa. Located near renowned universities such as Oral Roberts University, you have the opportunity to engage with a vibrant academic community. Additionally, the neighborhood is home to well-regarded public and private schools, providing families with excellent educational options for their children.</p>\n<p>The proximity to these esteemed educational establishments enhances the appeal of Polo Run Apartments, making it an ideal choice for students and families seeking a supportive and enriching academic environment. The University of Tulsa is just one of the exceptional schools surrounding our apartment community, which include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our Tulsa apartment community at Sheridan Pond boasts proximity to a range of public, private, and college schools, offering educational opportunities for students of all ages. As part of the Union Public Schools district, Sheridan Pond Apartments in Tulsa, OK, provides access to various neighborhood schools that offer quality education in a convenient location.</p>\n<p>Families can actively participate in their children’s educational journey while relishing the comfort and convenience of living at Sheridan Pond Apartments. Nearby schools include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Sugarberry Apartments offers exceptional educational opportunities for students of every age. Situated in Tulsa, our apartment community is conveniently near a diverse selection of public and private schools, from elementary and high school levels to two-year and four-year colleges. Academic institutions near our Tulsa apartment community include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>A number of prestigious schools, both public and private, are within a short drive of Sunchase Apartments in south Tulsa, OK. These highly regarded educational institutions cater to students of all ages and offer quality learning environments that enhance the community’s appeal.</p>\n<p>With easy access to these educational resources, Sunchase Apartments stands out as a vibrant, family-friendly community prioritizing academic excellence. Explore the esteemed schools near Sunchase Apartments.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Thanks to the several schools near our Tulsa apartments, it’s easy to find a good fit for any student. A variety of private and public elementary, middle, and high schools are all just a quick drive away from The Courtyards. We’re also a premier option for students looking for apartments near Oral Roberts University and The University of Tulsa. Schools near The Courtyards Apartments in Tulsa include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Highly rated elementary, middle, and high schools can all be found a quick drive away from The Greens of Bedford apartments so you can easily find a good fit for any student. Some schools near our apartment community in Tulsa include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Near Windsail Apartments in south Tulsa, there’s a wealth of educational institutions, from elementary, middle, and high schools to two- and four-year colleges. Discover the schools surrounding our apartment community in Tulsa, offering a well-rounded living experience that champions education and individual development. Notable schools near our Tulsa apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Your education and that of those you care about is a top priority in The Park on Westpointe community. Luckily, Oklahoma City offers a rich selection of top-rated schools for students of any age, from elementary through college and higher education. With convenient access to the highway, you can explore the choices available across town so you can find the ideal education fit at one of these highly acclaimed schools.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/the-ridge-@-66/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>A top-quality education is your top priority, and luckily, Ridge at 66 offers convenient access to highly-rated schools. Families seeking excellent educational opportunities for their children will appreciate the proximity to top-notch schools in the Yukon area, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>A quality education for you or your family should always be paramount when you choose your next home. Students of all ages can find top-rated institutions within easy reach of<strong> </strong><a href=\"/apartments/tx/amarillo/newport-amarillo-apts/floor-plans\"><strong>Newport Apartments</strong></a>, including private and public schools and several major colleges. High-quality schools within a short commute of your Amarillo apartment home include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Amarillo’s educational opportunities offer a high-quality learning experience for all types of students. Young academics can develop their skills and talents at one of several top-rated elementary, middle, and high schools, while adults looking for higher education can find their fit at several acclaimed Amarillo colleges. Schools near <a href=\"/apartments/tx/amarillo/park-at-coulter/floor-plans\"><strong>Park at Coulter Apartments</strong></a> include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Remington Apartments are great for families with school-aged children. Our apartments are located near many top-rated schools in the area, easily accessible from main roads and major highways. We’re also located near college campuses including Amarillo College West Campus and Vista College Amarillo, for those wanting to continue their education.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Numerous schools are situated within a short drive of our Amarillo apartments, offering students educational options to suit their needs. Our location caters to diverse academic pursuits, from public and private elementary, middle, and high schools close to Amarillo College and Texas Tech University Health Science Center.</p>\n<p>Explore the variety of schools near Winchester Apartments.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/acacia-park-apts/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Families with children of all ages in school will find several great school districts serving the El Paso area when living at Acacia Park Apartments. There are numerous elementary schools, middle schools, and high schools near our apartment community, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/chimneys-apts/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Is it time to send your kids off to school? Regardless of their age, many schools are within a short distance or a short drive from our West El Paso apartment homes. These schools range from elementary to high school and can be easily accessed through major roads and highways, including I-10.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Many great schools and educational institutions in West El Paso are near our Double Tree Apartment community, like Coronado High School, whether you have children in elementary school or starting college. The El Paso Independent School District, as well as private institutions, primarily serve the area. Some nearby schools include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>If you’re the parent of a school-aged child or looking to live near El Paso’s higher educational opportunities, our luxury apartment community in East El Paso is a great option. Near our High Ridge apartments, you’ll find many schools, such as:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/mountain-village-apts/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We know how much you value the future of your little ones, particularly when it comes to their schooling. When you live at Mountain Village Apartment Homes, you’ll be close to several of the best schools in El Paso, which are easy to get to via I-10 and other major roads in the area. These schools include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/patriot-apts/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>There are schools for students of all ages near our El Paso apartment community, including private institutions, public schools, and colleges. Schools for students of all ages can be found within reach of our El Paso apartments, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/phoenix-apts/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>From early childhood learning centers to colleges, there are several highly rated schools near our El Paso apartments, including public schools and private institutions. Schools near The Phoenix apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/shadow-ridge-apts/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Shadow Ridge Apartments is conveniently located near several local schools for all age groups. Whether you have children in elementary school, middle school, high school, or young adults attending a nearby college, education for all age ranges is never too far from our east El Paso apartments.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Crest is a great place to live for students of all ages, thanks to the many excellent schools nearby. The educational opportunities near our El Paso apartment community are plentiful, from early childhood education centers to universities and community colleges. Schools in the area include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/hewitt/icon-at-hewitt/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>When the school year starts and your kids begin to hit the books, there are several quality schools near the Icon at Hewitt for your kids to go to. Not only are there multiple elementary, middle, and high schools nearby to send your children, but we are also only a 13-minute drive from Baylor University for young adults pursuing a degree.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our family-friendly apartments in Lubbock are near several elementary schools, middle schools, and high schools. College students will also enjoy our apartments near Texas Tech University, just 20 minutes away. Schools near our Lubbock apartment community include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our southwest Lubbock apartments make getting your kids to school so easy. It doesn’t matter what age your kids are, you’ll find various schools just a short drive away. You’ll find elementary schools and high schools all around you. Loop 289 and Marsha Sharp Freeway are just minutes away, so you can quickly get to and from school. Our community makes it easy for your kids to get an education.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Thanks to our close distance to a number of great schools in the area, we’re an ideal place to live for those with children. You’ll enjoy a short drive to many elementary schools, middle schools, and high schools, such as:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/temple/portico-at-friars-creek-apts/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>While you’re moving your family, finding a place to live near quality schools can be a challenge. However, when you rent a loft or apartment at Portico at Friars Creek, you have several different elementary, middle, and high school options for your children to attend. In addition, we’re just down the road from Temple College for anyone pursuing their higher educational goals. Nearby schools include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Whether you’re a college student looking for apartments near Baylor or the parent of a young student, we have a Waco apartment for you. You’ll find several highly rated schools near our apartments in Waco, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/tuscany-ranch-apartments/neighborhood::propertyneighborhoodmap.schools_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Picking the perfect school for your children can play a major factor in where you choose to call home. Tuscany Ranch Apartments provides great options for nearby elementary, middle, and high schools. In addition, we’re only a seven-minute drive from Baylor University for those pursuing higher education.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/north-little-rock/lexington-park/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Run quick weekend errands or enjoy some retail therapy by visiting one of the many stores near Lexington Park Apartments in Little Rock. From department stores to clothing retailers, there are shopping options for every need within reach. Shopping options near our Little Rock apartment community include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/maize/watercress-apartments/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Within proximity to Watercress, you’ll discover convenient shopping options at Towne West Square and essential items at Walgreens. Surrounding the area is a diverse selection of grocery stores such as Sam’s Club, Dillons Marketplace, Walmart Supercenter, and ALDI. You can explore the following stores nearby.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The several shops near our Wichita apartment community make it easy to stock up on groceries, shop for a new outfit, and find any essentials you need. Several grocery stores, like Dillons, ALDI, and Walmart Neighborhood Market, can be found just a quick drive away from our Wichita apartments. Other shopping options nearby include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/crown-chase-apts/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Knock out your shopping easily thanks to the wide variety of stores near Crown Chase. When you need to quickly run for some essentials, head to the nearby Target or Walmart Supercenter, each just five minutes away from our Wichita apartment community. You’ll also find Towne West Square Mall nearby, home to dozens of retail stores and a small movie theater. Stores near Crown Chase Apartments in Wichita include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/huntington-park/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Shopping centers and malls near Huntington Park Apartments include all of the stores you’ll need for weekend errands, from grocery stores to clothing outlets. The New Market Square shopping center is also just five minutes away, the perfect destination for a little retail therapy. Shops near Huntington Park Apartments in Wichita include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/newport-wichita-apts/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>A day of fun and retail therapy is easy to come by when you live at Newport Apartment Homes in Wichita. Our apartment community is near several of Wichita’s favorite shops so you can find all you need just a few minutes from your front door. Whether you’re seeking the latest fashion trends, unique artisanal goods, or everyday essentials, you’ll find them in the bustling shopping districts surrounding our community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/portofino/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our position in Wichita’s western community puts your home just around the corner from several popular shopping centers that help you find everything you need to make yourself at home. Bradley Fair Shopping Center, just up the road from Portofino, brings practically everything you need to a conveniently close location with beauty stores like Bath &amp; Body Works, electronics from Best Buy, and everything in between. Healthy groceries are close at hand with Trader Joe’s, Natural Grocers, Dillons, and Whole Foods Market, all just a short drive away, allowing you to enjoy a range of options in your shopping experience, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/raintree-apartments/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Near Raintree Apartments in Wichita, you’ll discover a range of local retailers and businesses, including grocery stores, clothing outlets, and specialty shops. For your grocery needs, Natural Grocers and Dillons Marketplace are nearby. For clothing shopping, stores like Maurices and Kohl’s are conveniently located near our apartments. Near our west Wichita apartments, you’ll find these stores:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/remington-wichita/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Take advantage of the abundance of shops near The Remington Apartments for a delightful shopping day. The Bradley Fair Shopping Center is just under three miles away and home to more than 50 specialty retailers and dining establishments. Greenwich Place’s 106-acre shopping area also offers countless opportunities for a day out with loved ones or friends for new outfits, a bite to eat, and more.</p>\n<p>In proximity to our Wichita apartments, you’ll also find a selection of grocery stores like Sam’s Club, Dillons, and Trader Joe’s. Other stores near our Wichita apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/silver-springs-apts/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Located near Silver Springs Apartments in Wichita, many local businesses and retailers await, from grocery stores to clothing outlets and specialty shops. Should your pantry need replenishing, GreenAcres Market and Dillons stand ready to assist, while Old Navy and Half of Half Name Brand Clothing offer opportunities to revitalize your wardrobe. Explore the convenience of these nearby stores within reach of our Wichita apartments.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Run errands or enjoy some retail therapy at the many shopping options near Villas of Waterford in Wichita, KS. Stores nearby include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/belton/center-301/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Shopping surrounds our apartments in Belton, including grocery stores, clothing outlets, and specialty shops. Whether you need to make a quick run to the store to pick up some things for your apartment or want to expand your wardrobe, there are plenty of shopping options near our apartment community to choose from, such as:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/152-northland/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Anything you need to buy is within reach when you call 152 Northland home. You can shop for groceries at Price Chopper or other nearby supermarkets and pick up any other essentials at Target. If you’re looking to add to your wardrobe, Kohl’s and Ross are among the many nearby department stores in the area.</p>\n<p>Additional shopping options within reach of our apartments near MCI Airport include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/97-north-oak/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>You’ll find a Sun Fresh market right down the street when you need groceries and essentials. Update your wardrobe by visiting nearby department stores like Macy’s and Kohl’s, or grab an iced coffee and discover hidden treasures at the nearby Savers thrift store. Other shops near our northern Kansas City apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/trace-apts/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our apartment community in Ridgeland, MS, is just a short drive away from so many shopping options, you’ll be able to find everything you need nearby. Head to At Home to furnish your new apartment and then try The Antique Mall of the South, the perfect place to find all the odds and ends to finish up your ideal living space. Whether you think of yourself as a “shopaholic” or simply want your necessities close at hand, you’ll find several retailers near Trace of Ridgeland, from big department stores to small local shops, such as:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>There are several stores near Icon at Broken Arrow, including grocery stores, clothing retailers, and more. Whether you need to run quick errands or are craving a shopping day, one of the stores near our Broken Arrow apartment community is bound to have what you need. Shops near Icon at Broken Arrow include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start your next shopping trip at the locally loved Arrow Village Shopping Center, where you can find Reasor’s grocery store, nail salons, barber shops, and many more conveniently located outlets to browse. Keep your adventure going as you discover hidden gems at Main Street Square, where you can find charming boutiques like Simplicity or visit any of these nearby shopping destinations.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/redbud-ranch/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Near our North Broken Arrow apartments, you’ll discover many shops catering to all your needs, from groceries to clothing and gifts—you name it. Whether you’re seeking household essentials or fresh produce, the nearby Woodland Hills Mall boasts over 100 stores for your convenience.</p>\n<p>Additionally, near our North Broken Arrow apartments, you’ll find Reasor’s Foods and Aldi, offering further options for your shopping needs. Our North Broken Arrow apartments are conveniently situated near the following stores:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Run errands or enjoy some retail therapy at the many shopping options near Scissortail Crossing in Broken Arrow, OK. Stores nearby include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Shopping near Trails at Aspen Creek is convenient and plentiful, keeping everything within a short distance from your front door—from daily essentials for your apartment home to unique finds. Broken Arrow Town Center I is home to a host of shops and retailers like Target Broken Arrow for all your home needs, while Reasor’s and the grocery options in Arrow Village Shopping Center to the north keep your home stocked with fresh ingredients for your next meal.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Villas at Aspen Park boasts a premium location with easy access to many shopping options. From supermarkets to sprawling shopping centers and a diverse range of local businesses to explore, you’ll find everything you need just a stone’s throw away. When you feel like taking a break from work or want to indulge in some retail therapy, don’t hesitate to explore our list of nearby establishments, including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/fountain-lake/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Finish all your errands with ease when you live at our conveniently located Edmond apartment community. Grocery stores, clothing retailers, and several other stores are just a quick drive away. Head to the nearby T.J. Maxx when you need a gift for a friend or loved one, or stock up on groceries at Crest Foods or Natural Grocers, both nearby. When you’re in the mood for a day of retail therapy, drive over to Quail Springs Mall and browse their dozens of stores. Additional shops close to Fountain Lake include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Run errands or enjoy some retail therapy at the many shopping options near Villas at Stonebridge in Edmond, OK. Stores nearby include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/moore/mission-point/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>One of the unique benefits of living in a Mission Point apartment home is your unparalleled access to the many shopping centers of Oklahoma City. Just up the road in Shops at Moore, you can find groceries and all the home goods you need at ALDI, Target, or the Walmart Superstore, all in the same two-block area. Best Buy and The Home Depot are also right around the corner, making every aspect of outfitting your apartment home easily achievable. Find everything you need to live your life to the fullest in Oklahoma City at these shops and outlets near Mission Point:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Just minutes from University Town Center shopping strip, living at Cimarron Trails puts you within reach of a wide variety of retailers. Stock up on essentials at the nearby Walmart Neighborhood Market or Target, or spruce up your apartment with some decor from the local HomeGoods. Other stores near our apartments in Norman, OK, include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>From convenience stores to boutiques, you have plenty of shopping options when you live in our Oklahoma City apartments. Thanks to the variety of stores near our Oklahoma City apartment community, running errands has never been easier. Just a mile away, Quail Springs Mall offers a great selection of apparel and unique gifts. Shops near 24Hundred include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>When you need to run to the store for a few household items or find a gift for an upcoming holiday, one of the stores near Cimarron Pointe is bound to have what you need. From grocery stores to clothing outlets, there’s no lack of shopping near our apartments in Oklahoma City. You’ll find the following stores near Cimarron Pointe:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>A variety of popular retailers and local businesses can be found near Council Place Apartments in Oklahoma City, including grocery stores, clothing outlets, and specialty stores. Crest Foods and Walmart Neighborhood Market are right down the street when your fridge starts looking a bit sparse, and nearby clothing stores like Kohl’s and T.J. Maxx can help when your closet needs a refresh. You’ll find these stores near our Oklahoma City apartments:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Cross Timber is located near a wide selection of retailers, making it easy for you to quickly run to the store or enjoy a shopping day. When your fridge needs a restock, you’ll find several grocery stores nearby, like Crest Foods, Walmart Supercenter, Sprouts Farmers Market, and World Fresh International Market. If you need a unique gift for a friend or a fun new outfit, try Pink Attitude Boutique, right down the street from Cross Timber. Additional stores near our apartments in Oklahoma City include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>With several shopping centers just a quick drive away from Crown Pointe apartments, you can quickly make a run to the store. When you need some retail therapy, head to Quail Springs Mall, offering nearly 100 shopping and dining venues. There’s also a wide selection of grocery stores nearby for restocking your pantry and fridge, such as Sprouts Farmers Market, right down the street. Look for these stores near our Oklahoma City apartments:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter's-ridge-apts/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Stock up on groceries at nearby grocery stores or enjoy some retail therapy at one of the clothing outlets. There are so many shopping options near Hunter’s Ridge Apartments, you’ll have weekend errands done in no time. Stores near our Oklahoma City apartment community include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/park-at-tuscany/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Start a shopping spree near The Park at Tuscany in north Oklahoma City and discover a world of convenience just moments from your doorstep. Dive into the trendy boutiques and renowned brands at Quail Springs Mall, offering an ideal opportunity to refresh your wardrobe or find that special gift. For your grocery needs, explore the variety of healthy options available at nearby stores like Sprouts and Natural Grocers, along with all the other odds and ends you may need at these nearby shopping locations:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/persimmon-square-apartments/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Numerous retail options surround our north Oklahoma City apartments, providing a diverse array of products ranging from groceries and apparel to unique gifts. For health essentials, you can conveniently access Walgreens Pharmacy, situated approximately a mile away, offering prescription medications and a wide selection of health-related items.</p>\n<p>The proximity of these retail and health care establishments ensures you have easy access to everyday necessities and health care support. When residing at Persimmon Square apartments, you’ll find convenient access to the following stores:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Prairie Springs, we keep you close to everything you’ll need to <a href=\"/apartments/ok/oklahoma-city/prairie-springs-i/photos\"><strong>make your apartment the home you’ve envisioned</strong></a>. Just around the corner, Council Crossings Shopping Center offers quick access to all sorts of odds and ends you may need, including furniture from Family Leisure Oklahoma City and gardening supplies from TLC Garden Centers-NW. All your essentials can be found a few blocks further down the road at the Walmart Supercenter, while these other stores sit nearby to balance your shopping experience:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/stonehorse-crossing/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Groceries, clothing, decor, gifts, and everything else from essentials to luxury additions to your home can all be found a short trip away. Choose between a variety of options for healthy food and ingredients from Target Grocery, Costco, or Natural Grocers, all nearby. You can find your next favorite book at Barnes and Noble on Memorial Road, a new style at Lush Fashion Lounge, and the massive Quail Springs Shopping Mall directly south of us is sure to provide both excitement and opportunity on your next shopping spree. More nearby shops include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/tammaron-village-apartments/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Within proximity to Tammaron Village Apartments, you can conveniently access various stores for your shopping needs or a relaxing retail therapy session. Quail Springs Mall, a large shopping center featuring multiple restaurants, shops, and a 24-screen movie theater, is less than 15 minutes away. Nearby stores include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/warrington-apartments/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Located approximately four miles from The Warrington Apartments, Quail Springs Mall offers many retail and dining choices. Explore the diverse shopping options or catch a movie at its expansive 24-screen theater.</p>\n<p>Additionally, nearby establishments like Trader Joe’s and Uptown Grocery Co. provide convenient grocery shopping experiences. With the following various nearby stores, including grocery outlets and clothing stores, you’ll find everything you need just a stone’s throw away from The Warrington Apartments.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/coffee-creek/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore the expansive offerings at Owasso Market, a large shopping center boasting a Walmart superstore that provides access to all your household essentials. The Home Depot is less than two miles away for your home improvement needs, providing a one-stop shop for all your DIY projects. When you need anything from gifts and groceries to gadgets and gardening supplies, visit these nearby shopping centers to find exactly what you need:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cypress-crossing/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>When you’re looking for gifts, home decor, a new outfit, or simply have the shopping bug, our Owasso apartments keep you close to the action. Owasso Market Shopping Center is just down the street, a perfect place to pick up some healthy groceries, while Kohl’s, Costco, Lowe’s Home Improvement, JCPenney, Sam’s Club, and Walmart Supercenter will keep you stocked with everything you need to live comfortably.<br/><br/>More nearby shops and restaurants include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/pryor/west-530/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Easy access to groceries and shopping is a must in a premium apartment home, and between running errands, redecorating, or treating yourself to something new, you can find all the shops and outlets you’re looking for within reach. Buy everything you need from organic ingredients to home goods at Walmart Supercenter, just up the highway, as well as these other nearby places to shop:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cascata-luxury-apartments/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>You can find anything you need at one of the many shops near our apartments in Tulsa: groceries, clothing, gifts, you name it. The nearby Woodland Hills Mall boasts over 100 stores waiting for your next shopping spree. When you need to stock up on household essentials or groceries, head to the nearby Walmart Supercenter or Target. Some other stores near our Tulsa apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-glade-apts/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Need a good shopping trip? Head to Woodland Hills Mall, just around a mile from Cedar Glade, and browse through some of the 100+ stores or grab a quick lunch at the food court. With a Walmart Supercenter and Target nearby, you can stock up on essentials, too. Several more stores, including grocery stores and clothing outlets, can be found nearby, such as:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Shop to your heart’s content at the nearby Woodland Hills Mall or grab necessities at the nearby Target. You’ll have a wide selection of grocery retailers to choose from when it comes time to stock the fridge, including Sprouts Farmers Market, ALDI, Costco Wholesale, and Walmart Neighborhood Market. You’ll find the following stores near Cedar Ridge:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>While nearby Jenks and downtown Tulsa offer an abundance of places to shop and explore, our strategic location off 71st Street keeps all the essentials close to home. To keep your apartment well equipped, visit The Home Depot right across the street or head down to Sam’s Club for groceries and all of your homecare needs. The Woodland Hills Mall lies at the center of commercial action near Chardonnay, offering dozens of stores and outlets for you to discover, as well as these shops that can be found nearby:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Everything from your everyday essentials to home décor and gifts for your friends and family can be found within minutes of leaving your home. Access to healthy foods and high-quality ingredients is part of the foundation of a well-rounded home. Country Hollow’s proximity to upscale options like The Fresh Market allows you to maintain a healthy lifestyle. Find fresh styles while you explore the two stories of shopping at Woodland Hills, and find everything else at these other nearby shops:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/creekwood-apartments/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Treat yourself to a day of retail therapy by visiting one of the many stores near Creekwood Apartments. Less than 10 minutes away, you’ll find Woodland Hills Mall, boasting two stories of shops and restaurants. When stocking up on groceries, you’ll find several options nearby, including Walmart Neighborhood Market, The Fresh Market, and Winco Foods. Other stores near our Tulsa apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Run errands or enjoy some retail therapy at the many shopping options near Sunchase Apartments in Tulsa, OK. Stores nearby include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Conveniently located near plentiful shopping options ranging from grocery stores to clothing outlets, The Courtyards Apartments in Tulsa put you within reach of anything you could need. You’ll also find Woodland Hills Mall, just a 10-minute drive away when you need some retail therapy. Stores near our apartments in Tulsa include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Make a quick run to the store or indulge in a bit of retail therapy at one of the several stores near The Greens of Bedford Apartments. Less than 10 minutes away, Woodland Hills Mall boasts more than 150 shopping and dining venues to browse. Stores near our Tulsa apartment community include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover a range of convenient shopping options near Windsail, ensuring easy access to all your needs. For essential items, visit the nearby ALDI or Target, a mere seven-minute drive from our Tulsa apartment community.</p>\n<p>If you’re in the mood for a shopping spree, explore the Woodland Hills Mall, a fantastic shopping destination featuring a mix of chain and boutique stores, a kids’ play area, and a vibrant food court. Nearby stores close to Windsail Apartments in Tulsa, OK, include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Everything from groceries to gardening supplies and birthday gifts can be found within easy reach at one of several shopping centers near our apartment community. Find gourmet ingredients just down the street at Crockstar, and for all the other odds and ends you need in the kitchen and around the home, Walmart Supercenter is just a quick drive to the north by the Chisholm Shopping Center. Other shopping options near The Park on Westpointe include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/the-ridge-@-66/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore a variety of retail destinations offering everything from everyday essentials to unique finds. Whether you’re looking for fashion-forward clothing, home decor, or specialty gifts, you’ll find it all within reach. Shop for furniture, clothing, and home decor in the nearby Chisholm Shopping Center, and for all your grocery needs, Lakeview Market and the Walmart Supercenter give you the options to find healthy ingredients for every meal you make. More nearby shopping opportunities include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Newport Apartments in southwest Amarillo positions you conveniently close to shops for groceries, clothing, tools, gifts, and anything else you need to enjoy your home. Keep your kitchen stocked and ready for your next meal at United Supermarkets, on the other side of 45th and Bell Street across from Harbor Freight. Some of the other stores near Newport Apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Home decor, clothing, groceries, and everything else you may shop for can be found only minutes from your front door. Natural Grocers shares a street with Park at Coulter, giving you healthy and cost-effective options for groceries and other essentials. Other go-to shopping centers like The Home Depot and Lowe’s Home Improvement are complimented by more unique offerings like Lillie’s Boutique and the Vintage Living antique store, where you can find all the odds and ends that add a personal touch to your Amarillo apartment home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>All your essentials are within reach at Winchester Apartments in Amarillo. We’re ideally located near grocery stores, apparel shops, and various amenities. Just a short eight-minute drive away lies the Summit Shopping Center, offering a plethora of shopping opportunities. Adjacent to our Amarillo apartments, you can find:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/acacia-park-apts/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Run errands or enjoy some retail therapy at the many shopping options near Acacia Park Apts. in El Paso, TX. Stores nearby include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Run errands or enjoy some retail therapy at the many shopping options near Double Tree Apts. in El Paso, TX. Stores nearby include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Run errands or enjoy some retail therapy at the many shopping options near High Ridge Apts. in El Paso, TX. Stores nearby include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/patriot-apts/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>When you need to shop for groceries, clothing, gifts, or just about anything else, you’ll be able to find them at one of the many stores near our northeast El Paso apartments. For everyday essentials, you’ll find a Walmart Supercenter just a mile away, across from Lowe’s hardware store, stocked with tools and other hardware. Some stores near The Patriot apartments include: </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/phoenix-apts/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Run errands or enjoy some retail therapy at the many shopping options near Phoenix Apts. in El Paso, TX. Stores nearby include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Crest is just a quick drive away from a variety of shopping options conveniently located near your home. Whether you’re running errands or indulging in some retail therapy, you’ll find everything you need just a short drive away. Explore Mesa Street Antique Mall for unique treasures, or head to The Outlet Shoppes at El Paso for great deals on designer brands. For everyday essentials and gourmet delights, visit Food King grocery store or Whole Foods Market. Nearby shopping destinations include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>There are many shops near our apartments in southwest Lubbock, making it easy for you to find necessities and luxuries nearby. Since our apartments are near Route 389, shopping in the city is a breeze. Take a trip to Kingsgate North, due east of our apartment community, for all your grocery and personal care needs, and visit these other stores near our Lubbock apartments:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road/neighborhood::propertyneighborhoodmap.shopping_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>For home care, self care, healthy groceries, and everything else you need to live a comfortable life, Bend at New’s location near I-35 keeps you close to the essentials. Just down the road from our apartment complex, you can find Central Texas Marketplace, Walmart Supercenter, and these other shopping centers:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:property::propertyresourcesfooter.floorplans_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Floorplans at <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><a href=\"/apartments/ar/little-rock/arbors-of-pleasant-valley-apts/floor-plans\"><strong>At Arbors of Pleasant Valley Apartments</strong></a>, we believe that the heart of your home lies in the amenities we provide. From the moment you step into our community, you’ll experience a world of comfort and convenience that enhances your daily life. Dive into relaxation at our inviting outdoor pool. Whether you’re looking to cool off on a hot summer day or simply unwind, our pool is the perfect retreat. Reach your health and fitness goals in our 24-hour fitness center. Our facility offers a variety of exercise equipment to cater to your workout preferences.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Arbors of Pleasant Valley in Little Rock, AR, we understand that a home should be a perfect fit for your unique lifestyle. That’s why we offer a range of thoughtfully designed floor plans, including 1, 2, and 3 bedroom apartments. Each layout combines style, convenience, and comfort to cater to various needs. Discover your ideal home at The Arbors of Pleasant Valley Apartments</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Little Rock neighborhood surrounding Arbors of Pleasant Valley Apts — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Arbors of Pleasant Valley Apartments, we understand that pets are family, too. Our pet-friendly community welcomes your furry companions, making our apartments the perfect place for you and your four-legged friends to call home. Enjoy a stroll through our lush grounds and a visit to our onsite dog park with your pet! Speak with a member of our friendly leasing team for details.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our friendly community at Arbors of Pleasant Valley embodies the lifestyle of West Little Rock, Arkansas. Focus on your fitness and pleasure with the <a href=\"/apartments/ar/little-rock/arbors-of-pleasant-valley-apts/amenities\">24-hour fitness center</a> and onsite tanning bed. On sunny days, walk out of your apartment to find many of your neighbors poolside. The shared grills are perfect for cooking up meat and veggies. Our clubhouse is open to all guests and features comfortable furniture, a business center, a coffee bar, and a fireplace for getting cozy in cool weather. Our grounds are professionally maintained and visually pleasing, and limited-access gates help ensure the noise level is kept to a minimum.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/north-little-rock/lexington-park/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>When you live in our North Little Rock apartment community, you’ll enjoy an impressive list of amenities inside your apartment home and around our community. Spend each day lounging in your apartment home or stay active at our 24-hour fitness center or pool. The amenities at Lexington Park Apartments enable you to choose your own adventure every day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/north-little-rock/lexington-park/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our artfully designed 1, 2, and 3 bedroom apartment floor plans are the ideal backgrounds for your daily routine. Chores are made easy thanks to the <a href=\"/apartments/ar/north-little-rock/lexington-park/amenities\"><strong>in-home amenities</strong></a>, and the flowing layouts create a feeling of harmony. Every one of our apartment homes includes a washer and dryer, spacious closets, and a charming sunroom off the living room area.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/north-little-rock/lexington-park/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the North Little Rock neighborhood surrounding Lexington Park — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/north-little-rock/lexington-park/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>You and your furry friends can feel right at home in one of Lexington Park’s pet-friendly apartments in North Little Rock. Dogs love our on-site bark park, where they can stretch their legs and socialize with other pups. Cats can often be found happily napping in the bright sunroom or gazing out the large windows.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/north-little-rock/lexington-park/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Get a glimpse of life at our luxurious North Little Rock apartment homes by browsing our photos. We’ve included pictures of our community amenities and apartment homes so you can imagine what it would be like to live at Lexington Park. At the bottom of our photo gallery, you’ll also find a virtual 360-degree tour of our apartment community in North Little Rock, which allows you to explore from anywhere using your mobile device or computer.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/maize/watercress-apartments/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Indulge in our opulent amenities throughout Watercress, whether you opt for a serene day in your <a href=\"/apartments/ks/maize/watercress-apartments/floor-plans\"><strong>1 or 2 bedroom apartment</strong></a> sanctuary or an adventure in our resort-style community. Each apartment home boasts elegant and fashionable elements crafted to enhance your well-being. When you’re not relaxing in your comfortable apartment, enjoy our cutting-edge fitness center, zero-entry pool, and pet-friendly canine cove and Bark Park.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/maize/watercress-apartments/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our six distinctive 1 and 2 bedroom apartment floor plans offer a variety of amenities to enhance your comfort. Located in Maize near the <a href=\"/apartments/ks/maize/watercress-apartments/neighborhood\"><strong>Westlink neighborhood</strong></a>, our apartments exude a spacious, sophisticated ambience accentuated by lofty ceilings and open-concept designs. Additionally, select apartments in Maize feature flex spaces or attached garages, adding further versatility to cater to your lifestyle preferences.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/maize/watercress-apartments/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Maize neighborhood surrounding Watercress Apartments — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/maize/watercress-apartments/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience pet paradise at <a href=\"/apartments/ks/maize/watercress-apartments/floor-plans\"><strong>Watercress Apartments in Maize</strong></a>. Our pet-friendly spaces aim to bring joy to dogs and cats alike. Delight in our pet-centric amenities, including a canine cove and bark park. As the premier choice for pet-friendly living in Maize, Watercress Apartments prioritizes the well-being of you and your beloved pets. Explore the dedicated pet policy for Watercress Apartments below.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/maize/watercress-apartments/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Browse through our gallery for a preview of what’s to come when you join our luxury community. Our tranquil grounds inspire you to relax and create great memories. Imagine yourself soaking away your worries in the <a href=\"/apartments/ks/maize/watercress-apartments/amenities\">zero-entry pool </a>or relaxing with a drink on the lounge chair. Your pup’s favorite spot in the community will be the convenient Canine Cove, perfect for making puppy pals and burning off energy. See it all in person with a private tour!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Aspen Park in Wichita, KS, where modern living meets leisure. Our thoughtfully designed studios,  and spacious one- and two-bedroom apartments come with great layouts, and our onsite amenities include a pool, a fitness center, and inviting courtyards. Enjoy sun-soaked afternoons on your private balcony or a friendly match on the tennis court. Dive into community life today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "At Aspen Park in Wichita, KS, find the ideal space for your lifestyle. Our thoughtfully designed studio, one-bedroom, and two-bedroom apartments offer a blend of comfort and style. Browse our available homes today and uncover the perfect floor plan tailored just for you. Your new beginning awaits!",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Wichita neighborhood surrounding Aspen Park Apartments — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Nestled in vibrant Wichita, Aspen Park invites you to share your home with furry companions. With room for two pets, our community ensures your four-legged friends enjoy life as much as you do. Experience comfortable living paired with pet-friendly amenities at Aspen Park!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/aspen-park-apartments/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Aspen Park Apartments offers residents <a href=\"/apartments/ks/wichita/aspen-park-apartments/floor-plans\">stylish apartments</a> in a great location in West Wichita. Our close-knit community ensures residents feel at home from the moment they arrive. Escape the rat race and enjoy spending time by the outdoor swimming pool, working out in the onsite fitness center, or challenge your neighbors to a match on the tennis court.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Cottages at Crestview features well-equipped, beautifully designed apartment homes nestled in a gated community. As you explore our peaceful community, you’ll find upscale amenities to help you relax and make the most of your day. Whether you spend your day in the comfort of your apartment home or around the Cottages at Crestview community, the possibilities are endless. To get an even better idea of our amenities, we invite you to browse our <a href=\"/apartments/ks/wichita/cottages-at-crestview/photos\"><strong>photo gallery</strong></a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Browse our 12 unique apartment floor plans and find a layout that complements your lifestyle. The bright, airy living and dining space urges you to kick back and relax or share a meal with loved ones. Lux <a href=\"/apartments/ks/wichita/cottages-at-crestview/amenities\"><strong>amenities</strong></a> like stainless steel appliances and decorative ceramic tiling elevate your apartment’s style while serving as the ideal canvas for home decor. We also offer Wichita loft apartments with an attached garage alongside our floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Wichita neighborhood surrounding Cottages at Crestview — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>You and your furry friends can feel at home in our pet-friendly apartments in Wichita. Cottages at Crestview also offers an on-site dog park where you can play with your pup and let them stretch their legs.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/cottages-at-crestview/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover luxury living in a whole new way at Cottages at Crestview. Step outside your front door and straight into a staycation-worthy sundeck and <a href=\"/apartments/ks/wichita/cottages-at-crestview/amenities\">resort-style pool</a> embellished by an outdoor fire pit and lounge area. Take a look around and you’ll see that we have spared no detail in making sure that our community is designed for you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/crown-chase-apts/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The amenities at Crown Chase Apartments will complement your day-to-day life with a blend of essential features and stylish touches. Beyond our apartment homes, our Wichita apartment community has much to offer, with lux amenities around every corner, connected by lush green courtyards and manicured paths. No matter what <a href=\"/apartments/ks/wichita/crown-chase-apts/floor-plans\"><strong>floor plan</strong></a> you select, our amenities are sure to elevate your daily routine.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/crown-chase-apts/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We offer 1 and 2 bedroom apartments in Wichita, designed with <a href=\"/apartments/ks/wichita/crown-chase-apts/amenities\"><strong>amenities</strong></a> and a thoughtful layout to enhance your day-to-day life. Several of our Wichita apartment homes feature a beautiful waterside view off the private patio or balcony. To get an even better idea of our apartment floor plans, browse our photo gallery, which also features a virtual 360-degree tour of our 1 and 2 bedroom apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/crown-chase-apts/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Wichita neighborhood surrounding Crown Chase Apts — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/crown-chase-apts/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Crown Chase offers pet-friendly apartments where pet owners and their furry friends can thrive. When your pup needs some exercise, our Wichita apartment community’s bark park has plenty of space to play. Our pet policy includes the following guidelines down below:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/crown-chase-apts/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Peruse our photos and envision your life in our tranquil apartment community. You’ll find snapshots of our apartment homes and our community amenities. To get an in-depth view of our Wichita apartments, take advantage of our 360-degree virtual tour at the bottom of our photo gallery.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/huntington-park/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Huntington Park’s Wichita apartment homes feature curated amenities that bring your living space comfort and style. Around our peaceful community, even more luxurious amenities await, like an outdoor pool and spa, fitness center, resident clubhouse, and so many more. Our impressive collection of features and amenities enhances your day-to-day life.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/huntington-park/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find your personal oasis in one of our 1 or 2 bedroom apartments at Huntington Park. Each of our floor plans features a thoughtfully designed layout and a <a href=\"/apartments/ks/wichita/huntington-park/amenities\"><strong>collection of amenities</strong></a> that ensures comfort and convenience. We offer Wichita apartments ranging from 640 to 990 sq. ft., with each of our apartment homes featuring a private balcony or patio for getting some fresh air.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/huntington-park/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Wichita neighborhood surrounding Huntington Park — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/huntington-park/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Huntington Park offers luxury pet-friendly apartments in Wichita. Not only do we offer pet-friendly <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/apartments/ks/wichita/huntington-park/floor-plans\"><strong>floor plans</strong></a>, but you’ll also find an on-site dog park in our apartment community, so you can play with your pup without even leaving Huntington Park.&nbsp;</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/huntington-park/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>As you browse the photos of our Wichita, Kansas, apartments for rent near Westlink, you’ll begin to imagine your life within the beautifully landscaped grounds. Rest your bones in the hot tub or take a refreshing dip in the outdoor swimming pool. Work out in the onsite fitness center and then enjoy a relaxing shower in the privacy of your own home. Inside your apartment, walk across plush carpeting and choose from multiple <a href=\"/apartments/ks/wichita/huntington-park/floor-plans\">one and two bedroom floor plans</a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/newport-wichita-apts/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Newport Wichita, find your ideal home in a vibrant setting. Choose from our spacious one or two-bedroom apartments, featuring modern kitchens and cozy fireplaces. Enjoy serene lakeside walking trails, a refreshing outdoor pool, and a state-of-the-art fitness center. Experience peaceful living in Wichita—dive into our well-appointed amenities today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/newport-wichita-apts/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore our Wichita apartment floor plans and find the right space that compliments your unique <a href=\"/apartments/ks/wichita/newport-wichita-apts/neighborhood\"><strong>lifestyle</strong></a>. Available in three distinct layouts, you can choose between our 1 bedroom apartments and our two sizes of 2 bedroom apartments, with an optional private patio and wood-burning fireplace available across both sizes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/newport-wichita-apts/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Wichita neighborhood surrounding Newport Wichita Apts. — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/newport-wichita-apts/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>You and your pet will feel at home in your Newport apartment home. The bright and plentiful light brought in by our large windows provides the ideal setting for a catnap, and the nearby 10-acre lake is an ideal spot for a dog walk or a relaxing day by the water with your furry friends.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/newport-wichita-apts/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Newport Apartments brings together convenience and comfort in a <a href=\"/apartments/ks/wichita/newport-wichita-apts/pet-policy\">pet-friendly</a> community. We boast a great location in Northwest Wichita, Kansas, which we pair with enviable community amenities and apartment features. Spend time walking around the 10-acre lake on warm summer evenings, or cast out your line in the early morning to try your luck at fishing. Within our limited-access gates, you can sit back, relax, and enjoy all that Newport Wichita has to offer.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/portofino/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our luxury apartments offer modern living in an open-concept space. With custom cabinetry, premium internal lighting, and six customizable floor plan options, your upscale living experience inside your apartment is complemented by a suite of community amenities that enhance your comfort throughout your Portofino home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/portofino/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Available in six unique layouts between 789 and 1,176 sq. ft. in area, our 1 and 2 bedroom apartments are open and customizable. Choose options for an added fireplace, a bumpout expansion, or an attached garage to make your home reflect your lifestyle and thrive in a living space designed around comfort and functionality.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/portofino/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Wichita neighborhood surrounding Portofino — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/portofino/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Your pets are part of what makes where you live home, and at Portofino, we understand the importance of keeping your furry friends close. Our pet-friendly apartments are designed with your whole family in mind, so whether you have a playful pup or a cuddly cat, they’ll feel right at home in our welcoming environment. Our pet policy guidelines include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/portofino/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Look at luxury apartments and lofts like never before. Elegant surroundings. Beautifully landscaped grounds. Everything was designed with you in mind. Delight in stylish touches and well-considered details. Our homes maximize your living space with seamless open living areas and<a href=\"/apartments/ks/wichita/portofino/floor-plans\"> thoughtful floor plans</a>. Enjoy the comfort and convenience of in-home washer and dryer connections, generous closet space, and ceiling fans. Your home features a fully equipped gourmet kitchen with cabinet storage and modern stainless-steel appliances to help you live your best life in Wichita, Kansas.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/raintree-apartments/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Raintree Apartments, discover a range of <a href=\"/apartments/ks/wichita/raintree-apartments/floor-plans\"><strong>studio, 1, and 2 bedroom apartments</strong></a> with almost everything you need. Each apartment home features a private balcony or patio, providing an ideal space for potted plants and outdoor relaxation.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/raintree-apartments/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our Wichita apartment community offers meticulously planned floor plans tailored to complement your lifestyle. We provide budget-friendly studios and 1 and 2 bedroom apartments in Wichita, featuring <a href=\"/apartments/ks/wichita/raintree-apartments/amenities\"><strong>modern conveniences</strong></a> like fully equipped kitchens with upgraded appliances, private balconies or patios, and ample closet space.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/raintree-apartments/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Wichita neighborhood surrounding Raintree Apartments — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/raintree-apartments/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience the ideal haven for you and your pet with our verdant grounds, on-site dog park, and sun-soaked windows in our pet-friendly apartments. Our pet policy encompasses the following guidelines:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/raintree-apartments/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Peruse our photo gallery for a glimpse of life at Raintree Apartments. Imagine waking up in your spacious bedroom before fixing breakfast in your fully equipped kitchen. Take the dining and entertaining out onto your private patio or balcony for even more room to breathe.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/remington-wichita-apts/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Remington Wichita, your furry friends are part of the family! Enjoy spacious apartments with a welcoming environment for cats and dogs, where your pets can thrive. And they can enjoy our fenced in Bark park, a designated place for them to play and run! With our thoughtful pet policy, both you and your pets will feel right at home in beautiful Wichita, KS.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/remington-wichita/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover a wide array of essential comforts within our <a href=\"/apartments/ks/wichita/remington-wichita/floor-plans#/\"><strong>1 and 2 bedroom apartments</strong></a> at The Remington Apartments in Wichita, KS. Step outside your residence to bask in the amenities we provide. Elevate your daily rhythm with the exceptional amenities and indulgences at The Remington Apartments in Wichita.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/remington-wichita/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Select your ideal floor plan from a diverse range of options at The Remington Apartments in <a href=\"/apartments/ks/wichita/remington-wichita/neighborhood\"><strong>northeast Wichita, KS</strong></a>. Whether you prefer a cozy 1 bedroom layout or a more expansive 2 bedroom design, we offer floor plans that suit your lifestyle. Each floor plan boasts a generous open-concept living and dining area, perfect for relaxation and social gatherings with loved ones.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/remington-wichita/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Wichita neighborhood surrounding Remington Wichita Apts. — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/remington-wichita/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Remington Apartments in Wichita, your furry companions are always welcome. We have ample space for your dog to roam, while our cozy apartment homes offer sunny spots for your feline friend to bask in. With a range of pet-friendly <a href=\"/apartments/ks/wichita/remington-wichita/amenities\"><strong>amenities</strong></a>, pet owners can enjoy a harmonious living experience alongside their beloved pets. Here are the guidelines that shape our pet policy at The Remington Apartments:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/remington-wichita/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Imagine stepping into your ideal home at The Remington Apartments. Our community in Wichita offers <a href=\"/apartments/ks/wichita/remington-wichita/floor-plans\">one and two bedroom apartments</a> with breathtaking views and spacious floor plans. As you take a virtual tour of our apartments for rent in Wichita, get a feeling for what you can expect when you choose our lovely community as your next home. You’ll benefit from an array of amenities designed to enhance your lifestyle and apartment features to make your life simpler and more enjoyable.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/silver-springs-apts/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Every <a href=\"/apartments/ks/wichita/silver-springs-apts/floor-plans\"><strong>studio, 1 , and 2 bedroom apartment</strong></a> in our community comes fully equipped with all the essential amenities you desire. Embrace the outdoors with a balcony or patio in each apartment, perfect for showcasing your favorite potted plants. From the indoor pool to the nearby 10-acre lake, our community offers ample opportunities to get outside, breathe in the fresh air, and immerse yourself in the breathtaking scenery that surrounds us.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/silver-springs-apts/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>In our Wichita apartment community near the <a href=\"/apartments/ks/wichita/silver-springs-apts/neighborhood\"><strong>Silver Springs neighborhood</strong></a>, each meticulously crafted floor plan prioritizes comfort and includes various amenities. Upon your daily return, you’ll find a luminous and inviting living and dining space, ideal for plush sofas and cozy meals at a bistro table.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/silver-springs-apts/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Wichita neighborhood surrounding Silver Springs Apts. — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/silver-springs-apts/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Silver Springs in Wichita provides a harmonious blend of comfort and convenience for our residents and their pets. Our doors are open to dogs and cats, fostering a welcoming environment that meets their needs. With pet-friendly <a href=\"/apartments/ks/wichita/silver-springs-apts/amenities\"><strong>amenities</strong></a> and spacious floor plans, we prioritize the happiness and well-being of your beloved pets.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/silver-springs-apts/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Envision a new standard of living while perusing the gallery. Imagine starting the day with a hot cup of coffee on your <a href=\"/apartments/ks/wichita/silver-springs-apts/amenities\">private patio or balcony</a> while looking out at lake views. Spread out while preparing breakfast in the spacious kitchen and then choose an outfit from a walk-in closet. Commutes are made easy with our proximity to I-35 and I-235. After a long day, unwind by the tropical pool oasis or mingle with neighbors in the clubhouse.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience the ultimate luxury living experience at the Villas of Waterford in Wichita, KS! Our stunning apartment community provides<strong> </strong>four floor plans with contemporary finishes and premier amenities to enhance your lifestyle. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Villas of Waterford Apartments in northeast Wichita invites you to experience exceptional <a href=\"/apartments/ok/edmond/villas-at-stonebridge/pet-policy\"><strong>pet-friendly apartment living</strong></a>. We have four unique floor plans that cater to a vast array of preferences, thoughtfully designed with luxurious amenities and abundant features that ensure a homey feel. Whether you want a tranquil 1 bedroom layout or a generous 2 bedroom retreat, our floor plans fit diverse requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Villas of Waterford Apartments is in a prime location in Wichita, offering outstanding access to KS-96 and less than 10 minutes from Wichita State University. Numerous restaurants, retail shops, and businesses are active in the vibrant neighborhood near Cottonwood Village.<br>From stocking up on essentials at Costco to shopping with friends at Bradley Fair or enjoying a delicious meal with loved ones at Wasabi East, the countless options along North Rock Road and East 29th Street North keep residents entertained. Our<strong> </strong><a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/apartments/ks/wichita/villas-of-waterford/floor-plans\"><strong>luxury 1- and 2-bedroom apartments in Wichita</strong></a> provide convenience and sophistication, catering to your preferences.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Villas of Waterford, located near the Cottonwood Village <a href=\"/apartments/ks/wichita/villas-of-waterford/neighborhood\"><strong>neighborhood</strong></a>, proudly stands as a pet-friendly apartment community in Wichita. We recognize and appreciate the significance that pets hold in the lives of their owners and families, and that’s why we’re excited to be located near Northrock Hospital for Animals. Our 1- and 2-bedroom floor plans feature open-concept living spaces with plenty of room for playtime.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ks/wichita/villas-of-waterford/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We’ve placed some of our best features and <a href=\"/apartments/ks/wichita/villas-of-waterford/amenities\">amenities</a> in the spotlight. Explore our gallery for a preview of your upgraded lifestyle in our gated Wichita apartment community. Envision how you will decorate your stylish apartment, see some of our select features, or get a glimpse of all of the relaxing community amenities onsite. No matter what you’re looking for in a home, you’ll find the right fit at Villas of Waterford.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/belton/center-301/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find your bliss in one of our contemporary apartment homes, designed with essential amenities and elegant details. Optional amenities are available in several of <a href=\"/apartments/mo/belton/center-301/floor-plans#/\"><strong>our floor plans</strong></a>, allowing you to elevate your space, such as an attached garage or LED fireplace. Our apartment homes’ comfortable, luxurious atmosphere makes residents and guests feel right at home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/belton/center-301/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We offer a wide range of Belton apartment floor plans so you can find the layout that’s right for you. In addition to apartment homes, we also offer spacious townhomes near Kansas City for those wanting more space and privacy. Each of our floor plans features <a href=\"/apartments/mo/belton/center-301/amenities\"><strong>essential amenities</strong></a>, like abundant closet space for stowing your wardrobe, a fully equipped kitchen with everything you need to cook up a delicious meal, and a dishwasher for easy cleanup. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/belton/center-301/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Belton neighborhood surrounding Center 301 — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/belton/center-301/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Center 301 offers pet-friendly apartments in Belton, so you can bring your furry friends with you to your new apartment home. Dog owners will also love our sizable on-site dog park, where you can let your pup stretch its legs. Browse our <a href=\"/apartments/mo/belton/center-301/floor-plans\"><strong>apartment, loft, and townhome floor plans</strong></a> and find one that fits the needs of you and your fur baby.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/belton/center-301/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>As you browse our gallery of photos, you can’t help but notice the luxury that awaits you at Center 301 Apartments. With every image, a new story is told. Picture yourself enjoying your morning coffee on your private balcony or patio in select units. Then, whip up an intimate dinner for two in your chef-inspired kitchen with stainless steel appliances and ample countertop space. Keep clutter at bay with the extra storage space in the <a href=\"/apartments/mo/belton/center-301/amenities\">walk-in closet</a>, and always indulge in the perfect atmosphere with custom extras like vaulted ceilings and a cozy fireplace. It all comes together to complete the picture-perfect lifestyle you’ll enjoy when you make Center 301 Apartments your home in Belton, Missouri.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/independence/the-adirondack/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience luxury living with the many amenities offered with our brand new <a href=\"/apartments/mo/independence/the-adirondack/floor-plans\"><strong>1 and 2 bedroom apartments and townhomes</strong></a> at The Adirondack Apartments. From stylish touches like high ceilings, stainless steel appliances, and custom cabinetry to community amenities like an on-site dog park, business center, and resort-style pool, you’ll have everything you need to live the life you’ve always dreamed of right at your fingertips.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/independence/the-adirondack/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to our <a href=\"/apartments/mo/independence/the-adirondack/neighborhood\"><strong>charming community</strong></a> of 1 and 2 bedroom apartments and townhomes in Independence, MO. Nestled in the heart of this vibrant city, our thoughtfully designed residences offer the perfect place to call home. Whether you’re seeking a cozy 1 bedroom apartment or a spacious townhome for your growing family, we have the floor plan to suit your needs. Explore everything our <a href=\"/apartments/mo/independence/the-adirondack/pet-policy\"><strong>pet-friendly</strong></a> community has to offer and find your ideal home sweet home in Independence!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/independence/the-adirondack/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Independence neighborhood surrounding The Adirondack — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/independence/the-adirondack/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Adirondack Apartments, we understand that pets are part of the family and should be considered when looking for a place to call home. You can bond, play, and unwind with your furry friends at our pet-friendly community in Independence, MO. We have spacious living areas for you and your kitten to cuddle on the sofa, ample natural lighting for your four-legged companions to sunbathe midday, and <a href=\"/apartments/mo/independence/the-adirondack/amenities\"><strong>amenities</strong></a> like an on-site dog park for your pup to run around and burn some energy.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/independence/the-adirondack/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Just one look at the brand-new <a href=\"/apartments/mo/independence/the-adirondack/floor-plans\">lofts, townhomes, and apartments</a> at Adirondack will be enough to make you want to call our luxury community home. Imagine yourself enjoying life in one of our expansive one or two bedroom layouts, which offer everything from sleek stainless-steel appliances to spacious walk-in closets. In select homes, you can cozy up beside a fireplace or kick back and relax on a private patio or balcony. Attached and detached garages are also available, giving you plenty of space to park your vehicle and store other valuable items.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/152-northland/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Life is easy at 152 Northland, where comfortable in-home features meet resort-style community amenities. You’ll have no trouble feeling at home thanks to our pet-friendly apartment amenities and various options to stay active, entertain friends and family, or relax after a long day at work at our apartment community in Kansas City.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/152-northland/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We have a variety of comfortable floor plans available, so you can find an apartment that truly feels like home. Our 1 and 2 bedroom floor plans for Kansas City apartments are all unique, including single-level and loft-style options. Certain floor plans also include a flex space, and a fireplace is an optional addition to any of our apartments or townhomes in Kansas City.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/152-northland/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Kansas City neighborhood surrounding 152 Northland — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/152-northland/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Your pets are family, and they have a place here at 152 Northland. Our pet-friendly apartment community in Kansas City, MO, is designed with your furry friends’ comfort in mind, as our spacious floor plans offer enough space for them to take their afternoon nap or cuddle up by your feet.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/152-northland/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We place an emphasis on aesthetic value and beautiful design choices at 152 Northland. Our apartments are available in single-story and two-story floor plans, offering options for a tight-knit space or separate sleeping and lounging areas.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/97-north-oak/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Make yourself at home in 97 at North Oak’s apartments in Kansas City, where you’ll find apartments outfitted with upscale features and a community complete with resort-style amenities. When you live in our luxurious Kansas City apartment community, you can make the most of every day, whether relaxing on your own or spending time with friends. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/97-north-oak/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>You’ll find the perfect setting for your Kansas City life in one of our 1, 2, or 3 bedroom apartment floor plans. Wake up in your spacious bedroom and feel the plush carpeting under your feet while sunbeams shine through your bedroom window. Whether you spend the day binge-watching your favorite TV show in the living room or enjoying a cup of coffee before heading to the office, you’ll feel at home in one of our Kansas City apartments.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/97-north-oak/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Kansas City neighborhood surrounding 97 @ North Oak — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/97-north-oak/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We welcome you to make 97 at North Oak your new home in Kansas City, and we encourage you to bring your pets too! Our spacious floor plans provide plenty of room for your furry friends to roam so your dog can run to their heart’s content in our on-site Bark Park while your cat enjoys a nap under a beam of sunlight in your cozy apartment home. Our pet policy guidelines include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/mo/kansas-city/97-north-oak/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover charming, Craftsman-style buildings set among lush greenery at 97 at North Oak. Picture yourself here, enjoying our <a href=\"/apartments/mo/kansas-city/97-north-oak/amenities\">high-end amenities</a>. Whether you’re getting in some cardio at the fitness center or doing laps at the swimming pool, find your flow here. Then, head to the clubhouse for billiards or to the picnic area to barbecue with neighbors. Everyday living is elevated to picture-worthy perfection at 97 North Oak.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/mark-apts/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Convenience and comfort are at the forefront when you live at <a href=\"/apartments/ms/ridgeland/mark-apts/floor-plans\"><strong>The Mark Apartments</strong></a>. We strive to create a community that is more than just a place to stay but a place where you feel at home at every turn. You’ll be able to take advantage of the many amenities we have to offer, along with simple conveniences like having an apartment with a patio and living at apartments with parking amply available. You’ll also enjoy peace of mind knowing we have a 24/7 on-call maintenance staff ready to help at any time.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/mark-apts/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>1 and 2 Bedroom Apartments in Southeast Ridgeland</strong></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/mark-apts/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Ridgeland neighborhood surrounding Mark Apts. — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/mark-apts/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Mark Apartments knows your pets are part of your family. We’re proud to offer pet-friendly apartments in Ridgeland, MS, that are designed to accommodate your furry friends. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/mark-apts/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Far enough from the hustle and bustle near Madison, our community in Ridgeland, Mississippi, offers a relaxed and quiet refuge where you know you can always return to comfort. Our <a href=\"/apartments/ms/ridgeland/mark-apts/floor-plans\">one and two bedroom apartments</a> for rent in Madison County are an unbeatable combination of comfortable and affordable. Whether you spend your free time lounging by the pool, or playing friendly or competitive matches on the tennis courts, there’s a place for whatever mood to enjoy with friends and neighbors or relax by yourself.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/sunchase-ridgeland-apts/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Upscale and comfortable apartment living in Ridgeland, MS, is made all the easier with the numerous amenities available at Sunchase Ridgeland. In our family- and pet-friendly apartments, take comfort in our spacious apartment community with a fitness center, swimming pool, and more included. Once your day is done, enjoy a night out entertaining friends and family on your private balcony. <a href=\"/apartments/ms/ridgeland/sunchase-ridgeland-apts/floor-plans\"><strong>Find your Ridgeland apartment</strong></a> with us online!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/sunchase-ridgeland-apts/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>You, your family, and your pets deserve a quality place to call home. When you rent one of our studio, 1, or 2 bedroom apartments at Sunchase Ridgeland, you’ll get to experience apartment living in Ridgeland, MS, at its finest. Each of our Ridgeland apartments comes with numerous <a href=\"/apartments/ms/ridgeland/sunchase-ridgeland-apts/amenities\"><strong>amenities</strong></a> and features to make your home as comfortable as possible.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/sunchase-ridgeland-apts/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Ridgeland neighborhood surrounding Sunchase Ridgeland Apts. — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/sunchase-ridgeland-apts/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Pets are a vital part of the family, and at Sunchase Ridgeland, we don’t want you to leave your furry friend behind. That’s why we’re proud to offer pet-friendly apartments at our Ridgeland apartment community. Whether you have an energetic puppy or a cuddly kitten, your pet will experience upscale apartment living by your side inside our spacious and comfortable apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/sunchase-ridgeland-apts/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>As you peruse the photos, one thing becomes clearer and clearer – you were meant to be here. Sunchase proudly offers residents affordable living options within an upscale community so you can enjoy maintenance-free living in a community with a year-round indoor tropical oasis and swimming pool. Sunchase Ridgeland Apartments also features an excellent location near Natchez Trace Parkway and Ross Barnett Reservoir so you can easily get outside and get your heart pumping. You and your <a href=\"/apartments/ms/ridgeland/sunchase-ridgeland-apts/pet-policy\">furry friends</a> will love walking through the lush landscaping and appreciating the intricate detail throughout.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/the-pointe-of-ridgeland/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Point of Ridgeland Apartments, we’ve created a welcoming and vibrant community where you can live, work, and play. Our luxury apartments allow for nature-inspired living in the city, blending a serene country atmosphere with city amenities. From our <a href=\"/apartments/ms/ridgeland/the-pointe-of-ridgeland/pet-policy\"><strong>pet-friendly community</strong></a> to our spacious closets and washer and dryer connections, you’ll love to call The Point of Ridgeland home. Come experience the finest apartment living in Ridgeland, MS. Your dream home is waiting for you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/the-pointe-of-ridgeland/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Pointe of Ridgeland Apartments, we cater to a diverse range of lifestyles, making our <a href=\"/apartments/ms/ridgeland/the-pointe-of-ridgeland/pet-policy\"><strong>pet-friendly community</strong></a><strong> </strong>an ideal place to call home. Explore our 1, 2, and 3 bedroom apartment homes and find the perfect fit for your unique needs.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/the-pointe-of-ridgeland/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Ridgeland neighborhood surrounding The Pointe Of Ridgeland — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/the-pointe-of-ridgeland/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We get it– your pet is a member of your family. That’s why our apartments at The Pointe of Ridgeland are a pet-friendly community, welcoming your furry friend to join you in your luxury living. Take your furry friend on a stroll on our onsite walking trail or cuddle up in your spacious living room!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/the-pointe-of-ridgeland/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Pointe of Ridgeland provides you with the peace and quiet of the country while still offering the conveniences and fun of the city. As you browse the photos of <a href=\"/apartments/ms/ridgeland/the-pointe-of-ridgeland/floor-plans\">our apartments</a> for rent in East Ridgeland, begin to imagine your life here, walking among the lush landscaping around the three-acre pond with your favorite canine in tow. Our community brings together everything you desire most in Ridgeland apartment living – great amenities, an excellent location, and spacious, comfortable floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/trace-apts/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>One of the best things about our Ridgeland apartment community is the several amenities in our apartments and in our community. Searching for apartments with a fitness center or a pet-friendly apartment in Ridgeland? Check and check—you’ll find both at the Trace of Ridgeland.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/trace-apts/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Here at the Trace of Ridgeland, you’ll find nine distinct Ridgeland apartment floor plans to choose from, with both 1 bedroom and 2 bedroom apartments available. Whether you’re a single resident needing space for yourself (and perhaps a furry friend), or looking for a 2 bedroom apartment to make room for your partner or child, you’ll find a great Ridgeland apartment home in our community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/trace-apts/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Ridgeland neighborhood surrounding Trace Apts. — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/trace-apts/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>If you’re in need of a pet-friendly apartment, Trace of Ridgeland is the place for you. When you choose our luxury apartment community, you can bring your furry friends with you when you move in. Cats will love the bright, sunny windows in our Ridgeland apartments and dogs can enjoy the nearby CARA Bark Park.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ms/ridgeland/trace-apts/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Live among the trees in a natural, wooded area in South Ridgeland, Mississippi. Our luxurious property features lush landscaping, as well as a three-acre pond perfect for stretching your legs and enjoying a pleasant afternoon. Residents of our <a href=\"/apartments/ms/ridgeland/trace-apts/pet-policy\">pet-friendly</a> apartments will appreciate the close proximity to Bree’s Bark Park, located minutes away at CARA. We’ve created a welcoming community atmosphere accentuated by stellar amenities like a fitness center with racquetball court, a swimming pool with fountains and a spa, and a clubhouse perfect for gatherings.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our Broken Arrow apartment community features <a href=\"/apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/floor-plans\"><strong>1 and 2 bedroom apartments and lofts</strong></a> decked out with an impressive list of amenities that make your life easier. Luxurious living doesn’t stop when you step outside your front door. Our community also offers many amenities for tenants to enjoy.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find a good fit for your lifestyle in one of our thoughtfully designed 1 and 2 bedroom loft and apartment floor plans. Whether you select our compact, 1 bedroom layout or spacious 2 bedroom lofts, you’ll feel right at home thanks to the several <a href=\"/apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/amenities\"><strong>amenities in our apartment homes</strong></a>. When you choose one of our lofts in Broken Arrow, you’ll also have an optional attached garage add-on.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Broken Arrow neighborhood surrounding Icon at Broken Arrow Apartments — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Icon at Broken Arrow’s pet-friendly apartments in Tulsa are a great place to live for pet owners and their furry friends. Our Broken Arrow apartment community features an on-site dog park where pups can stretch their legs. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Get a glimpse of our luxury apartments in Broken Arrow by perusing photos of our apartment homes and peaceful community. At the bottom of our photo page, you’ll also find a virtual 360° tour that allows you to explore Icon at Broken Arrow anytime, anywhere, on your mobile device or computer. Imagine peaceful mornings sipping coffee on your private balcony or summer weekends spent enjoying a barbecue with friends at the grilling and picnic area.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Park at Mission Hills gives you the amenities and opportunity to create your ideal lifestyle. Our 1 and 2 bedroom apartments and lofts set a standard for comfortable living that extends throughout our grounds. Gourmet kitchens, sleek and stylish appliances, indoor and outdoor entertainment spaces, and an inviting environment are all part of the The Park at Mission Hills experience.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>You need to start with the right canvas to make your home a masterpiece. Explore our catalog of carefully crafted floor plans to find the one best suited for you as you make your dream apartment home a reality. The Park at Mission Hills offers six distinct apartment layouts designed to meet and exceed your needs along with those of your family, and each comes with an extensive set of <a href=\"/apartments/ok/broken-arrow/park-at-mission-hills/amenities\"><strong>amenities</strong></a> to help you make your apartment a home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Broken Arrow neighborhood surrounding Park at Mission Hills — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The pet-friendly apartments at The Park at Mission Hills are an ideal home for cat and dog lovers. Embrace the joy of morning strolls with your pup amid our lush courtyard, and let them explore the outdoors in our on-site Bark Park. And when the weather turns chilly, cats can enjoy the cozy indoor environment as they curl up next to your wood-burning fireplace. Our pet policy includes the following guidelines:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The lifestyle you crave is waiting for you at Park at Mission Hills. Click through the gallery to see all that our <a href=\"/apartments/ok/broken-arrow/park-at-mission-hills/floor-plans\">one and two bedroom apartments and lofts</a> for rent in Broken Arrow, Oklahoma, have to offer you. We designed our spacious homes with large windows so you can enjoy an inviting, light-filled space. Your beautiful gourmet kitchen features stainless appliances, including a handy dishwasher, for a sleek and stylish space. Some of our homes include convenient dining spaces, cozy fireplaces, and soaring vaulted ceilings.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/redbud-ranch/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We encourage you to embrace each day at Redbud Ranch, whether you opt for the comfort of your<strong> </strong><a href=\"/apartments/ok/broken-arrow/redbud-ranch/floor-plans\"><strong>luxurious apartment home</strong></a> or explore our extensive community grounds. Your kitchen boasts stainless steel appliances and ample cupboards, providing the ideal space for preparing breakfast and brewing coffee each morning. Spend your weekends at our on-site pool or picnic area, enjoying the tranquil lifestyle offered by our amenity-filled community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/redbud-ranch/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover your ideal home by exploring our meticulously crafted Broken Arrow apartment floor plans. Redbud Ranch offers diverse layouts, each providing generous living spaces filled with natural light and ample storage in expansive closets. Fireplaces are an option for cozy winter nights at home, and every apartment boasts an array of <a href=\"/apartments/ok/broken-arrow/redbud-ranch/amenities\"><strong>amenities</strong></a>, ensuring your comfort and enjoyment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/redbud-ranch/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Broken Arrow neighborhood surrounding Redbud Ranch — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/redbud-ranch/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Redbud Ranch, your pet is welcome! Our spacious apartments offer a pet-friendly haven with amenities like a dedicated dog park. Check out our pet policies below:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/redbud-ranch/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Enjoy the good life at Redbud Ranch Apartments. More than just a home, our thoughtfully designed community is built to elevate your lifestyle. Browse through our photo gallery and picture yourself working, playing, and relaxing in convenient and comfortable surroundings. Whether you want to get a head start on work in the state-of-the-art business center, tire out your pooch at any of our 3 onsite dog parks, or take a refreshing dip in <a href=\"/apartments/ok/broken-arrow/redbud-ranch/amenities\">the resort-style pool</a>, you’ll find the best of the best here. Experience everything that makes Redbud Ranch Apartments in Broken Arrow, Oklahoma, an exceptional place to live.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>You’ll discover everything you need within Scissortail Crossing’s comfortable luxury apartments and <a href=\"/apartments/ok/broken-arrow/scissortail-crossing/neighborhood\"><strong>beautiful gated community</strong></a> in Broken Arrow. In addition to our apartments’ elegant and essential features, upscale community amenities are just minutes from your front door. With Scissortail Crossing, you can enjoy 24-hour access to the fitness center for your workout routines and a resort-style pool for relaxation and leisure.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our north Broken Arrow apartment community offers six floor plans, each showcasing inviting living and dining spaces and fully equipped kitchens. Choose from our cozy 1 bedroom or versatile 2 bedroom apartments and lofts to find the ideal fit for your lifestyle.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Broken Arrow neighborhood surrounding Scissortail Crossing — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Your pets will flourish and enjoy themselves at Scissortail Crossing Apartments in north Broken Arrow, OK. Our on-site dog park provides ample space for pups to remain active, while the spacious apartment windows allow your cats to bask in the warm sun of Broken Arrow. Our pet policy includes the following guidelines:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore the photo gallery and take in the features and in-home comforts of the one and two bedroom apartments at Scissortail Crossing Apartments. Our centrally located, gated community features luxury amenities curated to enhance your everyday experience. Take a refreshing dip in our <a href=\"/apartments/ok/broken-arrow/scissortail-crossing/amenities\">resort-style pool</a>, and then relax in the cabana with a cool beverage and your favorite magazine. Stop by the internet cafe to fill up your coffee mug, then take your pup to the dog park for some off-leash playtime. And exercise is always an option at any time of the day or year in our 24-hour fitness center.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Trails at Aspen Creek, our cozy apartments and stunning community make everything easily accessible. Across our brand-new apartment community, you’ll discover luxurious amenities just steps away. Whether you enjoy starting your day with an intense workout at the 24-hour fitness center, playing with your canine best friend in our on-site dog park, or unwinding in the resort-style pool with a sun deck in the afternoon, Trails at Aspen Creek caters to all your needs.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Whether you’re living the bachelor’s life in a 1 bedroom space or planning to start a family in a 2 or 3 bedroom apartment, we have the home you’ve been looking for! Kick back, relax, and find your perfect apartment home in our brand-new, upscale Broken Arrow community. Our meticulously designed floor plans are brimming with luxury amenities, including energy-efficient appliances in the kitchen, a private balcony or patio in select homes, and an abundance of closet space. Our smart apartment living features, including Smart Door Locks and Smart Thermostats, are equipped in all floor plans for seamless integration and convenience. Find your perfect apartment home at Trails at Aspen Creek and begin living luxuriously!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Broken  Arrow neighborhood surrounding Trails at Aspen Creek — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Whether you’re a dog enthusiast or a cat lover, our pet-friendly apartments near the University of Oklahoma are perfect for you. At our Broken Arrow community, your furry friends will feel right at home. Our pet policy includes the following guidelines:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find your next home here at Trails at Aspen Creek. Our brand new apartments are spacious, luxurious places to kick back and relax or have friends over for a get together. Discover what makes Trails at Aspen Creek special and rent one of our apartments or townhomes today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our luxury apartment community in Broken Arrow, OK, offers carefully designed <a href=\"/apartments/ok/broken-arrow/villas-at-aspen-park/floor-plans#/\"><strong>six 1 and 2 bedroom floor plans</strong></a> that fit diverse needs. At the Villas at Aspen Park, we provide upscale features and modern community amenities that enhance your lifestyle and provide an elevated level of comfort. Our apartments and lofts have practical features like spacious closets, designer interiors, and a barstool-ready kitchen peninsula.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find exceptional <a href=\"/apartments/ok/broken-arrow/villas-at-aspen-park/pet-policy\"><strong>pet-friendly apartments</strong></a> in the Villas at Aspen Park in Broken Arrow. Our luxurious amenities and abundant features are designed to ensure a cozy and convenient feel, catering to various preferences. Choose between a peaceful 1 bedroom layout or a spacious 2 bedroom retreat from six unique floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Broken Arrow neighborhood surrounding Villas at Aspen Park — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Villas of Aspen Park, we believe that pets are an essential part of your family and deserve the same love and care as any other family member. That’s why we’re proud to be a pet-friendly apartment community that values the significance of your furry friends. We offer an on-site Bark Park to ensure you and your pets can relish the great outdoors together. Our 1- and 2-bedroom floor plans are thoughtfully designed to provide ample space for your pets to play and relax. Some of our apartments also feature a private balcony or patio, providing the perfect spot for your pet to soak up the afternoon sun.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Click through the gallery for a glimpse of what life is like at Villas at Aspen Park. Our <a href=\"/apartments/ok/broken-arrow/villas-at-aspen-park/floor-plans\">one and two bedroom apartments and lofts</a> for rent in Broken Arrow, Oklahoma, offer stylish details throughout. Select homes feature a cozy fireplace, elegant vaulted ceilings, or an extra dining or office nook. Designer paint colors and accent walls add depth and beauty to your home. A handsome kitchen, complete with dishwasher and refrigerator, is the perfect space to try out recipes from your newest cookbook.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/catoosa/bluffs-at-catoosa/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Amenities that keep your day moving.</strong> At Bluffs at Catoosa, you can start with a workout in the fitness center, reset by the pool, or step into the courtyard when you want fresh air close to home. Practical conveniences make just as much of a difference, from in-unit laundry connections, rentable garages, online payments, Flex rent options, and on-site management and maintenance.</p><p>Inside, your apartment is ready for the everyday details: a dishwasher, electric range, refrigerator, large closets, ceiling fan, window coverings, and a comfortable mix of faux wood vinyl flooring and carpeting. Select homes add a patio for an easy outdoor extension, and <a class=\"richtext-link\" href=\"/apartments/ok/catoosa/bluffs-at-catoosa/pet-policy\">pet-friendly living</a> helps home feel complete. See more in the <a class=\"richtext-link\" href=\"/apartments/ok/catoosa/bluffs-at-catoosa/photos\">photo gallery</a> or <a class=\"richtext-link\" href=\"/schedule-a-tour\">schedule a tour</a> to experience the amenities in person.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/catoosa/bluffs-at-catoosa/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Floor plans that keep life moving.</strong> Choose from a variety of apartment floor plans in Catoosa with practical one-bath layouts, generous closet space, and everyday essentials like a dishwasher, electric range, refrigerator, ceiling fan, and window coverings. Select homes add patios, while faux wood vinyl flooring and carpeting create a comfortable, polished finish. Browse featured plans below, then view current pricing and availability.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/catoosa/bluffs-at-catoosa/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Room for the routines you share.</strong> Pet-friendly living at Bluffs at Catoosa is about the everyday details: easy-care faux wood vinyl flooring, large closets for leashes and supplies, and patios in select homes when you want a little fresh air at your door. The courtyard gives you a convenient place to step outside, while on-site maintenance help keep daily pet care uncomplicated. For errands beyond the community, nearby Petco services and local veterinary care make food runs, grooming, training, and checkups easier to fit into the week.</p><p>Have questions about breed guidelines, fees, or choosing the right layout for you and your pet? Explore <a class=\"richtext-link\" href=\"/apartments/ok/catoosa/bluffs-at-catoosa/floor-plans\">available floor plans</a> or <a class=\"richtext-link\" href=\"/apartments/ok/catoosa/bluffs-at-catoosa/contact-us\">contact the leasing team</a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/fountain-lake/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Fountain Lake’s Edmond apartment homes and luxury community feature an impressive list of included amenities. Each apartment home was designed with comfort and style in mind, chock full of features and amenities that elevate your living space. Around our peaceful, gated community, amenities like a full fitness center, grilling and picnic area, and swimming pool with sun deck allow you to seize each day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/fountain-lake/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Fountain Lake’s spacious and thoughtfully designed 1 and 2 bedroom apartments in Edmond come in six different layouts so you can select the best fit for you. Our floor plans offer anywhere from 790 to 1,110 sq. ft. of room to spread out and an open-concept living and dining area. Select one of our floor plans with an attached garage for optimal convenience and privacy. To get an even better idea of our Edmond apartment floor plans, head to our <a href=\"/apartments/ok/edmond/fountain-lake/photos\"><strong>photo gallery</strong></a> and scroll down to take a virtual 360-degree tour.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/fountain-lake/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Edmond neighborhood surrounding Fountain Lake — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/fountain-lake/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Fountain Lake is proud to offer pet-friendly apartments in Edmond, OK. Our resident pups love strolls around our lush, green courtyards, and kitties enjoy frequent sun naps in the natural light from the windows of our apartment homes. The pet policy at Fountain Lake includes the following guidelines:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/fountain-lake/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Browse through our photo gallery and get a glance at everything Fountain Lake Apartments in Edmond has to offer. Take a look at the photos of our luxury apartment homes and resort-style community and picture your life here, going for refreshing swims in our pool or lounging in your cozy living area. In our photo gallery, you’ll also find a virtual 360-degree tour option, which allows you to explore Fountain Lake on your computer or mobile device.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At our apartment community in Edmond, OK, we offer an array of <a href=\"/apartments/ok/edmond/villas-at-stonebridge/floor-plans\"><strong>1, 2, and 3 bedroom floor plans</strong></a> for rent. The apartments at the Villas at Stonebridge enhance your lifestyle to another level of luxury living with numerous modern features and upscale community amenities. Along with our practical apartment features, the homes available for rent at the Villas at Stonebridge conveniently offer amenities like ample closet space, a spacious private patio, and a built-in pantry.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Villas at Stonebridge offers the perfect option for <a href=\"/apartments/ok/edmond/villas-at-stonebridge/pet-policy\"><strong>pet-friendly living in Edmond</strong></a>. With eight unique floor plans to choose from, you’re sure to find your ideal haven. Whether you prefer a cozy 1 bedroom design, a peaceful 2 bedroom apartment, or a spacious 3 bedroom retreat, each apartment in Edmond is thoughtfully appointed with top-quality amenities to make you feel right at home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Edmond neighborhood surrounding Villas at Stonebridge — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Villas at Stonebridge in Edmond is a pet-friendly apartment community that understands how much your pets mean to you. We know they’re a crucial part of your family, so we’re excited to offer streamlined access to the Edmond Dog Park. Whether you have a playful pup or a feline friend, our <a href=\"/apartments/ok/edmond/villas-at-stonebridge/floor-plans\"><strong>1-, 2-, and 3-bedroom floor plans</strong></a> provide enough space for your furry friend to play and rest. Our pet policy includes the following guidelines.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the exceptional range of luxury apartments available at the Villas at Stonebridge in Edmond, OK. Our online photo gallery showcases a diverse selection of stunning options to suit any lifestyle. Experience our dynamic community in person or via a virtual 360° tour of our apartment amenities and floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Reserve at Elm’s upscale apartment community offers a blend of comfortable and versatile living spaces and a selection of convenient amenities to make your time with us as comfortable as possible.<br/><br/><a href=\"/apartments/ok/jenks/the-reserve-at-elm/floor-plans\"><strong>From spacious floor plans</strong></a><strong> </strong>to modern finishes across our community, each apartment is thoughtfully designed to cater to your lifestyle needs. Whether you’re relaxing in the cozy ambiance of your living room or preparing a meal in the fully equipped kitchen, you’ll appreciate the attention to detail and quality craftsmanship found throughout our Jenks apartments.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Designed to exceed expectations, our 1 and 2 bedroom apartments give you a wide selection of layouts and personalized options to make your home your own. <a href=\"/apartments/ok/jenks/the-reserve-at-elm/amenities\"><strong>High-end finishes</strong></a> are not hard to find around every corner, with features like premium lighting, plush carpeting, tiled floors, and stunning accent walls that bring radiance and character into your Jenks apartment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Jenks neighborhood surrounding The Reserve at Elm — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Your cats, dogs, and other pets are welcome members of our luxury apartment community. Our pet-friendly <a href=\"/apartments/ok/jenks/the-reserve-at-elm/amenities\"><strong>on-site amenities</strong></a> offer plenty of space for your pets to play, including our own fenced in dog park in the middle of the apartments. There is also Bark West Dog Park that offers an expansive area for your pup to explore just a block west of The Reserve at Elm. Plus, there is the trail around Veterans Park Pond that many of our residents go to as well. Our pet policy’s guidelines include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a virtual tour of Elm Reserve Apartments and preview a life lived in luxury. Imagine relaxing by the pool, staying active in the fitness center, or enjoying the company of friends and neighbors in our inviting community spaces. To see more, browse photos of our beautifully appointed interiors, resort-style amenities, and scenic surroundings in our online gallery. For a closer look, take a virtual walk-through using our 360-degree digital tours.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/moore/mission-point/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>High-end living starts with a space designed around your needs and lifestyle. Our upscale look is complemented by modern appliances in every room and premium options, including a balcony or toasty fireplace in our 1 and 2 bedroom floor plans. Our outdoor lounge area is a great place to kick back and relax, and your pet will enjoy our spacious <a href=\"/apartments/ok/moore/mission-point/pet-policy\"><strong>on-site dog parks</strong></a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/moore/mission-point/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our thoughtfully designed 1 and 2 bedroom apartments offer spacious environments adaptable to your style and personal touches. Available in six distinct floor plans with options for poolside views, private balconies, fireplaces, and garages, you can customize your living experience to create a home that’s ideal for you at Mission Point.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/moore/mission-point/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Moore neighborhood surrounding Mission Point — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/moore/mission-point/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We invite you and your pets to make your home at Mission Point Apartments in Moore, OK. Cats can relax in comfort in the bright rays of sun that shine into your apartment, and our sizable on-site dog park gives your canine best friend the space to run, play, and enjoy their time outdoors alone or with other dogs as you relax in our nearby lounge.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/moore/mission-point/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Dive into vibrant snapshots showcasing our diverse apartments and community spaces in our photo gallery. Get a first-person sense of the serenity of daily life at Mission Point, from the natural beauty of our communal outdoor areas to the finest details of each floor plan we offer. For a more immersive experience, try our virtual 360-degree tour to see everything in store in your future home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/artisan-crossing-apts/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Comfort awaits you around every corner of our <a href=\"/apartments/ok/norman/artisan-crossing-apts/floor-plans\"><strong>apartment homes</strong></a> and our friendly community. Conveniently store clothing, accessories, and other belongings in the spacious closets in our apartment homes and relax on your private balcony or patio, available in select apartment homes. Throughout our community, you’ll find amenities to suit your unique lifestyle. Keep up with your fitness routine at our 24-hour fitness center, get some work or studying done in our internet cafe, or hang out with friends in the clubhouse.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/artisan-crossing-apts/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Select one of our nine floor plans to find the right Norman apartment layout for your needs. Whether you select one of our Norman 1 bedroom apartments or 2 bedroom townhouses in Norman, you’ll enjoy a roomy and thoughtfully designed layout. Even our smallest apartment floor plan offers a comfortable 789 sq. ft. to accommodate lots of decor and furniture to customize your space.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/artisan-crossing-apts/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Norman neighborhood surrounding Artisan Crossing Apts — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/artisan-crossing-apts/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Whether you’re a dog lover or a cat person, we can accommodate you at our pet-friendly apartments near the University of Oklahoma. Our Norman apartments are a great place to live with dogs, thanks to our on-site dog park and green courtyards. Cats will also feel at home while people-watching in your apartment’s wide windows.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/artisan-crossing-apts/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Live a modern and convenient lifestyle in the heart of Norman, Oklahoma, when you join Artisan Crossing. Wrap up work at the internet cafe and grab a cup of coffee before hitting our <a href=\"/apartments/ok/norman/artisan-crossing-apts/amenities\">state-of-the-art fitness center</a> for a workout. Express your inner chef in your fully equipped kitchen before an evening of cuddling into the couch with your pet. Whether it’s a day out at Ruby Grant Park or a night in with friends playing board games, it’s all effortless here at Artisan Crossing.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Each of our <a href=\"/apartments/ok/norman/cimarron-trails-apts/floor-plans\"><strong>1, 2, and 3 bedroom apartment homes</strong></a> features a variety of amenities to enhance your day-to-day life. Comfort and relaxation extend beyond your apartment home and into the Cimarron Trails community, where you can enjoy amenities like an on-site pool, picnic area, and cozy resident lounge with a fireplace.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Here at Cimarron Trails, we offer a variety of floor plans so you can find the ideal fit for you. From compact 1 bedroom apartments to spacious, two-floor townhomes, our five distinctive layouts offer a private patio or balcony, a kitchen, and a comfortable living and dining area. To get an even better picture of our Norman apartment floor plans, head to our <a href=\"/apartments/ok/norman/cimarron-trails-apts/photos\"><strong>photo gallery</strong></a>, which includes snapshots of our apartment community and a virtual tour.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Norman neighborhood surrounding Cimarron Trails Apts. — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find the ideal home for you and your furry friends here at Cimarron Trails, where you’ll find pet-friendly apartments near the University of Oklahoma. Check out our <a href=\"/apartments/ok/norman/cimarron-trails-apts/floor-plans\"><strong>floor plans</strong></a> to find the best layout to accommodate you and your pets. Our policy includes the following guidelines: </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/norman/cimarron-trails-apts/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>If coming home to a welcoming community filled with life-enhancing, <a href=\"/apartments/ok/norman/cimarron-trails-apts/amenities\">time saving amenities</a> sounds like something worth exploring, take a moment to peruse our photo gallery and start imagining your new life in our pet-friendly apartment and townhomes. You will love the relaxed yet modern lifestyle that’s waiting for you at Cimarron Trails Apartments in Norman, near South OKC. Whether your day starts with a hot cup of coffee freshly prepared in your cozy kitchen or an invigorating swim in the outdoor pool, you will find the perfect space you need to make it happen in our pet-friendly apartment community near University of Oklahoma.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At our Oklahoma City apartment community, you’ll find opulent amenities in our apartments and throughout our inviting community. Our apartments are equipped with stylish and comfortable features that will make your Oklahoma City apartment feel like home. You’ll also find amenities throughout our community that help you lead a fulfilling life each and every day. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We offer 12 unique floor plans at our <a href=\"/apartments/ok/oklahoma-city/24hundred-apartments/neighborhood\"><strong>Oklahoma City apartment community</strong></a>, each offering the perfect backdrop to your lifestyle. Even our smallest 1-bedroom apartments in Oklahoma City offer nearly 800 sq. ft. of space so you can settle in and get comfortable without feeling cramped. For those wanting extra room and privacy, we recommend one of our Oklahoma City lofts, offering an optional attached garage.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Oklahoma City neighborhood surrounding 24Hundred Apartments — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We invite you to bring your pets to live at 24Hundred, where you’ll find comfortable, stylish, pet-friendly apartments in Oklahoma City. Our larger loft and townhome floor plans offer plenty of space for your pets to get cozy. Plus, thanks to our on-site dog park, you can spend quality time with your pup while staying close to home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Have a look. You’ll notice a<a href=\"/apartments/ok/oklahoma-city/24hundred-apartments/amenities\"> new covetable feature</a> with every next glance. The newly designed, sleek interior finishes accentuate an open layout and high ceilings to give your home a consistent aesthetic backdrop. We invite you to imagine your new home with us. Whether cooking in your modern kitchen, curling up to read next to the fireplace in select units, or letting the sunshine warm you with your morning cup of coffee on your private patio or balcony in select units, every inch of your new home suffuses a sense of comfort, no matter what you’re doing.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Chisholm Pointe in Oklahoma City, we offer a range of luxurious and convenient duplexes and quadplexes in <a href=\"/apartments/ok/oklahoma-city/chisholm-pointe/floor-plans\"><strong>five uniquely designed floor plans</strong></a>. These Oklahoma City homes feature modern finishes and upscale amenities to meet your needs and heighten your life, providing a gourmet kitchen with energy-efficient appliances, spacious closets, and fenced yards.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Chisholm Pointe is your ultimate solution for exceptional <a href=\"/apartments/ok/oklahoma-city/chisholm-pointe/pet-policy\"><strong>pet-friendly apartment living in Oklahoma City</strong></a>. We offer seven distinct floor plans that meet various needs and preferences, from a cozy 1 bedroom apartment to a serene 2 bedroom design and a spacious 3 bedroom retreat. Each apartment is thoughtfully equipped with top-of-the-line amenities to ensure you feel right at home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Oklahoma City neighborhood surrounding Chisholm Pointe — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Chisholm Pointe, we take great pride in being a pet-friendly duplex and quadplex community near the <a href=\"/apartments/ok/oklahoma-city/chisholm-pointe/neighborhood\"><strong>Stonegate neighborhood in Oklahoma City</strong></a>. We understand how important pets are to the family, which is why our 1-, 2-, and 3-bedroom floor plans are thoughtfully designed with open-concept living spaces that provide generous accommodations for playtime. Our on-site bark park and fenced-in yards offer a delightful space for your pets to romp and play, while the nearness of Louis A. Macklanburg Park provides an ideal venue for evening play sessions.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our gallery offers a glimpse into life at Chisholm Pointe, a brand-new residential community that delivers on class and comfort. Browse through our photos to see how our luxury homes and amenities can enhance your lifestyle. Residents enjoy access to a state-of-the-art fitness center, a pickleball court, and a variety of outdoor lounge areas. If you like what you see, call and speak to a leasing agent today to schedule your personalized tour. An upgraded lifestyle in Oklahoma City awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Apartments and townhomes in our family-friendly community offer a variety of amenities to suit any lifestyle. At the end of the day, you’ll enjoy the comforts and conveniences of home in our apartments and townhomes. When you’ve got some free time, we invite you to relax around our peaceful apartment community, featuring amenities around every corner.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find the right apartment home for your lifestyle by browsing our many floor plans, including 1-, 2-, and 3-bedroom apartment and townhouse options. Each apartment has welcoming living and dining areas where you can enjoy binging your favorite TV show or hosting friends. Once you’ve browsed our floor plan options, get an even better look at them by browsing our <a href=\"/apartments/ok/oklahoma-city/cimarron-pointe-apts/photos\"><strong>photo gallery</strong></a> or <a href=\"https://app.tour24now.com/prospect/tour/cimarron-pointe/register/\" target=\"_blank\"><strong>scheduling a tour</strong></a>. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Oklahoma City neighborhood surrounding Cimarron Pointe Apts. — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find a pet-friendly apartment that you and your furry friends will love at Cimarron Pointe. Our Oklahoma City apartment community features lush courtyards and an on-site bark park, perfect for letting your pup stretch his legs.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Get ready to picture yourself living well at Cimarron Pointe Apartments in Oklahoma City. As you explore our photo gallery, start to think about how you might take advantage of the in-home features and community amenities. With<a href=\"/apartments/ok/oklahoma-city/cimarron-pointe-apts/floor-plans\"> one, two, and three bedroom floor plans</a> to choose from, you can find the perfect fit for your furniture and belongings. Think about how you might decorate your new space. Picture your pet lounging cozily beside a working fireplace or strolling happily through the beautiful landscape. It’s all part of the everyday lifestyle in your new OKC apartment or townhome.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Equipped with all the essential amenities you could need, our <a href=\"/apartments/ok/oklahoma-city/council-place-apartments/floor-plans\"><strong>1, 2, and 3 bedroom apartments</strong></a> serve as an ideal canvas for your style. Each apartment home has a private balcony or patio, an ideal spot for potted plants. Amenities like our on-site pool and fitness center allow you to stay active daily around our community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Each floor plan at our Oklahoma City apartment community is thoughtfully designed with comfort in mind, offering a variety of <a href=\"/apartments/ok/oklahoma-city/council-place-apartments/amenities\"><strong>amenities</strong></a>. A bright, airy living and dining area greets you as you come home each day—the ideal spot for cushy couches and a bistro table with chairs. The in-home washer and dryer, included in every floor plan, simplifies laundry days. We offer 1 bedroom, 1 bedroom with a den, 2 bedroom, and 3 bedroom floor plans with 500 to 1,010 sq. ft.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Oklahoma City neighborhood surrounding Council Place Apartments — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Residents and their pets will enjoy living in one of Council Place’s pet-friendly apartments in Oklahoma City. Cats and dogs are welcome to live in our community, given that residents adhere to the following pet policies:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore our photo gallery to get a feel for what life is like in our Northwest Oklahoma City apartment community in Northhaven. Take a tour through our <a href=\"/apartments/ok/oklahoma-city/council-place-apartments/floor-plans\">one, two, and three bedroom floor plans</a> and start to picture how you might live your best life in our pet-friendly apartments. Think about which floor plan has the space you need to arrange your furniture just how you like. Looking for a private outdoor space where you can rest and relax after a long day? Just put a couple deck chairs and potted plants on your private patio or balcony to turn it into a soothing oasis where you can put up your feet at the end of a long day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Cross Timber offers luxury living in Oklahoma City, with a wide range of amenities available in our apartment homes and around our community. Beautiful, modern features elevate your living space while essential amenities complement your daily routine. As you explore our community, discover lux amenities that can help you rest and refresh or stay active. For an even better sense of our features and community amenities, browse our <a href=\"/apartments/ok/oklahoma-city/cross-timber/photos\"><strong>photo gallery</strong></a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Spread out and get comfortable in one of our spacious 2 or 3 bedroom apartments in OKC, which includes all the <a href=\"/apartments/ok/oklahoma-city/cross-timber/amenities\"><strong>amenities</strong></a> you need to live comfortably and modern finishes to elevate your living space’s style. Our floor plans offer 929 to 1,204 sq. ft. of room, spacious closets, and open-concept living. Natural light floods through the wide windows in our apartment homes, giving your space an airy, bright feeling.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Oklahoma City neighborhood surrounding Cross Timber — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Cross Timber’s pet-friendly apartments in Oklahoma City offer you and your pet a comfortable living environment. Whether you’re a dog or cat owner, we welcome you to bring your pet when you move into your new apartment home. Cross Timber even offers an on-site dog park where your dog can enjoy some exercise.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/cross-timber/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Glimpse the good life in Cross Timber by browsing our photos. We’ve included pictures of our apartment homes and our community spaces so you can imagine what life is like in our picturesque Oklahoma City apartments. Below our photos, you’ll find a virtual 360-degree tour that allows you to take an even closer look at Cross Timber.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The amenities at Crown Pointe Apartments will complement your day-to-day life with a blend of essential features and stylish touches. Beyond our apartment homes, our Oklahoma City apartment community has much to offer, with lux amenities around every corner, connected by lush green courtyards and manicured paths. No matter what <a href=\"/apartments/ok/oklahoma-city/crown-pointe-apartments/floor-plans\"><strong>floor plan</strong></a> you select, our amenities are sure to elevate your daily routine.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Crown Pointe offers spacious 1 and 2 bedroom apartments with over 800 sq. ft. of space and well-designed layouts. The <a href=\"/apartments/ok/oklahoma-city/crown-pointe-apartments/amenities\"><strong>amenities</strong></a> included in every apartment home will make your daily routine a breeze and the stylish touches around our apartments create the ideal backdrop for your unique style. The oversized windows and neutrally colored walls give your apartment home an airy feeling while plush carpeting cushions your every step. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Oklahoma City neighborhood surrounding Crown Pointe Apartments — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Enjoy a comfortable, peaceful living environment for pet owners and their furry friends. Dogs love strolls along our well-manicured walking paths and green courtyards, and cats enjoy sunbathing in the light of the expansive windows. Our pet policy includes the following guidelines:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Browse pictures of Crown Pointe Apartments in Oklahoma City and envision a peaceful life in our serene, gated community. We’ve included photos of our beautiful apartment homes and luxury community amenities so you can get a good idea of what we offer. If you scroll to the bottom of our photo gallery, you’ll also find a virtual 360-degree tour of our Oklahoma City apartment community that allows you to explore Crown Pointe from the comfort of your couch.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>All the amenities at Hunter’s Ridge Apartments in Oklahoma City ensure comfortable and easy living. Our <a href=\"/apartments/ok/oklahoma-city/hunter-s-ridge-apts/floor-plans\"><strong>1- and 2-bedroom apartment floor plans</strong></a> include essential amenities and cozy features and finishes. At Hunter’s Ridge Apartments, you’ll enjoy community amenities like an outdoor pool and hot tub, an on-site laundry facility, and a resident lounge.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Browse our 1 and 2 bedroom apartment floor plans and find the layout that suits your needs and lifestyle, whether that’s our compact, efficient layout or our expansive 2 bed/2 bath with over 1,000 sq. ft. of living space. Alongside <a href=\"/apartments/ok/oklahoma-city/hunter-s-ridge-apts/amenities\"><strong>essential amenities</strong></a>, like a fully equipped kitchen and air conditioning, several of our apartments include optional extras like fireplaces or a private balcony, patio, or sunroom.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Oklahoma City neighborhood surrounding Hunter's Ridge Apts. — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find the ideal home for you and your furry friends in one of Hunter’s Ridge’s pet-friendly apartments in Oklahoma City. Browse our <a href=\"/apartments/ok/oklahoma-city/hunter-s-ridge-apts/floor-plans\"><strong>1- and 2-bedroom apartment floor plans</strong></a> to find a good fit for you and your pets.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter's-ridge-apts/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>All the amenities at Hunter’s Ridge Apartments in Oklahoma City ensure comfortable and easy living. Our <a href=\"/apartments/ok/oklahoma-city/hunter-s-ridge-apts/floor-plans\"><strong>1- and 2-bedroom apartment floor plans</strong></a> include essential amenities and cozy features and finishes. At Hunter’s Ridge Apartments, you’ll enjoy community amenities like an outdoor pool and hot tub, an on-site laundry facility, and a resident lounge.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter's-ridge-apts/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Browse our 1 and 2 bedroom apartment floor plans and find the layout that suits your needs and lifestyle, whether that’s our compact, efficient layout or our expansive 2 bed/2 bath with over 1,000 sq. ft. of living space. Alongside <a href=\"/apartments/ok/oklahoma-city/hunter-s-ridge-apts/amenities\"><strong>essential amenities</strong></a>, like a fully equipped kitchen and air conditioning, several of our apartments include optional extras like fireplaces or a private balcony, patio, or sunroom.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter's-ridge-apts/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Oklahoma City neighborhood surrounding Hunter's Ridge Apts. — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter's-ridge-apts/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find the ideal home for you and your furry friends in one of Hunter’s Ridge’s pet-friendly apartments in Oklahoma City. Browse our <a href=\"/apartments/ok/oklahoma-city/hunter-s-ridge-apts/floor-plans\"><strong>1- and 2-bedroom apartment floor plans</strong></a> to find a good fit for you and your pets.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/hunter's-ridge-apts/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>You can glimpse our Oklahoma City apartment community by browsing our photo gallery, which includes snapshots of our apartment homes and community amenities. We also offer a virtual 360-degree tour of Hunter’s Ridge Apartments via our photo gallery, allowing you to explore our community from anywhere on your mobile device or computer.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/park-at-tuscany/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>When you rent a luxury apartment at Park at Tuscany, you receive more than the standard. With the power of our many amenities to enhance your experience, you and your loved ones will unlock upscale apartment living in Oklahoma City, OK. See all we offer and <a href=\"/apartments/ok/oklahoma-city/park-at-tuscany/floor-plans\"><strong>find your Oklahoma City apartment</strong></a> online today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/park-at-tuscany/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Make your new home in one of our 1 or 2 bedroom<strong> </strong>apartment homes, available in six customizable layouts so you can find the ideal match for your lifestyle. With floor plans ranging in area from 789 to 1176 sq. ft., our apartment community has the <a href=\"/apartments/ok/oklahoma-city/park-at-tuscany/amenities\"><strong>features</strong></a> and options to accommodate single renters and families alike.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/park-at-tuscany/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Oklahoma City neighborhood surrounding Park at Tuscany — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/park-at-tuscany/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We want you to make your Park at Tuscany apartment feel like home, so we welcome cats, dogs, and other pets with open arms. Whether it’s spacious interiors for your cat to perch or outdoor spaces for your dog to roam, we strive to make every corner of your apartment comfortable for your whole family, pets included.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/park-at-tuscany/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a virtual journey through our apartments in Oklahoma City. Our photo gallery captures the essence of our unique and sophisticated style, showcasing the thoughtful details and modern amenities that define our living spaces. From the inviting living rooms to the well-appointed kitchens, see for yourself what a Park at Tuscany home can offer you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/persimmon-square-apartments/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We offer abundant amenities to make our Oklahoma City apartments at Persimmon Square community feel like home. Our apartment homes feature comfortable features like spacious kitchens and stylish finishes like wood-style flooring. Additionally, you can bask in the sun at the beautiful outdoor swimming pool or unwind in the inviting resident lounge.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/persimmon-square-apartments/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Persimmon Square, there are seven unique and spacious floor plans to choose from, encompassing 1 and 2 bedroom apartments. With a wide range of choices available, you’ll easily find the ideal fit for your lifestyle. Each floor plan boasts large closets and bright, airy living spaces and ranges from 550 to 1,300 sq. ft.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/persimmon-square-apartments/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Oklahoma City neighborhood surrounding Persimmon Square Apartments — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/persimmon-square-apartments/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Persimmon Square Apartments in Oklahoma City, we offer pet-friendly living, allowing you and your pet to coexist harmoniously. The large windows in our apartments provide the ideal spot for dogs and cats to bask in the sunlight for hours on end. Here are the pet policy guidelines:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/persimmon-square-apartments/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Check out our photo gallery to explore the apartment homes and community at Persimmon Square. Here, you can view snapshots of our floor plans and amenities. Additionally, you can take a virtual tour of our wheelchair-accessible apartments online or <a href=\"/apartments/ok/oklahoma-city/persimmon-square-apartments/contact-us\"><strong>schedule an in-person tour</strong></a> with the assistance of our helpful staff.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Comfort and luxury are the core tenets that guide the design and features of our upscale apartment community at Prairie Springs. In addition to the variety of spacious floor plans we offer to accommodate the diverse lifestyles and preferences of each of our residents, you can expect a set of premium amenities to accompany and accommodate you in your new apartment home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>A comfortable living experience is built on a foundation of flexibility, and Prairie Springs offers a wide range of diverse layouts in our 1, 2, and 3 bedroom apartments. Available in a staggering 18 unique floor plans, each of our apartments in Oklahoma City allows you to customize your living space so you can thrive in your new home. Choose between apartments with an optional balcony, fireplace, attached garage, and other lifestyle-enhancing features that help you truly feel at home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Oklahoma City neighborhood surrounding Prairie Springs I — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Prairie Springs, we understand that pets are an important part of your family, so we proudly offer pet-friendly apartments in OKC. We welcome cats and dogs to join our vibrant community, creating a welcoming environment for all residents and their furry companions. Our pet policy is designed to ensure the comfort and safety of all residents, with guidelines including:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a virtual tour of our luxurious apartments, state-of-the-art amenities, and lush landscaping with our online photo gallery. Imagine yourself relaxing by the pool, hosting friends in our clubhouse, or enjoying a peaceful evening on your private balcony before you visit our community, giving you the confidence that Prairie Springs is the right place for you. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/stonehorse-crossing/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Your luxurious living experience in north Oklahoma City is defined by the features that make Stonehorse Crossing exceptional. From the moment you step inside our meticulously crafted apartment homes, you’ll be greeted by an array of upscale finishes, whether it’s the sleek design of our modern kitchens, the spaciousness of our living areas, or the tranquility of our private balconies or patios.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/stonehorse-crossing/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We take pride in the care we put into designing every home in Stonehorse Crossing. Each residence is thoughtfully crafted to provide the utmost comfort, convenience, and style for modern living. Starting at 789 sq. ft., we offer 1 and 2 bedroom apartment homes as well as townhouses to give you the ability to customize your living experience with a floor plan that matches your lifestyle.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/stonehorse-crossing/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Oklahoma City neighborhood surrounding Stonehorse Crossing — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/stonehorse-crossing/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our community welcomes you and your whole family to make a home at Stonehorse Crossing, especially your pets. Your dog will find a paradise here with our wide open areas in our courtyard for them to explore and our on-site dog park, which we call “Canine Crossing” is great for pets that want to play or lounge under the sun. We love cats too, and many of our feline residents can regularly be seen relaxing on their windowsills as they watch over our gorgeous pet-friendly community. Our pet policy guidelines include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/stonehorse-crossing/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><a href=\"https://viewer.panoskin.com/?tour=62fe326a53dd6e409cd861a0\" target=\"_blank\"><strong>Take a virtual tour</strong></a> of Stonehorse Crossing Apartments and envision yourself living in luxury. Browse through our photo gallery to explore our beautifully landscaped grounds, modern interiors, and resort-style amenities. From our inviting clubhouse to our serene outdoor spaces, see why Stonehorse Crossing Apartments is the premier destination for upscale living in OKC.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summerfield-place-apts/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>You’ll have plenty of space in our <a href=\"/apartments/ok/oklahoma-city/summerfield-place-apts/floor-plans\"><strong>1 and 2 bedroom Oklahoma City apartments</strong></a> to show off your home décor, complemented with contemporary amenities and modern finishes. Enjoy the comfort of plush carpeting in your apartment, enhanced by energy-efficient appliances and a spacious kitchen that simplifies daily tasks. When you’re not relaxing in your apartment, take advantage of various community amenities, including our inviting outdoor pool.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summerfield-place-apts/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover a range of meticulously designed apartment floor plans at Summerfield Place near the <a href=\"/apartments/ok/oklahoma-city/summerfield-place-apts/neighborhood\"><strong>Quail Creek neighborhood</strong></a>, each tailored to complement your lifestyle in Oklahoma City. Experience a stylish living space adorned with plush carpeting and hardwood floors that exude sophistication. Step into your inviting 1 bedroom or 2 bedroom apartment with optional bay windows, where comfort awaits in the welcoming entryway living area.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summerfield-place-apts/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Oklahoma City neighborhood surrounding Summerfield Place Apts. — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summerfield-place-apts/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We highly recommend bringing your furry friends along if you’re considering living in our Oklahoma City apartment community. Both cats and dogs are warmly welcomed in our Oklahoma City apartments, offering pet-friendly <a href=\"/apartments/ok/oklahoma-city/summerfield-place-apts/amenities\"><strong>amenities</strong></a> like patios and balconies for basking in the sun and our spacious on-site dog park for your canine companions. Here are the guidelines outlined in our pet policy.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summerfield-place-apts/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore our photo gallery to envision your experience at Summerfield Place Apartments. Take a glimpse into our contemporary and new Oklahoma City apartments and luxurious amenities, including the clubhouse and community courtyard. Envision unwinding after a long day at work in the comfort of your inviting Oklahoma City apartment featuring carefully crafted, spacious floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summit-ridge-villas/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Chisholm Pointe in Oklahoma City, we offer a range of luxurious and convenient duplexes and quadplexes in <a href=\"/apartments/ok/oklahoma-city/chisholm-pointe/floor-plans\"><strong>five uniquely designed floor plans</strong></a>. These Oklahoma City homes feature modern finishes and upscale amenities to meet your needs and heighten your life, providing a gourmet kitchen with energy-efficient appliances, spacious closets, and fenced yards.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summit-ridge-villas/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Oklahoma City neighborhood surrounding Summit Ridge Villas — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summit-ridge-villas/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Chisholm Pointe, we take great pride in being a pet-friendly duplex and quadplex community near the <a href=\"/apartments/ok/oklahoma-city/chisholm-pointe/neighborhood\"><strong>Stonegate neighborhood in Oklahoma City</strong></a>. We understand how important pets are to the family, which is why our 1-, 2-, and 3-bedroom floor plans are thoughtfully designed with open-concept living spaces that provide generous accommodations for playtime. Our on-site bark park and fenced-in yards offer a delightful space for your pets to romp and play, while the nearness of Louis A. Macklanburg Park provides an ideal venue for evening play sessions.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summit-ridge-villas/summit-villas/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Chisholm Pointe in Oklahoma City, we offer a range of luxurious and convenient duplexes and quadplexes in <a href=\"/apartments/ok/oklahoma-city/chisholm-pointe/floor-plans\"><strong>five uniquely designed floor plans</strong></a>. These Oklahoma City homes feature modern finishes and upscale amenities to meet your needs and heighten your life, providing a gourmet kitchen with energy-efficient appliances, spacious closets, and fenced yards.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summit-ridge-villas/summit-villas/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Host game nights and dinner parties at Summit Villas, or lounge on the couch with your dog or cat in our open-concept living and dining areas. Enjoy the updated finishes throughout the duplex, including spacious closets, quartz countertops, and energy-efficient stainless steel appliances. Experience the ideal combination of comfort and sophistication at the Summit Villas Duplexes in Oklahoma City.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summit-ridge-villas/summit-villas/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Oklahoma City neighborhood surrounding Summit Ridge Villas — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summit-ridge-villas/summit-villas/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Chisholm Pointe, we take great pride in being a pet-friendly duplex and quadplex community near the <a href=\"/apartments/ok/oklahoma-city/chisholm-pointe/neighborhood\"><strong>Stonegate neighborhood in Oklahoma City</strong></a>. We understand how important pets are to the family, which is why our 1-, 2-, and 3-bedroom floor plans are thoughtfully designed with open-concept living spaces that provide generous accommodations for playtime. Our on-site bark park and fenced-in yards offer a delightful space for your pets to romp and play, while the nearness of Louis A. Macklanburg Park provides an ideal venue for evening play sessions.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/summit-ridge-villas/summit-villas/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our gallery offers a glimpse into life at Chisholm Pointe, a brand-new residential community that delivers on class and comfort. Browse through our photos to see how our luxury homes and amenities can enhance your lifestyle. Residents enjoy access to a state-of-the-art fitness center, a pickleball court, and a variety of outdoor lounge areas. If you like what you see, call and speak to a leasing agent today to schedule your personalized tour. An upgraded lifestyle in Oklahoma City awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/tammaron-village-apartments/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>With luxury amenities designed to enhance your daily life, Tammaron Village Apartments provides a true sense of home. Beyond your <a href=\"/apartments/ok/oklahoma-city/tammaron-village-apartments/floor-plans\"><strong>studio, 1, or 2 bedroom apartment</strong></a>, a range of community amenities, such as a lavish clubhouse and two outdoor swimming pools, guarantees you’ll always find entertainment and relaxation.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/tammaron-village-apartments/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Tammaron Village near <a href=\"/apartments/ok/oklahoma-city/tammaron-village-apartments/neighborhood\"><strong>the Northaven neighborhood</strong></a>, discover a diverse selection of studio, 1, and 2 bedroom apartment layouts tailored to your preferences. Our Oklahoma City residences boast a range of <a href=\"/apartments/ok/oklahoma-city/tammaron-village-apartments/amenities\"><strong>amenities</strong></a> and living spaces spanning from 500 to 850 sq. ft. Additionally, we feature floor plans designed for those seeking shared living arrangements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/tammaron-village-apartments/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Oklahoma City neighborhood surrounding Tammaron Village Apartments — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/tammaron-village-apartments/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Tammaron Village, near the Harvest Hills neighborhood in Oklahoma City, provides pet-friendly apartments for pet owners and their beloved furry friends. Our apartments warmly embrace dogs and cats, offering community <a href=\"/apartments/ok/oklahoma-city/tammaron-village-apartments/amenities\"><strong>amenities</strong></a> like an on-site dog park for your pet to socialize, play, and enjoy a good stretch. The pet policy at Tammaron Village comprises the following guidelines.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/tammaron-village-apartments/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>For a tranquil living experience surrounded by green space, discover comfortable living at Tammaron Village Apartments. As a resident of our Northwest Oklahoma City, Oklahoma, apartments, you can treat yourself to the height of relaxation. Your <a href=\"/apartments/ok/oklahoma-city/tammaron-village-apartments/floor-plans\">spacious apartment home</a> is designed with a variety of updated features for you to enjoy. Prepare your favorite meals in your beautifully appointed kitchen and simplify your cleaning routine with the help of the spacious dishwasher. Maximize your downtime and reduce your chores thanks to your very own washer and dryer in select homes. With the added convenience of two on-site laundry facilities, our community is carefully crafted to enrich your life.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/warrington-apartments/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover our meticulously crafted <a href=\"/apartments/ok/oklahoma-city/warrington-apartments/floor-plans\"><strong>1 and 2 bedroom apartments</strong></a> in Oklahoma City, blending the essence of home comforts with a touch of sophistication. Experience the convenience of essential features within our apartments that simplify your daily living. Uncover a range of community amenities thoughtfully tailored to elevate your everyday routine and enrich your leisure activities.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/warrington-apartments/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>There are eight floor plans to choose from at The Warrington, ranging in size from 624 to 1,065 sq. ft. Opt for 1 or 2 bedroom townhomes conveniently situated near the <a href=\"/apartments/ok/oklahoma-city/warrington-apartments/amenities\"><strong>Val Verde neighborhood</strong></a> for more natural light and creative freedom in home décor. Revel in every moment at The Warrington Apartments, which has exquisite interior features and ample living space.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/warrington-apartments/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Oklahoma City neighborhood surrounding Warrington Apartments — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/warrington-apartments/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Warrington, our spacious, pet-friendly apartments offer the perfect setting for your cherished dogs and cats. Moreover, our community boasts pet-friendly <a href=\"/apartments/ok/oklahoma-city/warrington-apartments/amenities\"><strong>amenities</strong></a>, including plenty of green space for your pets to enjoy amid our beautifully landscaped grounds. Below are our pet policy guidelines.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/warrington-apartments/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience our apartment community near Beacon Hills through our photo gallery, which offers a visual journey showcasing the highlights of The Warrington. Enjoy a refreshing moment of relaxation in our courtyard under the warm summer breeze, or embrace the cozy ambience of our wood-burning fireplace on a crisp autumn evening.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Waters Edge is more than just a place to lay your head at night. We’re a true community with amenities that make your life easier and more fun! Our <a href=\"/apartments/ok/oklahoma-city/waters-edge-apartments/floor-plans\"><strong>luxury apartments</strong></a> include a washer and dryer, pools, and a delightful grilling area. Plus, with preinstalled WiFi from our partners at Cox, we make it easy to set up for working and playing at home. Find your apartment for rent in Oklahoma City.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Coming home from a long day at school or work should feel like coming home—even if it’s simply turning off your laptop and making a drink in your kitchen. With <a href=\"/apartments/ok/oklahoma-city/waters-edge-apartments/amenities\"><strong>high-speed internet</strong></a>, high-quality furnishings, and spacious floor plans, Waters Edge has what you need.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Oklahoma City neighborhood surrounding Waters Edge Apartments — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Here at Waters Edge Apartments, we know your furry friends are a part of your family. That’s why we’re proud to provide our Oklahoma City pet-friendly apartments. From kittens and puppies to grown cats and dogs, our residents love their pets—and so do we.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>As you browse through our photo gallery for a peek at our lovely property and extensive amenities, one thing becomes clearer and clearer – you were meant to be here. Our <a href=\"/apartments/ok/oklahoma-city/waters-edge-apartments/floor-plans\">studio, one and two bedroom apartments</a> for rent in Oklahoma City, Oklahoma, have everything you need to live well. Enjoy a fully equipped kitchen with plenty of space for all of your cooking essentials. Individual heating and air conditioning mean you can keep the temperature just the way you like it. Our homes come with a washer and dryer and spacious walk-in closets. The Waters Edge community is pet-friendly, so we look forward to welcoming your four-legged friend to the neighborhood.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Zeal at Quail in vibrant Oklahoma City, choose from stylish one and two-bedroom duplex floor plans that cater to your lifestyle. Each home offers modern amenities and a welcoming atmosphere. Browse our available options today to find the ideal space that fits your vision of comfort and convenience.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Zeal at Quail in Oklahoma City, your furry companions are cherished guests! With no weight limits and space for two pets, you can make your luxury duplex truly feel like home. Just check in with us about breed specifics — together, we can create a pet-friendly paradise!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/coffee-creek/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Craft your signature lifestyle at Coffee Creek Apartments, where our carefully curated amenities seamlessly enhance your everyday experience with a fusion of practicality and sophistication. Our washer and dryer-ready <a href=\"/apartments/ok/owasso/coffee-creek/floor-plans\"><strong>1 and 2 bedroom apartments</strong></a> boast modern appliances and a sizable kitchen for dinner parties and casual gatherings. Outside, lush green courtyards surround our apartment homes, providing the perfect backdrop for our elegant community..</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/coffee-creek/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Coffee Creek Apartments, we pride ourselves on offering a range of spacious and thoughtfully designed 1 and 2 bedroom apartments that cater to diverse personal preferences. Choose from six distinctive layouts ranging in size from 789 to 1176 sq. ft., each crafted with style and convenience as the driving force behind our design to ensure maximum comfort and functionality.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/coffee-creek/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Owasso neighborhood surrounding Coffee Creek — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/coffee-creek/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Your pet is part of your family, and we welcome them to become part of the Coffee Creek community, too. Keep your dogs entertained and well exercised in our on-site Bark Park as your cats relax in the sun in your comfortably carpeted apartment home. We encourage you to bring your pets with you as you make Coffee Creek your home with the following guidelines:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/coffee-creek/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Get the complete picture of everything Coffee Creek has to offer by exploring our online photo gallery. See for yourself the beautiful scenery surrounding each apartment home and step inside to appreciate the full potential of each space. For an even more in-depth look, scroll down to use our virtual 3D tour tool and explore each corner of the Coffee Creek community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Cottages at Tallgrass Point’s selection of features and amenities have been carefully designed to maintain the accommodating and elegant environment our residents value. The moment you step into our Owasso apartments, you’ll be greeted by an opulent lobby that sets the tone for our entire living community. Whether you seek relaxation by our resort-style pool, an energizing workout in our state-of-the-art fitness center, or a leisurely stroll through our meticulously landscaped grounds, every detail has been considered to enhance your experience inside your apartment and throughout our community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Keeping with our upscale theme, each of our 1 and 2 bedroom apartments helps create a stylish living space that is as comfortable as it is well equipped. Available in six configurations ranging from 789 to 1,267 sq. ft., our 1 and 2 bedroom apartments are available with customizable features, including a wood-burning fireplace or private balcony with scenic views, allowing you to find the right balance between the space you need and the lifestyle you’d like to live.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Owasso neighborhood surrounding Cottages at Tallgrass Point — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><br/>Cottages at Tallgrass Point is proud to be a pet-friendly community. Our commitment to providing a welcoming environment for all our residents is evident in our on-site Bark Park and our large courtyard with a path that is perfect for walks all year long. <a href=\"/apartments/ok/owasso/cottages-at-tallgrass-point/floor-plans\"><strong>Our apartments</strong></a> are pet-approved and ready for you and your whole family to make Cottages at Tallgrass Point your home. Our pet policy is as follows:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Each residence offers ample living space and a bright, airy atmosphere, providing a canvas for you to personalize and make your own. Take a step into our community from the comfort of your home with our online photo gallery. Along with our high-definition photographs, you can become intimately acquainted with your future home through our 360-degree virtual walkthrough, offering a first-person perspective of every corner of Cottages at Tallgrass Point.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cypress-crossing/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>From thoughtful in-home features to impressive shared spaces, our amenities showcase the level of luxury and comfort every resident can enjoy at Cypress Crossing. Explore our full range of features to get a glimpse of what life could be like in your new home!<br/></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cypress-crossing/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Finding a place to call home has never been easier with our newly built <strong><a href=\"/apartments/ok/owasso/cypress-crossing/neighborhood\">Owasso apartment community</a></strong>. Our wide range of thoughtfully designed floor plans for families of all sizes are paired with premium amenities and a location that keeps you connected to everything Owasso has to offer. With multiple apartments, townhomes, and lofts to choose from, you’re sure to find the right match for your lifestyle so you can live in luxury. <br/></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cypress-crossing/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Owasso neighborhood surrounding Cypress Crossing — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cypress-crossing/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Cypress Crossing, we welcome your four-legged family members with open arms. Our pet-friendly community is designed to make you and your pets feel right at home. Your dogs will adore exploring and playing in our on-site dog park, the perfect spot to burn off energy and meet new friends. Meanwhile, your cats can <strong><a href=\"/apartments/ok/owasso/cypress-crossing/amenities\">lounge in comfort by the windows</a></strong> as they soak up the sun.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/owasso/cypress-crossing/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our beautiful community shines with thoughtfully designed spaces, modern amenities, and lush landscaping. Browse our photo gallery to get a glimpse of what your new life at Cypress Crossing could look like.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/pryor/west-530/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our Pryor apartment community offers an elevated living space with amenities that make each newly built apartment feel luxuriously comfortable. Enjoy a premium selection of community features and explore all the possibilities life at West 530 brings.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/pryor/west-530/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Make yourself at home in an apartment that fits your lifestyle at West 530! Our thoughtfully designed 1 and 2 bedroom floor plans are built with a balance of comfort, style, and functionality, with large living spaces and convenient touches around every corner. If you’re looking for a cozy space to unwind or additional room to spread out and entertain, you’ll find just what you need in our modern apartment homes in Pryor.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/pryor/west-530/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Pryor neighborhood surrounding West 530 — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/pryor/west-530/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Pets are part of the family and welcome here at West 530! Our pet-friendly community is thoughtfully designed for you and your furry companions so everyone can feel right at home. Dogs will love stretching out and socializing in our <a href=\"/apartments/ok/pryor/west-530/amenities\"><strong>onsite dog park</strong></a>, while cats can watch from the window as they relax in the sunlight.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/pryor/west-530/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our friendly community at West 530 embodies the lifestyle of Pryor, OK. On sunny days, walk out of your apartment to find many of your neighbors poolside. The shared grills are perfect for cooking up meat and veggies. Our clubhouse is open to all guests and features comfortable furniture, a business center, a billiards table, and a ping pong table. Our grounds are professionally maintained and visually pleasing, and limited-access gates help ensure the noise level is kept to a minimum.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/stillwater/apple-creek-stillwater/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our apartments in Stillwater are outfitted with amenities and stylish, modern touches, giving you the perfect canvas to accent with personal items. The high ceilings and hardwood floors add subtle undertones of luxury and elegance to your apartment, while stainless steel appliances and a fully equipped kitchen make daily chores a cinch. When you’re not spending time in your apartment, you can enjoy the wide array of community amenities, like our two outdoor pools. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/stillwater/apple-creek-stillwater/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find the right <a href=\"/apartments/ok/stillwater/apple-creek-stillwater/neighborhood\"><strong>Stillwater apartment</strong></a> floor plan for your lifestyle at Apple Creek. In each of our floor plans, you’ll enjoy stylish hardwood floors and lofty, high ceilings, making for the perfect canvas for your home decor. Get cozy in the entryway living area, welcoming you home to your cozy 1 bedroom or 2 bedroom apartment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/stillwater/apple-creek-stillwater/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Stillwater neighborhood surrounding Apple Creek Stillwater — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/stillwater/apple-creek-stillwater/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We invite you to bring your pets with you when you come to live in our Stillwater apartment community. Cats and dogs alike are welcomed at our Stillwater apartments, which are complete with windows for sunbathing and lots of walking paths for pups.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/stillwater/apple-creek-stillwater/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>One look at our spacious homes and community amenities and you see why residents love living at Apple Creek Apartments. Our <a href=\"/apartments/ok/stillwater/apple-creek-stillwater/pet-policy\">pet-friendly community</a> offers the perfect setting for your relaxed lifestyle in Stillwater, Oklahoma. Spend sunny afternoons walking your pup around the property and discover amenities ranging from a clubhouse to a laundry facility. Envision warm days by the two pools as you work on your summer glow or having fun with friends at the sports court. Get a sneak peek of life in our vibrant community as you browse our community photos, and call us to set up a tour to see it all in person!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/barrington-apartments/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Inside our Tulsa apartment homes and around the <a href=\"/apartments/ok/tulsa/barrington-apartments/neighborhood\"><strong>Barrington community</strong></a>, you’ll find several luxury amenities to make you feel right at home. Your spacious kitchen features a matching black stove, microwave, fridge, and dishwasher for a simplified dinner routine. The luxurious amenities don’t end when you leave your apartment. Around our community, you can enjoy a full fitness center, pool, clubhouse, business center, volleyball courts, and more amenities, all on-site.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/barrington-apartments/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Browse through our 10 unique floor plans and find the right apartment home. Whether you choose one of our compact 1 bedroom apartments or versatile 2 bedroom apartments in Tulsa, each of our layouts is thoughtfully designed with <a href=\"/apartments/ok/tulsa/barrington-apartments/amenities\"><strong>amenities</strong></a> to make you feel at home. The spacious living area in each of our floor plans can accommodate couches, comfy chairs, and other personal furnishings to create a homey feel. At the same time, the luxurious bathrooms with whirlpool tubs provide a retreat from stress.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/barrington-apartments/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Tulsa neighborhood surrounding Barrington Apartments — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/barrington-apartments/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Barrington’s pet-friendly apartments are perfect for cat and dog lovers alike. We invite you to take morning walks with your pup through our community’s lush courtyard and enjoy some play time at our on-site dog park. Cat owners will often find their kitty companions taking a sun nap near the glass door of their patio or balcony. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/barrington-apartments/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Picture your life at Barrington <a href=\"/apartments/ok/tulsa/barrington-apartments/floor-plans\">Apartments and Townhomes</a> in south Tulsa, Oklahoma. At Barrington Apartments, we encourage you to get to know your neighbors through regular community events. Our well-appointed clubhouse is a great spot for a gathering with new and old friends alike. Inside your apartment, the brick fireplace with an oak mantel serves as a sophisticated backdrop for entertaining guests. In the mood for an excursion? Barrington Apartments is located near many sports teams, including the Tulsa Drillers, the University of Tulsa Hurricanes, and FC Tulsa. With restaurants and shopping nearby, our residents never run out of fun activities to enjoy.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cascata-luxury-apartments/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Whether you stay inside your upscale apartment home or explore our community’s sprawling grounds, Cascata invites you to make the most of each day. Start your day by making yourself breakfast and coffee in your fully equipped kitchen with stainless steel appliances and ceramic tile floors. Spend your weekends in one of our two on-site pools or enjoy lunch with friends at our grilling and picnic area. Envision your peaceful life in our amenity-filled community by browsing our <a href=\"/apartments/ok/tulsa/cascata-luxury-apartments/photos\"><strong>photo gallery</strong></a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cascata-luxury-apartments/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Browse our thoughtfully designed Tulsa apartment floor plans and find your dream apartment home. Cascata offers six distinct layouts, each offering a spacious living area with lots of natural light and large closets for stowing your wardrobe. Optional fireplaces are also available in some of our floor plans, offering extra comfort on chilly winter evenings. Each of our Tulsa apartments offers a wide range of <a href=\"/apartments/ok/tulsa/cascata-luxury-apartments/amenities\"><strong>amenities</strong></a> so you can feel at home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cascata-luxury-apartments/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Tulsa neighborhood surrounding Cascata Luxury Apartments — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cascata-luxury-apartments/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Cascata’s pet-friendly apartment homes will ensure your pets and you are comfortable. Share quality time with your dog and play fetch at our on-site dog park, which has lots of room for your pup to stretch their legs. Our Tulsa apartments also feature a number of expansive windows that cats will love.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cascata-luxury-apartments/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Located in Tulsa, Oklahoma, near Woodland Hills Mall, Cascata Apartments offers luxury apartment homes with a sophisticated vibe. The outdoor firepit and lounge area is the perfect spot for hosting a get-together with friends. Use our gas grills to cook up a delicious meal on warm summer nights, then cool off with a dip in the sparkling swimming pool. The <a href=\"/apartments/ok/tulsa/cascata-luxury-apartments/amenities\">24-hour fitness and health center</a> is a great way to fit in a workout whenever it’s convenient for you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-glade-apts/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our Tulsa apartment homes are thoughtfully designed with all the comforts of home plus a stylish flair. Our apartments are outfitted with essential features that make everyday life easier. Around our community, you’ll find amenities to complement your daily routine and enhance your leisure time. To fully envision our Tulsa apartment community’s amenities, we recommend browsing our <a href=\"/apartments/ok/tulsa/cedar-glade-apts/photos\"><strong>photo gallery</strong></a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-glade-apts/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Make yourself at home in one of our four-floor plans, with thoughtful designs ranging from 730 sq. ft. to 1,300 sq. ft. Several of our apartment layouts include an optional wood-burning fireplace, allowing you to create a cozy and peaceful atmosphere. As you browse our floor plans, you’ll also notice other <a href=\"/apartments/ok/tulsa/cedar-glade-apts/amenities\"><strong>amenities</strong></a>, like the included balcony or patio, a perfect spot for sipping coffee or tea and enjoying the sunlight.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-glade-apts/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Tulsa neighborhood surrounding Cedar Glade Apts — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-glade-apts/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Residents and their pets can live in harmony at Cedar Glade’s pet-friendly apartments in Tulsa. Take a walk with your pup through our lush courtyard and walking paths, or visit one of the several nearby parks for a fun game of frisbee. On cold winter days, cats enjoy curling up by the wood-burning fireplace.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-glade-apts/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome home to Cedar Glade Apartments. Our excellent location in South Tulsa, near Woodland Hills, provides everything you need to feel right at home. As you enter the grounds, take in the beautiful landscaping that surrounds your home in a picturesque setting. The courtyard provides a perfect gathering place to enjoy the outdoors. The sparkling swimming pools beckon you in for a slow summer’s day and a glass of iced tea. While our<a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://www.caseusa.com/apartments/ok/tulsa/cedar-glade-apts/amenities/\">&nbsp;state-of-the-art fitness center</a>&nbsp;is there for you when it’s time to kick it up a notch.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Whether you spend your day relaxing in your apartment home haven or fill your day exploring our resort-style community, our lavish amenities await you all around Cedar Ridge. Each apartment home is designed with your comfort in mind, adorned with sophisticated and stylish features. When you’re not relaxing in your cozy apartment home, meander through our serene community and visit our fully stocked fitness center, sparkling pool, expansive dog park, or one of our many other amenities.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Each of our nine unique 1, 2, and 3 bedroom apartment floor plans is designed to maximize your comfort, with <a href=\"/apartments/ok/tulsa/cedar-ridge-apartments/amenities\">several amenities</a>. The lofty nine-foot ceilings give your apartment a roomy, elegant feeling, while the open-concept layout maximizes your living space. Beyond standard apartments, we also offer loft apartments in Tulsa with an optional attached garage.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Tulsa neighborhood surrounding Cedar Ridge Apartments — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We welcome you to bring your pet with you when you come to live at Cedar Ridge. Our spacious, pet-friendly apartments provide an ideal environment for dogs and cats to live happily. Plus, our community includes pet-friendly features, like our on-site dog park.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>When you click through the Cedar Ridge photo gallery, one thing becomes perfectly clear – you belong here. When you make Cedar Ridge your home base, you’re choosing the perfect blend of style and comfort. Each pet-friendly apartment, and loft combines casual luxury with sleek, modern functionality to help you get the most out of each day. Your home features a <a href=\"/apartments/ok/tulsa/cedar-ridge-apartments/amenities\">contemporary, fully equipped kitchen</a> with your choice of white or espresso custom cabinets and contrasting countertops. Stainless-steel, energy-efficient appliances and a convenient breakfast bar make cooking and cleanup easy. Thoughtful touches like the LED fireplace in select units, designer lighting, upscale fixtures and finishes, and generous storage are both elegant and practical.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our Tulsa apartment homes were built with our tenants’ comfort in mind, with features and amenities to make life easier. On top of the essentials, elevated features like the wood-burning fireplace and private balcony or patio add style to your living space. When you’re not unwinding in your apartment home, our community amenities await you, beckoning you to seize the day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Browse our Tulsa apartment floor plans and find a layout that complements your lifestyle. We offer three options: smaller 1 bedroom apartments, larger 1 bedroom apartments, and 2 bedroom apartments. No matter what floor plan you select, you’ll cherish <a href=\"/apartments/ok/tulsa/chardonnay/amenities\"><strong>homey features and amenities</strong></a> like the wood-burning fireplace and large private balcony or patio. Pets are allowed, and your fur babies will enjoy our on-site dog park.  </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Tulsa neighborhood surrounding Chardonnay — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Chardonnay offers pet-friendly apartment homes that you and your furry friends will love. The expansive windows let in sunlight for blissful cat naps, while the on-site dog park gives your pup room to run around and stretch their legs.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/chardonnay/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>It’s easy to imagine how you can get more out of both routines and spontaneous fun with our photo gallery of Chardonnay. Picture yourself lounging beside the outdoor swimming pool with complimentary WiFi and pristine landscaping. If you have pets, you will be happy to find an onsite dog park with agility equipment and running space. The amenities don’t stop there. Once you step into <a href=\"/apartments/ok/tulsa/chardonnay/floor-plans\">your new apartment</a>, you will find all the in-home essentials you want in a home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Country Hollow’s accommodations are available to complement your day-to-day life inside your apartment and throughout our community. From comfort-enhancing features inside your apartment to luxurious community amenities, we are committed to providing reasonably priced yet upscale living spaces that offer you all the delights of home without compromising quality.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Country Hollow’s apartment floor plans are available in three unique layouts to cater to diverse living situations. Starting at 500 sq. ft. in our practically sized studios, our range of options allows you to pick the size that strikes the right balance between affordability and upscale coziness for single renters and roommates alike.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Tulsa neighborhood surrounding Country Hollow Apartments — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our pet-friendly apartments in Tulsa welcome you and your beloved animals to make Country Hollow your home. Let your energetic pup run around our on-site Bark Park or cozy up with your cat in your new home on chilly evenings. However you choose to live, know that Country Hollow is here to make your apartment a home for your whole family. Our pet policy guidelines include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>See for yourself how Country Hollow can cater to your lifestyle to help you make the home you’ve imagined a reality. Our online photo gallery can help you envision your new life in southern Tulsa and each amenity and feature we offer to elevate your apartment living experience. While you are here, explore our 360-degree virtual walkthrough to fully explore each corner of your future apartment home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/creekwood-apartments/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Feel right at home in one of our <a href=\"/apartments/ok/tulsa/creekwood-apartments/floor-plans\"><strong>1 or 2 bedroom apartments</strong></a> equipped with amenities that enrich your life, including essentials and luxurious extras. When you leave your apartment, lush courtyards and pathways guide you to the resort-style community amenities residents can enjoy at Creekwoods Apartments in Tulsa.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/creekwood-apartments/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Peruse our Tulsa apartment floor plans and find the ideal fit for your lifestyle. From charming 1 bedroom apartments to sprawling 2 bedroom townhomes, Creekwood Apartments has a layout for everyone. Designed with your comfort in mind, each floor plan includes a spacious, open-concept living and dining area where you can relax and unwind or hang out with friends and loved ones. To envision life in our floor plans, check out our <a href=\"/apartments/ok/tulsa/creekwood-apartments/photos\"><strong>photo gallery and virtual 360-degree tour</strong></a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/creekwood-apartments/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Tulsa neighborhood surrounding Creekwood Apartments — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/creekwood-apartments/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find the ideal home for you and your pets at Creekwood, where you’ll find pet-friendly apartments in Tulsa. Your pup will love strolls through our lush grounds, and cats are sure to enjoy sunbathing in the light of the windows in our apartment homes. With several spacious <a href=\"/apartments/ok/tulsa/creekwood-apartments/floor-plans\"><strong>floor plan options</strong></a>, pet owners can find a suitable layout for living harmoniously with their furry friends. The pet policy at Creekwood includes the following guidelines: </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/creekwood-apartments/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Creekwood Apartments is your place for ultimate sophistication. Take a virtual tour of our <a href=\"/apartments/ok/tulsa/creekwood-apartments/floor-plans\"><strong>one and two bedroom apartments</strong></a> for rent in Tulsa, Oklahoma, near Oral Roberts University. Welcoming decorator carpet adds warmth and elegance. The fully equipped kitchen is beautiful and also functional. Add some furniture and plants and create your own oasis in your private patio or balcony with views of the lush grounds of our community. You’ll be proud to call Creekwood Apartments your home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/nickel-creek-apts/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>When you’re looking for luxury living in Tulsa, Nickel Creek is the community for you. We offer amenities both in your home and on the property to make every aspect of living here a great one. Enjoy spending time in the courtyard or on the sundeck during warm, sunny days. Our on-site management and 24-hour emergency maintenance ensures assistance is available when you need it. And with pre-installed WiFi from our partners at Cox, you’ll be ready to go starting the day you move in. Explore <a href=\"/apartments/ok/tulsa/nickel-creek-apts/floor-plans\"><strong>one- and two-bedroom apartments in Tulsa</strong></a> and call Nickel Creek your new home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/nickel-creek-apts/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Not only will you have room to call your own, but you will also enjoy a wide variety of <a href=\"/apartments/ok/tulsa/nickel-creek-apts/amenities\"><strong>luxury apartment amenities in Tulsa</strong></a> including spacious closets, fully equipped kitchens, high-speed internet, and more. No matter your home needs in Tulsa, we have you covered.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/nickel-creek-apts/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Tulsa neighborhood surrounding Nickel Creek Apts — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/nickel-creek-apts/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Nickel Creek we understand that pets are an important part of your family. From cuddly kittens to playful pups, we’re happy to welcome them all at our pet-friendly apartments in Tulsa. Enjoy a stroll through our lush grounds and take a visit to our on-site dog park. If you want to stretch your legs a bit further, we recommend nearby Hunter Park, LaFortune Park, and Helmerich Park.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/nickel-creek-apts/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a virtual tour of our<a href=\"/apartments/ok/tulsa/nickel-creek-apts/floor-plans\"> one and two bedroom apartments and lofts</a> for rent in Tulsa, Oklahoma, with spacious interiors and stunning views of our lush, garden-like community. Your new home is beautiful inside and out, and we equipped it with everything you need for convenient living. Air conditioning helps you stay cool year round. Take advantage of washer and dryer connections so you can do laundry on your own time in the comfort of your home. Head out to your private patio or balcony (in select units) for a breath of fresh air or to catch a breathtaking sunset view.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/polo-run-apartments/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our apartments in Tulsa offer contemporary amenities and stylish touches that are ideal for showcasing a sense of luxury and sophistication within your living space. The spacious pantry, refrigerator, and fully equipped all-electric kitchen simplify your daily routines. Additionally, take advantage of the diverse community amenities, including the outdoor pool, for leisure activities outside of your apartment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/polo-run-apartments/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We offer diverse Tulsa apartment floor plans tailored to complement your lifestyle. Our apartment floor plans boast luxurious plush carpeting and a charming fireplace, providing the ideal backdrop for expressing your personal style. Step into the welcoming embrace of your cozy 1 bedroom or 2 bedroom apartment, where comfort meets style from the entryway to the living area.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/polo-run-apartments/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Tulsa neighborhood surrounding Polo Run Apartments — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/polo-run-apartments/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We’re delighted to offer pet-friendly living at Polo Run Apartments in Tulsa. Our serene garden setting and lush grounds provide the perfect environment for your furry companions to explore. You can enjoy the welcoming and accommodating atmosphere, fostering a strong bond with your pet(s).</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/polo-run-apartments/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We welcome you to explore our photo gallery and envision the lifestyle awaiting you at Polo Run near Charter Oak. Experience the thoughtful design of our bright apartment floor plans, which provide a welcoming atmosphere that feels like home after a long day. Envision the tranquillity of relaxing in your cozy Tulsa apartment, which is the ideal retreat after a stressful day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We strive to create a comfortable and homey atmosphere in our Tulsa apartments and throughout Sheridan Pond. A spacious apartment home and a welcoming breakfast bar contribute to a feeling of comfort and relaxation. Whether you engage in a cardio workout at our fitness center or enjoy quality family time at the gazebo near our catch-and-release pond, the amenities at our Tulsa apartment community encourage enjoyment and relaxation.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Sheridan Pond offers eight unique Tulsa apartment floor plans for 1, 2, and 3 bedroom apartments. Regardless of your lifestyle, we have a floor plan to suit you. The apartments range from 547 to 1,488 sq. ft. and feature spacious closets and well-lit, open living areas.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Tulsa neighborhood surrounding Sheridan Pond — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience the ideal blend of comfort and convenience at Sheridan Pond Apartments, offering pet-friendly living in Tulsa. Our thoughtfully designed apartments cater to you and your furry companions, providing ample space to thrive.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sheridan-pond/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Are you curious about experiencing Sheridan Pond near Harvard Pointe? Our photo gallery offers a comprehensive glimpse of our floor plans and community amenities, providing insight into our apartment homes and the overall community atmosphere. Furthermore, you can tour our apartments virtually online or <a href=\"/apartments/ok/tulsa/sheridan-pond/contact-us\"><strong>schedule an in-person tour</strong></a> with our welcoming staff.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover many comfortable amenities within our <a href=\"/apartments/ok/tulsa/sugarberry-apartments/floor-plans\"><strong>1, 2, and 3 bedroom apartments</strong></a> in Tulsa and throughout the Sugarberry community that help enhance your living experience.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the ideal living space near the <a href=\"/apartments/ok/tulsa/sugarberry-apartments/neighborhood\"><strong>Burning Tree neighborhood</strong></a> within our four distinctive floor plans, each meticulously crafted to cater to your needs. Whether you opt for a cozy 1 bedroom layout or a flexible 2 bedroom design, every Tulsa apartment is thoughtfully appointed with amenities to evoke a sense of home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Tulsa neighborhood surrounding Sugarberry Apartments — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our pet-friendly apartments cater to cat and dog enthusiasts. Start your day with your furry friend, relishing in our pet-centric <a href=\"/apartments/ok/tulsa/sugarberry-apartments/amenities\"><strong>amenities</strong></a>, such as our beautiful grounds and dedicated dog park. For cat owners, expect to see your feline friends basking in the sun on their own screened-in sunroom patio. Our pet policy includes the following guidelines.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sugarberry-apartments/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore our wide selection of Tulsa apartments by perusing our extensive photo gallery to take a glimpse at our offerings. Embark on a virtual 360-degree tour of our vibrant Tulsa apartment community to immerse yourself in our amenities and diverse floor plans. Envision tranquil mornings within your apartment sanctuary and leisurely afternoons unwinding by the poolside.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Enhance your lifestyle with our <a href=\"/apartments/ok/tulsa/sunchase-apartments/floor-plans\"><strong>studio, 1, and 2 bedroom apartments</strong></a> offering many comfortable amenities. From indoor and outdoor pools to a 24-hour fitness center and a welcoming clubhouse, our community provides various features designed to elevate your daily living experience in the distinctive setting of south Tulsa.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Located in south Tulsa near the <a href=\"/apartments/ok/tulsa/sunchase-apartments/neighborhood\"><strong>Heatherridge neighborhood</strong></a>, Sunchase presents a selection of studio, 1 bedroom, and 2 bedroom apartments. With neutral walls and plenty of natural light, our spaces are the canvas for your personalization. Enjoy plush carpeting in the living room and bedrooms and sleek tile floors in the bathroom and kitchen areas.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Tulsa neighborhood surrounding Sunchase Apartments — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At our Tulsa apartments near the <a href=\"/apartments/ok/tulsa/sunchase-apartments/neighborhood\"><strong>Shadow Ridge neighborhood</strong></a>, we understand the significance of pets as valued family members. That’s why we warmly welcome furry friends with our pet policy that encompasses the following guidelines.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/sunchase-apartments/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore our photo gallery for a glimpse into our apartments in Tulsa. It showcases numerous images of our floor plans and community areas. Additionally, you can embark on a virtual tour of Sunchase from the comfort of your couch. Imagine watching movies in your apartment living room and enjoying winter evenings swimming in our heated indoor pool surrounded by a lush tropical garden ambience!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>What sets our south Tulsa apartments apart from others? For starters, we offer several amenities inside our apartment homes and around our community. A fully equipped kitchen with all the essential appliances awaits you in every one of our <a href=\"/apartments/ok/tulsa/the-courtyards/floor-plans\"><strong>floor plans</strong></a>, ready to make meal prep simple. When you feel like spending time outside your apartment, indulge in one of the community amenities included. Take a dip in our on-site pool or hit a workout at the fitness center.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find the right apartment for you by browsing our eight distinct 1 and 2 bedroom floor plans. Whatever floor plan you select, you’ll enjoy plentiful <a href=\"/apartments/ok/tulsa/the-courtyards/amenities\"><strong>amenities</strong></a> and a thoughtfully designed layout, ensuring comfortable living. Our several floor plan options ensure you can easily find a good fit for you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Tulsa neighborhood surrounding The Courtyards — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Courtyards pet-friendly apartments in Tulsa are the ideal places to call home for residents and their pets. We invite you to bring your cat or dog when you come to live in our peaceful apartment community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-courtyards/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Live life to its fullest at The Courtyards. Our<a href=\"/apartments/ok/tulsa/the-courtyards/floor-plans\"> one and two bedroom apartments</a> for rent in Tulsa, Oklahoma, were planned with your lifestyle in mind. The features vary throughout our apartments – choose from floor plans featuring cozy fireplaces with a mantel, 9-foot vaulted ceilings, or private balconies or patios. Each home features a fully equipped kitchen – a beautiful space that is sure to inspire your next culinary masterpiece. Peruse the gallery and imagine yourself relaxing in your beautiful new apartment at The Courtyards.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>You’ll feel right at home at Greens of Bedford. Each of our <a href=\"/apartments/ok/tulsa/the-greens-of-bedford/floor-plans\"><strong>apartment floor plans</strong></a> is thoughtfully designed with your comfort in mind, equipped with amenities to make your life easier. Several community amenities will ensure you’re never bored when you step outside your apartment, from an on-site fitness center to an outdoor pool.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find the right apartment home for your unique needs in one of our 1, 2, or 3 bedroom apartment floor plans at The Greens of Bedford. Our thoughtfully designed layouts feature <a href=\"/apartments/ok/tulsa/the-greens-of-bedford/amenities\"><strong>several amenities </strong></a>and 700 to 1,200 sq. ft. of space in our Tulsa apartment homes, plenty of room to live comfortably. Several of our floor plans are also ideal for those living with roommates.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Tulsa neighborhood surrounding The Greens Of Bedford — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Greens of Bedford offers pet-friendly apartments in Tulsa, an ideal place to live for pet owners and their furry friends. Cats and dogs are allowed at our Tulsa apartment community, which also features an on-site dog park where your pup can stretch its legs and play with friends, among other <a href=\"/apartments/ok/tulsa/the-greens-of-bedford/amenities\"><strong>community amenities</strong></a>. The pet policy at The Greens of Bedford includes the following guidelines:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The charming community of The Greens of Bedford and its <a href=\"/apartments/ok/tulsa/the-greens-of-bedford/floor-plans\">one, two, and three bedroom apartments</a> for rent in Tulsa, Oklahoma, are the place to be for easy living. Start your day with some high-energy exercise at our fitness center. On hot summer days, lounge by our outdoor pool with your favorite magazine and then cool off with a swim. Do you have a furry companion? Make sure you take them to our onsite bark park, where they are sure to make plenty of friends! When it comes to having fun in the sun, The Greens of Bedford has something for everyone.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience a blend of activity, relaxation, and rejuvenation in our Tulsa apartment community with our range of <a href=\"/apartments/ok/tulsa/windsail-apartments/floor-plans\"><strong>1 and 2 bedroom apartments</strong></a>. Each apartment boasts open-concept floor plans and private patios or balconies that invite natural light and reflect thoughtful design. Immerse yourself in our scenic community, where resort-style amenities like a swimming pool with a sun deck and inviting grilling areas await your enjoyment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Immerse yourself in elevated living at our apartments in Tulsa near the <a href=\"/apartments/ok/tulsa/windsail-apartments/neighborhood\"><strong>Hampton South neighborhood</strong></a>, with <a href=\"/apartments/ok/tulsa/windsail-apartments/amenities\"><strong>amenities</strong></a> and thoughtful layouts to elevate your everyday experience.<br/>Enjoy the comforts of a fireplace, convenient washer and dryer connections, and elegant vaulted ceilings available in select Tulsa residences. Explore our <a href=\"/apartments/ok/tulsa/windsail-apartments/photos\"><strong>photo gallery</strong></a> showcasing interactive 360° virtual tours of our 1 and 2 bedroom apartment homes, offering a glimpse into our sophisticated floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Tulsa neighborhood surrounding Windsail Apartments — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Windsail caters to pet owners and furry companions with pet-friendly apartments and community <a href=\"/apartments/ok/tulsa/windsail-apartments/amenities\"><strong>amenities</strong></a>. In our Tulsa apartments, you’ll find an on-site dog park where your pup can play and exercise freely. Join a community that cherishes every resident, including those with four-legged companions, as we outline our pet policy below.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/windsail-apartments/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore life within our serene community through our photo gallery showcasing our apartment homes and community amenities. Delve deeper into the essence of our south Tulsa apartments with a 360° virtual tour below our captivating photo gallery.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Park on Westpointe’s design fuses a modern and sleek aesthetic with homestyle interiors that provide an ideal backdrop for a life of luxurious comfort. Keep your home cozy in our plushly carpeted rooms, and make every meal in a gourmet kitchen with stainless steel appliances, expansive cabinetry, and premium features that maintain an upscale appearance in a highly functional living space.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We’ve seamlessly blended comfort with style to curate the ideal balance of comfort with <a href=\"/apartments/ok/yukon/park-at-westpointe/amenities\"><strong>luxurious flourishes</strong></a>. Every apartment is designed with your outdoor enjoyment in mind, featuring a private balcony or patio, options for a bumpout with a scenic view, and even a loft with an attached personal garage. Make your home a genuinely enriching living space with the size and customization options that make The Park on Westpointe a premier West Oklahoma City community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Yukon neighborhood surrounding Park at Westpointe — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Park on Westpointe, we understand that pets are integral to your family. Our commitment to creating a welcoming and pet-friendly community is evident in every aspect of our living spaces. From spacious living areas to outdoor spaces designed with pets in mind, we invite you and your entire family to make your home at The Park on Westpointe.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/park-at-westpointe/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Step into your life in a Park on Westpointe apartment without leaving your home with our digital photo gallery, featuring high-definition snapshots of our resort-style community. Virtually stroll through our courtyard and take a 3D tour of our apartment layouts so you can fully appreciate our premium features and get a sense of the comforting and luxurious environment we are proud to offer.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/the-ridge-@-66/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Ridge at 66’s diverse range of lifestyle-enhancing amenities gives you the freedom to live your own way in a comfortable environment. With modern appliances in your home and a collection of community features for both you and your pets, we help you maintain a cozy home around every corner.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/the-ridge-@-66/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Thrive in an upscale living environment by renting a 1, 2, or 3 bedroom home in our Yukon apartment community. At Ridge at 66, we offer a variety of spacious floor plans designed to cater to your lifestyle needs. Our floor plans range from 789 to 1,473 sq. ft., perfect for single renters, small families, or those seeking a little extra room for guests and storage.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/the-ridge-@-66/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Yukon neighborhood surrounding The Ridge @ 66 — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/the-ridge-@-66/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We make every effort to provide all our guests with a luxury living experience, and that includes everyone you live with. Your pet’s comfort and happiness are important to us, which is why our pet-friendly community comes equipped with an on-site dog park so your canine companions can run to their heart’s content while your cat cozies up next to your fireplace. Our pet policy guidelines include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/the-ridge-@-66/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our words don’t do it justice. Browse through our photo gallery to get a look at Ridge at 66 for yourself, or come tour yourself. Take in the lush and well-landscaped grounds, the classy clubhouse equipped with billiards and shuffleboard, and the resort-style pool, tanning ledge, and cabanas. Admire the modern yet cozy interiors of the one, two, and three bedroom <a href=\"/apartments/ok/yukon/the-ridge-66/floor-plans\">apartments, townhomes, and lofts</a>. Then, take the time to appreciate the sophisticated in-home finishes, like custom cabinetry and stainless-steel appliances, all the while imagining the life you’ll have here surrounded by all the features and amenities you want and need in a conveniently situated neighborhood. This is what you deserve.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/yukon/the-ridge-66/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our words don’t do it justice. Browse through our photo gallery to get a look at Ridge at 66 for yourself, or come tour yourself. Take in the lush and well-landscaped grounds, the classy clubhouse equipped with billiards and shuffleboard, and the resort-style pool, tanning ledge, and cabanas. Admire the modern yet cozy interiors of the one, two, and three bedroom <a href=\"/apartments/ok/yukon/the-ridge-66/floor-plans\">apartments, townhomes, and lofts</a>. Then, take the time to appreciate the sophisticated in-home finishes, like custom cabinetry and stainless-steel appliances, all the while imagining the life you’ll have here surrounded by all the features and amenities you want and need in a conveniently situated neighborhood. This is what you deserve.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Beautifully shaded courtyards will greet you and your guests as you welcome your friends and family into your Newport apartment home. A private pool, spa area, and community lounge offer a preview of our care in fully outfitting each apartment to accommodate your every living need. With modern appliances and luxurious touches in every home, we go a step beyond accommodation to offer you a living experience you can love.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find your new home in an apartment at Newport, available in seven unique floor plans to give you the flexibility to create a home that reflects your lifestyle. Our size options range from 624 sq. ft. to 925 sq. ft., with options for an additional full or half-bath and a private balcony or patio to give your home an added layer of comfort and functionality. We also offer wood-burning fireplaces in select spaces for even more coziness.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Amarillo neighborhood surrounding Newport Amarillo Apts — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>A welcoming community should be open to everyone important in your life, so we ensure our apartment homes are comfortable for you and your pets. With an on-site Bark Park and dog run, we offer pet-friendly amenities and outdoor spaces that invite you to create lasting memories with your pets, fostering a sense of home that encompasses every cherished member of your family. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore a snapshot of life at Newport Apartments from the comfort of your own home with our in-depth photo gallery. Take a virtual tour of our courtyard and lounge areas and look inside each of our apartment size options with high-definition images to guide you as you discover the amenities and thoughtful design that give our community its character.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>A dedicated management team and a suite of premium amenities and features are the foundation of any upscale living community. We incorporate modern and highly functional appliances in every unit. At the same time, premium options allow you to customize your space with a balcony, loft, and even a personal garage to truly make your space an ideal fit for you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We offer a range of apartment size options so you can find the right layout for you. Our floor plans are available in six distinct layouts ranging from 789 to 1,176 sq. ft., and both our 1 and 2 bedroom options are available with an additional patio, study, or loft to ensure you have a living space that reflects your personal needs.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Amarillo neighborhood surrounding Park at Coulter — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our commitment to creating a <a href=\"/apartments/tx/amarillo/park-at-coulter/neighborhood\"><strong>warm and inclusive community</strong></a> extends to the furry companions that bring joy and companionship to your life. Designed with your pets in mind, our apartment homes provide a comfortable and pet-friendly environment with an included dog park and a large courtyard for you and your canine companions to relax and bond. Cats are also welcome to become members of our apartment community, and they will surely enjoy the peace and warmth of your wood-burning fireplace and the wonderful views provided by our private patios.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/park-at-coulter/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore our apartment community online through our HD photo gallery. Browse captivating and vivid images that help you get a sense of what your life could be like in a Park at Coulter apartment. We also encourage you to scroll down to begin your virtual tour to get a first-person perspective of every aspect of our community and discover the luxurious touches that make our community stand out from the rest.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Imagine coming home after a long day’s work to a beautifully designed living space complete with modern appliances, ample storage options, and thoughtfully designed layouts that maximize both style and functionality. When you choose the Remington Apartments in Amarillo, you’ll get just that. Our apartments and community were built with you in mind, providing comfort and convenience all around.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the perfect living space for your lifestyle at Remington Apartments in Amarillo, TX. Offering 1 bedroom, 2 bedroom, and 3 bedroom apartments, you’ll be sure to find the right apartment fit for you. Enjoy the convenience of in-home washer and dryer connections, well-equipped kitchens, and spacious closets in our comfortable and cozy <a href=\"/apartments/tx/amarillo/remington-amarillo-apts\"><strong>Amarillo apartments</strong></a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Amarillo neighborhood surrounding Remington Amarillo Apts — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We completely understand and appreciate the deep bond that exists between individuals and their beloved pets. That’s why we take immense pride in the Remington Apartments being a pet-friendly community, where your furry companions are more than welcome to join you on your luxurious living journey. Not only do we offer spacious living areas that provide ample room for your pets to roam freely within the comforts of your home, but our community also boasts a well-maintained courtyard for you and your pet to stroll through.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore the breathtaking grounds and sophisticated interiors that set Remington Apartments apart from the crowd. Take a virtual tour of our <a href=\"/apartments/tx/amarillo/remington-amarillo-apts/floor-plans\">one, two, and three bedroom apartments</a> for rent near Sleepy Hollow, and picture your best life. Creating quick and tasty meals is easy in the fully equipped kitchen outfitted with premium appliances, abundant storage, and plenty of space to prepare your ingredients. Each home offers a private balcony or patio – a tranquil outdoor space where you can unwind, enjoy your morning coffee, or cultivate a container herb garden. Select homes also feature a fireplace, setting the scene for cool winter nights.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Colonies at Hillside goes beyond just offering a place to stay. We’re a vibrant community that curates a truly luxurious living experience for all our residents. You’ll have access to an array of exciting and convenient amenities when you call us home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Whether you’re coming home from a busy day at work or seeking relaxation on the weekend, Colonies at Hillside prioritizes your comfort and coziness. We craft each floor plan to meet your unique needs and preferences, and we’re proud to present a selection of spacious apartment layouts in southwest Amarillo.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Amarillo neighborhood surrounding The Colonies at Hillside — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We invite both you and your pets to make Colonies at Hillside your home. You and your pet are sure to enjoy a leisurely stroll through our lush grounds and a visit to our onsite dog park. Whether it’s stretching their legs or mingling with other pets, your cat or canine companion will have plenty of opportunities for play and relaxation. Our pet policy guidelines include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Relax in comfort, tranquility, and style at Colonies at Hillside. Take a look through our photo gallery and explore our <a href=\"/apartments/tx/amarillo/the-colonies-at-hillside/floor-plans\">one and two bedroom</a> Southwest Amarillo, Texas, apartments for rent near West Texas A&amp;M University. Each home offers a bright, expansive floor plan complete with large windows and abundant natural light. The fully equipped chef’s kitchen is the center of your new home, featuring premium appliances, spacious cabinets, and tons of counter space for prepping your favorite meals. Enjoy your food indoors or take your plate outside to your tranquil and private balcony or patio (balcony/patio in select units only).</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The amenities available within our apartment homes and across the community sets our Amarillo apartments apart. Enjoy the convenience of a fully equipped kitchen with essential appliances in every <a href=\"/apartments/tx/amarillo/winchester-apartments/floor-plans\"><strong>floor plan</strong></a>, simplifying meal preparations. Take a refreshing swim in the outdoor pool or work out in our 24-hour fitness center after you step outside your apartment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover our 13 unique floor plans showcasing 1, 2, and 3 bedroom apartments. With numerous options available, we guarantee you’ll find the perfect match for your needs. Whether you’re looking for a cozy haven or a spacious sanctuary, you’ll have a beautifully crafted layout with many amenities.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Amarillo neighborhood surrounding Winchester Apartments — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Winchester’s pet-friendly apartments in Amarillo, you and your furry companions will adore our serene living spaces and community <a href=\"/apartments/tx/amarillo/winchester-apartments/amenities\"><strong>amenities</strong></a>. Upon settling into your welcoming abode, feel free to bring along your cat or dog and adhere to the guidelines outlined in our pet policy.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/amarillo/winchester-apartments/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore our photo gallery to immerse yourself in the tranquility of our Amarillo apartment community. Discover images showcasing our apartment homes and enticing amenities. Furthermore, experience a virtual 360° tour of our Amarillo community from your mobile device, allowing you to wander through our spaces from any corner of the globe.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/acacia-park-apts/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The search is over if you’re looking for an <a href=\"/apartments/tx/el-paso/acacia-park-apts\"><strong>apartment in West El Paso with a pool</strong></a> or a fitness center. Acacia Park is the place to go! From shooting hoops at our community basketball court and splashing around in the resort-style pool to working on your fitness goals in our fitness center, there’s always something to do at Acacia Park Apartments. Parents and caregivers can also relish that our apartments have a playground perfect for little ones.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/acacia-park-apts/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>With floor plans ranging from 1 bedroom to 3 bedroom apartments at Acacia Park Apartments, we make finding the apartment of your dreams easy. Whether you’re moving into your first place and need a 1 bedroom apartment or a 2 bedroom apartment that offers extra room for a roommate or a potential guest room, you’ll find space for comfortable living in our <a href=\"/apartments/tx/el-paso/acacia-park-apts/amenities\"><strong>luxury apartments with abundant amenities</strong></a> in West El Paso.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/acacia-park-apts/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the El Paso neighborhood surrounding Acacia Park Apts. — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/acacia-park-apts/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Acacia Park, we know that whether or not pets are allowed in your apartment is a major dealbreaker. When you choose to live in our West El Paso apartment community, you can bring your furry friend with you. Pups will surely enjoy our on-site dog parks, and your kitty companions will love the ample natural light for cat naps.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/acacia-park-apts/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>With dynamic mountain views set in a sprawling desert landscape, Acacia Park Apartments inspires both the mind and the senses. Take the virtual tour of our<a href=\"/apartments/tx/el-paso/acacia-park-apts/floor-plans\"> one, two, and three bedroom</a> West El Paso, Texas, apartments for rent near Coronado High School. The spacious floor plans offer bright and airy living spaces. Start your morning routine in your modern chef-style kitchen, beautifully equipped with white appliances, a sleek dishwasher, and upgraded fixtures. Choose your outfit of the day from your oversized closet, then head out the door to pick up your car from your reserved space in the available covered parking area.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/chimneys-apts/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>When looking for the best apartments in El Paso, TX, turn to The Chimneys Apartment Homes. Our pet-friendly apartments have a vast array of amenities to enhance every part of your apartment living. Whether you use our fitness center and pool or rent an apartment with a private patio, balcony, or fireplace, we give you the tools you need to help make our home your home. <a href=\"/apartments/tx/el-paso/chimneys-apts/floor-plans\"><strong>Find your apartment in El Paso</strong></a> online today.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/chimneys-apts/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Chimneys is proud to offer both 1 bedroom and 2 bedroom apartments for rent in El Paso, TX. With expansive floor plans and a wide range of <a href=\"/apartments/tx/el-paso/chimneys-apts/amenities\"><strong>El Paso apartment amenities</strong></a>, such as large closets, patios, balconies, and more, we give you the power to make apartment living a luxury, regardless of your home needs.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/chimneys-apts/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the El Paso neighborhood surrounding Chimneys Apts. — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/chimneys-apts/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Chimneys Apartments in west El Paso, TX, we understand that pets are an essential part of many of our tenants’ lives. We offer a pet-friendly environment and community across our west El Paso apartments. Enjoy strolling through the park-like setting of our apartment community and our accommodations for your furry friends. After all, it’s best to allow your pets to enjoy the same luxury living as you do.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/chimneys-apts/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Have a look around and see for yourself what’s waiting for you at The Chimneys Apartments. Our <a href=\"/apartments/tx/el-paso/chimneys-apts/floor-plans\">one and two bedroom apartment</a> community in Northwest El Paso, Texas, is the home you’ve been searching for. Plush carpeting makes your home cozy and warm, while the private patio and refrigerated air conditioning provide a fresh breeze on those hot Texas days. Keep scrolling and discover more features waiting for you in your new home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Are you looking for a pet-friendly apartment with a pool in West El Paso? The search is over at Double Tree Apartments, less than 25 minutes from Fort Bliss. With <a href=\"/apartments/tx/el-paso/double-tree-apts/floor-plans\"><strong>four distinct floor plans</strong></a>, our 1 and 2 bedroom apartment homes feature spacious floor plans, ample closet space, and a private patio or balcony, perfect for planting flowers or vegetables in a container. When you’re not spending time inside, you can head outside to our picnic area to admire the well-kept landscaping and gorgeous mountains.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Double Tree Apartments, we’re proud to offer top-tier 1 and 2 bedroom apartments in Westside El Paso, designed with your comfort and lifestyle in mind. Our <a href=\"/apartments/tx/el-paso/double-tree-apts/pet-policy\"><strong>pet-friendly</strong></a> floor plans<strong> </strong>feature a cozy dining space, a spacious living space, and a private patio or balcony. No matter which one of our El Paso apartment floor plans you select, you’ll love our large closets.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the El Paso neighborhood surrounding Double Tree Apts. — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Here at Double Tree, we know pets are a vital part of the family. That’s why we offer pet-friendly apartments in El Paso. Dog owners love our walking paths and the nearby parks for walking their pups, while cat owners can find their kitties birdwatching in the windows.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/double-tree-apts/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Are you curious to see what our Double Tree Apartment Community looks like? Head to our <a href=\"/apartments/tx/el-paso/double-tree-apts/photos\"><strong>photo gallery</strong></a> to explore our apartment community further. Envision yourself basking in the sun by the pool or crafting a meal for friends and family on the grill. To better picture yourself in one of Double Tree’s 1-bedroom and 2-bedroom apartments in West El Paso, scroll to the bottom of the photo gallery page and take a 360° virtual tour today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>High Ridge Apartments in East El Paso features an apartment community with a pool, fitness center, and several other high-end amenities for our residents’ disposal. You’ll love our apartments with a fireplace for those chilly fall and winter evenings, perfect for cozying up with hot cocoa. Our <a href=\"/apartments/tx/el-paso/high-ridge-apts/pet-policy\"><strong>pet-friendly apartment community</strong></a> is near Ben Burton Park, ideal for exploring nature with your pup.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>In our High Ridge apartment community in East El Paso, you’ll find 1 and 2 bedroom apartments offering four distinct floor plans to suit your lifestyle. These floor plans were meticulously designed to blend style and comfort. We offer cozy 1 bedroom apartments and spacious 2 bedroom apartments, all featuring <a href=\"/apartments/tx/el-paso/high-ridge-apts/amenities\"><strong>luxury amenities</strong></a> like large closets, a private balcony, and upgraded fixtures.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the El Paso neighborhood surrounding High Ridge Apts. — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Are you looking for a pet-friendly apartment in El Paso? We’ve got you covered. When you rent with us, your furry friends can move in with you. Whether you have an adorable pooch or a feline friend, they’re sure to love living at High Ridge Apartments.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/high-ridge-apts/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>For a warm and comfortable home in an excellent location, look no further than High Ridge Apartments. Our <a href=\"/apartments/tx/el-paso/high-ridge-apts/floor-plans\">one and two bedroom apartments</a> for rent in East El Paso embody the spirit of Texas. Click through our photo gallery and picture a new life to love. Beat the heat in the warm summer months with the help of in-home air conditioning and ceiling fans. On cool winter nights, take advantage of the wood-burning fireplace in select homes. Your new apartment home is also outfitted with a fully equipped kitchen, beautifully furnished with a spacious refrigerator and convenient dishwasher, as well as upgraded countertops, cabinets, and light fixtures.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/mountain-village-apts/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Mountain Village is more than just a place to stay—we’re a community committed to creating a luxurious living experience for all. When you live here, you’ll have access to several exciting and helpful amenities, not to mention conveniences like having an apartment with a patio or balcony. We offer more than just apartments with a pool. We have two pools for you to enjoy. Find the perfect apartment for you in <a href=\"/apartments/tx/el-paso/mountain-village-apts/neighborhood\"><strong>West El Paso</strong></a>!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/mountain-village-apts/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We want you to feel comfortable and cozy in your home, whether you’re returning from a long day at work or looking to relax on the weekend. We offer three spacious Northwest El Paso apartment floor plans, state-of-the-art amenities, and perks.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/mountain-village-apts/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the El Paso neighborhood surrounding Mountain Village Apts. — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/mountain-village-apts/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Mountain Village Apartments, we believe that your furry friends are a part of your family and deserve to be treated as such. We proudly offer pet-friendly apartments in West El Paso so you and your loved ones can live together peacefully. From puppies to kittens to grown-up pets, our residents find it easy to love and play with their pets while living here.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/mountain-village-apts/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The cool mountain setting and active lifestyle set us apart from other apartment communities in the area. Take the virtual tour through our photo gallery to explore our community near Sunland Park Mall. Complete with plush carpeting as well as a spacious living area, each apartment is impressively designed to maximize your home life, and select floor plans feature a wood-burning fireplace for cozy nights at home. Take advantage of the gorgeous El Paso weather outside on your<a href=\"/apartments/tx/el-paso/mountain-village-apts/amenities\"> private balcony or patio</a> overlooking beautiful Franklin Mountains State Park.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/patriot-apts/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The amenities inside <a href=\"/apartments/tx/el-paso/patriot-apts/floor-plans\"><strong>our El Paso apartments</strong></a> and around The Patriot community make it easy for every resident to feel at home. Inside our apartment homes, you’ll find comforting touches, like a spacious kitchen and stylish finishes, like wood-style flooring. Our El Paso apartment community’s amenities invite residents to have fun and relax, whether they prefer a cardio workout in our 24-hour fitness center or family time at our on-site playground.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/patriot-apts/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Patriot offers eight distinctive floor plans, allowing you to choose a 1 bedroom, 2 bedroom, or 3 bedroom apartment. With our wide range of options, you’ll have no trouble finding a good fit for your lifestyle. Apartment homes range from 655 to over 1,070 sq. ft., and every floor plan features large closets and a bright, airy living space.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/patriot-apts/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the El Paso neighborhood surrounding Patriot Apts. — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/patriot-apts/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Patriot, you’ll find pet-friendly apartments in El Paso where you and your pet can live in harmony. When your pup needs some play time, our on-site dog park is nearby. With our apartments’ large windows, cats will enjoy sunbathing in the light for hours. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/patriot-apts/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our apartments seamlessly combine comfort with convenience. As you enter your <a href=\"/apartments/tx/el-paso/patriot-apts/floor-plans\">one, two, or three bedroom apartment</a>, you’ll feel welcomed by handsome wood-style flooring met by plush carpeting. The kitchen is fully equipped with all the essentials, including a timesaving dishwasher, garbage disposal, and refrigerator, and the roommate-accommodating floor plan makes it easy to share your home or host out-of-town guests while maintaining plenty of privacy and space.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/phoenix-apts/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We offer a variety of <a href=\"/apartments/tx/el-paso/phoenix-apts/floor-plans\"><strong>1, 2, and 3 bedroom apartments</strong></a>, each with comfortable amenities that enhance your life. Our family-friendly community is gated for extra security and peace of mind. Around our community, you’ll find several amenities to help you enjoy each day living in sunny El Paso, including a pool, a sun deck, and a resident clubhouse.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/phoenix-apts/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Find an El Paso apartment home at The Phoenix with 1, 2, and 3 bedroom options. The natural light and neutral walls around our apartments allow you to cater your apartment home to your lifestyle. You’ll find plush, comfortable carpeting in the living room and bedrooms and wood-style flooring in the bathrooms and kitchen for easy cleanup.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/phoenix-apts/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the El Paso neighborhood surrounding Phoenix Apts. — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/phoenix-apts/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We understand that pets are an important part of a family, so we offer pet-friendly apartments in El Paso. Our welcoming apartment community is a great place to live with a dog or cat, with lots of room to play.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/phoenix-apts/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>As you explore our photo gallery, envision how you’ll make this space your own. Do you like to cook? How will you style your fully equipped kitchen? Pay attention to the details designed for your comfort and convenience – <a href=\"/apartments/tx/el-paso/phoenix-apts/amenities\">air conditioning</a> to stay cool year round, a time-saving dishwasher, and reliable cell reception so you can keep in touch with friends and family.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/shadow-ridge-apts/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Shadow Ridge is not just a place to put a roof over your head. It’s an exciting and upscale experience with many amenities to help your apartment home reach its full potential. Some of the many amenities in our pet-friendly apartments include expansive patios and balconies, a swimming pool, a gym, and much more. Browse through our available <a href=\"/apartments/tx/el-paso/shadow-ridge-apts/floor-plans\"><strong>apartments in El Paso, TX,</strong></a> and make Shadow Ridge your home today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/shadow-ridge-apts/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>After a long day at work or school, you’ll want to return to a comfortable and inviting place to call home. With a wide selection of floor plans and <a href=\"/apartments/tx/el-paso/shadow-ridge-apts/amenities\"><strong>amenities</strong></a>, such as a well-equipped kitchen and high-speed internet, the luxury apartments at Shadow Ridge are your number one choice for upscale apartment living in El Paso, TX.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/shadow-ridge-apts/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the El Paso neighborhood surrounding Shadow Ridge Apts. — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/shadow-ridge-apts/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>It’s known throughout our team that many of our residents at Shadow Ridge Apartments consider their pets a part of their family. From purring cats to yappy pups, we allow them in our pet-friendly apartments in east El Paso, TX. With comfortable apartment homes and an on-site bark park on a scenic, spacious property, turn your El Paso luxury apartment into a paradise for your furry friend.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/shadow-ridge-apts/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Browse the photos of Shadow Ridge and discover comfortable living in El Paso. Take a look at the swimming pool, complete with a wading pool and grilling area and imagine spending a lazy weekend taking advantage of poolside hangouts in the summer sun. As you browse through the gallery, take note of our <a href=\"/apartments/tx/el-paso/shadow-ridge-apts/floor-plans\">spacious floor plans</a> with select features, including a wood-burning fireplace, private patios, and more.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Crest’s comfortable apartments and <a href=\"/apartments/tx/el-paso/the-crest/neighborhood\"><strong>beautiful community</strong></a> put everything you need within reach. When you’re not enjoying our apartments’ blend of elegant and essential features, you’ll find upscale community amenities just minutes from your front door. Whether you prefer to spend your mornings breaking a sweat at the fitness center or afternoons floating in the pool, The Crest has it all. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><a href=\"/apartments/tx/el-paso/the-crest/neighborhood\"><strong>Our El Paso apartment community</strong></a> has seven distinct floor plans, each featuring cozy living and dining spaces and full kitchens. We offer cozy 1 bedroom apartments, versatile 2 bedroom layouts, and roomy 3 bedroom havens, allowing you to select the best option for you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the El Paso neighborhood surrounding The Crest — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>There is no better place for your pets to live and play than at Crest Apartments in El Paso. Pups can exercise at our on-site dog park, while cats can bask in the warm El Paso sun shining through the glass doors of your patio or balcony.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/el-paso/the-crest/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a virtual tour of our community to see why The Crest Apartments stands apart from the crowd. Imagine stepping into your new home, taking note of the beautiful, easy-to-clean wood-plank flooring and an air conditioner that helps you stay cool year-round. Your kitchen is equipped with stainless-steel appliances, including a time-saving microwave for those days when you don’t feel like cooking.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/hewitt/icon-at-hewitt/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>For the best upscale apartments in Hewitt, TX, look no further than the Icon at Hewitt. Alongside our family and pet-friendly apartments, we offer an extended range of amenities and features for apartment and community use. Whether you want to use our fitness center or pool or want a night in on your private patio or balcony, experience it in luxury at the Icon at Hewitt. <a href=\"/apartments/tx/hewitt/icon-at-hewitt/floor-plans#/\"><strong>Find your Hewitt apartment</strong></a> online today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/hewitt/icon-at-hewitt/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Icon at Hewitt, we’re proud to offer high-quality 1 and 2 bedroom apartments and townhomes in Hewitt, TX. With our apartment <a href=\"/apartments/tx/hewitt/icon-at-hewitt/amenities\"><strong>amenities</strong></a> like private balconies, patios, and garages included, our cozy yet spacious floor plans offer you the power to live in luxury.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/hewitt/icon-at-hewitt/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Hewitt neighborhood surrounding Icon at Hewitt — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/hewitt/icon-at-hewitt/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our team at Icon at Hewitt Apartments understands that pets are incredibly important to many of our residents. We offer pet-friendly apartments in our Hewitt apartment community to let your furry friend live comfortably. Whether you have an indoor cat or a puppy eager to roam our on-site dog park, your pets will enjoy the same comfort and luxury as you do.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/hewitt/icon-at-hewitt/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Get a glimpse of the resort-style ambiance at Icon at Hewitt. Our <a href=\"/apartments/tx/hewitt/icon-at-hewitt/floor-plans\">one and two bedroom apartments and lofts </a>for rent in Hewitt, Texas, offer all the comforts of home and the luxury amenities you desire. Enjoy an invigorating workout any time of the day in our 24-hour fitness center. Enjoy a refreshing soak in the zero-entry pool, and then lounge on the sundeck with a good book. Grab a coffee at the internet café, then take your pup to the dog park for some off-leash playtime. Icon at Hewitt is packed with the perks to help you maximize your downtime.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>The Cottages at Abbey Glen apartment community in Lubbock features elevated living and high-quality amenities. From inside your apartment home to throughout our apartment community, luxury and comfort awaits you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Cottages at Abbey Glen, you’ll find a variety of floor plans for our 1 and 2 bedroom apartments in Lubbock. Every single one of our luxury apartments offers space to spread out, complete with a spacious living room area. <a href=\"/apartments/tx/lubbock/cottages-at-abbey-glen/neighborhood\"><strong>Our Lubbock apartment homes</strong></a> are ideal for hosting dinners for friends, date nights, or just vegging out and watching TV.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Lubbock neighborhood surrounding Cottages at Abbey Glen — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Are you a pet owner looking for a pet-friendly apartment in Lubbock? Our Cottages at Abbey Glen apartment community has you covered! When you move into our luxury apartments in Lubbock, you can bring your pets with you. Pups love playing in our on-site dog park, and cats love rolling around on our plush carpeting. Pet policies at our apartments include:</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore the photo gallery and envision a new standard of living at Cottages at Abbey Glen Apartments. Our <a href=\"/apartments/tx/lubbock/cottages-at-abbey-glen/floor-plans\">one and two bedroom apartments and townhomes</a> for rent in Lubbock, Texas, offer an abundance of resort-style amenities for you to take advantage of. Enjoy an invigorating workout any time of the day in our 24-hour fitness center. Relax poolside under a plush cabana or head to the grill area for a community picnic.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>You’ll be happy choosing The Icon at Lubbock if you’re looking for the ultimate apartment in Lubbock, TX. Our pet-friendly apartments in Lubbock have various amenities to make your apartment living experience exceptional. Enjoy our apartments with a relaxing pool and state-of-the-art fitness center, or choose an apartment with a garage, spacious closet, or cozy fireplace. Find your perfect Lubbock apartment online today.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our spacious 1 bedroom and 2 bedroom apartments in <a href=\"/apartments/tx/lubbock/icon-at-lubbock/neighborhood\"><strong>Lubbock, TX</strong></a>, offer big floor plans and a variety of amenities to meet your needs. We take pride in providing you with the best rental options in Lubbock, TX. With us, you can transform apartment living into a luxurious experience with enlarged bathrooms, cozy fireplaces, attached garages, and more.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Lubbock neighborhood surrounding Icon at Lubbock — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our pet-friendly community welcomes you and your pet to make your home at Icon at Lubbock. The onsite bark park provides a convenient space for your companions to run to their heart’s content or they relax indoors next to your fireplace on cool winter evenings.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/icon-at-lubbock/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a look through our beautiful apartment community in Lubbock. Let the high ceilings and plush carpeting welcome you home. Check out the large, modern kitchen detailed with sophisticated ceramic tile and <a href=\"/apartments/tx/lubbock/icon-at-lubbock/amenities\">stainless-steel appliances</a>. We know that luxury doesn’t have to exclude practicality, which is why each loft, one, or two bedroom apartment for rent is outfitted with a spacious walk-in closet and convenient extra storage.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Enter the comfort and convenience at <strong><a href=\"/apartments/tx/lubbock/tuscany-place\">Tuscany Place in Lubbock</a></strong>, where our apartment homes and community are adorned with an array of luxurious amenities that elevate your living experience. Inside your apartment home, a furnished kitchen awaits, complete with modern steel appliances, including a stove, microwave, fridge, and dishwasher—streamlining your dinner routine with gourmet style.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>With upscale 1 and 2 bedroom apartments in Lubbock, Tuscany Place has a floor plan for every lifestyle. We even offer 2 bedroom apartments with an attached garage for optimal privacy. The abundance of natural light in all of our Lubbock apartments creates a bright and airy atmosphere, setting the scene for your ideal home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Lubbock neighborhood surrounding Tuscany Place — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Here at Tuscany Place, we know your dogs and cats are more than just pets. They’re family. That’s why we offer pet-friendly apartments in Lubbock, complete with an on-site dog park and beautifully landscaped walking paths. Your kitty companions will also love living in our luxury apartments, with plenty of big windows for birdwatching.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/lubbock/tuscany-place/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover an enhanced sense of ease in a one or two bedroom apartment or loft for rent in Lubbock, Texas.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/temple/portico-at-friars-creek-apts/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Portico at Friars Creek is more than just a place to come home to. It’s a vibrant community filled with many opportunities to take advantage of with the help of our amenities. With a wide range of community and apartment amenities, you’ll discover how our Temple apartment homes can spark joy and comfort for you and your loved ones. <a href=\"/apartments/tx/temple/portico-at-friars-creek-apts/floor-plans\"><strong>Find your Temple apartment or loft</strong></a> online today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/temple/portico-at-friars-creek-apts/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>After a long day at work or school, you deserve a place to wind down and relax. Our high-end 1 and 2 bedroom apartments, lofts, and townhomes in Temple, TX, provide the perfect retreat for you and your family.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/temple/portico-at-friars-creek-apts/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Temple neighborhood surrounding Portico at Friars Creek Apts — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/temple/portico-at-friars-creek-apts/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Pets are an important part of many of our residents’ lives. As part of our commitment to create an elevated community experience, we’re excited to open our doors to your furry friends. Our pet-friendly apartments are a perfect option for comfortable and convenient living for people and pets alike. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/temple/portico-at-friars-creek-apts/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>We welcome you to picture your new life at The Portico at Friars Creek. Take advantage of our <a href=\"/apartments/tx/temple/portico-at-friars-creek-apts/amenities\">24-hour fitness center </a>to work toward your health goals, take a dip at our beautiful resort-style pool with cabanas, then kick back in a lounge chair with your favorite read. Over at the barbecue and picnic area, you can enjoy a cookout with your friends or an evening curled up by the outdoor fireplace. Our community is here for your lifestyle to thrive.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>What makes our high-end Waco apartments so great? For starters, we offer a wide range of amenities in our apartments and our apartment community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>With so many floor plans available at our Bend at New Road apartments in Waco, you’re sure to find a great fit for your lifestyle. Our spacious Waco apartments are great for single residents, couples, and even families. We also offer pet-friendly apartments, so you can bring the fur babies too!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Waco neighborhood surrounding Bend at New Road — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Luxury apartment living shouldn’t mean your pets can’t come along with you. Here at Bend at New Road, we know pets are your family members, which is why we offer pet-friendly apartment homes in Waco. Pups love our on-site bark park, while cats enjoy sunbathing in all our apartments’ natural light.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/bend-at-new-road/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Envision your new lifestyle as you browse through the gallery and take a closer look at our apartments and community grounds. Inside and out, Bend at New Road Apartments sets you up to experience the best version of your life. Imagine play dates with your pup at the <a href=\"/apartments/tx/waco/bend-at-new-road/pet-policy\">on-site dog park</a>, watching your worries float away in the resort-inspired pool, or catching up with friends in the luxury clubhouse.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/tuscany-ranch-apartments/amenities::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>When you rent a luxury apartment at Tuscany Ranch, you receive more than the standard. With the power of our many amenities to enhance your experience, you and your loved ones will unlock upscale apartment living in Waco, TX. See all we offer and <a href=\"/apartments/tx/waco/tuscany-ranch-apartments/floor-plans#/\"><strong>find your South Waco apartment</strong></a> online today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/tuscany-ranch-apartments/floor-plans::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>No matter how rough or pleasant your school or workday is, you deserve to return to a place that feels like home. Across all our Waco apartments, lofts, and townhomes, you’ll find the perfect space for you, your family, and your pets to call home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/tuscany-ranch-apartments/neighborhood::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the Waco neighborhood surrounding Tuscany Ranch Apartments — your guide to nearby dining, shopping, schools, and entertainment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/tuscany-ranch-apartments/pet-policy::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our commitment to luxury apartment living is not exclusive to just humans. We offer the best pet-friendly apartments in Waco, TX. With a number of different residential and community <a href=\"/apartments/tx/waco/tuscany-ranch-apartments/amenities\"><strong>amenities</strong></a> for the comfort of you and your furry companions, luxury living is waiting for you at Tuscany Ranch Apartments. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/tx/waco/tuscany-ranch-apartments/photos::propertysubpageheader.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Get a preview of your new, relaxing lifestyle at Tuscany Ranch. Imagine hot, sunny days around our resort-inspired pool or early morning workouts in our fully equipped, <a href=\"/apartments/tx/waco/tuscany-ranch-apartments/amenities\">24-hour fitness center</a>. Picture curling up with your furry friend beside your wood-burning fireplace (in select homes) or enjoying the sunset from your private patio or balcony. Browse our photo gallery for a detailed view of our pet-friendly apartments and unmatched community amenities all nestled in a prime Waco neighborhood.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/floor-plans::propertysubpageheader.title": {
    "overrideType": "VALUE",
    "customValue": "<p><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Duplexes in <span data-type=\"field-token\" data-field=\"property_address_city\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/oklahoma-city/24hundred-apartments::specialoffers.show_image": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/cascata-luxury-apartments::specialoffers.show_image": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford::specialoffers.show_image": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:property::tourschedulermodal.tour.disable_live_video_tour": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts::tourschedulermodal.tour.disable_self_guided_tour": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts/amenities::tourschedulermodal.tour.disable_self_guided_tour": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts/contact-us::tourschedulermodal.tour.disable_self_guided_tour": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts/floor-plans::tourschedulermodal.tour.disable_self_guided_tour": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts/neighborhood::tourschedulermodal.tour.disable_self_guided_tour": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts/pet-policy::tourschedulermodal.tour.disable_self_guided_tour": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts/photos::tourschedulermodal.tour.disable_self_guided_tour": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/north-little-rock/lexington-park::tourschedulermodal.tour.disable_self_guided_tour": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/north-little-rock/lexington-park/amenities::tourschedulermodal.tour.disable_self_guided_tour": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/north-little-rock/lexington-park/contact-us::tourschedulermodal.tour.disable_self_guided_tour": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/north-little-rock/lexington-park/floor-plans::tourschedulermodal.tour.disable_self_guided_tour": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/north-little-rock/lexington-park/neighborhood::tourschedulermodal.tour.disable_self_guided_tour": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/north-little-rock/lexington-park/pet-policy::tourschedulermodal.tour.disable_self_guided_tour": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "apartments/ar/north-little-rock/lexington-park/photos::tourschedulermodal.tour.disable_self_guided_tour": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:property::tourschedulermodal.tour.self_guided_tour_link": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_tour24_url"
  }
};

export const slotGroupOverrides = {
  "aboutimageslider.image_0": {
    "sourceIndex": 9,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfd5c-6273-779d-a2f8-1bb8823bc679.webp"
      }
    }
  },
  "aboutimageslider.image_1": {
    "sourceIndex": 7,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfd5c-59a4-7768-9d1d-97f6bb8b9422.webp"
      }
    }
  },
  "aboutimageslider.image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfd5c-74ab-7608-8787-3750f0afc72c.webp"
      }
    }
  },
  "aboutimageslider.image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfd5c-6ba6-71e8-afd0-f113dbcb5f45.webp"
      }
    }
  },
  "aboutimageslider.image_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfd5c-4fbc-76d7-808b-801534e70d78.webp"
      }
    }
  },
  "apartments/ks/wichita/aspen-park-apartments/amenities::amenitieslist.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019db589-06c6-773d-a90a-41acae245937.webp"
      }
    }
  },
  "apartments/ks/wichita/cottages-at-crestview/amenities::amenitieslist.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a18979-4ccf-75fe-a4a7-a3b4df6ca8a6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of apartment buildings with a swimming pool and courtyard area."
      }
    }
  },
  "apartments/ks/wichita/huntington-park/amenities::amenitieslist.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166545/01a11c6c-eb1f-7788-98c8-968e8d416200.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with cardio machines, weight racks, and televisions."
      }
    }
  },
  "apartments/ks/wichita/portofino/amenities::amenitieslist.photo_0": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "apartments/ks/wichita/villas-of-waterford/amenities::amenitieslist.photo_0": {
    "sourceIndex": 30,
    "fieldOverrides": null
  },
  "apartments/mo/belton/center-301/amenities::amenitieslist.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431e-78ee-717b-a621-389d6e497cb7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor seating area with a fire pit, overlooking a pool and apartment buildings."
      }
    }
  },
  "apartments/mo/independence/the-adirondack/amenities::amenitieslist.photo_0": {
    "sourceIndex": 32,
    "fieldOverrides": null
  },
  "apartments/mo/kansas-city/152-northland/amenities::amenitieslist.photo_0": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "apartments/mo/kansas-city/97-north-oak/amenities::amenitieslist.photo_0": {
    "sourceIndex": 19,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/amenities::amenitieslist.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019faa59-e287-7358-bbb3-652f8e7c7362.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Beautiful outdoor swimming pool with lounge chairs at a multifamily property."
      }
    }
  },
  "apartments/ok/broken-arrow/redbud-ranch/amenities::amenitieslist.photo_0": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/amenities::amenitieslist.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-9b2d-7086-b05d-6b07c367664d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor grilling station with picnic tables, grills, and a stone fireplace."
      }
    }
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/amenities::amenitieslist.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a33-e2c5-763b-a941-b9958778064e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Gym with treadmills, weight machines, and large TV on the wall."
      }
    }
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/amenities::amenitieslist.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-5ab2-74ae-82b7-a9dd84eab160.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with fireplace, sofa, coffee table, and desk."
      }
    }
  },
  "apartments/ok/edmond/villas-at-stonebridge/amenities::amenitieslist.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c1c-8e01-7331-82ee-de6a5289dbcc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool with lounge chairs and apartment buildings in the background."
      }
    }
  },
  "apartments/ok/jenks/the-reserve-at-elm/amenities::amenitieslist.photo_0": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "apartments/ok/norman/artisan-crossing-apts/amenities::amenitieslist.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019f003f-a471-760e-b465-a612fe48c29b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool with lounge chairs and a building."
      }
    }
  },
  "apartments/ok/norman/cimarron-trails-apts/amenities::amenitieslist.photo_0": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/amenities::amenitieslist.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db713-52af-71c9-b1c2-473289cc53a9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern apartment kitchen with stainless steel appliances, white cabinets, and a marble countertop."
      }
    }
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/amenities::amenitieslist.photo_0": {
    "sourceIndex": 2,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d2-5a85-71be-969d-f767c4a28084.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with cable machine, free weights, kettlebells, medicine balls, and treadmills."
      }
    }
  },
  "apartments/ok/oklahoma-city/council-place-apartments/amenities::amenitieslist.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/019cfb3d-d011-75de-b463-634f2d1d48fd.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A clean, bright outdoor swimming pool with blue lounge chairs and surrounding green grass."
      }
    }
  },
  "apartments/ok/oklahoma-city/cross-timber/amenities::amenitieslist.photo_0": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/amenities::amenitieslist.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08674-af76-763d-856f-f13512738c6d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with treadmills, elliptical, and free weights."
      }
    }
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/amenities::amenitieslist.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d7-d5ae-73bb-854f-60704947c536.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment complex with a swimming pool and lounge chairs."
      }
    }
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments/amenities::amenitieslist.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4b-266a-74d8-9f70-b422a34096cc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Tennis court with a fenced perimeter, adjacent to a lake with a gazebo and pier."
      }
    }
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/amenities::amenitieslist.photo_0": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "apartments/ok/owasso/coffee-creek/amenities::amenitieslist.photo_0": {
    "sourceIndex": 29,
    "fieldOverrides": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/amenities::amenitieslist.photo_0": {
    "sourceIndex": 2,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/01a13590-98c4-77af-8227-9110a45f9324.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "The Cottages at Tallgrass Point monument sign."
      }
    }
  },
  "apartments/ok/owasso/cypress-crossing/amenities::amenitieslist.photo_0": {
    "sourceIndex": 48,
    "fieldOverrides": null
  },
  "apartments/ok/pryor/west-530/amenities::amenitieslist.photo_0": {
    "sourceIndex": 26,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-3b77-7548-aab7-9961a1c6883a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Gym with treadmills, elliptical, stationary bike, weight machines, and exercise balls."
      }
    }
  },
  "apartments/ok/stillwater/apple-creek-stillwater/amenities::amenitieslist.photo_0": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/barrington-apartments/amenities::amenitieslist.photo_0": {
    "sourceIndex": 26,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cedar-glade-apts/amenities::amenitieslist.photo_0": {
    "sourceIndex": 27,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf6a-a312-7504-8e2b-22f52387782e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Community coffee and refreshment station with a stainless steel refrigerator, microwave, coffee maker, and a counter with stools."
      }
    }
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/amenities::amenitieslist.photo_0": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/chardonnay/amenities::amenitieslist.photo_0": {
    "sourceIndex": 9,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/amenities::amenitieslist.photo_0": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/creekwood-apartments/amenities::amenitieslist.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1948-830e-7784-bdda-a8ae8e9d682e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with treadmills, stationary bikes, elliptical machines, and a fireplace."
      }
    }
  },
  "apartments/ok/tulsa/sheridan-pond/amenities::amenitieslist.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02003-318c-74d1-a816-48d36ec7c1c6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor dog park with agility equipment and apartment buildings in the background."
      }
    }
  },
  "apartments/ok/tulsa/sugarberry-apartments/amenities::amenitieslist.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01600-dacb-75db-8808-46cbe45398eb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area with a round table, four black chairs, and a wall clock."
      }
    }
  },
  "apartments/ok/tulsa/sunchase-apartments/amenities::amenitieslist.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-5a4e-72b0-9433-ec50c214bb37.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Indoor swimming pool with rocks and waterfall feature."
      }
    }
  },
  "apartments/ok/tulsa/the-courtyards/amenities::amenitieslist.photo_0": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/amenities::amenitieslist.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-2941-717a-8bdd-71015d0639a2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Gym with treadmills, elliptical, weight machines, free weights, and weight benches."
      }
    }
  },
  "apartments/ok/tulsa/windsail-apartments/amenities::amenitieslist.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fcea7-525e-70d8-8f89-7033e84ba84e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious community lounge with high ceilings, fireplace, seating areas, and a reception desk."
      }
    }
  },
  "apartments/ok/yukon/park-at-westpointe/amenities::amenitieslist.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c1-7bfb-711b-a137-be0d36478e07.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor kitchen area with built-in grills and a stone fireplace, along with a picnic table."
      }
    }
  },
  "apartments/tx/amarillo/newport-amarillo-apts/amenities::amenitieslist.photo_0": {
    "sourceIndex": 3,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf6-c5f4-73fb-93c8-1f6282748753.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor grilling area with two built-in grills, picnic tables, and umbrellas, surrounded by green lawn and apartment buildings."
      }
    }
  },
  "apartments/tx/amarillo/park-at-coulter/amenities::amenitieslist.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc3-a4bd-734d-8eb1-ce44ea58c401.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "The Park at Coulter luxury apartments monument sign."
      }
    }
  },
  "apartments/tx/amarillo/remington-amarillo-apts/amenities::amenitieslist.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df3-62f6-730e-a615-2020b3facecf.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious lounge area with fireplace and view of outdoor pool."
      }
    }
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/amenities::amenitieslist.photo_0": {
    "sourceIndex": 12,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/01a0e997-0ab0-708d-8afe-13b6d8981768.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Treadmills, elliptical, and weight machine in a bright, well-lit fitness center."
      }
    }
  },
  "apartments/tx/amarillo/winchester-apartments/amenities::amenitieslist.photo_0": {
    "sourceIndex": 30,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/01a117a3-760e-709e-a8d9-f2ae237f3154.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Winchester property monument sign with landscaping and trees"
      }
    }
  },
  "apartments/tx/el-paso/acacia-park-apts/amenities::amenitieslist.photo_0": {
    "sourceIndex": 25,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/chimneys-apts/amenities::amenitieslist.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611c-0f98-737a-96a0-c03b0d3fa4b8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool and spa area with fountains and seating."
      }
    }
  },
  "apartments/tx/el-paso/double-tree-apts/amenities::amenitieslist.photo_0": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/high-ridge-apts/amenities::amenitieslist.photo_0": {
    "sourceIndex": 32,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/phoenix-apts/amenities::amenitieslist.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/01a0a16b-3880-741f-89a6-684617cff2aa.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Playground with slides and climbing structures."
      }
    }
  },
  "apartments/tx/el-paso/shadow-ridge-apts/amenities::amenitieslist.photo_0": {
    "sourceIndex": 88,
    "fieldOverrides": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/amenities::amenitieslist.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a0e9d7-75de-754c-921b-19d6407ae05e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and umbrellas at a multifamily property."
      }
    }
  },
  "apartments/tx/lubbock/tuscany-place/amenities::amenitieslist.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2a-3d99-708a-b7a7-c941e49f72cf.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and tables, surrounded by apartment buildings."
      }
    }
  },
  "apartments/tx/waco/bend-at-new-road/amenities::amenitieslist.photo_0": {
    "sourceIndex": 10,
    "fieldOverrides": null
  },
  "apartments/ks/wichita/aspen-park-apartments/amenities::amenitieslist.photo_1": {
    "sourceIndex": 31,
    "fieldOverrides": null
  },
  "apartments/ks/wichita/huntington-park/amenities::amenitieslist.photo_1": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "apartments/ks/wichita/portofino/amenities::amenitieslist.photo_1": {
    "sourceIndex": 49,
    "fieldOverrides": null
  },
  "apartments/mo/belton/center-301/amenities::amenitieslist.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431e-b4c4-704d-8704-40e6cc3f7cff.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment complex with a dog park featuring benches and agility equipment."
      }
    }
  },
  "apartments/mo/independence/the-adirondack/amenities::amenitieslist.photo_1": {
    "sourceIndex": 21,
    "fieldOverrides": null
  },
  "apartments/mo/kansas-city/152-northland/amenities::amenitieslist.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3ced-0abe-7628-bf11-512ddbf68354.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Well-equipped fitness center with treadmills, ellipticals, and weight machines, featuring a vibrant hexagonal carpet."
      }
    }
  },
  "apartments/mo/kansas-city/97-north-oak/amenities::amenitieslist.photo_1": {
    "sourceIndex": 22,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/amenities::amenitieslist.photo_1": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills/amenities::amenitieslist.photo_1": {
    "sourceIndex": 21,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/redbud-ranch/amenities::amenitieslist.photo_1": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/amenities::amenitieslist.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a33-e3a2-71cc-97ea-ac58760acb1d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "The Trails at Aspen Creek community lounge with modern furniture and a large fireplace."
      }
    }
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/amenities::amenitieslist.photo_1": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/amenities::amenitieslist.photo_1": {
    "sourceIndex": 28,
    "fieldOverrides": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/amenities::amenitieslist.photo_1": {
    "sourceIndex": 8,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-6b55-768e-bb20-ce6f2b86be23.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of apartment building with attached garages under a clear blue sky."
      }
    }
  },
  "apartments/ok/norman/artisan-crossing-apts/amenities::amenitieslist.photo_1": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "apartments/ok/norman/cimarron-trails-apts/amenities::amenitieslist.photo_1": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/amenities::amenitieslist.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db713-2e07-7799-b022-b7c04c4c80ef.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Primary bedroom with queen-size bed, bedside tables, dresser, and wall decor."
      }
    }
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/amenities::amenitieslist.photo_1": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/amenities::amenitieslist.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a14009-d7d9-775e-95cc-50bbba677a51.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment complex with a large, blue swimming pool and lounge chairs."
      }
    }
  },
  "apartments/ok/oklahoma-city/council-place-apartments/amenities::amenitieslist.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/01a183b2-9e8d-74f1-95d9-25816724cbe0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Gym with treadmills, elliptical machines, free weights, and a TV."
      }
    }
  },
  "apartments/ok/oklahoma-city/cross-timber/amenities::amenitieslist.photo_1": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/amenities::amenitieslist.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08675-75ae-72f2-87a9-2355f6debf88.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Empty walk-in closet with white wire shelving and woven baskets."
      }
    }
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/amenities::amenitieslist.photo_1": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/amenities::amenitieslist.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d7-98d7-7428-8c7c-0acaf01cad86.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "View of apartment building and trees from a balcony or patio."
      }
    }
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments/amenities::amenitieslist.photo_1": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/amenities::amenitieslist.photo_1": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "apartments/ok/owasso/coffee-creek/amenities::amenitieslist.photo_1": {
    "sourceIndex": 31,
    "fieldOverrides": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/amenities::amenitieslist.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/01a1358e-4f13-701b-9716-0d9d0cc0e0cd.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Community lounge area with a dining table, island, fireplace, and large windows."
      }
    }
  },
  "apartments/ok/owasso/cypress-crossing/amenities::amenitieslist.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019dc150-67b7-77fa-84da-fc9cec1d3090.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment buildings with a fenced-in dog park area in the foreground, featuring a red tunnel and benches."
      }
    }
  },
  "apartments/ok/pryor/west-530/amenities::amenitieslist.photo_1": {
    "sourceIndex": 39,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/barrington-apartments/amenities::amenitieslist.photo_1": {
    "sourceIndex": 25,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cedar-glade-apts/amenities::amenitieslist.photo_1": {
    "sourceIndex": 17,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf6a-a0e5-77a2-aad9-188e91b99c99.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Lobby with fireplace and seating areas"
      }
    }
  },
  "apartments/ok/tulsa/country-hollow-apartments/amenities::amenitieslist.photo_1": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/creekwood-apartments/amenities::amenitieslist.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1948-cb52-72c6-a70d-051261f9f776.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor basketball court with dark gray surface, white lines, and a hoop. Apartment buildings and parked cars are visible behind the fence."
      }
    }
  },
  "apartments/ok/tulsa/nickel-creek-apts/amenities::amenitieslist.photo_1": {
    "sourceIndex": 10,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/sugarberry-apartments/amenities::amenitieslist.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a015fe-938e-74ec-b914-9e505e85cfbd.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy living room with a fireplace, comfortable sofa, and balcony access."
      }
    }
  },
  "apartments/ok/tulsa/sunchase-apartments/amenities::amenitieslist.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa1f-c175-768d-b56a-f1bb8c1fe1e4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Gym with various cardio and strength training equipment."
      }
    }
  },
  "apartments/ok/tulsa/the-greens-of-bedford/amenities::amenitieslist.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-e2f1-771c-a347-46d5517db5df.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "In-unit stacked washer and dryer."
      }
    }
  },
  "apartments/ok/tulsa/windsail-apartments/amenities::amenitieslist.photo_1": {
    "sourceIndex": 21,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fed5c-fefb-7166-bb2d-a6177f0f2266.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool with lounge chairs and apartment buildings in the background."
      }
    }
  },
  "apartments/ok/yukon/park-at-westpointe/amenities::amenitieslist.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c1-9c50-75f2-8643-c57bfe2658d8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Sparkling blue swimming pool with lounge chairs and apartment buildings in the background."
      }
    }
  },
  "apartments/ok/yukon/the-ridge-66/amenities::amenitieslist.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f1930-3e55-767a-8e2d-2321c48378d6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor grilling area with two built-in grills and picnic tables, with apartment buildings in the background."
      }
    }
  },
  "apartments/tx/amarillo/newport-amarillo-apts/amenities::amenitieslist.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf7-feb6-7699-95d7-294746447889.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool with lounge chairs and a picnic table under an umbrella."
      }
    }
  },
  "apartments/tx/amarillo/park-at-coulter/amenities::amenitieslist.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc4-4458-7558-9eb9-67481d64546b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor dog park with agility equipment including a tunnel, ramp, and jumping bars."
      }
    }
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/amenities::amenitieslist.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d51ca-298d-724f-bbd1-f1100514f107.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "View from a balcony looking out at the apartment buildings and sky."
      }
    }
  },
  "apartments/tx/amarillo/winchester-apartments/amenities::amenitieslist.photo_1": {
    "sourceIndex": 29,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/01a117a3-3e92-7305-a383-1d9fee1fcaf7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment complex exterior with a pool and a wooden pergola."
      }
    }
  },
  "apartments/tx/el-paso/acacia-park-apts/amenities::amenitieslist.photo_1": {
    "sourceIndex": 24,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/double-tree-apts/amenities::amenitieslist.photo_1": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/high-ridge-apts/amenities::amenitieslist.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb40-67f7-776d-8dc4-845a9e72073e.webp"
      }
    }
  },
  "apartments/tx/el-paso/shadow-ridge-apts/amenities::amenitieslist.photo_1": {
    "sourceIndex": 9,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-d9fe-735a-a821-21c25da990ff.webp"
      }
    }
  },
  "apartments/tx/el-paso/the-crest/amenities::amenitieslist.photo_1": {
    "sourceIndex": 26,
    "fieldOverrides": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/amenities::amenitieslist.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a0e9d7-4106-76b9-8294-8c29f56c6417.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with treadmills, weights, and exercise machines."
      }
    }
  },
  "apartments/tx/lubbock/icon-at-lubbock/amenities::amenitieslist.photo_1": {
    "sourceIndex": 10,
    "fieldOverrides": null
  },
  "apartments/tx/lubbock/tuscany-place/amenities::amenitieslist.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2e-a0d6-721a-b8eb-55a6f9154460.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Balcony view of resort-style pool and apartment buildings."
      }
    }
  },
  "apartments/tx/waco/bend-at-new-road/amenities::amenitieslist.photo_1": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "apartments/ks/maize/watercress-apartments/amenities::amenitieslist.photo_2": {
    "sourceIndex": 9,
    "fieldOverrides": null
  },
  "apartments/ks/wichita/aspen-park-apartments/amenities::amenitieslist.photo_2": {
    "sourceIndex": 29,
    "fieldOverrides": null
  },
  "apartments/ks/wichita/cottages-at-crestview/amenities::amenitieslist.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a18979-73d7-7264-8e54-facc5805a959.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Covered outdoor seating area with couches, chairs, and a TV."
      }
    }
  },
  "apartments/ks/wichita/huntington-park/amenities::amenitieslist.photo_2": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "apartments/ks/wichita/portofino/amenities::amenitieslist.photo_2": {
    "sourceIndex": 45,
    "fieldOverrides": null
  },
  "apartments/mo/belton/center-301/amenities::amenitieslist.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431e-7113-71ab-a921-9b024804dfdb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor grilling area with two built-in grills and a picnic table, with apartment buildings in the background."
      }
    }
  },
  "apartments/mo/independence/the-adirondack/amenities::amenitieslist.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da3-df91-75ec-92cb-0b442fa2b332.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Swimming pool with lounge chairs and apartment buildings in the background"
      }
    }
  },
  "apartments/mo/kansas-city/152-northland/amenities::amenitieslist.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3ced-0813-7590-b6ec-24f16516c44c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern clubhouse interior with stylish seating and fireplace."
      }
    }
  },
  "apartments/mo/kansas-city/97-north-oak/amenities::amenitieslist.photo_2": {
    "sourceIndex": 29,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/amenities::amenitieslist.photo_2": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/redbud-ranch/amenities::amenitieslist.photo_2": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/amenities::amenitieslist.photo_2": {
    "sourceIndex": 10,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/amenities::amenitieslist.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a33-b072-7163-a3cf-45beedeb64ac.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Community room with pool table and view of outdoor pool and apartment buildings."
      }
    }
  },
  "apartments/ok/edmond/villas-at-stonebridge/amenities::amenitieslist.photo_2": {
    "sourceIndex": 25,
    "fieldOverrides": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/amenities::amenitieslist.photo_2": {
    "sourceIndex": 6,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-3b7a-7056-b0c5-14dc412bb2fd.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor grilling area with picnic tables and built-in grills."
      }
    }
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/amenities::amenitieslist.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db713-429a-7798-b6e8-a599e4ef691b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern bathroom with gray vanity, marble countertop, and decorative artwork."
      }
    }
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/amenities::amenitieslist.photo_2": {
    "sourceIndex": 22,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/amenities::amenitieslist.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a1400a-6832-72c6-8ea5-cdeb3816e6ad.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Playground with slide and swings in a grassy courtyard area between apartment buildings."
      }
    }
  },
  "apartments/ok/oklahoma-city/council-place-apartments/amenities::amenitieslist.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/01a183b2-ab6e-7591-9af8-ab05ae6b2812.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Lobby seating area with a TV and fireplace, a bar with computers, and a printer."
      }
    }
  },
  "apartments/ok/oklahoma-city/cross-timber/amenities::amenitieslist.photo_2": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/amenities::amenitieslist.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08674-e61e-74c9-a631-f03bdffa8383.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a fireplace, couch, and coffee table."
      }
    }
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/amenities::amenitieslist.photo_2": {
    "sourceIndex": 12,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/01a08182-8961-73ce-9fe6-d463f634ff13.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Laundry room with rows of washers and dryers."
      }
    }
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments/amenities::amenitieslist.photo_2": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/amenities::amenitieslist.photo_2": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "apartments/ok/owasso/coffee-creek/amenities::amenitieslist.photo_2": {
    "sourceIndex": 23,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019cfb51-129d-723a-b2fe-93434dab976d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor dog park with agility equipment, including red horse figures and a red tunnel."
      }
    }
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/amenities::amenitieslist.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fb452-6a66-7221-9d82-8034ae864a4a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with dumbbells, weight machines, cardio equipment, and a mounted TV."
      }
    }
  },
  "apartments/ok/owasso/cypress-crossing/amenities::amenitieslist.photo_2": {
    "sourceIndex": 48,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e1cd0-9eb3-7298-bc83-0c62fab76ec7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor covered lounge area with teal sofas and modern metal furniture."
      }
    }
  },
  "apartments/ok/pryor/west-530/amenities::amenitieslist.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-461b-7140-a82f-74d54c7e1ba5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A fenced-in dog park with green grass, a bench, and a sign with dog park rules."
      }
    }
  },
  "apartments/ok/stillwater/apple-creek-stillwater/amenities::amenitieslist.photo_2": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/barrington-apartments/amenities::amenitieslist.photo_2": {
    "sourceIndex": 42,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cedar-glade-apts/amenities::amenitieslist.photo_2": {
    "sourceIndex": 32,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/chardonnay/amenities::amenitieslist.photo_2": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/amenities::amenitieslist.photo_2": {
    "sourceIndex": 34,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/creekwood-apartments/amenities::amenitieslist.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f193f-f797-7010-a508-2cd08e858fe0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright blue swimming pool with lounge chairs surrounded by pink flowering trees and lush greenery on a sunny day."
      }
    }
  },
  "apartments/ok/tulsa/nickel-creek-apts/amenities::amenitieslist.photo_2": {
    "sourceIndex": 47,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/polo-run-apartments/amenities::amenitieslist.photo_2": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/sunchase-apartments/amenities::amenitieslist.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-7576-73ca-ae32-a9f326cad56d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Laundry room with rows of washers and dryers."
      }
    }
  },
  "apartments/ok/tulsa/the-greens-of-bedford/amenities::amenitieslist.photo_2": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/windsail-apartments/amenities::amenitieslist.photo_2": {
    "sourceIndex": 15,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-0c16-7156-b429-a6ec4a75bf60.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "View of a wooden fence and APCO sign from a balcony with two chairs."
      }
    }
  },
  "apartments/ok/yukon/the-ridge-66/amenities::amenitieslist.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192f-de08-701e-96e0-88749448b5aa.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor patio area with a fire pit and seating, adjacent to a modern apartment building."
      }
    }
  },
  "apartments/tx/amarillo/newport-amarillo-apts/amenities::amenitieslist.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf5-8b5d-7009-8057-5ae831afb1a7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a multifamily property with a swimming pool, lounge chairs, and tennis courts."
      }
    }
  },
  "apartments/tx/amarillo/park-at-coulter/amenities::amenitieslist.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc3-d774-73bb-b0cc-e634f12e9b9e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor pool area with lounge seating and a covered patio."
      }
    }
  },
  "apartments/tx/amarillo/remington-amarillo-apts/amenities::amenitieslist.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df3-724b-7296-a0d1-ef3d20378216.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with treadmills, ellipticals, weight machines, and free weights."
      }
    }
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/amenities::amenitieslist.photo_2": {
    "sourceIndex": 17,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/01a0e997-0574-762b-81c6-3fb68a6c5253.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Sparkling blue outdoor swimming pool with lounge chairs and tables by the apartment buildings."
      }
    }
  },
  "apartments/tx/amarillo/winchester-apartments/amenities::amenitieslist.photo_2": {
    "sourceIndex": 24,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/chimneys-apts/amenities::amenitieslist.photo_2": {
    "sourceIndex": 29,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/double-tree-apts/amenities::amenitieslist.photo_2": {
    "sourceIndex": 39,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/high-ridge-apts/amenities::amenitieslist.photo_2": {
    "sourceIndex": 33,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019cfb41-25ef-72ac-8263-bcbadb955637.webp"
      }
    }
  },
  "apartments/tx/el-paso/phoenix-apts/amenities::amenitieslist.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/01a0a16b-faa9-74f7-a757-49e7978359c0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern bathroom with a vanity, sink, toilet, and bathtub with a shower."
      }
    }
  },
  "apartments/tx/el-paso/shadow-ridge-apts/amenities::amenitieslist.photo_2": {
    "sourceIndex": 90,
    "fieldOverrides": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/amenities::amenitieslist.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a0e9d6-fffb-702e-b1d9-63c0688133f6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Business center with computers and printer"
      }
    }
  },
  "apartments/tx/lubbock/icon-at-lubbock/amenities::amenitieslist.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda5-6044-763f-8a5a-77c8ede01ff3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior of apartment buildings with garages and a parking lot."
      }
    }
  },
  "apartments/tx/lubbock/tuscany-place/amenities::amenitieslist.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2a-3f16-770f-9007-acd334c5ebec.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor seating area with grills and a fireplace at a multifamily property."
      }
    }
  },
  "apartments/ks/wichita/aspen-park-apartments/amenities::amenitieslist.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-e878-729d-9732-5b9c7cd56d3b.webp"
      }
    }
  },
  "apartments/ks/wichita/cottages-at-crestview/amenities::amenitieslist.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a18979-1436-752c-9fd1-9aa13841e8f8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "The Crest View luxury apartments communal lounge with fireplace and seating areas."
      }
    }
  },
  "apartments/ks/wichita/huntington-park/amenities::amenitieslist.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166545/01a11c6b-eb15-75c9-a3d3-1d90ce299412.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of the apartment complex showing garages, buildings, and parking lot."
      }
    }
  },
  "apartments/ks/wichita/villas-of-waterford/amenities::amenitieslist.photo_3": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "apartments/mo/independence/the-adirondack/amenities::amenitieslist.photo_3": {
    "sourceIndex": 20,
    "fieldOverrides": null
  },
  "apartments/mo/kansas-city/152-northland/amenities::amenitieslist.photo_3": {
    "sourceIndex": 10,
    "fieldOverrides": null
  },
  "apartments/mo/kansas-city/97-north-oak/amenities::amenitieslist.photo_3": {
    "sourceIndex": 37,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/amenities::amenitieslist.photo_3": {
    "sourceIndex": 40,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills/amenities::amenitieslist.photo_3": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/redbud-ranch/amenities::amenitieslist.photo_3": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/amenities::amenitieslist.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-14b4-712f-a1b9-aa2e147e6fc4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with white cabinets, gray countertops, stainless steel appliances, and a microwave."
      }
    }
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/amenities::amenitieslist.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a33-e31f-772a-a275-fe37d4d9ae98.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room with a white curved sofa, floral accent pillows, and large windows."
      }
    }
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/amenities::amenitieslist.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-2636-774d-8fa2-037bbb9c6954.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bathroom with vanity, toilet, and bathtub with shower curtain."
      }
    }
  },
  "apartments/ok/edmond/villas-at-stonebridge/amenities::amenitieslist.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c13-fbaf-74bb-89f8-b7e784d105bf.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy living room with a fireplace, plush sofa, coffee table, and dining area."
      }
    }
  },
  "apartments/ok/jenks/the-reserve-at-elm/amenities::amenitieslist.photo_3": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "apartments/ok/norman/artisan-crossing-apts/amenities::amenitieslist.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/01a062bd-74b2-72a6-b14b-d0a0bc43ee80.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious living room with a large sofa, ottoman, armchair, and desk with a world map above it."
      }
    }
  },
  "apartments/ok/norman/cimarron-trails-apts/amenities::amenitieslist.photo_3": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/amenities::amenitieslist.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db712-e51f-750f-bd6b-f7c701baa5ab.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room with a sofa, armchair, coffee table, and a desk."
      }
    }
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/amenities::amenitieslist.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d1-49d9-7575-900a-cda6236e7b5f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with stainless steel appliances, white countertops, and gray cabinets."
      }
    }
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/amenities::amenitieslist.photo_3": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/amenities::amenitieslist.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/01a183b3-1096-748b-bc86-f84b1bab8ed9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Stackable washer and dryer with decorative framed artwork on the wall."
      }
    }
  },
  "apartments/ok/oklahoma-city/cross-timber/amenities::amenitieslist.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-afd4-77fd-86ba-306b8097977c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with white cabinets, black appliances, and a large island."
      }
    }
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/amenities::amenitieslist.photo_3": {
    "sourceIndex": 17,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/01a08181-f91c-71ac-9192-3b247e6aa753.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with wood cabinets, stainless steel sink, white dishwasher, and white stove with microwave above."
      }
    }
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/amenities::amenitieslist.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d5-c7aa-73ee-bc66-8e9b3a0c5f20.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with wood cabinets, granite countertops, white microwave, and white stove."
      }
    }
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments/amenities::amenitieslist.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4a-be7b-755e-95dc-a075b7d2e8c0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen and living room area of an apartment."
      }
    }
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/amenities::amenitieslist.photo_3": {
    "sourceIndex": 33,
    "fieldOverrides": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/amenities::amenitieslist.photo_3": {
    "sourceIndex": 4,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/01a1358d-e2ca-706b-9bd2-68702a2d3aef.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor grilling area with picnic tables, grills, and a stone fireplace."
      }
    }
  },
  "apartments/ok/owasso/cypress-crossing/amenities::amenitieslist.photo_3": {
    "sourceIndex": 28,
    "fieldOverrides": null
  },
  "apartments/ok/pryor/west-530/amenities::amenitieslist.photo_3": {
    "sourceIndex": 16,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03546-188b-7367-9748-1895172761ba.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room with a fireplace, large windows, and comfortable seating."
      }
    }
  },
  "apartments/ok/stillwater/apple-creek-stillwater/amenities::amenitieslist.photo_3": {
    "sourceIndex": 25,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/barrington-apartments/amenities::amenitieslist.photo_3": {
    "sourceIndex": 21,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cascata-luxury-apartments/amenities::amenitieslist.photo_3": {
    "sourceIndex": 20,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cedar-glade-apts/amenities::amenitieslist.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-d9d0-704e-b070-a5361d2b9ac5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and wood-look flooring."
      }
    }
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/amenities::amenitieslist.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b8-3a2c-763b-ad87-740ae6440b56.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a sofa, armchair, coffee table, fireplace, and TV mounted on the wall."
      }
    }
  },
  "apartments/ok/tulsa/chardonnay/amenities::amenitieslist.photo_3": {
    "sourceIndex": 19,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/amenities::amenitieslist.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019ef53e-d0c3-7698-a4be-3dfb276fcd60.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A cozy bedroom featuring a queen-size bed with a gray comforter, a wooden dresser, and a nightstand with a lamp."
      }
    }
  },
  "apartments/ok/tulsa/creekwood-apartments/amenities::amenitieslist.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1947-41a3-724e-9943-5555fb97fccb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with wooden cabinets, granite countertops, double sink, white appliances, and a window with blinds."
      }
    }
  },
  "apartments/ok/tulsa/nickel-creek-apts/amenities::amenitieslist.photo_3": {
    "sourceIndex": 38,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/sheridan-pond/amenities::amenitieslist.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/019dac86-46c5-7282-b85e-6e7f642b717e.webp"
      }
    }
  },
  "apartments/ok/tulsa/sunchase-apartments/amenities::amenitieslist.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-2649-772b-9f4d-090b6825be86.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with wooden cabinets, granite countertops, sink, dishwasher, and refrigerator."
      }
    }
  },
  "apartments/ok/tulsa/the-courtyards/amenities::amenitieslist.photo_3": {
    "sourceIndex": 35,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/amenities::amenitieslist.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-4a71-7778-82d8-f25054368530.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a large sofa, armchair, coffee table, and TV console."
      }
    }
  },
  "apartments/ok/tulsa/windsail-apartments/amenities::amenitieslist.photo_3": {
    "sourceIndex": 14,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-3a7b-7097-9470-e4be17888b65.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with white appliances, wooden cabinets, and granite countertops."
      }
    }
  },
  "apartments/tx/amarillo/newport-amarillo-apts/amenities::amenitieslist.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf6-e540-71ab-a247-a027a2a8d55c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dog park with agility equipment including tunnels and hoops."
      }
    }
  },
  "apartments/tx/amarillo/park-at-coulter/amenities::amenitieslist.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc5-03c9-7007-bace-60830ddcced6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with weights, exercise machines, and mirrors."
      }
    }
  },
  "apartments/tx/amarillo/winchester-apartments/amenities::amenitieslist.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/01a117a3-e091-708b-b395-920b5a565150.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Swimming pool area with apartment buildings in the background"
      }
    }
  },
  "apartments/tx/el-paso/acacia-park-apts/amenities::amenitieslist.photo_3": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/chimneys-apts/amenities::amenitieslist.photo_3": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/double-tree-apts/amenities::amenitieslist.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-d133-730d-a410-f2c4a0c211e9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with wood cabinets, white appliances including refrigerator, microwave, stove, and dishwasher."
      }
    }
  },
  "apartments/tx/el-paso/high-ridge-apts/amenities::amenitieslist.photo_3": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/phoenix-apts/amenities::amenitieslist.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/01a0a169-a75e-72aa-9cfd-6c272a3c885e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Community gym with cardio equipment including treadmills, ellipticals, and recumbent bikes."
      }
    }
  },
  "apartments/tx/el-paso/shadow-ridge-apts/amenities::amenitieslist.photo_3": {
    "sourceIndex": 84,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/the-crest/amenities::amenitieslist.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb52-c585-71ab-9ba7-a4b3e0634767.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Pet park with agility equipment and seating area."
      }
    }
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/amenities::amenitieslist.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a03a62-3be6-758b-8aee-393ad803c2c1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with white cabinets, stainless steel appliances, and granite countertops."
      }
    }
  },
  "apartments/tx/lubbock/tuscany-place/amenities::amenitieslist.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2a-3f8b-75de-8bb5-31c2c2201d25.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Tuscany Place apartment complex entrance sign with brick pillars and landscaping."
      }
    }
  },
  "apartments/tx/waco/bend-at-new-road/amenities::amenitieslist.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd71-94f1-716f-804a-35872fb41b32.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with stainless steel appliances and light gray cabinets."
      }
    }
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Arbors of Pleasant Valley offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">At Arbors of Pleasant Valley in Little Rock, AR, we understand that a home should be a perfect fit for your unique lifestyle. That&#8217;s why we offer a range of thoughtfully designed floor plans, including 1, 2, and 3-bedroom apartments. Each layout combines style, convenience, and comfort to cater to various needs. Discover your ideal home at The Arbors of Pleasant Valley Apartments today.</p>"
      }
    }
  },
  "apartments/ar/north-little-rock/lexington-park/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Lexington Park offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our artfully designed 1-, 2-, and 3-bedroom apartment floor plans are the ideal backgrounds for your daily routine. Chores are made easy thanks to the in-home amenities, and the flowing layouts create a feeling of harmony. Every one of our apartment homes includes a washer and dryer, spacious closets, and a charming sunroom off the living room area. </p>"
      }
    }
  },
  "apartments/ks/maize/watercress/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Watercress Apartments offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our six distinctive 1- and 2-bedroom apartment floor plans offer a variety of amenities to enhance your comfort. Additionally, select apartments in Maize feature flex spaces or attached garages, adding further versatility to cater to your lifestyle preferences.<br></p>"
      }
    }
  },
  "apartments/ks/wichita/aspen-park/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Aspen Park offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Find the right fit for your lifestyle in one of our thoughtfully designed Wichita apartment floor plans. We offer affordable 1-bedroom, 2-bedroom, and studio apartments in Wichita, with stylish and practical amenities like a fully equipped kitchen with updated appliances, a private balcony or patio, and spacious closets.</p>"
      }
    }
  },
  "apartments/ks/wichita/cottages-at-crestview/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Cottages at Crestview offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Browse our 12 unique apartment floor plans and find a layout that complements your lifestyle. The bright, airy living and dining space urges you to kick back and relax or share a meal with loved ones. Lux amenities like stainless steel appliances and decorative ceramic tiling elevate your apartment’s style while serving as the ideal canvas for home decor. We also offer Wichita loft apartments with an attached garage alongside our floor plans.</p>"
      }
    }
  },
  "apartments/ks/wichita/crown-chase-apts/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Crown Chase offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We offer 1- and 2-bedroom apartments in Wichita, designed with amenities and a thoughtful layout to enhance your day-to-day life. Several of our Wichita apartment homes feature a beautiful waterside view off the private patio or balcony. To get an even better idea of our apartment floor plans, browse our photo gallery, which also features a virtual 360-degree tour of our 1- and 2-bedroom apartment homes.</p>"
      }
    }
  },
  "apartments/ks/wichita/huntington-park/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Huntington Park offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Find your personal oasis in one of our 1- or 2-bedroom apartments at Huntington Park. Each of our floor plans features a thoughtfully designed layout and a collection of amenities that ensures comfort and convenience. We offer Wichita apartments ranging from 640 to 990 sq. ft., with each of our apartment homes featuring a private balcony or patio for getting some fresh air. </p>"
      }
    }
  },
  "apartments/ks/wichita/newport-wichita/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Newport Wichita offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Explore our Wichita apartment floor plans and find the right space that compliments your unique lifestyle. Available in three distinct layouts, you can choose between our 1-bedroom apartments and our two sizes of 2-bedroom apartments, with an optional private patio and wood-burning fireplace available across both sizes.</p>"
      }
    }
  },
  "apartments/ks/wichita/portofino/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Portofino offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Available in six unique layouts between 790 and 1,180 sq. ft. in area, our 1- and 2-bedroom apartments are open and customizable. Choose options for an added fireplace, a bumpout expansion, or an attached garage to make your home reflect your lifestyle and thrive in a living space designed around comfort and functionality.<br></p>"
      }
    }
  },
  "apartments/ks/wichita/raintree-apts/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Raintree offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our Wichita apartment community offers meticulously planned floor plans tailored to complement your lifestyle. We provide budget-friendly studios and 1- and 2-bedroom apartments in Wichita, featuring modern conveniences like fully equipped kitchens with upgraded appliances, private balconies or patios, and ample closet space.</p>"
      }
    }
  },
  "apartments/ks/wichita/remington-wichita/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does The Remington Wichita offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Choose from our diverse selection of thoughtfully crafted 1- and 2-bedroom apartment layouts tailored to enhance your lifestyle. Many of our residences feature private balconies or patios, ideal for showcasing plants or crafting a cozy reading spot. Embrace the opportunity to curate your tranquil haven within the suburban setting of Wichita, allowing you to unwind and savor life&#8217;s simple pleasures.</p>"
      }
    }
  },
  "apartments/ks/wichita/silver-springs/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Silver Springs offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Discover a range of living options at Silver Springs, featuring studio, 1-, and 2-bedroom apartment homes tailored to your lifestyle, offering between 500 and 900 sq. ft. Within each floor plan, spacious living and dining areas provide the perfect setting for enjoying your favorite shows or hosting movie nights with friends. The open layout design allows for seamless transitions from the kitchen to the dining area during dinner parties, enhancing the overall social experience.</p>"
      }
    }
  },
  "apartments/ks/wichita/villas-of-waterford/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Villas of Waterford offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The Villas of Waterford Apartments in northeast Wichita invites you to experience exceptional pet-friendly apartment living. We have four unique floor plans that cater to a vast array of preferences, thoughtfully designed with luxurious amenities and abundant features that ensure a homey feel. Whether you want a tranquil 1-bedroom layout or a generous 2-bedroom retreat, our floor plans fit diverse requirements.</p>"
      }
    }
  },
  "apartments/mo/belton/center-301/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Center 301 offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We offer a wide range of Belton apartment floor plans so you can find the layout that’s right for you. In addition to apartment homes, we also offer spacious townhomes near Kansas City for those wanting more space and privacy. Each of our floor plans features essential amenities, like abundant closet space for stowing your wardrobe, a fully equipped kitchen with everything you need to cook up a delicious meal, and a dishwasher for easy cleanup.</p>"
      }
    }
  },
  "apartments/mo/independence/the-adirondack/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does The Adirondack offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Welcome to our charming community of 1- and 2-bedroom apartments and townhomes in Independence, MO. Nestled in the heart of this vibrant city, our thoughtfully designed residences offer the perfect place to call home. Whether you&#8217;re seeking a cozy 1-bedroom apartment or a spacious townhome for your growing family, we have the floor plan to suit your needs. Explore everything our pet-friendly community has to offer and find your ideal home sweet home in Independence!</p>"
      }
    }
  },
  "apartments/mo/kansas-city/152-northland/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans are available at 152 Northland?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The perfect home for your lifestyle is available at 152 Northland. We offer 1 and 2 bedroom apartments in Kansas City that provide plenty of space to live life to the fullest. With modern appliances and kitchen design choices, plush carpeting, and other optional amenities, everything you need to love your home is in place in our Kansas City apartments.</p>"
      }
    }
  },
  "apartments/mo/kansas-city/97-north-oak/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does 97 at North Oak offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Discover the ideal backdrop for your life in Kansas City with our selection of 1-, 2-, or 3-bedroom apartments. Imagine waking up in a roomy bedroom, the softness of plush carpet beneath your feet as sunlight filters through the window. Whether your day involves marathon-watching your preferred TV series in the living room or savoring a morning coffee before setting off to work, our Kansas City apartments promise a true sense of home.</p>"
      }
    }
  },
  "apartments/ms/ridgeland/mark-apts/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does The Mark offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The Mark Apartments is the perfect place for people from all walks of life. Whether you work from home, commute in, or manage a constantly changing schedule, you can guarantee you have a relaxing place to call home when you live with us. We offer two floor plan options with both 1- and 2-bedroom apartments in Ridgeland available.</p>"
      }
    }
  },
  "apartments/ms/ridgeland/sunchase-ridgeland-apts/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Sunchase Ridgeland offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">You, your family, and your pets deserve a quality place to call home. When you rent one of our studio, 1-, or 2-bedroom apartments at Sunchase Ridgeland, you’ll get to experience apartment living in Ridgeland, MS, at its finest. Each of our Ridgeland apartments comes with numerous amenities and features to make your home as comfortable as possible.</p>"
      }
    }
  },
  "apartments/ms/ridgeland/the-pointe-of-ridgeland/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does The Pointe of Ridgeland offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">At The Point of Ridgeland Apartments, we cater to a diverse range of lifestyles, making our pet-friendly community<strong> </strong>an ideal place to call home. Explore our 1-, 2-, and 3-bedroom apartment homes and find the perfect fit for your unique needs. </p>"
      }
    }
  },
  "apartments/ms/ridgeland/trace-apts/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does The Trace of Ridgeland offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Here at the Trace of Ridgeland, you’ll find nine distinct Ridgeland apartment floor plans to choose from, with both 1-bedroom and 2-bedroom apartments available. Whether you’re a single resident needing space for yourself (and perhaps a furry friend), or looking for a 2-bedroom apartment to make room for your partner or child, you’ll find a great Ridgeland apartment home in our community.</p>"
      }
    }
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Icon at Broken Arrow offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Find a good fit for your lifestyle in one of our thoughtfully designed 1- and 2-bedroom loft and apartment floor plans. Whether you select our compact, 1-bedroom layout or spacious 2-bedroom lofts, you’ll feel right at home thanks to the several amenities in our apartment homes. When you choose one of our lofts in Broken Arrow, you’ll also have an optional attached garage add-on.</p>"
      }
    }
  },
  "apartments/ok/broken-arrow/park-at-mission-hills/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does The Park at Mission Hills offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">You need to start with the right canvas to make your home a masterpiece. Explore our catalog of carefully crafted floor plans to find the one best suited for you as you make your dream apartment home a reality. The Park at Mission Hills offers six distinct apartment layouts designed to meet and exceed your needs along with those of your family, and each comes with an extensive set of amenities to help you make your apartment a home.</p>"
      }
    }
  },
  "apartments/ok/broken-arrow/redbud-ranch/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Redbud Ranch offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Experience the ideal living space tailored to your needs with our array of 1-, 2-, and 3-bedroom apartments in Broken Arrow. Each of our floor plans offers unmatched comfort and convenience. Select one of our apartments featuring a fireplace, adding extra warmth and comfort, perfect for chilly days. The open-concept kitchen and dining area are ideal for dinner parties or gatherings with friends.</p>"
      }
    }
  },
  "apartments/ok/broken-arrow/scissortail-crossing/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Scissortail Crossing offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our north Broken Arrow apartment community offers six floor plans, each showcasing inviting living and dining spaces and fully equipped kitchens. Choose from our cozy 1-bedroom or versatile 2-bedroom apartments and lofts to find the ideal fit for your lifestyle.</p>"
      }
    }
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans are available at Trails at Aspen Creek?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">At Trails at Aspen Creek, we want you to feel at home. That’s why we provide multiple floor plan options, including 1 and 2 bedroom apartment homes, townhomes, and lofts. For even more space, consider one of our 3 bedroom apartment homes. No matter what you’re looking for in a living space, you can find the right fit in our welcoming community.</p>"
      }
    }
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Villas at Aspen Park offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Find exceptional pet-friendly apartments in the Villas at Aspen Park in Broken Arrow. Our luxurious amenities and abundant features are designed to ensure a cozy and convenient feel, catering to various preferences. Choose between a peaceful 1-bedroom layout or a spacious 2-bedroom retreat from six unique floor plans.</p>"
      }
    }
  },
  "apartments/ok/edmond/fountain-lake/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Fountain Lake offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>Fountain Lake’s spacious and thoughtfully designed 1- and 2-bedroom apartments in Edmond come in six different layouts so you can select the best fit for you. Our floor plans offer anywhere from 789 to 1,110 sq. ft. of room to spread out and an open-concept living and dining area. Select one of our floor plans with an attached garage for optimal convenience and privacy. To get an even better idea of our Edmond apartment floor plans, head to our photo gallery and scroll down to take a virtual 360-degree tour.</p>"
      }
    }
  },
  "apartments/ok/edmond/villas-at-stonebridge/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Villas at Stonebridge offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The Villas at Stonebridge offers the perfect option for pet-friendly living in Edmond. With eight unique floor plans to choose from, you&#8217;re sure to find your ideal haven. Whether you prefer a cozy 1-bedroom design, a peaceful 2-bedroom apartment, or a spacious 3-bedroom retreat, each apartment in Edmond is thoughtfully appointed with top-quality amenities to make you feel right at home.</p>"
      }
    }
  },
  "apartments/ok/jenks/the-reserve-at-elm/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does The Reserve at Elm offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Designed to exceed expectations, our 1- and 2-bedroom apartments give you a wide selection of layouts and personalized options to make your home your own. High-end finishes are not hard to find around every corner, with features like premium lighting, plush carpeting, tiled floors, and stunning accent walls that bring radiance and character into your Jenks apartment.</p>"
      }
    }
  },
  "apartments/ok/moore/mission-point/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Mission Point offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our thoughtfully designed 1- and 2-bedroom apartments offer spacious environments adaptable to your style and personal touches. Available in five distinct floor plans with options for poolside views, a private balcony, fireplaces, and a full garage, you can customize your living experience to create a home that’s ideal for you at Mission Point.</p>"
      }
    }
  },
  "apartments/ok/norman/artisan-crossing-apts/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Artisan Crossing offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Select one of our nine floor plans to find the right Norman apartment layout for your needs. Whether you select one of our Norman 1-bedroom apartments or 2-bedroom townhouses in Norman, you’ll enjoy a roomy and thoughtfully designed layout. Even our smallest apartment floor plan offers a comfortable 790 sq. ft. to accommodate lots of decor and furniture to customize your space.</p>"
      }
    }
  },
  "apartments/ok/norman/cimarron-trails-apts/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans Cimarron Trails offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Here at Cimarron Trails, we offer a variety of floor plans so you can find the ideal fit for you. From compact 1-bedroom apartments to spacious, two-floor townhomes, our five distinctive layouts offer a private patio or balcony, a fully equipped kitchen, and a comfortable living and dining area. To get an even better picture of our Norman apartment floor plans, head to our photo gallery, which includes snapshots of our apartment community and a virtual tour.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does 24Hundred offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our Oklahoma City apartment community features 12 distinct floor plans, designed to complement your lifestyle beautifully. Our cozy 1-bedroom apartments provide almost 800 sq. ft. of living space, ensuring you feel at home without the constraint of tight quarters. For residents seeking additional space and privacy, our lofts in Oklahoma City are an excellent choice, with the option of an attached garage available.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Chisholm Pointe offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We offer five distinct floor plans that meet various needs and preferences, from a cozy 1-bedroom apartment to a serene 2-bedroom design and a spacious 3-bedroom retreat. Each apartment is thoughtfully equipped with top-of-the-line amenities to ensure you feel right at home.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Cimarron Pointe offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Find the right apartment home for your lifestyle by browsing our many floor plans, including 1-, 2-, and 3-bedroom apartment and townhouse options. Each apartment has welcoming living and dining areas where you can enjoy binging your favorite TV show or hosting friends.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/council-place-apartments/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Council Place offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Each floor plan at our Oklahoma City apartment community is thoughtfully designed with comfort in mind, offering a variety of amenities. A bright, airy living and dining area greets you as you come home each day—the ideal spot for cushy couches and a bistro table with chairs. The in-home washer and dryer, included in every floor plan, simplifies laundry days. We offer 1-bedroom, 1-bedroom with a den, 2-bedroom, and 3-bedroom floor plans with 500 to 1,010 sq. ft.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/cross-timber/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Cross Timber offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Spread out and get comfortable in one of our spacious 2- or 3-bedroom apartments in OKC, which includes all the amenities you need to live comfortably and modern finishes to elevate your living space’s style. Our floor plans offer 930 to 1,210 sq. ft. of room, spacious closets, and open-concept living. Natural light floods through the wide windows in our apartment homes, giving your space an airy, bright feeling.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Crown Pointe offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Crown Pointe offers spacious 1- and 2-bedroom apartments with as much as 1,000 sq. ft. of space and well-designed layouts. The<strong> </strong>amenities included in every apartment home will make your daily routine a breeze and the stylish touches around our apartments create the ideal backdrop for your unique style. The oversized windows and neutrally colored walls give your apartment home an airy feeling while plush carpeting cushions your every step.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/hunter's-ridge-apts/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Hunter’s Ridge offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Browse our 1- and 2-bedroom apartment floor plans and find the layout that suits your needs and lifestyle, whether that’s our compact, efficient layout or our expansive 2-bed/2-bath with over 1,000 sq. ft. of living space. Alongside essential amenities, like a fully equipped kitchen and air conditioning, several of our apartments include optional extras like fireplaces or a private balcony, patio, or sunroom.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/park-at-tuscany/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does The Park at Tuscany offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Make your new home in one of our 1- or 2-bedroom<strong> </strong>apartment homes, available in six customizable layouts so you can find the ideal match for your lifestyle. With floor plans ranging in area from 790 to 1180 sq. ft., our apartment community has the features and options to accommodate single renters and families alike.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/persimmon-square-apartments/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Persimmon Square offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">At Persimmon Square, there are seven unique and spacious floor plans to choose from, encompassing 1- and 2-bedroom apartments. With a wide range of choices available, you&#8217;ll easily find the ideal fit for your lifestyle. Each floor plan boasts large closets and bright, airy living spaces and ranges from 550 to 1,300 sq. ft.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Prairie Springs offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">A comfortable living experience is built on a foundation of flexibility, and Prairie Springs offers a wide range of diverse layouts in our 1-, 2-, and 3-bedroom apartments. Available in a staggering 18 unique floor plans, each of our apartments in Oklahoma City allows you to customize your living space so you can thrive in your new home. </p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/stonehorse-crossing/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Stonehorse Crossing offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Discover the perfect floor plan to suit your lifestyle at Stonehorse Crossing Apartments. Whether you&#8217;re seeking a cozy 1-bedroom space for you and your pets or a 2-bedroom apartment or townhome, our diverse selection of layouts offers something for everyone. Each apartment home is designed with comfort and functionality in mind, featuring open-concept living areas, designer finishes, and ample storage space throughout. Select apartments and townhomes also feature an enclosed garage, perfect for keeping your vehicle secured and ready for your next drive to work or a family road trip.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/summerfield-place-apts/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Summerfield Place offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Discovering the ideal apartment in south Tulsa is effortless, thanks to our diverse floor plans. Our compact studio and 1-bedroom, 1-bathroom apartments, spanning from 500 to 700 sq. ft., offer ample room for customization to suit your preferences. Meanwhile, our 2-bedroom, 2-bathroom apartment homes feature spacious closets, two full bathrooms with bathtubs, and generous living areas, ensuring plenty of space for all residents.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/summit-ridge-villas/summit-villas/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Chisholm Pointe offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We offer five distinct floor plans that meet various needs and preferences, from a cozy 1-bedroom apartment to a serene 2-bedroom design and a spacious 3-bedroom retreat. Each apartment is thoughtfully equipped with top-of-the-line amenities to ensure you feel right at home.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/tammaron-village-apartments/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Tammaron Village offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">At Tammaron Village near the Northhaven neighborhood, discover a diverse selection of studio, 1-, and 2-bedroom apartment layouts tailored to your preferences. Our Oklahoma City residences boast a range of amenities and living spaces spanning from 500 to 900 sq. ft. Additionally, we feature floor plans designed for those seeking shared living arrangements.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/warrington-apartments/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does The Warrington Apartments offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">There are eight floor plans to choose from at The Warrington, ranging in size from 600 to 1,100 sq. ft. Opt for 1- or 2-bedroom townhomes conveniently situated near the Val Verde neighborhood for more natural light and creative freedom in home décor. Revel in every moment at The Warrington Apartments, which has exquisite interior features and ample living space.<br></p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Waters Edge Apartments offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">At Waters Edge, you’ll find cozy studio, 1-, and 2-bedroom apartments in Oklahoma City. Enjoy a patio or balcony in our 1- and 2-bedroom apartments, or cook a delicious meal in your well-equipped kitchen. Whether you’re starting your newlywed life, downsizing in retirement, or anything in between, you can live your life how you want with any of our floor plans.<br></p>"
      }
    }
  },
  "apartments/ok/owasso/coffee-creek/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Coffee Creek offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Craft your signature lifestyle at Coffee Creek Apartments, where our carefully curated amenities seamlessly enhance your everyday experience with a fusion of practicality and sophistication. Our washer and dryer-ready 1- and 2-bedroom apartments boast modern appliances and a sizable kitchen for dinner parties and casual gatherings.</p>"
      }
    }
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Cottages at Tallgrass Point offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Each of our 1- and 2-bedroom apartments helps create a stylish living space that is as comfortable as it is well equipped. Available in six configurations ranging from 790 to 1,470 sq. ft., our 1- and 2-bedroom apartments are available with customizable features, including a wood-burning fireplace or private balcony with scenic views, allowing you to find the right balance between the space you need and the lifestyle you’d like to live.</p>"
      }
    }
  },
  "apartments/ok/owasso/cypress-crossing/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How close is Cypress Crossing to major highways or roadways?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our community is conveniently located near Highway 169, offering quick and easy access to Owasso and Tulsa. We are in the center of northern Owasso, bringing you the quiet suburban environment our residents love without sacrificing accessibility.</p>"
      }
    }
  },
  "apartments/ok/pryor/west-530/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are pets allowed in the apartments?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">At West 530, residents are permitted to have a maximum of two pets, with certain breed restrictions in effect. Each pet incurs a monthly pet rent of $30. There is a one-time, non-refundable fee of $500 per pet. Service animals are not considered pets. Pet deposits and pet rent are not applicable for these service animals. Additional documentation may be requested.</p>"
      }
    }
  },
  "apartments/ok/stillwater/apple-creek-stillwater/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Apple Creek offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">At Apple Creek, discover the ideal Stillwater apartment floor plan to suit your lifestyle. Experience the charm of stylish hardwood floors and spacious high ceilings in every layout, providing a versatile backdrop for your interior design. Unwind in the inviting living space as you step into your comfortable 1-bedroom or 2-bedroom residence.</p>"
      }
    }
  },
  "apartments/ok/tulsa/barrington-apartments/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Barrington offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Browse through our 10 unique floor plans and find the right apartment home. Whether you choose one of our compact 1-bedroom apartments or versatile 2-bedroom apartments in Tulsa, each of our layouts is thoughtfully designed with amenities to make you feel at home. The spacious living area in each of our floor plans can accommodate couches, comfy chairs, and other personal furnishings to create a homey feel.</p>"
      }
    }
  },
  "apartments/ok/tulsa/cascata-luxury-apartments/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Cascata offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Browse our thoughtfully designed Tulsa apartment floor plans and find your dream apartment home. Cascata offers six distinct layouts, each offering a spacious living area with lots of natural light and large closets for stowing your wardrobe. Optional fireplaces are also available in some of our floor plans, offering extra comfort on chilly winter evenings.</p>"
      }
    }
  },
  "apartments/ok/tulsa/cedar-glade-apts/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Cedar Glade offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Make yourself at home in one of our four-floor plans, with thoughtful designs ranging from 730 sq. ft. to 1,300 sq. ft. Several of our apartment layouts include an optional wood-burning fireplace, allowing you to create a cozy and peaceful atmosphere.</p>"
      }
    }
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Cedar Ridge offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Each of our nine unique 1-, 2-, and 3-bedroom apartment floor plans is designed to maximize your comfort, with several amenities. The lofty nine-foot ceilings give your apartment a roomy, elegant feeling, while the open-concept layout maximizes your living space. Beyond standard apartments, we also offer loft apartments in Tulsa with an optional attached garage.</p>"
      }
    }
  },
  "apartments/ok/tulsa/chardonnay/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Chardonnay offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Browse our Tulsa apartment floor plans and find a layout that complements your lifestyle. We offer three options: smaller 1-bedroom apartments, larger 1-bedroom apartments, and 2-bedroom apartments. No matter what floor plan you select, you’ll cherish homey features and amenities like the wood-burning fireplace and large private balcony or patio.</p>"
      }
    }
  },
  "apartments/ok/tulsa/country-hollow-apartments/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Country Hollow offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Country Hollow’s apartment floor plans are available in three unique layouts to cater to diverse living situations. Starting at 500 sq. ft. in our practically sized studios, our range of options allows you to pick the size that strikes the right balance between affordability and upscale coziness for single renters and roommates alike.</p>"
      }
    }
  },
  "apartments/ok/tulsa/creekwood-apartments/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Creekwood offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>View our Tulsa apartment floor plans and find the ideal fit for your lifestyle. From charming 1-bedroom apartments to sprawling 2-bedroom townhomes, Creekwood Apartments has a layout for everyone. Designed with your comfort in mind, each floor plan includes a spacious, open-concept living and dining area where you can relax and unwind or hang out with friends and loved ones.</p>"
      }
    }
  },
  "apartments/ok/tulsa/nickel-creek-apts/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Nickel Creek offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Not only will you have room to call your own, but you will also enjoy a wide variety of luxury apartment amenities in Tulsa including spacious closets, fully equipped kitchens, high-speed internet, and more. No matter your home needs in Tulsa, we have you covered. </p>"
      }
    }
  },
  "apartments/ok/tulsa/polo-run-apartments/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Polo Run offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We offer diverse Tulsa apartment floor plans tailored to complement your lifestyle. Our apartment floor plans boast luxurious plush carpeting and a charming fireplace, providing the ideal backdrop for expressing your personal style. Step into the welcoming embrace of your cozy 1-bedroom or 2-bedroom apartment, where comfort meets style from the entryway to the living area.</p>"
      }
    }
  },
  "apartments/ok/tulsa/sheridan-pond/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Sheridan Pond offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Sheridan Pond offers eight unique Tulsa apartment floor plans for 1-, 2-, and 3-bedroom apartments. Regardless of your lifestyle, we have a floor plan to suit you. The apartments range from 600 to 1,500 sq. ft. and feature spacious closets and well-lit, open living areas.</p>"
      }
    }
  },
  "apartments/ok/tulsa/sugarberry-apartments/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Sugarberry offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Discover the ideal floor plan to complement your lifestyle within our Tulsa apartment community. Select from our four distinct floor plans and revel in the comfort of your tastefully furnished, fully equipped apartment.<br><br>Our 1-bedroom apartments in Tulsa offer generous living and dining spaces, perfect for cozy movie nights or hosting intimate gatherings with friends. Our 2-bedroom apartments feature a master bedroom and two additional bedrooms, catering to diverse living preferences and needs.</p>"
      }
    }
  },
  "apartments/ok/tulsa/sunchase-apartments/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Sunchase offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Located in south Tulsa near the Heatherridge neighborhood, Sunchase presents a selection of studio, 1-bedroom, and 2-bedroom apartments. With neutral walls and plenty of natural light, our spaces are the canvas for your personalization. Enjoy plush carpeting in the living room and bedrooms and sleek tile floors in the bathroom and kitchen areas.</p>"
      }
    }
  },
  "apartments/ok/tulsa/the-courtyards/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does The Courtyards offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Find the right apartment for you by browsing our eight distinct 1- and 2-bedroom floor plans. Whatever floor plan you select, you’ll enjoy plentiful amenities and a thoughtfully designed layout, ensuring comfortable living. Our several floor plan options ensure you can easily find a good fit for you.</p>"
      }
    }
  },
  "apartments/ok/tulsa/the-greens-of-bedford/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does The Greens of Bedford offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Find the right apartment home for your unique needs in one of our 1-, 2-, or 3-bedroom apartment floor plans at The Greens of Bedford. Our thoughtfully designed layouts feature several amenities and 700 to 1,200 sq. ft. of space in our Tulsa apartment homes, plenty of room to live comfortably. Several of our floor plans are also ideal for those living with roommates.</p>"
      }
    }
  },
  "apartments/ok/tulsa/windsail-apts/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Windsail Apartments offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Experience seamless living in our thoughtfully crafted 1- and 2-bedroom apartment floor plans, featuring an interconnected living and dining space adjacent to a well-equipped kitchen. Enjoy the convenience of in-home laundry facilities with our washer and dryer connections in select apartments. Select homes also include fireplaces, ideal for cozying up during cool weather days.<br></p>"
      }
    }
  },
  "apartments/ok/yukon/park-at-westpointe/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does The Park on Westpointe offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We have cozy 1-bedroom and spacious 2-bedroom apartments available at The Park on Westpointe to fit your lifestyle. With additional options for an attached loft and garage, balcony, or space-boosting bumpout, you can customize your apartment to create the home of your dreams.<br></p>"
      }
    }
  },
  "apartments/ok/yukon/the-ridge-@-66/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Ridge @ 66 offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Thrive in an upscale living environment by renting a 1-, 2-, or 3-bedroom home in our Yukon apartment community. At Ridge at 66, we offer a variety of spacious floor plans designed to cater to your lifestyle needs. Our floor plans range from 790 to 1,470 sq. ft., perfect for single renters, small families, or those seeking a little extra room for guests and storage.</p>"
      }
    }
  },
  "apartments/tx/amarillo/newport-amarillo-apts/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Newport Amarillo offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Find your new home in an apartment at Newport, available in seven unique floor plans to give you the flexibility to create a home that reflects your lifestyle. Our size options range from 630 sq. ft. to 930 sq. ft., with options for an additional full or half-bath, a wood-burning fireplace, and a private balcony or patio to give your home an added layer of comfort and functionality. </p>"
      }
    }
  },
  "apartments/tx/amarillo/park-at-coulter/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Park at Coulter offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We offer a range of apartment size options so you can find the right layout for you. Our floor plans are available in six distinct layouts ranging from 790 to 1180 sq. ft., and both our 1- and 2-bedroom options are available with an additional patio, study, or loft to ensure you have a living space that reflects your personal needs.</p>"
      }
    }
  },
  "apartments/tx/amarillo/remington-amarillo-apts/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Remington offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Discover the perfect living space for your lifestyle at Remington Apartments in Amarillo, TX. Offering 1-bedroom, 2-bedroom, and 3-bedroom apartments, you’ll be sure to find the right apartment fit for you. Enjoy the convenience of in-home washer and dryer connections, well-equipped kitchens, and spacious closets in our comfortable and cozy Amarillo apartments.</p>"
      }
    }
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans do Colonies at Hillside offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Whether you&#8217;re coming home from a busy day at work or seeking relaxation on the weekend, Colonies at Hillside prioritizes your comfort and coziness. We craft each floor plan to meet your unique needs and preferences, and we&#8217;re proud to present a selection of spacious apartment layouts in southwest Amarillo.</p>"
      }
    }
  },
  "apartments/tx/amarillo/winchester-apartments/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Winchester Apartments offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Winchester Apartments of Amarillo features well-designed 1-, 2-, and 3-bedroom floor plans with many amenities. Each of our 13 apartment layouts features a spacious living and dining area for relaxing and unwinding after a long day or hosting guests. We also offer wood-burning fireplaces in select apartment homes for a classic, cozy touch.<br></p>"
      }
    }
  },
  "apartments/tx/el-paso/acacia-park-apts/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Acadia Park offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">With floor plans ranging from 1-bedroom to 3-bedroom apartments at Acacia Park Apartments, we make finding the apartment of your dreams easy. Whether you’re moving into your first place and need a 1-bedroom apartment or a 2-bedroom apartment that offers extra room for a roommate or a potential guest room, you’ll find space for comfortable living in our luxury apartments with abundant amenities in West El Paso.</p>"
      }
    }
  },
  "apartments/tx/el-paso/chimneys-apts/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does The Chimneys offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The Chimneys is proud to offer both 1-bedroom and 2-bedroom apartments for rent in El Paso, TX. With expansive floor plans and a wide range of El Paso apartment amenities, such as large closets, patios, balconies, and more, we give you the power to make apartment living a luxury, regardless of your home needs.</p>"
      }
    }
  },
  "apartments/tx/el-paso/double-tree-apts/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Double Tree offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">At Double Tree Apartments, we&#8217;re proud to offer top-tier 1- and 2-bedroom apartments in Westside El Paso, designed with your comfort and lifestyle in mind. Our pet-friendly floor plans feature a cozy dining space, a spacious living space, and a private patio or balcony. No matter which one of our El Paso apartment floor plans you select, you’ll love our large closets.</p>"
      }
    }
  },
  "apartments/tx/el-paso/high-ridge-apts/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does High Ridge offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">In our High Ridge apartment community in East El Paso, you’ll find 1- and 2-bedroom apartments offering four distinct floor plans to suit your lifestyle. These floor plans were meticulously designed to blend style and comfort. We offer cozy 1-bedroom apartments and spacious 2-bedroom apartments, all featuring luxury amenities like large closets, a private balcony, and upgraded fixtures.</p>"
      }
    }
  },
  "apartments/tx/el-paso/mountain-village-apts/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Mountain Village offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We offer three spacious Northwest El Paso apartment floor plans, state-of-the-art amenities, and perks. Our 1-bedroom apartments and 2-bedroom apartments are designed for luxurious living and a great apartment experience in West El Paso, TX.</p>"
      }
    }
  },
  "apartments/tx/el-paso/patriot-apts/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does The Patriot offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The Patriot offers eight distinctive floor plans, allowing you to choose a 1-bedroom, 2-bedroom, or 3-bedroom apartment. With our wide range of options, you’ll have no trouble finding a good fit for your lifestyle. Apartment homes range from 660 to over 1,000 sq. ft., and every floor plan features large closets and a bright, airy living space.</p>"
      }
    }
  },
  "apartments/tx/el-paso/phoenix-apts/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does The Phoenix offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Find an El Paso apartment home at The Phoenix with 1-, 2-, and 3-bedroom options. The natural light and neutral walls around our apartments allow you to cater your apartment home to your lifestyle. You’ll find plush, comfortable carpeting in the living room and bedrooms and wood-style flooring in the bathrooms and kitchen for easy cleanup. </p>"
      }
    }
  },
  "apartments/tx/el-paso/shadow-ridge-apts/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Shadow Ridge offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Shadow Ridge features 1-, 2-, and 3-bedroom apartments in East El Paso. With a wide selection of floor plans and amenities, such as a well-equipped kitchen and high-speed internet, the luxury apartments at Shadow Ridge are your number one choice for upscale apartment living.</p>"
      }
    }
  },
  "apartments/tx/el-paso/the-crest/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does The Crest offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">In El Paso, our apartment community features seven distinctive floor plans designed with inviting living and dining spaces, complemented by fully furnished kitchens. Whether you&#8217;re looking for a cozy 1-bedroom apartment, a flexible 2-bedroom layout, or a more expansive 3-bedroom option, we offer a selection that allows you to find the ideal match for your needs.</p>"
      }
    }
  },
  "apartments/tx/hewitt/icon-at-hewitt/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Icon at Hewitt offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">At Icon at Hewitt, we’re proud to offer high-quality 1- and 2-bedroom apartments and townhomes in Hewitt, TX. With our apartment amenities like private balconies, patios, and garages included, our cozy yet spacious floor plans offer you the power to live in luxury.</p>"
      }
    }
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Cottages at Abbey Glen offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">At Cottages at Abbey Glen, you’ll find a variety of floor plans for our 1- and 2-bedroom apartments in Lubbock. Every single one of our luxury apartments offers space to spread out, complete with a spacious living room area. Our Lubbock apartment homes are ideal for hosting dinners for friends, date nights, or just vegging out and watching TV.</p>"
      }
    }
  },
  "apartments/tx/lubbock/icon-at-lubbock/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Icon at Lubbock offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our spacious 1-bedroom and 2-bedroom apartments in Lubbock, TX, offer big floor plans and a variety of amenities to meet your needs. We take pride in providing you with the best rental options in Lubbock, TX. With us, you can transform apartment living into a luxurious experience with enlarged bathrooms, cozy fireplaces, attached garages, and more.</p>"
      }
    }
  },
  "apartments/tx/lubbock/tuscany-place/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Tuscany Place offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">With upscale 1- and 2-bedroom apartments in Lubbock, Tuscany Place has a floor plan for every lifestyle. We even offer 2-bedroom apartments with an attached garage for optimal privacy. The abundance of natural light in all of our Lubbock apartments creates a bright and airy atmosphere, setting the scene for your ideal home.</p>"
      }
    }
  },
  "apartments/tx/temple/portico-at-friars-creek-apts/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Portico at Friar’s Creek offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">After a long day at work or school, you deserve a place to wind down and relax. Our high-end 1- and 2-bedroom apartments, lofts, and townhomes in Temple, TX, provide the perfect retreat for you and your family.</p>"
      }
    }
  },
  "apartments/tx/waco/bend-at-new-road/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Bend at New Road offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">With so many floor plans available at our Bend at New Road apartments in Waco, you’re sure to find a great fit for your lifestyle. Our spacious Waco apartments are great for single residents, couples, and even families.</p>"
      }
    }
  },
  "apartments/tx/waco/tuscany-ranch-apartments/contact-us::contactform.faq_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plans does Tuscany Ranch offer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">No matter how rough or pleasant your school or workday is, you deserve to return to a place that feels like home. Across all our Waco apartments, lofts, and townhomes, you’ll find the perfect space for you, your family, and your pets to call home.</p>"
      }
    }
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Arbors of Pleasant Valley like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Living at the Arbors of Pleasant Valley not only comes with comfort and luxurious living, but it also comes with convenience and scenic surroundings. In our quiet suburban neighborhood near UAMS Hospital, we’re near all the shopping, dining, and entertainment you desire. Situated on Hinson Road near Pleasant Valley Country Club, we’re also located near plenty of schools and daycares perfect for your little ones.</p>"
      }
    }
  },
  "apartments/ar/north-little-rock/lexington-park/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Lexington Park like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Lexington Park’s 1-, 2-, and 3-bedroom apartments are in northern Little Rock, about a 15-minute drive from downtown. Near our Little Rock apartment community, you’ll find everything you’ll need daily, from local restaurants, like Casa Mexicana, to family-friendly attractions, like The Wonder Place. There are also several highly rated schools in the area so you can find the right fit for any student.</p>"
      }
    }
  },
  "apartments/ks/maize/watercress/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Watercress Apartments like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The pet-friendly Watercress apartment community in Maize, KS, is the perfect blend of urban convenience and suburban charm near Wichita. Situated near various employers and educational institutions, such as the Wichita State University West location, residents and students benefit from an effortless commute. Moreover, with access to trendy boutiques, top dining establishments, and major retailers, you’ll have everything you need right at your fingertips.<br></p>"
      }
    }
  },
  "apartments/ks/wichita/aspen-park/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Aspen Park like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our Wichita apartments are located on the west side of town, near several restaurants, stores, and schools. The numerous parks nearby, like Sedgwick Park, Swanson Park, and Brown Thrust Park, beckon residents to visit and enjoy the great outdoors. Wichita State University is also nearby, just a quick 15-minute drive from our apartments.</p>"
      }
    }
  },
  "apartments/ks/wichita/cottages-at-crestview/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Cottages at Crestview like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Cottages at Crestview’s 1-, 2-, and 3-bedroom apartments in eastern Wichita are located near Harrison Park, within reach of several shopping, dining, and entertainment venues. As one of the centers of aviation development, our Wichita apartments keep you close to McConnel Air Force Base, Spirit Aerosystems Holdings, and the Cessna Aircraft headquarters. Private and public elementary, middle, and high schools are just minutes from our Wichita apartments. Cottages at Crestview is an excellent option for those searching for apartments near Wichita State University, just a 10-minute drive away.</p>"
      }
    }
  },
  "apartments/ks/wichita/crown-chase-apts/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Crown Chase like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Crown Chase Apartments are located near the desirable Westlink and Orchard Breeze neighborhoods. Just a short drive from our Wichita apartment community, unique local restaurants, shopping venues, and some of the city’s best attractions await your visit. Crown Chase keeps you close to Wichita’s center of the action with Textron Aviation, the Dwight D. Eisenhower National Airport, and many other major employers easily within reach, and with a variety of private and public schools nearby, it is a breeze to find the right fit for young students or those looking to continue their education.</p>"
      }
    }
  },
  "apartments/ks/wichita/huntington-park/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Huntington Park like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Situated near the Westlink neighborhood, Huntington Park Apartments put you near all of what makes Wichita unique. Dining, shopping, and entertainment options are all just minutes away and highly rated schools for students of all ages, including Wichita State University, can also be found nearby.</p>"
      }
    }
  },
  "apartments/ks/wichita/newport-wichita/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Newport Wichita like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Find our apartment homes in northwest Wichita near other desirable neighborhoods, including Westlink, Orchard Breeze, and Orchard Park. Our proximity to Central Avenue gives you a distinct advantage through unparalleled access to the heart of Wichita, making fine dining, entertainment, and top-quality schools easily within reach.</p>"
      }
    }
  },
  "apartments/ks/wichita/portofino/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood near Portofino like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The Portofino apartment community is situated on the suburban western edge of Wichita near the intersection of K-96, U.S. Route 400, and I-35. Our ideal location is a massive benefit for commuters and students seeking quick access to the center of town and Wichita State University, giving you multiple highway routes to the greater Wichita area only a few blocks from your door.<br></p>"
      }
    }
  },
  "apartments/ks/wichita/raintree-apts/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Raintree like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Raintree Apartments in Wichita are convenient for various dining, shopping, and entertainment options. Additionally, several elementary, middle, and high schools are easily accessible, offering a family-friendly appeal. For outdoor recreation, Sedgwick County Park, located just two miles away, provides a delightful setting for enjoying the fresh air with friends and family.</p>"
      }
    }
  },
  "apartments/ks/wichita/remington-wichita/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at The Remington Wichita like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Situated near Bel Aire, The Remington offers pet-friendly apartments that provide a retreat from downtown Wichita while remaining conveniently close by. A quick drive will take you downtown for more urban adventures. For your shopping needs, the Bradley Fair Shopping Center is just a stone&#8217;s throw away, and various dining options, such as Wasabi East and Buffalo Wild Wings, are within a short distance, ensuring delicious cuisine is always at your fingertips.</p>"
      }
    }
  },
  "apartments/ks/wichita/silver-springs/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Silver Springs like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Numerous dining, shopping, and entertainment venues are near Silver Springs’s pet-friendly apartments in Wichita, KS, by the serene Central Bay neighborhood.<br><br>Just a short distance away lies Sedgwick County Park, which provides abundant opportunities for outdoor sports, recreation, and fitness activities. The park features four picturesque lakes ideal for fishing enthusiasts and facilities available for shelter rentals, ensuring a diverse range of leisure pursuits for you to enjoy.</p>"
      }
    }
  },
  "apartments/ks/wichita/villas-of-waterford/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Villas of Waterford like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The Villas of Waterford Apartments is in a prime location in Wichita, offering outstanding access to KS-96 and less than 10 minutes from Wichita State University. Numerous restaurants, retail shops, and businesses are active in the vibrant neighborhood near Cottonwood Village. </p>"
      }
    }
  },
  "apartments/mo/belton/center-301/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Center 301 like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Rapidly growing Belton is an ideal place to live with everything you could need to live a happy, fulfilling life—plentiful restaurants, shopping, and highly rated schools. Students and commuters will find a Starbucks and a Dutch Bros mere minutes from our Belton apartments for that early morning boost. Nearby grocery stores like Price Chopper and Hy-Vee make stocking the pantry easy. With Highway 71 nearby, you can reach Kansas City&#8217;s hot spots like The Plaza, Crossroads, and River Market in no time.</p>"
      }
    }
  },
  "apartments/mo/independence/the-adirondack/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at The Adirondack like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our vibrant neighborhood features an array of conveniences that cater to your every need, like shopping with family, running errands, dining out with friends, or enjoying a night on the town. The area is teeming with choices, including Main Event Entertainment just around the corner and premier restaurants such as Los Cabos Mexican Grill and Cantina within proximity. Our apartments and townhomes in Independence blend comfort and luxury, ensuring you never have to settle for less.</p>"
      }
    }
  },
  "apartments/mo/kansas-city/152-northland/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the neighborhood around 152 Northland like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The Northland is one of Kansas City’s best places to live. 152 Northland is located within reach of everything the area has to offer, ranging from essential shopping options to delicious dining opportunities.<br><br>You’ll have your choice between big box stores like Costco and Sam’s Club or supermarkets like Price Chopper or Sprouts for your groceries. When you want to hit the town, grab wings at The Peanut or drive down to the Argosy Casino &amp; Hotel. Plus, everything in downtown Kansas City is within a 20-minute drive.<br></p>"
      }
    }
  },
  "apartments/mo/kansas-city/97-north-oak/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at 97 at North Oak like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Located in the Kansas City northland, we’re ideally situated close to all your essentials, ranging from romantic dine-out spots to serene parks. The heart of KC, including Downtown, River Market, Power and Light, and numerous other attractions, is conveniently accessible via Highway 169. Additionally, a wide range of shopping venues is just around the corner, including supermarkets and fashion stores.</p>"
      }
    }
  },
  "apartments/ms/ridgeland/mark-apts/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at The Mark like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Living at The Mark Apartments puts you right in the middle of all there is to do in Ridgeland and the Jackson metropolitan area. The surrounding neighborhood is an idyllic balance of a quiet suburban feel with enough hustle and bustle to provide excitement. In addition to several beloved chains and mom-and-pop restaurants, there are several recreational opportunities and events to explore. Beyond that, there are several high-quality schools and places to work nearby. </p>"
      }
    }
  },
  "apartments/ms/ridgeland/sunchase-ridgeland-apts/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Sunchase Ridgeland like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Situated near major roads and highways, including I-55, Sunchase Ridgeland Apartments is more than what’s on our property. It’s about exploring Ridgeland and the surrounding towns near you. Indulge yourself in the shopping, dining, and entertainment options at your fingertips.</p>"
      }
    }
  },
  "apartments/ms/ridgeland/the-pointe-of-ridgeland/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at The Pointe of Ridgeland like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Living at The Pointe of Ridgeland on Rice Road, you’ll enjoy the convenient location close to shops, dining, entertainment, and schools. When you live in an apartment on the reservoir, you can easily take a day trip to Ross Barnett Reservoir and admire nature’s beauty. Looking for a date night spot? Amerigo Italian and Local 463 are the hot spots and favorite restaurants you don’t want to miss out on. </p>"
      }
    }
  },
  "apartments/ms/ridgeland/trace-apts/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at The Trace of Ridgeland like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our Ridgeland apartment community is just south of the heart of Ridgeland, near I-55 and Highway 51. Nearby, you’ll find many restaurants, stores, parks, and more. Old Trace Park, on the banks of Ross R. Barnett Reservoir, is less than four miles from our apartments in Ridgeland.</p>"
      }
    }
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Icon at Broken Arrow like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The peaceful suburb of Broken Arrow is an excellent place to live, offering suburban conveniences with proximity to all of the excitement of downtown Tulsa. Icon at Broken Arrow is near delicious dining options and convenient shops like Walmart, Target, and Bass Pro Shops. When you don’t feel like taking advantage of our community’s lux amenities, there’s always something to do in the neighborhood</p>"
      }
    }
  },
  "apartments/ok/broken-arrow/park-at-mission-hills/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at The Park at Mission Hills like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Broken Arrow, OK, offers a relaxing suburban escape from the bustle of nearby Tulsa. Strategically positioned, The Park at Mission Hill<strong>s</strong> can be found next to Country Lane Estates north of Broken Arrow Expressway to give you unparalleled accessibility without the nuisance of road noise. Whenever you are looking for something good to eat, live entertainment, or local businesses to support, the entirety of Broken Arrow is at your doorstep, with downtown Tulsa just up the road.</p>"
      }
    }
  },
  "apartments/ok/broken-arrow/redbud-ranch/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Redbud Ranch like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our apartments near Lynn Lane and Aspen Creek provide convenient access to Highway 51 and the Creek Turnpike. You can explore various dining options, from well-known fast food chains to distinctive local eateries near our Broken Arrow apartments. Popular retail destinations such as Target, Sprouts Farmers Market, and Walmart Neighborhood Market are nearby, offering convenience for running errands.</p>"
      }
    }
  },
  "apartments/ok/broken-arrow/scissortail-crossing/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Scissortail Crossing like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">When you live at Scissortail Crossing Apartments in Broken Arrow, you can enjoy the best of both worlds. You can enjoy the natural beauty of Ray Harral Nature Park and skate near Nienhuis Park Community Center. In north Broken Arrow, cuisine enthusiasts can enjoy classic Mexican dishes at Los Cabos Mexican Grill &amp; Cantina or indulge in flavorful ribs at Oklahoma Joe’s Barbecue. Additionally, nearby parks, attractions, and shops are easily accessible, making Scissortail Crossing an ideal location for leisure and convenience.</p>"
      }
    }
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Trails at Aspen Creek like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Whether you’re looking for a home close to your job by Creek Turnpike or down the road from the Tulsa Tech—Broken Arrow campus, our community is perfect for professionals and young students. Our proximity to the Indian Springs Sports Complex, Warren Theater, and Ray Harral Nature Park &amp; Center also makes us a great spot for families moving around the area.<br><br>Other nearby points of interest you’ll find near Trails at Aspen Creek in Broken Arrow include:<br><br>&#8211; Life Church South Broken Arrow<br>&#8211; Broken Arrow Lanes<br>&#8211; Warren Theater<br>&#8211; Broken Arrow Youth Baseball<br>&#8211; Indian Springs Country Club<br>&#8211; Northeastern State University-Broken Arrow</p>"
      }
    }
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Villas at Aspen Park like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The Villas at Aspen Park boasts a prime location just north of Rhema Park, providing easy access to OK-51. This bustling neighborhood, located just to the west of Southbrook, offers a variety of local and chain businesses that provide endless entertainment and engagement opportunities for Broken Arrow residents. Whether you need groceries from Aldi&#8217;s, enjoy shopping with your family at Woodland Hills Mall, or wish to have a delicious meal with friends at 50&#8217;s Diner, our pet-friendly apartments in Broken Arrow offer the perfect combination of convenience and luxury.</p>"
      }
    }
  },
  "apartments/ok/edmond/fountain-lake/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Fountain Lake like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Fountain Lake’s convenient suburban location is the best of both worlds, offering the peace and quiet of nearby neighborhoods while remaining just 15 minutes away from the bright lights of Oklahoma City. A few miles away, Quail Springs Marketplace shopping center offers a wide range of shopping and dining options. In addition to major employers like Frontier City and Paycom just a short drive from your front door, there are also several highly rated elementary, middle, and high schools nearby to suit the needs of any student.</p>"
      }
    }
  },
  "apartments/ok/edmond/villas-at-stonebridge/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Villas at Stonebridge like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The Villas at Stonebridge boasts an unbeatable location just northeast of Oklahoma State University, providing unparalleled access to US-77. This vibrant neighborhood is a bustling hub of activity, offering abundant local and chain businesses. Whether you&#8217;re stocking up on essentials, indulging in some retail therapy with friends, or savoring a delicious meal with loved ones, the countless options along South Boulevard and East 33rd Street will keep you entertained and enthralled.</p>"
      }
    }
  },
  "apartments/ok/jenks/the-reserve-at-elm/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at The Reserve at Elm like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our relaxed community is situated near the southern edge of the Tulsa Metropolitan Area while keeping you close to the action through premium dining opportunities, commercial hot spots, and must-see attractions only minutes from home. Take the Okmulgee Expressway north for a straight shot to the heart of Tulsa or cross the river to be greeted by the River Spirit Casino Resort, a fine preview of the excitement that awaits in our vibrant community.</p>"
      }
    }
  },
  "apartments/ok/moore/mission-point/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Mission Point like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Just a short drive south of downtown Oklahoma City, you can find Mission Point’s luxury apartments near 27th Street and Interstate 35 by looking for our signature masonry and bright red tiled roofs. Our cozy corner of paradise by the highway opens up a world of possibilities in entertainment, shopping, and fine dining. We are surrounded by a range of nearby restaurants and shops, and with all the excitement of greater Oklahoma City easily within reach from your Mission Point apartment home, you can immerse yourself in the city’s culture and quickly become a member of the local community.</p>"
      }
    }
  },
  "apartments/ok/norman/artisan-crossing-apts/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Artisan Crossing like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">You’ll find our apartments near OU less than five miles from campus and downtown Norman, near several restaurants, stores, and other essentials. Head down the street for El Huevo Mexi-Diner, where you’ll find fresh breakfast options and unique cocktails, or stop by Starbucks for a caffeine boost. You can always find what you need at grocery stores, shopping malls, and local boutiques nearby. </p>"
      }
    }
  },
  "apartments/ok/norman/cimarron-trails-apts/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Cimarron Trails like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Find our apartments in northern Norman, off Monarch Highway near Legacy Park and University Town Center shopping center. Grab a delicious meal from one of the many nearby restaurants, or plan a shopping day and visit some of the several clothing outlets and specialty stores near our apartments in Norman. Cimarron Trails Apartments near the University of Oklahoma are within reach of top elementary, middle, and high schools, ensuring an excellent education is always within reach.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at 24Hundred like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our luxurious apartments enjoy a prime position adjacent to the Quail Ridge area, merely a short drive away from the heart of Oklahoma City. Nestled in our tranquil community, you&#8217;ll discover a variety of gourmet dining options, distinctive boutiques, entertaining activities, top-notch educational institutions, and much more. At 24Hundred, both shopping excursions and memorable moments with friends and family are conveniently at your doorstep.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Chisholm Pointe like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Chisholm Pointe is a wonderful pet-friendly community located in Oklahoma City. We offer a variety of duplexes and quadplexes to choose from. Our community is conveniently situated near the Stonegate neighborhood, providing easy access to I-344 and Lake Hefner.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Cimarron Pointe like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Northwest of downtown, you’ll find Cimarron Pointe near desirable suburbs like Warr Acres and Bethany. With unique restaurants and popular chains nearby, finding a good meal near Cimarron Pointe is simple. Retail outlets like Walmart Supercenter and Kohl’s are just minutes away, making errand days a cinch. Several public and private schools are situated within proximity to our Oklahoma City apartments as well, enabling you to find the right fit for students of any age.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/council-place-apartments/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Council Place like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Located near the peaceful Beacon Hills neighborhood, Council Place Apartments in Oklahoma City is conveniently located near dining, shopping, and entertainment venues. Our town is home to several major employers, including the headquarters for Paycom and INTEGRIS Health’s corporate offices. These are well within reach, with easy access to Northwest Expressway and the John Kilpatrick Turnpike from your apartment home. Also nearby are several elementary, middle, and high schools, and just a few miles away, Bluff Creek Park offers hiking and biking paths and covered pavilions where you can enjoy fresh air.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/cross-timber/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Cross Timber like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">You’ll find Cross Timber’s 2- and 3-bedroom apartments south of downtown Oklahoma City in the desirable Lakeridge Run neighborhood. OKC&#8217;s bright lights and premier attractions are well within reach of our ideal location, yet your apartment home serves as a retreat from the hustle and bustle of the metro. When you want to get out of your apartment, dine at one of the nearby restaurants or indulge in a little retail therapy by visiting one of the various nearby retailers.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Crown Pointe like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Near the Warwick Village neighborhood and The Village, Crown Pointe’s 1- and 2-bedroom apartments are located northwest of downtown OKC. You&#8217;ll never be far from a scenic natural retreat just north of Bluff Creek Park and scenic Lake Hefner. There’s also a wide selection of dining and shopping options nearby so you can easily finish your errands.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/hunter's-ridge-apts/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Hunter’s Ridge like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Hunter’s Ridge Apartments are located northwest of downtown Oklahoma City, just west of scenic Lake Hefner. Numerous dining, shopping, and entertainment venues are available nearby, making it easy to enjoy every day. There are also many highly rated schools near our apartments in Oklahoma City, allowing you to find a good fit for students of any age. See our location firsthand by scheduling a tour of Hunter’s Ridge.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/park-at-tuscany/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at The Park at Tuscany like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Just a short drive north of the intersection of John Kilpatrick Turnpike and Lake Hefner Parkway, The Park at Tuscany offers the quiet suburban environment of north Oklahoma City while maintaining unmatched access to the cultural, educational, and commercial centers of activity in this bustling community. Find everything you need, from groceries to golfing at premier OKC destinations like the Gaillardia Golf Club and Quail Springs Mall, both only a few minutes away.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/persimmon-square-apartments/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Persimmon Square like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">In the vibrant Oklahoma City community near Persimmon Square, you&#8217;ll discover an array of conveniences just a stone&#8217;s throw away, including delightful restaurants and picturesque parks. The Quail Springs Mall, ALDI, and Uptown Grocery Co. are nearby for fantastic shopping options. For outdoor enthusiasts, stroll around Lake Hefner or explore the scenic Duffner Park.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Prairie Springs like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">With a variety of dining, shopping, and entertainment options nearby, Prairie Springs boasts a prime location for those seeking a dynamic lifestyle in OKC. Our ideal position near the Northwest Expressway keeps the greater OKC area within an easy drive from your home, opening up a world of cultural, culinary, and commercial exploration.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/stonehorse-crossing/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Stonehorse Crossing like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Just minutes away from the vibrant heart of Oklahoma City, Stonehorse Crossing gives you a high degree of convenience accessibility with a wealth of entertainment, dining, and shopping options nearby. A vast collection of shopping options await at Quail Springs Mall to the south and an array of local restaurants allow you to enjoy every flavor of Oklahoma City’s famed culinary and cultural scene.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/summerfield-place-apts/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Summerfield Place like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our pet-friendly Sunchase apartments in south Tulsa offer easy access to the city&#8217;s vibrant downtown scene with just a short drive. Nearby our Tulsa apartments, you&#8217;ll discover various restaurants, schools, shops, parks, and all the essentials for your daily routine. Thanks to our proximity to Highway 169 and Creek Turnpike, commuting to prominent locations like the Sem Group Corporation for work is effortless and efficient.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/summit-ridge-villas/summit-villas/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Chisholm Pointe like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Chisholm Pointe is a wonderful pet-friendly community located in Oklahoma City. We offer a variety of duplexes and quadplexes to choose from. Our community is conveniently situated near the Stonegate neighborhood, providing easy access to I-344 and Lake Hefner.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/tammaron-village-apartments/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Tammaron Village like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Conveniently situated in northwest Oklahoma City, Tammaron Village Apartments offers easy access to a variety of dining, shopping, and entertainment venues and top-rated schools and colleges. Our pet-friendly apartments are located near the Beacon Hill neighborhood, providing an ideal location for residents.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/warrington-apartments/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at The Warrington Apartments like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Explore our pet-friendly apartments in Oklahoma City, conveniently located near Lake Hefner and Mercy Hospital. Our residences are close to schools, dining establishments, shopping centers, and local attractions, ensuring easy access to everyday necessities via John Kilpatrick Turnpike.<br></p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Waters Edge Apartments like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Moving to Waters Edge means moving to a vibrant urban community with food, shops, and entertainment just a few minutes away. Located in Southwest Oklahoma City, we’re just a hop, skip, and a jump away from downtown OKC, Oak Grove, Boecking Acres, and Wheatland. Taking your next vacation? We’re also less than a mile north of Will Rogers World Airport.<br></p>"
      }
    }
  },
  "apartments/ok/owasso/coffee-creek/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Coffee Creek like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Coffee Creek’s 1- and 2-bedroom apartments offer a lavish residential experience in northern Owasso with all the conveniences of the greater Tulsa area just a short trip from your front door. Our ideal position keeps our community within arm’s reach of Highway 169 but with just enough distance so that road noise is not an issue. Explore the delightful eateries and shops in Owasso, or take a trip down into the city at your convenience to experience the broad range of services and attractions available near your apartment at Coffee Creek.</p>"
      }
    }
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Cottages at Tallgrass Point like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our 1- and 2-bedroom apartments offer a luxurious residential experience in northern Owasso, with the allure of the greater Tulsa area just a short trip from your doorstep. Explore the local charm of Owasso&#8217;s delightful eateries and shops, or venture into the heart of Tulsa to dive into the iconic blend of Midwestern and Southern culture you can only find here in the heart of Oklahoma.<br></p>"
      }
    }
  },
  "apartments/ok/owasso/cypress-crossing/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the easiest way to get in touch with the leasing office?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">You can reach us with any questions, comments, or concerns by phone, email, or by using the contact form on this page.</p>"
      }
    }
  },
  "apartments/ok/pryor/west-530/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is there an onsite fitness center?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, we have a fully equipped fitness center available for residents as well as a resort-style pool.</p>"
      }
    }
  },
  "apartments/ok/stillwater/apple-creek-stillwater/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What&#8217;s the neighborhood like at Apple Creek?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Experience the convenience of Apple Creek&#8217;s apartments near OSU, allowing you to make the most of all that Stillwater has to offer. Located just a short drive from shops, eateries, entertainment venues, and all the essentials for your daily life, our apartment community ensures easy access to everything you need. Whether it&#8217;s running errands or socializing with friends, our central location brings everything closer to home.</p>"
      }
    }
  },
  "apartments/ok/tulsa/barrington-apartments/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Barrington like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Just a short drive from downtown, Barrington Apartments are located in south Tulsa near Broken Arrow. Whether you’re running errands, grabbing dinner with friends, or heading to a night out on the town, the neighborhood has everything you need. The next time you&#8217;re in the mood for a little retail therapy, take the quick five-minute drive to Woodland Hills Mall, where you’ll find nearly 150 stores. When you’re hungry and don’t want to cook, try one of the several restaurants nearby.</p>"
      }
    }
  },
  "apartments/ok/tulsa/cascata-luxury-apartments/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Cascata like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">South of downtown Tulsa, you’ll find Cascata tucked away near the Woodland and South Towne Square neighborhoods. When you’re searching for a good meal, head to one of the many restaurants near our Tulsa apartments, which include everything from familiar fast food chains to unique local favorites. Nearby stores like Target, Sam’s Club, and Best Buy make running errands a cinch.</p>"
      }
    }
  },
  "apartments/ok/tulsa/cedar-glade-apts/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Cedar Glade like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We’re located in south Tulsa, southwest of Woodland Hills Mall and north of Tulsa Community College’s Southeast Campus. Our Tulsa apartments are surrounded by schools, restaurants, shopping, and attractions, making it easy to find what you need nearby. When you’re looking for something to do on a Friday night or weekend, take the quick five-minute drive to Cinemark Tulsa and IMAX and sit back in a reclining lounger while watching the latest film.</p>"
      }
    }
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Cedar Ridge like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Tucked away from the heart of Tulsa, Cedar Ridge offers all the benefits of being close to the metro combined with suburban convenience. Commuters and students alike can benefit from a streamlined commute thanks to our proximity to several employers and schools, like Tulsa Community College-Southeast Campus. When you need new clothes or a gift for a friend, you can find Woodland Hills Mall close at hand, with over 100 stores to peruse.</p>"
      }
    }
  },
  "apartments/ok/tulsa/chardonnay/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Chardonnay like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Look for the Chardonnay Apartments in south Tulsa, near desirable neighborhoods like Burning Tree and South Towne Square. Whenever you crave the exciting atmosphere of Tulsa, downtown is only around 15 minutes away. Restaurants, shopping, and attractions surround our pet-friendly Tulsa apartments, so there’s always something to do nearby.</p>"
      }
    }
  },
  "apartments/ok/tulsa/country-hollow-apartments/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Country Hollow like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our community’s advantageous position presents all the attractions and must-see destinations of greater Tulsa right outside your door. Our proximity to Oral Roberts University and Tulsa Community College makes our community an ideal choice for students looking for a comfortable, reasonably priced community near campus, while our position near Riverside Parkway keeps the commercial heart of town well within reach.</p>"
      }
    }
  },
  "apartments/ok/tulsa/creekwood-apartments/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Creekwood like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Nestled in the peaceful Woodland neighborhood, Creekwood’s<strong> </strong>1- and 2-bedroom apartments<strong> </strong>offer a retreat from downtown Tulsa, yet remain just a quick drive away from the metro. Over 100 stores await you at the nearby Woodland Hills Mall, and delicious cuisine is always within reach at restaurants like Le Louvre French Cafe and Brook South. The several nearby schools ensure that all students can find a great fit.</p>"
      }
    }
  },
  "apartments/ok/tulsa/nickel-creek-apts/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Nickel Creek like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">At Nickel Creek we want you to enjoy more than just your apartment unit. Located in south Tulsa, we’re a short drive from plenty of bars, restaurants, and attractions around the city. Have fun with friends at Main Event Tulsa, spend an evening at Tulsa Spotlight Theater, or catch your favorite artist at the BOK Center. No matter how you choose to spend your time, you’ll always have a welcoming space to come home to. Take a self-guided tour of Nickel Creek Apartments to learn more about our community.</p>"
      }
    }
  },
  "apartments/ok/tulsa/polo-run-apartments/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Polo Run like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">At Polo Run apartments, you can savor all that Tulsa offers. Our convenient proximity to stores, restaurants, attractions, and essential amenities ensures that everything you need is just a short drive away. The central location of our apartments simplifies errands and social gatherings, offering you easy access to the best of the city.</p>"
      }
    }
  },
  "apartments/ok/tulsa/sheridan-pond/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Sheridan Pond like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our vibrant Tulsa community offers a plethora of amenities for daily living. From delightful local dining spots to picturesque parks, residents can easily access everything they need. The Sheridan Pond neighborhood boasts a range of local employers, such as hospitals and universities, along with schools within the Union Public Schools district, providing convenient options for work and education.</p>"
      }
    }
  },
  "apartments/ok/tulsa/sugarberry-apartments/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Sugarberry like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Indulge in retail therapy at Woodland Hills Mall, just a 10-minute drive away, boasting nearly 150 stores for your shopping pleasure. With various nearby restaurants, dining options abound if you prefer to take a day off from cooking. Discover the convenience of the exceptional location of our sought-after pet-friendly apartments in south Tulsa.</p>"
      }
    }
  },
  "apartments/ok/tulsa/sunchase-apartments/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Sunchase like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our pet-friendly Sunchase apartments in south Tulsa offer easy access to the city&#8217;s vibrant downtown scene with just a short drive. Nearby our Tulsa apartments, you&#8217;ll discover various restaurants, schools, shops, parks, and all the essentials for your daily routine. Thanks to our proximity to Highway 169 and Creek Turnpike, commuting to prominent locations like the Sem Group Corporation for work is effortless and efficient.</p>"
      }
    }
  },
  "apartments/ok/tulsa/the-courtyards/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at The Courtyards like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The Courtyards of Tulsa apartment community is located south of the Tulsa metro area, not far from Jenks and Broken Arrow. Located in the desirable Chimney Hills neighborhood, our 1- and 2-bedroom apartments are surrounded by everything you could need: grocery stores, clothing outlets, restaurants, and so much more. Excellent schools for students of all ages can also be found near Courtyards apartments in Tulsa.</p>"
      }
    }
  },
  "apartments/ok/tulsa/the-greens-of-bedford/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at The Greens of Bedford like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Located south of downtown Tulsa, near Broken Arrow, The Greens of Bedford Apartments are just a quick drive away from several dining, shopping, and entertainment options, and highly rated schools and colleges. The Greens of Bedford Apartments are just minutes from Highway 64, making your commute to ONEOK Inc. or one of the many other businesses based downtown. Experience our ideal location firsthand by scheduling a tour of our Tulsa apartments.</p>"
      }
    }
  },
  "apartments/ok/tulsa/windsail-apts/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Windsail Apartments like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Situated near the Woodland Hills and Burning Tree neighborhoods, the pet-friendly Windsail Apartments on 71st and Mingo offers proximity to Tulsa&#8217;s top attractions, charming local eateries, and convenient shopping destinations. With close access to private and public schools, Windsail simplifies the process of selecting the perfect educational environment for young learners or individuals seeking to advance their studies.<br></p>"
      }
    }
  },
  "apartments/ok/yukon/park-at-westpointe/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at The Park on Westpointe like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The Park on Westpointe sits right at the gate to greater Oklahoma City near I-40. Ideal for residents seeking a quick commute to downtown, our apartments in Yukon are ideally situated and surrounded by quaint local eateries, beautiful parks, and must-see attractions that locals and visitors love.<br></p>"
      }
    }
  },
  "apartments/ok/yukon/the-ridge-@-66/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Ridge @ 66 like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our calm apartment community on the edge of Lake Overholser presents a relaxed living environment that keeps you close to all of Yukon and greater OKC’s attractions. Located just a stone’s throw away from the intersection of Interstate 344 and the historic Route 66 highway, the accessibility offered by Ridge at 66 is hard to beat.</p>"
      }
    }
  },
  "apartments/tx/amarillo/newport-amarillo-apts/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Newport Amarillo like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our apartment community in southwest Amarillo is ideally located. Those looking for a quiet home that is separated from the bustle of the downtown can enjoy a superior home that is only a short drive from highly rated schools, fine and casual dining, and the distinct blend of Texan culture that gives Amarillo its charm.</p>"
      }
    }
  },
  "apartments/tx/amarillo/park-at-coulter/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Park at Coulter like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Few cities epitomize the Texas panhandle quite like Amarillo. Home to one-of-a-kind attractions like The RV Museum and Cadillac Ranch and a top-notch culinary scene, Amarillo presents decades of American culture for you to explore and enjoy when you make your home at Park at Coulter Apartments. </p>"
      }
    }
  },
  "apartments/tx/amarillo/remington-amarillo-apts/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Remington like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Located near Soncy Road and I-40, the Remington Apartments are conveniently situated near plenty of dining, shopping, and entertainment options. When looking for date night spots, couples enjoy Saltgrass Steak House for dinner or brunch at Butterlove Biscuits. Take in the beautiful flowers at Amarillo Botanical Gardens, catch the newest movie at Cinemark, or indulge in a shopping trip at Westgate Mall, all located in close proximity to your new home.</p>"
      }
    }
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Colonies at Hillside like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">This vibrant neighborhood and the greater Amarillo area is teeming with exhilarating activities, captivating destinations, and opportunities for personal growth. So living in apartments at Coulter and Hillside, such as the Colonies at Hillside will unlock a world of possibilities. The Colonies at Hillside is conveniently located near I-40, I-27, and other major roads, so you can live the life you want.</p>"
      }
    }
  },
  "apartments/tx/amarillo/winchester-apartments/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Winchester Apartments like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The Winchester apartment community offers a prime location in the vibrant Amarillo neighborhood near Puckett and Olsen. Our pet-friendly apartments near Sleepy Hollow provide easy access to essential amenities such as grocery stores, retail shops, and dining options. Additionally, Winchester Apartments in Amarillo is near top-notch schools catering to students of all ages.<br></p>"
      }
    }
  },
  "apartments/tx/el-paso/acacia-park-apts/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Acadia Park like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Acacia Park is ideally located near North Mesa Street and offers apartments in the Upper Mesa Hills neighborhood. The nearby community has something for everyone, from family-friendly fun to swanky bars. Outdoor lovers will enjoy hiking opportunities near our El Paso apartment community, from the Franklin Mountains to Resler Canyon.</p>"
      }
    }
  },
  "apartments/tx/el-paso/chimneys-apts/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at The Chimneys like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The Chimneys in West El Paso is only be a short drive away from the town’s major attractions and events. Whether you go out to Franklin Mountains State Park, get your game on at TopGolf, or visit the Shoppes at Solana or any of El Paso’s shopping districts, you’ll never run out of things to do in town. After all is said and done, you will have a welcoming place to return to at The Chimneys Apartments.</p>"
      }
    }
  },
  "apartments/tx/el-paso/double-tree-apts/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Double Tree like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our Double Tree Apartments near Mesa Hills put you near various attractions, restaurants, and parks. You can hike the Franklin Mountains, catch a movie at Alamo Drafthouse Cinema Montecillo, or glide through the mountains at Wyler Aerial Tramway. Excellent nearby school districts also ensure learning opportunities for those with children or prospective college students.</p>"
      }
    }
  },
  "apartments/tx/el-paso/high-ridge-apts/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at High Ridge like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">There’s no shortage of fun activities, dining, and entertainment options near our East El Paso 1- and 2-bedroom apartments. With our proximity to I-10 and US-78, you’ll find family-friendly entertainment, like El Paso Zoo and Botanical Gardens, and great options for date nights, like DePalma’s Italian Cafe Westside. Living at High Ridge puts you next to it all.</p>"
      }
    }
  },
  "apartments/tx/el-paso/mountain-village-apts/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Mountain Village like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Living at Mountain Village Apartments in El Paso opens the door to all the city offers. The neighborhood and greater El Paso area are full of exciting things to do, interesting places to visit, and opportunities to build a better future for yourself and your loved ones. With I-10 just minutes away and other major roads within a short distance, there are no boundaries to the life you can live at Mountain Village.</p>"
      }
    }
  },
  "apartments/tx/el-paso/patriot-apts/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at The Patriot like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">When you live in our El Paso community, you’ll find everything you need nearby for day-to-day life, from charming local restaurants to gorgeous parks. Our apartments near Fort Bliss are ideal for military service members and their families. Want to spend time in the great outdoors? Head to Franklin Mountain State Park nearby, where you’ll find over 24,000 acres of land ripe with hiking, biking, climbing, and sightseeing opportunities.</p>"
      }
    }
  },
  "apartments/tx/el-paso/phoenix-apts/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at The Phoenix like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Located in southeast El Paso, the Phoenix apartments are only a short drive from everything downtown offers. Near our El Paso apartments, you will find restaurants, schools, shops, parks, and just about anything else you need in your day-to-day life. Thanks to our proximity to I-10, you’ll enjoy a simple commute to work or school.</p>"
      }
    }
  },
  "apartments/tx/el-paso/shadow-ridge-apts/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Shadow Ridge like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">While a comfortable apartment near Fort Bliss can be a luxury in itself, there’s much more to the area. A plethora of attractions and events are just a short distance away from your east El Paso apartment. With I-10 and Loop 375 nearby, you can easily reach these destinations in just a few minutes.</p>"
      }
    }
  },
  "apartments/tx/el-paso/the-crest/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at The Crest like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">El Paso shines as a unique city where a deep-rooted culture and history harmoniously intertwine with contemporary elements. Culinary aficionados revel in El Paso&#8217;s distinctive dining scene, from indulging in a steak at the renowned Cattleman’s Steakhouse to enjoying a margarita at ELEMI. By choosing The Crest, you position yourself in the heart of it all—near the parks, attractions, and shopping venues that animate the vibrant spirit of El Paso.</p>"
      }
    }
  },
  "apartments/tx/hewitt/icon-at-hewitt/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Icon at Hewitt like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Apartment living at Icon at Hewitt doesn’t end once you step off-site. You have easy and reliable access to a bustling and lively community in West Waco and Hewitt, TX. By hopping onto I-35 or the other major roads and highways near our apartment community, you’ll reach a whole world of dining, shopping, and entertainment. Enjoy delicious eateries right around the corner, such as Marco’s Pizza, Mexicano Grille, and Bush’s Chicken.</p>"
      }
    }
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Cottages at Abbey Glen like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">You’ll find our Lubbock apartment community located in south Lubbock, near Route 289 and Slide Road. Some neighborhoods near our apartments include Abbey Glen, Lake Ridge, Vintage Township, and The Falls. We’re also near numerous dining and entertainment options and schools. If you’re in need of student housing, keep our apartments near Texas Tech University in mind!</p>"
      }
    }
  },
  "apartments/tx/lubbock/icon-at-lubbock/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Icon at Lubbock like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Get to know Lubbock—where there&#8217;s much more to explore than just your apartment. You&#8217;ll be just a short drive from the town&#8217;s unique attractions and events when renting at The Icon at Lubbock near Wolfforth. Shop at West End Center, The Hub, or Canyon West Shopping Center and return home to decorate your living spaces, fill your closet, and make a meal your friends and family are sure to remember. </p>"
      }
    }
  },
  "apartments/tx/lubbock/tuscany-place/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Tuscany Place like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Tuscany Place’s Lubbock apartment community is located near Lubbock’s best neighborhoods and just a quick drive from the heart of the city. We’re also a great option if you’re looking for an apartment in Wolfforth, which is less than a ten-minute drive from our apartment community. We also offer apartments near Texas Tech, less than 10 miles away.</p>"
      }
    }
  },
  "apartments/tx/temple/portico-at-friars-creek-apts/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Portico at Friar’s Creek like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">When you’re looking for an apartment to rent in Temple, TX, don’t just look at what’s on the property. Temple is a lively town with a plethora of fun attractions and activities to do. With Portico at Friars Creek right next to several major streets and highways, you have reliable access to the many attractions and landmarks of Temple, TX, such as the Temple Mall, Mary Alice Marshall Performing Arts Center, and Temple College.</p>"
      }
    }
  },
  "apartments/tx/waco/bend-at-new-road/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Bend at New Road like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our apartments in Waco are in the perfect location, not far from downtown and near several great neighborhoods. Even if you’re not a resident of Waco, we’re a great option if you’re looking for apartments in Beverly Hills, TX, or Robinson, TX. Our apartments in New Road are situated in south Waco, chock full of dining, entertainment, shopping, and great schools.</p>"
      }
    }
  },
  "apartments/tx/waco/tuscany-ranch-apartments/contact-us::contactform.faq_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What’s the neighborhood at Tuscany Ranch like?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Close to I-35, our South Waco apartments are conveniently located for you to explore the neighborhood with no hassle. From the numerous shopping and entertainment options to a meal at one of the many nearby restaurants, you can enjoy apartment living to its fullest even when you’re off the property.</p>"
      }
    }
  },
  "apartments/ar/little-rock/arbors-of-pleasant-valley-apts/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Arbors of Pleasant Valley?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>A maximum of two pets are allowed, with breed restrictions in effect. Pet owners must pay a pet rent of $30 per pet per month. Additionally, there’s a non-refundable fee of $500 per pet.</p>"
      }
    }
  },
  "apartments/ar/north-little-rock/lexington-park/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Lexington Park?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>Dogs and cats are permitted with breed restrictions and subject to management approval, with a maximum of two pets allowed per home. There is a non-refundable fee of $500 per pet and a monthly rent of $30 per pet.</p>"
      }
    }
  },
  "apartments/ks/maize/watercress/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Watercress Apartments?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">At Watercress Apartments, cats and dogs are welcome. Both cats and dogs have a monthly rent of $30 per pet along with a non-refundable pet fee that’s equal to half a month’s rent. <br></p>"
      }
    }
  },
  "apartments/ks/wichita/aspen-park/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Aspen Park?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We welcome pets here at Aspen Park! We allow a maximum of two pets and a maximum pet weight of 80 pounds. Pet rent is $25 per month, and we charge a pet deposit at half of the first months’ rent per pet. Service animals are not considered pets and are exempt.</p>"
      }
    }
  },
  "apartments/ks/wichita/cottages-at-crestview/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Cottages at Crestview?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Dogs and cats are permitted with breed restrictions in place, limited to a maximum of two pets per home. Each pet must not exceed 80 pounds in weight, with a non-refundable fee equal to half of one month’s rent per pet and a monthly rent of $30 per pet.</p>"
      }
    }
  },
  "apartments/ks/wichita/crown-chase-apts/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Crown Chase?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Residents are permitted a maximum of two pets, with each pet allowed a maximum weight of 80 pounds. There is a pet rent of $30 per pet per month, along with a one-time, non-refundable fee equal to half a month&#8217;s rent per pet.</p>"
      }
    }
  },
  "apartments/ks/wichita/huntington-park/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Huntington Park?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">There&#8217;s a pet rent of $30 per pet per month for a maximum of two pets. Additionally, a non-refundable pet fee, equivalent to half of the first full month&#8217;s rent, applies to up to two pets, with breed restrictions and subject to management approval.</p>"
      }
    }
  },
  "apartments/ks/wichita/newport-wichita/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Newport Wichita?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">There&#8217;s a limit of two pets, subject to breed restrictions, with a pet rent of $30 per pet per month. Additionally, there&#8217;s a non-refundable pet fee equal to half of one month’s rent, and pets must not exceed 80 pounds in weight.</p>"
      }
    }
  },
  "apartments/ks/wichita/portofino/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Portofino?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Portofino’s pet policy allows for a maximum of two pets and a maximum weight of 80 pounds per pet. The monthly pet rent per pet is $30, but there is a one-time, non-refundable fee for your first month. This fee is the equivalent of one-half of your first month’s rent.<br></p>"
      }
    }
  },
  "apartments/ks/wichita/raintree-apts/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Raintree?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">In our pet policy, there is a two pet maximum per household with applicable breed restrictions. The monthly pet rent is $25 per pet with a one-time and non-refundable fee at your first month. This fee is one-half of your first month’s rent per pet.</p>"
      }
    }
  },
  "apartments/ks/wichita/remington-wichita/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at The Remington Wichita?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">A maximum of two pets are allowed, subject to breed restrictions. Pet rent is $30 per pet per month, with a non-refundable fee equal to half a month&#8217;s rent per pet.<br></p>"
      }
    }
  },
  "apartments/ks/wichita/silver-springs/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Silver Springs?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">A maximum of two pets are allowed, with each pet weighing up to 80 pounds. Pet owners must pay a monthly pet rent of $25 per pet, as well as a non-refundable fee equivalent to half a month&#8217;s rent per pet.</p>"
      }
    }
  },
  "apartments/ks/wichita/villas-of-waterford/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Villas of Waterford?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Residents are allowed a maximum of two pets, with breed restrictions in place. Additionally, there&#8217;s a pet rent of $30 per pet per month, along with a non-refundable fee of $500 per pet for pets weighing up to 80 pounds.</p>"
      }
    }
  },
  "apartments/mo/belton/center-301/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Center 301?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our pet policy accommodates pets up to a maximum weight of 80 pounds. For each pet, a monthly rent of $30 is charged. Additionally, there is a non-refundable deposit of $500 required for each pet. Service animals are not considered pets and are excluded.</p>"
      }
    }
  },
  "apartments/mo/independence/the-adirondack/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at The Adirondack?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">There&#8217;s a limit of two pets, with breed restrictions and an 80-pound weight limit per pet. Additionally, there&#8217;s a non-refundable pet fee of $500 per pet, along with a monthly pet rent of $30 per pet.</p>"
      }
    }
  },
  "apartments/mo/kansas-city/152-northland/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is 152 Northland’s pet policy?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We’re glad to welcome your furry friends into our pet-friendly apartment community in Kansas City, MO. Two pets are allowed per apartment, maximum. We have no weight limits, but breed restrictions do apply. A one-time $500 pet fee is required upon move-in, along with a monthly pet rent of $35.<br></p>"
      }
    }
  },
  "apartments/mo/kansas-city/97-north-oak/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at 97 at North Oak?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Pets are not just allowed but encouraged! Our generous floor plans offer ample space for your pets to explore and feel comfortable. Our pet policy includes a maximum weight limit of 80 lbs for pets, a monthly pet rent of $30 per pet, and a $500 non-refundable fee per pet. It&#8217;s important to note that service animals are exempt from these stipulations, as they are not classified as pets.</p>"
      }
    }
  },
  "apartments/ms/ridgeland/mark-apts/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at The Mark?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">A maximum of two pets are permitted, with breed restrictions in place. Pet rent is $30 per pet per month, and there&#8217;s a non-refundable fee of $400 per pet for those weighing up to 40 pounds, and $500 per pet for those weighing between 41 and 80 pounds.</p>"
      }
    }
  },
  "apartments/ms/ridgeland/sunchase-ridgeland-apts/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Sunchase Ridgeland?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our pet policy states that up to two pets can reside in a single household with a max weight of 40 pounds per pet. The pet rent per month is $30 per pet. Along with that, there’s a one-time, non-refundable fee of $400. </p>"
      }
    }
  },
  "apartments/ms/ridgeland/the-pointe-of-ridgeland/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at The Pointe of Ridgeland?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">A maximum of two pets are allowed, with breed restrictions in effect. Pet rent is $30 per pet per month. Additionally, there&#8217;s a non-refundable fee of $400 per pet for pets weighing up to 40 lbs.</p>"
      }
    }
  },
  "apartments/ms/ridgeland/trace-apts/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at The Trace of Ridgeland?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We allow up to two pets per household with certain breed restrictions applied. The monthly pet rent is $30 per pet with a one-time $400 fee per pet up to 40 pounds. This fee is not refundable.</p>"
      }
    }
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Icon at Broken Arrow?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Pets are welcome with a maximum of two allowed, each weighing up to 80 pounds. There&#8217;s a pet rent of $30 per pet per month and a non-refundable fee of $400 for pets up to 40 pounds and $500 for pets up to 80 pounds.</p>"
      }
    }
  },
  "apartments/ok/broken-arrow/park-at-mission-hills/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at The Park at Mission Hills?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>A maximum of two pets are allowed with breed restrictions in place. Pet rent is $30 per pet per month. There’s a non-refundable fee of $500 per pet for.</p>"
      }
    }
  },
  "apartments/ok/broken-arrow/redbud-ranch/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Redbud Ranch?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Redbud Ranch’s pet policy allows for a maximum of two pets with restrictions on certain breeds. The pet policy includes a $30 monthly pet rent per pet on top of a one-time $500 fee per pet. This fee is non-refundable.</p>"
      }
    }
  },
  "apartments/ok/broken-arrow/scissortail-crossing/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Scissortail Crossing?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Scissortail Crossing’s pet policy allows for a maximum of two pets up to 80 pounds each. Breed restrictions do apply. On top of that, there is a $30 monthly pet rent per pet along with a one-time $500 fee per pet. This fee is not refundable.</p>"
      }
    }
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Villas at Aspen Park?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Residents may have a maximum of two pets, with breed restrictions in place and a maximum weight limit of 80 pounds per pet. Additionally, there&#8217;s a pet rent of $30 per pet per month, along with a non-refundable fee of $500 per pet.</p>"
      }
    }
  },
  "apartments/ok/edmond/fountain-lake/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Fountain Lake?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Residents are allowed a maximum of two pets, subject to management approval and breed restrictions. Each pet must not exceed 80 pounds, with a monthly pet rent of $30 per pet and a one-time non-refundable fee of $500 per pet.</p>"
      }
    }
  },
  "apartments/ok/edmond/villas-at-stonebridge/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Villas at Stonebridge?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Residents are permitted a maximum of two pets, with breed restrictions in place. Additionally, there&#8217;s a pet rent of $30 per pet per month, along with a non-refundable fee of $500 per pet for pets weighing up to 80 pounds.</p>"
      }
    }
  },
  "apartments/ok/jenks/the-reserve-at-elm/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at The Reserve at Elm?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The pet policy at Reserve at Elm allows for a two pet maximum per household with breed restrictions. The maximum weight allowed per pet is 80 pounds. There is a $30 monthly pet rent per pet along with a one-time and non-refundable fee of $500 per pet.</p>"
      }
    }
  },
  "apartments/ok/moore/mission-point/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Mission Point?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Dogs and cats are welcome, with certain breed restrictions in effect and a maximum of two pets permitted. Each pet must weigh no more than 80 pounds, with a one-time non-refundable fee of $500 per pet and a monthly pet rent of $30 per pet.</p>"
      }
    }
  },
  "apartments/ok/norman/artisan-crossing-apts/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Artisan Crossing?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our apartment community&#8217;s pet policy embraces the following regulations: Residents are permitted to have up to two pets, with a weight cap of 80 pounds. We also enforce breed restrictions for the safety and comfort of all community members. A monthly pet rent of $30 is required for each pet, alongside a non-refundable deposit of $500 per pet, provided they meet the weight restriction. It&#8217;s important to note that service animals are exempt from being classified as pets under our policy, meaning pet fees and monthly pet rent do not apply to them.</p>"
      }
    }
  },
  "apartments/ok/norman/cimarron-trails-apts/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Cimarron Trails?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Residents are allowed a maximum of two pets, subject to breed restrictions and management approval. Each pet must not exceed 90 pounds, with a monthly pet rent of $30 per pet and a one-time non-refundable fee of $500 per pet.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at 24Hundred?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">For each pet, there is a $30 monthly pet rent and a $500 non-refundable deposit required. It&#8217;s important to mention that service animals are excluded from these stipulations; they are not considered pets, and consequently, neither pet deposits nor pet rent apply to them. We might ask for further documentation concerning service animals.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Chisholm Pointe?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our pet policy permits a maximum of two pets per household, with each pet allowed a maximum weight of up to 80 pounds. For each pet, there is a monthly rent of $30. Additionally, there is a non-refundable fee of $500 per pet for those weighing up to 80 pounds.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Cimarron Pointe?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our community&#8217;s pet policy allows for a maximum of two pets per household, subject to certain breed restrictions to ensure the well-being and safety of all residents. Each pet is required to be under a maximum weight limit of 40 pounds. For the privilege of having your pet in our community, there is a pet rent of $25 charged monthly for each pet. Additionally, a non-refundable deposit of $400 is required for each pet to cover potential damages.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/council-place-apartments/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Council Place?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">A maximum of two pets are allowed, with certain breed restrictions in place for dogs and cats. Pets must not exceed a maximum weight of 40 pounds, with a pet rent of $25 per pet per month and a one-time non-refundable fee of $500 per pet.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/cross-timber/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Cross Timber?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Residents are limited to a maximum of two pets, subject to breed restrictions and management approval. Additionally, there&#8217;s a pet rent of $30 per pet per month and a one-time non-refundable fee of $500 per pet.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Crown Pointe?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Pets are subject to management approval, with a maximum of two pets allowed and breed restrictions in place. Additionally, pets must not exceed a maximum weight of 80 pounds, and there&#8217;s a pet rent of $30 per pet per month, along with a one-time non-refundable fee of $500 per pet.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/hunter's-ridge-apts/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Hunter’s Ridge?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">A maximum of two pets are allowed, subject to breed restrictions. There&#8217;s a pet rent of $30 per pet per month, along with a one-time non-refundable fee of $400 per pet for pets weighing up to 40 pounds and $500 per pet for pets weighing 41 to 80 pounds.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/park-at-tuscany/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at The Park at Tuscany?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">A maximum of two pets are permitted, subject to breed restrictions, with a maximum weight limit of 50 pounds per pet. Pet rent is $30 per pet per month, and there&#8217;s a one-time non-refundable fee of $500 per pet.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/persimmon-square-apartments/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Persimmon Square?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our pet policy allows dogs and cats with certain breed restrictions applied. The maximum weight per pet is 40 pounds with a maximum of two pets per household. The monthly pet rent is $25 per pet and includes a one-time and non-refundable $500 fee.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Prairie Springs?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The pet policy at Prairie Springs allows for a maximum of two pets allowed up to 40 pounds each. The pet rent per month is $30 per pet along with a one-time fee of $500 on your first month. This one-time fee is non-refundable.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/stonehorse-crossing/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Stonehorse Crossing?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Residents are permitted a maximum of two pets, with a weight limit of 80 lbs each. Pet owners must pay a pet rent of $30 per pet per month, along with a non-refundable fee of $500 per pet for pets weighing up to 80 lbs.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/summerfield-place-apts/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Summerfield Place?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Residents may have a maximum of two pets, with each pet weighing no more than 40 pounds. The monthly pet rent is $25 per pet, and there&#8217;s a non-refundable fee of $500 per pet.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/summit-ridge-villas/summit-villas/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Chisholm Pointe?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our pet policy permits a maximum of two pets per household, with each pet allowed a maximum weight of up to 80 pounds. For each pet, there is a monthly rent of $30. Additionally, there is a non-refundable fee of $500 per pet for those weighing up to 80 pounds.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/tammaron-village-apartments/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Tammaron Village?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Residents are allowed a maximum of two pets, with each pet having a maximum weight limit of 40 pounds. Additionally, there&#8217;s a pet rent of $25 per pet per month, along with a non-refundable fee of $500 per pet.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/warrington-apartments/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at The Warrington Apartments?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">At The Warrington Apartments, residents are welcome to have up to two pets, but there are breed restrictions in place and a maximum weight limit of 40 pounds per pet. Pet owners are required to pay a monthly pet rent of $25 per pet. Additionally, there is a one-time, non-refundable fee of $500 per pet.<br></p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Waters Edge Apartments?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">At Waters Edge Apartments, residents are permitted to have a maximum of two pets, with certain breed restrictions in effect. Each pet incurs a monthly pet rent of $30. For pets weighing up to 40 pounds, there is a one-time, non-refundable fee of $400 per pet. Pets weighing between 41 and 80 pounds are subject to a $500 non-refundable fee per pet.<br></p>"
      }
    }
  },
  "apartments/ok/owasso/coffee-creek/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Coffee Creek?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>Our pet policy allows a maximum of two pets allowed per household and is subject to have breed restrictions applied. Pet rent is $30 per pet per month along with a one-time $500 per pet. This one-time fee is non-refundable.</p>"
      }
    }
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Cottages at Tallgrass Point?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>The pet policy at Cottages at Tallgrass Point allows for a maximum of two pets with breed restrictions applied and approval from management required. The pet rent is $30 per pet per month on top of a one-time $500 fee. This fee is non-refundable.</p>"
      }
    }
  },
  "apartments/ok/owasso/cypress-crossing/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is required to apply?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">To apply, you’ll need to provide a completed application, proof of income, a valid photo ID, and any applicable fees. Contact us for details.</p>"
      }
    }
  },
  "apartments/ok/pryor/west-530/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How do I apply for an apartment?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Applying is easy! Just complete the online application form. You can also schedule a tour of the property before submitting your application.</p>"
      }
    }
  },
  "apartments/ok/stillwater/apple-creek-stillwater/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Apple Creek?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>Our pet-friendly apartments offer plenty of sunlight-perfect windows for your pets to sunbathe and numerous walking paths for enjoyable strolls. Within our pet policy, we accommodate up to two pets per apartment without imposing a weight limit. For each pet, there’s a monthly pet rent of $30 and a one-time non-refundable Pet Fee of $500. It’s important to note that service animals are not considered pets, so they are exempt from these fees and restrictions, although additional documentation might be requested for verification.</p>"
      }
    }
  },
  "apartments/ok/tulsa/barrington-apartments/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Barrington?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our pet policy is designed with the well-being of our community in mind, requiring all pets to gain approval from management before joining our community. We welcome up to two pets per residence, provided they do not exceed a maximum weight of 40 pounds. For the comfort and maintenance of our community, we also require a pet rent of $25 per pet each month. Additionally, a non-refundable fee of $400 per pet is necessary as a deposit.</p>"
      }
    }
  },
  "apartments/ok/tulsa/cascata-luxury-apartments/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Cascata?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>Our pet-friendly apartments welcome furry friends! We have a maximum of two pets allowed. Pet rent is $30 per pet per month. A $500 deposit per pet is required. Breed restrictions apply. Service animals are not considered pets and are exempt.</p>"
      }
    }
  },
  "apartments/ok/tulsa/cedar-glade-apts/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Cedar Glade?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>We allow a maximum of two pets per household, although breed restrictions are in place. For each pet, a monthly pet rent of $30 is required. Additionally, a non-refundable deposit is required, which is $500 per pet. It’s important to note that service animals are exempt from these conditions, as they are not considered pets under our policy, meaning no pet fees or rent will be charged for them.</p>"
      }
    }
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Cedar Ridge?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our pet policy permits a maximum of two pets per household, with a weight limit of 80 pounds. We have breed restrictions in place to ensure the safety and comfort of all our residents. A monthly pet rent of $30 is required for each pet. Additionally, a non-refundable deposit is necessary for each pet, with the amount being $400 for pets weighing up to 40 pounds and $500 for those weighing between 41-80 pounds.</p>"
      }
    }
  },
  "apartments/ok/tulsa/chardonnay/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Chardonnay?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>Our pet policy allows for up to two pets per household, with specific breed restrictions in place to ensure the safety and comfort of our community. A monthly pet rent of $25 is required for each pet. Furthermore, a non-refundable fee of $500 is required for each pet.</p>"
      }
    }
  },
  "apartments/ok/tulsa/country-hollow-apartments/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Country Hollow?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>Country Hollow’s pet policy allows for a maximum of two pets with breed restrictions. Pet rent is $30 a month per pet along with a one-time, non-refundable $500 fee per pet.</p>"
      }
    }
  },
  "apartments/ok/tulsa/creekwood-apartments/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Creekwood?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>Pets are subject to management approval, with a maximum allowance of two pets, and breed restrictions apply. We require a monthly pet rent of $30 per pet and a one-time non-refundable fee of $500 per pet.</p>"
      }
    }
  },
  "apartments/ok/tulsa/nickel-creek-apts/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Nickel Creek?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Two pets maximum are allowed with breed restrictions in place. Pet rent is set at $30 per pet per month, and there&#8217;s a non-refundable pet fee equal to half of one month’s rent. Additionally, pets must not exceed a weight limit of 80 pounds.</p>"
      }
    }
  },
  "apartments/ok/tulsa/polo-run-apartments/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Polo Run?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>The pet policy at Polo Run Apartments allows for a maximum of two pets per household with certain breed restrictions applied. There is no weight limit. There is a $30 monthly pet rent per pet and a one-time $500 fee that is non-refundable.&nbsp;</p>"
      }
    }
  },
  "apartments/ok/tulsa/sheridan-pond/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Sheridan Pond?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The pet policy at Sheridan Pond Apartments allows for up to two pets per household with a maximum weight of 40 pounds per pet. Certain breed restrictions do apply. There is also a monthly pet rent of $30 per pet along with a one-time $500 fee per pet. This one-time fee is not refundable.</p>"
      }
    }
  },
  "apartments/ok/tulsa/sugarberry-apartments/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Sugarberry?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">A maximum of two pets are permitted, subject to breed restrictions. Pet owners must pay a pet rent of $25 per pet per month, along with a non-refundable fee of $500 per pet.</p>"
      }
    }
  },
  "apartments/ok/tulsa/sunchase-apartments/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Sunchase?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>Residents are permitted a maximum of two pets. Additionally, there’s a pet rent of $30 per pet per month, along with a non-refundable fee of $500 per pet.</p>"
      }
    }
  },
  "apartments/ok/tulsa/the-courtyards/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at The Courtyards?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Pets are subject to management approval, with a maximum allowance of two pets and breed restrictions in effect. Additionally, pets must not exceed a maximum weight of 80 pounds, with a monthly pet rent of $30 per pet and a one-time non-refundable fee of $500 per pet.</p>"
      }
    }
  },
  "apartments/ok/tulsa/the-greens-of-bedford/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at The Greens of Bedford?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Residents may have a maximum of two pets, subject to breed restrictions and management approval. Each pet has a weight limit of 80 pounds, with a monthly pet rent of $25 per pet and a one-time non-refundable fee of $500 per pet.</p>"
      }
    }
  },
  "apartments/ok/tulsa/windsail-apts/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Windsail Apartments?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">At Windsail Apartments, residents are allowed a maximum of two pets, subject to certain breed restrictions. Each pet incurs a monthly pet rent of $25. For pets weighing up to 80 pounds, there is a one-time, non-refundable fee of $500 per pet.<br></p>"
      }
    }
  },
  "apartments/ok/yukon/park-at-westpointe/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at The Park on Westpointe?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">At The Park on Westpointe, residents are allowed a maximum of two pets, with certain breed restrictions in place. All pets must receive management approval before residing on the premises. There is a monthly pet rent of $30 per pet and a one-time, non-refundable fee of $500 per pet.<br></p>"
      }
    }
  },
  "apartments/ok/yukon/the-ridge-@-66/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Ridge @ 66?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">There&#8217;s a limit of two pets, subject to breed restrictions, with a weight limit of up to 80 lbs per pet. Additionally, there&#8217;s a $500 pet fee per pet, along with a $30 pet rent per pet per month.</p>"
      }
    }
  },
  "apartments/tx/amarillo/newport-amarillo-apts/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Newport Amarillo?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">A maximum of two pets are allowed with breed restrictions in place. There&#8217;s a pet rent of $30 per pet per month and a one-time non-refundable fee of $500 per pet.</p>"
      }
    }
  },
  "apartments/tx/amarillo/park-at-coulter/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Park at Coulter?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The pet rent is $30 per pet per month, and there&#8217;s a one-time non-refundable fee of $500 per pet.</p>"
      }
    }
  },
  "apartments/tx/amarillo/remington-amarillo-apts/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Remington?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">A maximum of two pets are allowed per household with a maximum of 80 pounds per pet. The monthly pet rent is $30 per pet along with a one-time $500 fee. The one-time fee is non-refundable.</p>"
      }
    }
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Colonies at Hillside?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The pet policy at Colonies at Hillside Apartments allows for up to two pets per household with a $30 monthly rent per pet. On top of that, there is also a one-time, non-refundable fee of $500. </p>"
      }
    }
  },
  "apartments/tx/amarillo/winchester-apartments/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Winchester Apartments?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">At Winchester Apartments, residents can have up to two pets, each weighing a maximum of 40 pounds, but certain breed restrictions apply. The monthly pet rent is $25 per pet, and there is a one-time, non-refundable fee of $500 per pet.<br></p>"
      }
    }
  },
  "apartments/tx/el-paso/acacia-park-apts/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Acadia Park?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our pet policy allows up to two pets per household with a $25 monthly rent per pet. There’s also a one-time, non-refundable fee on your arrival. The conditions to the fee are as follows:<br><br>1 to 25 pounds: $400 non-refundable fee per pet<br>26 to 40 pounds: $500 non-refundable fee per pet<br>41 to 80 pounds: $600 non-refundable fee per pet</p>"
      }
    }
  },
  "apartments/tx/el-paso/chimneys-apts/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at The Chimneys?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our pet policy welcomes up to two pets per household, with a weight limit of up to 80 pounds per pet. There is a monthly pet rent of $30 for each pet. Additionally, a non-refundable fee is required for each pet, with the amount depending on the pet&#8217;s weight: $400 for pets up to 40 pounds and $500 for pets up to 80 pounds.</p>"
      }
    }
  },
  "apartments/tx/el-paso/double-tree-apts/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Double Tree?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">With certain breed restrictions, our pet policy allows for cats and dogs along with a maximum of two pets per household. The monthly pet rent is $25 per pet. On top of that, there is a one-time non-refundable pet fee. The fee is $400 per pet 1 to 25 pounds and $500 per pet 26 to 40 pounds.</p>"
      }
    }
  },
  "apartments/tx/el-paso/high-ridge-apts/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at High Ridge?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our pet policy allows for up to two pets with cats and dogs allowed within breed restrictions. Along with a monthly pet rent of $25 per pet, there is a one-time, non-refundable pet fee which goes by the following standards:<br><br>1 to 25 pounds: $400 non-refundable fee per pet<br>26 to 40 pounds: $500 non-refundable fee per pet<br>41 to 80 pounds: $600 non-refundable fee per pet</p>"
      }
    }
  },
  "apartments/tx/el-paso/mountain-village-apts/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Mountain Village?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">With certain breed restrictions, our pet policy at Mountain Village Apartments allows for up to two pets per household. Pet rent per month is $30 per pet along with a one-time and non-refundable fee. This fee is $400 per pet up to 40 pounds or $500 per pet 41 to 80 pounds in weight.</p>"
      }
    }
  },
  "apartments/tx/el-paso/patriot-apts/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at The Patriot?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our pet-friendly policy welcomes both dogs and cats, with a limit of two pets per residence. We do have breed restrictions in place to ensure the safety and comfort of all our residents. The non-refundable pet deposit varies depending on the weight of your pet: $400 for pets weighing 1-25 pounds, $500 for those between 26-40 pounds, and $600 for pets ranging from 41-80 pounds. Additionally, a monthly pet rent of $25 per pet is required to accommodate your furry friends comfortably.</p>"
      }
    }
  },
  "apartments/tx/el-paso/phoenix-apts/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at The Phoenix?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We welcome both dogs and cats within our community, adhering to a two-pet limit per household. However, it&#8217;s important to note that we do have certain breed restrictions in place. The non-refundable deposit for your pets varies depending on their weight, with $400 for those ranging from 1-25 pounds, $500 for pets weighing 26-40 pounds, and $600 for the larger pets between 41-80 pounds. Additionally, there is a monthly pet rent of $25 per pet to ensure all our furry residents are comfortable and well-cared for.</p>"
      }
    }
  },
  "apartments/tx/el-paso/shadow-ridge-apts/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Shadow Ridge?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our pet policy allows for up to two pets per residence, with a maximum weight limit of 80 pounds for each pet. A monthly pet rent of $30 is applicable for each pet. For pets weighing up to 40 pounds, a non-refundable fee of $400 is required per pet. For pets weighing between 41 and 80 pounds, the non-refundable fee increases to $500 per pet.</p>"
      }
    }
  },
  "apartments/tx/el-paso/the-crest/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at The Crest?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">At The Crest Apartments, we welcome your furry friends with a pet policy designed to accommodate your needs. Residents are permitted to have up to two pets, with a maximum weight limit of 80 pounds per pet. To ensure the comfort and well-being of all our residents, a monthly pet rent of $30 is required for each pet. Additionally, a non-refundable deposit is necessary for each pet, amounting to $400 for pets up to 40 pounds and $500 for those up to 80 pounds. It&#8217;s important to note that service animals are not classified as pets at The Crest Apartments, and therefore, no pet fees or rent will be charged for them.</p>"
      }
    }
  },
  "apartments/tx/hewitt/icon-at-hewitt/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Icon at Hewitt?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">A maximum of two pets are allowed, subject to breed restrictions, with each pet weighing no more than 80 pounds. Pet rent is $30 per pet per month, and there&#8217;s a non-refundable fee of $500 for pets weighing between 41 and 80 pounds.</p>"
      }
    }
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Cottages at Abbey Glen?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Allowing pets up to 75 pounds, we offer a home for up to two pets per household. There is a $30 monthly pet rent per pet and a one-time $500 fee. This fee is not refundable.</p>"
      }
    }
  },
  "apartments/tx/lubbock/icon-at-lubbock/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Icon at Lubbock?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">There&#8217;s a limit of two pets, each weighing no more than 40 pounds. Pet rent is $30 per pet per month, with a non-refundable fee of $500 per pet.</p>"
      }
    }
  },
  "apartments/tx/lubbock/tuscany-place/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Tuscany Place?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">At Tuscany Place Apartments, we allow up to two pets per apartment home with a maximum weight of 70 pounds per pet. Certain breed restrictions do apply. The monthly pet rent is $30 per pet. Along with that, there is a one-time and non-refundable fee of $500.</p>"
      }
    }
  },
  "apartments/tx/temple/portico-at-friars-creek-apts/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Portico at Friar’s Creek?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">At Portico at Friar’s Creek, our pet policy allows residents to house up to two pets up to 80 pounds in weight per apartment home. There is not only a $30 monthly pet rent per pet but a $500 one-time, non-refundable deposit per pet between 41 and 80 pounds.</p>"
      }
    }
  },
  "apartments/tx/waco/bend-at-new-road/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Bend at New Road?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">With certain breed restrictions, our Waco apartments allow for up to two pets per household. The maximum weight per pet is 80 pounds. There is a $30 monthly pet rent per pet and a $500 deposit per pet up to 80 pounds. This one-time fee is not refundable.</p>"
      }
    }
  },
  "apartments/tx/waco/tuscany-ranch-apartments/contact-us::contactform.faq_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Tuscany Ranch?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our pet policy at Tuscany Ranch allows up to two pets per apartment home with certain breed restrictions. The maximum allowed weight per pet is 80 pounds. The monthly pet rent is $30 per pet. On top of that, there is a one-time $500 deposit per pet between 41 and 80 pounds. This fee is non-refundable.</p>"
      }
    }
  },
  "ctasection.promo_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apartments"
      },
      "label": {
        "type": "VALUE",
        "customValue": "Check out our new communities at 152 Northland and West 530!"
      }
    }
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/floor-plans::floorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "answer": {
        "type": "FIELD_MAPPING",
        "mappedField": ""
      }
    }
  },
  "apartments/mo/belton/center-301::pagehero.furnished_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "cta_url": {
        "type": "VALUE",
        "customValue": "https://linkprotect.cudasvc.com/url?a=https%3a%2f%2fwww.hellolanding.com%2fproperties%2fcenter-301&c=E,1,IijIID7dh5ST26lzdDDS6KhlBRZwbtYcuzdHGDEzq5kVk9vOUZ_EMjB1A2EJJ31QjG34KSj3zWhS_SUNYc_v758h9ZeDtltRMQnvPV401tcTo_3sIka_&typo=1"
      }
    }
  },
  "apartments/ok/broken-arrow/park-at-mission-hills::pagehero.furnished_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "cta_url": {
        "type": "VALUE",
        "customValue": "https://linkprotect.cudasvc.com/url?a=https%3a%2f%2fwww.hellolanding.com%2fproperties%2fpark-at-mission-hills-9e0336e0-7c57-46f4-9154-f1920c12d14b&c=E,1,19Ad2zfacwHkPo5tR1zIK7_KrIug87tMM36cbUpRmASwLtmTm2EzMg3qEipQatzjDP1fIUihqybsdvabymXIAa1O8EhiFliQBzfyQZJhIa2BKhCePv8Owg,,&typo=1"
      }
    }
  },
  "apartments/ok/broken-arrow/redbud-ranch::pagehero.furnished_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "cta_url": {
        "type": "VALUE",
        "customValue": "https://linkprotect.cudasvc.com/url?a=https%3a%2f%2fwww.hellolanding.com%2fproperties%2fredbud-ranch-57a8d885-d2c6-4729-b109-f74cd9ba7dee&c=E,1,JGpcGG8JWLK3z6jlKNwYgP1XHj6_EZnqZcnRvI9P9rAt6gaqHmlY5wzH2pjy30s8SCbAV3s0hNtUaP6rwD62mjkg204OjlxFUxJp0EURm703V8xL7prPG1EXnYU,&typo=1"
      }
    }
  },
  "apartments/ok/broken-arrow/scissortail-crossing::pagehero.furnished_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "cta_url": {
        "type": "VALUE",
        "customValue": "https://linkprotect.cudasvc.com/url?a=https%3a%2f%2fwww.hellolanding.com%2fproperties%2fscissortail-crossing-8b85d65a-a826-41dc-9cb2-42d72d97d35d&c=E,1,yH6RQqHQ4w6cVDG1sIwIqgIplF8NrIzpDUsIq-D4NgK36i2md7cdRxXIlSnU36vuDuFv9ssDoHSy6u9bpva83oPPaXjjJkGi1drJJaP2&typo=1"
      }
    }
  },
  "apartments/ok/edmond/villas-at-stonebridge::pagehero.furnished_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "cta_url": {
        "type": "VALUE",
        "customValue": "https://www.hellolanding.com/properties/villas-at-stonebridge"
      }
    }
  },
  "apartments/ok/jenks/the-reserve-at-elm::pagehero.furnished_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "cta_url": {
        "type": "VALUE",
        "customValue": "https://linkprotect.cudasvc.com/url?a=https%3a%2f%2fwww.hellolanding.com%2fproperties%2fthe-reserve-at-elm-36559d17-7aec-46f5-a32d-ffef5f726d5b&c=E,1,GFxec9Lokvep1UU8NQiVq8maWjVn3DdZwmSjN9Z2Q1IhrXcBqTtG5bax5uWT6tfVliLLsi4pm-4ouBHEGND2iUvlh5lSRoRZZ30JXxos&typo=1"
      }
    }
  },
  "apartments/ok/moore/mission-point::pagehero.furnished_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "cta_url": {
        "type": "VALUE",
        "customValue": "https://linkprotect.cudasvc.com/url?a=https%3a%2f%2fwww.hellolanding.com%2fproperties%2fmission-point-apartments&c=E,1,kVsreevjNR6iuSZ-Z87S7Of-GiNF1vRDn2NXor5Z-y4G9atWFDXbZzYydkXSMX2zp7fTsv5d60WYgXNOFAhlA8fZJlD3IWq__HhoI5oKv-mTH3uEnzrh&typo=1"
      }
    }
  },
  "apartments/ok/oklahoma-city/park-at-tuscany::pagehero.furnished_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "cta_url": {
        "type": "VALUE",
        "customValue": "https://linkprotect.cudasvc.com/url?a=https%3a%2f%2fwww.hellolanding.com%2fproperties%2fpark-at-tuscany&c=E,1,S_hlqZh6IiUb8ekr13xL4bNFlcJ65r-G9MEWPz0uWIhEUVDktRWc5Oub8qessL7P-yGWj-mmi9ufhIRB6B9hUh1twxnUjFjbEx7tE_mxpdYRg5Z1xkGF&typo=1"
      }
    }
  },
  "apartments/ok/oklahoma-city/stonehorse-crossing::pagehero.furnished_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "cta_url": {
        "type": "VALUE",
        "customValue": "https://linkprotect.cudasvc.com/url?a=https%3a%2f%2fwww.hellolanding.com%2fproperties%2fstonehorse-crossing&c=E,1,Q-GB-BG_Rh2PvnTzX2ZhNAJ6xYgO7wRbVs-f-i6KHxS0j14mBQb_yalM3zBN93mWIoRLVvkDiKnb07u_xJVoZfrB3ixKwZIB9QRnHYX20xqEdSr0PiI,&typo=1"
      }
    }
  },
  "apartments/ok/yukon/the-ridge-66::pagehero.furnished_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "cta_url": {
        "type": "VALUE",
        "customValue": "https://linkprotect.cudasvc.com/url?a=https%3a%2f%2fwww.hellolanding.com%2fproperties%2fridge-at-66&c=E,1,A8SzF21gnlk8Cq0NRAKT2nTosKyw6Vn0568Sf0ylUyKtMC0iHZxkd2YG35CJfkXyeg5MSxgmGsHfpD65_P8Vq61SG7bkUz1aUqNfjY5Q&typo=1"
      }
    }
  },
  "apartments/ar/north-little-rock/lexington-park/pet-policy::petpolicy.pet_image": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "apartments/ks/wichita/aspen-park-apartments/pet-policy::petpolicy.pet_image": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "apartments/ks/wichita/cottages-at-crestview/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a1897b-6301-7381-aa12-3568cb7a6aef.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dog park with agility equipment and picnic benches outside apartment buildings."
      }
    }
  },
  "apartments/ks/wichita/huntington-park/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166545/019cfb4e-e10d-742d-af8b-d74b55a3591d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of the apartment building with a bridge and landscaping."
      }
    }
  },
  "apartments/ks/wichita/portofino/pet-policy::petpolicy.pet_image": {
    "sourceIndex": 36,
    "fieldOverrides": null
  },
  "apartments/ks/wichita/villas-of-waterford/pet-policy::petpolicy.pet_image": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "apartments/mo/belton/center-301/pet-policy::petpolicy.pet_image": {
    "sourceIndex": 32,
    "fieldOverrides": null
  },
  "apartments/mo/independence/the-adirondack/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165632/019e1da5-991b-744a-9f3d-4caacec6ab44.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "The Adirondack Apartments monument sign with a gated entrance and buildings in the background."
      }
    }
  },
  "apartments/mo/kansas-city/152-northland/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3ced-a3fb-77fd-9830-0874a3ad51c1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment complex with a large swimming pool and lounge chairs."
      }
    }
  },
  "apartments/mo/kansas-city/97-north-oak/pet-policy::petpolicy.pet_image": {
    "sourceIndex": 43,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-7f03-76c8-8be0-d4707c1c36c3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious dog park with agility equipment and seating area."
      }
    }
  },
  "apartments/ok/broken-arrow/park-at-mission-hills/pet-policy::petpolicy.pet_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4c-3517-757f-a8f0-f368fd3a6c8f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Trails & Tails Pet Friendly Park with a red tunnel and bench, next to apartment buildings."
      }
    }
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4f9-c2a7-71af-88f8-f94a6102f72e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dog park with agility equipment including ramps, tunnels, and weave poles."
      }
    }
  },
  "apartments/ok/edmond/villas-at-stonebridge/pet-policy::petpolicy.pet_image": {
    "sourceIndex": 25,
    "fieldOverrides": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/pet-policy::petpolicy.pet_image": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "apartments/ok/norman/artisan-crossing-apts/pet-policy::petpolicy.pet_image": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "apartments/ok/norman/cimarron-trails-apts/pet-policy::petpolicy.pet_image": {
    "sourceIndex": 5,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06276-a227-745f-80e2-fe8b875b5343.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment buildings with well-maintained courtyards and walking paths."
      }
    }
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/pet-policy::petpolicy.pet_image": {
    "sourceIndex": 31,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/pet-policy::petpolicy.pet_image": {
    "sourceIndex": 29,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/019cfb3d-dda2-755d-8798-5ff313a4f557.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of an apartment building with a red tile roof."
      }
    }
  },
  "apartments/ok/oklahoma-city/cross-timber/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/01a03eb6-450b-728f-834c-fd8695086361.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Welcome to Barking Timbers pet-friendly park with agility equipment."
      }
    }
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08676-1ae4-70a6-bac0-2324e1a032e1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Winding sidewalk through a grassy courtyard with apartment buildings in the background."
      }
    }
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d7-f634-7002-99f9-d35bb2861ff4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dog park with agility equipment and apartment buildings in the background."
      }
    }
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments/pet-policy::petpolicy.pet_image": {
    "sourceIndex": 10,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d571e-ef30-7369-9936-b5dec720dcb6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Community dog park with agility equipment and benches."
      }
    }
  },
  "apartments/ok/owasso/coffee-creek/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019d270e-04aa-7622-a7b3-1479b4d4dc0c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious dog park with agility equipment including red jumping horses, a red tunnel, and a blue agility table."
      }
    }
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/01a13590-9798-7178-9873-85e1efe8ec09.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dog park with agility equipment, benches, and a seesaw."
      }
    }
  },
  "apartments/ok/owasso/cypress-crossing/pet-policy::petpolicy.pet_image": {
    "sourceIndex": 5,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019d48df-688a-71f3-9e93-163bb72ac028.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a modern apartment complex with multiple buildings and surrounding green space."
      }
    }
  },
  "apartments/ok/pryor/west-530/pet-policy::petpolicy.pet_image": {
    "sourceIndex": 39,
    "fieldOverrides": null
  },
  "apartments/ok/stillwater/apple-creek-stillwater/pet-policy::petpolicy.pet_image": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/barrington-apartments/pet-policy::petpolicy.pet_image": {
    "sourceIndex": 34,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cascata-luxury-apartments/pet-policy::petpolicy.pet_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cedar-glade-apts/pet-policy::petpolicy.pet_image": {
    "sourceIndex": 23,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-f225-701c-a4c1-932f56345bd3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a multifamily property with multiple buildings, parking lots, and landscaping."
      }
    }
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3b-4454-729d-9dfa-4ca878915cfe.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment community dog park with agility equipment"
      }
    }
  },
  "apartments/ok/tulsa/chardonnay/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d07dc-2937-70bb-bc03-dd9e02416e49.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A dog park with agility equipment and a tunnel under a bright blue sky."
      }
    }
  },
  "apartments/ok/tulsa/country-hollow-apartments/pet-policy::petpolicy.pet_image": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/creekwood-apartments/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1948-fb7b-771b-b7be-5f7f4d957156.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Grassy pet park with agility equipment including a red tunnel and jumps, a red bench, and a pet waste station."
      }
    }
  },
  "apartments/ok/tulsa/nickel-creek-apts/pet-policy::petpolicy.pet_image": {
    "sourceIndex": 32,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db131-cbad-74ff-a01b-d0dbb3391536.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of apartment buildings with a paved walkway and manicured lawn."
      }
    }
  },
  "apartments/ok/tulsa/polo-run-apartments/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a2-44a9-72a3-b2ac-e25c15c2e391.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior of apartment buildings with balconies and brick accents."
      }
    }
  },
  "apartments/ok/tulsa/sheridan-pond/pet-policy::petpolicy.pet_image": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/sugarberry-apartments/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a015fd-bae2-736f-8fae-9d2f04d72ab8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment community pool with lounge chairs and surrounding buildings and trees."
      }
    }
  },
  "apartments/ok/tulsa/sunchase-apartments/pet-policy::petpolicy.pet_image": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/the-courtyards/pet-policy::petpolicy.pet_image": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-3553-734b-be57-166cbdb7a33f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A fenced-in dog park with agility equipment, red tunnel, and benches."
      }
    }
  },
  "apartments/ok/tulsa/windsail-apartments/pet-policy::petpolicy.pet_image": {
    "sourceIndex": 15,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019dd090-2fd0-73af-925e-b4f722110f5a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Pet grooming station with sinks and dryers, featuring fun wall art."
      }
    }
  },
  "apartments/ok/yukon/park-at-westpointe/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c1-6032-73ee-ae9b-6d32901e16d4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dog park with agility equipment and apartment buildings in the background."
      }
    }
  },
  "apartments/ok/yukon/the-ridge-66/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f1930-4d32-7229-8d05-774cfd8f933a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dog park with agility equipment and benches, with apartment buildings in the background."
      }
    }
  },
  "apartments/tx/amarillo/newport-amarillo-apts/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf6-e540-71ab-a247-a027a2a8d55c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dog park with agility equipment including tunnels and hoops."
      }
    }
  },
  "apartments/tx/amarillo/park-at-coulter/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc4-45e7-72ed-8dc5-917becdad4a2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dog park with fence and signage."
      }
    }
  },
  "apartments/tx/amarillo/remington-amarillo-apts/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df4-4e9d-7114-85ae-1ff3e4a7d234.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Canine Creek Pet Friendly Park sign with apartment buildings and playground equipment."
      }
    }
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/01a0e997-7d16-7558-b1c0-25958f780f8c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor grilling area with two large barbecues and picnic tables."
      }
    }
  },
  "apartments/tx/amarillo/winchester-apartments/pet-policy::petpolicy.pet_image": {
    "sourceIndex": 26,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/01a117a3-8ec6-719a-925a-10f4eef2d51a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Walkway leading to picnic area with grills and seating between apartment buildings."
      }
    }
  },
  "apartments/tx/el-paso/acacia-park-apts/pet-policy::petpolicy.pet_image": {
    "sourceIndex": 2,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/chimneys-apts/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611c-0c3e-7780-9654-49c8e161edf5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor dog park area with wooden fencing, benches, and green grass."
      }
    }
  },
  "apartments/tx/el-paso/high-ridge-apts/pet-policy::petpolicy.pet_image": {
    "sourceIndex": 16,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/01a0a195-c480-778d-a833-5b273487b5a5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment buildings with mature trees and manicured lawns."
      }
    }
  },
  "apartments/tx/el-paso/phoenix-apts/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/019cfb54-86e9-713a-88bc-bfee2cf97402.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "The Phoenix apartment complex monument sign with a bird emblem."
      }
    }
  },
  "apartments/tx/el-paso/the-crest/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb52-c547-75d3-9348-80287848d9a4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Community dog park with agility equipment, a blue tunnel, and a shaded seating area."
      }
    }
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a0e9d7-00b2-765a-af02-b06e9e43ad5f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fenced dog park with agility equipment and a red bench with 'BARK PARK' inscription."
      }
    }
  },
  "apartments/tx/lubbock/icon-at-lubbock/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda5-6d24-7530-ad7d-ab2a3618ce5a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A fenced-in dog park area with agility equipment and a bench."
      }
    }
  },
  "apartments/tx/lubbock/tuscany-place/pet-policy::petpolicy.pet_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2e-c4f2-7698-9028-3ed5b7e1caa5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dog park with agility equipment, benches, and grass area."
      }
    }
  },
  "apartments/tx/waco/bend-at-new-road/pet-policy::petpolicy.pet_image": {
    "sourceIndex": 9,
    "fieldOverrides": null
  },
  "apartments/ks/maize/watercress-apartments::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ee-7482-7199-8ab5-14be86410fc0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and apartment buildings in the background."
      }
    }
  },
  "apartments/ks/wichita/aspen-park-apartments::propertyamenities.photo_0": {
    "sourceIndex": 18,
    "fieldOverrides": null
  },
  "apartments/ks/wichita/cottages-at-crestview::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a18979-76bc-7408-be29-5f71e74ff8fc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Swimming pool and lounge chairs at apartment complex."
      }
    }
  },
  "apartments/ks/wichita/huntington-park::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166545/019cfb4e-5b17-77fb-91ae-6a0be2f681c2.webp"
      }
    }
  },
  "apartments/ks/wichita/villas-of-waterford::propertyamenities.photo_0": {
    "sourceIndex": 30,
    "fieldOverrides": null
  },
  "apartments/mo/belton/center-301::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431e-581b-7689-8e86-e6bf176b5454.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool with lounge chairs and apartment buildings in the background."
      }
    }
  },
  "apartments/mo/independence/the-adirondack::propertyamenities.photo_0": {
    "sourceIndex": 39,
    "fieldOverrides": null
  },
  "apartments/mo/kansas-city/152-northland::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3ced-0b91-74ca-8c6c-51d53e2fdecb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Gym with treadmills, weight machines, and a bench."
      }
    }
  },
  "apartments/mo/kansas-city/97-@-north-oak::propertyamenities.photo_0": {
    "sourceIndex": 6,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb38-9d1c-742b-9001-4a3d8180a3fe.webp"
      }
    }
  },
  "apartments/mo/kansas-city/97-north-oak::propertyamenities.photo_0": {
    "sourceIndex": 34,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-8003-76a0-a21a-aa6facd1fbfc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and apartment buildings in the background."
      }
    }
  },
  "apartments/ok/broken-arrow/redbud-ranch::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa537-7a77-7611-bdf8-1edd9c373359.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings."
      }
    }
  },
  "apartments/ok/broken-arrow/scissortail-crossing::propertyamenities.photo_0": {
    "sourceIndex": 10,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4f9-96c5-74be-9db1-f4af01324834.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings."
      }
    }
  },
  "apartments/ok/edmond/villas-at-stonebridge::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c1c-8e01-7331-82ee-de6a5289dbcc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool with lounge chairs and apartment buildings in the background."
      }
    }
  },
  "apartments/ok/jenks/the-reserve-at-elm::propertyamenities.photo_0": {
    "sourceIndex": 4,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-d539-7529-b649-f03d41f23d7c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and apartment buildings in the background."
      }
    }
  },
  "apartments/ok/norman/artisan-crossing-apts::propertyamenities.photo_0": {
    "sourceIndex": 10,
    "fieldOverrides": null
  },
  "apartments/ok/norman/cimarron-trails-apts::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06276-e331-776a-9a99-4ec8e989f273.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs at an apartment complex."
      }
    }
  },
  "apartments/ok/oklahoma-city/24hundred-apartments::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db713-162d-7093-9142-dfdb98a09990.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Welcome to 24 Unleashed pet friendly park sign with apartment buildings in the background."
      }
    }
  },
  "apartments/ok/oklahoma-city/chisholm-pointe::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70cf-db0d-77bf-8b31-cef77799c8ca.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Sparkling blue swimming pool with lounge chairs and a building with an overhang."
      }
    }
  },
  "apartments/ok/oklahoma-city/council-place-apartments::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/01a183b2-b464-738d-b713-c62d345cf6fd.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style outdoor swimming pool with blue lounge chairs and tables."
      }
    }
  },
  "apartments/ok/oklahoma-city/cross-timber::propertyamenities.photo_0": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments::propertyamenities.photo_0": {
    "sourceIndex": 2,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/01a08180-e52a-729d-ac84-7a4baabad227.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment building exterior with a courtyard pool and fountain feature."
      }
    }
  },
  "apartments/ok/oklahoma-city/prairie-springs-i::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d7-f16a-7430-b4c2-ac529c77e870.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment buildings with a pond and fountain in front."
      }
    }
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4d-c3e3-77b4-b2f2-755196cddc29.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Swimming pool with lounge chairs and umbrellas"
      }
    }
  },
  "apartments/ok/oklahoma-city/zeal-at-quail::propertyamenities.photo_0": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "apartments/ok/owasso/coffee-creek::propertyamenities.photo_0": {
    "sourceIndex": 27,
    "fieldOverrides": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/01a1358e-b2b2-734e-aa68-ac639dfdcf14.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and umbrellas outside apartment buildings."
      }
    }
  },
  "apartments/ok/owasso/cypress-crossing::propertyamenities.photo_0": {
    "sourceIndex": 60,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019e2196-8e06-77cd-8122-1e222e97fe2c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cypress Crossing community room with pool table and TVs"
      }
    }
  },
  "apartments/ok/pryor/west-530::propertyamenities.photo_0": {
    "sourceIndex": 30,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/barrington-apartments::propertyamenities.photo_0": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cascata-luxury-apartments::propertyamenities.photo_0": {
    "sourceIndex": 2,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cedar-glade-apts::propertyamenities.photo_0": {
    "sourceIndex": 16,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b9-ea5e-765a-aac0-d8d65096a269.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool and cabana area with lounge chairs at Cedar Ridge apartments."
      }
    }
  },
  "apartments/ok/tulsa/country-hollow-apartments::propertyamenities.photo_0": {
    "sourceIndex": 2,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/creekwood-apartments::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f193f-f01c-757f-b41c-18b4ad7af310.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Indoor swimming pool area with seating and large windows"
      }
    }
  },
  "apartments/ok/tulsa/polo-run-apartments::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a2-66eb-734c-a07b-8ae0b22a49b7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool with lounge chairs and a covered seating area."
      }
    }
  },
  "apartments/ok/tulsa/sheridan-pond::propertyamenities.photo_0": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/sugarberry-apartments::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/019cfb48-0cf5-73af-a2b7-9322a35ef2c1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool with lounge chairs and trees."
      }
    }
  },
  "apartments/ok/tulsa/sunchase-apartments::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019fb44b-c5c8-74cc-b2e5-70da7b7aa7e6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of apartment buildings with surrounding parking lots and commercial areas."
      }
    }
  },
  "apartments/ok/tulsa/the-courtyards::propertyamenities.photo_0": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-2b65-776c-a90b-2b0e5e2570c3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Sparkling blue swimming pool with lounge chairs and umbrellas under a bright blue sky."
      }
    }
  },
  "apartments/ok/tulsa/windsail-apartments::propertyamenities.photo_0": {
    "sourceIndex": 21,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fed5d-0012-7581-897a-0eb4e271bcd7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Sparkling swimming pool with lounge chairs and a large weeping willow tree next to apartment buildings."
      }
    }
  },
  "apartments/ok/yukon/park-at-westpointe::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c1-fbba-75eb-bad1-99948a050bf3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Community lounge area with fireplace, seating, and large windows overlooking the pool."
      }
    }
  },
  "apartments/ok/yukon/the-ridge-66::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019cfb4b-716c-7529-b54a-8313c4c0d3b2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with in-water loungers and a cabana."
      }
    }
  },
  "apartments/tx/amarillo/newport-amarillo-apts::propertyamenities.photo_0": {
    "sourceIndex": 1,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf7-feb6-7699-95d7-294746447889.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool with lounge chairs and a picnic table under an umbrella."
      }
    }
  },
  "apartments/tx/amarillo/park-at-coulter::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc5-3117-7663-a3e2-c681f2f42898.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Interior of a well-equipped fitness center with treadmills, weight machines, and exercise balls."
      }
    }
  },
  "apartments/tx/amarillo/remington-amarillo-apts::propertyamenities.photo_0": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/01a0e997-80e4-765a-9aa9-171ec91f3b33.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Colonies @ Hillside monument sign with address 7550 Hillside Rd."
      }
    }
  },
  "apartments/tx/amarillo/winchester-apartments::propertyamenities.photo_0": {
    "sourceIndex": 30,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/01a117a3-73e2-7421-86e2-b2597e7aa214.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of apartment buildings with an American flag displayed."
      }
    }
  },
  "apartments/tx/el-paso/acacia-park-apts::propertyamenities.photo_0": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/chimneys-apts::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611c-15cb-7500-9938-c512b953af7a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Sparkling blue swimming pool and spa with fountains, lounge chairs, and apartment buildings in the background."
      }
    }
  },
  "apartments/tx/el-paso/double-tree-apts::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92e-2b9c-736e-8e60-ad2d37889c5d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of apartment building with landscaping and a red cube sign with Case & Associates logo."
      }
    }
  },
  "apartments/tx/el-paso/high-ridge-apts::propertyamenities.photo_0": {
    "sourceIndex": 13,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/01a0a195-c1cc-70ea-ab8d-38276f6c3fef.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment complex outdoor swimming pool with lounge chairs and umbrellas."
      }
    }
  },
  "apartments/tx/el-paso/phoenix-apts::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/01a0a16b-6653-710d-b066-26f8ee545d4d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Playground and basketball court area outside apartment buildings."
      }
    }
  },
  "apartments/tx/el-paso/shadow-ridge-apts::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-0448-7369-b106-f37aa20ab897.webp"
      }
    }
  },
  "apartments/tx/el-paso/the-crest::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd5-3bbf-774f-ab6a-764f04e75198.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool with lounge chairs and palm trees"
      }
    }
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a0e9d7-66b3-73a9-81e5-e0042427e4b8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment complex pool with lounge chairs and umbrellas"
      }
    }
  },
  "apartments/tx/waco/bend-at-new-road::propertyamenities.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd7c-89e2-747a-a682-1a7fa4599172.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Gym with treadmills, elliptical, and recumbent bike."
      }
    }
  },
  "apartments/ks/maize/watercress-apartments::propertyamenities.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ef-6f42-778a-a1f5-721b6ec79e3f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor patio with picnic tables, grills, and a fireplace."
      }
    }
  },
  "apartments/ks/wichita/aspen-park-apartments::propertyamenities.photo_1": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "apartments/ks/wichita/cottages-at-crestview::propertyamenities.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a18979-66f6-7407-82c6-402642f0964d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor grilling area with picnic tables and umbrellas."
      }
    }
  },
  "apartments/ks/wichita/huntington-park::propertyamenities.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166545/019cfb4e-57bd-73a4-8eb0-4497fe98df5e.webp"
      }
    }
  },
  "apartments/mo/belton/center-301::propertyamenities.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431e-c5c8-719b-a4cb-97f7ea0cd79c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A fenced-in dog park area with play structures, a bench, and apartment buildings in the background."
      }
    }
  },
  "apartments/mo/independence/the-adirondack::propertyamenities.photo_1": {
    "sourceIndex": 38,
    "fieldOverrides": null
  },
  "apartments/mo/kansas-city/152-northland::propertyamenities.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cec-5f3b-703b-a05f-3e66d9f82882.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A swimming pool with lounge chairs and apartment buildings in the background."
      }
    }
  },
  "apartments/mo/kansas-city/97-north-oak::propertyamenities.photo_1": {
    "sourceIndex": 47,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments::propertyamenities.photo_1": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/redbud-ranch::propertyamenities.photo_1": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park::propertyamenities.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4f9-d539-74cc-90f8-06aeba317274.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Gym with treadmills, weight machines, free weights, and exercise balls."
      }
    }
  },
  "apartments/ok/edmond/villas-at-stonebridge::propertyamenities.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c1c-8c25-73f5-9773-7ba28250d13c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Gym with treadmills, weight machines, and dumbbells"
      }
    }
  },
  "apartments/ok/jenks/the-reserve-at-elm::propertyamenities.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-7a31-77bc-bd4b-a1dc2dc4d09c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment community dog park with agility equipment and seating."
      }
    }
  },
  "apartments/ok/norman/cimarron-trails-apts::propertyamenities.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d593f-fb00-7635-a0e7-b2fc093e7671.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor grilling station with two grills, a fireplace, and seating areas."
      }
    }
  },
  "apartments/ok/oklahoma-city/24hundred-apartments::propertyamenities.photo_1": {
    "sourceIndex": 0,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db712-fc5b-76b1-bfe5-b375ad4ee20a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with treadmills, ellipticals, weight racks, and a bench."
      }
    }
  },
  "apartments/ok/oklahoma-city/chisholm-pointe::propertyamenities.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70cf-7507-74e0-bb5f-7bb7d5cff954.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor sports court with pickleball lines and a net, adjacent to a pool and community building."
      }
    }
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts::propertyamenities.photo_1": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments::propertyamenities.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/01a183b2-953e-71ec-8507-94adb306d37b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of a multifamily building with red tile roofs and stucco walls."
      }
    }
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments::propertyamenities.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08676-3984-7028-b650-51fbc10de58c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor grilling station with a stainless steel grill and a large stone fireplace, with a table and chairs under a blue umbrella."
      }
    }
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts::propertyamenities.photo_1": {
    "sourceIndex": 11,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/01a08182-887a-756d-aa62-1025822f0d74.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Laundry room with rows of washers and dryers."
      }
    }
  },
  "apartments/ok/oklahoma-city/prairie-springs-i::propertyamenities.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d7-f634-7002-99f9-d35bb2861ff4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dog park with agility equipment and apartment buildings in the background."
      }
    }
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments::propertyamenities.photo_1": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail::propertyamenities.photo_1": {
    "sourceIndex": 10,
    "fieldOverrides": null
  },
  "apartments/ok/owasso/coffee-creek::propertyamenities.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167036/019d270e-04aa-7622-a7b3-1479b4d4dc0c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious dog park with agility equipment including red jumping horses, a red tunnel, and a blue agility table."
      }
    }
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point::propertyamenities.photo_1": {
    "sourceIndex": 3,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/01a13590-9798-7178-9873-85e1efe8ec09.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dog park with agility equipment, benches, and a seesaw."
      }
    }
  },
  "apartments/ok/owasso/cypress-crossing::propertyamenities.photo_1": {
    "sourceIndex": 33,
    "fieldOverrides": null
  },
  "apartments/ok/pryor/west-530::propertyamenities.photo_1": {
    "sourceIndex": 28,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/barrington-apartments::propertyamenities.photo_1": {
    "sourceIndex": 34,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cedar-glade-apts::propertyamenities.photo_1": {
    "sourceIndex": 32,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments::propertyamenities.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70ae-2689-7089-b051-3c4902d5447d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Community lounge area with a pool table and shuffleboard."
      }
    }
  },
  "apartments/ok/tulsa/chardonnay::propertyamenities.photo_1": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/country-hollow-apartments::propertyamenities.photo_1": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/creekwood-apartments::propertyamenities.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1948-fb7b-771b-b7be-5f7f4d957156.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Grassy pet park with agility equipment including a red tunnel and jumps, a red bench, and a pet waste station."
      }
    }
  },
  "apartments/ok/tulsa/nickel-creek-apts::propertyamenities.photo_1": {
    "sourceIndex": 33,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/polo-run-apartments::propertyamenities.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165619/019fa4a6-40ec-73d5-8443-0237ee41898b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Lounge area with two sofas facing a fireplace and TV."
      }
    }
  },
  "apartments/ok/tulsa/sheridan-pond::propertyamenities.photo_1": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/sugarberry-apartments::propertyamenities.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a015fe-6c73-752e-b654-6a6c5add0c46.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Gym with treadmills, rowing machine, and ellipticals"
      }
    }
  },
  "apartments/ok/tulsa/sunchase-apartments::propertyamenities.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019fb44b-a977-706f-a16f-075070375b03.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A pristine swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and lush greenery."
      }
    }
  },
  "apartments/ok/tulsa/the-greens-of-bedford::propertyamenities.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-a57f-763f-9409-4217dca71a7b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Playground with slide and apartment buildings in the background"
      }
    }
  },
  "apartments/ok/tulsa/windsail-apartments::propertyamenities.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019dd090-2fd0-73af-925e-b4f722110f5a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Pet grooming station with sinks and dryers, featuring fun wall art."
      }
    }
  },
  "apartments/ok/yukon/park-at-westpointe::propertyamenities.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c1-a872-70a5-bec6-c1741373fd2b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Sparkling outdoor swimming pool with lounge chairs and seating areas, surrounded by apartment buildings."
      }
    }
  },
  "apartments/ok/yukon/the-ridge-66::propertyamenities.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f1930-4d32-7229-8d05-774cfd8f933a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dog park with agility equipment and benches, with apartment buildings in the background."
      }
    }
  },
  "apartments/tx/amarillo/newport-amarillo-apts::propertyamenities.photo_1": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "apartments/tx/amarillo/park-at-coulter::propertyamenities.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc4-4458-7558-9eb9-67481d64546b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor dog park with agility equipment including a tunnel, ramp, and jumping bars."
      }
    }
  },
  "apartments/tx/amarillo/remington-amarillo-apts::propertyamenities.photo_1": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "apartments/tx/amarillo/the-colonies-at-hillside::propertyamenities.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/01a0e997-61b1-7732-9312-dc5af41d36d1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Large swimming pool with lounge chairs and apartment buildings in the background."
      }
    }
  },
  "apartments/tx/amarillo/winchester-apartments::propertyamenities.photo_1": {
    "sourceIndex": 24,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/acacia-park-apts::propertyamenities.photo_1": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/chimneys-apts::propertyamenities.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611c-0c3e-7780-9654-49c8e161edf5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor dog park area with wooden fencing, benches, and green grass."
      }
    }
  },
  "apartments/tx/el-paso/double-tree-apts::propertyamenities.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92c-d22b-7051-99a9-b27f56fa5e01.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright blue outdoor swimming pool with lounge chairs and trees surrounding it."
      }
    }
  },
  "apartments/tx/el-paso/high-ridge-apts::propertyamenities.photo_1": {
    "sourceIndex": 33,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/phoenix-apts::propertyamenities.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/01a0a169-dee2-7181-a7ce-90ca259fb261.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Community pool with lounge chairs and umbrellas."
      }
    }
  },
  "apartments/tx/el-paso/shadow-ridge-apts::propertyamenities.photo_1": {
    "sourceIndex": 90,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb46-cff5-73de-aa9f-a0f60bdd3f33.webp"
      }
    }
  },
  "apartments/tx/el-paso/the-crest::propertyamenities.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd6-27c7-77f9-9489-c5018087e342.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor basketball court with hoops and fencing."
      }
    }
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen::propertyamenities.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a0e9d7-5798-77a9-a9eb-6f6800c3ab74.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor grilling area with picnic tables, umbrellas, fireplace, and grills by the swimming pool."
      }
    }
  },
  "apartments/tx/lubbock/icon-at-lubbock::propertyamenities.photo_1": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "apartments/tx/waco/bend-at-new-road::propertyamenities.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd79-3b6d-731b-96e1-ca65079c8bac.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Two outdoor grills with apartment buildings in the background."
      }
    }
  },
  "apartments/ks/maize/watercress-apartments::propertyamenities.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ef-e159-7617-b5e3-0cb599c9608a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "View from balcony of apartment complex pool area with lounge chairs and tables."
      }
    }
  },
  "apartments/ks/wichita/cottages-at-crestview::propertyamenities.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a1897b-6301-7381-aa12-3568cb7a6aef.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dog park with agility equipment and picnic benches outside apartment buildings."
      }
    }
  },
  "apartments/ks/wichita/huntington-park::propertyamenities.photo_2": {
    "sourceIndex": 19,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166545/019cfb4e-9f7a-7228-9ed1-d3be6a0d76a1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool and spa with lounge chairs and surrounding buildings."
      }
    }
  },
  "apartments/ks/wichita/portofino::propertyamenities.photo_2": {
    "sourceIndex": 49,
    "fieldOverrides": null
  },
  "apartments/ks/wichita/villas-of-waterford::propertyamenities.photo_2": {
    "sourceIndex": 18,
    "fieldOverrides": null
  },
  "apartments/mo/belton/center-301::propertyamenities.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431e-7113-71ab-a921-9b024804dfdb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor grilling area with two built-in grills and a picnic table, with apartment buildings in the background."
      }
    }
  },
  "apartments/mo/independence/the-adirondack::propertyamenities.photo_2": {
    "sourceIndex": 24,
    "fieldOverrides": null
  },
  "apartments/mo/kansas-city/152-northland::propertyamenities.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cec-7850-739b-8c5e-c01ded7bce5d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor seating area with a fire pit and pink chairs."
      }
    }
  },
  "apartments/mo/kansas-city/97-north-oak::propertyamenities.photo_2": {
    "sourceIndex": 48,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments::propertyamenities.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019faa55-d1b3-734b-a893-34d1adcf2cdb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Lobby seating area with green chairs and a fireplace."
      }
    }
  },
  "apartments/ok/broken-arrow/redbud-ranch::propertyamenities.photo_2": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing::propertyamenities.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-0c5b-7615-bfa3-8a5159e0601d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "View from a balcony overlooking a courtyard with apartment buildings and green lawns."
      }
    }
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park::propertyamenities.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4f9-c35f-76fd-bc2b-35956b60da4b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dog park with agility equipment including ramps and a tunnel."
      }
    }
  },
  "apartments/ok/edmond/villas-at-stonebridge::propertyamenities.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c14-e035-73ac-8cec-3dc0eb1b1050.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment buildings with balconies overlooking a lake on a sunny day."
      }
    }
  },
  "apartments/ok/jenks/the-reserve-at-elm::propertyamenities.photo_2": {
    "sourceIndex": 13,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc09-955f-72cc-b404-cc4a5c9bd1bc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "State-of-the-art fitness center with treadmills, ellipticals, and a recumbent bike, featuring a large mirrored wall and natural light."
      }
    }
  },
  "apartments/ok/norman/cimarron-trails-apts::propertyamenities.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06274-3b41-73eb-80d4-f489abc1fe02.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "View of apartment buildings and courtyard from a balcony."
      }
    }
  },
  "apartments/ok/oklahoma-city/chisholm-pointe::propertyamenities.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70cf-cb66-730c-98d4-c1c9f30495ed.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor grilling station with two stainless steel grills built into a brick counter."
      }
    }
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts::propertyamenities.photo_2": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments::propertyamenities.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/019cfb3d-f1bc-73cd-b5f3-3e6664e63c6a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Gym with treadmills, elliptical, and weight machine."
      }
    }
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments::propertyamenities.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08674-af76-763d-856f-f13512738c6d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with treadmills, elliptical, and free weights."
      }
    }
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts::propertyamenities.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/01a08182-132a-77ea-84ce-3ce9635d259b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Covered parking spaces with numbered stalls next to an apartment building."
      }
    }
  },
  "apartments/ok/oklahoma-city/prairie-springs-i::propertyamenities.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d7-78b9-768a-a589-dc7c804ee94c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Laundry room with stacked washers and dryers."
      }
    }
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments::propertyamenities.photo_2": {
    "sourceIndex": 20,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail::propertyamenities.photo_2": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "apartments/ok/owasso/coffee-creek::propertyamenities.photo_2": {
    "sourceIndex": 32,
    "fieldOverrides": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point::propertyamenities.photo_2": {
    "sourceIndex": 44,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/01a1358e-6ddb-709f-a46f-3630fb38d066.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern sculpture in front of apartment buildings and a swimming pool."
      }
    }
  },
  "apartments/ok/owasso/cypress-crossing::propertyamenities.photo_2": {
    "sourceIndex": 50,
    "fieldOverrides": null
  },
  "apartments/ok/pryor/west-530::propertyamenities.photo_2": {
    "sourceIndex": 34,
    "fieldOverrides": null
  },
  "apartments/ok/stillwater/apple-creek-stillwater::propertyamenities.photo_2": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/barrington-apartments::propertyamenities.photo_2": {
    "sourceIndex": 42,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cascata-luxury-apartments::propertyamenities.photo_2": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cedar-glade-apts::propertyamenities.photo_2": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments::propertyamenities.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70ad-ed66-7023-acde-a9b3bbced26d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with treadmills, elliptical, and stationary bike."
      }
    }
  },
  "apartments/ok/tulsa/chardonnay::propertyamenities.photo_2": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/country-hollow-apartments::propertyamenities.photo_2": {
    "sourceIndex": 0,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/creekwood-apartments::propertyamenities.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1948-ad4e-74c0-9c77-023c219a397b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Playground with slide and swings in front of apartment buildings."
      }
    }
  },
  "apartments/ok/tulsa/nickel-creek-apts::propertyamenities.photo_2": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/polo-run-apartments::propertyamenities.photo_2": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/sheridan-pond::propertyamenities.photo_2": {
    "sourceIndex": 9,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/sugarberry-apartments::propertyamenities.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a015fe-6323-70e9-a5b6-e2246b5ebd2b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Community coffee bar with green cabinets and a TV displaying a landscape image."
      }
    }
  },
  "apartments/ok/tulsa/sunchase-apartments::propertyamenities.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-5714-76f7-a7e7-03258dc9d961.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Indoor pool area with a wooden deck, seating, rock waterfall, and lush greenery."
      }
    }
  },
  "apartments/ok/tulsa/the-greens-of-bedford::propertyamenities.photo_2": {
    "sourceIndex": 24,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/windsail-apartments::propertyamenities.photo_2": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "apartments/ok/yukon/the-ridge-66::propertyamenities.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192f-43f1-72f7-8ce2-6b4e59faeab5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern apartment gym with exercise balls, weights, treadmills, and weight machines."
      }
    }
  },
  "apartments/tx/amarillo/newport-amarillo-apts::propertyamenities.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf6-e540-71ab-a247-a027a2a8d55c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dog park with agility equipment including tunnels and hoops."
      }
    }
  },
  "apartments/tx/amarillo/park-at-coulter::propertyamenities.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc4-45e7-72ed-8dc5-917becdad4a2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dog park with fence and signage."
      }
    }
  },
  "apartments/tx/amarillo/the-colonies-at-hillside::propertyamenities.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/01a0e997-0ab0-708d-8afe-13b6d8981768.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Treadmills, elliptical, and weight machine in a bright, well-lit fitness center."
      }
    }
  },
  "apartments/tx/amarillo/winchester-apartments::propertyamenities.photo_2": {
    "sourceIndex": 34,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/acacia-park-apts::propertyamenities.photo_2": {
    "sourceIndex": 31,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/chimneys-apts::propertyamenities.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611d-db2c-706c-8350-d26ec3143be2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Gym with treadmills, elliptical machines, and weight equipment."
      }
    }
  },
  "apartments/tx/el-paso/double-tree-apts::propertyamenities.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92c-c655-735b-be89-fd829892c760.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor seating area with lounge chairs and tables under a pergola near a stone wall."
      }
    }
  },
  "apartments/tx/el-paso/high-ridge-apts::propertyamenities.photo_2": {
    "sourceIndex": 34,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/phoenix-apts::propertyamenities.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/01a0a169-a75e-72aa-9cfd-6c272a3c885e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Community gym with cardio equipment including treadmills, ellipticals, and recumbent bikes."
      }
    }
  },
  "apartments/tx/el-paso/shadow-ridge-apts::propertyamenities.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb46-83ae-779a-a058-43b087e2ccb8.webp"
      }
    }
  },
  "apartments/tx/el-paso/the-crest::propertyamenities.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd5-2d5e-7478-b2f5-dcca142d3627.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dog park with agility equipment and pet waste station"
      }
    }
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen::propertyamenities.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a0e9d7-763b-734c-b607-d698744f3c88.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Covered patio with seating area overlooking a swimming pool."
      }
    }
  },
  "apartments/tx/lubbock/icon-at-lubbock::propertyamenities.photo_2": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "apartments/tx/lubbock/tuscany-place::propertyamenities.photo_2": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "apartments/tx/waco/bend-at-new-road::propertyamenities.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd77-0ab7-70ac-a9db-236893fa871d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool with lounge chairs and tables, adjacent to apartment buildings."
      }
    }
  },
  "apartments/ks/maize/watercress-apartments::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ef-633e-7140-94b9-ed0bdd462533.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with treadmills, stationary bike, weight rack, and multi-station gym equipment."
      }
    }
  },
  "apartments/ks/wichita/aspen-park-apartments::propertyamenities.photo_3": {
    "sourceIndex": 26,
    "fieldOverrides": null
  },
  "apartments/ks/wichita/cottages-at-crestview::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a18979-a34e-735b-9615-834d5eb00f28.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A well-equipped fitness center with treadmills, stair climbers, and weight machines."
      }
    }
  },
  "apartments/ks/wichita/huntington-park::propertyamenities.photo_3": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "apartments/mo/belton/center-301::propertyamenities.photo_3": {
    "sourceIndex": 22,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431e-51fb-72a3-98e6-d1748ed820ea.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Pool table and seating area in the community lounge."
      }
    }
  },
  "apartments/mo/independence/the-adirondack::propertyamenities.photo_3": {
    "sourceIndex": 49,
    "fieldOverrides": null
  },
  "apartments/mo/kansas-city/152-northland::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cec-682c-76e9-888e-7cb7a33874f7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor grilling station with picnic table and umbrella, apartment buildings in background."
      }
    }
  },
  "apartments/mo/kansas-city/97-@-north-oak::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019cfb36-f1dc-7014-8b72-0d41594b20ac.webp"
      }
    }
  },
  "apartments/mo/kansas-city/97-north-oak::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019db729-15c1-71e9-acd2-91b41ab8b548.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Game room with pool table, shuffleboard, and lounge area at Ninety-Seven @ North Oak"
      }
    }
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments::propertyamenities.photo_3": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills::propertyamenities.photo_3": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/redbud-ranch::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa537-73e8-72c8-951f-21bae753113e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern apartment building exterior with outdoor seating and fire pit."
      }
    }
  },
  "apartments/ok/broken-arrow/scissortail-crossing::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019cfb54-6611-70ae-90d3-6112c9629dee.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with weight machines, treadmills, and free weights."
      }
    }
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a34-0e00-76aa-9f83-88741d1b5c16.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Billiard table in community lounge with large windows overlooking a pool and outdoor area."
      }
    }
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4f9-7c7f-7729-8053-e9c9ffad2c40.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor gathering area with built-in grills and stone fireplace."
      }
    }
  },
  "apartments/ok/edmond/villas-at-stonebridge::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c14-d4dd-778e-9d19-68223b98991c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious dog park with agility equipment, benches, and lush green grass."
      }
    }
  },
  "apartments/ok/jenks/the-reserve-at-elm::propertyamenities.photo_3": {
    "sourceIndex": 20,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-40e6-734e-a3ae-4c3b59579f8c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor seating area with grill and picnic table near apartment buildings."
      }
    }
  },
  "apartments/ok/norman/artisan-crossing-apts::propertyamenities.photo_3": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/24hundred-apartments::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db713-1325-738b-a5ec-a380939daf6f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and umbrellas. Buildings and clubhouse in background."
      }
    }
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts::propertyamenities.photo_3": {
    "sourceIndex": 9,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/019cfb3d-e7c4-72c7-b061-a3304cfed2b2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Comfortable lounge area with plush seating, a modern fireplace, and a full-service bar with computers."
      }
    }
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08675-a1f0-70de-b001-bb782fcb052a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with white cabinets, wood trim, white stove, and microwave."
      }
    }
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts::propertyamenities.photo_3": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d7-d6a7-738e-8ad5-10610f9d2b7c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Gym with treadmills, ellipticals, free weights, and benches."
      }
    }
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4a-edc7-736e-b053-73a2aa09b93e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy living room with a large gray sectional sofa, armchair, wooden coffee table, and console table."
      }
    }
  },
  "apartments/ok/oklahoma-city/zeal-at-quail::propertyamenities.photo_3": {
    "sourceIndex": 42,
    "fieldOverrides": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point::propertyamenities.photo_3": {
    "sourceIndex": 12,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/01a1358e-70fd-7441-8a0f-228e7cf1811c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern apartment buildings with balconies overlooking a resort-style pool area with blue lounge chairs and a large blue umbrella."
      }
    }
  },
  "apartments/ok/owasso/cypress-crossing::propertyamenities.photo_3": {
    "sourceIndex": 55,
    "fieldOverrides": null
  },
  "apartments/ok/pryor/west-530::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/019cfb50-4763-75f9-a675-7fcb314b0b3a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Community putting green with yellow flag and apartment buildings in background."
      }
    }
  },
  "apartments/ok/tulsa/barrington-apartments::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019cfb39-8a59-708a-8ee6-8cbc85ebee71.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Basketball court and playground area"
      }
    }
  },
  "apartments/ok/tulsa/cascata-luxury-apartments::propertyamenities.photo_3": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cedar-glade-apts::propertyamenities.photo_3": {
    "sourceIndex": 31,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3b-3643-77df-8004-23c155b7d955.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor seating area with fire pit and lounge chairs, with apartment buildings in the background."
      }
    }
  },
  "apartments/ok/tulsa/chardonnay::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-9ed5-7168-9356-baab3d389541.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Sidewalk leading through a well-maintained courtyard with manicured lawns, flower beds, and apartment buildings."
      }
    }
  },
  "apartments/ok/tulsa/country-hollow-apartments::propertyamenities.photo_3": {
    "sourceIndex": 22,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/creekwood-apartments::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f193f-ef76-7049-b93c-1044ae960b84.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Interior of a wooden sauna with benches and a light fixture."
      }
    }
  },
  "apartments/ok/tulsa/nickel-creek-apts::propertyamenities.photo_3": {
    "sourceIndex": 14,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db130-5ef5-76de-9c37-8c08f5d4cbc5.webp"
      }
    }
  },
  "apartments/ok/tulsa/polo-run-apartments::propertyamenities.photo_3": {
    "sourceIndex": 0,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/the-courtyards::propertyamenities.photo_3": {
    "sourceIndex": 25,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-2941-717a-8bdd-71015d0639a2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Gym with treadmills, elliptical, weight machines, free weights, and weight benches."
      }
    }
  },
  "apartments/ok/tulsa/windsail-apartments::propertyamenities.photo_3": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "apartments/ok/yukon/park-at-westpointe::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c1-7bfb-711b-a137-be0d36478e07.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor kitchen area with built-in grills and a stone fireplace, along with a picnic table."
      }
    }
  },
  "apartments/ok/yukon/the-ridge-66::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192f-442a-746d-abf2-413548223699.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Community game room with pool table, shuffleboard, and lounge seating."
      }
    }
  },
  "apartments/tx/amarillo/newport-amarillo-apts::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf6-c5f4-73fb-93c8-1f6282748753.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor grilling area with two built-in grills, picnic tables, and umbrellas, surrounded by green lawn and apartment buildings."
      }
    }
  },
  "apartments/tx/amarillo/park-at-coulter::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc3-a0f8-74ba-b86e-0ab45107fcb7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor BBQ grill and seating area with umbrellas in front of apartment buildings."
      }
    }
  },
  "apartments/tx/amarillo/remington-amarillo-apts::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df3-6ffb-71d9-ad4c-799f6ab51196.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Gym with treadmills, elliptical machines, and weight equipment."
      }
    }
  },
  "apartments/tx/amarillo/the-colonies-at-hillside::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/019d51ca-298d-724f-bbd1-f1100514f107.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "View from a balcony looking out at the apartment buildings and sky."
      }
    }
  },
  "apartments/tx/amarillo/winchester-apartments::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-c7fb-7764-8b67-d2da9a568807.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "View of apartments and pool area through a balcony railing."
      }
    }
  },
  "apartments/tx/el-paso/acacia-park-apts::propertyamenities.photo_3": {
    "sourceIndex": 33,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/chimneys-apts::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611e-91ce-74ea-b78c-472fc5fd47fa.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Balcony view with trees and a closed door"
      }
    }
  },
  "apartments/tx/el-paso/double-tree-apts::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92c-f37f-70e7-9395-149b19cfc289.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Mailroom with rows of mailboxes."
      }
    }
  },
  "apartments/tx/el-paso/high-ridge-apts::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/01a0a195-c34d-7778-a9f2-76022742711c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Communal laundry room with multiple washing machines and dryers."
      }
    }
  },
  "apartments/tx/el-paso/phoenix-apts::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/01a0a16c-2d9b-72cf-900d-ba33acb5dd20.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with light wood cabinets, white appliances including a refrigerator, stove, microwave, and dishwasher. Decorated with a plant and wall art."
      }
    }
  },
  "apartments/tx/el-paso/shadow-ridge-apts::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019d20af-b9c2-70d6-998d-25e3eaea2022.webp"
      }
    }
  },
  "apartments/tx/el-paso/the-crest::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd5-39bc-7317-93a1-90ef37c499c7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "On-site laundry room with multiple washers and dryers."
      }
    }
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a0e9d7-3ece-708c-be71-604a22ac793c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with treadmills, ellipticals, and weight machines."
      }
    }
  },
  "apartments/tx/lubbock/icon-at-lubbock::propertyamenities.photo_3": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "apartments/tx/lubbock/tuscany-place::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2a-a773-773c-a307-d3ad90f7d1b2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Pergola with lounge chairs at an apartment complex."
      }
    }
  },
  "apartments/tx/waco/bend-at-new-road::propertyamenities.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019d4d6a-ae86-71df-99b0-6f3f057ef320.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior of apartment building with garages and unit number 1501."
      }
    }
  },
  "apartments/ar/north-little-rock/lexington-park::propertyamenities.photo_4": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "apartments/ks/maize/watercress-apartments::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4ee-b536-76f9-b8f3-62d573cc9391.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment complex with a fenced-in dog park featuring agility equipment."
      }
    }
  },
  "apartments/ks/wichita/aspen-park-apartments::propertyamenities.photo_4": {
    "sourceIndex": 29,
    "fieldOverrides": null
  },
  "apartments/ks/wichita/cottages-at-crestview::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a18979-412a-71ed-8417-1bc51e2c20f3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Community game room with pool table, shuffleboard, and seating areas."
      }
    }
  },
  "apartments/ks/wichita/huntington-park::propertyamenities.photo_4": {
    "sourceIndex": 11,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166545/019cfb4e-6617-7697-aed6-df9b8f9b4b7a.webp"
      }
    }
  },
  "apartments/ks/wichita/villas-of-waterford::propertyamenities.photo_4": {
    "sourceIndex": 39,
    "fieldOverrides": null
  },
  "apartments/mo/belton/center-301::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165590/019f431e-1ff7-774b-b2ce-cb88f604034c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Gym with treadmills, weight machines, free weights, and exercise balls."
      }
    }
  },
  "apartments/mo/independence/the-adirondack::propertyamenities.photo_4": {
    "sourceIndex": 2,
    "fieldOverrides": null
  },
  "apartments/mo/kansas-city/152-northland::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3ced-a6e5-75bf-a29f-b0831deab268.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Balcony view of the community amenities including a pool and seating areas."
      }
    }
  },
  "apartments/mo/kansas-city/97-north-oak::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019d4e51-4ff5-76b5-aa64-528b4e7fc357.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Covered outdoor lounge area with sofas, chairs, coffee tables, and a TV."
      }
    }
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments::propertyamenities.photo_4": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/park-at-mission-hills::propertyamenities.photo_4": {
    "sourceIndex": 27,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/redbud-ranch::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa538-ef6d-7699-bf90-d8650ae19307.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor grills and seating area at a multifamily property"
      }
    }
  },
  "apartments/ok/broken-arrow/scissortail-crossing::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-96ba-747e-9611-917fbf704a84.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor grilling and seating area with picnic tables, grills, and a fireplace."
      }
    }
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a33-b902-73cb-9ebe-6e04a7b83339.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Interior view of a well-equipped fitness center with various weight machines and free weights."
      }
    }
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-254d-7687-873a-cdc8de2803f8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "View of apartments and lake from a balcony with chairs"
      }
    }
  },
  "apartments/ok/edmond/villas-at-stonebridge::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c14-82d5-76af-9063-0e0a25cd283d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor patio with a brick fireplace, built-in grill, picnic table, and benches."
      }
    }
  },
  "apartments/ok/jenks/the-reserve-at-elm::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-a70c-77c7-a11b-93f1c74fff39.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "The Reserve apartment complex monument sign with American flag."
      }
    }
  },
  "apartments/ok/norman/artisan-crossing-apts::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019cfb39-daaf-763b-aa56-b7344738dae1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor lounge area with comfortable seating, a TV, and tables, overlooking a pool area."
      }
    }
  },
  "apartments/ok/oklahoma-city/24hundred-apartments::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db713-0612-734a-8d53-a69a695ab2f0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor fire pit with lounge chairs in front of a building with stone accents and large windows."
      }
    }
  },
  "apartments/ok/oklahoma-city/chisholm-pointe::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d593f-621b-717b-807d-63ad77aada82.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor patio with lounge chairs, fire pit, and dining table."
      }
    }
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a14009-436b-7209-b856-3d6cfe31ee4a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and umbrellas."
      }
    }
  },
  "apartments/ok/oklahoma-city/council-place-apartments::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/019cfb3d-d30f-730e-a89d-1deb932e1952.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a swimming pool with lounge chairs and umbrellas."
      }
    }
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08675-a267-741d-8329-e86c96d75c6a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with brown sofa, coffee tables, TV, and large windows."
      }
    }
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts::propertyamenities.photo_4": {
    "sourceIndex": 30,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail::propertyamenities.photo_4": {
    "sourceIndex": 9,
    "fieldOverrides": null
  },
  "apartments/ok/owasso/coffee-creek::propertyamenities.photo_4": {
    "sourceIndex": 42,
    "fieldOverrides": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fb452-6a66-7221-9d82-8034ae864a4a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with dumbbells, weight machines, cardio equipment, and a mounted TV."
      }
    }
  },
  "apartments/ok/owasso/cypress-crossing::propertyamenities.photo_4": {
    "sourceIndex": 38,
    "fieldOverrides": null
  },
  "apartments/ok/pryor/west-530::propertyamenities.photo_4": {
    "sourceIndex": 25,
    "fieldOverrides": null
  },
  "apartments/ok/stillwater/apple-creek-stillwater::propertyamenities.photo_4": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/barrington-apartments::propertyamenities.photo_4": {
    "sourceIndex": 36,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cascata-luxury-apartments::propertyamenities.photo_4": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3b-4454-729d-9dfa-4ca878915cfe.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment community dog park with agility equipment"
      }
    }
  },
  "apartments/ok/tulsa/chardonnay::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-8e37-7591-b1bd-34e602924c6e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Interior common area of a multifamily property with a coffee bar and seating area."
      }
    }
  },
  "apartments/ok/tulsa/country-hollow-apartments::propertyamenities.photo_4": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/creekwood-apartments::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019cfb3e-4245-77a2-b79d-4f84efa725ce.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Well-equipped apartment gym with treadmills, elliptical machines, free weights, and a view of the outdoor pool."
      }
    }
  },
  "apartments/ok/tulsa/sheridan-pond::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a01fa2-3a57-711d-a5b7-8a87ba7d0295.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Gym with various weight machines and free weights."
      }
    }
  },
  "apartments/ok/tulsa/sunchase-apartments::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019cfb48-1ecd-7288-81d5-fc1bc087b6d2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with weight machines, treadmills, and ellipticals."
      }
    }
  },
  "apartments/ok/tulsa/the-courtyards::propertyamenities.photo_4": {
    "sourceIndex": 2,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c5-0331-72fb-aed6-a636573da744.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Sidewalk path between brick apartment buildings with green grass and trees."
      }
    }
  },
  "apartments/ok/tulsa/windsail-apartments::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019dd08f-fadb-71b8-8f1a-651ef1c90cff.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Tennis court with apartment buildings in the background"
      }
    }
  },
  "apartments/ok/yukon/park-at-westpointe::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c1-6582-71ab-9481-562c27375b4a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with treadmills, ellipticals, and weight balls."
      }
    }
  },
  "apartments/tx/amarillo/newport-amarillo-apts::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf7-80d0-746d-93b0-f709e922d034.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Laundry room with multiple washers and dryers"
      }
    }
  },
  "apartments/tx/amarillo/park-at-coulter::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc3-e908-75eb-a537-028512172b48.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Picnic table with grill and lounge chairs near a pool area."
      }
    }
  },
  "apartments/tx/amarillo/remington-amarillo-apts::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df4-3225-774c-9fe4-c2657f95de1d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of apartment buildings and mailboxes"
      }
    }
  },
  "apartments/tx/amarillo/the-colonies-at-hillside::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/01a0e997-7d16-7558-b1c0-25958f780f8c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor grilling area with two large barbecues and picnic tables."
      }
    }
  },
  "apartments/tx/amarillo/winchester-apartments::propertyamenities.photo_4": {
    "sourceIndex": 37,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/01a117a3-7a5a-7238-997c-8caad964ff38.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor grilling area with picnic tables and umbrellas next to apartment buildings."
      }
    }
  },
  "apartments/tx/el-paso/acacia-park-apts::propertyamenities.photo_4": {
    "sourceIndex": 26,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/chimneys-apts::propertyamenities.photo_4": {
    "sourceIndex": 25,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/double-tree-apts::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92c-d6b3-75da-ae27-3c0faad9d657.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Laundry room with rows of washers and dryers."
      }
    }
  },
  "apartments/tx/el-paso/high-ridge-apts::propertyamenities.photo_4": {
    "sourceIndex": 7,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/01a0a195-499b-77fe-b512-d63a3191f00b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Rows of secured U.S. Mailboxes in a hallway"
      }
    }
  },
  "apartments/tx/el-paso/phoenix-apts::propertyamenities.photo_4": {
    "sourceIndex": 0,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/shadow-ridge-apts::propertyamenities.photo_4": {
    "sourceIndex": 61,
    "fieldOverrides": null
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a0e9d7-00b2-765a-af02-b06e9e43ad5f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fenced dog park with agility equipment and a red bench with 'BARK PARK' inscription."
      }
    }
  },
  "apartments/tx/lubbock/icon-at-lubbock::propertyamenities.photo_4": {
    "sourceIndex": 34,
    "fieldOverrides": null
  },
  "apartments/tx/lubbock/tuscany-place::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2c-fdb3-77a5-99ed-0282db90a162.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "View from balcony of apartment complex pool and buildings."
      }
    }
  },
  "apartments/tx/waco/bend-at-new-road::propertyamenities.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-ec30-744e-9ee2-d64bdbde6191.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dog park with agility equipment, benches, and waste stations."
      }
    }
  },
  "apartments/ks/maize/watercress::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How do I schedule a tour of the community?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">You can schedule a guided tour with one of our team members or choose a<a href=\"https://app.tour24now.com/prospect/tour/watercress/register/ target= target=\"_blank\"\"_blank\"\"> <strong>self-guided option</strong></a> that lets you tour the community at your own pace. If you prefer a detailed walkthrough or a more flexible experience, you can schedule with one of our options in only a few clicks.</p>"
      }
    }
  },
  "apartments/ks/wichita/aspen-park::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Do your apartment homes have spacious closets?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">They do! All our apartment homes have closets that provide ample room to store your clothes and other personal belongings. Each room has its own closet space, and you can find plenty of cabinets and shelves throughout your apartment for additional storage.</p>"
      }
    }
  },
  "apartments/ks/wichita/cottages-at-crestview::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What appliances come in each apartment’s kitchen?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Appliances for our apartment home kitchens include refrigerators, freezers, stoves, microwaves, and dishwashers. <a href=\"/apartments/ks/wichita/cottages-at-crestview/contact-us\"><strong>Contact us</strong></a> online for more information about what each home offers.</p>"
      }
    }
  },
  "apartments/ks/wichita/crown-chase-apts::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are the stoves gas or electric?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">All our <a href=\"/apartments/ks/wichita/crown-chase-apts/amenities\"><strong>apartment homes feature modern amenities</strong></a>, including all electric stovetops and ovens. You’ll also find that our kitchen sinks, ovens, refrigerators, and more all feature sleek stainless steel finishes that add style to any home.</p>"
      }
    }
  },
  "apartments/ks/wichita/huntington-park::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What amenities come included with my apartment home?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">All our residents can enjoy the <a href=\"/apartments/ks/wichita/huntington-park/amenities\"><strong>on-site amenities</strong></a> at Huntington Park. From our outdoor swimming pool to community events at our resident clubhouse, there’s always something to enjoy at our Wichita apartment community.</p>"
      }
    }
  },
  "apartments/ks/wichita/newport-wichita::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How do I schedule a tour?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">You can schedule a tour online in just a few clicks, <a href=\"/apartments/ks/wichita/newport-wichita/contact-us\"><strong>contact us</strong></a> online, or <a href=\"tel:8447520769\"><strong>call our team</strong></a> at Newport Apartments. Choose from a guided tour led by our team or an unguided tour to explore independently.</p>"
      }
    }
  },
  "apartments/ks/wichita/portofino::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are the apartment kitchens equipped with appliances?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Absolutely. Our kitchens are move-in ready, featuring a full suite of stainless steel appliances, including a refrigerator, microwave, oven, stove, and dishwasher. Whether you are a gourmet cook or a meal-prep pro, you will have everything you need.</p>"
      }
    }
  },
  "apartments/ks/wichita/raintree-apts::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is there a swimming pool available at Raintree Apartments?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes! Our residents love to beat the heat in our sparkling swimming pool. It is a wonderful place to relax, swim laps, or lounge poolside on a sunny afternoon.</p>"
      }
    }
  },
  "apartments/ks/wichita/remington-wichita::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What hours does the fitness center operate?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">With 24-hour access to our fitness center, you can work out anytime. Be aware that there might be some closures for general maintenance and cleaning.</p>"
      }
    }
  },
  "apartments/ks/wichita/silver-springs::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are these apartment homes pet friendly?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Absolutely! We love our four-legged residents and are proud to be a pet-friendly community. To ensure your pets feel right at home, we even feature an on-site Bark Park where they can run, play, and socialize with each other. Please check out our <a href=\"/apartments/ks/wichita/silver-springs/pet-policy\"><strong>pet policies</strong></a> for more details.</p>"
      }
    }
  },
  "apartments/ks/wichita/villas-of-waterford::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What size apartment homes are available?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">You can find the home that fits your lifestyle at Villas of Waterford. Our apartments are available in a range of sizes, from compact 789 sq. ft. 1 bedroom layouts to spacious 1,110 sq. ft. 2 bedroom, 2 bathroom homes. Browse our <a href=\"/apartments/ks/wichita/villas-of-waterford/floor-plans\"><strong>floor plans</strong></a> to see our options.</p>"
      }
    }
  },
  "apartments/mo/independence/the-adirondack::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How close are these apartments to major highways?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We’re tucked in the southeast corner of Independence, just south of Interstate 70. This makes it easy to reach downtown KC, just a straight shot to the west. You can also take Interstate 470 to reach Lee’s Summit to the south or head north to Liberty. You can also go east on Highway 40 to get to Blue Springs and Lake Tapawingo.</p>"
      }
    }
  },
  "apartments/mo/kansas-city/97-north-oak::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is the community bicycle-friendly?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, it is. Many of our residents use their bikes to commute or simply to enjoy the scenery on a ride around the community. There is plenty of room in the <a href=\"/apartments/mo/kansas-city/97-north-oak/neighborhood\"><strong>surrounding neighborhood</strong></a> to explore on foot or on wheels.</p>"
      }
    }
  },
  "apartments/ms/ridgeland/trace-apts::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Do you have a tennis court in The Trace of Ridgeland?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, we do. Residents have access to our outdoor tennis courts, the perfect spot for a friendly match with neighbors or friends. You can also enjoy a swim in our sparkling water swimming pool to cool off.</p>"
      }
    }
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Do you have a swimming pool, fitness center, or community clubhouse?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes to all of the above! You can take a dip in our <a href=\"/apartments/ok/broken-arrow/trails-at-aspen-creek/amenities\"><strong>sparkling pool</strong></a>, break a sweat in the fitness center, or unwind with friends in the clubhouse whenever you’d like.</p>"
      }
    }
  },
  "apartments/ok/edmond/fountain-lake::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Do you offer guided apartment tours?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>We offer flexible touring options so you can explore your new home in the way that works best for you. Choose a guided tour led by our community staff, or take an unguided tour at your own pace. Schedule your tour today!</p>"
      }
    }
  },
  "apartments/ok/edmond/villas-at-stonebridge::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What happens if I lose or forget my apartment key?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">If you lose your key, you can <a href=\"https://protect.checkpoint.com/v2/r01/___tel:4053593081___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6Mzc3YzFiMDc4ZDFjZjc4YzIxNGU2NzA2Y2U1ZTg3YmM6NzozZDY2OjcyMzQxZGI2MmM2MzI1NDE4MGI4NDE3Y2ZiOThjMWU4NTI1ZWY2YTExZGY5NjQ2MDMzNmYzYmRlMmFmZWFmMDE6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>call</strong></a> or <strong><u>contact our leasing office</u></strong> and let us know what happened. A member of our team will come help you get back into your apartment. If it’s late at night or on a weekend, our <a href=\"/apartments/ok/edmond/villas-at-stonebridge/amenities\"><strong>24-hour emergency maintenance</strong></a> team can still come out.</p>"
      }
    }
  },
  "apartments/ok/moore/mission-point::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Who provides the internet services?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Cox is the internet service provided at Mission Point. Every apartment home comes with a preinstalled WiFi modem for easy setup. Visit <a href=\"https://protect.checkpoint.com/v2/r01/___https:/www.cox.com/quickconnect___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6Mzc3YzFiMDc4ZDFjZjc4YzIxNGU2NzA2Y2U1ZTg3YmM6Nzo0MWY4OmFlYjBlMDQ4MTA0NDdkMDA4ZDIzOWJlZjJhMGI2MzliNDZlM2I1NTVkZWY5YmQ1YTI3ZmVlODE4ODc5ZWE5Mzc6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>COX for details</strong></a> on plans and pricing to find the right speed for your needs.</p>"
      }
    }
  },
  "apartments/ok/norman/artisan-crossing-apts::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are the apartment appliances new?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">All of our apartment homes feature <a href=\"/apartments/ok/norman/artisan-crossing-apts/amenities\"><strong>modern and highly efficient appliances</strong></a>. All our ovens and stoves are 100% percent electric. Everything from the kitchen sink to the refrigerator features sleek brushed stainless steel finishes for a stylish and fully equipped cooking space.</p>"
      }
    }
  },
  "apartments/ok/norman/cimarron-trails-apts::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Who provides internet access at Cimarron Trails?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Every apartment at Cimarron Trails comes with a preinstalled <a href=\"https://www.cox.com/residential/mdu-community/quick-connect.html?sc_id=cr_dm_camp_z_quickconnect_vanity target= target=\"_blank\"\"_blank\"\"><strong>WiFi modem powered by Cox</strong></a>. Internet service, along with other utilities, is billed separately from rent. Tenants are individually responsible for keeping their utility accounts current throughout the lease term.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/24hundred-apartments::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What are the accepted methods for paying rent at 24Hundred?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Rent can be paid online through our secure resident portal for added convenience. In addition, you can use <a href=\"https://getflex.com/ target= target=\"_blank\"\"_blank\"\"><strong>flex. to separate your rent</strong></a> into smaller, manageable payments across the month while still having confidence that everything will be paid on time.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/chisholm-pointe::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What apartment floor plan options are available?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\"><a href=\"/apartments/ok/oklahoma-city/chisholm-pointe/floor-plans\"><strong>We offer a great selection of layouts</strong></a> so it’s simple to find the home you love. You can have your choice between a one-bedroom, one-bathroom, a two-bedroom, two-bathroom, or a three-bedroom, two-bathroom home. We also offer options for attached single or double garages, giving you even more flexibility.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How can I schedule a tour of the available apartments?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We invite you to come and see your future home at Cimarron Pointe. You can schedule a tour online on our website or by <a href=\"tel:8335952557\"><strong>calling us</strong></a> directly. We offer both guided tours with our staff and self-guided options, so you can choose the experience that works best for you.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/council-place-apartments::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How does Case and Associates communicate important updates or events to residents?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our primary method of communication is email, using the address provided in your application. We may also send occasional text messages for convenience or time-sensitive updates. Important notices, such as pest control schedules or inspection reminders, may also be posted directly on your door.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/cross-timber::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is the swimming pool chlorine or saltwater?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We have a <a href=\"/apartments/ok/oklahoma-city/cross-timber/amenities\"><strong>stunning saltwater swimming pool</strong></a> available for all our residents to enjoy. Many residents also find saltwater pools more relaxing, with less skin and eye irritation than traditional chlorine pools.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Does my apartment come with a fireplace?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\"><a href=\"/apartments/ok/oklahoma-city/crown-pointe-apartments/floor-plans\"><strong>Our 1 and 2 bedroom apartments</strong></a> have the option of a wood-burning fireplace, perfect for cozy winter evenings. Select floor plans also include a private patio or balcony, giving you a relaxing place to enjoy the outdoors when the weather warms up.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/hunter's-ridge-apts::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is there a swimming pool on-site?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, our OKC apartment community features a <a href=\"/apartments/ok/oklahoma-city/hunter-s-ridge-apts/amenities\"><strong>private resort-style pool</strong></a> for all residents to enjoy. Relax poolside in one of our many community lounge chairs or take a dip to cool off during hot summer days.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/park-at-tuscany::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Do you offer after-hours security?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We want you to feel secure in your home—that’s why we have a limited-access gate reserved for residents and their guests. Our community also features a nighttime courtesy patrol to help monitor the property and maintain a peaceful environment. </p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/persimmon-square-apartments::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is the kitchen stove gas or electric?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Enjoy the benefits of modern all-electric living in your updated kitchen. All apartment homes at Persimmon Square feature electric stoves to whip up easy meals, and our <a href=\"/apartments/ok/oklahoma-city/persimmon-square-apartments/amenities\"><strong>energy-efficient electric appliances</strong></a> make mealtime convenient.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/prairie-springs-i::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What options do I have for touring the community?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">What options do You may schedule either a guided tour or a <a href=\"https://protect.checkpoint.com/v2/r01/___https:/app.tour24now.com/prospect/tour/prairie-springs/register/___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6Mzc3YzFiMDc4ZDFjZjc4YzIxNGU2NzA2Y2U1ZTg3YmM6NzozNjUyOjgzZTQzNGIyYmIxYjJkYWUyMGQ0ZGI3MThlM2VmOWRiMGQ3M2MyZjQyMTFmODkwNWFlMjIyOTQ5MTZjNGFhZGI6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>self-guided tour</strong></a> of our apartment community. With a guided tour, one of our team members will walk you through the neighborhood, highlight key features, and answer any questions you may have. If you prefer to wander on your own, a self-guided tour gives you the freedom to move at your own pace and focus on the spaces that interest you.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/stonehorse-crossing::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What options are there for touring the apartment community?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Schedule a guided tour with one of our team members or choose a <a href=\"https://protect.checkpoint.com/v2/r01/___https:/app.tour24now.com/prospect/tour/stonehorse-crossing/register/___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6Mzc3YzFiMDc4ZDFjZjc4YzIxNGU2NzA2Y2U1ZTg3YmM6Nzo5YzFlOmZiYjJkZTNjMmYwM2Y2MGNjMjVjOWYwYTY5NjhiYWY4OWQ0YjlhNDVlNmIwN2Q4NDdhOGM3NTk3NTAwYmU0NjU6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>self-guided tour</strong></a> if you prefer to wander at your own pace. You can reserve online or by phone and easily find a time that fits your lifestyle.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/summerfield-place-apts::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How do I schedule a tour of the community?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">You can schedule a guided tour with one of our team members or choose a <a href=\"https://protect.checkpoint.com/v2/r01/___https:/tour.tourbuilder.com/?tour=5f6d60819984540c277a0fdd___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6Mzc3YzFiMDc4ZDFjZjc4YzIxNGU2NzA2Y2U1ZTg3YmM6NzowZmI2OmU4MGFlNGI0M2VmMDU4MWJmMzYyOGVmOTEwMTYwNzk5MDI3ZGNiM2RjMjAxMmUxZmJjNDVmODA3NDI2NTMzYTg6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>self-guided option</strong></a> that lets you tour the community at your own pace. If you prefer a detailed walkthrough or a more flexible experience, you can schedule with one of our options in only a few clicks.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/tammaron-village-apartments::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What are your office hours and how can I reach the leasing team?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our leasing office is open Monday through Thursday from 8:30 a.m. to 5:30 p.m., Friday from 8:30 a.m. to 5:00 p.m., and Saturday from 10:00 a.m. to 3:00 p.m. On Sundays, you can call for availability. You can also simply <a href=\"https://protect.checkpoint.com/v2/r01/___tel:8446850723___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6Mzc3YzFiMDc4ZDFjZjc4YzIxNGU2NzA2Y2U1ZTg3YmM6Nzo2NDA3Ojc3ZDJhZmEwZmEyYWZmOWExYzhmY2M5ODJiODMxMjJlMzgyMWQxYmU3ZWY0YzMyYjNiZGI1YWMyM2M5ZTE5NTc6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>call us</strong></a> if you ever need to reach us.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/warrington-apartments::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Do your kitchens come with appliances?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, all our apartments come with fully equipped and spacious kitchens. Enjoy <s>modern</s> energy-efficient appliances in your home kitchen, including a stove, refrigerator, freezer, microwave, and dishwasher.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What swimming options are available at Waters Edge Apartments?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Do you want to take a dip in a pool? Splash into one of our two on-site swimming pools with you, your roommates. Unwind on a cool day in our hot tub, or relax under the sun with plenty of poolside seating.</p>"
      }
    }
  },
  "apartments/ok/owasso/coffee-creek::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What schools are Coffee Creek Luxury Apartments near?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Coffee Creek Luxury Apartments is strategically located to be convenient and accessible to students and families of all ages. Northeast Elementary, Bailey Education Group, Owasso High School, and the Tulsa Tech are just some of them!</p>"
      }
    }
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What do I do if I have a plumbing problem?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">If you experience a plumbing issue, you can immediately call our on-site maintenance team, which is available 24 hours a day for your convenience. Our staff is always on standby to ensure that any emergency repairs are handled quickly.</p>"
      }
    }
  },
  "apartments/ok/tulsa/barrington-apartments::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What amenities are available at Barrington Apartments in Tulsa, OK?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Residents have access to a wide range of community amenities, including a swimming pool, fitness center with free weights, basketball and sand volleyball courts, playground, picnic areas, and a clubhouse with business center access. Covered parking, package receiving, and 24-hour emergency maintenance are also available throughout the apartment community.</p>"
      }
    }
  },
  "apartments/ok/tulsa/cascata-luxury-apartments::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Does Cascata Luxury Apartments offer fitness and recreation options for residents in Tulsa, OK?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, the apartment community features a full fitness center that is open 24 hours, allowing residents to work out on their own schedule. Outdoor recreation areas, including poolside seating, a fire pit, and lounge spaces, provide additional places to relax and spend time outside.</p>"
      }
    }
  },
  "apartments/ok/tulsa/cedar-glade-apts::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Who typically chooses to live at Cedar Glade Apartments in Tulsa, OK?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Cedar Glade Apartments attracts a mix of residents, including students, working professionals, and households looking for a convenient south Tulsa location. Proximity to Union Public Schools, Tulsa Community College, and major employers makes the apartment community a practical choice for a wide range of lifestyles.</p>"
      }
    }
  },
  "apartments/ok/tulsa/cedar-ridge-apartments::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "When can I access the fitness center in Cedar Ridge Apartments?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">You can access the fitness center anytime you want, as it is open 24 hours a day. Keep in mind that it might momentarily close from time to time for general maintenance and cleaning.</p>"
      }
    }
  },
  "apartments/ok/tulsa/chardonnay::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are pets allowed at Chardonnay Apartment Homes?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes! We are a <a href=\"/apartments/ok/tulsa/chardonnay/pet-policy\"><strong>pet-friendly community</strong></a> because we believe your furry friends are just as much a part of the family as anyone else. Residents can also enjoy our convenient on-site dog park, providing the perfect space for your pets to play.</p>"
      }
    }
  },
  "apartments/ok/tulsa/country-hollow-apartments::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are there pickleball courts on-site?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes! When you pay rent, you automatically get access to the pickleball courts. This is a communal area perfect for playing with friends or neighbors!</p>"
      }
    }
  },
  "apartments/ok/yukon/park-at-westpointe::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Who provides the internet service at The Park at Westpointe?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Setting up the internet in our Yukon apartment homes is easy! Every apartment comes with a preinstalled WiFi modem with services powered by COX. Browse <a href=\"https://protect.checkpoint.com/v2/r01/___https:/www.cox.com/quickconnect___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6Mzc3YzFiMDc4ZDFjZjc4YzIxNGU2NzA2Y2U1ZTg3YmM6Nzo0MWY4OmFlYjBlMDQ4MTA0NDdkMDA4ZDIzOWJlZjJhMGI2MzliNDZlM2I1NTVkZWY5YmQ1YTI3ZmVlODE4ODc5ZWE5Mzc6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>available internet plans</strong></a> at The Park at Westpointe online to find an ideal option that meets your internet service needs.</p>"
      }
    }
  },
  "apartments/ok/yukon/the-ridge-@-66::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are the appliances electric?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, <a href=\"/apartments/ok/yukon/the-ridge-66/amenities\"><strong>all our appliances are electric</strong></a>, efficient, and feature sleek stainless steel finishes. They’re designed to bring a modern look to any style home while helping you save on energy costs, too.</p>"
      }
    }
  },
  "apartments/tx/hewitt/icon-at-hewitt::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is The Icon at Hewitt conveniently located?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\"><a href=\"/apartments/tx/hewitt/icon-at-hewitt/neighborhood\"><strong>Our apartment community</strong></a> keeps you close to the action without sacrificing the calm cozy environment our residents love. We&#8217;re just a short drive west of I-35, which will take you right into downtown Waco or Temple to the south.</p>"
      }
    }
  },
  "apartments/tx/lubbock/icon-at-lubbock::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Can I take a self-guided tour of The Icon at Lubbock?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Of course. We offer you various options to explore your future home, either on your own or guided by a friendly member of our community staff. <a href=\"https://app.tour24now.com/prospect/tour/icon-at-lubbock/register/ target= target=\"_blank\"\"_blank\"\"><strong>Guided and solo tours</strong></a> can be easily scheduled online before your visit.</p>"
      }
    }
  },
  "apartments/tx/temple/portico-at-friars-creek-apts::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Do apartments include a microwave and dishwasher?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, our apartments come fully outfitted with <a href=\"/apartments/tx/temple/portico-at-friars-creek-apts/amenities\"><strong>modern stainless steel appliances</strong></a>, including both a microwave and dishwasher. You’ll also find hookups for washers and dryers in all homes, giving you the option to bring your own or enjoy in-apartment convenience where available.</p>"
      }
    }
  },
  "apartments/tx/waco/bend-at-new-road::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What utilities are included in the rent?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Every apartment comes <a href=\"/apartments/tx/waco/bend-at-new-road/amenities\"><strong>fully equipped with all-electric appliances</strong></a>, heating, air conditioning, water, and ready for internet setup at an additional cost. Select apartment homes also come with washers and dryer hookups. You’ll have everything you need to feel comfortable without having to juggle multiple utility accounts.</p>"
      }
    }
  },
  "apartments/tx/waco/tuscany-ranch-apartments::propertyfaq.dropdown_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Does my apartment come with a smoke and carbon monoxide alarm?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, every apartment comes outfitted with smoke detectors, while loft units have carbon monoxide detectors for your protection. We also regularly check and replace the batteries to help keep them functioning properly at all times.</p>"
      }
    }
  },
  "apartments/ks/maize/watercress::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What are the lease term options?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We usually offer 12-month leases. If you need something shorter or longer, you can reach out to our leasing team anytime. We’ll look at what leasing options are open and help you choose the one that fits your plans. Short term leases are sometimes available for an additional fee.</p>"
      }
    }
  },
  "apartments/ks/wichita/aspen-park::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are your apartment kitchens well-equipped?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Each apartment features a fully equipped, kitchen. For your convenience, your home includes an energy-efficient dishwasher, refrigerator, freezer, stove, and microwave.</p>"
      }
    }
  },
  "apartments/ks/wichita/cottages-at-crestview::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What pet amenities are available at the Cottages at Crestview?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our Wichita apartment community features a bark park for your furry friend to meet new faces and play to their heart’s content. We also have walking paths to take your pet for a relaxing stroll.</p>"
      }
    }
  },
  "apartments/ks/wichita/crown-chase-apts::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Do the apartments have balconies or patios?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">You have the option to choose the home that best matches your lifestyle at Crown Chase. You can enjoy an apartment with a stunning view from your private patio or porch across our lineup of <a href=\"/apartments/ks/wichita/crown-chase-apts/floor-plans\"><strong>1-bedroom, 1-bathroom and 2-bedroom, 2-bathroom options</strong></a>.</p>"
      }
    }
  },
  "apartments/ks/wichita/huntington-park::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Do your apartment kitchens come with appliances?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">In your spacious kitchen, you’ll find energy-efficient appliances to enhance your apartment living experience. These appliances include a refrigerator, dishwasher, stove, and microwave.</p>"
      }
    }
  },
  "apartments/ks/wichita/newport-wichita::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "When can I use the fitness center?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our <a href=\"/apartments/ks/wichita/newport-wichita/amenities\"><strong>fitness center is open 24/7</strong></a>, allowing you to work out whenever it works for your schedule. Whether you’re an early riser or prefer a late-night workout, the gym is always available and ready for you to enjoy.</p>"
      }
    }
  },
  "apartments/ks/wichita/portofino::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How big are the closets at Portofino Apartments?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Storage space is not an issue at Portofino Apartments. Our floor plans are laid out for your comfort, featuring spacious closets that provide ample room to organize your wardrobe and store your belongings.</p>"
      }
    }
  },
  "apartments/ks/wichita/raintree-apts::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What do I do if I need assistance?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We pride ourselves on excellent service. We provide on-site management during business hours to assist with your needs. For your peace of mind, we also offer 24-hour emergency maintenance, ensuring that help is always just a phone call away if an urgent issue arises after hours.</p>"
      }
    }
  },
  "apartments/ks/wichita/remington-wichita::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are the apartment homes equipped with a fireplace?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Select apartment homes at The Remington do <a href=\"/apartments/ks/wichita/remington-wichita/amenities\"><strong>include fireplaces</strong></a>. If having a fireplace is a priority for your home to maximize coziness during the winter months, please <a href=\"/apartments/ks/wichita/remington-wichita/contact-us\"><strong>contact our leasing team. </strong></a>We will be happy to guide you through the availability of these specific floor plans to help you find the right fit.</p>"
      }
    }
  },
  "apartments/ks/wichita/silver-springs::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What can I do if I have an emergency?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Your comfort and safety are our top priorities. We provide 24-hour emergency maintenance services to handle any urgent issues that may arise outside of regular business hours. If you experience issues like plumbing emergencies or heating problems, we are a phone call away!</p>"
      }
    }
  },
  "apartments/ks/wichita/villas-of-waterford::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Who provides the internet services?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Cox is the internet service provider at Villas of Waterford. Every apartment home comes with a preinstalled WiFi modem for easy setup. Visit<a href=\"https://protect.checkpoint.com/v2/r01/___https:/www.cox.com/quickconnect___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6Mzc3YzFiMDc4ZDFjZjc4YzIxNGU2NzA2Y2U1ZTg3YmM6Nzo0MWY4OmFlYjBlMDQ4MTA0NDdkMDA4ZDIzOWJlZjJhMGI2MzliNDZlM2I1NTVkZWY5YmQ1YTI3ZmVlODE4ODc5ZWE5Mzc6cDpUOk4 target= target=\"_blank\"\"_blank\"\"> <strong>COX for details</strong></a> on plans and pricing to find the right speed for your needs.</p>"
      }
    }
  },
  "apartments/mo/independence/the-adirondack::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are the appliances gas or electric?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We use <a href=\"/apartments/mo/independence/the-adirondack/amenities\"><strong>modern, stainless steel appliances</strong></a> in all our apartment homes. They are all electric and energy-efficient, which helps you save money each month without worrying about the hassle of a separate gas bill.</p>"
      }
    }
  },
  "apartments/mo/kansas-city/97-north-oak::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How do I schedule a tour?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Scheduling is easy! Just reach out to us online or by phone. We offer both guided tours led by our team and unguided tours, allowing you to explore the community at your own pace.</p>"
      }
    }
  },
  "apartments/ms/ridgeland/trace-apts::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Can I rent for a short period of time?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>Yes, we offer short-term leases for an additional charge. Contact our leasing office for details. </p>"
      }
    }
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How can I schedule a tour of the property?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">You can book a guided tour with one of our friendly team members or schedule an <a href=\"https://app.tour24now.com/prospect/tour/trails-at-aspen-creek/register/ target= target=\"_blank\"\"_blank\"\"><strong>unguided tour</strong></a>if you’d like to explore at your own pace. Just <a href=\"/apartments/ok/broken-arrow/trails-at-aspen-creek/contact-us\"><strong>contact us</strong></a> online or <a href=\"tel:8337550210\"><strong>call our team</strong></a>, and we’ll arrange a time that works best for you.</p>"
      }
    }
  },
  "apartments/ok/edmond/fountain-lake::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What appliances come with my apartment?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>Our apartments feature <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/apartments/ok/edmond/fountain-lake/amenities\"><strong><s>a</s>ppliances</strong></a> designed with style and efficiency. Enjoy a side-by-side refrigerator with ice and filtered water, an all-electric cooktop and oven, a built-in microwave, and a dishwasher. You’ll also find deep kitchen sinks that make meal prep and cleanup a breeze.</p>"
      }
    }
  },
  "apartments/ok/edmond/villas-at-stonebridge::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Can I schedule a tour on my own schedule, including self-guided tours?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Can I Yes, you can choose the type of tour that works best for you. If you’d like someone to walk with you and answer questions, we offer guided tours with a team member. If you prefer to look around on your own, you can pick a <a href=\"https://protect.checkpoint.com/v2/r01/___https:/app.tour24now.com/prospect/tour/villas-stonebridge/register/___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6Mzc3YzFiMDc4ZDFjZjc4YzIxNGU2NzA2Y2U1ZTg3YmM6Nzo4MjE0OjE3ZWUyNmVjNjY3MWJjYTRiMDcxMDc3YTUyZTdmYjdmN2ZhMjFhNWM5ZGQ3MWJkNTNiNWNiYzA1ZDJkNjFkNTE6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>self-guided tour</strong></a>.</p>"
      }
    }
  },
  "apartments/ok/moore/mission-point::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are there on-site facilities available for pets?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes! Keep your pets happy and well exercised at our on-site dog parks. Featuring plenty of room to run and explore, we also offer dog waste stations so you can easily pick up after your pets, which we respectfully ask all residents to do.</p>"
      }
    }
  },
  "apartments/ok/norman/artisan-crossing-apts::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Artisan Crossing?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\"><a href=\"/apartments/ok/norman/artisan-crossing-apts/pet-policy\"><strong>Our pet policy is welcoming to all sizes</strong></a>, which means we do not have any weight restrictions for cats or dogs. However, there is a limit of 2 pets per apartment, and breed restrictions do apply. Additionally, there is a $30 per month pet rent per pet and a $500 nonrefundable upfront pet fee.</p>"
      }
    }
  },
  "apartments/ok/norman/cimarron-trails-apts::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is there a package receiving service?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, <a href=\"/apartments/ok/norman/cimarron-trails-apts/amenities\"><strong>we offer package receiving services</strong></a> to help you easily accept orders, even when you aren’t home. You can note in your delivery instructions that packages should be held at our office, and then stop by to pick them up at your convenience.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/24hundred-apartments::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How do I apply for an apartment at 24Hundred?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our application process is easy. You can do the entire process from the comfort of home through our <a href=\"https://24hundredapartmentsokc.securecafe.com/onlineleasing/2400-watermark-blvd-oklahoma-city-ok-73134/register.aspx target= target=\"_blank\"\"_blank\"\"><strong>online application portal</strong></a>.  <br> <br>You can also schedule a guided or solo apartment tour to see every corner of your new home before you sign.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/chisholm-pointe::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are there any weight restrictions on pets?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We are happy to <a href=\"/apartments/ok/oklahoma-city/chisholm-pointe/pet-policy\"><strong>welcome pets of all sizes</strong></a> to our community, which means we have no weight limit on cats or dogs. We do have a maximum limit of two pets per renter. Please note that certain breed restrictions do apply, so contact our office for details.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How many pets are allowed?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We welcome cats and dogs to our pet-friendly apartments in OKC. Each household may have up to two pets, with no weight limit. For more details on breed restrictions and related policies, <a href=\"/apartments/ok/oklahoma-city/cimarron-pointe-apts/pet-policy\"><strong>please review our full pet policy</strong></a>.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/council-place-apartments::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Do the apartments come with a washer and dryer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We are proud to <a href=\"/apartments/ok/oklahoma-city/council-place-apartments/amenities\"><strong>offer in-home washers and dryers</strong></a> to all our residents. Having laundry machines in your apartment makes day-to-day living far more convenient, letting you skip trips to the shared laundry room and avoid waiting for a machine to become available.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/cross-timber::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Do I need to find my own internet provider?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Every apartment comes with a <a href=\"https://www.cox.com/residential/mdu-community/quick-connect.html?sc_id=cr_dm_camp_z_quickconnect_vanity target= target=\"_blank\"\"_blank\"\"><strong>modem preinstalled by Cox Internet</strong></a>, so you can get connected quickly. If you prefer, you can bring your own router to personalize your setup. You also have the freedom to choose the service package that best reflects your internet usage needs.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Who provides the internet?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Internet service is provided by Cox, with a modem preinstalled in every apartment home for easy setup. Affordable plans are available at a range of speeds to fit your lifestyle. <a href=\"https://www.cox.com/quickconnect target= target=\"_blank\"\"_blank\"\"><strong>Visit Cox’s website</strong></a>for details about current service packages.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/hunter's-ridge-apts::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Do you have wheelchair-accessible homes available?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We pride ourselves on offering apartment homes that are comfortable for all residents. We offer ADA accessible homes in multiple layouts, though availability may be limited. Please feel free to <a href=\"https://protect.checkpoint.com/v2/r01/___tel:8556431619___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6Mzc3YzFiMDc4ZDFjZjc4YzIxNGU2NzA2Y2U1ZTg3YmM6Nzo3NGI1OmFmMjc1MzdlOTNiZjNlMjhlZWI2YTMzYTc0MzI5OGVjYzQ4NjU5ODhhNjFiNmUyYTM1NzUyYjcxYjk5NjYzOTQ6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>call us</strong></a> to learn more about our wheelchair-accessible apartments.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/park-at-tuscany::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are the appliances electric?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, all our apartment homes feature modern <a href=\"/apartments/ok/oklahoma-city/park-at-tuscany/amenities\"><strong>stainless-steel electric appliances</strong></a>. Your oven, stovetop, and heating and cooling systems are 100% electric, making them easy to use and maintain. Enjoy convenient, efficient living every day with stylish, energy-efficient appliances.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/persimmon-square-apartments::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Who provides the internet services at Persimmon Square?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Internet service at Persimmon Square is provided by <a href=\"https://protect.checkpoint.com/v2/r01/___https:/www.cox.com/quickconnect___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6Mzc3YzFiMDc4ZDFjZjc4YzIxNGU2NzA2Y2U1ZTg3YmM6Nzo0MWY4OmFlYjBlMDQ4MTA0NDdkMDA4ZDIzOWJlZjJhMGI2MzliNDZlM2I1NTVkZWY5YmQ1YTI3ZmVlODE4ODc5ZWE5Mzc6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>COX</strong></a>. Each apartment home includes a preinstalled WiFi modem to make setup quick and easy. Visit COX online to explore available internet plans and find the option that works for your lifestyle.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/prairie-springs-i::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is there parking available for residents?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, we have <a href=\"/apartments/ok/oklahoma-city/prairie-springs-i/amenities\"><strong>garage parking</strong></a> available for rent for our residents to come and go whenever they need. Some of our apartment homes also come with direct access to the garage, making it more convenient to get to your vehicle during hot summers or rainy days. Our regular parking lot accommodates our residents as well.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/stonehorse-crossing::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How does the maintenance service work?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">If something urgent happens in your apartment, our maintenance team is ready to help 24/7, including late at night or early in the morning. For smaller issues like a light that’s out or a loose handle, you can send a request through your <a href=\"https://protect.checkpoint.com/v2/r01/___https:/stonehorsecrossingapartmentsoklahomacity.securecafe.com/residentservices/stonehorse-crossing/userlogin.aspx___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6Mzc3YzFiMDc4ZDFjZjc4YzIxNGU2NzA2Y2U1ZTg3YmM6NzoxMWEwOmY5MTJjM2ZhNjZmZjg3YzljNWUwNGVjODYzZTVjMDY3MDk4OTUzODZlOTExNjdmNTgxNzMxMjBjMmVkMGZlNjU6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>online resident portal</strong></a>.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/summerfield-place-apts::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What are the lease term options?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We usually offer 12-month leases. If you need something shorter or longer, you can reach out to our leasing team anytime. We’ll look at what leasing options are open and help you choose the one that fits your plans.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/tammaron-village-apartments::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are there options for self-guided or virtual tours of the community?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, you’re more than welcome to choose the touring style that fits your schedule. If you prefer to experience the community with the help of our team, we offer guided tours where a staff member can walk with you and answer any questions you may have. If you’d rather take your time and look around independently, <a href=\"https://protect.checkpoint.com/v2/r01/___https:/app.tour24now.com/prospect/tour/tammaron-village/register/___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6Mzc3YzFiMDc4ZDFjZjc4YzIxNGU2NzA2Y2U1ZTg3YmM6NzoyMjkzOmZiYmFkZTM5NGE1N2UzODdjMjViM2RmNGVmYjRmMmIzNjEyYmE4YmE4N2UxZTQ1ZTE1Y2UzMTQ2ZjczMDMwZWU6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>self-guided tours</strong></a> are also available and give you the freedom to experience the community at your own pace.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/warrington-apartments::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "When can I use the fitness center?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Any time you need it! Our fitness center is open 24 hours a day, seven days a week, so you can work out on your own time. Be aware that temporary closures for cleaning and maintenance may occur.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Do your apartments have in-home washers and dryers?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, they do! Instead of hauling you and your laundry off-site to a laundromat or similar facility, do it all indoors with your in-home washers and dryers. These appliances are available in all our apartment homes.</p>"
      }
    }
  },
  "apartments/ok/owasso/coffee-creek::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are garages available at Coffee Creek Luxury Apartments?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes. If you want to reserve a garage for your vehicle, please <a href=\"/apartments/ok/owasso/coffee-creek/contact-us\"><strong>contact us</strong></a> or <a href=\"tel:8556431576\"><strong>give us a call </strong></a>to get the process started.</p>"
      }
    }
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are the apartments at Cottages at Tallgrass Point carpeted?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, our apartment homes feature cozy wall-to-wall carpeting throughout the living areas and bedrooms. This flooring provides a comfortable environment that makes your living space feel warm and inviting. Perfect for the winter!</p>"
      }
    }
  },
  "apartments/ok/tulsa/barrington-apartments::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is Barrington Apartments a pet-friendly apartment community in Tulsa, OK?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, Barrington Apartments welcomes pets. The apartment community is pet-friendly and offers outdoor spaces where residents can enjoy time with their pets. Barrington Apartments has a pet fee of $30 per pet per month, with a $500 non refundable pet fee per pet. Breed restrictions apply.</p>"
      }
    }
  },
  "apartments/ok/tulsa/cascata-luxury-apartments::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is Cascata Luxury Apartments a pet-friendly apartment community in Tulsa, OK?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\"> Yes, Cascata Luxury Apartments is a pet-friendly apartment community. Residents can enjoy a dedicated outdoor space at the on-site bark park. Breed restrictions and pet-related fees apply, so viewing our pet policy page or contacting the leasing office is recommended for current policy details.</p>"
      }
    }
  },
  "apartments/ok/tulsa/cedar-glade-apts::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What everyday conveniences are available within the Cedar Glade apartment community?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Residents can enjoy conveniences such as electronic payments, on-site management, a resident clubhouse with business center access, and a community coffee bar. The apartment community also offers 24-hour emergency maintenance to support day-to-day living.</p>"
      }
    }
  },
  "apartments/ok/tulsa/cedar-ridge-apartments::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is Cedar Ridge Apartments pet-friendly?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Your pets are as loved as any other member of the family, so we want to make sure you can keep them with you when you move to Cedar Ridge Apartments. You will also be able to find an on-site dog park for your furry friends. Make sure to check our <a href=\"/apartments/ok/tulsa/cedar-ridge-apartments/pet-policy\"><strong>pet policies</strong></a>!</p>"
      }
    }
  },
  "apartments/ok/tulsa/chardonnay::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What do I do if the AC doesn’t work?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">If your air conditioning fails, you can rely on our 24-hour emergency maintenance team to restore your comfort at any time. Please don&#8217;t hesitate to <a href=\"tel:%20(844)%20580-1171\"><strong>call us immediately</strong></a> so we can provide the prompt assistance you need.</p>"
      }
    }
  },
  "apartments/ok/tulsa/country-hollow-apartments::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Does Country Hollow Apartments have a pool?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our sparkling on-site pool is the perfect place for residents to relax and cool off during those sunny days. It quickly becomes the heart of the community in the summer, turning into a refreshing escape when the temperatures rise!</p>"
      }
    }
  },
  "apartments/ok/yukon/park-at-westpointe::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Do all apartments at The Park at Westpointe have garbage disposals?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, every home in our apartment community comes equipped with a convenient under-the-sink garbage disposal unit. You’ll also have <a href=\"/apartments/ok/yukon/park-at-westpointe/amenities\"><strong>modern stainless-steel appliances</strong></a> that bring both function and style to your kitchen, from your side-by-side refrigerator to your energy-efficient dishwasher.</p>"
      }
    }
  },
  "apartments/ok/yukon/the-ridge-@-66::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are you a pet-friendly community?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, we welcome both cats and dogs as part of our community. Breed restrictions and pet fees apply; please <a href=\"/apartments/ok/yukon/the-ridge-66/pet-policy\"><strong>review our pet policy for details</strong></a>. Please contact our office for more information.</p>"
      }
    }
  },
  "apartments/tx/hewitt/icon-at-hewitt::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "When can I use the fitness center?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">You can stay in shape whenever it is convenient for you with <a href=\"/apartments/tx/hewitt/icon-at-hewitt/amenities\"><strong>our 24-hour fitness center</strong></a>. You&#8217;re free to use the free weights or run on the treadmills whenever you feel the urge. There may be brief temporary closures on occasion for maintenance.</p>"
      }
    }
  },
  "apartments/tx/lubbock/icon-at-lubbock::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Does my apartment come with a fireplace?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Select homes feature fireplaces, giving you an extra touch of comfort and warmth during cold evenings and creating a welcoming atmosphere for gatherings. All our apartments are designed to stay cozy in the winter, provided with efficient electric heating that you can control directly from your personal thermostat.</p>"
      }
    }
  },
  "apartments/tx/temple/portico-at-friars-creek-apts::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Do the apartments have balconies or patios?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, <a href=\"/apartments/tx/temple/portico-at-friars-creek-apts/floor-plans\"><strong>select apartment homes</strong></a> across our range of sizes come with the option for additional outdoor space. The layout depends on the level of your apartment, with upper floors offering balconies and ground-level options featuring patios.</p>"
      }
    }
  },
  "apartments/tx/waco/bend-at-new-road::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are smoke detectors and carbon monoxide detectors installed in the apartments?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, <a href=\"/apartments/tx/waco/bend-at-new-road/floor-plans\"><strong>every apartment we offer</strong></a> comes with modern and up-to-code smoke detectors, and select apartments also come with carbon monoxide detectors. At Case &amp; Associates, we value your well-being, which is why our maintenance team regularly checks and services our safety systems to keep them in working order.</p>"
      }
    }
  },
  "apartments/tx/waco/tuscany-ranch-apartments::propertyfaq.dropdown_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are the stoves gas or electric?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">All our apartments feature <a href=\"/apartments/tx/waco/tuscany-ranch-apartments/amenities\"><strong>modern electric appliances</strong></a> designed for ease of use and energy efficiency. This includes your oven and stovetop, as well as hookups for washers and dryers to simplify everyday living.</p>"
      }
    }
  },
  "apartments/ks/maize/watercress::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How does the maintenance service work?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">If something urgent happens in your apartment, our maintenance team is ready to help 24/7, including late at night or early in the morning. For smaller issues like a light that’s out or a loose handle, you can send a request through your<a href=\"https://protect.checkpoint.com/v2/r01/___https:/stonehorsecrossingapartmentsoklahomacity.securecafe.com/residentservices/stonehorse-crossing/userlogin.aspx___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6Mzc3YzFiMDc4ZDFjZjc4YzIxNGU2NzA2Y2U1ZTg3YmM6NzoxMWEwOmY5MTJjM2ZhNjZmZjg3YzljNWUwNGVjODYzZTVjMDY3MDk4OTUzODZlOTExNjdmNTgxNzMxMjBjMmVkMGZlNjU6cDpUOk4 target= target=\"_blank\"\"_blank\"\"> <strong>online resident portal</strong></a>.</p>"
      }
    }
  },
  "apartments/ks/wichita/aspen-park::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What times can I use the tennis and pickleball courts?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">You can use our community tennis and pickleball courts throughout the day and evening. We ask that you be mindful as you play so you don’t disturb other residents. Our courts are available on a first-come, first-served basis.</p>"
      }
    }
  },
  "apartments/ks/wichita/cottages-at-crestview::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "When can I use the fitness center?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">You can work out at your convenience in our fitness center, which is open 24 hours a day, seven days a week. Be aware that temporary closures are possible for maintenance and cleaning.</p>"
      }
    }
  },
  "apartments/ks/wichita/crown-chase-apts::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "When can I use the fitness center?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Work out on your own schedule with 24-hour access to our fitness center. This means you can enjoy your morning run or late night workout whenever you want, though occasional closures may occur for maintenance purposes.</p>"
      }
    }
  },
  "apartments/ks/wichita/huntington-park::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What if my apartment doesn’t have an in-home washer and dryer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">If your apartment does not have an in-home washer and dryer, you can use our on-site laundry facility. Access to these spaces comes included with your rent and can be used at your convenience.</p>"
      }
    }
  },
  "apartments/ks/wichita/newport-wichita::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Who provides the internet?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">High-speed internet is available through AT&amp;T, keeping you connected for work, school, and streaming without interruption.</p>"
      }
    }
  },
  "apartments/ks/wichita/portofino::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is a pool available at Portofino Apartments?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes! To help you beat the summer heat, all residents have exclusive access to our swimming pool. It is a wonderful place to take a refreshing dip, lounge on the sundeck, and unwind after a long day.</p>"
      }
    }
  },
  "apartments/ks/wichita/raintree-apts::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is Raintree Apartments pet-friendly?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Absolutely! We are a <a href=\"/apartments/ks/wichita/raintree-apts/pet-policy\"><strong>pet-friendly community</strong></a> and believe your furry friends are part of the family. We even have an on-site Bark Park where your dog can run and play. Please note that there is a monthly pet rent of $30 per pet.</p>"
      }
    }
  },
  "apartments/ks/wichita/remington-wichita::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What should I do if I lose my key?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">If you lose your key, please reach out to the leasing office or your property manager as soon as possible. Our team can assist you by providing a replacement key. Additional fees may apply for key replacements.</p>"
      }
    }
  },
  "apartments/ks/wichita/silver-springs::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Do the apartment homes come with spacious closets?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">All our homes feature spacious closets. These generous storage spaces give you plenty of room to organize your wardrobe and keep your home feeling open and clutter-free. We also offer plenty of cabinet space in the kitchen to make every meal easy.</p>"
      }
    }
  },
  "apartments/ks/wichita/villas-of-waterford::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Do you offer homes with attached garages?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Do you offer homes with attached garages?</p>"
      }
    }
  },
  "apartments/mo/independence/the-adirondack::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How can I contact the leasing office for more information?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\"><a href=\"/apartments/mo/independence/the-adirondack/contact-us\"><strong>Fill out a contact form</strong></a> at any time, and we’ll respond as soon as possible. You can also <a href=\"tel:8447306351\"><strong>call our office</strong></a> anytime from 8:30 a.m. to 5:30 p.m., Monday through Thursday, and 8:30 a.m. to 5:00 p.m. on Fridays. On Saturdays, we’re open from 10:00 a.m. to 3:00 p.m., and we can also be reached for Sunday availability.</p>"
      }
    }
  },
  "apartments/mo/kansas-city/97-north-oak::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are pets allowed?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, we’d love to have your pets be part of our community. Cats and dogs are welcome with no weight limit. <a href=\"/apartments/mo/kansas-city/97-north-oak/pet-policy\"><strong>Breed restrictions and monthly fees</strong></a> apply.</p>"
      }
    }
  },
  "apartments/ms/ridgeland/trace-apts::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Do the apartments come with a private balcony?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, our floor plans feature private balconies so you can have your own personal outdoor space to relax. No matter when you step out, whether it’s for your morning coffee or unwinding with a book at the end of the day, you can always enjoy the outdoors at The Trace of Ridgeland.</p>"
      }
    }
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What are the criteria for the return of the security fee at the end of the lease?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Your fee can be returned after a damage assessment is completed and the apartment is left in good condition. We always recommend carefully filling out your move-in checklist, so there’s a clear record of the home’s condition from the start.</p>"
      }
    }
  },
  "apartments/ok/edmond/fountain-lake::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What are the fitness center access hours?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Work out on your own schedule at Fountain Lake. With access to our fitness center, you can enjoy early morning sessions or late-night workouts at your convenience. Temporary closures for cleaning and maintenance may occur.</p>"
      }
    }
  },
  "apartments/ok/edmond/villas-at-stonebridge::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are there designated outdoor spaces for dogs and pets to play and socialize?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Your dog can run, play, and roam without a leash inside our on-site bark park. It’s a secure fenced area, so you can easily relax while your pet burns off energy and meets other dogs in our community.</p>"
      }
    }
  },
  "apartments/ok/moore/mission-point::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What pets are allowed at Mission Point?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We welcome both cats and dogs to our pet-friendly apartments. There is no weight limit, though we do have a maximum of two pets per home, and all pets are subject to management approval. <a href=\"/apartments/ok/moore/mission-point/pet-policy\"><strong>Review our pet policy page</strong></a> for further details.</p>"
      }
    }
  },
  "apartments/ok/norman/artisan-crossing-apts::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are there handicap accessible homes available?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\"><a href=\"/accessibility-statement\"><strong>We are committed</strong></a> to providing a quality home to all our tenants. Handicap apartments are offered at Artisan Crossing, though availability may be limited. <a href=\"/apartments/ok/norman/artisan-crossing-apts/contact-us\"><strong>Please contact our office</strong></a> today to learn more about our ADA accessible options and their availability.</p>"
      }
    }
  },
  "apartments/ok/norman/cimarron-trails-apts::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is subletting permitted, and if so, what is the approval process?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">No, subletting is not permitted at Cimarron Trails. This policy helps reduce liability for both our team and the renter. If you have questions about changes to your lease, <a href=\"/apartments/ok/norman/cimarron-trails-apts/contact-us\"><strong>please contact our office</strong></a> to talk to a property manager.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/24hundred-apartments::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is parking available for residents?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Ample parking is available for all our residents. Our community has a vast parking lot that is sure to accommodate your vehicles with <a href=\"/apartments/ok/oklahoma-city/24hundred-apartments/neighborhood\"><strong>easy access to downtown OKC</strong></a> via Lake Hefner Parkway. We also offer apartments with private heated garage spaces for added security against the sun and seasons.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/chisholm-pointe::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are there communal grilling areas or outdoor dining spaces available to residents?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We have plenty of outdoor amenities for everyone to enjoy, including your friends, family, and all your guests. You can use our outdoor fire pit, dog park, clubhouse, and pickleball court for endless afternoons of fun.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How do I submit a maintenance request?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We prioritize fast response time during our maintenance visits. You can submit a maintenance request online through our resident portal or by <a href=\"tel:8335952557\"><strong>calling our office</strong></a>. Our team is ready to help you quickly.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/council-place-apartments::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Who should I contact if I have questions or concerns about my apartment?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We’re always here to listen to your questions, comments, or concerns. You can <a href=\"/apartments/ok/oklahoma-city/council-place-apartments/contact-us\"><strong>contact our office </strong></a>team online or by phone for general inquiries. For maintenance issues, you can easily submit a maintenance request ticket for our maintenance staff on the resident portal.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/cross-timber::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Do you offer apartments with accessibility features?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, we are committed to offering apartment homes that are accessible to everyone. Ground-level and ADA-compliant apartments are available, though they are limited in number. <a href=\"/apartments/ok/oklahoma-city/cross-timber/contact-us\"><strong>Please contact our leasing office</strong></a> for more information and to check on current availability.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy at Crown Pointe Apartments?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Many of our residents are proud pet owners, and we’re happy to welcome your furry companions too. There is no weight limit, though breed restrictions apply, and each household may have up to two pets. A one-time, non-refundable pet fee of $500 is due before move-in, and pet rent is $30 per month, per pet. <a href=\"/apartments/ok/oklahoma-city/crown-pointe-apartments/pet-policy\"><strong>Review our pet policy for further details.</strong></a></p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/hunter's-ridge-apts::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What size apartment homes are available?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">You can find the home that fits your lifestyle at Hunter’s Ridge. Our apartments are available in a range of sizes, from compact 525 sq. ft. 1 bedroom layouts to spacious 1,078 sq. ft. 2 bedroom, 2 bathroom homes. Browse our <a href=\"/apartments/ok/oklahoma-city/hunter-s-ridge-apts/floor-plans\"><strong>floor plans</strong></a> to see our options.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/park-at-tuscany::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Do you offer homes with attached garages?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, select apartment homes <a href=\"/apartments/ok/oklahoma-city/park-at-tuscany/floor-plans\"><strong>feature personal attached garages</strong></a> to store your car indoors and protect it from the elements outside. Additional fees apply to homes with garage access.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/persimmon-square-apartments::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is there a lifeguard on duty at the pool?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">No, there is not a lifeguard on duty at our community pool. For safety, we ask that all residents and guests follow posted pool rules. Enjoy a relaxing swim or time in the sun responsibly at our <a href=\"/apartments/ok/oklahoma-city/persimmon-square-apartments/photos\"><strong>beautiful resort-style pool</strong></a>.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/prairie-springs-i::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are washer and dryer connections available in the homes?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our homes come with washer and dryer connections, so you can bring your own machines and do laundry conveniently inside your apartment. We also have on-site laundry facilities that are an easy and reliable option.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/stonehorse-crossing::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What kind of connection or internet options are available?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Every apartment already has the equipment and wiring you need to get high-speed internet, so you won’t have to set anything up on your own. To get started, <a href=\"https://protect.checkpoint.com/v2/r01/___https:/www.cox.com/quickconnect___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6Mzc3YzFiMDc4ZDFjZjc4YzIxNGU2NzA2Y2U1ZTg3YmM6Nzo0MWY4OmFlYjBlMDQ4MTA0NDdkMDA4ZDIzOWJlZjJhMGI2MzliNDZlM2I1NTVkZWY5YmQ1YTI3ZmVlODE4ODc5ZWE5Mzc6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>pick a plan with Cox</strong></a> that fits what you need, whether it’s for school, work, or streaming your favorite shows.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/summerfield-place-apts::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is there cable, internet, or TV service included?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Your apartment home is already set up for cable and already has <a href=\"https://protect.checkpoint.com/v2/r01/___https:/www.cox.com/quickconnect___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6Mzc3YzFiMDc4ZDFjZjc4YzIxNGU2NzA2Y2U1ZTg3YmM6Nzo0MWY4OmFlYjBlMDQ4MTA0NDdkMDA4ZDIzOWJlZjJhMGI2MzliNDZlM2I1NTVkZWY5YmQ1YTI3ZmVlODE4ODc5ZWE5Mzc6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>a WiFi modem installed by Cox</strong></a>. This means you don’t have to worry about bringing your own equipment or waiting for someone to come out and install it.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/tammaron-village-apartments::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is emergency maintenance available, and how does that work?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, our maintenance team is here to help you with a large variety of items that may pop up. Our maintenance team works Monday through Friday and is available for emergencies after hours as well. If something serious happens after we close our office for the day, like a leak, a broken heater, or anything that needs quick attention, we can still help.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/warrington-apartments::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Do you have covered vehicle parking?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, we offer covered parking spaces to give your vehicle extra protection. The rate for covered parking is $25 per month. Upon signing up for covered parking, you will be assigned a space on a first-come, first-served basis.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Who do I speak to if I have any questions about my lease?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Any questions about your lease should be directed to our professional on-site management team, which includes the property manager. <a href=\"/apartments/ok/oklahoma-city/waters-edge-apartments/contact-us\"><strong>Contact us</strong></a> online to book an appointment or <a href=\"https://protect.checkpoint.com/v2/r01/___tel:8559064626___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6YTk3MGMyYThhNmY0Nzg4ZDVlMjMyNGJjMmMxMWFjZDI6NzpkMjBkOjcwZDk2MzkyMWYzZmQ1MWYxNmNkOWJkN2RlZDQwM2VhY2Y2NGU2MDAwMWU5YzRlNWFhNzJkZGZhNjIzY2U0ZjY6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>give us a call</strong></a> for immediate questions today!</p>"
      }
    }
  },
  "apartments/ok/owasso/coffee-creek::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What do I do if I lose my key?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">You should <a href=\"/apartments/ok/owasso/coffee-creek/contact-us\"><strong>reach out to the leasing office</strong></a> or property manager. We are available during regular office hours, but if you happen to lose your key after hours, we also have a 24-hour emergency number.</p>"
      }
    }
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are private patios or balconies available?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We offer a select number of apartment homes that feature private balconies or patios for outdoor enjoyment. Please <a href=\"/apartments/ok/owasso/cottages-at-tallgrass-point/contact-us\"><strong>contact our leasing office</strong></a> directly, and we will be happy to guide you toward the specific apartment homes that currently have these features available.</p>"
      }
    }
  },
  "apartments/ok/tulsa/barrington-apartments::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How can I schedule a tour of Barrington Apartments in Tulsa, OK?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Tours can be scheduled by contacting the leasing office by <a href=\"tel:%20(855)%20876-8820\"><strong>phone</strong></a> or <a href=\"/apartments/ok/tulsa/barrington-apartments\"><strong>online</strong></a>. Prospective residents can request a <strong>self-guided tour</strong>, or a guided tour to explore the apartment community and view available apartment homes in person.</p>"
      }
    }
  },
  "apartments/ok/tulsa/cascata-luxury-apartments::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Where are Cascata Luxury Apartments located in Tulsa, OK?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Cascata Luxury Apartments is located in south Tulsa near the Woodland area, close to parks, shopping, dining, and everyday conveniences. The location provides easy access to nearby attractions while offering a comfortable residential setting within the Union School District.</p>"
      }
    }
  },
  "apartments/ok/tulsa/cedar-glade-apts::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What recreational amenities are available at Cedar Glade Apartments?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Cedar Glade Apartments features multiple swimming pools, a community courtyard, and a 24-hour fitness center with free weights. These shared spaces provide residents with options to relax, stay active, or spend time outdoors close to home.</p>"
      }
    }
  },
  "apartments/ok/tulsa/cedar-ridge-apartments::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are fireplaces available at Cedar Ridge Apartments?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\"><strong> </strong>Yes, select units come with an LED fireplace. If you want a fireplace in your apartment, feel free to <a href=\"tel:8556052070\"><strong>call us</strong></a> so we can make sure you get what you’re looking for.</p>"
      }
    }
  },
  "apartments/ok/tulsa/chardonnay::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Does Chardonnay Apartment Homes have a swimming pool?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, you can relax at our beautiful resort-style swimming pool and enjoy our lovely picnic area. It is the perfect spot to cool off, share a meal, and soak up the sun during those warm summer months!</p>"
      }
    }
  },
  "apartments/ok/tulsa/country-hollow-apartments::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are pets allowed in Country Hollow Apartments?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Absolutely! You will be able to bring a maximum of two pets with no weight limit. Keep in mind there is a $500 one-time fee, and rent is $30 per pet per month. Read more about our <a href=\"/apartments/ok/tulsa/country-hollow-apartments/pet-policy\"><strong>pet-friendly policies</strong></a> and <a href=\"tel:8557380148\"><strong>contact us</strong></a> for any questions!</p>"
      }
    }
  },
  "apartments/ok/yukon/park-at-westpointe::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Do you have a swimming pool?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We have not one, but two fantastic resort-style swimming pools in our apartment community for you to enjoy. Our exclusive swimming spaces are a favorite among residents and guests, and they are a great place to relax, unwind, and cool off on sunny days. Lounge by the water or take a refreshing dip just steps from your front door.</p>"
      }
    }
  },
  "apartments/ok/yukon/the-ridge-@-66::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How can I pay my bills?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">You can pay rent online through <a href=\"https://ridgeat66apartmentsyukon.securecafe.com/residentservices/the-ridge-66/userlogin.aspx target= target=\"_blank\"\"_blank\"\"><strong>our resident portal</strong></a>. We also <a href=\"https://getflex.com/ target= target=\"_blank\"\"_blank\"\"><strong>partner with flex</strong></a> so you can spread out your payment and make it easier to manage while keeping all your bills on time.</p>"
      }
    }
  },
  "apartments/tx/hewitt/icon-at-hewitt::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is there a community dog park?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, we have a dog park for all our residents and their furry friends to enjoy. This fenced area is a great place for your dog to socialize and exercise. We ask our residents to be mindful of others and clean up after your pets while using the facility.</p>"
      }
    }
  },
  "apartments/tx/lubbock/icon-at-lubbock::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How long is the typical lease term?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We typically offer 12-month leases across all the homes available in our community. If you are looking for additional accommodations or already know you need to end your lease early, please don’t hesitate to <strong><u>call us</u></strong> to discuss your options.</p>"
      }
    }
  },
  "apartments/tx/temple/portico-at-friars-creek-apts::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What are some of the closest grocery stores, restaurants, and shopping centers?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\"><a href=\"/apartments/tx/temple/portico-at-friars-creek-apts/neighborhood\"><strong>Our community is conveniently located</strong></a> near the heart of the action, placing shopping, dining, and entertainment just minutes away. Temple Mall and Market Place Shopping Center are within easy reach for everyday needs and unique finds. Dining favorites like Megg’s Cafe and Roopa’s Kitchen are also nearby, so it’s simple to enjoy a night out without traveling far.</p>"
      }
    }
  },
  "apartments/tx/waco/bend-at-new-road::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What happens if I lose my key?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Don’t worry! Just visit or <strong><u>call our front office</u></strong>, and we’ll help you get back inside as quickly as possible. Our office hours are:<br> <br>Monday through Thursday from 8:30 a.m. to 5:30 p.m.<br>Fridays from 8:30 a.m. to 5:00 p.m.<br>Saturdays from 10:00 a.m. to 3:00 p.m.<br>Sundays, call for availability</p>"
      }
    }
  },
  "apartments/tx/waco/tuscany-ranch-apartments::propertyfaq.dropdown_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "When can I use the fitness center?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">It&#8217;s always a good hour to work out in our fitness center. Our fitness center is open 24 hours a day, seven days a week, so you can work out at your own convenience. Temporary closures may occur for cleaning and maintenance purposes.</p>"
      }
    }
  },
  "apartments/ks/wichita/newport-wichita::propertyfaq.dropdown_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are the fireplaces wood or gas?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We opt for the classic wood-burning fireplaces to bring both charm and warmth to your living space. Fireplaces are available in select <a href=\"/apartments/ks/wichita/newport-wichita/floor-plans\"><strong>1 and 2 bedroom floor plans</strong></a>.</p>"
      }
    }
  },
  "apartments/ks/wichita/portofino::propertyfaq.dropdown_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is parking available at Portofino Apartments?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Both indoor and outdoor parking are available at Portofino Apartments. We offer garages to protect your vehicle from the elements and provide extra peace of mind. To learn more about garage availability, please <a href=\"/apartments/ks/wichita/portofino/contact-us\"><strong>contact our leasing office</strong></a>.</p>"
      }
    }
  },
  "apartments/ks/wichita/raintree-apts::propertyfaq.dropdown_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is on-site laundry available?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, we provide convenient on-site laundry facilities for all our residents. This allows you to take care of your chores quickly and easily without ever having to leave the community.</p>"
      }
    }
  },
  "apartments/ks/wichita/villas-of-waterford::propertyfaq.dropdown_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is the kitchen stove gas or electric?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Enjoy the benefits of modern all-electric living in your kitchen. All apartment homes at Villas of Waterford feature electric stoves to whip up easy meals, and our <a href=\"/apartments/ks/wichita/villas-of-waterford/amenities\"><strong>energy-efficient electric appliances</strong></a> make mealtime convenient.</p>"
      }
    }
  },
  "apartments/mo/independence/the-adirondack::propertyfaq.dropdown_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What amenities come with my apartment?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Every apartment home comes equipped with a dishwasher, microwave, garbage disposal, refrigerator, ceiling fan, personal thermostat, and washer-dryer connections. We also offer options for in-apartment fireplaces, <a href=\"/apartments/mo/independence/the-adirondack/floor-plans\"><strong>private patios, porches, and attached garages</strong></a>.</p>"
      }
    }
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek::propertyfaq.dropdown_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are there pet facilities?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, your four-legged friends will feel right at home here. We have two fully fenced bark parks—one for small dogs and the other for large.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/24hundred-apartments::propertyfaq.dropdown_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are the appliances new at 24Hundred Apartments?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Every home at 24Hundred is supplied with <a href=\"/apartments/ok/oklahoma-city/24hundred-apartments/amenities\"><strong>modern and efficient appliances</strong></a>, including ovens, microwaves, stovetops, and refrigerators. Each appliance features stylish stainless steel finishes to complement your kitchen design, and all homes also offer connections for washers and dryers.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/warrington-apartments::propertyfaq.dropdown_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are washers and dryers included in the apartment?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Are washers and dryers included in the apartment?</p>"
      }
    }
  },
  "apartments/ok/owasso/coffee-creek::propertyfaq.dropdown_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are these apartment homes pet-friendly?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Absolutely! Your pet is your family, and they deserve to live comfortably with you. You will even find an on-site dog park for your furry friend to play! Don’t forget to check our <a href=\"/apartments/ok/owasso/coffee-creek/pet-policy\"><strong>pet-friendly policies</strong></a><strong>.</strong></p>"
      }
    }
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point::propertyfaq.dropdown_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Where do I pick up my mail?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>When you rent an apartment at Cottages at Tallgrass Point, you get on-site management with package receiving services so your deliveries are secure. Pick up mail at the our centrally located mailboxes at the clubhouse!</p>"
      }
    }
  },
  "apartments/ok/tulsa/cascata-luxury-apartments::propertyfaq.dropdown_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How can I schedule a tour of Cascata Luxury Apartments in Tulsa, OK?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Prospective residents can schedule a guided tour with a member of the leasing team or arrange a self-guided tour to explore the apartment community independently. Tours can be requested <a href=\"/apartments/ok/tulsa/cascata-luxury-apartments\"><strong>online</strong></a> or by contacting the leasing office directly.</p>"
      }
    }
  },
  "apartments/ok/tulsa/cedar-glade-apts::propertyfaq.dropdown_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How do residents apply to live at Cedar Glade Apartments in Tulsa, OK?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>Prospective residents can apply <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://cedargladeapartmentstulsa.securecafe.com/onlineleasing/cedar-glade-apts/register.aspx\"><strong>online</strong></a> after touring the apartment community. Tours are available with the leasing team or through a self-guided option for those who prefer to explore independently.</p>"
      }
    }
  },
  "apartments/ok/tulsa/cedar-ridge-apartments::propertyfaq.dropdown_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are the apartments equipped with a dishwasher?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes! All our apartments have a dishwasher, so you can save time every day from washing the dishes. Perfect if you value comfort!</p>"
      }
    }
  },
  "apartments/ok/tulsa/country-hollow-apartments::propertyfaq.dropdown_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What if my apartment doesn’t have an in-home washer and dryer?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">There is an on-site laundry facility that you can use whenever you want! This comes included with rent and is kept clean at all times.</p>"
      }
    }
  },
  "apartments/ok/yukon/the-ridge-@-66::propertyfaq.dropdown_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Do I have a personal thermostat?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, every apartment comes with a personal thermostat, allowing you to control your central heating and cooling and maintain your home&#8217;s comfort level throughout the year.</p>"
      }
    }
  },
  "apartments/tx/lubbock/icon-at-lubbock::propertyfaq.dropdown_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Do you offer wheelchair-accessible homes at The Icon at Lubbock?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, <a href=\"/accessibility-statement\"><strong>we are committed to accessibility</strong></a> for all our residents. Wheelchair-accessible apartment homes are available at ground level, featuring layouts and entryways designed to facilitate easier movement throughout your space.</p>"
      }
    }
  },
  "apartments/tx/temple/portico-at-friars-creek-apts::propertyfaq.dropdown_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is there a move-out checklist provided to help ensure I get my full security fee"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, we provide a detailed move-out checklist to help guide you through the process. This checklist outlines cleaning expectations, key returns, and other steps that must be completed before your final inspection. This list is signed by both parties at both move-in and when notice is given. You can also request a walk through with management at move-out, but it is not required.</p>"
      }
    }
  },
  "apartments/tx/waco/bend-at-new-road::propertyfaq.dropdown_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What documents do I need to submit with my application (e.g., photo ID, pay stubs)?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">To complete your application, you’ll need to provide a valid government-issued photo ID along with recent proof of income, such as pay stubs or an employment verification letter. Depending on your situation, additional documents, such as rental history or bank statements, may also be requested. Having these ready helps streamline the approval process, so you can move in without unnecessary delays.</p>"
      }
    }
  },
  "apartments/tx/waco/tuscany-ranch-apartments::propertyfaq.dropdown_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is there a lifeguard on staff?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">No, there is not a lifeguard on staff at our community pool. For your well-being, you and your guests should always exercise caution and follow posted guidelines while swimming or spending time near the water.</p>"
      }
    }
  },
  "apartments/ks/wichita/villas-of-waterford::propertyfaq.dropdown_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What restaurants are near the Villas at Waterford Apartments?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">There are several restaurants near our apartments. You can get to popular chains like Buffalo Wild Wings, Five Guys, and Chipotle in just a few minutes. You can also visit more local eateries like Mulligan’s Pub and Wichita Sunflower Cupcakes for dessert.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/warrington-apartments::propertyfaq.dropdown_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are pets allowed?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Are pYes. A pet is part of the family, so you are welcome to bring your pet with you to your new home. <a href=\"/apartments/ok/oklahoma-city/warrington-apartments/pet-policy\"><strong>Review our pet policy</strong></a> for more details.</p>"
      }
    }
  },
  "apartments/ks/maize/watercress/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the application and administrative fee, and is any portion refundable?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Every person who applies will need to pay a nonrefundable application fee. This fee helps cover the cost of running background and credit checks, which we require before we approve your move-in. You will also pay an administrative fee, which we can refund you if you cancel your application within 24 hours or if it’s denied.</p>"
      }
    }
  },
  "apartments/ks/wichita/aspen-park/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How much does an apartment in Wichita cost?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Several factors come into play when determining the pricing of an apartment, including the size and type of apartment you choose and the current housing market. <a href=\"/apartments/ks/wichita/aspen-park/contact-us\"><strong>Contact us</strong></a> online to learn more about rent pricing today!</p>"
      }
    }
  },
  "apartments/ks/wichita/cottages-at-crestview/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What rent payment options are available?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">To make payments easier, take advantage of flexible <a href=\"https://protect.checkpoint.com/v2/r01/___https:/getflex.com/___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6YTk3MGMyYThhNmY0Nzg4ZDVlMjMyNGJjMmMxMWFjZDI6NzpmNDc0OmFjZTFjYjEzN2JkZDFkYmZjNDA3YzYzOTcyZmVkYTgwOGEzNDA3ZGFhM2I2ZWEwOTQ1YmM1NzcxOTBiZjgzZmM6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>payment options with flex</strong></a>. Flex makes it easy to split your bill across several installments.</p>"
      }
    }
  },
  "apartments/ks/wichita/crown-chase-apts/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What are the fees for pets?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\"><a href=\"/apartments/ks/wichita/crown-chase-apts/pet-policy\"><strong>Our pet policy</strong></a> does not include a weight limit, but there is a maximum of two pets per apartment, and breed restrictions may apply. A one-time non-refundable fee equal to half of one month&#8217;s rent is due before move-in, as well as $30 a month in pet rent.</p>"
      }
    }
  },
  "apartments/ks/wichita/huntington-park/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What rent payment options are available?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Use our <a href=\"https://protect.checkpoint.com/v2/r01/___https:/getflex.com/___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6YTk3MGMyYThhNmY0Nzg4ZDVlMjMyNGJjMmMxMWFjZDI6NzpmNDc0OmFjZTFjYjEzN2JkZDFkYmZjNDA3YzYzOTcyZmVkYTgwOGEzNDA3ZGFhM2I2ZWEwOTQ1YmM1NzcxOTBiZjgzZmM6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>payment services through flex</strong></a> to make splitting payments as easy as possible. This service is a smart solution for individuals looks to make their rent more budgeable.</p>"
      }
    }
  },
  "apartments/ks/wichita/newport-wichita/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is your pet policy, and are there any associated fees?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\"><a href=\"/apartments/ks/wichita/newport-wichita/pet-policy\"><strong>Cats and dogs are welcome at Newport Apartments</strong></a> with a limit of two pets per home. Breed restrictions apply, and each pet requires a $500 non-refundable fee along with $30 monthly pet rent.</p>"
      }
    }
  },
  "apartments/ks/wichita/raintree-apts/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What does it cost to rent at Raintree Apartments?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our rental rates fit a variety of budgets and depend on the floor plan you choose. Please <a href=\"/apartments/ks/wichita/raintree-apts/contact-us\"><strong>contact our leasing team</strong></a> for current pricing.</p>"
      }
    }
  },
  "apartments/ks/wichita/remington-wichita/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What amenities come included with rent?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">With your apartment home, you have access to<a href=\"/apartments/ks/wichita/remington-wichita/amenities\"><strong>all amenities</strong></a> available in The Remington Apartment Homes in <a href=\"/blog/an-expert-guide-on-the-best-neighborhoods-in-wichita-ks\"><strong>Wichita, KS</strong></a>, including an outdoor swimming pool, a 24-hour fitness center, 24-hour emergency maintenance, and our business center.</p>"
      }
    }
  },
  "apartments/ks/wichita/silver-springs/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How much does it cost to rent an apartment in Silver Springs?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Monthly rent at Silver Springs is determined by several factors, primarily the floor plan size and the specific unit type you choose. For the most accurate and up-to-date pricing for your preferred move-in date, please visit our current availability or<a href=\"/apartments/ks/wichita/silver-springs/contact-us\"><strong>contact our leasing office.</strong></a></p>"
      }
    }
  },
  "apartments/ks/wichita/villas-of-waterford/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Can I pay rent weekly instead of monthly?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We partner with<a href=\"https://protect.checkpoint.com/v2/r01/___https:/getflex.com/___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6Mzc3YzFiMDc4ZDFjZjc4YzIxNGU2NzA2Y2U1ZTg3YmM6NzowNjk2OjlkZmIwNzc5NTM4MDlhMDNkMmRkMzg5NDZiODk3YjllZTMzZWU2NmM1Mjg5NWZkYzFjZWRiMjU5Mzk5ZmYwNGI6cDpUOk4 target= target=\"_blank\"\"_blank\"\"> flex.</a>, allowing you to break up your payments into smaller, more manageable chunks each week as long as all payments are made through flex.</p>"
      }
    }
  },
  "apartments/mo/independence/the-adirondack/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are there any fees for pets?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, there are pet fees. We allow a maximum of two pets per home, with breed restrictions and a weight limit in place. A $500 non-refundable fee is charged per pet, and monthly pet rent is $30.</p>"
      }
    }
  },
  "apartments/mo/kansas-city/97-north-oak/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are there any late fees for rent payments?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">There is an additional fee of $5 for every day the rent is past due, subject to change. If you anticipate a payment may be late, please contact our office in advance so we can discuss your options.</p>"
      }
    }
  },
  "apartments/ms/ridgeland/trace-apts/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What rent payment options are available?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We want to make your life easier, which is why we offer flexible <a href=\"https://protect.checkpoint.com/v2/r01/___https:/getflex.com/___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6YTk3MGMyYThhNmY0Nzg4ZDVlMjMyNGJjMmMxMWFjZDI6NzpmNDc0OmFjZTFjYjEzN2JkZDFkYmZjNDA3YzYzOTcyZmVkYTgwOGEzNDA3ZGFhM2I2ZWEwOTQ1YmM1NzcxOTBiZjgzZmM6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>payment options through flex</strong></a>. This also allows you to budget wisely, as you can split rent into multiple payments.</p>"
      }
    }
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is Trails at Aspen Creek a pet-friendly community, and what are the restrictions?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We welcome your family to join our community, including cats and dogs. You can bring up to <a href=\"/apartments/ok/broken-arrow/trails-at-aspen-creek/pet-policy\"><strong>two pets</strong></a>, with a monthly rent of $30 per pet and a non-refundable fee of $500 per pet. Breed restrictions apply, so reach out to our office for the full list.</p>"
      }
    }
  },
  "apartments/ok/edmond/fountain-lake/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are there any fees for pets?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our pet policy at Fountain Lake Apartments allows for up to two pets per home. A $500 non-refundable pet fee is due at signing, and a $30 monthly pet rent per pet applies. <a href=\"/apartments/ok/edmond/fountain-lake/pet-policy\"><strong>Review our pet policy page</strong></a> for more details.</p>"
      }
    }
  },
  "apartments/ok/edmond/villas-at-stonebridge/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the application fee, and when is it due?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">There is a $75 application fee for each adult who applies. This fee is nonrefundable, which means we can’t return it once it’s paid. It helps cover the cost of checking important information like your background and credit history, so we can fairly review your application.</p>"
      }
    }
  },
  "apartments/ok/moore/mission-point/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "When is the security deposit due?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Your security deposit is due with your application to hold your apartment off-market, as well as any applicable fees, before your move-in date. If you have any questions or concerns before your move, please do not hesitate to <a href=\"https://protect.checkpoint.com/v2/r01/___tel:8337677710___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6Mzc3YzFiMDc4ZDFjZjc4YzIxNGU2NzA2Y2U1ZTg3YmM6NzpiNmYyOjY4ZGNlNjMxYjI4YTA3MjJlMmE5MjYzMTk2NDQ4MDEzNmJhMDU4YjI2ZjFiOTQ1OTM3ZTg4ZGFhYmI1MDE1ODk6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>call our team</strong></a>.</p>"
      }
    }
  },
  "apartments/ok/norman/artisan-crossing-apts/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Who provides the internet?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Every apartment comes with a preinstalled Wi-Fi modem powered by <a href=\"https://www.cox.com/residential/mdu-community/quick-connect.html?sc_id=cr_dm_camp_z_quickconnect_vanity target= target=\"_blank\"\"_blank\"\"><strong>Cox </strong></a>Internet Services. All residents are individually responsible for paying their internet bill, which is billed separately from rent.</p>"
      }
    }
  },
  "apartments/ok/norman/cimarron-trails-apts/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is your policy regarding renters&#8217; insurance, and is it required?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">No, renters’ insurance is not required however it is highly recommended. Contact your current insurance agency to add on renters coverage! </p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the security fee amount, and is it refundable?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Before move-in day, you&#8217;ll need to submit your security fee. This fee amount varies based on unit size is refundable and is used to cover the cost of any damage incurred during your lease.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What additional fees can I expect along with rent?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Rent and utilities are billed separately. The tenant is responsible for these payments. Otherwise, there is a monthly pet rent of $30 per pet, along with an initial nonrefundable pet fee of $500. Water is billed through the property and must be paid with rent.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Can I apply with a co-signer, and what are their specific requirements?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, a co-signer may be an option for you. In these situations, both signees are jointly and individually responsible for paying rent and utilities. Co-signers also share responsibility for any damages that may occur during the lease term.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/council-place-apartments/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What types of damage constitute a deduction from my security deposit?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">It’s possible to receive your entire security deposit back if your apartment is left in ideal condition. Some of the most common deductions from security fees include fees for carpet cleaning, patching wall damage, or replacing broken fixtures. Any excessive wear and tear beyond standard use may also result in partial deductions.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/cross-timber/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "If I pay rent early, is there a discount or incentive?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">While there is no discount for early rent payments, we do offer options to make it easier to keep up with your bills. You can use our <a href=\"https://getflex.com/ target= target=\"_blank\"\"_blank\"\"><strong>flex. payment plan</strong></a> to split your monthly bill into smaller weekly payments. Even with this plan, your rent will still reflect as paid on time.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Can I set up recurring or automatic rent payments?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, you can have your rent paid each month automatically. Set up direct deposit for automatic withdrawals through your bank on our online portal.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/hunter's-ridge-apts/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Can I pay rent weekly instead of monthly?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We partner with <a href=\"https://protect.checkpoint.com/v2/r01/___https:/getflex.com/___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6Mzc3YzFiMDc4ZDFjZjc4YzIxNGU2NzA2Y2U1ZTg3YmM6NzowNjk2OjlkZmIwNzc5NTM4MDlhMDNkMmRkMzg5NDZiODk3YjllZTMzZWU2NmM1Mjg5NWZkYzFjZWRiMjU5Mzk5ZmYwNGI6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>flex.</strong></a>, allowing you to break up your payments into smaller, more manageable chunks each week. As long as all payments are made through flex. are on time, your bill will show as paid in full at the end of the month.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/park-at-tuscany/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are utilities and rent billed together?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Utilities and rent are billed separately at Park at Tuscany. We split these costs individually to give each apartment fair, transparent pricing, so you only have to pay for the utilities you use. You may experience separate due dates for each utility, though they are all billed monthly. </p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/persimmon-square-apartments/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the application fee?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">A $75 application fee is due when submitting your application at Persimmon Square. This fee helps cover administrative and processing costs during the approval process. You can easily <a href=\"https://protect.checkpoint.com/v2/r01/___https:/persimmonsquareapartmentsoklahomacity.securecafe.com/onlineleasing/persimmon-square-apartments/register.aspx___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6Mzc3YzFiMDc4ZDFjZjc4YzIxNGU2NzA2Y2U1ZTg3YmM6NzpmZTEwOjk5ZDQ3MzU2NmJlMWFmNzJjMDljNzE0Nzg0YzE5ZTdkMmJkZGY3Mjk2OWY4YmI2YWY4YmZhNjg3OGU2NmI1Y2E6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>apply online</strong></a> to view all fees due at the time of application and move-in.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What fees and deposits are required when I apply for a 1 bedroom, 2 bedroom, or 3 bedroom home?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">When you <a href=\"https://protect.checkpoint.com/v2/r01/___https:/prairiespringsapartmentsoklahomacity.securecafe.com/onlineleasing/prairie-springs-i-ii/oleapplication.aspx?stepname=Apartments&amp;myOlePropertyId=48344&amp;floorPlans=850222___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6Mzc3YzFiMDc4ZDFjZjc4YzIxNGU2NzA2Y2U1ZTg3YmM6NzpjMGJjOjg3ZDdmM2I2ODgzOGFlMzJiZDM3YjY3YmViYjg4Y2U5NDM0YThkM2E0Zjk2ZWZiODVjYWE1NWZmZWQ3YzUyNTQ6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>apply for an apartment</strong></a>, you’ll need to pay a nonrefundable application fee and an administrative fee. These payments help the office check your background, review your information, and process your application. As well as a security deposit to secure an apartment off market. Our system requires you to select a unit (waitlist or actual unit) when applying so both are paid together.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/stonehorse-crossing/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What payment options are available for rent?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">You can pay your rent each month through our online resident portal using ACH, a credit card, or a debit card. You can also use <a href=\"https://protect.checkpoint.com/v2/r01/___https:/getflex.com/___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6Mzc3YzFiMDc4ZDFjZjc4YzIxNGU2NzA2Y2U1ZTg3YmM6NzowNjk2OjlkZmIwNzc5NTM4MDlhMDNkMmRkMzg5NDZiODk3YjllZTMzZWU2NmM1Mjg5NWZkYzFjZWRiMjU5Mzk5ZmYwNGI6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>flex.</strong></a> to split your rent into smaller payments during the month, which can make it easier to stay on track.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/summerfield-place-apts/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the application and administrative fee, and is any portion refundable?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Every person who applies will need to pay a nonrefundable application fee. This fee helps cover the cost of running background and credit checks, which we require before we approve your move-in. You will also pay an administrative fee, which we can refund you if you cancel your application within 24 hours or if it’s denied.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/tammaron-village-apartments/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What are the application and administrative fees for my apartment home?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We charge a nonrefundable $75 application fee, which covers the cost of running your background and credit checks. In addition, there’s a separate administrative fee due at the time you apply. This fee may be refundable if we deny your application or if you choose to cancel within the required timeframe.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/warrington-apartments/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How much is the monthly rent, and what is included?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Your rent is determined based on the size and type of home you select and the current market. Your rent includes access to all our <a href=\"/apartments/ok/oklahoma-city/warrington-apartments/amenities\"><strong>on-site amenities</strong></a>, including our swimming pool and fitness center.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What amenities are included in my rent?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Access to all our <a href=\"/apartments/ok/oklahoma-city/waters-edge-apartments/amenities\"><strong>on-site amenities</strong></a>, such as our fitness center and swimming pools, is included in your monthly rent. Utilities like your electric bill are charged separately from rent each month. Water is billed separately and is paid along with rent.</p>"
      }
    }
  },
  "apartments/ok/owasso/coffee-creek/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How much is the application fee?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The application fee is $75, and is required for all who wish to live here. This expense covers credit checks and background checks. <a href=\"https://coffeecreekapartmentsowasso.securecafe.com/onlineleasing/coffee-creek/register.aspx target= target=\"_blank\"\"_blank\"\"><strong>Start your application</strong></a> today!</p>"
      }
    }
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How can I pay rent?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>You can pay electronically through your online portal, through our WIPS system, or through our <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://getflex.com/ target= target=\"><strong>payment system, flex</strong></a>, to make your life easier. This platform allows you to pay the full amount at once or split payments throughout the month, which is perfect for budgeting.</p>"
      }
    }
  },
  "apartments/ok/tulsa/barrington-apartments/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Whatfloor plan options are available at Barrington Apartments in Tulsa, OK?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Barrington Apartments offers 1-, 2-, and 3-bedroom apartment homes and townhomes. Floor plans range from 600 sq. ft. to 1,360 sq. ft., with layouts designed to accommodate a variety of living preferences.</p>"
      }
    }
  },
  "apartments/ok/tulsa/cascata-luxury-apartments/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What floor plan options are available at Cascata Luxury Apartments in Tulsa, OK?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Cascata Luxury Apartments offers one and 2-bedroom apartment homes with six distinct floor plan layouts. These options include designs with an added study or flex space, as well as select homes with optional fireplaces or attached garages.</p>"
      }
    }
  },
  "apartments/ok/tulsa/cedar-glade-apts/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What apartment sizes are available at Cedar Glade Apartments in Tulsa, OK?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Cedar Glade Apartments offers 1, 2, and 3-bedroom apartment homes. Floor plans range from approximately 725 sq. ft. to 1,250 sq. ft., providing options for individuals, roommates, or larger households.</p>"
      }
    }
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What amenities come included with rent?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">All our common amenities are available to use when you pay rent. This includes the fitness center, poolside grill and chill area, resort-style pool with sundeck, the resident clubhouse, and the internet cafe with complimentary coffee and tea bar.</p>"
      }
    }
  },
  "apartments/ok/tulsa/chardonnay/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How can I pay my rent?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>Paying rent is simpler than ever with our flexible payment options <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://getflex.com/ target= target=\"><strong>through flex</strong></a>, which allows you to split costs into manageable installments, or through our online resident portal. Whether you’re budgeting for yourself, you can handle your payments with just a few easy clicks!</p>"
      }
    }
  },
  "apartments/ok/tulsa/country-hollow-apartments/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How can I pay my rent?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>Paying your rent is simple when you use our <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://getflex.com/ target= target=\"><strong>flex payment tool</strong></a>! It’s a great way to split the payments and manage your monthly budget with ease. We can also take electronic payments.</p>"
      }
    }
  },
  "apartments/ok/yukon/park-at-westpointe/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Can multiple roommates split rent payments online?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, you can split rent payments with roommates. Please make sure that each tenant has their own personal residential account for the easiest online payment options. All payments can be made <a href=\"https://protect.checkpoint.com/v2/r01/___https:/parkatwestpointeapartmentsyukon.securecafe.com/residentservices/park-at-westpointe-i/userlogin.aspx___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6Mzc3YzFiMDc4ZDFjZjc4YzIxNGU2NzA2Y2U1ZTg3YmM6NzozZTJiOjIwM2EyY2EyMjc5OTE4ZjgxNDhkZjE4YjgwZjM0OWE4Nzc1ODFmYWU1ZWYyOWJmYzExNjk3MjcwM2VmYTgyMTY6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>from our resident portal</strong></a>.</p>"
      }
    }
  },
  "apartments/ok/yukon/the-ridge-@-66/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Which homes have attached garages?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\"><a href=\"/apartments/ok/yukon/the-ridge-66/amenities\"><strong>Attached garages</strong></a> are available for our 1 and 2 bedroom lofts and townhomes. There is an additional monthly fee for homes with an attached garage.</p>"
      }
    }
  },
  "apartments/tx/hewitt/icon-at-hewitt/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What are the fees for pets at The Icon at Hewitt?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\"><a href=\"/apartments/tx/hewitt/icon-at-hewitt/pet-policy\"><strong>Our pet policy has no weight limit</strong></a>, though we do have a maximum of two pets per apartment. There is $35 a month in pet rent, and an initial $500 nonrefundable pet fee due before move-in.</p>"
      }
    }
  },
  "apartments/tx/lubbock/icon-at-lubbock/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the security fee amount, and is it refundable?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Before you move in, a security fee is required. The fee is subject to change based on which unit you select.<br> <br>This fee is refundable after you move out, minus any costs accrued for repairing damage or addressing outstanding charges.</p>"
      }
    }
  },
  "apartments/tx/temple/portico-at-friars-creek-apts/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the monthly rent, and what is included?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Monthly rent will vary depending on the type and size of the apartment you select. Included with your rent, you have access to all of our on-site amenities.</p>"
      }
    }
  },
  "apartments/tx/waco/bend-at-new-road/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Do you allow pets, and if so, what are the restrictions and fees?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\"><a href=\"/apartments/tx/waco/bend-at-new-road/pet-policy\"><strong>Cats and dogs, small and large, are all welcome</strong></a> at Bend at New Road. A maximum of two pets is permitted per apartment home, and breed restrictions do apply. Pet rent is $30 per month, along with a one-time $500 nonrefundable fee. Our community is designed to be pet-friendly, giving your four-legged friends plenty of space to feel at home.</p>"
      }
    }
  },
  "apartments/tx/waco/tuscany-ranch-apartments/floor-plans::propertyfloorplansfaq.item_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What are your restrictions and fees for pets?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We welcome <a href=\"/apartments/tx/waco/tuscany-ranch-apartments/pet-policy\"><strong>cats and dogs of all sizes</strong></a>, with no weight restrictions, although we have a two-pet maximum per apartment. Breed restrictions apply, and the pet rent is $30 per month, along with a one-time, nonrefundable $500 fee.</p>"
      }
    }
  },
  "apartments/ks/maize/watercress/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What payment options are available for rent?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">You can pay your rent each month through our online resident portal using ACH, a credit card, or a debit card. You can also use<a href=\"https://protect.checkpoint.com/v2/r01/___https:/getflex.com/___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6Mzc3YzFiMDc4ZDFjZjc4YzIxNGU2NzA2Y2U1ZTg3YmM6NzowNjk2OjlkZmIwNzc5NTM4MDlhMDNkMmRkMzg5NDZiODk3YjllZTMzZWU2NmM1Mjg5NWZkYzFjZWRiMjU5Mzk5ZmYwNGI6cDpUOk4 target= target=\"_blank\"\"_blank\"\"> <strong>flex.</strong></a> to split your rent into smaller payments during the month, which can make it easier to stay on track.</p>"
      }
    }
  },
  "apartments/ks/wichita/aspen-park/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What rent payment options are available?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">One way to make paying for your rent simpler is through our <a href=\"https://protect.checkpoint.com/v2/r01/___https:/getflex.com/___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6YTk3MGMyYThhNmY0Nzg4ZDVlMjMyNGJjMmMxMWFjZDI6NzpmNDc0OmFjZTFjYjEzN2JkZDFkYmZjNDA3YzYzOTcyZmVkYTgwOGEzNDA3ZGFhM2I2ZWEwOTQ1YmM1NzcxOTBiZjgzZmM6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>payment options with flex</strong></a>. This service lets you split your rent into multiple segments for effortless budgeting and allows you to easily budget your payments.</p>"
      }
    }
  },
  "apartments/ks/wichita/cottages-at-crestview/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What does my monthly rent include?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">With your apartment home, you have access to all our <a href=\"/apartments/ks/wichita/cottages-at-crestview/amenities\"><strong>on-site amenities</strong></a>. Some of our popular community features include a 24-hour fitness center and a resort-style pool, and we have social spaces throughout the community to share with friends and family.</p>"
      }
    }
  },
  "apartments/ks/wichita/crown-chase-apts/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is the security deposit refundable?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, it is possible to have your security deposit refunded. You may get most, if not all, of your security deposit back if your apartment is left in pristine condition on move-out, provided you carefully fill out your move-in checklist at the beginning of your lease.</p>"
      }
    }
  },
  "apartments/ks/wichita/huntington-park/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the application fee at Huntington Park?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our nonrefundable application fee is $75. This fee helps process your application and conduct routine background and credit checks. Your fee must be submitted with your application for your candidacy to be considered.</p>"
      }
    }
  },
  "apartments/ks/wichita/newport-wichita/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the application fee, and is it refundable?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">There is a $75 application fee that is non-refundable. This fee covers the processing of your application and is not included in the security fee amount. We also charge a $75 admin fee that is refundable if your application is denied or cancelled within 24 hours.</p>"
      }
    }
  },
  "apartments/ks/wichita/raintree-apts/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How can I pay my rent?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">To make payments easier, take advantage of <a href=\"https://protect.checkpoint.com/v2/r01/___https:/getflex.com/___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6YTk3MGMyYThhNmY0Nzg4ZDVlMjMyNGJjMmMxMWFjZDI6NzpmNDc0OmFjZTFjYjEzN2JkZDFkYmZjNDA3YzYzOTcyZmVkYTgwOGEzNDA3ZGFhM2I2ZWEwOTQ1YmM1NzcxOTBiZjgzZmM6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>flexible payment options with flex</strong></a>. This tool makes the process as easy as possible and comes in handy when you need to split your bill into several installments for yourself.</p>"
      }
    }
  },
  "apartments/ks/wichita/remington-wichita/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the application fee at The Remington Apartment Homes?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The<a href=\"https://protect.checkpoint.com/v2/r01/___https:/remingtonapartmentswichita.securecafe.com/onlineleasing/remington-wichita-apts/register.aspx___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6YTk3MGMyYThhNmY0Nzg4ZDVlMjMyNGJjMmMxMWFjZDI6Nzo0YWQ3OjVhYjc1OTRkNDRmODdkN2VjNmU3Y2E5ZjlhN2RhNjFlMjkyN2M0ZThhNzdiYTVjYThkMmE1ZDQ3MGM3MWM0OTc6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>application fee</strong></a> is $75 and is nonrefundable. This covers the cost of processing your application and the necessary background and credit checks. Your application fee is not a security deposit.</p>"
      }
    }
  },
  "apartments/ks/wichita/silver-springs/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What rent payment options are available?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">You can make keeping up with your bills simple by using our <a href=\"https://protect.checkpoint.com/v2/r01/___https:/getflex.com/___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6YTk3MGMyYThhNmY0Nzg4ZDVlMjMyNGJjMmMxMWFjZDI6NzpmNDc0OmFjZTFjYjEzN2JkZDFkYmZjNDA3YzYzOTcyZmVkYTgwOGEzNDA3ZGFhM2I2ZWEwOTQ1YmM1NzcxOTBiZjgzZmM6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>payment services through flex</strong></a>. Weekly bills let you split rent into multiple payments, making it easier to budget. This is a popular feature, helping everyone pay on time without any hassle.</p>"
      }
    }
  },
  "apartments/ks/wichita/villas-of-waterford/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are there late fees?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, if your rent payment is late, fees will apply. Typically, you can expect a separate fee for every day your rent is overdue. Please review the terms and conditions of your rental agreement for further details.</p>"
      }
    }
  },
  "apartments/mo/independence/the-adirondack/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is the security fee refundable?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The security fee varies based on unit size, and is potentially refundable depending on the condition of your apartment after moving out. Completing your move-in checklist at the start of your lease helps establish clear expectations for the return of your fee.</p>"
      }
    }
  },
  "apartments/mo/kansas-city/97-north-oak/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What can I do if I need to schedule an early move-out?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">If you need to adjust your move-out date, reach out to our office as soon as possible. Please note that if you choose to move out earlier than your lease end date, you must also pay an early termination fee, plus rent, utilities and any fees remaining.</p>"
      }
    }
  },
  "apartments/ms/ridgeland/trace-apts/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How much do I have to pay per month?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Your rent is determined by numerous factors, including the size of your apartment and the type of apartment you choose. If you have questions about specific floor plans, utilities, or your rental agreement, <a href=\"/apartments/ms/ridgeland/trace-apts/contact-us\"><strong>please contact our team</strong></a>.</p>"
      }
    }
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is garage parking available?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, <a href=\"/apartments/ok/broken-arrow/trails-at-aspen-creek/amenities\"><strong>personal attached garages</strong></a> are available in various floor plans for our lofts and townhomes, including our 1 and 2 bedroom homes.</p>"
      }
    }
  },
  "apartments/ok/edmond/fountain-lake/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is my security deposit refundable?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, your security deposit may be partially or fully refunded, depending on the condition of your apartment after move out. We encourage you to complete your move in checklist to increase your chance of recieving your security fee back. </p>"
      }
    }
  },
  "apartments/ok/edmond/villas-at-stonebridge/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is there an administrative fee at move-in?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">There is. This fee helps us cover the cost of setting up your account, preparing your paperwork, and getting everything ready for your new apartment home. Keep in mind that it’s separate from your first month’s rent and any other required move-in fees or the security deposit.</p>"
      }
    }
  },
  "apartments/ok/moore/mission-point/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are short-term leases available?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We know that a full 12-month lease may not be convenient for all residents. That’s why we’re sometimes able to offer short-term leasing agreements on all our apartment homes. Short-term leases are subject to availability and include an additional upcharge.</p>"
      }
    }
  },
  "apartments/ok/norman/artisan-crossing-apts/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is there an additional fee for apartments with attached garages?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\"><strong>Y</strong>ou can get an apartment home with an attached personal garage across our lineup of 1 and 2 bedroom apartments and townhomes. There is an additional monthly fee for garage usage. Other apartments options include personal fireplaces, porches, and patios. </p>"
      }
    }
  },
  "apartments/ok/norman/cimarron-trails-apts/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What happens at the end of my lease term?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">At the end of your lease, our team will guide you through the lease renewal process, or you can provide your written 30-day notice, and our team will assist you with the move-out process. The move-out process includes completing a final inspection to assess any damages, returning your keys, and finalizing your account before departure. Be sure to review your move-out checklist to understand all the required steps.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is your pet policy and the associated fees at 24Hundred Apartments?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our <a href=\"/apartments/ok/oklahoma-city/24hundred-apartments/pet-policy\"><strong>pet-friendly apartment community</strong></a> welcomes cats and dogs with no weight limit. Whether you have a small cat or a large dog, the monthly pet rent is $30 per pet, along with a one-time, nonrefundable $500 fee. A maximum of two pets is allowed per apartment, and some breed restrictions apply.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What apartments are available to rent?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Price and availability are subject to change on all our apartment home options. For more information about apartment pricing, please <a href=\"tel:8333412975\"><strong>feel free to call us</strong></a>. Link to floor plans page instead?</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What documents will I need to submit with my application?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We require a standard set of documents to verify your identity before <a href=\"https://cimarronpointeapartmentsoklahomacity.securecafe.com/onlineleasing/cimarron-pointe-apts/register.aspx target= target= target=\"_blank\"\"_blank\"\"_blank\"\"><strong>processing your application</strong></a>. Please be prepared to provide a government-issued photo ID, proof of income, and any additional documentation requested during the application process.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/council-place-apartments/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the pet policy, and are there any fees?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\"><a href=\"/apartments/ok/oklahoma-city/council-place-apartments/pet-policy\"><strong>We welcome both dogs and cats</strong></a> at Council Place. There is no weight limit, though a maximum of two pets is allowed per apartment, and breed restrictions apply. There is a one-time, non-refundable pet fee of $500, and pet rent is $30 per month.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/cross-timber/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are utility costs included in my monthly rent?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">No, utilities such as power, water, and internet are billed separately from your rent. Water is billed through the property &amp; is due with your rent. This approach gives each resident a clear view of their actual usage. Residents are individually responsible for keeping their utility accounts current.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are there other payment options?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Every apartment comes with a <a href=\"https://www.cox.com/residential/mdu-community/quick-connect.html?sc_id=cr_dm_camp_z_quickconnect_vanity target= target=\"_blank\"\"_blank\"\"><strong>modem preinstalled by Cox Internet</strong></a>, so you can get connected qIn addition to paying through our online resident portal, you can also <a href=\"https://getflex.com/ target= target=\"_blank\"\"_blank\"\"><strong>use flex.</strong></a>, which lets you break your rent into smaller payments spread throughout the month. This makes budgeting easier, and your rent will still show as paid on time at the end of the month.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/hunter's-ridge-apts/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Do you offer free unguided tours?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We want you to be completely sure you have found your perfect future home layout before you move in. That’s why we give you the option to tour in the way that’s most convenient for you. Schedule an in-person tour, guided or unguided, or book a live video call to experience life at Hunter’s Ridge remotely.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/park-at-tuscany/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How do I get my security deposit back?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The best way to get your security deposit back is to take good care of your home. Fill out your move-in checklist on day one to record and report any pre-existing issues, and as you reach the end of your lease, be sure to follow all move-out procedures. Move-out instructions will be sent to the contact information you provided.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/persimmon-square-apartments/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "When is my security deposit due?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The security deposit is due with your application to secure your apartment off and additional applicable fees. If you have questions about payment timing or total move-in costs, <a href=\"https://protect.checkpoint.com/v2/r01/___tel:8556730183___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6Mzc3YzFiMDc4ZDFjZjc4YzIxNGU2NzA2Y2U1ZTg3YmM6NzplYWQ3OjJiOWViZTE4YjZhMTdiNmE2MmQxN2NlMDZlNDBiNWZkOTY0YTdlMmFhMTUyMzM5OTkzN2EyMjJiNWNlYjAxZjE6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>please call our leasing team</strong></a> for more details.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Does the rent vary when choosing a floor plan with optional features?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes. Some apartment homes come with direct-access single garages or double garages as an upgraded option. These <a href=\"/apartments/ok/oklahoma-city/prairie-springs-i/amenities\"><strong>garages</strong></a> give you a private, covered space to park directly next to your home. Other features may affect pricing as well.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/stonehorse-crossing/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are there additional monthly fees beyond base rent for specific floor plans?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Some homes include upgrades such as attached garages or loft-style layouts. These <a href=\"/apartments/ok/oklahoma-city/stonehorse-crossing/amenities\"><strong>features</strong></a> may have an added monthly fee. Any upgrade costs will appear in your floor plan options when you select your preferred home.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/summerfield-place-apts/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What How is rent structured and are there alternate payment options available?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">You’ll pay rent every month by the 1<sup>st</sup> of the month through our payment portal. You can also use <a href=\"https://protect.checkpoint.com/v2/r01/___https:/getflex.com/___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6Mzc3YzFiMDc4ZDFjZjc4YzIxNGU2NzA2Y2U1ZTg3YmM6NzowNjk2OjlkZmIwNzc5NTM4MDlhMDNkMmRkMzg5NDZiODk3YjllZTMzZWU2NmM1Mjg5NWZkYzFjZWRiMjU5Mzk5ZmYwNGI6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>flex.</strong></a> to split your rent into smaller payments during the month.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/tammaron-village-apartments/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How is rent determined for the different floor plan sizes?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Rent depends on the size of the apartment you choose, like a studio, a 1 bed/1 bath, or a 2 bed/1 bath. Prices can also change based on how many homes are available at the time, and off of the current market demands as well. We stay comparable to current market trends. The starting at price is the lowest rate, but the final cost may be higher depending on the apartment’s <a href=\"/apartments/ok/oklahoma-city/tammaron-village-apartments/amenities\"><strong>features</strong></a>.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/warrington-apartments/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What rent payment options are available?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Make life easier by splitting rent with using our <a href=\"https://protect.checkpoint.com/v2/r01/___https:/getflex.com/___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6YTk3MGMyYThhNmY0Nzg4ZDVlMjMyNGJjMmMxMWFjZDI6NzpmNDc0OmFjZTFjYjEzN2JkZDFkYmZjNDA3YzYzOTcyZmVkYTgwOGEzNDA3ZGFhM2I2ZWEwOTQ1YmM1NzcxOTBiZjgzZmM6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>payment services through flex</strong></a>. By splitting rent into multiple installments, you can easily budget and plan your monthly expenses.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What rent payment options are available?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">If you need help splitting your rent into multiple smaller payments, use our <a href=\"https://protect.checkpoint.com/v2/r01/___https:/getflex.com/___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6YTk3MGMyYThhNmY0Nzg4ZDVlMjMyNGJjMmMxMWFjZDI6NzpmNDc0OmFjZTFjYjEzN2JkZDFkYmZjNDA3YzYzOTcyZmVkYTgwOGEzNDA3ZGFhM2I2ZWEwOTQ1YmM1NzcxOTBiZjgzZmM6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>payment options through flex</strong></a>. This service provides the added buffer and flexibility you can use to budget your monthly rent payments.</p>"
      }
    }
  },
  "apartments/ok/owasso/coffee-creek/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How can I pay rent?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>We have a few ways for you to pay your rent at Coffee Creek Apartments. You can utilize your resident portal for debit or credit card or ACH payments, you can utilize our WIPS (walk in payment system) or you can set up your payment plan through our <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"https://getflex.com/ target= target=\"><strong>payment system, flex.</strong></a> This is a helpful tool that allows you to budget however you need.</p>"
      }
    }
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How do I apply to live at Cottages at Tallgrass Point?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">To begin your journey with us, you can <a href=\"https://cottagesattallgrassapartmentsowasso.securecafe.com/onlineleasing/cottages-at-tallgrass-point/register.aspx target= target=\"_blank\"\"_blank\"\"><strong>submit your application</strong></a> through our online portal. There is a $75 application fee that covers your background and credit checks, which are required steps for all future residents.</p>"
      }
    }
  },
  "apartments/ok/tulsa/barrington-apartments/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Does rent vary by floor plan size at Barrington Apartments in Tulsa, OK?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\"> Yes, rent can vary depending on the floor plan, square footage, and specific features of the apartment home. Pricing is subject to availability, so contacting the leasing office is the best way to receive current rent information.</p>"
      }
    }
  },
  "apartments/ok/tulsa/cascata-luxury-apartments/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Does rent vary by floor plan at Cascata Luxury Apartments in Tulsa, OK?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, rent varies depending on the floor plan size, layout, and included features. Pricing and availability are subject to change, so contacting the leasing office is the best way to confirm current rent details for a specific apartment home.</p>"
      }
    }
  },
  "apartments/ok/tulsa/cedar-glade-apts/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How does pricing differ between Cedar Glade Apartments floor plans?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Pricing varies based on bedroom count, square footage, and availability. Larger floor plans generally have higher starting rent, and pricing is subject to change. The leasing office can provide current details for specific apartment homes.</p>"
      }
    }
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How can I pay rent?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">You can use <a href=\"https://getflex.com/ target= target=\"_blank\"\"_blank\"\"><strong>flex, our payment service</strong></a>, to help you budget throughout the month. It will make your finances easier to manage and simplify your life!</p>"
      }
    }
  },
  "apartments/ok/tulsa/chardonnay/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the application fee at Chardonnay Apartment Homes?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our <a href=\"https://chardonnayapartmentstulsa.securecafe.com/onlineleasing/chardonnay/register.aspx?nocache=1 target= target=\"_blank\"\"_blank\"\"><strong>application fee</strong></a> is just $75 per person, which covers the cost of your background and credit checks. This simple step helps us get your application processed quickly so you can start planning your move into your new home!</p>"
      }
    }
  },
  "apartments/ok/tulsa/country-hollow-apartments/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What comes included with rent?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We want you to feel right at home, which is why all of our <a href=\"/apartments/ok/tulsa/country-hollow-apartments/amenities\"><strong>common amenities</strong></a> are included in your monthly rent. You’ll have full access to everything our community has to offer without any extra hidden fees! This includes the pool and fitness center.</p>"
      }
    }
  },
  "apartments/ok/yukon/park-at-westpointe/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What are the pet fees at The Park at Westpointe?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We allow up to two pets per home with no weight limit. Monthly pet rent is $30 per pet, plus a one-time, non-refundable $500 fee per pet. All pet breeds are subject to management approval. See <a href=\"/apartments/ok/yukon/park-at-westpointe/pet-policy\"><strong>our pet policy</strong></a> for further details.</p>"
      }
    }
  },
  "apartments/ok/yukon/the-ridge-@-66/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is the security fee refundable?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, your security fee is refundable depending on the condition of your apartment when you move out. Filling out your move-in checklist carefully helps make this process smooth and helps you maximize your return at the end of your lease.</p>"
      }
    }
  },
  "apartments/tx/hewitt/icon-at-hewitt/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How can I make payment easier?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">You can spread out your payments in smaller increments each week with our <a href=\"https://getflex.com/ target= target=\"_blank\"\"_blank\"\"><strong>flex. payment options</strong></a>. When broken up, payments made through Flex will still show as on time on your monthly bill.</p>"
      }
    }
  },
  "apartments/tx/lubbock/icon-at-lubbock/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are there separate fees for pets at The Icon at Lubbock?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The Icon at Lubbock is a <a href=\"/apartments/tx/lubbock/icon-at-lubbock/pet-policy\"><strong>pet-friendly community</strong></a> for cats and dogs, with no weight limit. A maximum of two pets is allowed per apartment, and breed restrictions do apply. Pet rent is $30 per month, along with a one-time, nonrefundable $500 pet fee.</p>"
      }
    }
  },
  "apartments/tx/temple/portico-at-friars-creek-apts/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What rent payment options are available?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">You can make your life easier by splitting your rent into <a href=\"https://getflex.com/ target= target=\"_blank\"\"_blank\"\"><strong>smaller payments with flex</strong></a>. This service allows you to split your rent into multiple installments throughout the month, so you can align payments with your personal schedule. Even with smaller payments, your rent will always be covered in full and on time.<br><br>You can apply for this option <a href=\"https://getflex.com/ target= target=\"_blank\"\"_blank\"\"><strong>directly through Flex</strong></a><strong>.</strong></p>"
      }
    }
  },
  "apartments/tx/waco/bend-at-new-road/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Do you offer apartment homes with attached garages?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We provide you with a diverse collection of spaces to suit your lifestyle, helping you find the right fit. While open, outdoor parking is available for all our residents, we also offer home options with an attached garage, including our 1 bedroom lofts, 2 bedroom lofts, and select town homes.</p>"
      }
    }
  },
  "apartments/tx/waco/tuscany-ranch-apartments/floor-plans::propertyfloorplansfaq.item_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the required security fee?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">A security fee and a recordation fee are required to be submitted to reserve your apartment. The fee amount varies based on the unit you select.<br> <br>This deposit helps cover potential damages to your apartment during your stay and is potentially fully refundable upon move-out, provided the home is left in good condition and free of excessive wear or outstanding charges.</p>"
      }
    }
  },
  "apartments/ks/maize/watercress/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What are the fees and policy for pets?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We welcome cats and dogs, with a maximum of two pets per apartment home. Keep in mind that breed restrictions apply. Each pet incurs $30 monthly pet rent, plus a one-time nonrefundable pet fee.<a href=\"tel:8556431621\"> <strong>Call</strong></a> or<a href=\"/apartments/ks/maize/watercress/contact-us\"> <strong>contact our leasing office online</strong></a> for our full list of breed restrictions and up-to-date <a href=\"/apartments/ks/maize/watercress/pet-policy\"><strong>pet policy</strong></a> details.</p>"
      }
    }
  },
  "apartments/ks/wichita/aspen-park/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the application fee at Aspen Park Apartments?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Expect a one-time, nonrefundable $75 application fee when you apply for a home at Aspen Park Apartments. This price covers the cost of processing your application, background, and credit checks.</p>"
      }
    }
  },
  "apartments/ks/wichita/cottages-at-crestview/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How much is my rent per month?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">A variety of factors will determine your rent’s pricing. These factors include your apartment home type, size, and the current standards of the local apartment living market.</p>"
      }
    }
  },
  "apartments/ks/wichita/crown-chase-apts/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are Utilities and Rent Billed Separately?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We want all our residents to experience clarity in their billing. Tenants are responsible for paying their utilities, which are billed separately from rent rather than as a flat fee, so you only have to pay for the power and internet services you use.  Water, however, is billed separately, and must be paid with rent.</p>"
      }
    }
  },
  "apartments/ks/wichita/huntington-park/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What should I do if I lose my key?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\"><a href=\"/apartments/ks/wichita/huntington-park/contact-us\"><strong>Reach out to the leasing office</strong></a> or your property manager if you lose your key. We can provide you with a replacement key. Additional fees may apply for key replacements.</p>"
      }
    }
  },
  "apartments/ks/wichita/newport-wichita/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Who provides the internet?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">High-speed internet is available through AT&amp;T, keeping you connected for work, school, and streaming without interruption.</p>"
      }
    }
  },
  "apartments/ks/wichita/raintree-apts/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What amenities come included with my apartment?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Your home includes access to a wide variety of <a href=\"/apartments/ks/wichita/raintree-apts/amenities\"><strong>community features</strong></a> for both fun and convenience. You can relax in our clubhouse, visit the internet café, or spend time in our game room. Outdoors, you can take advantage of our swimming pool<s>.</s></p>"
      }
    }
  },
  "apartments/ks/wichita/remington-wichita/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What rent payment options are available?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">You can pay online through our <a href=\"https://protect.checkpoint.com/v2/r01/___https:/getflex.com/___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6YTk3MGMyYThhNmY0Nzg4ZDVlMjMyNGJjMmMxMWFjZDI6NzpmNDc0OmFjZTFjYjEzN2JkZDFkYmZjNDA3YzYzOTcyZmVkYTgwOGEzNDA3ZGFhM2I2ZWEwOTQ1YmM1NzcxOTBiZjgzZmM6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>flex payment services</strong></a>. This makes it easy to stay on top of rent, manage your budget wisely with weekly installments.</p>"
      }
    }
  },
  "apartments/ks/wichita/silver-springs/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How do the 2 bedroom apartments look in Silver Springs Apartment Homes?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our 2 bed/2 bath floor plans bring you maximum comfort and privacy. These homes feature fully equipped kitchens with vinyl flooring and bright, open-concept living and dining areas. With more living space than our 1 bedroom options, these homes provide more room for comfort and the convenience of a second full bathroom.</p>"
      }
    }
  },
  "apartments/ks/wichita/villas-of-waterford/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What are the pet fees at The Villas at Waterford?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p>We allow up to two pets per home with no weight limit. Monthly pet rent is $30 per unit, plus a one-time, non-refundable pet fee that is half of one month’s rent per pet. All pet breeds are subject to management approval. See<a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/apartments/ks/wichita/villas-of-waterford/pet-policy\"> <strong>our pet policy</strong></a> for further details.</p>"
      }
    }
  },
  "apartments/mo/independence/the-adirondack/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the application fee?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">A non-refundable application fee of $75 is required. The additional administrative fee of $75 is refundable in the event your application is denied or canceled.</p>"
      }
    }
  },
  "apartments/mo/kansas-city/97-north-oak/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Do you charge a fee for a background check or credit check?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The non-refundable application fee is used to cover your background check, and credit checks. There is an additional $75 admin fee, that is refundable if your application is denied or cancelled within 24 hours.</p>"
      }
    }
  },
  "apartments/ms/ridgeland/trace-apts/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How can I apply for an apartment at The Trace of Ridgeland?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Ready to call The Trace of Ridgeland home? You can submit your application through <a href=\"https://protect.checkpoint.com/v2/r01/___https:/traceapartmentsridgeland.securecafe.com/onlineleasing/trace-apts/register.aspx___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6YTk3MGMyYThhNmY0Nzg4ZDVlMjMyNGJjMmMxMWFjZDI6NzpmNmYzOmJlZWRlZDJjZWJiMzljZGE2MzdiNDFiNzdmMDFhM2VlMjk1M2NkOTVmYjE5NzA0NDhkYTM1ZGNhY2YyYTFiZDM6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>our application portal</strong></a>. Please note that there is a $75 non-refundable application fee. To complete your application, you will also need to provide a valid government-issued ID.</p>"
      }
    }
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How much is the security fee?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The security fee, due before move-in day, varies based on unit size. This fee is fully refundable at the end of your lease, provided your apartment passes inspection. There is also a $75 non-refundable application fee.</p>"
      }
    }
  },
  "apartments/ok/edmond/villas-at-stonebridge/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How does the flex. payment option work for rent?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">You can choose to use the <a href=\"https://protect.checkpoint.com/v2/r01/___https:/getflex.com/___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6Mzc3YzFiMDc4ZDFjZjc4YzIxNGU2NzA2Y2U1ZTg3YmM6NzowNjk2OjlkZmIwNzc5NTM4MDlhMDNkMmRkMzg5NDZiODk3YjllZTMzZWU2NmM1Mjg5NWZkYzFjZWRiMjU5Mzk5ZmYwNGI6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>flex.</strong></a> payment option if you want. It lets you split your rent into smaller payments during the month instead of paying it all at once. You’ll still need to pay the full amount of rent each month, but this option can make it easier to manage your payments.</p>"
      }
    }
  },
  "apartments/ok/moore/mission-point/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the process for move-out inspections?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">In the weeks leading up to the end of your lease, we will send you a message detailing move-out instructions. These instructions will include the date of your inspection, your final move-out date, and details on what to do if you decide to move out early. Please contact us with any questions before your move-out date.<br> <br>Residents are required to provide a 30-day written notice, and then we will provide you the instructions you need to complete your move-out successfully, including providing a detailed move-out inspection expectation.</p>"
      }
    }
  },
  "apartments/ok/norman/artisan-crossing-apts/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is it possible to refund the application fee?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\"><a href=\"https://artisancrossingapartmentsnorman.securecafe.com/onlineleasing/artisan-crossing-apts/register.aspx target= target=\"_blank\"\"_blank\"\"><strong>Your application</strong></a> fee is non-refundable. That said, the application fee may be refunded if your application is denied. Terms apply.</p>"
      }
    }
  },
  "apartments/ok/norman/cimarron-trails-apts/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "When can I expect to receive my security deposit back?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We work to process security deposit refunds quickly, typically within a few weeks of move-out. You can expect to receive most or all of your fee back if the apartment is left in pristine condition. Remember to complete your move-out checklist to help avoid deductions.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How much do apartments with a garage cost at 24Hundred?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">All our apartments with garages are priced individually, allowing you to find the best value for your lifestyle. Attached garages are available in select 1 and 2 bedroom lofts and town houses, typically for an additional charge per month. We also offer layouts with fireplaces and other features, allowing you to select the home that meets your needs.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is the application fee refundable?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The application fee is non-refundable. However, the application fee will be refunded in the event of application rejection or denial. </p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What payment methods does Case and Associates accept?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">You have a couple of payment options to choose from. Payments can be made through our online resident portal, or by using our weekly <a href=\"https://getflex.com/ target= target= target=\"_blank\"\"_blank\"\"_blank\"\"><strong>flex. payment plan</strong></a> to break your payments into smaller amounts.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/council-place-apartments/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the application fee?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\"><a href=\"https://councilplaceapartmentsoklahomacity.securecafe.com/onlineleasing/council-place-apartments/register.aspx target= target=\"_blank\"\"_blank\"\"><strong>The application fee</strong></a>, due with the submission of your application, is $75 and covers the cost of administrative paperwork and processing. This application fee is refundable in the event that your application is rejected.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/cross-timber/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "If I am away for an extended period, am I still required to keep the utilities active in my name?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">In most cases, yes, you are still responsible for utility bills even if you are away. However, you may choose to pause or adjust your internet service while you are gone. For specific plan options, <a href=\"https://www.cox.com/residential/mdu-community/quick-connect.html?sc_id=cr_dm_camp_z_quickconnect_vanity target= target=\"_blank\"\"_blank\"\"><strong>please consult Cox Internet directly</strong></a>.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are utilities billed along with my rent?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">To keep billing fair and accurate, utilities are billed separately from rent. Each household is responsible for paying for the utilities they use, including electricity, water, and internet service.  Water is billed through the property &amp; is due with rent. All our apartments are electrically heated and feature energy-saving appliances.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/hunter's-ridge-apts/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are there late fees?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, if your rent payment is late, fees will apply. Please review the terms and conditions of your rental agreement for further details.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/park-at-tuscany/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is there an application fee?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, an application fee of $75 is due with your application. This fee partially covers the cost of administrative paperwork. <a href=\"https://protect.checkpoint.com/v2/r01/___https:/parkattuscanyapartmentsoklahomacity.securecafe.com/onlineleasing/park-at-tuscany/register.aspx___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6Mzc3YzFiMDc4ZDFjZjc4YzIxNGU2NzA2Y2U1ZTg3YmM6NzpkYzBiOjRhYWYwZTk3ZDRkOTcxNTJlMWJjYzEyYjNlNzQ5NmM2MjQ4ZTY4MjdlMGY3ZGFhYTY5OWIwZjE2NjFhYmY2M2E6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>Apply online today</strong></a> to see the fees included with your application and those that are due upon signing.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/persimmon-square-apartments/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How much is pet rent?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We welcome up to two pets per apartment home with no weight limit, though all pets are subject to management approval. Monthly pet rent at Persimmon Square is $30 per pet. A one-time non-refundable fee of $500 also applies per pet at move-in. <a href=\"/apartments/ok/oklahoma-city/persimmon-square-apartments/pet-policy\"><strong>Review our pet policy</strong></a> for further details.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "If I lease a home now but move in later, will rent or fees change?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Rent and fees can change depending on what’s available and what the market looks like. To make sure you have the correct information, it’s a good idea to <a href=\"https://protect.checkpoint.com/v2/r01/___tel:4057222727___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6Mzc3YzFiMDc4ZDFjZjc4YzIxNGU2NzA2Y2U1ZTg3YmM6NzozOTQwOjg2MWY4Yzg2ZjkyNGFmMjFmMjllNzc0MTg2OTMyNjVjYWU1YTM2ZTZkZThlNjYwZmNiNjYyODM1MjVlZDk3ZTE6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>call</strong></a> or <a href=\"/apartments/ok/oklahoma-city/prairie-springs-i/contact-us\"><strong>contact our office online</strong></a> about current prices and whether any specials are available when you sign your lease.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/stonehorse-crossing/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "When is the application fee due, and is it refundable?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">You’ll need to pay for your application fee the moment you’re ready to turn it in. This fee isn’t refundable as it helps cover the cost of checking your background and credit. These checks are a standard part of our process and help us make sure everything is correct before move-in day.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/summerfield-place-apts/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What are the fees and policy for pets?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">We welcome cats and dogs, with a maximum of two pets per apartment home. Keep in mind that breed restrictions apply. Each pet incurs $30 monthly pet rent, plus a one-time nonrefundable pet fee. <a href=\"https://protect.checkpoint.com/v2/r01/___tel:8552651519___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6Mzc3YzFiMDc4ZDFjZjc4YzIxNGU2NzA2Y2U1ZTg3YmM6Nzo5NTU2Ojg5NmRmNGZhYTY5OWUzMjg1ODg3MzVhNjAwZmVkYjMxMjgwMzlhZGY4ZjQ5ODEwZThjNmUwMTkzNGY4MThjZDY6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>Call</strong></a> or <a href=\"/apartments/ok/oklahoma-city/summerfield-place-apts/contact-us\"><strong>contact our leasing office online</strong></a> for our full list of breed restrictions and up-to-date <a href=\"/apartments/ok/oklahoma-city/summerfield-place-apts/pet-policy\"><strong>pet policy</strong></a> details.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/tammaron-village-apartments/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What fees apply for pets in my apartment home?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">You may bring up to two pets to your apartment home, with standard breed restrictions in place for everyone. Each pet requires a one-time, nonrefundable fee as well as a monthly pet rent. These costs can vary, so we encourage you to <a href=\"https://protect.checkpoint.com/v2/r01/___tel:8446850723___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6Mzc3YzFiMDc4ZDFjZjc4YzIxNGU2NzA2Y2U1ZTg3YmM6Nzo2NDA3Ojc3ZDJhZmEwZmEyYWZmOWExYzhmY2M5ODJiODMxMjJlMzgyMWQxYmU3ZWY0YzMyYjNiZGI1YWMyM2M5ZTE5NTc6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>call</strong></a> or <a href=\"/apartments/ok/oklahoma-city/tammaron-village-apartments/contact-us\"><strong>contact our leasing office online</strong></a> for the most up-to-date amounts and to review the full <a href=\"/apartments/ok/oklahoma-city/tammaron-village-apartments/pet-policy\"><strong>pet policy</strong></a> before applying. Pet rent is $30 per pet per month, with a $500 nonrefundable fee per pet.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/warrington-apartments/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the application fee at the Warrington Apartments?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">There is a one-time, nonrefundable fee of $75 that covers processing your application, background check, and credit check. <a href=\"https://protect.checkpoint.com/v2/r01/___tel:8445450337___.YXAzOmdvbG9jYWxpbnRlcmFjdGl2ZTpjOmc6YTk3MGMyYThhNmY0Nzg4ZDVlMjMyNGJjMmMxMWFjZDI6NzpkYTdlOjQ4YWQ0NTIxMjM2NDhkZTVlZWQxYjI5M2U4YTY3YzZkODYyYzQzODc5MjlmODViMjgzYTA0MzAyY2NlZTliMDc6cDpUOk4 target= target=\"_blank\"\"_blank\"\"><strong>Give us a call</strong></a> if you have any questions about fees or our application process.</p>"
      }
    }
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the application fee at Waters Edge Apartments?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Our application fee is $75 and is not refundable. This fee covers the cost of processing your application and the background and credit checks that come with it. Your application fee is not a security deposit.</p>"
      }
    }
  },
  "apartments/ok/owasso/coffee-creek/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What amenities come included with rent?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Once you pay rent, you have access to all our common-use amenities like the picnic area with barbecue grills, the 24-hour fitness center, and the on-site dog park. No hidden fees!</p>"
      }
    }
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What does my rent include?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Your monthly rent includes full access to our extensive collection of <a href=\"/apartments/ok/owasso/cottages-at-tallgrass-point/amenities\"><strong>on-site amenities.</strong></a> You can enjoy everything from our modern resident clubhouse to the cozy outdoor fire pit and relaxing lounge areas.</p>"
      }
    }
  },
  "apartments/ok/tulsa/barrington-apartments/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Do Barrington Apartments floor plans include in-home features?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Select apartment homes include features such as vaulted ceilings, washer and dryer, whirlpool tubs, brick fireplaces with oak mantels, and private patios or enclosed balconies. Some features are available only in select homes.</p>"
      }
    }
  },
  "apartments/ok/tulsa/cascata-luxury-apartments/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Are apartments with attached garages available at Cascata Luxury Apartments in Tulsa, OK?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, select one and 2-bedroom floor plans include an attached garage. Garage availability and related pricing can vary, and residents are encouraged to contact the leasing office for the most up-to-date information.</p>"
      }
    }
  },
  "apartments/ok/tulsa/cedar-glade-apts/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Do Cedar Glade Apartments floor plans include outdoor space?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Many floor plans include a private patio or balcony, offering additional space for relaxing outdoors. Availability of these features may vary by layout.</p>"
      }
    }
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How much is my rent per month?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Many factors can play into determining how much your rent is going to be a month. Your apartment home type, the features you get, and the current standards of local apartment markets are some of the elements that can determine rent cost.</p>"
      }
    }
  },
  "apartments/ok/tulsa/chardonnay/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What does my monthly rent include?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Your monthly rent gives you full access to all of our <a href=\"/apartments/ok/tulsa/chardonnay/amenities\"><strong>on-site amenities,</strong></a> including the resort-style pool and dog park. You’ll be able to enjoy every part of our community the moment you move in without any extra membership fees!</p>"
      }
    }
  },
  "apartments/ok/tulsa/country-hollow-apartments/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the application fee for Country Hollow Apartments?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">To <a href=\"https://countryhollowapartmentstulsa.securecafe.com/onlineleasing/country-hollow-apartments/register.aspx target= target=\"_blank\"\"_blank\"\"><strong>get started with your application</strong></a>, there is a $75 fee that covers your standard background and credit checks. This helps us ensure a safe and comfortable environment for everyone in our community!</p>"
      }
    }
  },
  "apartments/ok/yukon/park-at-westpointe/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Do I still have to pay for utilities even while I’m away?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">Yes, all tenants are responsible for paying their rent and utilities, even when absent from the apartment. These services remain active to help protect the apartment and maintain essential functions, such as climate control and refrigeration. Keeping accounts current also helps avoid service interruptions or fees while you’re gone.</p>"
      }
    }
  },
  "apartments/ok/yukon/the-ridge-@-66/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "How much is the application fee?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The application fee is $75 and is used to cover the costs of processing your application. This fee is non-refundable, and must be submitted before your application can be reviewed.</p>"
      }
    }
  },
  "apartments/tx/hewitt/icon-at-hewitt/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Can I get my security deposit back after my lease ends?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">The security deposit is refundable, less any damages incurred to your apartment over the duration of your lease or unpaid charges. You can maximize your return by carefully filling out your move-in checklist and leaving the apartment in good condition.</p>"
      }
    }
  },
  "apartments/tx/lubbock/icon-at-lubbock/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What is the application fee at The Icon at Lubbock?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\"><a href=\"https://iconatlubbockapartments.securecafe.com/onlineleasing/icon-at-lubbock/register.aspx target= target=\"_blank\"\"_blank\"\"><strong>The application fee</strong></a> is $75 and nonrefundable. This fee helps us cover the costs of processing your application, including background and credit checks.<br> <br>Separately, the administrative fee of $75is refundable if you decide to cancel your application or if it is denied within 24 hours.</p>"
      }
    }
  },
  "apartments/tx/temple/portico-at-friars-creek-apts/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What are the different fees needed with my application?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">There is a $75 nonrefundable application fee, which covers the cost of processing your application. In addition, an administrative fee is applicable, which can be refunded if your application is denied or if you cancel within 24 hours.<br></p>"
      }
    }
  },
  "apartments/tx/waco/bend-at-new-road/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "What community features are available outside my apartment?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\">As a resident, you’ll enjoy 24-hour access to our fitness center, making it easy to fit in a workout on your schedule. Our on-site dog park provides your pets with a space to play, while complimentary coffee and tea are always available for a quick pick-me-up. When it’s time to relax, you can cool off in our resort-style swimming pool or simply unwind in the community spaces designed with your lifestyle in mind.</p>"
      }
    }
  },
  "apartments/tx/waco/tuscany-ranch-apartments/floor-plans::propertyfloorplansfaq.item_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "question": {
        "type": "VALUE",
        "customValue": "Is my application fee refundable?"
      },
      "answer": {
        "type": "VALUE",
        "customValue": "<p class=\"\"><a href=\"https://tuscanyranchapartmentswaco.securecafe.com/onlineleasing/tuscany-ranch-apartments/register.aspx target= target=\"_blank\"\"_blank\"\">The application fee itself is $75</a> and is used to cover the costs of processing your application, like running background checks. Because of this, it&#8217;s not refundable.<br> <br>However, your separate administrative fee is refundable in the event you cancel your application or if your application is denied.</p>"
      }
    }
  },
  "apartments/ar/north-little-rock/lexington-park/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165609/019fc925-6b4a-77da-a5b9-d196af34aab1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Primary bedroom with a queen-size bed and walk-in closet."
      }
    }
  },
  "apartments/ks/maize/watercress-apartments/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4f0-1b81-759f-b409-ac356e502e7a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a king-size bed, nightstand, and dresser."
      }
    }
  },
  "apartments/ks/wichita/aspen-park-apartments/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166543/019cfb4e-0ac5-7159-8597-0e4f7be20af4.webp"
      }
    }
  },
  "apartments/ks/wichita/cottages-at-crestview/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a1897b-95f4-74ab-a6d6-62559ed4cb95.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a queen-size bed, dresser, and mirror."
      }
    }
  },
  "apartments/ks/wichita/huntington-park/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "apartments/ks/wichita/villas-of-waterford/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "apartments/mo/independence/the-adirondack/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "apartments/mo/kansas-city/152-northland/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cee-f933-7424-bad4-8d9993325e92.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern bedroom with a queen-size bed, dresser, and nightstands."
      }
    }
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019fb452-d44d-72b8-91c1-73e3ca893803.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living and dining area with sofa, armchair, and dining table."
      }
    }
  },
  "apartments/ok/broken-arrow/park-at-mission-hills/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-85db-722e-9622-93237a60dd15.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy bedroom with a king-size bed, wooden furniture, and a ceiling fan."
      }
    }
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a36-51f8-73d9-bc01-a0c6fab4efe0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy bedroom with a king-size bed, nightstands, and a dresser."
      }
    }
  },
  "apartments/ok/edmond/villas-at-stonebridge/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c14-2a0e-746d-b707-43cbc02acd41.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy bedroom with vaulted ceiling, ceiling fan, queen bed, nightstand, and large windows."
      }
    }
  },
  "apartments/ok/jenks/the-reserve-at-elm/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": 21,
    "fieldOverrides": null
  },
  "apartments/ok/norman/artisan-crossing-apts/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/01a062bd-755c-753f-8352-be0096c1db2a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A dining area with a round table and chairs next to a home office setup with a desk and chair."
      }
    }
  },
  "apartments/ok/norman/cimarron-trails-apts/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": 14,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06274-5c68-75e5-8f8e-f3aa0837e26c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a queen-size bed, nightstand, dresser, and window."
      }
    }
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d1-68a1-71df-8c37-f368f85efff0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A bright bedroom with a queen-size bed, yellow bedding, and a dresser."
      }
    }
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a14009-681b-759c-8f21-84903ea3f30e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a queen-size bed, dresser, and a doorway leading to another room."
      }
    }
  },
  "apartments/ok/oklahoma-city/council-place-apartments/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/019cfb3d-f4ec-703e-8d9f-bae38563ea4f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Stylish bedroom with a queen-size bed, dresser, and large mirror."
      }
    }
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08675-afae-70eb-be11-cc8ebff32f02.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a queen-size bed, nightstand, and dresser."
      }
    }
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": 16,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/01a08181-ef16-7697-9fe9-0d80b5f25b08.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a gray sectional sofa, coffee table, and accent decor."
      }
    }
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d5-c9b4-7035-90be-e85b3385237d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with sofa, coffee table, dining table, and chairs."
      }
    }
  },
  "apartments/ok/oklahoma-city/waters-edge-apartments/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "apartments/ok/owasso/coffee-creek/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": 7,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa492-f832-708a-90ce-ad72aff11a2e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Primary bedroom with a king-size bed, nightstands, dresser, and mirror."
      }
    }
  },
  "apartments/ok/owasso/cypress-crossing/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": 19,
    "fieldOverrides": null
  },
  "apartments/ok/pryor/west-530/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": 20,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03546-696b-72cc-94f1-52f896471c51.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A cozy bedroom featuring a dark metal bed frame, dresser, and two large windows."
      }
    }
  },
  "apartments/ok/stillwater/apple-creek-stillwater/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": 26,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cascata-luxury-apartments/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cedar-glade-apts/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": 9,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b8-9fb3-706e-b212-bddf7c2c55c3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "King-size bed with purple and grey linens, tufted headboard, and decorative pillows in a well-lit bedroom."
      }
    }
  },
  "apartments/ok/tulsa/chardonnay/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": 29,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/creekwood-apartments/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1947-5903-76ec-b872-26a8aa75d6a9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious bedroom with a queen-sized bed, decorative pillows, nightstand with lamp, armchair by a large window, and ceiling fan."
      }
    }
  },
  "apartments/ok/tulsa/nickel-creek-apts/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": 37,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/polo-run-apartments/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/sheridan-pond/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-6342-73dd-bc18-b260e6dfa5ac.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy bedroom with a queen-sized bed, nightstand, and dresser."
      }
    }
  },
  "apartments/ok/tulsa/sugarberry-apartments/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01600-f860-72d3-8d65-f0fa4be1c3f3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A well-lit bedroom with a queen-size bed, bedside table, and a large window."
      }
    }
  },
  "apartments/ok/tulsa/sunchase-apartments/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa20-1c06-769c-9d92-256d9426e84a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with sofa, coffee table, and chair."
      }
    }
  },
  "apartments/ok/tulsa/the-courtyards/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c3-fa92-70bc-8ed4-5b4fc1d34395.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy living room with white sofa, armchair, coffee table, TV, and plush carpet."
      }
    }
  },
  "apartments/ok/tulsa/windsail-apartments/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": 36,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019fb44c-3a7c-75e9-aaa3-1bee6908bfc5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Queen size bed with patterned comforter and pillows, wooden headboard, and nightstand with lamp."
      }
    }
  },
  "apartments/ok/yukon/park-at-westpointe/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c2-b08a-77fb-b13c-f02c4d4acdcd.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Primary bedroom with a queen bed, ceiling fan, and dresser."
      }
    }
  },
  "apartments/ok/yukon/the-ridge-66/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192d-8608-741a-83c7-f6447f0e9148.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious bedroom with a king-size bed, nightstand, dresser, and ceiling fan."
      }
    }
  },
  "apartments/tx/amarillo/newport-amarillo-apts/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf5-2a2e-76c6-afdc-b2fbf27b8642.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen sink with modern faucet, granite countertops, dishwasher, and laundry area"
      }
    }
  },
  "apartments/tx/amarillo/remington-amarillo-apts/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df4-31ee-709d-893e-b75cfb33b41a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy bedroom with a queen-size bed, dresser, and nightstand."
      }
    }
  },
  "apartments/tx/el-paso/acacia-park-apts/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": 10,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/double-tree-apts/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-b579-76ce-9fce-00352994a0e8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a pink bed, white bedding, and decorative pillows. A ceiling fan is visible overhead."
      }
    }
  },
  "apartments/tx/el-paso/high-ridge-apts/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": 25,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/01a0a195-8159-71bf-bbdd-49bba4af7164.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A beautifully decorated bedroom featuring a wooden bed frame, plush bedding, and a ceiling fan."
      }
    }
  },
  "apartments/tx/el-paso/phoenix-apts/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/shadow-ridge-apts/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": 68,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/the-crest/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd5-89cd-740f-a87b-fe171f324b67.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Primary bedroom with king-sized bed and sliding glass door to balcony."
      }
    }
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a03a68-0246-700a-8653-2d8fa0e8dead.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Stylish bedroom with a king-size bed, patterned bedding, and desert-themed decor."
      }
    }
  },
  "apartments/tx/lubbock/icon-at-lubbock/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda4-6d28-774f-b0e4-16ab3c694e17.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a queen-size bed, nightstand, dresser, and ceiling fan."
      }
    }
  },
  "apartments/tx/lubbock/tuscany-place/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2d-3573-75d5-81a1-dafd1c2df4df.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a granite countertop."
      }
    }
  },
  "apartments/tx/waco/bend-at-new-road/floor-plans::propertyfloorplanslist.bedroom1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd71-03e3-709c-84e2-3b229ba5ae94.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room with plush sofa and armchair, coffee table, and large windows."
      }
    }
  },
  "apartments/ar/north-little-rock/lexington-park/floor-plans::propertyfloorplanslist.bedroom3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165609/019fc925-428e-7368-8e4a-79ddb0dcd1dd.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room and kitchen area with dining table, sofa, coffee table, and TV."
      }
    }
  },
  "apartments/ks/wichita/cottages-at-crestview/floor-plans::propertyfloorplanslist.bedroom3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a1897b-0854-705b-8db9-8c01a7dffc52.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Stylish dining area with a round table and chairs, situated near a console table with decorative items and a large abstract painting."
      }
    }
  },
  "apartments/ok/broken-arrow/redbud-ranch/floor-plans::propertyfloorplanslist.bedroom3_image": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/floor-plans::propertyfloorplanslist.bedroom3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a36-511f-7529-9148-8952d9aa5d3f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with white cabinets, stainless steel appliances, and marble countertops."
      }
    }
  },
  "apartments/ok/edmond/villas-at-stonebridge/floor-plans::propertyfloorplanslist.bedroom3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c14-20ea-706e-a05c-4deb1adc528e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area with a wooden table and four white chairs, overlooking a balcony."
      }
    }
  },
  "apartments/ok/norman/cimarron-trails-apts/floor-plans::propertyfloorplanslist.bedroom3_image": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/floor-plans::propertyfloorplanslist.bedroom3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d0-d873-715b-9730-a7dbeb139b42.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with stainless steel appliances, gray cabinets, white quartz countertops, and bar seating."
      }
    }
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/floor-plans::propertyfloorplanslist.bedroom3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a1400a-25d1-7507-94ff-ddd0a7dde06e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with wooden cabinets, black appliances, and granite countertops."
      }
    }
  },
  "apartments/ok/oklahoma-city/council-place-apartments/floor-plans::propertyfloorplanslist.bedroom3_image": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/cross-timber/floor-plans::propertyfloorplanslist.bedroom3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-af63-74f8-bd16-c1ed82ab6849.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room with a white sofa, two coffee tables, and a view of the kitchen with bar stools."
      }
    }
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/floor-plans::propertyfloorplanslist.bedroom3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d5-a8c8-707d-a6a4-92bbd0814237.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy bedroom with a black metal bed frame, white bedding, and decorative pillows."
      }
    }
  },
  "apartments/ok/owasso/cypress-crossing/floor-plans::propertyfloorplanslist.bedroom3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019d48de-be70-7149-a200-7843fe037c84.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room with a sectional sofa, armchair, coffee table, and abstract art."
      }
    }
  },
  "apartments/ok/tulsa/cedar-glade-apts/floor-plans::propertyfloorplanslist.bedroom3_image": {
    "sourceIndex": 18,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dd42b-5890-70cd-baee-45ca59048a94.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area adjacent to kitchen with dark cabinets and appliances."
      }
    }
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/floor-plans::propertyfloorplanslist.bedroom3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70ae-4c43-7448-bf0c-0fbcfb8ac46e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with white cabinets, stainless steel appliances, and dark countertops."
      }
    }
  },
  "apartments/ok/tulsa/sheridan-pond/floor-plans::propertyfloorplanslist.bedroom3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02001-c992-764d-9ea1-4050f75cc819.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with wood cabinets, stainless steel appliances including a microwave and refrigerator, and a double sink."
      }
    }
  },
  "apartments/ok/tulsa/sugarberry-apartments/floor-plans::propertyfloorplanslist.bedroom3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165627/01a01600-ca16-71af-a6e8-1a0b2a456684.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with fireplace, couch, coffee table, and console table."
      }
    }
  },
  "apartments/ok/tulsa/the-greens-of-bedford/floor-plans::propertyfloorplanslist.bedroom3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-dc5b-76b1-9d71-ca13db99faea.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with wood cabinets, black appliances, granite countertops, and a double sink."
      }
    }
  },
  "apartments/ok/yukon/the-ridge-66/floor-plans::propertyfloorplanslist.bedroom3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192d-a5ac-7566-9116-1c0452e863ce.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Desk and dining area in an apartment with large windows and modern decor."
      }
    }
  },
  "apartments/tx/amarillo/remington-amarillo-apts/floor-plans::propertyfloorplanslist.bedroom3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df3-84e9-7697-8e7c-4f0191a7e137.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with wooden cabinets, white microwave, stove, and refrigerator."
      }
    }
  },
  "apartments/tx/amarillo/winchester-apartments/floor-plans::propertyfloorplanslist.bedroom3_image": {
    "sourceIndex": 25,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/01a117ae-132b-754c-840a-315a1c5f3900.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Updated kitchen with white cabinets, wood trim, and white appliances."
      }
    }
  },
  "apartments/tx/el-paso/acacia-park-apts/floor-plans::propertyfloorplanslist.bedroom3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165582/019e1762-c45d-7028-b74b-782309b8a569.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with sofa, two chairs, coffee table, and decorative key art."
      }
    }
  },
  "apartments/tx/el-paso/phoenix-apts/floor-plans::propertyfloorplanslist.bedroom3_image": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/shadow-ridge-apts/floor-plans::propertyfloorplanslist.bedroom3_image": {
    "sourceIndex": 82,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/the-crest/floor-plans::propertyfloorplanslist.bedroom3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd5-7b06-70bf-bdb5-7ac2d352aa77.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with stainless steel appliances, light wood cabinets, and dark wood floors."
      }
    }
  },
  "_template:property::propertyfloorplanslist.card_apply_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "cta_url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_online_leasing_url"
      }
    }
  },
  "apartments/ok/catoosa/bluffs-at-catoosa/floor-plans::propertyfloorplanslist.card_apply_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "cta_url": {
        "type": "VALUE",
        "mappedField": "property_online_leasing_url",
        "customValue": "/apartments/ok/catoosa/bluffs-at-catoosa/photos"
      },
      "cta_text": {
        "type": "VALUE",
        "customValue": "View Gallery"
      }
    }
  },
  "apartments/ar/north-little-rock/lexington-park/floor-plans::propertyfloorplanslist.site_plan_bg": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "apartments/ks/wichita/cottages-at-crestview/floor-plans::propertyfloorplanslist.site_plan_bg": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a1897a-f962-751b-b01b-2912be5ef3a5.webp"
      }
    }
  },
  "apartments/ks/wichita/portofino/floor-plans::propertyfloorplanslist.site_plan_bg": {
    "sourceIndex": 49,
    "fieldOverrides": null
  },
  "apartments/mo/belton/center-301/floor-plans::propertyfloorplanslist.site_plan_bg": {
    "sourceIndex": 22,
    "fieldOverrides": null
  },
  "apartments/mo/kansas-city/152-northland/floor-plans::propertyfloorplanslist.site_plan_bg": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3ced-a3fb-77fd-9830-0874a3ad51c1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment complex with a large swimming pool and lounge chairs."
      }
    }
  },
  "apartments/ok/broken-arrow/redbud-ranch/floor-plans::propertyfloorplanslist.site_plan_bg": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/floor-plans::propertyfloorplanslist.site_plan_bg": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c1c-9f86-7337-932f-efc4cc42b98c.webp"
      }
    }
  },
  "apartments/ok/jenks/the-reserve-at-elm/floor-plans::propertyfloorplanslist.site_plan_bg": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165635/019ecc08-d53f-7683-b3a0-51ee26f70299.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and apartment buildings in the background."
      }
    }
  },
  "apartments/ok/norman/artisan-crossing-apts/floor-plans::propertyfloorplanslist.site_plan_bg": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/floor-plans::propertyfloorplanslist.site_plan_bg": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/019cfb3d-f23a-72fa-9e7f-02eb6c97e2cf.webp"
      }
    }
  },
  "apartments/ok/oklahoma-city/cross-timber/floor-plans::propertyfloorplanslist.site_plan_bg": {
    "sourceIndex": 0,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/01a03e9f-fd2a-742c-a511-aee66a2c58bd.webp"
      }
    }
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/floor-plans::propertyfloorplanslist.site_plan_bg": {
    "sourceIndex": 25,
    "fieldOverrides": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/floor-plans::propertyfloorplanslist.site_plan_bg": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "apartments/ok/pryor/west-530/floor-plans::propertyfloorplanslist.site_plan_bg": {
    "sourceIndex": 24,
    "fieldOverrides": null
  },
  "apartments/ok/stillwater/apple-creek-stillwater/floor-plans::propertyfloorplanslist.site_plan_bg": {
    "sourceIndex": 16,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/barrington-apartments/floor-plans::propertyfloorplanslist.site_plan_bg": {
    "sourceIndex": 31,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f049f-15d8-75cf-8461-90609948b4c2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a large bed, dresser, and balcony access."
      }
    }
  },
  "apartments/ok/tulsa/country-hollow-apartments/floor-plans::propertyfloorplanslist.site_plan_bg": {
    "sourceIndex": 9,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/creekwood-apartments/floor-plans::propertyfloorplanslist.site_plan_bg": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f194a-be4b-732f-8bd2-68fa2f3e94b4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a rectangular swimming pool with lounge chairs, a hot tub, and a brick clubhouse building."
      }
    }
  },
  "apartments/ok/tulsa/the-courtyards/floor-plans::propertyfloorplanslist.site_plan_bg": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "apartments/ok/yukon/park-at-westpointe/floor-plans::propertyfloorplanslist.site_plan_bg": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c2-c4af-76cb-bc4c-85987aad02dd.webp"
      }
    }
  },
  "apartments/tx/amarillo/remington-amarillo-apts/floor-plans::propertyfloorplanslist.site_plan_bg": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df3-c418-75a9-b7a3-ef3f22dfd3a1.webp"
      }
    }
  },
  "apartments/tx/amarillo/winchester-apartments/floor-plans::propertyfloorplanslist.site_plan_bg": {
    "sourceIndex": 35,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/acacia-park-apts/floor-plans::propertyfloorplanslist.site_plan_bg": {
    "sourceIndex": 16,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/chimneys-apts/floor-plans::propertyfloorplanslist.site_plan_bg": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/high-ridge-apts/floor-plans::propertyfloorplanslist.site_plan_bg": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/019db5a9-f473-7023-acd2-08f603f1f8d0.webp"
      }
    }
  },
  "apartments/tx/lubbock/icon-at-lubbock/floor-plans::propertyfloorplanslist.site_plan_bg": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda4-2d67-7624-9bab-0e450f001044.webp"
      }
    }
  },
  "apartments/tx/lubbock/tuscany-place/floor-plans::propertyfloorplanslist.site_plan_bg": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "propertyfloorplanslist.site_plan_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "cta_url": {
        "type": "FIELD_MAPPING",
        "mappedField": "custom_floorplan_pdf_url"
      }
    }
  },
  "_template:property::propertyfloorplanslist.site_plan_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "cta_url": {
        "type": "FIELD_MAPPING",
        "mappedField": "custom_floorplan_pdf_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "apartments/ok/norman/artisan-crossing-apts/floor-plans::propertyfloorplanslist.site_plan_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "cta_url": {
        "type": "FIELD_MAPPING",
        "mappedField": "custom_floorplan_pdf_url"
      }
    }
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/floor-plans::propertyfloorplanslist.site_plan_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "cta_url": {
        "type": "FIELD_MAPPING",
        "mappedField": "custom_floorplan_pdf_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "apartments/ks/wichita/cottages-at-crestview/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a11f89-846b-7202-90cf-174d699b1e7b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious living room with a large sectional sofa, coffee table, and TV."
      }
    }
  },
  "apartments/ks/wichita/huntington-park/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166545/01a11c6d-0496-74a6-afe2-2753fd572fae.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a grey tufted sofa, accent chairs, and large sliding glass doors."
      }
    }
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-4957-74d8-a994-4915b1508644.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and a large refrigerator."
      }
    }
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "apartments/ok/jenks/the-reserve-at-elm/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": 27,
    "fieldOverrides": null
  },
  "apartments/ok/norman/artisan-crossing-apts/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "apartments/ok/norman/cimarron-trails-apts/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06276-e331-776a-9a99-4ec8e989f273.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs at an apartment complex."
      }
    }
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": 16,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": 9,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/01a183b2-ab6e-7591-9af8-ab05ae6b2812.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Lobby seating area with a TV and fireplace, a bar with computers, and a printer."
      }
    }
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb40-193e-7777-b999-c1180449db1e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a brown leather sofa and coffee table."
      }
    }
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/01a08181-f924-7458-a442-0b677099cbbf.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Open concept living and dining area with a pass-through to the kitchen."
      }
    }
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa492-f0dc-707d-b451-93c87d643e79.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A dining table with two bar stools next to a desk with a chair and a globe."
      }
    }
  },
  "apartments/ok/owasso/cypress-crossing/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "apartments/ok/pryor/west-530/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": 18,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03546-60de-71df-b4b5-78b0af6ebef9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Laundry room with washer, dryer, and vanity"
      }
    }
  },
  "apartments/ok/stillwater/apple-creek-stillwater/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": 10,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b6-f0bd-77ea-905a-ca756a2ef287.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Luxurious bedroom with a king-size bed, plush bedding, and modern decor."
      }
    }
  },
  "apartments/ok/tulsa/country-hollow-apartments/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": 2,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019ef53e-0fd0-7446-9e36-dacd2f7abf49.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a sofa, coffee table, and side table."
      }
    }
  },
  "apartments/ok/tulsa/nickel-creek-apts/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/sheridan-pond/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02001-c8b4-747d-92f2-d7d8f6abfaf9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a sofa, coffee table, armchair, and bar stools."
      }
    }
  },
  "apartments/ok/tulsa/sunchase-apartments/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": 9,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/the-courtyards/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf7-a414-74c2-aeb9-9c7cd0866b52.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area with a round table and two chairs next to a kitchen."
      }
    }
  },
  "apartments/tx/amarillo/park-at-coulter/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc6-605c-751e-8f04-834ef9a8176d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern bathroom with dark vanity, marble countertop, and subway tile shower."
      }
    }
  },
  "apartments/tx/amarillo/remington-amarillo-apts/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df3-7f2f-77ba-98aa-98c6108aceb8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy living room with a fireplace and TV."
      }
    }
  },
  "apartments/tx/amarillo/winchester-apartments/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/chimneys-apts/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/double-tree-apts/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/phoenix-apts/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/01a0a16b-3880-741f-89a6-684617cff2aa.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Playground with slides and climbing structures."
      }
    }
  },
  "apartments/tx/el-paso/the-crest/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd5-6966-740a-a3be-304f0d9065be.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious living room with a sectional sofa, coffee table, and decorative wall art."
      }
    }
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a0e9d3-7230-701f-8b3d-01c360b1e706.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Empty closet with shelves and decorative wooden crates"
      }
    }
  },
  "apartments/tx/lubbock/icon-at-lubbock/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda3-387c-77a9-a678-811b08e8a086.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a brown sofa, white armchair, coffee table, and TV."
      }
    }
  },
  "apartments/tx/waco/bend-at-new-road/neighborhood::propertyneighborhoodmap.entertainment_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd6c-86e0-7285-b797-c850c87a3def.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room with green sofa, accent chair, and coffee table."
      }
    }
  },
  "apartments/ar/north-little-rock/lexington-park/neighborhood::propertyneighborhoodmap.entertainment_image_2": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "apartments/ks/wichita/cottages-at-crestview/neighborhood::propertyneighborhoodmap.entertainment_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a18978-cbe0-756f-a3eb-d2919539b1a6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern bathroom with a soaking tub, white vanity, and ample storage."
      }
    }
  },
  "apartments/ks/wichita/huntington-park/neighborhood::propertyneighborhoodmap.entertainment_image_2": {
    "sourceIndex": 2,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/neighborhood::propertyneighborhoodmap.entertainment_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-6771-73c7-b40b-b91eaeb84e96.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with fireplace, sofa, and dining area."
      }
    }
  },
  "apartments/ok/jenks/the-reserve-at-elm/neighborhood::propertyneighborhoodmap.entertainment_image_2": {
    "sourceIndex": 32,
    "fieldOverrides": null
  },
  "apartments/ok/norman/cimarron-trails-apts/neighborhood::propertyneighborhoodmap.entertainment_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06276-90a9-77aa-951a-1ebc775b3fa2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor grilling area with built-in grills, a fireplace, and seating."
      }
    }
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/neighborhood::propertyneighborhoodmap.entertainment_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d1-2130-703f-a02f-42e23f947817.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a TV, couch, and coffee table."
      }
    }
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/neighborhood::propertyneighborhoodmap.entertainment_image_2": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/neighborhood::propertyneighborhoodmap.entertainment_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-b980-73a8-965a-401388c27f9a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bathroom vanity with sink, mirror, and toilet."
      }
    }
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/neighborhood::propertyneighborhoodmap.entertainment_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa491-b0f7-735b-846a-ad774624f786.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a sofa, armchair, TV, and coffee table."
      }
    }
  },
  "apartments/ok/pryor/west-530/neighborhood::propertyneighborhoodmap.entertainment_image_2": {
    "sourceIndex": 22,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03546-4af6-73ca-8cc8-66ac1385eee2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with white cabinets, stainless steel appliances, and an open living area."
      }
    }
  },
  "apartments/ok/stillwater/apple-creek-stillwater/neighborhood::propertyneighborhoodmap.entertainment_image_2": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/neighborhood::propertyneighborhoodmap.entertainment_image_2": {
    "sourceIndex": 21,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/creekwood-apartments/neighborhood::propertyneighborhoodmap.entertainment_image_2": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/nickel-creek-apts/neighborhood::propertyneighborhoodmap.entertainment_image_2": {
    "sourceIndex": 16,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/sheridan-pond/neighborhood::propertyneighborhoodmap.entertainment_image_2": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/sunchase-apartments/neighborhood::propertyneighborhoodmap.entertainment_image_2": {
    "sourceIndex": 16,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/the-courtyards/neighborhood::propertyneighborhoodmap.entertainment_image_2": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "apartments/ok/yukon/park-at-westpointe/neighborhood::propertyneighborhoodmap.entertainment_image_2": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/neighborhood::propertyneighborhoodmap.entertainment_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf4-c6dc-73b8-b08c-e640a614933f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room with a fireplace, brown sofa, green accent chair, and a large mirror above the fireplace."
      }
    }
  },
  "apartments/tx/amarillo/remington-amarillo-apts/neighborhood::propertyneighborhoodmap.entertainment_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df3-9301-72c8-a092-de79af3b960c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bathroom vanity with sink, wooden cabinets, mirror, and toilet."
      }
    }
  },
  "apartments/tx/el-paso/chimneys-apts/neighborhood::propertyneighborhoodmap.entertainment_image_2": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/double-tree-apts/neighborhood::propertyneighborhoodmap.entertainment_image_2": {
    "sourceIndex": 28,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/high-ridge-apts/neighborhood::propertyneighborhoodmap.entertainment_image_2": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/phoenix-apts/neighborhood::propertyneighborhoodmap.entertainment_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/01a0a169-df9e-76b7-b6e0-154e5168adf8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Laundry room with rows of washers and dryers."
      }
    }
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/neighborhood::propertyneighborhoodmap.entertainment_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a0e9d3-6ff3-7199-9b69-e08a62e4a947.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern bathroom vanity with white cabinets, dark countertop, and sink."
      }
    }
  },
  "apartments/tx/lubbock/icon-at-lubbock/neighborhood::propertyneighborhoodmap.entertainment_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda3-42b6-772d-9a8d-bbec1a199c2e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area with a wooden table, four chairs, and abstract art on the wall."
      }
    }
  },
  "apartments/tx/waco/bend-at-new-road/neighborhood::propertyneighborhoodmap.entertainment_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd70-a5f5-742a-a0a3-c75b2c7d1fe4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A spacious bedroom with a king-size bed, ceiling fan, and dresser."
      }
    }
  },
  "apartments/ks/wichita/cottages-at-crestview/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a18979-d300-77f4-a587-d0cc2d54377c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area with a round table and four chairs, door to balcony with blinds"
      }
    }
  },
  "apartments/ks/wichita/huntington-park/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": 19,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb51-594c-74fe-a27a-0187992e4e7a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy bedroom with a large wooden bed, bedside tables, and a ceiling fan."
      }
    }
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": 22,
    "fieldOverrides": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c14-2703-7075-9975-437381195e7c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bathroom with a vanity, toilet, and tub with shower curtain."
      }
    }
  },
  "apartments/ok/jenks/the-reserve-at-elm/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "apartments/ok/norman/artisan-crossing-apts/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "apartments/ok/norman/cimarron-trails-apts/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06274-3b41-73eb-80d4-f489abc1fe02.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "View of apartment buildings and courtyard from a balcony."
      }
    }
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": 10,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a1400a-00da-764a-a346-79a234efca0f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Empty walk-in closet with carpet and shelving"
      }
    }
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08675-9b53-7470-bafb-0d4930cd56a8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a breakfast bar overlooking the kitchen, leather sofa, and coffee table."
      }
    }
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "apartments/ok/owasso/coffee-creek/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa491-9494-7668-81b5-897132096824.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a king-size bed, nightstand, dresser, and window."
      }
    }
  },
  "apartments/ok/owasso/cypress-crossing/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": 31,
    "fieldOverrides": null
  },
  "apartments/ok/pryor/west-530/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03545-b237-705b-890e-484bda48085a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room and kitchen with granite countertops, stainless steel appliances, and a large TV."
      }
    }
  },
  "apartments/ok/stillwater/apple-creek-stillwater/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": 34,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019ef53d-fea2-75fb-aff4-be6a86a8a277.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright living room with a green sofa, a daybed, and a small kitchen area."
      }
    }
  },
  "apartments/ok/tulsa/nickel-creek-apts/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": 25,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/sheridan-pond/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": 24,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/sunchase-apartments/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/the-courtyards/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": 21,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/windsail-apartments/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": 16,
    "fieldOverrides": null
  },
  "apartments/tx/amarillo/newport-amarillo-apts/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf4-aabb-7088-8650-211237d61705.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a queen-size bed, nightstand, and closet."
      }
    }
  },
  "apartments/tx/amarillo/park-at-coulter/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": 21,
    "fieldOverrides": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df4-306e-766d-b4b9-a58da11ebeed.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a queen-size bed, dresser, and window with white curtains."
      }
    }
  },
  "apartments/tx/el-paso/acacia-park-apts/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/chimneys-apts/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611e-7d27-71d9-90d2-a64700b4b6fb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a large tufted headboard and a white comforter."
      }
    }
  },
  "apartments/tx/el-paso/high-ridge-apts/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": 2,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/phoenix-apts/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/01a0a16b-3815-7524-8b4d-941531726958.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor basketball court and children's playground with apartment buildings in the background."
      }
    }
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a0e9d3-252b-71e9-9ab2-8a756459386c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "King-size bed with plush bedding and decorative pillows in a bedroom with a walk-in closet."
      }
    }
  },
  "apartments/tx/lubbock/icon-at-lubbock/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda3-00d3-7748-9397-2478827d53c7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bathroom with a toilet, sink, vanity, and shower curtain."
      }
    }
  },
  "apartments/tx/waco/bend-at-new-road/neighborhood::propertyneighborhoodmap.entertainment_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd6c-7d75-758b-8b57-3780069e21d3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with gray cabinets, stainless steel appliances, and marble countertops."
      }
    }
  },
  "apartments/mo/kansas-city/152-northland/neighborhood::propertyneighborhoodmap.food_bg_image": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/chardonnay/neighborhood::propertyneighborhoodmap.food_bg_image": {
    "sourceIndex": 0,
    "fieldOverrides": null
  },
  "apartments/ar/north-little-rock/lexington-park/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165609/019fc925-1ec8-701c-9ee0-846218426059.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with granite countertops, white cabinets, stainless steel appliances, and a laundry area."
      }
    }
  },
  "apartments/ks/maize/watercress-apartments/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4f0-05fb-701b-91e5-a65ba3a05352.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a king-size bed, dresser, nightstands, and a ceiling fan."
      }
    }
  },
  "apartments/ks/wichita/cottages-at-crestview/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a1897a-ef5e-731c-981e-d39ee01fc9e1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with sofa, coffee table, fireplace, and view into bedroom"
      }
    }
  },
  "apartments/ks/wichita/huntington-park/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "apartments/ks/wichita/portofino/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 51,
    "fieldOverrides": null
  },
  "apartments/ks/wichita/remington-wichita-apts/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "apartments/ks/wichita/villas-of-waterford/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "apartments/mo/belton/center-301/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "apartments/mo/independence/the-adirondack/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 22,
    "fieldOverrides": null
  },
  "apartments/mo/kansas-city/152-northland/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 58,
    "fieldOverrides": null
  },
  "apartments/mo/kansas-city/97-north-oak/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019faa56-e0b9-7753-9f9c-330678a93511.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room and kitchen area with breakfast bar seating and modern furniture."
      }
    }
  },
  "apartments/ok/broken-arrow/park-at-mission-hills/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccd-70df-719f-9621-afa8e09a1c54.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining room with a table and four chairs, large windows with blinds and curtains, and decorative plants."
      }
    }
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-b85a-7713-881a-77a59ce50bfe.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with stainless steel appliances, dark wood cabinets, and granite countertops."
      }
    }
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-6a04-728b-a66b-3eef19a9eadb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a queen-size bed, dresser, and a ceiling fan."
      }
    }
  },
  "apartments/ok/edmond/villas-at-stonebridge/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c14-1bb9-728a-ac53-544f8fec4361.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with white refrigerator, white oven and microwave, and oak cabinets."
      }
    }
  },
  "apartments/ok/jenks/the-reserve-at-elm/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "apartments/ok/norman/artisan-crossing-apts/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 12,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/01a062bd-749e-713b-a94b-87ea222761a3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room and bedroom of apartment with neutral tones and blue accents."
      }
    }
  },
  "apartments/ok/norman/cimarron-trails-apts/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 2,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06274-3b47-74f8-9dc7-bf24937d16a2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy living room with a plush sectional sofa, accent chair, and coffee table."
      }
    }
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db713-0f16-734d-8d35-edd064ae79c8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of apartment complex buildings surrounding a pond and pool."
      }
    }
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d1-238d-75dd-81a7-4f5bf8c86cb4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area with a round table and four chairs, next to a stainless steel refrigerator."
      }
    }
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a1400a-1f87-71cd-ab4c-9d36e3a10beb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area with table and chairs near kitchen."
      }
    }
  },
  "apartments/ok/oklahoma-city/council-place-apartments/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/019cfb3d-f313-774d-85cd-c43f2d23320f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area with a round wooden table and four brown chairs."
      }
    }
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08674-e41e-7037-9ebf-8a3af537e0cc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a fireplace, coffee table, and sofa."
      }
    }
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-afe7-708a-9174-b227256daee9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room and dining area with a balcony view."
      }
    }
  },
  "apartments/ok/oklahoma-city/park-at-tuscany/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d5-a4f2-700d-a68c-b91236e2556e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a king-size bed, dresser, and closet."
      }
    }
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 28,
    "fieldOverrides": null
  },
  "apartments/ok/owasso/coffee-creek/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 14,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa491-bab6-7289-84df-0295e809c43d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with white cabinets, stainless steel appliances, and a granite countertop."
      }
    }
  },
  "apartments/ok/owasso/cypress-crossing/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 21,
    "fieldOverrides": null
  },
  "apartments/ok/pryor/west-530/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 15,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03546-395c-70ec-b37d-8d4656163131.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area with round table and chairs, adjacent to a balcony door."
      }
    }
  },
  "apartments/ok/stillwater/apple-creek-stillwater/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 31,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/barrington-apartments/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cascata-luxury-apartments/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019f610a-cbba-753a-a775-186efa658b84.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright and airy living room with a sofa, coffee table, and dining area."
      }
    }
  },
  "apartments/ok/tulsa/cedar-glade-apts/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 6,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb3a-549f-70fe-a904-92d8df77f0dd.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of an apartment complex with buildings, parking lots, and surrounding roads."
      }
    }
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b6-ae4b-748d-9adc-2e611190215c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area with a round wooden table and four chairs, decorative wall art, and blinds on windows."
      }
    }
  },
  "apartments/ok/tulsa/chardonnay/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 19,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/creekwood-apartments/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1947-10f3-70e9-887c-99b8867df364.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area with a table, chairs, and view into the kitchen."
      }
    }
  },
  "apartments/ok/tulsa/nickel-creek-apts/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 19,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165614/019db132-5f06-77da-95dc-ad65724ee752.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment buildings with a courtyard, pathway, and picnic table."
      }
    }
  },
  "apartments/ok/tulsa/polo-run-apartments/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/sheridan-pond/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 26,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/sunchase-apartments/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019fb44b-9d06-76db-afda-aed3b890a7cf.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with white countertops, stainless steel appliances, and wooden cabinets."
      }
    }
  },
  "apartments/ok/tulsa/the-courtyards/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-a57f-763f-9409-4217dca71a7b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Playground with slide and apartment buildings in the background"
      }
    }
  },
  "apartments/ok/tulsa/windsail-apartments/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 17,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019dd091-05a7-700f-9bf4-48567ebc40fe.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room with a sleek electric fireplace and large vertical blinds."
      }
    }
  },
  "apartments/ok/yukon/park-at-westpointe/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c2-c4af-76cb-bc4c-85987aad02dd.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious living room with a sectional sofa, coffee table, and dining area."
      }
    }
  },
  "apartments/ok/yukon/the-ridge-66/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192d-cd19-735e-92be-44845b1d0578.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern dining area with a dark wood table, four upholstered chairs, and decorative wall art."
      }
    }
  },
  "apartments/tx/amarillo/newport-amarillo-apts/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf7-862c-76df-b81b-c795c2ce542c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area with a table and chairs, adjacent to a kitchen with a refrigerator and a built-in bookshelf."
      }
    }
  },
  "apartments/tx/amarillo/park-at-coulter/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc6-41a9-713e-a19e-1345e7e654d0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a fireplace, sofa, and coffee table."
      }
    }
  },
  "apartments/tx/amarillo/remington-amarillo-apts/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df3-c63e-717e-a0fb-d481bab1aaae.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living and dining area with a white couch, dining table, and chairs."
      }
    }
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/01a0e998-be95-778a-886e-003ef2b50c28.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining room with a round wooden table and four leather chairs, next to a desk area with a chair."
      }
    }
  },
  "apartments/tx/amarillo/winchester-apartments/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/chimneys-apts/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611e-97e1-74b0-8dff-5efd3c1fb3e1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy living room with a brick fireplace, leather couch, and coffee table."
      }
    }
  },
  "apartments/tx/el-paso/double-tree-apts/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-c221-753e-90f9-bf6d775b85bc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a gray sectional sofa, coffee table, and TV stand with a large television."
      }
    }
  },
  "apartments/tx/el-paso/high-ridge-apts/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/patriot-apts/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/phoenix-apts/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/shadow-ridge-apts/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-7b6d-7695-a3cb-82a4f6f7281f.webp"
      }
    }
  },
  "apartments/tx/el-paso/the-crest/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd5-6d7f-7192-acc7-ed4d259c537f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining room and open doorway to bathroom with wood vanity and sink."
      }
    }
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a03a5d-dc07-71a9-9768-7a7cc359c147.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area with a glass-top table, four upholstered chairs, and a large artwork on the wall."
      }
    }
  },
  "apartments/tx/lubbock/icon-at-lubbock/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda4-5e70-70a3-92bd-34ca6c90e2f4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area with a round table and four chairs, featuring large windows with blinds and maroon curtains."
      }
    }
  },
  "apartments/tx/lubbock/tuscany-place/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2c-d23d-71ee-95cd-69dcd7cf4cc4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room with blue velvet sofa, armchair, coffee table, and dining area."
      }
    }
  },
  "apartments/tx/waco/bend-at-new-road/neighborhood::propertyneighborhoodmap.intro_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd71-005a-721f-9364-a177b45dc709.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a sofa, armchair, coffee table, and dining area."
      }
    }
  },
  "apartments/ar/north-little-rock/lexington-park/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165609/019fc925-4c48-76fa-ae85-a2f7e3995dbd.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bathroom with a bathtub, toilet, vanity, and large mirror."
      }
    }
  },
  "apartments/ks/wichita/aspen-park-apartments/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 21,
    "fieldOverrides": null
  },
  "apartments/ks/wichita/cottages-at-crestview/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "apartments/ks/wichita/huntington-park/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166545/01a11c6c-7fea-700c-a4c7-7922e9a6140d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bathroom with vanity, toilet, shower curtain, and decorative accents."
      }
    }
  },
  "apartments/ks/wichita/portofino/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 48,
    "fieldOverrides": null
  },
  "apartments/ks/wichita/remington-wichita-apts/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "apartments/mo/belton/center-301/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "apartments/mo/independence/the-adirondack/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 18,
    "fieldOverrides": null
  },
  "apartments/mo/kansas-city/97-north-oak/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 20,
    "fieldOverrides": null
  },
  "apartments/ms/ridgeland/trace-apts/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019faa54-43fc-7698-bc76-23de5fd003a1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a king-size bed, dresser, nightstand, and ceiling fan."
      }
    }
  },
  "apartments/ok/broken-arrow/park-at-mission-hills/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 19,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-0e7d-721d-aab0-90b2555ef898.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a white sofa, white ottoman, and dining area."
      }
    }
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a36-5764-718f-8bce-d7c19d731515.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bathroom with vanity, toilet, and shower curtain."
      }
    }
  },
  "apartments/ok/edmond/fountain-lake/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c14-29e2-765f-b713-8f55a9a46b3d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy bedroom with a large bed, armchair, and artwork."
      }
    }
  },
  "apartments/ok/jenks/the-reserve-at-elm/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 20,
    "fieldOverrides": null
  },
  "apartments/ok/norman/artisan-crossing-apts/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/01a062bd-747e-75a4-84fa-4ac22bf47a03.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with dark wood cabinets, stainless steel appliances, and white subway tile backsplash."
      }
    }
  },
  "apartments/ok/norman/cimarron-trails-apts/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 4,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06274-3b4f-7599-9ad9-3c23a3834f87.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a queen-size bed, nightstand, and closet."
      }
    }
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db712-fc59-75de-bf70-fb69e75c8a89.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of a multi-story apartment building with balconies and brick accents."
      }
    }
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d1-4dc9-762e-a11a-9335e83af35d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern bathroom with a vanity, toilet, and shower with patterned shower curtain."
      }
    }
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a1400a-01f6-74cc-a4fd-18af2bf5211d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a queen-size bed, nightstand, and dresser."
      }
    }
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 3,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08675-249b-77e9-8716-a7ff68cd2a08.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern bathroom with a white tub, shower, toilet, and vanity with a stone countertop."
      }
    }
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/01a08181-f960-742a-861d-49e1fd05dcef.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bathroom with wood vanity, white sink, mirror, bathtub, and toilet."
      }
    }
  },
  "apartments/ok/oklahoma-city/park-at-tuscany/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d5-a2e3-75f5-bf9f-a2baa292932c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bathroom with a single vanity, toilet, and bathtub with shower curtain."
      }
    }
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 31,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/01a08bfd-d9ac-718b-b8a6-ef51c9456e1b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of two adjacent townhome units with garages and front doors."
      }
    }
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 11,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa490-b32b-722d-a5e4-e64be9a7ac8d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A cozy bedroom featuring a queen-size bed with wood furniture and a ceiling fan."
      }
    }
  },
  "apartments/ok/owasso/cypress-crossing/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 9,
    "fieldOverrides": null
  },
  "apartments/ok/pryor/west-530/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 19,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03546-6713-769b-92de-5adf48f90c5a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern bathroom with white vanity, toilet, and bathtub with shower curtain."
      }
    }
  },
  "apartments/ok/stillwater/apple-creek-stillwater/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 20,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/barrington-apartments/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cascata-luxury-apartments/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 19,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70ab-35ad-72eb-8c26-a75e4149b8dd.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A staged bedroom with a queen-size bed, nightstand, and dresser."
      }
    }
  },
  "apartments/ok/tulsa/country-hollow-apartments/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 21,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/creekwood-apartments/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1940-26d4-76c6-bea8-b4e3dd4b8f09.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright bedroom featuring a bed with a pink comforter, wooden headboard, nightstand with a lamp, and two large windows."
      }
    }
  },
  "apartments/ok/tulsa/nickel-creek-apts/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 31,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/polo-run-apartments/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/sugarberry-apartments/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/sunchase-apartments/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa20-2dc1-75fb-ab0e-fddc8b61eb82.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area with a round table, four chairs, and a small kitchen area in the background."
      }
    }
  },
  "apartments/ok/tulsa/the-courtyards/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 29,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 6,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-0d1d-713b-9169-621e4e9cda9d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchenette area with a small dining table, chairs, and a view into the bathroom."
      }
    }
  },
  "apartments/ok/yukon/the-ridge-66/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192d-b6ee-76a8-b485-96f148f3c0cc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bathroom with white vanity, marble countertop, sink, toilet, and shower with curtain."
      }
    }
  },
  "apartments/tx/amarillo/newport-amarillo-apts/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/019cfb43-6ed2-734a-a951-80979d2b9884.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a queen-size bed, nightstand, and window."
      }
    }
  },
  "apartments/tx/amarillo/park-at-coulter/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165615/01a0edc6-425a-741a-92a7-b958b238cd2b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area with a wooden table and four chairs, featuring large windows with white curtains."
      }
    }
  },
  "apartments/tx/amarillo/remington-amarillo-apts/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df3-472f-747d-b230-839344e5bbd2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with wood cabinets, white appliances, and granite countertops."
      }
    }
  },
  "apartments/tx/amarillo/the-colonies-at-hillside/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167037/01a0e998-8e3e-7589-9aa4-0cf84058f2ce.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a king-size bed, dresser, and nightstand."
      }
    }
  },
  "apartments/tx/amarillo/winchester-apartments/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 21,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/01a117ae-0755-74c8-8686-409561fa9be2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Stylish bedroom with a large tufted headboard bed, dresser, and nightstand."
      }
    }
  },
  "apartments/tx/el-paso/chimneys-apts/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/double-tree-apts/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-b579-76ce-9fce-00352994a0e8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a pink bed, white bedding, and decorative pillows. A ceiling fan is visible overhead."
      }
    }
  },
  "apartments/tx/el-paso/patriot-apts/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/phoenix-apts/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/shadow-ridge-apts/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/the-crest/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd3-f587-75df-8fa2-9d889eb56747.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a sofa, chairs, TV, and coffee table."
      }
    }
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a03a5d-cd9b-74e0-aa31-d955148549e8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern bathroom with white vanity, toilet, and shower/tub."
      }
    }
  },
  "apartments/tx/lubbock/icon-at-lubbock/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda4-2d67-7624-9bab-0e450f001044.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with wood cabinets, granite countertops, stainless steel appliances, and a refrigerator."
      }
    }
  },
  "apartments/tx/lubbock/tuscany-place/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": 11,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2c-dc3f-71da-b235-e8fbb8cda035.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bathroom with vanity, sink, toilet, and bathtub with a red and white striped shower curtain."
      }
    }
  },
  "apartments/tx/waco/bend-at-new-road/neighborhood::propertyneighborhoodmap.schools_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd70-7b4f-762e-9765-601705c9046f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room and kitchen area with modern furniture and appliances."
      }
    }
  },
  "apartments/ar/north-little-rock/lexington-park/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165609/019cfb42-7df7-71ab-9e28-87aa8bbe534f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with sofa, coffee table, TV, dining area, and kitchen view."
      }
    }
  },
  "apartments/ks/wichita/huntington-park/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": 22,
    "fieldOverrides": null
  },
  "apartments/mo/independence/the-adirondack/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "apartments/mo/kansas-city/152-northland/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cee-ae40-702f-95f1-46a46a2f49e9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern bathroom with a double vanity, large mirror, and shower."
      }
    }
  },
  "apartments/mo/kansas-city/97-north-oak/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": 16,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-7038-73bf-a5e4-48a7768ea8de.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area with a table and chairs, featuring a modern arc floor lamp and decorative wall art."
      }
    }
  },
  "apartments/ok/broken-arrow/park-at-mission-hills/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": 28,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/redbud-ranch/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": 9,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdcca-c1f3-77da-89c7-a938d837edce.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with fireplace, sofa, and armchair."
      }
    }
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-81ae-758a-9d07-c35288d42bd6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a large TV, a comfortable sofa, and a kitchen bar with stools."
      }
    }
  },
  "apartments/ok/jenks/the-reserve-at-elm/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": 19,
    "fieldOverrides": null
  },
  "apartments/ok/norman/cimarron-trails-apts/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": 16,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d593f-de0c-74a8-9d17-dc22aa2182ac.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area and kitchen view with a dark wood table and chairs, artwork, and a coffee maker."
      }
    }
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d1-c36e-7379-b550-d9f4d305aa33.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Open concept living room with kitchen and dining area."
      }
    }
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a1400a-1ef3-70b3-8c50-86aa0e4aae8c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with wooden cabinets, black appliances, and a granite countertop."
      }
    }
  },
  "apartments/ok/oklahoma-city/council-place-apartments/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/019cfb3d-f233-71af-98de-f5beb1a6b20a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with fireplace, couch, coffee table, and window."
      }
    }
  },
  "apartments/ok/oklahoma-city/cross-timber/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-af54-77cf-bb67-b1f2ebbaab1c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a bed, nightstand, and window."
      }
    }
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019cfb3f-c1ea-724c-905d-4a106b8966c3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Balcony with two chairs and a small table with decorative pillows."
      }
    }
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/01a08181-f93b-7152-b8e4-3553d4dea698.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with white appliances, wooden cabinets, and laminate flooring."
      }
    }
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d5-22e9-753e-88f0-b1940b487a03.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a sectional sofa, coffee table, and view of the bathroom and balcony."
      }
    }
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": 35,
    "fieldOverrides": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa490-b6f1-749a-b984-b1a3745c8837.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining room with table and chairs, large windows with blinds, and decorative vase."
      }
    }
  },
  "apartments/ok/owasso/cypress-crossing/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": 22,
    "fieldOverrides": null
  },
  "apartments/ok/pryor/west-530/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03545-b238-721c-a0fa-b54230998530.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and subway tile backsplash."
      }
    }
  },
  "apartments/ok/stillwater/apple-creek-stillwater/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": 28,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cascata-luxury-apartments/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": 24,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70ae-3c3b-72c9-851b-e1d97e38a6a5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with white cabinets, stainless steel appliances, and a breakfast bar."
      }
    }
  },
  "apartments/ok/tulsa/chardonnay/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": 35,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/creekwood-apartments/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1940-d84c-743c-9b6e-ccfb696883ba.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A home office setup with a wooden desk, stool, and \"WORK\" wall art."
      }
    }
  },
  "apartments/ok/tulsa/nickel-creek-apts/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": 40,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/sheridan-pond/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02001-7663-748a-9533-5e11c20b53f0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room and kitchen area with dining table, fireplace, and TV."
      }
    }
  },
  "apartments/ok/tulsa/sunchase-apartments/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa20-175e-712c-acbc-962199272774.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room with a gray sofa, armchair, coffee table, and dining area."
      }
    }
  },
  "apartments/ok/tulsa/the-courtyards/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": 18,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-f25d-7598-972a-0c5d734f857b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bathroom with a vanity, toilet, and bathtub."
      }
    }
  },
  "apartments/ok/tulsa/windsail-apartments/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019dd08e-91e5-72f9-a3a3-eace49865e04.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with wooden cabinets, white appliances, and floral wall art."
      }
    }
  },
  "apartments/ok/yukon/park-at-westpointe/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c2-a29e-719a-8701-2f18df593f33.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a fireplace, sofa, coffee table, and television. Bedroom is visible through doorway."
      }
    }
  },
  "apartments/ok/yukon/the-ridge-66/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192d-2678-7451-8299-284e9033787f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A modern apartment kitchen featuring dark wood cabinets, stainless steel appliances, a white subway tile backsplash, and a marble-look island with two bar stools."
      }
    }
  },
  "apartments/tx/amarillo/newport-amarillo-apts/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf7-a47d-74fb-9da2-7bb16013d2cf.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A bathroom vanity with a sink, wood cabinets, and a mirror above, next to a toilet and bathtub."
      }
    }
  },
  "apartments/tx/amarillo/park-at-coulter/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": 26,
    "fieldOverrides": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df3-441e-77d2-ad11-c72ba373f383.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern dining area with a round table and four upholstered chairs, abstract art, and a door to the outside."
      }
    }
  },
  "apartments/tx/amarillo/winchester-apartments/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-a114-76a8-86ca-ba4a590b206a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious living and dining area with a sofa, coffee table, TV, and dining table."
      }
    }
  },
  "apartments/tx/el-paso/chimneys-apts/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019cfb3b-dc4d-7558-b5f4-2882fb8f470b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a sofa, coffee tables, a bar area, and a shelf with decor."
      }
    }
  },
  "apartments/tx/el-paso/double-tree-apts/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-c266-766a-8dfa-5e3a2decbbfd.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area with a round table, two chairs, and a modern art piece on the wall."
      }
    }
  },
  "apartments/tx/el-paso/high-ridge-apts/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": 11,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165606/01a0a195-fbe8-761b-8dbb-253e355c72c6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bathroom vanity with sink, toilet, bathtub, and shower curtain."
      }
    }
  },
  "apartments/tx/el-paso/phoenix-apts/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": 35,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/01a0a16c-1ec3-7428-8b6d-82d53ba9bf99.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy bedroom with a queen-size bed, orange comforter, and artwork on the wall."
      }
    }
  },
  "apartments/tx/el-paso/shadow-ridge-apts/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": 69,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/the-crest/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd5-7abc-7708-8bfb-f797b06ddb08.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bathroom with double vanity, toilet, and bathtub with shower curtain."
      }
    }
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/019d270e-1eea-77f9-b9b7-5157111a44de.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious bedroom with a queen-sized bed, dresser, and nightstand."
      }
    }
  },
  "apartments/tx/lubbock/icon-at-lubbock/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda4-2f28-72c8-ab10-5350ff6f7d46.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern bathroom with a white tub, shower, toilet, and vanity with a marble countertop."
      }
    }
  },
  "apartments/tx/waco/bend-at-new-road/neighborhood::propertyneighborhoodmap.shopping_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd70-bdca-74be-8904-343410d7663d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with stainless steel appliances, dark cabinets, and a large island sink."
      }
    }
  },
  "apartments/ar/north-little-rock/lexington-park/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165609/019fc925-1e0a-713b-98dd-6000c3b15712.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Luxurious bedroom with a king-size bed, plush teal bedding, and decorative pillows."
      }
    }
  },
  "apartments/ks/maize/watercress-apartments/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "apartments/ks/wichita/huntington-park/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166545/019cfb4e-9f93-7701-a16d-fe6f0a2cfc9b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with fireplace, TV, sofa, and decorative artwork."
      }
    }
  },
  "apartments/mo/belton/center-301/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": 27,
    "fieldOverrides": null
  },
  "apartments/mo/kansas-city/152-northland/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": 20,
    "fieldOverrides": null
  },
  "apartments/mo/kansas-city/97-north-oak/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165581/019d593e-fa45-77be-b509-3b8a12f6c0d5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room with fireplace, TV, plush ottoman, and open kitchen view with bar stools."
      }
    }
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-7603-708a-9cbd-5132becdf500.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern bathroom with dark wood vanity, granite countertop, white toilet, and bathtub with shower curtain."
      }
    }
  },
  "apartments/ok/broken-arrow/park-at-mission-hills/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019db68f-5e06-7587-8286-0072514229c0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bathroom vanity with sink, dark wood cabinets, and a mirror reflecting a dining area."
      }
    }
  },
  "apartments/ok/broken-arrow/redbud-ranch/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": 21,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdcca-d7ec-73fa-81ec-9f02716735dc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern bedroom with a king-size bed, dresser, and nightstand."
      }
    }
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a36-3c93-74bf-a2d7-ee1362dde7f2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room with a blue armchair, white sofa, and abstract art."
      }
    }
  },
  "apartments/ok/jenks/the-reserve-at-elm/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": 28,
    "fieldOverrides": null
  },
  "apartments/ok/norman/artisan-crossing-apts/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "apartments/ok/norman/cimarron-trails-apts/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06274-51bb-70cc-bd3d-dc2ab19de7fe.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Updated bathroom with a large vanity, oval sink, and modern lighting."
      }
    }
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019f70d0-d873-715b-9730-a7dbeb139b42.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with stainless steel appliances, gray cabinets, white quartz countertops, and bar seating."
      }
    }
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": 20,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/council-place-apartments/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/019cfb3d-5c7c-7779-823e-c87fc950bd8c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a queen-size bed, mirrored closet doors, and large window."
      }
    }
  },
  "apartments/ok/oklahoma-city/cross-timber/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/01a03ea8-f8c8-747b-a12b-e0c961c80497.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern bathroom with a double vanity, toilet, and shower/tub combo."
      }
    }
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08675-a267-741d-8329-e86c96d75c6a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with brown sofa, coffee tables, TV, and large windows."
      }
    }
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-c4c2-728c-8742-8db82d99c7d3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a queen-size bed, closet, and bathroom access."
      }
    }
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d5-71dc-70ae-afe2-dd243f7f486e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area with a round table and four bar stools, wall art, and a vase of flowers."
      }
    }
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": 41,
    "fieldOverrides": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa492-f831-7081-879e-62d751ef822f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern home office with a white desk, chair, and large windows."
      }
    }
  },
  "apartments/ok/owasso/cypress-crossing/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "apartments/ok/pryor/west-530/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03546-1758-7003-b029-d4a67b437c52.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Balcony with two chairs and a table overlooking community amenities and apartment buildings."
      }
    }
  },
  "apartments/ok/stillwater/apple-creek-stillwater/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": 29,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cascata-luxury-apartments/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": 18,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b6-ac68-71ff-89a7-59ae6d676a7b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room with a large TV, a comfortable couch, and decorative wall art."
      }
    }
  },
  "apartments/ok/tulsa/chardonnay/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/creekwood-apartments/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1940-41c8-750c-8295-b4a76d9ea288.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Clean bathroom with white tile shower, white bathtub, and wooden vanity."
      }
    }
  },
  "apartments/ok/tulsa/nickel-creek-apts/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/sheridan-pond/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-853e-73a0-8cb1-9e41798d852d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern bathroom with white tiled shower and tub, vanity with sink, and decorative wall hangings."
      }
    }
  },
  "apartments/ok/tulsa/sunchase-apartments/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa1f-ec0a-76da-b17d-c9c1ae22e560.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A cozy bedroom with a queen-sized bed, wooden furniture, and decorative wall art."
      }
    }
  },
  "apartments/ok/tulsa/the-courtyards/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165634/01a015c4-c34f-77aa-9236-014bab0dc86c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a TV, armchair, and dining area visible."
      }
    }
  },
  "apartments/ok/yukon/park-at-westpointe/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/01a068c2-9b40-747d-bdef-065f49cf6871.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bathroom with dark wood vanity, granite countertop, white sink, and large mirror."
      }
    }
  },
  "apartments/ok/yukon/the-ridge-66/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192d-e196-75bd-b9f3-69c2c87feb7c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Stylish apartment bathroom with a dark wood vanity, single sink, large mirror, modern lighting, and a white toilet."
      }
    }
  },
  "apartments/tx/amarillo/newport-amarillo-apts/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf5-0a8d-72dd-b712-0c08b0d62c38.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area with a round table, two chairs, and a wall hanging."
      }
    }
  },
  "apartments/tx/amarillo/remington-amarillo-apts/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df4-3056-7758-ab4e-6cb06e44d3ae.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern bathroom with a single vanity, toilet, and bathtub with a decorative shower curtain."
      }
    }
  },
  "apartments/tx/amarillo/winchester-apartments/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019d47cb-5ba2-707e-b4c3-fe1bf58f22cb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern bathroom with a bathtub, toilet, and double vanity with wood accents."
      }
    }
  },
  "apartments/tx/el-paso/chimneys-apts/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/double-tree-apts/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-d0d4-7643-813f-8d8de7e04d58.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Updated bathroom vanity with sink, toilet, and bathtub with shower curtain."
      }
    }
  },
  "apartments/tx/el-paso/high-ridge-apts/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/phoenix-apts/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/01a0a16b-fa48-73ed-b8d0-a8a287fd96e6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bathroom vanity with sink and mirror, view into bedroom."
      }
    }
  },
  "apartments/tx/el-paso/the-crest/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd5-890f-72fe-9031-e24ee8f67cf6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a queen-size bed, nightstands, and mirrored closet doors."
      }
    }
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/019d270e-0ce5-7358-a853-63dae6f56a6e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A dining area with a glass-top table and four chairs, adjacent to a home office space with a desk and chair."
      }
    }
  },
  "apartments/tx/lubbock/icon-at-lubbock/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda3-8579-7753-8a5d-79d67192a448.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A king-sized bed with plush pillows and a cozy throw blanket in a well-lit bedroom."
      }
    }
  },
  "apartments/tx/waco/bend-at-new-road/neighborhood::propertyneighborhoodmap.shopping_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd72-360a-7318-b1f8-b889da7aef57.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern bathroom with a vanity, sink, toilet, and bathtub with a shower curtain."
      }
    }
  },
  "apartments/ar/north-little-rock/lexington-park/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165609/019cfb42-7dba-7299-85f7-1f36b4832aa1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room and kitchen area with TV, counter, and appliances."
      }
    }
  },
  "apartments/ks/wichita/huntington-park/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166545/01a11c6c-1421-7639-8481-e232b1eb95a5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with gray cabinets, stainless steel appliances, and a granite countertop."
      }
    }
  },
  "apartments/ks/wichita/villas-of-waterford/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": 18,
    "fieldOverrides": null
  },
  "apartments/mo/independence/the-adirondack/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "apartments/mo/kansas-city/152-northland/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": 19,
    "fieldOverrides": null
  },
  "apartments/mo/kansas-city/97-north-oak/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": 35,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019cfb52-6f08-740f-bf63-a014c359272a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A vanity table with a makeup mirror and chair in a well-lit room with large windows."
      }
    }
  },
  "apartments/ok/broken-arrow/park-at-mission-hills/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": 11,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167043/019cfb52-fa36-742d-b79b-8b5dba2043a3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "King-size bed with green and white bedding in a bright bedroom with a dresser and a ceiling fan."
      }
    }
  },
  "apartments/ok/broken-arrow/redbud-ranch/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": 26,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019cfb53-c04a-702c-9e6a-fb690fa368d5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with white cabinets, stainless steel appliances, and granite countertops."
      }
    }
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": 21,
    "fieldOverrides": null
  },
  "apartments/ok/edmond/villas-at-stonebridge/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/01a08c14-0ee8-777e-a119-9cb686bee35e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy living room with a fireplace, coffee table, and a sofa."
      }
    }
  },
  "apartments/ok/jenks/the-reserve-at-elm/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": 21,
    "fieldOverrides": null
  },
  "apartments/ok/norman/artisan-crossing-apts/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "apartments/ok/norman/cimarron-trails-apts/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": 10,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06274-51b0-74cc-b66d-1254a299e6c2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with dark cabinets, stainless steel appliances, and granite countertops."
      }
    }
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": 26,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a14009-fc6e-7199-beee-b59dbf67f05d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a king-size bed, nightstand, and view of the bathroom."
      }
    }
  },
  "apartments/ok/oklahoma-city/council-place-apartments/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/01a183b3-05a4-75aa-91b1-30c589398ca0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area and living room with modern furniture and decor, including a round dining table with chairs and a media console with mirrors above."
      }
    }
  },
  "apartments/ok/oklahoma-city/cross-timber/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": 16,
    "fieldOverrides": null
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/019d4ea1-d84b-754a-bbe4-46dfb6570c4e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Queen-size bed with grey duvet and decorative pillows in a bedroom with city skyline art."
      }
    }
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-c4ad-7689-b36f-bc2b8ec85468.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a queen-size bed, nightstand, and dresser."
      }
    }
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d5-4487-70b8-8d00-bf269b30df0c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with white appliances, light wood cabinets, and a double sink."
      }
    }
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019cfb52-3f5a-7785-be97-51933c87a246.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern bathroom with vanity, toilet, and shower/tub combo with decorative curtain."
      }
    }
  },
  "apartments/ok/owasso/cypress-crossing/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": 27,
    "fieldOverrides": null
  },
  "apartments/ok/pryor/west-530/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03545-b15a-754d-95b8-99644e0736a2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy bedroom with a queen-size bed, nightstands, dresser, and window."
      }
    }
  },
  "apartments/ok/stillwater/apple-creek-stillwater/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": 22,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/barrington-apartments/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": 8,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165586/019f049e-a3fc-719f-bb9d-d8e756b25c2b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern dining area with a round table and four upholstered chairs, adjacent to a kitchen with wooden cabinetry and black appliances."
      }
    }
  },
  "apartments/ok/tulsa/cascata-luxury-apartments/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": 26,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70ae-3ab6-76da-887e-67ee28bb28ea.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern open-concept living room and kitchen with gray sofa, bar stools, and white cabinets."
      }
    }
  },
  "apartments/ok/tulsa/country-hollow-apartments/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/creekwood-apartments/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": 12,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1940-811c-775f-97b4-90b526b39132.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with a refrigerator, dishwasher, coffee maker, and double sink."
      }
    }
  },
  "apartments/ok/tulsa/nickel-creek-apts/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": 41,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/sheridan-pond/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02002-5ec5-76cc-95ad-e07479927f8b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Stainless steel refrigerator and oven in a kitchen with wood cabinets."
      }
    }
  },
  "apartments/ok/tulsa/sunchase-apartments/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa1f-76ec-730a-a7a4-13b6e2988679.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bathroom with vanity, toilet, and tub/shower combo."
      }
    }
  },
  "apartments/ok/tulsa/the-courtyards/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": 32,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": 10,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/windsail-apartments/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165645/019dd08f-7e46-76db-a2ee-a982abd8f96a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area with a round wooden table and four chairs."
      }
    }
  },
  "apartments/ok/yukon/park-at-westpointe/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "apartments/ok/yukon/the-ridge-66/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192d-3c69-714a-acfc-85106992ee26.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright and spacious apartment living room with a white sofa, a wooden coffee table, a pink armchair, and a desk area. Large windows offer natural light."
      }
    }
  },
  "apartments/tx/amarillo/newport-amarillo-apts/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf5-0cea-7649-aa74-cfa249d63574.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with fireplace, TV, and large sofa."
      }
    }
  },
  "apartments/tx/amarillo/park-at-coulter/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": 19,
    "fieldOverrides": null
  },
  "apartments/tx/amarillo/remington-amarillo-apts/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/019cfb55-0585-720f-9cef-6936ee3f9b7c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A minimalist bedroom with a queen-sized bed, nightstand, and dresser."
      }
    }
  },
  "apartments/tx/amarillo/winchester-apartments/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": 18,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/019cfb4d-a179-7662-bb0b-6cfc07a03f02.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a sofa, coffee table, TV, and armchair."
      }
    }
  },
  "apartments/tx/el-paso/acacia-park-apts/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": 25,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/chimneys-apts/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165592/019f611e-b163-7289-824b-8e87382097a4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bathroom with a bathtub, toilet, and vanity with a marble countertop."
      }
    }
  },
  "apartments/tx/el-paso/double-tree-apts/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-d146-71b2-b3a6-109ed33d8b8b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A cozy bedroom featuring a king-size bed with plush pillows and a soft pink throw, bedside tables with lamps, and a decorative wall accent."
      }
    }
  },
  "apartments/tx/el-paso/phoenix-apts/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": 13,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167045/01a0a16c-266d-7749-95c7-98ccfc4373d3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with light wood cabinets, white appliances, and a dining area."
      }
    }
  },
  "apartments/tx/el-paso/shadow-ridge-apts/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb47-8b78-7567-9d6c-a8ac49643ec5.webp"
      }
    }
  },
  "apartments/tx/el-paso/the-crest/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/019cfb52-bc59-75bc-acd6-15105dfe2bd9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area and kitchen in an apartment"
      }
    }
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/019cfb50-e6f5-707f-ad49-74c8790a4848.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with white cabinets, stainless steel appliances, and a large island."
      }
    }
  },
  "apartments/tx/lubbock/icon-at-lubbock/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda3-803d-724f-9717-7e28b0fdf34f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area with a round black table and four chairs, a large plant, and a painting on the wall."
      }
    }
  },
  "apartments/tx/lubbock/tuscany-place/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2d-1278-73ee-b48f-c3365d1b3348.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a king-size bed, dresser, and nightstands."
      }
    }
  },
  "apartments/tx/waco/bend-at-new-road/neighborhood::propertyneighborhoodmap.shopping_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd6c-ce1b-70ab-97c8-62351d615da3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area with a round table and four white chairs near large windows with pink curtains."
      }
    }
  },
  "apartments/ks/maize/watercress-apartments/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166551/019fa4f0-1fc3-72fe-84ad-afeb5de8bf0c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room and kitchen area with dining table and bar seating."
      }
    }
  },
  "apartments/ks/wichita/aspen-park-apartments/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": 26,
    "fieldOverrides": null
  },
  "apartments/ks/wichita/cottages-at-crestview/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165596/01a1897b-0bbd-776a-8d58-c94f38d6a6ac.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area with a round table and four chairs, featuring large windows with blinds and curtains."
      }
    }
  },
  "apartments/ks/wichita/huntington-park/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166545/01a11c6c-809f-7656-81c7-6d0a80881d1d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with wooden cabinets, stainless steel appliances, and a dishwasher."
      }
    }
  },
  "apartments/ks/wichita/portofino/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": 45,
    "fieldOverrides": null
  },
  "apartments/mo/belton/center-301/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "apartments/mo/independence/the-adirondack/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": 27,
    "fieldOverrides": null
  },
  "apartments/mo/kansas-city/152-northland/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "apartments/mo/kansas-city/97-north-oak/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/icon-at-broken-arrow-apartments/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167041/019faa54-2aa2-73bc-98e4-ecf9b045337f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern desk with chair and a dining table with chairs in a well-lit room."
      }
    }
  },
  "apartments/ok/broken-arrow/park-at-mission-hills/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": 16,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/redbud-ranch/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "apartments/ok/broken-arrow/scissortail-crossing/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167051/019fdccb-2559-7667-b2bf-3ac36e2a5505.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with tufted headboard, dresser, and ceiling fan."
      }
    }
  },
  "apartments/ok/broken-arrow/trails-at-aspen-creek/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-a3fc-70a8-8bab-d47e53ff9739.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Open concept living and dining area with a modern kitchen."
      }
    }
  },
  "apartments/ok/broken-arrow/villas-at-aspen-park/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165640/019fa4fa-385c-72a8-bf1b-a7b89874fdeb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with sofa, armchair, coffee table, dining table, and chairs."
      }
    }
  },
  "apartments/ok/jenks/the-reserve-at-elm/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": 16,
    "fieldOverrides": null
  },
  "apartments/ok/norman/artisan-crossing-apts/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": 21,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165585/019f0040-a101-776a-9f66-ead7c157b60a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious living room with a sectional sofa, ottoman, accent chair, and a desk."
      }
    }
  },
  "apartments/ok/norman/cimarron-trails-apts/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/01a06274-1f4c-7071-95d8-adefdc5bb793.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area and kitchen with dark cabinets and stainless steel appliances."
      }
    }
  },
  "apartments/ok/oklahoma-city/24hundred-apartments/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165580/019db710-a85b-766a-a44c-ece0b19a26d5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with in-water loungers and lounge chairs, surrounded by apartment buildings."
      }
    }
  },
  "apartments/ok/oklahoma-city/chisholm-pointe/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165593/019d593f-944f-7229-ae40-911753604994.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a sectional sofa, armchair, TV, and decorative wall art."
      }
    }
  },
  "apartments/ok/oklahoma-city/cimarron-pointe-apts/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165594/01a14009-44f5-7469-be5c-fda92806b713.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright living room with a gray sofa, ottoman, armchair, ceiling fan, and double doors leading outside."
      }
    }
  },
  "apartments/ok/oklahoma-city/council-place-apartments/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165597/01a183b2-a97c-70f0-8d46-766548789255.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with wooden cabinets, stainless steel appliances, and a sink."
      }
    }
  },
  "apartments/ok/oklahoma-city/crown-pointe-apartments/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165602/01a08674-e744-72be-a28f-08d12158ad4a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining room with a wooden table and four green chairs. The table is set with plates and decorative candle holders."
      }
    }
  },
  "apartments/ok/oklahoma-city/hunter-s-ridge-apts/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165607/019cfb41-ba53-7258-ae1c-1edb37451abb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen area with wooden cabinets, stainless steel sink, and a view into a bedroom."
      }
    }
  },
  "apartments/ok/oklahoma-city/prairie-springs-i/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165621/01a081d5-c9b4-7035-90be-e85b3385237d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with sofa, coffee table, dining table, and chairs."
      }
    }
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "apartments/ok/owasso/coffee-creek/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": 24,
    "fieldOverrides": null
  },
  "apartments/ok/owasso/cottages-at-tallgrass-point/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167039/019fa491-7793-75a9-abae-fab28c94e624.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room and kitchen area with a sofa, armchair, TV, and bar stools."
      }
    }
  },
  "apartments/ok/owasso/cypress-crossing/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": 22,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165603/019d48df-3bd5-7389-aac8-97beedc7cdcc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Large outdoor swimming pool with lounge chairs and umbrellas."
      }
    }
  },
  "apartments/ok/pryor/west-530/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": 21,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166552/01a03545-c73d-7402-a3cc-d5c15daa4bb5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious living room with large windows, a sectional sofa, and decorative armchair."
      }
    }
  },
  "apartments/ok/stillwater/apple-creek-stillwater/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/barrington-apartments/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": 16,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/cedar-glade-apts/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a fireplace, coffee table, and sofa."
      }
    }
  },
  "apartments/ok/tulsa/cedar-ridge-apartments/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70ae-3aea-743f-b689-4ba9214bf41c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious living room with gray sectional sofa, accent chair, and large windows."
      }
    }
  },
  "apartments/ok/tulsa/chardonnay/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": 26,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/country-hollow-apartments/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/creekwood-apartments/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165599/019f1946-d81d-736a-8874-6369eb3180bb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy living room with a sofa, coffee table, and large window."
      }
    }
  },
  "apartments/ok/tulsa/nickel-creek-apts/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": 44,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/polo-run-apartments/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": 18,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/sheridan-pond/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165625/01a02001-9b18-74c9-b3cb-b47c6e12c8b9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a curved sofa, coffee table, and a ceiling fan."
      }
    }
  },
  "apartments/ok/tulsa/sunchase-apartments/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165629/019faa21-3076-752e-a275-c1e0eb104d7c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright and airy living room with a sofa, armchairs, and a coffee table."
      }
    }
  },
  "apartments/ok/tulsa/the-courtyards/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/the-greens-of-bedford/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "apartments/ok/tulsa/windsail-apartments/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "apartments/ok/yukon/the-ridge-66/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165636/019f192d-a2c2-77af-9cc8-cc6654952b41.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A modern apartment kitchen with white cabinets, stainless steel appliances, a marble-top island with bar stools, and a glimpse of a bedroom."
      }
    }
  },
  "apartments/tx/amarillo/newport-amarillo-apts/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165613/01a0edf5-2a2e-76c6-afdc-b2fbf27b8642.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen sink with modern faucet, granite countertops, dishwasher, and laundry area"
      }
    }
  },
  "apartments/tx/amarillo/remington-amarillo-apts/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167289/01a10df3-a210-71da-8384-118701555afc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a queen-size bed, wooden headboard, and nightstand with a lamp."
      }
    }
  },
  "apartments/tx/amarillo/winchester-apartments/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": 7,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165644/01a117ae-132b-754c-840a-315a1c5f3900.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Updated kitchen with white cabinets, wood trim, and white appliances."
      }
    }
  },
  "apartments/tx/el-paso/double-tree-apts/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-cea7-71da-88e7-dfc427d5bff5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Kitchen with white appliances and wooden cabinets."
      }
    }
  },
  "apartments/tx/el-paso/high-ridge-apts/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": 13,
    "fieldOverrides": null
  },
  "apartments/tx/el-paso/shadow-ridge-apts/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": 10,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165624/019cfb46-7d9b-702a-9714-4fe4e8ae8a28.webp"
      }
    }
  },
  "apartments/tx/el-paso/the-crest/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167040/01a19cd3-82b5-75aa-bb70-389382b9b0cb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Master bedroom with king-size bed and view into en-suite bathroom."
      }
    }
  },
  "apartments/tx/lubbock/cottages-at-abbey-glen/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167038/01a03a5b-db4d-746d-b0ac-47fd4192dd25.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a fireplace and a TV."
      }
    }
  },
  "apartments/tx/lubbock/icon-at-lubbock/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165608/01a0eda4-557e-74de-ab09-a90c756160b4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room with fireplace, curved sofa, and accent chair."
      }
    }
  },
  "apartments/tx/lubbock/tuscany-place/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167288/01a11c2e-e490-718a-bb21-f9949ef2ca6b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living and dining area with a couch, dining table, desk, and artwork."
      }
    }
  },
  "apartments/tx/waco/bend-at-new-road/neighborhood::propertyneighborhoodmap.skyline_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd72-07fe-7555-95a1-f5e823cc5b77.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A beautifully staged bedroom with a king-size bed and dark wood furniture."
      }
    }
  },
  "apartments/ok/oklahoma-city/zeal-at-quail/neighborhood::propertyresourcesfooter.floorplans_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "Zeal at Quail"
      }
    }
  },
  "reviews.photo_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfd5c-74ab-7608-8787-3750f0afc72c.webp"
      }
    }
  },
  "reviews.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfd5d-6834-74ae-bada-73a2a8e89423.webp"
      }
    }
  },
  "reviews.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfd5d-711b-707c-8ce6-e39742fc8647.webp"
      }
    }
  },
  "reviews.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfd5d-7c63-73a0-a1c0-9abea6028172.webp"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "apartments/ok/tulsa/windsail-apts/amenities::amenitieslist.apartment": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": [
      41,
      47,
      55
    ],
    "ordering": null,
    "customItems": null
  },
  "apartments/ok/tulsa/windsail-apts/amenities::amenitieslist.community": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": [
      41,
      55,
      47
    ],
    "ordering": null,
    "customItems": null
  },
  "apartments/ok/tulsa/cedar-glade-apts::propertyamenities.apartment_items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "apartments/ok/tulsa/windsail-apts::propertyamenities.apartment_items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": [
      41,
      47,
      55
    ],
    "ordering": null,
    "customItems": null
  },
  "apartments/ok/tulsa/windsail-apts::propertyamenities.community_items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": [
      47,
      55,
      41
    ],
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "basis-tracking-pixel",
      "blockId": "basis-tracking-pixel",
      "position": 0
    },
    {
      "sectionId": "facebook-pixel",
      "blockId": "facebook-pixel",
      "position": 0
    },
    {
      "sectionId": "ga4-tracking",
      "blockId": "ga4-tracking",
      "position": 0
    }
  ],
  "_template:property": [
    {
      "sectionId": "flex-payment",
      "blockId": "flex-payment",
      "position": 0
    },
    {
      "sectionId": "ga4-tracking-2",
      "blockId": "ga4-tracking",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "image-tracking-pixel",
      "blockId": "image-tracking-pixel",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    },
    {
      "sectionId": "residentboost-chatbot",
      "blockId": "residentboost-chatbot",
      "position": 0
    }
  ]
};

export const styleOverrides = {
  "awardsintro.image_0": {
    "properties": {
      "overflow": "visible"
    }
  },
  "careersemployees.bel_image": {
    "properties": {
      "minHeight": "-1px"
    }
  }
};
